(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[3],{

/***/ "+2Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMAINING_STOCK_LIMIT; });
var REMAINING_STOCK_LIMIT = 10;

/***/ }),

/***/ "+DnP":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("W0vE"),
    baseFilter = __webpack_require__("sjzV"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD");

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ "+M7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQuickDashboardQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOptionByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFutureBookingsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentBookingsQuery; });
/* unused harmony export sendRequestPickYourRoomResortOnly */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("L7OA");
/* harmony import */ var _queries_account_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QRI5");



 // QUICKDASHBOARD

var getQuickDashboardQueries = function getQuickDashboardQueries(bookingId, appContext) {
  return "\n    query {\n      customerBooking(id: \"".concat(bookingId, "\") {\n        ...booking\n      }\n    }\n    ").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: true
  }), "\n    ");
}; // DASHBOARD

var getOptionByIdQuery = function getOptionByIdQuery(bookingId, appContext) {
  return "query {\n  customerBooking(id: \"".concat(bookingId, "\") {\n    ...booking\n  }\n}\n").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: false
  }), "\n");
};

var getOptionFilter = function getOptionFilter(appContext) {
  var base = ['"OPTION"'];
  return Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.enableOptionRenewal') ? [].concat(base, ['"EXPIRED"']) : base;
};

var getFutureBookingsQuery = function getFutureBookingsQuery(appContext) {
  return "query { \n    customers(byPassGetCustomer: true) {\n      futureTrips {\n        count\n        trips(status: [\"VALIDATED\"]) {\n          data {\n            ...booking\n          }\n        }\n        options: trips(status: [".concat(getOptionFilter(appContext).join(','), "]){\n          data {\n            ...booking\n          }\n        }\n      }\n    }\n  }\n  ").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: true
  }), "\n  ");
};
var getCurrentBookingsQuery = function getCurrentBookingsQuery(appContext) {
  return "query { \n    customers(byPassGetCustomer: true) {\n      currentTrips {\n        count\n        trips {\n          data {\n            ...booking\n          }\n        }\n      }\n    }\n  }\n  ".concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: false
  }), "\n  ");
};
var sendRequestPickYourRoomResortOnly = function sendRequestPickYourRoomResortOnly(_ref) {
  var bookingId = _ref.bookingId,
      comment = _ref.comment,
      criteria = _ref.criteria;
  return "mutation {\n    sendRequestPickYourRoomResortOnly(bookingId: \"".concat(bookingId, "\", criteria: \"").concat(criteria, "\", comment:\"").concat(comment, "\")\n  }");
};

/***/ }),

/***/ "+Mso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "+Rc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTrigger; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("XiOS");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("EkOT");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("1JJ2");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("m1JM");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRdV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("W+NJ");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("U2fG");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("C/y5");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;















var CUSTOM_HEADER_HEIGHT = 44;
var CriteriaTrigger = function CriteriaTrigger(props) {
  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_3__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0];

  var pageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_4__[/* usePageContext */ "b"])();
  var rootRef = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_9__[/* useTracking */ "a"])();

  var customLayerHeader = __jsx("div", {
    className: "fixed inset-x-0 top-0 z-1 flex items-center justify-between border-b bg-white px-15",
    style: {
      height: CUSTOM_HEADER_HEIGHT,
      maxHeight: CUSTOM_HEADER_HEIGHT
    }
  }, __jsx("button", {
    onClick: props.onClose,
    type: "button",
    className: "ms-auto flex-1 leading-0"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
    width: "1.125rem"
  }), __jsx("span", {
    className: "sr-only"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('common.backNavigation'))), __jsx("span", {
    className: "mx-auto w-full px-10 text-center"
  }, props.layerHeader), __jsx("span", {
    className: "h-full flex-1"
  }, props.layerHeaderSlot));

  var buttons = props.buttons.map(function (btnProps) {
    var children = btnProps.children,
        allOtherProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(btnProps, ["children"]);

    return __jsx("div", {
      key: Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_8__[/* generateUniqueId */ "b"])([btnProps.theme, btnProps.color, btnProps.colorBg, btnProps.colorBorder], 'criteria-btn-')
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_11__[/* Button */ "a"], allOtherProps, children));
  });
  var criteriaDropdownOrLayer = isDesktop ? __jsx("div", {
    className: "flex flex-2"
  }, __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_13__[/* DropDown */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_16__[/* classnames */ "a"])('min-w-300 flex-1', {
      relative: props.isDropDownRelative
    }) // $FlowFixMe
    ,
    contentStyle: props.dropDownStyle,
    isExpanded: props.isOpen,
    onClose: props.onClose,
    hasArrow: false,
    rootRef: rootRef,
    theme: "hollow",
    unmountsOnClose: true
  }, function () {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment, null, props.children, props.reassurance.shouldDisplay && __jsx("div", {
      className: "mx-auto max-w-1/2 p-10 pt-0 text-start text-10 text-mediumGrey"
    }, props.reassurance.text), !!buttons.length && __jsx("div", {
      className: "p-20"
    }, props.buttonsSlot && __jsx("div", {
      className: "pb-10"
    }, props.buttonsSlot), __jsx("div", {
      className: "flex items-center justify-between gap-10"
    }, buttons)));
  })) : __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_15__[/* Layer */ "b"], {
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "p"],
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('common.close'),
    customHeader: {
      content: customLayerHeader,
      height: CUSTOM_HEADER_HEIGHT
    },
    hasAnimateEnter: true,
    onClose: props.onClose
  }, __jsx("div", {
    className: "flex h-full flex-col"
  }, __jsx("div", {
    className: "scroll-y"
  }, props.children, props.reassurance.shouldDisplay && __jsx("div", {
    className: "mx-10 mt-10 text-start text-12 text-mediumGrey sm:border-t-1 sm:pt-10 lg:mt-0"
  }, props.reassurance.text)), buttons.length && __jsx("div", {
    className: "mt-auto border-t-1 bg-white p-15 shadow"
  }, props.buttonsSlot && __jsx("div", {
    className: "pb-10"
  }, props.buttonsSlot), __jsx("div", {
    className: "relative mt-auto flex w-full items-center justify-between text-end lg:px-0"
  }, buttons))));
  var defaultTheme = isDesktop ? 'default' : 'remote';
  var theme = props.theme ? props.theme : defaultTheme;
  return __jsx("div", {
    "data-testid": props.dataTestId,
    ref: rootRef,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_16__[/* classnames */ "a"])({
      'border-1 border-success': !!props.badgeCount
    }, props.className)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_16__[/* classnames */ "a"])('relative', {
      'criteria-arrow': props.isOpen
    })
  }, __jsx(_frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_14__[/* InputButton */ "a"], {
    badgeCount: props.badgeCount,
    className: "w-full",
    dataTestId: "criteria-trigger-button",
    hasSwitch: props.hasSwitch,
    iconName: props.buttonIcon,
    isActive: props.isOpen,
    isFilled: props.buttonIsFilled,
    isLoading: isDesktop && props.isLoading,
    key: String(isAppMounted),
    onClear: isDesktop ? function () {
      props.onClear && props.onClear();
    } : undefined,
    onClick: function onClick(e) {
      e === null || e === void 0 ? void 0 : e.preventDefault();

      if (props.isOpen) {
        props.onClose && props.onClose();
      } else {
        props.onOpen && props.onOpen();

        if (props.trackingLabel && criteriaContext.trackingActionName) {
          track({
            actionGA: criteriaContext.trackingActionName,
            categoryGA: pageContext.pageId,
            labelGA: props.trackingLabel
          });
        }
      }
    },
    theme: theme
  }, props.buttonLabel)), props.isOpen && criteriaDropdownOrLayer);
};
CriteriaTrigger.defaultProps = {
  buttons: [],
  reassurance: {
    shouldDisplay: false,
    text: ''
  }
};

/***/ }),

/***/ "+VQP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isodate = _interopRequireDefault(__webpack_require__("y/CH"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "+pJz":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "+xJO":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "/+ub":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");
var createElement = __webpack_require__("a4SZ");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "/013":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flow.js
var flow = __webpack_require__("jPI1");
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("FllU");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// CONCATENATED MODULE: ./src/utils/immutability/immutability.js










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function updateArrayIndexFp(array, index, updater) {
  // $FlowFixMe
  return Object.values(_objectSpread(_objectSpread({}, array), {}, Object(defineProperty["a" /* default */])({}, index, updater(array[index]))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx




























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function FormValidator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormValidator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormValidator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormValidator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable flowtype/no-weak-types */




function _isFormValid(fields) {
  return fields.every(function (field) {
    return field.validationState === validationStates["b" /* IS_VALID */];
  });
}

function _isFieldValid(field) {
  var fieldValidators = get_default()(field, 'validators') || [];
  return !isEmpty_default()(fieldValidators) ? fieldValidators.every(function (validator) {
    return validator.isValid(field.value);
  }) : true;
}

function _setFieldValidationState(field) {
  if (isEmpty_default()(get_default()(field, 'validators'))) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: validationStates["b" /* IS_VALID */]
    });
  }

  if (!field.value) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
    });
  }

  return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
    validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["a" /* IS_INVALID */]
  });
}

var FormValidator_FormValidator = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FormValidator, _React$Component);

  var _super = _createSuper(FormValidator);

  function FormValidator(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FormValidator);

    _this = _super.call(this, props);
    var formFields = _this.getFields(_this.props) || [];
    _this.state = FormValidator_objectSpread(FormValidator_objectSpread({}, _this.state), {}, {
      fields: formFields.map(function (field) {
        return _setFieldValidationState(field);
      })
    });
    Object(assertThisInitialized["a" /* default */])(_this).setFieldsInState = _this.setFieldsInState.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFormSubmittable = _this.isFormSubmittable.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFieldValid = _this.isFieldValid.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).onSubmit = _this.onSubmit.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).updateFieldValue = _this.updateFieldValue.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).validateFields = _this.validateFields.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldByName = _this.getFieldByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldValueByName = _this.getFieldValueByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }

  Object(createClass["a" /* default */])(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual_default()(this.props, prevProps)) {
        this.setFieldsInState(this.props);
      }
    }
  }, {
    key: "setFieldsInState",
    value: function setFieldsInState(props) {
      var formFields = this.getFields(props) || [];
      this.setState({
        fields: formFields.map(function (field) {
          return _setFieldValidationState(field);
        })
      });
    }
    /**
     * getFields has to be implemented by the inherited form class
     *
     * @param props (the props used to get/calculate the form fields)
     * @returns the list of form fields
     *
     * const someValidFormField = {
     *    name : a string to eventually identify the field
     *    value : anything
     *    validators : a list of validators to validate the field
     *        -> ex: utils/common-validator/CommonValidators
     * }
     */
    // eslint-disable-next-line no-unused-vars

  }, {
    key: "getFields",
    value: function getFields(props) {
      return [];
    }
  }, {
    key: "validateFields",
    value: function validateFields(callback) {
      var fieldsWithValidation = this.state.fields.map(_setFieldValidationState);
      this.setState({
        fields: fieldsWithValidation
      }, callback);
      return fieldsWithValidation;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(fieldName, options, callback) {
      var _this2 = this;

      return function (newFieldValue) {
        var indexToUpdate = findIndex_default()(_this2.state.fields, {
          name: fieldName
        });

        var newFields = updateArrayIndexFp(_this2.state.fields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            value: newFieldValue
          });
        });

        _this2.setState({
          fields: newFields
        }, function () {
          return get_default()(options, 'validate') ? _this2.validateFields(callback) : callback;
        });
      };
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "updateFieldsValue",
    value: function updateFieldsValue(keyValues, options, callback) {
      var _this3 = this;

      var newFields = keyValues.reduce(function (updatedFields, _ref) {
        var fieldName = _ref.fieldName,
            value = _ref.value;

        var indexToUpdate = findIndex_default()(updatedFields, {
          name: fieldName
        });

        return updateArrayIndexFp(updatedFields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            name: fieldName,
            value: value
          });
        });
      }, this.state.fields);
      this.setState({
        fields: newFields
      }, function () {
        return get_default()(options, 'validate') ? _this3.validateFields(callback) : callback;
      });
    }
  }, {
    key: "isFormSubmittable",
    value: function isFormSubmittable(callback) {
      return flow_default()(this.validateFields, _isFormValid)(callback);
    }
  }, {
    key: "isFieldValid",
    value: function isFieldValid(field) {
      return _isFieldValid(field);
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "isFormValid",
    value: function isFormValid() {
      return _isFormValid(this.state.fields);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      return this.isFormSubmittable() && this.props.onSubmit(this.state.fields);
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return get_default()(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
    }
  }, {
    key: "getFieldValueByName",
    value: function getFieldValueByName(fieldName) {
      var formField = get_default()(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });

      return get_default()(formField, 'value');
    }
  }]);

  return FormValidator;
}(react["Component"]);

/* harmony default export */ var form_validator_hoc_FormValidator = __webpack_exports__["a"] = (FormValidator_FormValidator);

/***/ }),

/***/ "/1vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return popinTypes; });
var popinTypes = {
  VIEW: 'view',
  OUTSIDE_FACILITIES: 'outsideFacilities',
  ROOM_TYPE: 'roomType'
};

/***/ }),

/***/ "/ExG":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var isCallable = __webpack_require__("ANQd");
var store = __webpack_require__("l6h7");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "/GgU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var toObject = __webpack_require__("A+R+");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "/HC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormikInput_FormikInput; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/inputsUtils.js
var inputsUtils = __webpack_require__("vpua");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("s2Gj");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/image-validation-status/ImageValidationStatus.jsx
var __jsx = react_default.a.createElement;




var ImageValidationStatus_ImageValidationStatus = function ImageValidationStatus(_ref) {
  var className = _ref.className,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated;
  return __jsx(react["Fragment"], null, isErrored && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none text-red', className),
    name: icons["a" /* ICONS */].CROSS,
    width: "0.8125rem"
  }), isValidated && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none text-success', className),
    name: icons["a" /* ICONS */].CHECK,
    width: "0.8125rem"
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/BirthDateInputSeparator.jsx
var BirthDateInputSeparator_jsx = react_default.a.createElement;


var BirthDateInputSeparator_BirthDateInputSeparator = function BirthDateInputSeparator(_ref) {
  var isDisabled = _ref.isDisabled,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated,
      position = _ref.position;
  return BirthDateInputSeparator_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none absolute flex h-full items-center', {
      'text-success': isValidated && !isDisabled,
      'text-red': isErrored && !isDisabled
    }),
    style: {
      left: "".concat(position / 3 * 100, "%")
    }
  }, "/");
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Legend.jsx
var Legend = __webpack_require__("hUUf");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DateInput.jsx





















var DateInput_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var DateInput_DateInput = function DateInput(_ref) {
  var air360ClassName = _ref.air360ClassName,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      isDisabled = _ref.isDisabled,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      monthPlaceholder = _ref.monthPlaceholder,
      onKeyDown = _ref.onKeyDown,
      yearPlaceholder = _ref.yearPlaceholder,
      errorMessage = _ref.errorMessage,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "className", "dataTestId", "dateFormat", "dayPlaceholder", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "monthPlaceholder", "onKeyDown", "yearPlaceholder", "errorMessage"]);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored,
      isDefaultState = _getValidationStatus.isDefaultState;

  var _useRef = Object(react["useRef"])("dateInput-".concat(field.name)),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);
  var errorNoteId = "error-".concat(kebabCase_default()(field.name)); // Form state (global)

  var date = Object(react["useMemo"])(function () {
    return field.value ? moment_default()(field.value) : null;
  }, [field.value]);
  var dateDay = date && date.isValid() ? date.format('DD') : '';
  var dateMonth = date && date.isValid() ? date.format('MM') : '';
  var dateYear = date && date.isValid() ? date.format('YYYY') : ''; // Field state (local)

  var _useState = Object(react["useState"])(dateDay),
      day = _useState[0],
      setDay = _useState[1];

  var _useState2 = Object(react["useState"])(dateMonth),
      month = _useState2[0],
      setMonth = _useState2[1];

  var _useState3 = Object(react["useState"])(dateYear),
      year = _useState3[0],
      setYear = _useState3[1];

  var onChangeDay = function onChangeDay(_ref2) {
    var target = _ref2.target;
    setDay(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeMonth = function onChangeMonth(_ref3) {
    var target = _ref3.target;
    setMonth(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref4) {
    var target = _ref4.target;
    setYear(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'd',
    name: "".concat(field.name, "-BirthdateInput-day"),
    value: day || dateDay,
    title: 'Day',
    length: 2,
    handleChange: onChangeDay,
    placeholder: dayPlaceholder
  }, {
    keyPos: 'm',
    name: "".concat(field.name, "-BirthdateInput-month"),
    value: month || dateMonth,
    title: 'Month',
    length: 2,
    handleChange: onChangeMonth,
    placeholder: monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-BirthdateInput-year"),
    value: year || dateYear,
    title: 'Year',
    length: 4,
    handleChange: onChangeYear,
    placeholder: yearPlaceholder
  }].sort( // sort each input to respect the locale format (DD/MM/YYYY or YYYY/MM/DD ...)
  function (i1, i2) {
    return dateFormat.toLowerCase().indexOf(i1.keyPos) - dateFormat.toLowerCase().indexOf(i2.keyPos);
  }); // Update form state on field change

  Object(react["useEffect"])(function () {
    if (structure.every(function (_ref5) {
      var value = _ref5.value,
          length = _ref5.length;
      return value.length === length;
    })) {
      var birthdate = moment_default()([+year, +month - 1, +day]).valueOf();
      form.setFieldValue(field.name, birthdate);
    } else {
      form.setFieldValue(field.name, null);
    }
  }, [day, month, year]);
  Object(react["useEffect"])(function () {
    if (day !== dateDay) {
      setDay(dateDay);
    }

    if (month !== dateMonth) {
      setMonth(dateMonth);
    }

    if (year !== dateYear) {
      setYear(dateYear);
    }
  }, [dateDay, dateMonth, dateYear]);

  var handleBlur = function handleBlur(_ref6) {
    var relatedTarget = _ref6.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref7) {
    var target = _ref7.target;

    if (structure.every(function (_ref8) {
      var value = _ref8.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var dataCsMask = pick_default()(props, 'data-cs-mask');

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return DateInput_jsx("fieldset", {
    className: className
  }, !!label && DateInput_jsx(Legend["a" /* Legend */], {
    className: "mx-15 mb-5",
    isDisabled: isDisabled,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), DateInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'direction-ltr relative isolate flex w-full items-center'),
    "data-testid": dataTestId ? "wrapper-".concat(dataTestId) : undefined
  }, DateInput_jsx("div", {
    className: "relative isolate flex flex-1 items-stretch"
  }, structure.map(function (_ref9, key) {
    var name = _ref9.name,
        handleChange = _ref9.handleChange,
        value = _ref9.value,
        length = _ref9.length,
        placeholder = _ref9.placeholder,
        title = _ref9.title;
    return DateInput_jsx("input", Object(esm_extends["a" /* default */])({
      "aria-describedby": errorNoteId,
      autoComplete: "off",
      className: Object(classnames_utils["a" /* classnames */])(air360ClassName, 'h-48 w-full overflow-hidden bg-transparent py-10 text-center text-16 leading-normal outline-none sm:text-14', {
        'cursor-not-allowed opacity-100': isDisabled
      }),
      "data-dateinputidentifier": uniqIdentifier
    }, dataCsMask, {
      "data-testid": "".concat(dataTestId || kebabCase_default()(field.name), "-").concat(title.toLowerCase()),
      disabled: isDisabled,
      key: name,
      maxLength: length,
      name: name,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: onKeyDown,
      placeholder: placeholder,
      ref: key === 0 ? refFirstInput : undefined,
      style: _objectSpread({}, isDisabled ? {
        WebkitTextFillColor: '#a0a0a0'
      } : {}),
      title: title,
      type: "tel",
      value: value
    }));
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 1
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 2
  })), !isDisabled && DateInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && DateInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: errorMessage !== null && errorMessage !== void 0 ? errorMessage : get_default()(form.errors, field.name),
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Checkbox.jsx















var Checkbox_jsx = react_default.a.createElement;

function Checkbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Checkbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Checkbox_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Checkbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Checkbox_Checkbox = function Checkbox(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref$iconColor,
      iconName = _ref.iconName,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      _ref$isFlex = _ref.isFlex,
      isFlex = _ref$isFlex === void 0 ? true : _ref$isFlex,
      _onChange = _ref.onChange,
      onClick = _ref.onClick,
      placeholderComponent = _ref.placeholderComponent;

  // Checkbox value defaults to false
  var value = get_default()(form.values, field.name, false);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Checkbox_objectSpread(Checkbox_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored;

  var checkboxId = "checkbox-".concat(kebabCase_default()(field.name));
  return Checkbox_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('gap-10 text-14', {
      'formik-errored': isErrored && isRequired,
      'flex items-center justify-between': isFlex
    }, className)
  }, iconName && Checkbox_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-".concat(iconColor),
    name: iconName,
    width: "1em"
  }), Checkbox_jsx("label", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full items-start gap-10', {
      'cursor-pointer': !isDisabled,
      'cursor-not-allowed': isDisabled,
      'leading-0': !placeholderComponent
    }),
    htmlFor: checkboxId
  }, Checkbox_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": ariaDescribedBy,
    className: "sr-only",
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: checkboxId,
    type: "checkbox"
  }, field, {
    checked: value,
    onChange: function onChange(e) {
      field.onChange(e);

      if (_onChange) {
        _onChange(e);
      }
    },
    onClick: onClick ? onClick : field.onClick
  })), !placeholderComponent && Checkbox_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('outline-custom-sibling flex h-24 w-24 shrink-0 items-center justify-center rounded-8 border p-2', {
      'border-black': !isDisabled,
      'border-grey bg-pearl': isDisabled,
      'text-success': isValidated && isRequired,
      'formik-errored text-red': isErrored && isRequired
    })
  }, !!value && Checkbox_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].CHECK,
    width: "1em"
  })), label && Checkbox_jsx("span", {
    className: "mt-1 inline-block text-14 font-bold leading-normal text-black"
  }, Checkbox_jsx("span", null, label), isRequired && '*'), placeholderComponent && placeholderComponent(value)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/CreditCardExpiryInput.jsx








var CreditCardExpiryInput_jsx = react_default.a.createElement;






var CreditCardExpiryInput_CreditCardExpiryInput = function CreditCardExpiryInput(_ref) {
  var className = _ref.className,
      label = _ref.label,
      field = _ref.field,
      isRequired = _ref.isRequired,
      isDisabled = _ref.isDisabled,
      form = _ref.form,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "field", "isRequired", "isDisabled", "form"]);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var _useRef = Object(react["useRef"])("dateInput-".concat(shortid_default.a.generate())),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(''),
      month = _useState[0],
      setMonth = _useState[1];

  var _useState2 = Object(react["useState"])(''),
      year = _useState2[0],
      setYear = _useState2[1];

  var onChangeMonth = function onChangeMonth(_ref2) {
    var target = _ref2.target;
    setMonth(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref3) {
    var target = _ref3.target;
    setYear(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'm',
    name: "".concat(field.name, "-CreditCardExpiryInput-month"),
    value: month,
    length: 2,
    handleChange: onChangeMonth,
    placeholder: props.monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-CreditCardExpiryInput-year"),
    value: year,
    length: 2,
    handleChange: onChangeYear,
    placeholder: props.yearPlaceholder
  }].sort( // sort each input to respect the locale format (MM/YYYY or YYYY/MM ...)
  function (i1, i2) {
    return props.dateFormat.toLowerCase().indexOf(i1.keyPos) - props.dateFormat.toLowerCase().indexOf(i2.keyPos);
  });
  Object(react["useEffect"])(function () {
    // if no value is entered, no need to set fields to null
    if (!month && !year) {
      return;
    } // when the date is incomplete erase the stored birth date to null to not store an invalid date


    if (!structure.every(function (_ref4) {
      var value = _ref4.value,
          length = _ref4.length;
      return value.length === length;
    })) {
      /**
       * setFieldValue returns a promise even if the doc says the opposite
       * https://github.com/jaredpalmer/formik/blob/f117c04738ed218b5eb8916d7189e0849962d50d/packages/formik/src/Formik.tsx#L602
       * BUT useEffect does not allow a promise as return...
       */
      form.setFieldValue(field.name, null);
      return;
    }

    var expiryDate = moment_default()([+year, +month], 'YY-MM');
    form.setFieldValue(field.name, expiryDate.valueOf());
  }, [month, year]);

  var handleBlur = function handleBlur(_ref5) {
    var relatedTarget = _ref5.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref6) {
    var target = _ref6.target;

    if (structure.every(function (_ref7) {
      var value = _ref7.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return CreditCardExpiryInput_jsx(react_default.a.Fragment, null, CreditCardExpiryInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'flex isolate relative', className)
  }, structure.map(function (_ref8, key) {
    var name = _ref8.name,
        handleChange = _ref8.handleChange,
        value = _ref8.value,
        length = _ref8.length,
        placeholder = _ref8.placeholder;
    return CreditCardExpiryInput_jsx("input", {
      autoComplete: "off",
      className: "outline-none",
      ref: key === 0 ? refFirstInput : undefined,
      key: name,
      name: name,
      type: "tel",
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      maxLength: length,
      value: value,
      placeholder: placeholder,
      disabled: isDisabled,
      "data-dateinputidentifier": uniqIdentifier
    });
  }), CreditCardExpiryInput_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('absolute flex items-center left-1/2 pointer-events-none -mx-20', {
      'text-success': isValidated,
      'text-red': form.touched[field.name] && isErrored
    })
  }, "/")), CreditCardExpiryInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: form.errors[field.name]
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/useStateRef.js


var useStateRef_useStateRef = function useStateRef(initalState) {
  var _useState = Object(react["useState"])(initalState),
      state = _useState[0],
      setState = _useState[1];

  var ref = Object(react["useRef"])(initalState);

  var setStateRef = function setStateRef(newState) {
    setState(newState);
    ref.current = newState;
  };

  return [state, setStateRef, ref];
};

/* harmony default export */ var formik_input_useStateRef = (useStateRef_useStateRef);
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatalistInput.jsx









var DatalistInput_jsx = react_default.a.createElement;




var labelMatch = function labelMatch(currentInput, item) {
  return item.label.substr(0, currentInput.length).toLowerCase() === currentInput.toLowerCase();
};

var indexOfMatch = function indexOfMatch(currentInput, item) {
  return item.label.toLowerCase().indexOf(currentInput.toLowerCase());
};

var indexOfItem = function indexOfItem(item, items) {
  return items.indexOf(items.find(function (i) {
    return i.key === item.key;
  }));
};

var DatalistInput_DataListInput = function DataListInput(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      activeItemClassName = _ref.activeItemClassName,
      dropdownClassName = _ref.dropdownClassName,
      dropDownLength = _ref.dropDownLength,
      value = _ref.value,
      inputClassName = _ref.inputClassName,
      itemClassName = _ref.itemClassName,
      onSelect = _ref.onSelect,
      onBlur = _ref.onBlur,
      placeholder = _ref.placeholder,
      _ref$requiredInputLen = _ref.requiredInputLength,
      requiredInputLength = _ref$requiredInputLen === void 0 ? 1 : _ref$requiredInputLen,
      items = _ref.items,
      field = _ref.field;

  var _useState = Object(react["useState"])(),
      lastValidItem = _useState[0],
      setLastValidItem = _useState[1];

  var _useStateRef = formik_input_useStateRef(value !== undefined ? value : ''),
      _useStateRef2 = Object(slicedToArray["a" /* default */])(_useStateRef, 3),
      currentInput = _useStateRef2[0],
      setCurrentInput = _useStateRef2[1],
      currentInputRef = _useStateRef2[2];

  var _useState2 = Object(react["useState"])([]),
      matchingItems = _useState2[0],
      setMatchingItems = _useState2[1];

  var _useStateRef3 = formik_input_useStateRef(false),
      _useStateRef4 = Object(slicedToArray["a" /* default */])(_useStateRef3, 3),
      visible = _useStateRef4[0],
      setVisible = _useStateRef4[1],
      visibleRef = _useStateRef4[2];

  var _useState3 = Object(react["useState"])(0),
      focusIndex = _useState3[0],
      setFocusIndex = _useState3[1];

  var interactionHappenedRef = Object(react["useRef"])(false);

  var _useState4 = Object(react["useState"])(false),
      isMatchingDebounced = _useState4[0],
      setIsMatchingDebounced = _useState4[1];

  var menu = Object(react["useRef"])();
  var inputField = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    var onClickCloseMenu = function onClickCloseMenu(event) {
      if (!menu.current) {
        return;
      } // if rerender, items inside might change, allow one click without further checking


      if (interactionHappenedRef.current) {
        interactionHappenedRef.current = false;
        return;
      } // do not do anything if input is clicked, as we have a dedicated func for that


      if (!inputField.current) {
        return;
      }

      var targetIsInput = event.target === inputField.current;
      var targetInInput = inputField.current.contains(event.target);

      if (targetIsInput || targetInInput) {
        return;
      } // do not close menu if user clicked inside


      var targetInMenu = menu.current.contains(event.target);
      var targetIsMenu = event.target === menu.current;

      if (targetInMenu || targetIsMenu) {
        return;
      }

      if (visibleRef.current) {
        setVisible(false);
        setFocusIndex(-1);
      }
    };

    window.addEventListener('click', onClickCloseMenu, false);
    return function () {
      window.removeEventListener('click', onClickCloseMenu);
    };
  }, [setVisible, visibleRef]);
  Object(react["useEffect"])(function () {
    var isValuePropSet = value !== undefined;
    var isValueDifferent = currentInputRef.current !== value;
    var isMatchingRunning = visible || isMatchingDebounced;

    if (isValuePropSet && isValueDifferent && !isMatchingRunning) {
      setCurrentInput(value);
    }
  }, [visible, isMatchingDebounced, value, setCurrentInput, currentInputRef]);
  var debouncedMatchingUpdateStep = Object(react["useCallback"])(function (nextInput) {
    var reachedRequiredLength = nextInput.length >= requiredInputLength;
    var showMatchingStillLoading = false;
    setCurrentInput(nextInput);
    setIsMatchingDebounced(showMatchingStillLoading); // no matching if we do not reach required input length

    if (!reachedRequiredLength) {
      return;
    }

    var updateMatchingItems = function updateMatchingItems() {
      // matching process to find matching entries in items array
      var updatedMatchingItems = items.filter(function (item) {
        return labelMatch(nextInput, item);
      });
      var displayableItems = updatedMatchingItems.slice(0, dropDownLength);
      var showDragIndex = !!lastValidItem;
      var index = showDragIndex ? indexOfItem(lastValidItem, displayableItems) : 0;

      if (displayableItems.length) {
        setMatchingItems(displayableItems);
        setFocusIndex(index > 0 ? index : 0);
        setIsMatchingDebounced(false);
        setVisible(true);
      } else {
        if (visibleRef.current) {
          setVisible(false);
        }

        setMatchingItems(displayableItems);
        setFocusIndex(-1);
        setIsMatchingDebounced(false);
      }
    };

    updateMatchingItems();
  }, [requiredInputLength, setCurrentInput, items, dropDownLength, lastValidItem, setVisible, visibleRef]);
  var onHandleInput = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    debouncedMatchingUpdateStep(newValue);
  }, [debouncedMatchingUpdateStep]);
  var onClickInput = Object(react["useCallback"])(function () {
    var currentValue = currentInputRef.current;
    var reachedRequiredLength = currentValue.length >= requiredInputLength;

    if (reachedRequiredLength && !visibleRef.current) {
      debouncedMatchingUpdateStep(currentValue);
    }
  }, [currentInputRef, requiredInputLength, visibleRef, debouncedMatchingUpdateStep]);
  var onHandleBlur = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    onBlur(newValue);
  }, [onBlur]);
  var onHandleSelect = Object(react["useCallback"])(function (selectedItem) {
    if (isMatchingDebounced) {
      return;
    }

    setCurrentInput(selectedItem.label);
    setVisible(false);
    setFocusIndex(-1);
    interactionHappenedRef.current = true;
    setLastValidItem((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
    onSelect((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
  }, [isMatchingDebounced, setCurrentInput, setVisible, lastValidItem, onSelect]);
  var onHandleKeydown = Object(react["useCallback"])(function (event) {
    if (!visibleRef.current) {
      return;
    }

    var currentFocusIndex = focusIndex;

    if (event.keyCode === 40 || event.keyCode === 9) {
      currentFocusIndex += 1;

      if (currentFocusIndex >= matchingItems.length) {
        currentFocusIndex = 0;
      }

      setFocusIndex(currentFocusIndex);
      event.preventDefault();
    } else if (event.keyCode === 38) {
      currentFocusIndex -= 1;

      if (currentFocusIndex <= -1) {
        currentFocusIndex = matchingItems.length - 1;
      }

      setFocusIndex(currentFocusIndex);
    } else if (event.keyCode === 13) {
      if (focusIndex > -1) {
        var selectedItem = matchingItems[currentFocusIndex];
        onHandleSelect(selectedItem);
      }
    }
  }, [focusIndex, matchingItems, onHandleSelect, visibleRef]);
  var renderItemLabel = Object(react["useCallback"])(function (item) {
    var index = indexOfMatch(currentInput, item);
    var inputLength = currentInput.length;
    return index >= 0 && inputLength ? // renders label with matching search string marked
    DatalistInput_jsx(react["Fragment"], null, item.label.substr(0, index), DatalistInput_jsx("strong", null, item.label.substr(index, inputLength)), item.label.substr(index + inputLength, item.label.length)) : item.label;
  }, [currentInput]);
  var renderItems = Object(react["useCallback"])(function () {
    return DatalistInput_jsx(react["Fragment"], null, matchingItems.map(function (item, i) {
      var isActive = focusIndex === i;
      var itemActiveClasses = isActive ? "cursor-pointer ".concat(activeItemClassName || 'bg-saffron text-white border-solid border-grey-light p-10;') : '';
      var itemClasses = "".concat(itemClassName, " ").concat(itemActiveClasses);
      return DatalistInput_jsx("div", {
        onClick: function onClick() {
          return onHandleSelect(item);
        },
        className: itemClasses,
        key: item.key,
        tabIndex: 0,
        role: "button",
        "aria-label": item.label,
        onKeyUp: function onKeyUp(event) {
          return event.preventDefault();
        }
      }, renderItemLabel(item));
    }));
  }, [matchingItems, focusIndex, activeItemClassName, itemClassName, onHandleSelect, renderItemLabel]);
  var dropDown = Object(react["useMemo"])(function () {
    var reachedRequiredLength = currentInputRef.current.length >= requiredInputLength;

    if (reachedRequiredLength && isMatchingDebounced) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute z-1 top-full inset-x-0 ".concat(dropdownClassName || 'p-10 cursor-pointer bg-white border border-solid grey-light'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, DatalistInput_jsx("div", {
        className: itemClassName
      }, "loading..."));
    }

    if (reachedRequiredLength && visible) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute z-1 top-full inset-x-0 ".concat(dropdownClassName || 'p-10 cursor-pointer bg-white border border-solid grey-light'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, renderItems());
    }

    return undefined;
  }, [currentInputRef, requiredInputLength, isMatchingDebounced, visible, dropdownClassName, itemClassName, renderItems]);
  return DatalistInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative inline-block isolate w-full', className)
  }, DatalistInput_jsx("input", Object(esm_extends["a" /* default */])({}, field, {
    "aria-label": "Search",
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])(inputClassName, 'w-full'),
    "data-testid": dataTestId,
    id: field.name,
    onBlur: onHandleBlur,
    onChange: onHandleInput,
    onClick: onClickInput,
    onKeyDown: onHandleKeydown,
    placeholder: placeholder,
    ref: inputField,
    type: "text",
    value: currentInput
  })), dropDown);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Datalist.jsx














var Datalist_jsx = react_default.a.createElement;

function Datalist_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Datalist_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Datalist_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Datalist_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Datalist_Datalist = function Datalist(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      setOrDefault = _ref.setOrDefault,
      options = _ref.options;

  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Datalist_objectSpread(Datalist_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });

  var handleOnSelectOrBlure = function handleOnSelectOrBlure(value) {
    value && form.setFieldValue(field.name, setOrDefault(value));
  };

  return Datalist_jsx(react["Fragment"], null, !!label && Datalist_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Datalist_jsx(DatalistInput_DataListInput, {
    className: className,
    dataTestId: dataTestId,
    field: field,
    inputClassName: classes,
    items: options.map(function (_ref2) {
      var itemLabel = _ref2.label,
          value = _ref2.value;
      return {
        label: itemLabel,
        key: value
      };
    }),
    onSelect: handleOnSelectOrBlure,
    onBlur: handleOnSelectOrBlure
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/hooks/use-unmount-delay/useUnmountDelay.js
var useUnmountDelay = __webpack_require__("5C2K");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatePickerInput.jsx








var DatePickerInput_jsx = react_default.a.createElement;











var clickedElementIs = function clickedElementIs(element, elementType, dataTestId) {
  return element instanceof Element && element.closest(elementType) && // $FlowFixMe element.closest is not null or void
  element.closest(elementType).matches("[data-testid=\"".concat(dataTestId, "\"]"));
};

var DatePickerInput_DatePickerInput = function DatePickerInput(_ref) {
  var className = _ref.className,
      customClasses = _ref.customClasses,
      dataTestId = _ref.dataTestId,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'DD/MM/YYYY' : _ref$dateFormat,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? 1 : _ref$defaultDuration,
      disabledDays = _ref.disabledDays,
      field = _ref.field,
      form = _ref.form,
      _ref$hasArrowDown = _ref.hasArrowDown,
      hasArrowDown = _ref$hasArrowDown === void 0 ? false : _ref$hasArrowDown,
      _ref$isDateRange = _ref.isDateRange,
      isDateRange = _ref$isDateRange === void 0 ? false : _ref$isDateRange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      language = _ref.language,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      placeholder = _ref.placeholder;

  var _useState = Object(react["useState"])(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var datePickerReference = Object(react["useRef"])(null);

  var _get2 = get_default()(form.values, field.name, {
    from: null,
    to: null
  }),
      from = _get2.from,
      to = _get2.to;

  var fromInputValue = from ? moment_default()(from).format(dateFormat) : null;
  var toInputValue = to ? moment_default()(to).format(dateFormat) : null;
  var inputValue = [fromInputValue, toInputValue].filter(function (value) {
    return !!value;
  }).join(' — ');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated; // Open/Close effect


  Object(react["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var datePickerElement = datePickerReference.current;
      var clickedElement = e.target;
      var clickedElementIsPrevArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-prev');
      var clickedElementIsNextArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-next');

      if (datePickerElement && !datePickerElement.contains(clickedElement) && !clickedElementIsPrevArrow && !clickedElementIsNextArrow) {
        // 1. Set "to" date based on default duration if it's not defined
        if (isDateRange && !!from && !to) {
          form.setFieldValue(field.name, {
            from: from,
            to: moment_default()(from).add({
              days: defaultDuration
            }).toDate()
          });
        } // 2. Close DatePicker


        setIsActive(false);
      }
    };

    document.addEventListener('click', onClickOutside);
    document.addEventListener('focus', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('focus', onClickOutside);
    };
  }, [from, to]);

  var onDaySelect = function onDaySelect(_ref2) {
    var fromDate = _ref2.fromDate,
        toDate = _ref2.toDate;

    if (isDateRange && !!fromDate && !toDate) {
      form.setFieldValue(field.name, {
        from: fromDate,
        to: moment_default()(fromDate).add({
          days: defaultDuration
        }).toDate()
      });
    } // 2. Close DatePicker


    setIsActive(false);
  };

  var shouldRenderDatePicker = Object(useUnmountDelay["a" /* useDelayUnmount */])(isActive, 300);
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var datePickerStyle = customClasses ? customClasses : classes;
  return DatePickerInput_jsx(react["Fragment"], null, !!label && DatePickerInput_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), DatePickerInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate w-full', className),
    ref: datePickerReference
  }, DatePickerInput_jsx("div", {
    className: "relative isolate flex w-full items-center"
  }, DatePickerInput_jsx("input", Object(esm_extends["a" /* default */])({
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])('h-48', datePickerStyle),
    "data-testid": dataTestId,
    disabled: isDisabled
  }, field, {
    onFocus: function onFocus() {
      return setIsActive(true);
    },
    placeholder: placeholder,
    type: "text",
    value: inputValue
  })), hasArrowDown && DatePickerInput_jsx("div", {
    className: "pointer-events-none absolute end-0 mx-20 flex items-center"
  }, DatePickerInput_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && DatePickerInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: Object(classnames_utils["a" /* classnames */])('absolute end-0', {
      'mx-40': hasArrowDown,
      'mx-20': !hasArrowDown
    }),
    isErrored: isErrored,
    isValidated: isValidated
  })), shouldRenderDatePicker && DatePickerInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-500 absolute left-1/2 top-full mt-10 min-w-full -translate-x-1/2 transform rounded-12 border-1 border-black bg-white p-10', isActive ? 'animate-fadeIn' : 'animate-fadeOut')
  }, DatePickerInput_jsx(Datepicker["a" /* Datepicker */], {
    field: field,
    form: form,
    isDateRange: isDateRange,
    isFormikInput: true,
    locale: language,
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    onSelect: onDaySelect,
    theme: "defaultFormikInput"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Hidden.jsx


var Hidden_jsx = react_default.a.createElement;

var Hidden_Hidden = function Hidden(_ref) {
  var field = _ref.field;
  return Hidden_jsx("input", Object(esm_extends["a" /* default */])({
    id: field.name,
    type: "hidden"
  }, field, {
    // to not trigger a React error when the field is initialize to undefined
    value: field.value || ''
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Input.jsx
















var Input_jsx = react_default.a.createElement;

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Input_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Input_Input = function Input(_ref) {
  var air360ClassName = _ref.air360ClassName,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
      _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      customId = _ref.customId,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      placeholder = _ref.placeholder,
      type = _ref.type,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "autoComplete", "customClasses", "customId", "dataTestId", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "placeholder", "type"]);

  // Input value defaults to empty string
  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Input_objectSpread(Input_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var inputStyle = customClasses ? Object(classnames_utils["a" /* classnames */])(air360ClassName, customClasses) : Object(classnames_utils["a" /* classnames */])(air360ClassName, classes);
  return Input_jsx(react["Fragment"], null, !!label && Input_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: customId || field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Input_jsx("div", {
    className: "flex isolate items-center relative w-full"
  }, Input_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    "aria-invalid": isErrored,
    "aria-required": isRequired,
    autoComplete: autoComplete,
    className: inputStyle,
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: customId ? customId : field.name,
    type: type
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    // default to '' for prevent react warning on controlled component
    value: value || ''
  }, props)), !isDisabled && Input_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Input_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Radio.jsx
var Radio = __webpack_require__("yWv5");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Select.jsx
















var Select_jsx = react_default.a.createElement;

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Select_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-onchange */








var Select_Select = function Select(_ref) {
  var _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      hideImageValidation = _ref.hideImageValidation,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _ref$withOptionGroup = _ref.withOptionGroup,
      withOptionGroup = _ref$withOptionGroup === void 0 ? false : _ref$withOptionGroup;

  if (!options) {
    throw new Error("Can't use select input type without options props");
  } // Select value defaults to empty string


  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Select_objectSpread(Select_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var onSelectChange = onChange ? onChange : field.onChange;
  var onSelectClick = onClick ? onClick : field.onClick;
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var selectStyle = customClasses ? customClasses : classes;
  return Select_jsx(react["Fragment"], null, !!label && Select_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Select_jsx("div", {
    className: "relative isolate flex w-full items-center"
  }, Select_jsx("select", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])('h-48', selectStyle, 'pe-40'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name
  }, field, {
    onChange: onSelectChange,
    onClick: onSelectClick
  }), placeholder && Select_jsx("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), withOptionGroup ? options.map(function (_ref2) {
    var groupName = _ref2.groupName,
        groupOptions = _ref2.groupOptions;
    return (groupOptions === null || groupOptions === void 0 ? void 0 : groupOptions.length) && Select_jsx("optgroup", {
      label: groupName,
      key: groupName
    }, groupOptions.map(function (_ref3) {
      var isDisabledOption = _ref3.isDisabled,
          key = _ref3.key,
          name = _ref3.name,
          value = _ref3.value;
      return Select_jsx("option", {
        key: key || value,
        value: value,
        disabled: isDisabledOption
      }, name);
    }));
  }) : options.map(function (_ref4) {
    var isDisabledOption = _ref4.isDisabled,
        key = _ref4.key,
        name = _ref4.name,
        value = _ref4.value;
    return Select_jsx("option", {
      key: key || name + field.name,
      value: value,
      disabled: isDisabledOption
    }, name);
  })), Select_jsx("div", {
    className: "pointer-events-none absolute end-0 mx-20 flex items-center"
  }, Select_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && !hideImageValidation && Select_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-40",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Select_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Textarea.jsx















var Textarea_jsx = react_default.a.createElement;

function Textarea_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Textarea_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Textarea_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Textarea_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Textarea_Textarea = function Textarea(_ref) {
  var dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder;

  // Textarea value defaults to empty string
  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Textarea_objectSpread(Textarea_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasRadius: false,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return Textarea_jsx(react["Fragment"], null, !!label && Textarea_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Textarea_jsx("textarea", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])(classes, 'rounded-12'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name,
    maxLength: maxLength
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    value: value
  })), !hideErrorMessage && Textarea_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: form.errors[field.name],
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx


var FormikInput_jsx = react_default.a.createElement;

















var FormikInput_getComponentByType = function getComponentByType(type) {
  switch (type) {
    case 'birthdate':
      return DateInput_DateInput;

    case 'checkbox':
      return Checkbox_Checkbox;

    case 'creditCardExpiry':
      return CreditCardExpiryInput_CreditCardExpiryInput;

    case 'datalist':
      return Datalist_Datalist;

    case 'datepicker':
      return DatePickerInput_DatePickerInput;

    case 'hidden':
      return Hidden_Hidden;

    case 'radio':
      return Radio["a" /* Radio */];

    case 'select':
      return Select_Select;

    case 'textarea':
      return Textarea_Textarea;

    default:
      return Input_Input;
  }
};

var requiredValidationRule = Object(inputsUtils["c" /* getValidateFieldFunction */])(lib["mixed"]().transform(function (value) {
  return !!value;
}).oneOf([true]).required());

var FormikInput_getValidateFunction = function getValidateFunction(validate, isRequired, context) {
  var isValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var locale = arguments.length > 4 ? arguments[4] : undefined;

  if (validate) {
    return Object(inputsUtils["c" /* getValidateFieldFunction */])(validate, context, locale);
  }

  if (isValidate) {
    if (isRequired) {
      return requiredValidationRule;
    }
  }

  return undefined;
};

var FormikInput_FormikInput = function FormikInput(_ref) {
  var customId = _ref.customId,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage,
      _ref$hideDataFromSess = _ref.hideDataFromSessionRecording,
      hideDataFromSessionRecording = _ref$hideDataFromSess === void 0 ? true : _ref$hideDataFromSess,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$isValidate = _ref.isValidate,
      isValidate = _ref$isValidate === void 0 ? true : _ref$isValidate,
      _ref$optimized = _ref.optimized,
      optimized = _ref$optimized === void 0 ? false : _ref$optimized,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      validate = _ref.validate,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["customId", "hideErrorMessage", "hideDataFromSessionRecording", "isRequired", "isValidate", "optimized", "type", "validate"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var context = Object(formik_esm["e" /* useFormikContext */])();
  var FormikField = optimized ? formik_esm["a" /* FastField */] : formik_esm["b" /* Field */];
  var air360ClassName = Object(classnames_utils["a" /* classnames */])({
    'air360-replay-ignore': hideDataFromSessionRecording
  });
  var dataCsMask = hideDataFromSessionRecording ? {
    'data-cs-mask': true
  } : undefined;
  return FormikInput_jsx(FormikField, Object(esm_extends["a" /* default */])({
    air360ClassName: air360ClassName,
    component: FormikInput_getComponentByType(type),
    customId: customId,
    hideErrorMessage: hideErrorMessage,
    isRequired: isRequired,
    type: type,
    validate: FormikInput_getValidateFunction(validate, isRequired, context, isValidate, locale) // $FlowFixMe

  }, otherProps, dataCsMask));
};

/***/ }),

/***/ "/Sb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RateMessages; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _RateMessages_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tuzA");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var RateMessages = function RateMessages(_ref) {
  var rate = _ref.rate;

  if (!rate) {
    return null;
  }

  var _getRateMessagesPrope = Object(_RateMessages_utils__WEBPACK_IMPORTED_MODULE_1__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
    className: "block font-bold text-12",
    text: rateTitle
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
    className: "block text-10 font-sans",
    text: rateContent
  }));
};

/***/ }),

/***/ "/ile":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}

/***/ }),

/***/ "/nu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureDate; });
/* unused harmony export hasPriceSuggestions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSuggestionsTrackingData; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UIAR");



var getDepartureDate = function getDepartureDate(_ref) {
  var date = _ref.date,
      duration = _ref.duration,
      format = _ref.format,
      unit = _ref.unit;
  return moment__WEBPACK_IMPORTED_MODULE_1___default()(date, format).add(duration, unit).format(format);
};
var hasPriceSuggestions = function hasPriceSuggestions(proposal, appContext) {
  var _proposal$price;

  return (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) > 0 && (proposal.price.gap < _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */ "x"] || appContext.isSeller && proposal.price.gap >= _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "y"]);
};
var getSuggestionsTrackingData = function getSuggestionsTrackingData(_ref2) {
  var appContext = _ref2.appContext,
      disableAlternativePrice = _ref2.disableAlternativePrice,
      proposal = _ref2.proposal,
      suggestions = _ref2.suggestions;
  var hasDateSuggestion = suggestions.dates.length > 0;
  var hasResortSuggestion = suggestions.resorts.length > 0;
  var hasDurationSuggestion = suggestions.durations.length > 0;
  var hasPriceSuggestion = !disableAlternativePrice && proposal && hasPriceSuggestions(proposal, appContext);
  var labelGA = "displayCounterProposals".concat(hasPriceSuggestion ? '_rate10' : '').concat(hasDateSuggestion ? '_date' : '').concat(hasResortSuggestion ? '_resort' : '').concat(hasDurationSuggestion ? '_duration' : '');
  return {
    labelGA: labelGA
  };
};

/***/ }),

/***/ "/xkv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arePointsEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deepEqual; });
/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */
function arePointsEqual(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
/* eslint-disable complexity */
/**
 * Compare any two objects
 * @param a
 * @param b
 * @returns true if the objects are deep equal
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    else if (Array.isArray(b)) {
        return false;
    }
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        for (const key of aKeys) {
            if (!b.hasOwnProperty(key)) {
                return false;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=deep-equal.js.map

/***/ }),

/***/ "/yCi":
/***/ (function(module, exports, __webpack_require__) {

var createMathOperation = __webpack_require__("qqpj");

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

module.exports = add;


/***/ }),

/***/ "05PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getCalendar; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSelectedMonth; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getCalendarLoading; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getDays; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getPricesByDays; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getDepartureDateBookable; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getAvailableDurations; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getInitialDuration; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getCalendarTripPrice; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getCalendarTripPriceLoading; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getBlockInputDepartureDate; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getCalendarDepartureCity; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getCalendarProductId; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getIsPriceCalendarSelection; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/utils/api-availability/constants.js
var constants = __webpack_require__("/FsK");

// CONCATENATED MODULE: ./src/utils/api-availability/availabilityUtils.js




function isBookable(availability) {
  return !!availability && !constants["d" /* API_NOT_BOOKABLE */].includes(availability);
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.selector.js
















var INITIAL_LIST = [];
var INITIAL_CALENDAR = {};

function getMonthIndex() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthId = arguments.length > 1 ? arguments[1] : undefined;
  return months.findIndex(function (_ref) {
    var id = _ref.id;
    return id === monthId;
  });
}

function getMonthIndexFromDays() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dayId = arguments.length > 1 ? arguments[1] : undefined;
  /**
   * return if a day is elligible based on:
   * - dayContent.id equals dayId parameter
   * - dayContent.isCurrentMonth at true
   * @param  {Object} day  objet day from calendar.months[i]
   * @return {boolean}     this day is elligible
   */

  var matchBasedOnDay = function matchBasedOnDay(_ref2) {
    var dayContent = _ref2.dayContent;
    return dayContent.id === dayId && dayContent.isCurrentMonth;
  };

  return months.findIndex(function (_ref3) {
    var days = _ref3.days;
    return days.some(matchBasedOnDay);
  });
}

function getCurrentMonth() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedDay = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDayMonthIndex = arguments.length > 2 ? arguments[2] : undefined;
  var firstMonthIndex = arguments.length > 3 ? arguments[3] : undefined;
  return selectedDay && selectedDayMonthIndex > -1 ? months[selectedDayMonthIndex] : months[firstMonthIndex];
}

function getDaysFromMonths(calendar, monthId) {
  var months = calendar.months;
  var monthIndex = getMonthIndex(months, monthId);
  return get_default()(months, "".concat(monthIndex, ".days"));
}

function getDaysFromDays(calendar, dayId) {
  var months = calendar.months,
      firstAvailableMonthIndex = calendar.firstAvailableMonthIndex;
  var selectedDayMonthIndex = getMonthIndexFromDays(months, dayId);
  var month = getCurrentMonth(months, dayId, selectedDayMonthIndex, firstAvailableMonthIndex);
  return get_default()(month, 'days', INITIAL_LIST);
}

function getDaysSelector() {
  var calendar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_CALENDAR;
  var selectedMonth = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDay = arguments.length > 2 ? arguments[2] : undefined;

  if (isEmpty_default()(calendar)) {
    return INITIAL_LIST;
  }

  var daysFromMonths = getDaysFromMonths(calendar, selectedMonth);
  var daysFromDays = getDaysFromDays(calendar, selectedDay);
  return !daysFromMonths || daysFromMonths === daysFromDays ? daysFromDays : daysFromMonths;
}

var calendarSelector = function calendarSelector(_ref4) {
  var calendar = _ref4.calendar;
  return calendar;
};

var getCalendar = Object(lib["createSelector"])(calendarSelector, function (_ref5) {
  var calendar = _ref5.calendar;
  return calendar;
});
var getSelectedMonth = Object(lib["createSelector"])(calendarSelector, function (_ref6) {
  var selectedMonth = _ref6.selectedMonth;
  return selectedMonth;
});
var getCalendarLoading = Object(lib["createSelector"])(calendarSelector, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading;
});
var getDays = Object(lib["createSelector"])(getCalendar, getSelectedMonth, tripCriteria_selector["b" /* getDepartureDate */], getDaysSelector);
var getPricesByDays = Object(lib["createSelector"])(calendarSelector, function (_ref8) {
  var byDays = _ref8.byDays;
  return byDays;
});
var getDepartureDateBookable = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getCalendarLoading, function (_ref9, departureDate, isLoading) {
  var _byDays$dayId;

  var byDays = _ref9.byDays;

  if (!departureDate || isLoading) {
    return false;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return byDays && byDays[dayId] && isBookable((_byDays$dayId = byDays[dayId]) === null || _byDays$dayId === void 0 ? void 0 : _byDays$dayId.availability);
});
var getAvailableDurations = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], function (_ref10, departureDate) {
  var _bookableDates$months, _bookableDates$months2, _bookableDates$months3;

  var bookableDates = _ref10.bookableDates,
      bookableDatesLoading = _ref10.bookableDatesLoading;

  if (bookableDatesLoading) {
    return [];
  }

  if (!departureDate || !bookableDates) {
    return null;
  }

  var monthId = moment_default()(departureDate).format(apiDate["b" /* API_MONTH_ID */]);
  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return Array.isArray(bookableDates === null || bookableDates === void 0 ? void 0 : bookableDates.months) ? (bookableDates === null || bookableDates === void 0 ? void 0 : (_bookableDates$months = bookableDates.months.find(function (m) {
    return m.id.toString() === monthId;
  })) === null || _bookableDates$months === void 0 ? void 0 : (_bookableDates$months2 = _bookableDates$months.days.find(function (d) {
    return d.id.toString() === dayId;
  })) === null || _bookableDates$months2 === void 0 ? void 0 : (_bookableDates$months3 = _bookableDates$months2.availabilities.filter(function (a) {
    return a.status === 'AVAILABLE' || a.status === 'UNKNOWN';
  })) === null || _bookableDates$months3 === void 0 ? void 0 : _bookableDates$months3.reduce(function (acc, a) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(a.durations));
  }, [])) || null : null;
});
var getInitialDuration = Object(lib["createSelector"])(calendarSelector, function (_ref11) {
  var initialDuration = _ref11.initialDuration;
  return initialDuration;
});
var getCalendarTripPrice = Object(lib["createSelector"])(calendarSelector, function (_ref12) {
  var tripPrice = _ref12.tripPrice;
  return tripPrice;
});
var getCalendarTripPriceLoading = Object(lib["createSelector"])(calendarSelector, function (_ref13) {
  var tripPriceIsLoading = _ref13.tripPriceIsLoading;
  return tripPriceIsLoading;
});
var getBlockInputDepartureDate = Object(lib["createSelector"])(calendarSelector, function (_ref14) {
  var blockInputDepartureDate = _ref14.blockInputDepartureDate;
  return blockInputDepartureDate;
});
var getCalendarDepartureCity = Object(lib["createSelector"])(calendarSelector, function (_ref15) {
  var departureCity = _ref15.departureCity;
  return departureCity;
});
var getCalendarProductId = Object(lib["createSelector"])(calendarSelector, function (_ref16) {
  var productId = _ref16.productId;
  return productId;
});
var getIsPriceCalendarSelection = Object(lib["createSelector"])(calendarSelector, function (_ref17) {
  var isPriceCalendarSelection = _ref17.isPriceCalendarSelection;
  return isPriceCalendarSelection;
});

/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_TICKET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_TICKET_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORT_TAXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOURISTIC_TAXES; });
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
var PRICE_TICKET_REQUEST_ABORT = 'PRICE_TICKET_REQUEST_ABORT';
var PORT_TAXES = 'PORT_TAXES';
var TOURISTIC_TAXES = 'TOURISTIC_TAXES';

/***/ }),

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "l"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "15pl":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jHPj");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_pull__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nnm9");
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_18__);


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) {
          return {
            activeIndexes: []
          };
        }
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_18__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default()(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return lodash_pull__WEBPACK_IMPORTED_MODULE_14___default()(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_17__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "1YFU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var $documentAll = __webpack_require__("S8S5");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "1a7w":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("1s2Y");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "1aYn":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    isArrayLike = __webpack_require__("9y2L"),
    keys = __webpack_require__("BlJA");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* unused harmony export setKidsWithoutClearProposals */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1m4l":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var uncurryThis = __webpack_require__("kZDm");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var anObject = __webpack_require__("ep/x");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);




var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(_ref) {
  var _ref$seasons = _ref.seasons,
      seasons = _ref$seasons === void 0 ? [] : _ref$seasons,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type;
  return seasons.length === 1 && seasons.includes('WINTER') && type.toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(product) {
  return product.category === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(product) {
  return product.activityCategories.leisure.some(function (_ref2) {
    var subCategories = _ref2.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "1s2Y":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("Y8c0");
var fails = __webpack_require__("fhLv");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "1sLo":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    arrayMap = __webpack_require__("H87J"),
    baseUnary = __webpack_require__("SU8Q"),
    cacheHas = __webpack_require__("S0iI");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),

/***/ "1vCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fw2E");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("R5gN")(module)))

/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zwLB");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("829J");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("EkOT");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("DqI1");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("5xkM");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */
















var Hero = function Hero(_ref) {
  var alt = _ref.alt,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"] : _ref$as,
      _ref$backgroundURLDes = _ref.backgroundURLDesktop,
      backgroundURLDesktop = _ref$backgroundURLDes === void 0 ? '' : _ref$backgroundURLDes,
      _ref$backgroundURLMob = _ref.backgroundURLMobile,
      backgroundURLMobile = _ref$backgroundURLMob === void 0 ? '' : _ref$backgroundURLMob,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_24__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__[/* useTrackEvent */ "a"])(),
      trackEvent = _useTrackEvent.trackEvent;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_26__[/* usePageContext */ "b"])(),
      siteSection = _usePageContext.siteSection; // just in case, you know, someone forgets to set one or something
  // mobile is default because Mobile First™
  // we're keeping the support for the legacy url prop for backwards compat
  // i.e. with ImmersiveSlideshow, as providing only a desktop url or a mobile one is pretty awkward


  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* generateBackgroundStylesAndClassName */ "d"])({
    backgroundURLDesktop: backgroundURLDesktop || url,
    backgroundURLMobile: backgroundURLMobile || url
  }),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].BLACK : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].SAFFRON : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* getHeroDimensions */ "e"])(size),
      heightClassName = _getHeroDimensions.heightClassName,
      paddingBottomClassName = _getHeroDimensions.paddingBottomClassName,
      paddingTopClassName = _getHeroDimensions.paddingTopClassName;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"][contentPosition] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"]['bottom-left'];
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? as : react__WEBPACK_IMPORTED_MODULE_13__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('inline-block transform transition-all duration-250 ease-in hover:scale-105', linkSpacing),
    'data-testid': isImmersive ? 'immersive-text' : undefined,
    onClick: function onClick() {
      return track(tracking);
    },
    url: link.url
  } : {};

  var getTitleAndSubtitleWrapperProps = function getTitleAndSubtitleWrapperProps() {
    if (!(link === null || link === void 0 ? void 0 : link.url)) {
      return;
    }

    if (as === 'a') {
      return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
        href: link === null || link === void 0 ? void 0 : link.url
      });
    }

    return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
      url: link === null || link === void 0 ? void 0 : link.url
    });
  };

  var buttonTrack = function buttonTrack(trackingPayload) {
    var isPBFLanding = Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_23__[/* isPBFLandingPage */ "m"])(asPath);

    if (siteSection === 'Shopping_Landing' && isPBFLanding) {
      trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_25__[/* TRACK_EVENT_NAMES */ "F"].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'check_my_request'
      });
    } else {
      track && track(trackingPayload);
    }
  };

  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  var iconLink = (isTablet ? icon === null || icon === void 0 ? void 0 : icon.linkDesktop : icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkDesktop); // hey isn't that the same logic that we used up there for the imageUrl?
  // yes it is!

  return __jsx("div", {
    "aria-label": alt,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(heightClassName, className),
    "data-size": size,
    "data-testid": "Hero",
    id: id,
    role: "img",
    style: style
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('relative', heightClassName, paddingTopClassName)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('animation-duration-500 absolute inset-x-0 top-0 h-full w-full animate-fadeIn bg-cover bg-center bg-no-repeat', imageClassName, heightClassName)
  }), icon && displayIcon && iconLink && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingTopClassName, 'absolute inset-0', {
      'pb-40': hasOverlap
    })
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('m-auto flex h-full w-full max-w-site overflow-hidden p-20', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "max-h-full flex-none",
    src: iconLink,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingBottomClassName, 'relative z-1 flex h-full flex-col px-20 pt-10 align-bottom')
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("mx-auto flex w-full max-w-site flex-col ".concat(textAlignment))
  }, __jsx(TitleAndSubtitleWrapperTag, getTitleAndSubtitleWrapperProps(), __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__[/* Heading */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("text-".concat(titleColor), {
      'lg:text-48': !isHighlight && size !== 'small',
      'text-shadow-3': titleColor === _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE
    }),
    hLevel: hLevel,
    theme: "heading-brand-1"
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-5 font-bold text-shadow-3 md:text-16', "text-".concat(subtitleColor)),
    text: subtitle,
    theme: "text-sans-n1"
  })), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__[/* Countdown */ "a"], {
    className: "py-10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])({
      'mt-auto': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-15 md:mt-0', {
      'w-full': !isDesktop
    }, isHighlight && !isDesktop ? 'max-w-none' : 'max-w-280'),
    color: linkColor,
    colorBg: linkBackgroundColor,
    "data-testid": isImmersive ? 'immersive-button' : undefined,
    isExternalLink: isImmersive,
    onClick: function onClick() {
      return buttonTrack(tracking);
    },
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.2)_100%)]"
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "2CYk":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "2GfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaFieldFragment = "\n fragment ValidationSchemaField on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      display\n      type\n      name\n      required\n      values {\n        code\n        label\n      }\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaFieldFragment);

/***/ }),

/***/ "2MAG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
  var positions = _ref.positions;
  return new instance.visualization.HeatmapLayer({
    data: positions.reduce(function (acc, _ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng,
          _ref2$weight = _ref2.weight,
          weight = _ref2$weight === undefined ? 1 : _ref2$weight;

      acc.push({
        location: new instance.LatLng(lat, lng),
        weight: weight
      });
      return acc;
    }, [])
  });
};

var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === undefined ? {} : _ref3$options;
  return Object.keys(options).map(function (option) {
    return instance.set(option, options[option]);
  });
};

/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "2z5K":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),

/***/ "3+yQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hr; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Hr = function Hr(_ref) {
  var className = _ref.className;
  return __jsx("hr", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('block border-0 border-solid border-lightGrey border-t-1 h-1 m-0 p-0', className)
  });
};

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.querySelector(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "a"]);

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    setTimeout(function () {
      var element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });

        if (scrollUnderNav) {
          scrollUnderNavBar();
        }
      }
    }, 100);
  }
}

/***/ }),

/***/ "393O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHEN_EVENT; });
var OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';

/***/ }),

/***/ "3K/D":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var create = __webpack_require__("Znn2");
var defineProperty = __webpack_require__("87KK").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "3LIW":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var isCallable = __webpack_require__("ANQd");
var classofRaw = __webpack_require__("XywU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "3dHC":
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ "3dm5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classof = __webpack_require__("3LIW");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./src/client/components/utils/markdown/markdown.js
var markdown = __webpack_require__("ZMpj");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js
var themes = {
  none: {
    thRoot: ''
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MARKDOWN_ALLOWED_TYPES = [markdown["a" /* HTML_ELEMENTS */].BREAK.type, markdown["a" /* HTML_ELEMENTS */].EMPHASIS.type, markdown["a" /* HTML_ELEMENTS */].PARAGRAPH.type, markdown["a" /* HTML_ELEMENTS */].STRONG.type, markdown["a" /* HTML_ELEMENTS */].TEXT.type];

var HeadingText = function HeadingText(_ref) {
  var children = _ref.children;
  return children;
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["children", "className", "hLevel", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_ALLOWED_TYPES,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Object(markdown["c" /* markdownRootHeadingRenderer */])(_objectSpread(_objectSpread({}, rest), {}, {
        hLevel: hLevel
      })),
      paragraph: HeadingText
    }
  }, children);
};

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js
var themes = {
  "default": {
    thScrollable: 'w-full',
    thHeader: 'flex-col md:flex-row gap-5 md:items-center md:justify-between mb-20',
    thList: 'gap-5',
    thSlot: '',
    thBody: 'relative'
  },
  simple: {
    thList: 'pb-10 justify-between',
    thListItem: '',
    thSlot: 'pb-10'
  },
  underlined: {
    thHeader: 'flex-col md:flex-row md:items-center md:justify-between',
    thList: 'gap-10 md:gap-20 whitespace-nowrap',
    thListItem: 'flex-none',
    thSlot: 'flex items-center ms-auto top-full mt-10 absolute md:static md:mt-0 px-20 md:px-0 mb-5 end-0',
    thBody: 'py-20'
  },
  rounded: {
    thScrollable: 'flex-1',
    thListItem: 'flex-1',
    thBody: 'bg-white border-1 border-t-0 border-lightGrey rounded-b-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      containerSize = _ref.containerSize,
      _ref$forceEnableHeade = _ref.forceEnableHeaderClick,
      forceEnableHeaderClick = _ref$forceEnableHeade === void 0 ? false : _ref$forceEnableHeade,
      hasControlsOnTouch = _ref.hasControlsOnTouch,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      message = _ref.message;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = themes[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        className: thListItem,
        controlsId: panelId,
        id: headerId,
        isActive: isActive,
        isDisabled: forceEnableHeaderClick ? false : tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (isFunction_default()(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return title && __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex w-full', thList),
      role: "tablist"
    }, els);

    var hasActiveIndex = activeIndexes.length > 0 && !activeIndexes.includes(-1);
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])('relative isolate', className),
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      className: "z-1",
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft(activeIndexes)), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasControlsOnTouch: hasControlsOnTouch,
      navPosition: "top",
      theme: "tabs"
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight(activeIndexes)))), message && __jsx("div", {
      className: "justify-end md:flex"
    }, __jsx(Notification["a" /* Notification */], {
      className: "mb-20 md:order-1 md:mb-0",
      "data-testid": "specialOfferBlock",
      iconName: icons["a" /* ICONS */].SPECIAL_OFFERS
    }, __jsx(Text["a" /* Text */], {
      "data-testid": "specialOfferText",
      text: message,
      theme: "text-sans-n1"
    }))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: Object(classnames_utils["a" /* classnames */])(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), hasActiveIndex), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: Object(classnames_utils["a" /* classnames */])({
          'pointer-events-none invisible h-0 overflow-hidden': !isActive,
          'animation-duration-500 animate-fadeIn': isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i),
          index: index
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVRL_PMNTS; });
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return trackErrorOnAddService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleWrongUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateRange; });
/* unused harmony export hexToRgba */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getExclusiveCollectionFromComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getExclusiveCollectionFromAccomodation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("zytj");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("1qsz");






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_23__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var SVRL_PMNTS = 'svrl-pmnts';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, product) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* hasChildcare */ "n"])(selectedProposal) && !product.isJoyview && !product.isUrbanOasis && selectedProposal.additionalServices.childcares.length === 0 || product.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY || product.isUrbanOasis && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* hasTransfer */ "q"])(selectedProposal) && !lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isPartiallyPaid = _ref.isPartiallyPaid,
      isPartiallyPaid = _ref$isPartiallyPaid === void 0 ? false : _ref$isPartiallyPaid,
      _ref$shouldHideActivi = _ref.shouldHideActivitiesStepAbTest,
      shouldHideActivitiesStepAbTest = _ref$shouldHideActivi === void 0 ? false : _ref$shouldHideActivi;
  var bankingStep = {
    name: 'banking',
    eventPageName: 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: 'banking',
    agenceType: 'NonDucroire',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: true,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title,
    gridSize: ''
  };

  if (isPartiallyPaid) {
    // the proposals should not be modified after an household has already paid
    return [bankingStep];
  }

  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* isRecommendedTransport */ "x"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && !shouldHideActivitiesStepAbTest && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_29__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;

  var isJoyview = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(resort, 'isJoyview');

  var isUrbanOasis = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(resort, 'isUrbanOasis');

  var isUrbanOasisOrJoyview = isJoyview || isUrbanOasis;
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_26__[/* tAlt */ "u"])({
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      product: resort,
      resortKeyPath: 'booking.accommodation.pageTitle'
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__[/* getTransportIcon */ "m"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports.inbound'), lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports.outbound')),
    // eslint-disable-next-line no-nested-ternary
    title: isRecommendedTransportSelected ? i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isUrbanOasisOrJoyview ? 'allInclusive' : 'service',
    labelGA: isUrbanOasisOrJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isUrbanOasisOrJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isUrbanOasisOrJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'medium'
  }];

  if (activitiesView) {
    breadcrumbPages.splice(3, 0, activitiesView);
  } // adds the banking step if the optionHoldOnly featureFlip is disabled


  if (!isOptionHoldOnlyFeatureFlipped) {
    breadcrumbPages.push(bankingStep);
  } // $FlowFixMe Absolutely no clue of why


  return lodash_reject__WEBPACK_IMPORTED_MODULE_19___default()(breadcrumbPages, 'isToBeHidden');
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var trackErrorOnAddService = function trackErrorOnAddService(error, trackCallback, defaultValue) {
  if (error) {
    var _error$errors, _error$errors$;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.errorCode;
    trackCallback({
      labelGA: "error_".concat(errorCode ? errorCode : defaultValue)
    });
  }
};
var handleWrongUrl = function handleWrongUrl(router) {
  var _router$query, _router$query2, _router$query3;

  var proposalIds = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.proposalIds;
  var bookingStep = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.bookingStep;
  var date = (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.date;
  var today = new Date();
  var isExpiredDate = moment__WEBPACK_IMPORTED_MODULE_22___default()(date).isBefore(moment__WEBPACK_IMPORTED_MODULE_22___default()(today), 'day');

  if (!router.query || !proposalIds || proposalIds.length < 1 || !bookingStep || isExpiredDate) {
    // If the url misses proposalsIds or bookingStep, or has a date in the past
    // then, we should redirect to homepage instead of throwing a 500 error
    _logger_logger__WEBPACK_IMPORTED_MODULE_21__["default"].error('If the url misses proposalsIds or bookingStep, or has a date in the past, then we should redirect to homepage instead of throwing a 500 error');
    router.push('/');
    throw new Error('Invalid booking paramerter');
  }
};
var getDepartureDateRange = function getDepartureDateRange(daysBeforeDeparture) {
  if (daysBeforeDeparture <= 34) {
    return 'late_booking';
  }

  if (daysBeforeDeparture <= 90) {
    return 'middle_booking';
  }

  return 'early_booking';
};
var hexToRgba = function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (hex === '' || hex === null || !hex.startsWith('#')) {
    hex = '#924833';
  }

  var matches = hex && hex.match(/\w\w/g);

  if (!matches) {
    return hex;
  }

  var _matches$map = matches.map(function (x) {
    return parseInt(x, 16);
  }),
      _matches$map2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_matches$map, 3),
      r = _matches$map2[0],
      g = _matches$map2[1],
      b = _matches$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};
var getExclusiveCollectionFromComfort = function getExclusiveCollectionFromComfort(comfort, hasECSpace) {
  if (hasECSpace) {
    return 'exclusive_collection_space';
  }

  if (comfort == null) {
    return undefined;
  }

  if (comfort < 5) {
    return 'no';
  }

  return 'exclusive_collection';
};
var getExclusiveCollectionFromAccomodation = function getExclusiveCollectionFromAccomodation(hasECSpace, isEclusiveCollectionAccommodation) {
  if (isEclusiveCollectionAccommodation && hasECSpace) {
    return 'exclusive_collection_space';
  }

  if (isEclusiveCollectionAccommodation && !hasECSpace) {
    return 'exclusive_collection';
  }

  return 'no';
};

/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center w-320',
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx


var __jsx = react_default.a.createElement;







var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "icon", "iconSize", "size", "theme"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize,
    size: size
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4GH7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _wrap2 = __webpack_require__("Zk8D");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = function () {
  function LatLng(lat, lng) {
    _classCallCheck(this, LatLng);

    if (isNaN(lat) || isNaN(lng)) {
      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
    }
    this.lat = +lat;
    this.lng = +lng;
  }

  LatLng.prototype.wrap = function wrap() {
    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
  };

  return LatLng;
}();

LatLng.convert = function (a) {
  if (a instanceof LatLng) {
    return a;
  }

  if (Array.isArray(a)) {
    return new LatLng(a[0], a[1]);
  }

  if ('lng' in a && 'lat' in a) {
    return new LatLng(a.lat, a.lng);
  }

  return a;
};

exports.default = LatLng;

/***/ }),

/***/ "4I0e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "4KA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TeaserCard_TeaserCard; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.themes.js
var themes = {
  "default": {
    thRoot: 'flex flex-col',
    thImage: 'bg-grey isolate order-first overflow-hidden rounded-12 transition-all duration-250 ease-in',
    thImageActive: 'opacity-75 scale-095'
  },
  "short": {
    thRoot: 'flex flex-col h-full isolate overflow-hidden relative rounded-12 shadow-sm transition-all duration-250 ease-in',
    thChildren: 'p-15 md:p-20 h-full',
    thRootActive: 'shadow-md',
    thImage: 'bg-grey order-first overflow-hidden rounded-t-12 shrink-0 duration-250 ease-in transition-all'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx

var __jsx = react_default.a.createElement;






var TeaserCard_TeaserCard = function TeaserCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].R_38_BY_28 : _ref$ratio,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var defaultPicture = media[0] || {};
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thRootActive = _themes$theme.thRootActive,
      thChildren = _themes$theme.thChildren,
      thImage = _themes$theme.thImage,
      thImageActive = _themes$theme.thImageActive;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, Object(defineProperty["a" /* default */])({
      'h-full': media.length <= 1
    }, thRootActive, isActive), className)
  }, __jsx("div", {
    className: thChildren
  }, children), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thImage, Object(defineProperty["a" /* default */])({}, thImageActive, isActive))
  }, media.length > 1 ? __jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasLazyLoading: true,
    media: media,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratio
  }) : __jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    ratioKey: ratio,
    ratioDisplay: 1 / 4
  })));
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-20 text-black text-20', {
      'sr-only': !label
    }, className),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4XSA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      var parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

        parsed = +parsed;
      }

      if (this.isType(parsed)) return parsed;
      return parseFloat(parsed);
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = _locale.number.lessThan;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = _locale.number.moreThan;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = _locale.number.positive;
    }

    return this.moreThan(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = _locale.number.negative;
    }

    return this.lessThan(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = _locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "4gXF":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("nnO8");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "4i1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getDefaultTrackingProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getDestinationTrackingProps; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getDestinationTravelTrackingProps; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getLandingTrackingProps; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getOfferTrackingProps; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getPrebookingTrackingProps; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getHomepageTrackingProps; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ resolveDepartureDateTracking; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getTourTrackingProps; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getResortTrackingProps; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__("Umn3");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__("5x5+");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("HO86");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__("kQdG");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return Object(arrayWithHoles["a" /* default */])(arr) || Object(iterableToArray["a" /* default */])(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || Object(nonIterableRest["a" /* default */])();
}
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/toUpper.js
var toUpper = __webpack_require__("9BmX");
var toUpper_default = /*#__PURE__*/__webpack_require__.n(toUpper);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/toLower.js
var toLower = __webpack_require__("Eu1I");
var toLower_default = /*#__PURE__*/__webpack_require__.n(toLower);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// CONCATENATED MODULE: ./node_modules/path-to-regexp/dist.es2015/index.js
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at " + i);
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at " + j);
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at " + j);
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern)
                throw new TypeError("Missing pattern at " + i);
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function () {
        var result = "";
        var value;
        // tslint:disable-next-line
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:" + token.pattern + ")$", reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"" + token.name + "\" to not repeat, but got an array");
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"" + token.name + "\" to not be empty");
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"" + token.name + "\" to be " + typeOfMessage);
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function dist_es2015_match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            // tslint:disable-next-line
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) {
        for (var i = 0; i < groups.length; i++) {
            keys.push({
                name: i,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            });
        }
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d;
    var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    }
                    else {
                        route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                    }
                }
                else {
                    route += "(" + token.pattern + ")" + token.modifier;
                }
            }
            else {
                route += "(?:" + prefix + suffix + ")" + token.modifier;
            }
        }
    }
    if (end) {
        if (!strict)
            route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiter.indexOf(endToken[endToken.length - 1]) > -1
            : // tslint:disable-next-line
                endToken === undefined;
        if (!strict) {
            route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        }
        if (!isEndDelimited) {
            route += "(?=" + delimiter + "|" + endsWith + ")";
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/tracking/resort.js
var tracking_resort = __webpack_require__("zCbR");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/utils.js























function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}








var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;

function matchPath(path, pathSchema) {
  var keys = [];
  var regexp = pathToRegexp(pathSchema, keys);
  var match = regexp.exec(path);

  if (match) {
    var _match = _toArray(match),
        url = _match[0],
        paramValues = _match.slice(1);

    return {
      matched: true,
      url: url,
      params: keys.reduce(function (memo, key, index) {
        return _objectSpread(_objectSpread({}, memo), {}, Object(defineProperty["a" /* default */])({}, key.name, paramValues[index]));
      }, {})
    };
  }

  return {
    matched: false
  };
}

function getDefaultTrackingProps(_ref) {
  var pageId = _ref.pageId,
      pageType = _ref.pageType;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getDestinationTrackingProps(_ref2) {
  var pageType = _ref2.pageType,
      _ref2$pageRegion = _ref2.pageRegion;
  _ref2$pageRegion = _ref2$pageRegion === void 0 ? {
    name: null
  } : _ref2$pageRegion;
  var destinationRegion = _ref2$pageRegion.name,
      _ref2$pageCountry = _ref2.pageCountry;
  _ref2$pageCountry = _ref2$pageCountry === void 0 ? {
    name: null
  } : _ref2$pageCountry;
  var destinationCountry = _ref2$pageCountry.name;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  }); // The default productType for 'destination' && 'destination-mice' pages is 'resort',
  // Otherwise it is specified after the hyphen, e.g. 'destination-tour' or 'destination-cruise'.

  var productType = pageType === PAGE_TYPES.DESTINATION || pageType === PAGE_TYPES.DESTINATION_MICE ? PAGE_TYPES.RESORT : pageType.split('-')[1];
  var productTypes = Object.keys(PRODUCT_TYPES).map(toLower_default.a);
  var isIndexPage = !destinationRegion && !destinationCountry;
  var pageName = siteSection;

  if (!isIndexPage) {
    var pageIdentifier = [destinationRegion, destinationCountry].filter(function (item) {
      return !!item;
    }).join('_');
    pageName = "".concat(siteSection, "_").concat(pageIdentifier);
  }

  return _objectSpread({
    siteSection: siteSection,
    pageName: pageName,
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  }, productTypes.includes(productType) ? {
    productType: toUpper_default()(productType)
  } : null);
}
function getDestinationTravelTrackingProps(_ref3) {
  var pageId = _ref3.pageId,
      pageMeta = _ref3.pageMeta,
      _ref3$pageRegion = _ref3.pageRegion;
  _ref3$pageRegion = _ref3$pageRegion === void 0 ? {
    name: null
  } : _ref3$pageRegion;
  var destinationRegion = _ref3$pageRegion.name,
      _ref3$pageCountry = _ref3.pageCountry;
  _ref3$pageCountry = _ref3$pageCountry === void 0 ? {
    name: null
  } : _ref3$pageCountry;
  var destinationCountry = _ref3$pageCountry.name; // 'Travel' section != 'DestinationTravel' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Travel';
  var _pageMeta$name = pageMeta.name,
      name = _pageMeta$name === void 0 ? null : _pageMeta$name;
  var pageIdentifier = name ? name : pageId;
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier),
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  };
}
function getLandingTrackingProps(_ref4, resort) {
  var pageId = _ref4.pageId,
      pageType = _ref4.pageType,
      pageMeta = _ref4.pageMeta;
  var isSummerCamp = (resort === null || resort === void 0 ? void 0 : resort.type) === PRODUCT_TYPES.SUMMER_CAMP;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageMeta$name2 = pageMeta.name,
      name = _pageMeta$name2 === void 0 ? null : _pageMeta$name2;
  var pageIdentifier = name ? name : pageId;

  if (isSummerCamp && resort) {
    return {
      siteSection: siteSection,
      pageName: "".concat(siteSection, "_SummerCamp_").concat(resort.id),
      categoryGA: pageIdentifier
    };
  }

  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier)
  };
}
function getOfferTrackingProps(_ref5) {
  var pagePath = _ref5.pagePath; // 'Offers' section != 'Offer' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Offers';

  var _matchPath = matchPath(pagePath, '/o/:offerSlug?'),
      _matchPath$params = _matchPath.params;

  _matchPath$params = _matchPath$params === void 0 ? {} : _matchPath$params;
  var offerSlug = _matchPath$params.offerSlug;
  var pageName = offerSlug ? "".concat(siteSection, "_").concat(Object(utils["p" /* noCase */])(offerSlug)) : siteSection;
  return {
    siteSection: siteSection,
    pageName: pageName,
    channel: 'Offers'
  };
}
function getPrebookingTrackingProps(_ref6) {
  var pageId = _ref6.pageId,
      pageType = _ref6.pageType;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getHomepageTrackingProps(_ref7) {
  var pageId = _ref7.pageId;
  var siteSection = 'Shopping_Home';
  var categoryGA = pageId.toLowerCase();
  return {
    categoryGA: categoryGA,
    siteSection: siteSection,
    pageName: "".concat(siteSection)
  };
}
function resolveDepartureDateTracking(departureDate) {
  var daysBeforeDapture = Object(apiDate["j" /* momentFromApiDate */])(departureDate).diff(moment_default()(), 'days');
  return {
    resort_departure_date: departureDate,
    departure_quarter: Object(apiDate["j" /* momentFromApiDate */])(departureDate).quarter(),
    departure_semester: Object(apiDate["j" /* momentFromApiDate */])(departureDate).quarter() > 2 ? 2 : 1,
    departure_date_range: Object(BookingEngine_utils["c" /* getDepartureDateRange */])(daysBeforeDapture),
    resort_year_season: Object(apiDate["j" /* momentFromApiDate */])(departureDate).format('YYYY')
  };
}
function getTourTrackingProps(_ref8) {
  var pageType = _ref8.pageType,
      _ref8$pageData = _ref8.pageData,
      pageData = _ref8$pageData === void 0 ? {} : _ref8$pageData;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageData$resort = pageData.resort,
      resort = _pageData$resort === void 0 ? {} : _pageData$resort,
      _pageData$price = pageData.price,
      price = _pageData$price === void 0 ? {} : _pageData$price,
      _pageData$bookingCrit = pageData.bookingCriteria,
      bookingCriteria = _pageData$bookingCrit === void 0 ? {} : _pageData$bookingCrit;

  var resortId = get_default()(resort, 'id'); // '_Main' is appended to resort pageNames to preserve historical tracking consistency


  var pageName = "".concat(siteSection.toLowerCase(), "_").concat(resortId);

  var departureCityCode = get_default()(price, 'termsAndConditions.departureCity.value');

  var departureCityName = get_default()(price, 'termsAndConditions.departureCity.name');

  var departureDate = get_default()(price, 'termsAndConditions.departureDate', null);

  return _objectSpread(_objectSpread({}, resolveDepartureDateTracking(departureDate)), {}, {
    page_name: pageName,
    site_section: siteSection,
    isProductPage: true,
    resort_code: get_default()(resort, 'id', null),
    resort_country: toUpper_default()(get_default()(resort, 'destination.country', '')),
    resort_name: toUpper_default()(get_default()(resort, 'name', '')),
    resort_season_type: get_default()(resort, 'seasonName', null),
    resort_region: toUpper_default()(get_default()(resort, 'destination.area', '')),
    resort_type: get_default()(resort, 'type', null),
    resort_year_season: '',
    resort_exclusive_collection: Object(BookingEngine_utils["e" /* getExclusiveCollectionFromComfort */])((resort === null || resort === void 0 ? void 0 : resort.comfort) || '', (resort === null || resort === void 0 ? void 0 : resort.hasECSpace) || ''),
    resort_url_image: get_default()(resort, 'image', null),
    resort_participants: ((bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialNumberOfAdults) || 0) + ((bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialNumberOfChildren) || 0),
    resort_night_number: (bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialDuration) || 1,
    resort_adult: (bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialNumberOfAdults) || 0,
    resort_children: (bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialNumberOfChildren) || 0,
    resort_departure_city_name: toUpper_default()(Object(tracking_resort["d" /* getDepartureCityName */])(departureCityCode, departureCityName)),
    resort_default_price: get_default()(price, 'bestPrice.value', null)
  });
}
function getResortTrackingProps(_ref9) {
  var pageType = _ref9.pageType,
      _ref9$pageData = _ref9.pageData,
      pageData = _ref9$pageData === void 0 ? {} : _ref9$pageData;
  var siteSection = Object(utils["k" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageData$resort2 = pageData.resort,
      resort = _pageData$resort2 === void 0 ? {} : _pageData$resort2,
      _pageData$price2 = pageData.price,
      price = _pageData$price2 === void 0 ? {} : _pageData$price2,
      _pageData$bookingCrit2 = pageData.bookingCriteria,
      bookingCriteria = _pageData$bookingCrit2 === void 0 ? null : _pageData$bookingCrit2;

  var resortId = get_default()(resort, 'id'); // '_Main' is appended to resort pageNames to preserve historical tracking consistency


  var pageName = get_default()(resort, 'type', '') === PRODUCT_TYPES.RESORT ? "".concat(siteSection, "_").concat(resortId, "_Main") : "".concat(siteSection, "_").concat(resortId);

  var departureCityCode = get_default()(price, 'termsAndConditions.departureCity.value');

  var departureCityName = get_default()(price, 'termsAndConditions.departureCity.name');

  return {
    isProductPage: true,
    categoryGA: "".concat(pageType, "-").concat(resortId),
    siteSection: siteSection,
    pageName: pageName,
    resortCode: get_default()(resort, 'id', null),
    resortCountry: toUpper_default()(get_default()(resort, 'destination.country', '')),
    resortDefaultPrice: get_default()(price, 'bestPrice.value', null),
    resortDepartureCityCode: toUpper_default()(Object(tracking_resort["c" /* getDepartureCityCode */])(departureCityCode)),
    resortDepartureCityName: toUpper_default()(Object(tracking_resort["d" /* getDepartureCityName */])(departureCityCode, departureCityName)),
    resortDepartureDate: get_default()(price, 'termsAndConditions.departureDate', null),
    resortName: toUpper_default()(get_default()(resort, 'name', '')),
    resortOldPrice: get_default()(price, 'initialPrice.value', null),
    resortRegion: toUpper_default()(get_default()(resort, 'destination.area', '')),
    resortSeasonType: get_default()(resort, 'seasonName', null),
    resortTransport: toUpper_default()(Object(tracking_resort["e" /* getTrackingTransport */])(departureCityCode)),
    resortTrident: get_default()(resort, 'comfort', null),
    resortUrlImage: get_default()(resort, 'image', null),
    bookingCriteria: bookingCriteria
  };
}

/***/ }),

/***/ "4xcl":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

module.exports = upperCase;


/***/ }),

/***/ "5LiQ":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("dNjr");
var toAbsoluteIndex = __webpack_require__("Jm8J");
var lengthOfArrayLike = __webpack_require__("XhyO");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "5h8T":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var call = __webpack_require__("we+H");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createPropertyDescriptor = __webpack_require__("OouP");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var hasOwn = __webpack_require__("/GgU");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "5iaM":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("lPgN");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "5r8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _snakeCase2 = _interopRequireDefault(__webpack_require__("CzFL"));

var _camelCase2 = _interopRequireDefault(__webpack_require__("S0cN"));

var _mapKeys = _interopRequireDefault(__webpack_require__("A0Zq"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _propertyExpr = __webpack_require__("dFUt");

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _sortFields = _interopRequireDefault(__webpack_require__("7pmY"));

var _sortByKeyOrder = _interopRequireDefault(__webpack_require__("OhDV"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    var isChanged = false;
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);

        if (field._strip === true) {
          isChanged = isChanged || prop in value;
          return;
        }

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];

      if (intermediateValue[prop] !== value[prop]) isChanged = true;
    });
    return isChanged ? intermediateValue : value;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field && field.validate) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          return field.validate(value[key], innerOptions);
        }

        return Promise.resolve(true);
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone();
    var fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, _propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      if (obj == null) return obj;
      var newObj = obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete newObj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    next._options.stripUnknown = noAllow;
    return next;
  },
  unknown: function unknown(allow, message) {
    if (allow === void 0) {
      allow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    return this.noUnknown(!allow, message);
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "5svr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ productAccommodations_utils_getAllAvailableItems; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ withExclusiveCollectionTag; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ groupAccommodationsByCategory; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getTabsItemsAndPropsFromAccommodations; });

// UNUSED EXPORTS: getSurfaceIconItem, getCapacityIconItem, getViewIconItem, getOutsideFacilitiesIconItems, aggregateIconList, mapAccommodationServices

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/unionBy.js
var unionBy = __webpack_require__("2z5K");
var unionBy_default = /*#__PURE__*/__webpack_require__.n(unionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersectionBy.js
var intersectionBy = __webpack_require__("wyfB");
var intersectionBy_default = /*#__PURE__*/__webpack_require__.n(intersectionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/compact.js
var compact = __webpack_require__("3dHC");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx + 2 modules
var ProductInformationSlider_container = __webpack_require__("JjZN");

// EXTERNAL MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx + 3 modules
var ProductRoomsComparatorLauncher = __webpack_require__("9tk8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/markup/markup.js
var markup = __webpack_require__("Iz3O");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx + 1 modules
var TeaserCard = __webpack_require__("4KA2");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-card/ProductRoomCard.jsx












var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductRoomCard_ProductRoomCard = function ProductRoomCard(_ref) {
  var className = _ref.className,
      isHidden = _ref.isHidden,
      isLarge = _ref.isLarge,
      _ref$labeledIconsList = _ref.labeledIconsList,
      labeledIconsList = _ref$labeledIconsList === void 0 ? [] : _ref$labeledIconsList,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var TagName = Object(markup["b" /* getLinkTagName */])(link);
  var linkProps = Object(markup["a" /* getLinkProps */])(link);

  var content = __jsx(react["Fragment"], null, __jsx(Title["a" /* Title */], {
    hasEllipsis: true,
    theme: "title-brand-n3"
  }, title), __jsx("ul", {
    className: "space-y-5"
  }, labeledIconsList.map(function (_ref2, index) {
    var labels = _ref2.labels;
    return !!labels && __jsx("li", {
      className: "inline-flex min-h-20 w-full items-center justify-between gap-5 overflow-hidden text-14",
      key: index
    }, labels.map(function (label, labelIndex) {
      return __jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])({
          'text-mediumGrey': labelIndex === 0,
          'text-end font-bold text-black': labelIndex !== 0
        }),
        key: label
      }, label, "\xA0");
    }));
  })), !!seeMoreLabel && __jsx("p", {
    className: "mt-auto text-center text-12 text-black underline"
  }, seeMoreLabel));

  var props = _objectSpread(_objectSpread({}, linkProps), {}, {
    onClick: function onClick() {
      var _linkProps$onClick;

      (_linkProps$onClick = linkProps.onClick) === null || _linkProps$onClick === void 0 ? void 0 : _linkProps$onClick.call(linkProps);
    }
  });

  var ratio = isLarge && isTablet ? ratios_utils["c" /* default */].R_38_BY_58 : ratios_utils["c" /* default */].XL;
  return isDesktop ? __jsx(TeaserCard["a" /* TeaserCard */], {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent transition-transform w-full duration-250 ease-in', className),
    isActive: isHovering,
    media: media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratio: ratio,
    theme: "short"
  }, __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    className: "text-initial flex w-full flex-col items-stretch gap-10",
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    tabIndex: isHidden ? -1 : 0
  }), content)) : __jsx(TagName, Object(esm_extends["a" /* default */])({}, props, {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('tap-highlight-color-transparent text-initial block h-full w-full', className),
    tabIndex: isHidden ? -1 : 0
  }), __jsx(TeaserCard["a" /* TeaserCard */], {
    media: media.slice(0, 1),
    ratio: ratio,
    theme: "short"
  }, content));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx + 1 modules
var Sheet = __webpack_require__("RHTr");

// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-district/resortDistrict.utils.js
var resortDistrict_utils = __webpack_require__("dAFS");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/ResortDistrictContainer.jsx



var ResortDistrictContainer_jsx = react_default.a.createElement;






var ResortDistrict = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(966)]).then(__webpack_require__.bind(null, "V163")).then(function (mod) {
    return mod.ResortDistrict;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("V163")];
    },
    modules: ["./ResortDistrict"]
  }
});
var ResortDistrictContainer_ResortDistrictContainer = function ResortDistrictContainer(props) {
  var _data$resortAreas, _data$resortAreas2;

  var resortId = props.resortId;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Object(resortDistrict_utils["a" /* getResortDistrictQuery */])(resortId),
    queryOptions: {
      requestName: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */],
      cacheFront: {
        key: requestDictionary["W" /* CUSTOMER_BOOKING_RD_GET_RESORT_SETTINGS */] + resortId
      }
    },
    ignore: !resortId
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  if (isLoading) {
    return ResortDistrictContainer_jsx("div", {
      className: "flex h-full w-full items-center justify-center"
    }, ResortDistrictContainer_jsx(AsyncLoader["a" /* AsyncLoader */], null));
  }

  if (!(data === null || data === void 0 ? void 0 : (_data$resortAreas = data.resortAreas) === null || _data$resortAreas === void 0 ? void 0 : _data$resortAreas.areas) || !(data === null || data === void 0 ? void 0 : (_data$resortAreas2 = data.resortAreas) === null || _data$resortAreas2 === void 0 ? void 0 : _data$resortAreas2.geoData)) {
    return null;
  }

  return ResortDistrictContainer_jsx(ResortDistrict, Object(esm_extends["a" /* default */])({}, data, props));
};
// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-detail/ProductRoomDetail.jsx













var ProductRoomDetail_jsx = react_default.a.createElement;

function ProductRoomDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductRoomDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductRoomDetail_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductRoomDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var ProductRoomDetail_ProductRoomDetail = function ProductRoomDetail(_ref) {
  var _ref$areas = _ref.areas,
      areas = _ref$areas === void 0 ? [] : _ref$areas,
      description = _ref.description,
      immersive = _ref.immersive,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$overviewCompact = _ref.overviewCompact,
      overviewCompact = _ref$overviewCompact === void 0 ? [] : _ref$overviewCompact,
      _ref$overviewAlternat = _ref.overviewAlternate,
      overviewAlternate = _ref$overviewAlternat === void 0 ? [] : _ref$overviewAlternat,
      strengthsLabel = _ref.strengthsLabel,
      amenitiesLabel = _ref.amenitiesLabel,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? [] : _ref$services,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$multimedia = _ref.multimedia,
      multimedia = _ref$multimedia === void 0 ? {} : _ref$multimedia,
      _ref$floorPlans = _ref.floorPlans,
      floorPlans = _ref$floorPlans === void 0 ? [] : _ref$floorPlans,
      productId = _ref.productId,
      title = _ref.title,
      subtitle = _ref.subtitle;

  var slideshowProps = ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, slideshow), {}, {
    groupKey: 'roomDetail',
    hasInfiniteScroll: true,
    media: slideshow.media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: 0.8
  });

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var numberOfPhotos = multimedia && multimedia.photos ? multimedia.photos.length : 0;
  var multimediaProps = {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    descriptionLabels: {
      photos: '',
      streetViews: Object(src_i18n["h" /* t */])('common.view360Disclaimer')
    },
    galleryLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.galleries.gallery'),
    isOverlay: true,
    labels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle')
    },
    medias: multimedia,
    nextLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.previous'),
    pictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
      total: numberOfPhotos,
      productName: title
    })
  };

  var getHeader = function getHeader(floorPlansLength, index) {
    return floorPlansLength > 1 ? {
      header: {
        title: "".concat(index === 0 ? '' : '+').concat(index)
      }
    } : null;
  };

  var getFloorplansTabs = function getFloorplansTabs() {
    return floorPlans.map(function (floorPlan, index) {
      return ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, getHeader(floorPlans.length, index)), {}, {
        content: ProductRoomDetail_jsx("div", {
          className: "mx-auto w-full max-w-site-small",
          key: index
        }, ProductRoomDetail_jsx("div", {
          className: "flex flex-col"
        }, !isTablet && ProductRoomDetail_jsx(Tooltip["a" /* Tooltip */], {
          trackingData: {
            actionGA: 'layer',
            labelGA: 'floorPlans'
          },
          renderTrigger: function renderTrigger(toggle) {
            return ProductRoomDetail_jsx("button", {
              onClick: function onClick() {
                toggle();
              },
              className: "mb-15 ms-auto rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-colors duration-250 ease-in hocus:bg-black/60 hocus:text-white",
              type: "button"
            }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
              name: icons["a" /* ICONS */].EXPAND,
              width: "1.25rem"
            }));
          },
          modalProps: {
            addendum: ProductRoomDetail_jsx(Text["a" /* Text */], {
              className: "px-10 py-20 text-center text-12 leading-tight text-white",
              text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer'),
              theme: "none"
            }),
            children: ''
          }
        }, ProductRoomDetail_jsx(Zoom["a" /* Zoom */], {
          alt: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          hint: Object(src_i18n["h" /* t */])('common.roomPlan.swipeInstruction'),
          imageUrl: floorPlan
        })), ProductRoomDetail_jsx("div", {
          className: "relative isolate h-0 w-full pb-[60%] md:pb-[50%]"
        }, ProductRoomDetail_jsx(Image["a" /* Image */], {
          altMsg: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
          className: "absolute flex h-full w-full items-center justify-center",
          dimensions: DIMENSIONS,
          imageUrl: floorPlan,
          transformation: "resize"
        })), ProductRoomDetail_jsx(Text["a" /* Text */], {
          className: "pb-40 pt-30 leading-tight md:pb-80 md:pt-25 md:text-center",
          text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer')
        })))
      });
    });
  };

  var color = isExclusiveCollection ? colors["a" /* COLORS */].ULTRAMARINE : colors["a" /* COLORS */].BLACK;
  var hasResortDistrict = Object(src_i18n["e" /* getListValue */])('common.resortDistrict.productIds', 15).includes(productId) && !!(areas === null || areas === void 0 ? void 0 : areas.length);

  var header = ProductRoomDetail_jsx("section", {
    className: "p-20 md:pt-80"
  }, ProductRoomDetail_jsx("p", {
    className: "mb-5 text-16 md:text-20"
  }, subtitle), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "text-".concat(color),
    theme: "title-brand-n44"
  }, title), ProductRoomDetail_jsx("ul", {
    className: "mb-25 mt-20 flex gap-5 text-14 md:mb-50"
  }, overviewCompact.map(function (item, index) {
    return ProductRoomDetail_jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])('md:basis-1/5', {
        'basis-1/2': !(hasResortDistrict && !!productId && areas.length > 0),
        'basis-1/3': hasResortDistrict && !!productId && areas.length > 0
      }),
      key: index
    }, item.map(function (line, idx) {
      return ProductRoomDetail_jsx("span", {
        className: Object(classnames_utils["a" /* classnames */])('block', {
          'font-bold': idx === 0
        }),
        key: "".concat(index, "-").concat(idx)
      }, line);
    }));
  }), hasResortDistrict && !!productId && areas.length > 0 && ProductRoomDetail_jsx("li", {
    className: "basis-1/3 md:basis-1/5"
  }, ProductRoomDetail_jsx("span", {
    className: "block font-bold"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), areas.map(function (area) {
    return ProductRoomDetail_jsx("div", {
      className: "flex items-center gap-5",
      key: area.id
    }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].ADDRESS
    }), ProductRoomDetail_jsx("button", {
      className: "text-initial underline",
      onClick: function onClick() {
        return Object(scrollToHash["a" /* goToHash */])('#room-location', true, 'smooth');
      },
      type: "button"
    }, area.label));
  }))), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: "mx-auto w-full max-w-site-small md:text-20",
    text: description,
    theme: "text-sans-n3"
  }));

  return ProductRoomDetail_jsx(Sheet["a" /* Sheet */], {
    fullWidthContent: true,
    header: header,
    immersive: immersive,
    isExclusiveCollection: isExclusiveCollection,
    multimedia: multimediaProps,
    slideshow: slideshowProps
  }, !!overviewAlternate.length && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, strengthsLabel), ProductRoomDetail_jsx("div", {
    className: "mx-auto w-full max-w-site-small"
  }, ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    color: color,
    items: overviewAlternate
  }))), floorPlans.length > 0 && ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20 pb-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-40 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.roomPlan.title')), ProductRoomDetail_jsx(Tabs["a" /* Tabs */], {
    id: "product-accommodations-line-tabs",
    isContainerWide: true,
    isContentUnmountedOnCollapse: true,
    items: getFloorplansTabs()
  })), hasResortDistrict && !!productId && ProductRoomDetail_jsx("section", {
    className: "relative pb-20"
  }, ProductRoomDetail_jsx("div", {
    className: "absolute top-0 -mt-60 h-0 w-0",
    id: "room-location"
  }), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mx-auto mb-40 max-w-site-medium px-20 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, Object(src_i18n["h" /* t */])('common.resortDistrict.layerDistrictLabel')), ProductRoomDetail_jsx("div", {
    className: "pb-15 pt-60"
  }, ProductRoomDetail_jsx(ResortDistrictContainer_ResortDistrictContainer, {
    access: Object(src_i18n["h" /* t */])('common.resortDistrict.access'),
    resortId: productId,
    roomAreas: areas,
    roomLabel: title,
    trackingData: {
      actionGA: "layer_".concat(subtitle)
    }
  }))), ProductRoomDetail_jsx("section", {
    className: "mx-auto max-w-site-medium px-20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "mb-15 md:text-32 text-".concat(color),
    hLevel: 3,
    theme: "title-brand-n3"
  }, amenitiesLabel), services.map(function (_ref2) {
    var label = _ref2.label,
        items = _ref2.items;
    return ProductRoomDetail_jsx("section", {
      className: "mx-auto w-full max-w-site-small py-15 md:py-30",
      key: label
    }, ProductRoomDetail_jsx(Title["a" /* Title */], {
      className: "mb-30 border-b-1 border-ultramarine pb-10 md:text-20 text-".concat(color),
      hLevel: 4,
      theme: "title-brand-n4"
    }, label), ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      color: color,
      items: items,
      theme: "list"
    }));
  })));
};
// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var constants = __webpack_require__("tI+f");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js






























var productAccommodations_utils_jsx = react_default.a.createElement;

function productAccommodations_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function productAccommodations_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? productAccommodations_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : productAccommodations_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    RANKINGS = dist["constants"].RANKINGS;
var DEFAULT_RANKING = RANKINGS.LOW;
function getSurfaceIconItem(i18n, surface, roomType) {
  return {
    icon: icons["a" /* ICONS */][roomType] || null,
    labels: [get_default()(i18n, camelCase_default()(roomType)), surface || roomType && ' ' || '']
  };
}
function getCapacityIconItem(i18n, capacity) {
  var peopleLabel = get_default()(i18n, 'numberOfPeopleLabel');

  if (!capacity || !peopleLabel) {
    return null;
  }

  return {
    icon: icons["a" /* ICONS */].PEOPLE,
    labels: [get_default()(i18n, 'capacityOfPeopleLabel'), Object(dist["messageFormat"])(peopleLabel).format({
      count: capacity
    })]
  };
}
function getViewIconItem(view) {
  return view ? {
    icon: icons["a" /* ICONS */][get_default()(view, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [view.label]
  } : null;
}
function getOutsideFacilitiesIconItems(outsideFacilities) {
  if (isEmpty_default()(outsideFacilities)) {
    return null;
  }

  return outsideFacilities.map(function (item) {
    return {
      icon: icons["a" /* ICONS */][get_default()(item, 'id')],
      labels: [item.label]
    };
  });
}

function getServiceIconItem(service) {
  return service ? {
    icon: icons["a" /* ICONS */][get_default()(service, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [service.label]
  } : null;
}

function aggregateIconList(_ref) {
  var surfaceItem = _ref.surfaceItem,
      capacityItem = _ref.capacityItem,
      outsideFacilitiesItems = _ref.outsideFacilitiesItems,
      strengths = _ref.strengths,
      viewItem = _ref.viewItem;
  var maxAccomodationsToDisplay = 4;
  var accomodationsWithoutStrengthsCount = [capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem]).filter(function (item) {
    return get_default()(item, 'labels.0');
  }).length;
  var availableSpacesForStrengths = maxAccomodationsToDisplay - accomodationsWithoutStrengthsCount;
  var strengthsItems = (strengths || []).slice(0, availableSpacesForStrengths).map(function (strength) {
    return {
      icon: icons["a" /* ICONS */][get_default()(strength, 'id')] || icons["a" /* ICONS */].TRIDENT1,
      labels: [get_default()(strength, 'label') || '']
    };
  }); // $FlowFixMe

  return compact_default()([surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem], Object(toConsumableArray["a" /* default */])(strengthsItems))).filter(function (_ref2) {
    var _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return labels.length && labels[0];
  }).slice(0, 4);
}

function mapAccommodationStrengths(i18n, accommodation) {
  var maxCapacity = accommodation.maxCapacity,
      roomType = accommodation.roomType,
      strengths = accommodation.strengths,
      surface = accommodation.surface,
      view = accommodation.view,
      outsideFacilities = accommodation.outsideFacilities;
  var surfaceItem = getSurfaceIconItem(i18n, surface, roomType);
  var capacityItem = getCapacityIconItem(i18n, maxCapacity);
  var viewItem = getViewIconItem(view);
  var outsideFacilitiesItems = getOutsideFacilitiesIconItems(outsideFacilities);
  return {
    strengths: aggregateIconList({
      surfaceItem: surfaceItem,
      capacityItem: capacityItem
    }),
    strengthsCompact: [surfaceItem === null || surfaceItem === void 0 ? void 0 : surfaceItem.labels, capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.labels].filter(Boolean),
    strengthsAlternate: aggregateIconList({
      outsideFacilitiesItems: outsideFacilitiesItems,
      viewItem: viewItem,
      strengths: strengths
    })
  };
}

function mapAccommodationServices(i18n, accommodation, isExclusiveCollection) {
  var _accommodation$bathro = accommodation.bathroomEquipments,
      bathroomEquipments = _accommodation$bathro === void 0 ? [] : _accommodation$bathro,
      _accommodation$equipm = accommodation.equipments,
      equipments = _accommodation$equipm === void 0 ? [] : _accommodation$equipm,
      _accommodation$servic = accommodation.services,
      services = _accommodation$servic === void 0 ? [] : _accommodation$servic;
  var isSuiteAccommodation = (accommodation === null || accommodation === void 0 ? void 0 : accommodation.comfortId) === constants["c" /* COMFORT_TYPE_SUITE */];
  return [{
    label: isExclusiveCollection || isSuiteAccommodation ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }, {
    label: get_default()(i18n, 'equipmentLabel', ''),
    items: equipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: get_default()(i18n, 'bathroomLabel', ''),
    items: bathroomEquipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: !(isExclusiveCollection || isSuiteAccommodation) ? get_default()(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }].filter(function (service) {
    return service.label;
  });
}

function getRankingIndex(ranking) {
  return Object.values(RANKINGS).findIndex(function (r) {
    return r === ranking;
  });
}

function isProductExclusiveCollection(comfort) {
  return comfort > 4;
} // eslint-disable-next-line clubmed/no-fake-component


function getAccommodation(_ref3) {
  var accommodation = _ref3.accommodation,
      categoryLabel = _ref3.categoryLabel,
      resortComfort = _ref3.resortComfort,
      streetView = _ref3.streetView,
      i18n = _ref3.i18n;
  var areas = accommodation.areas,
      categoryId = accommodation.categoryId,
      comfortId = accommodation.comfortId,
      comfortType = accommodation.comfortType,
      description = accommodation.description,
      floorPlans = accommodation.floorPlans,
      id = accommodation.id,
      label = accommodation.label,
      photos = accommodation.media.photos,
      productId = accommodation.productId;

  var _mapAccommodationStre = mapAccommodationStrengths(i18n, accommodation),
      strengths = _mapAccommodationStre.strengths,
      strengthsCompact = _mapAccommodationStre.strengthsCompact,
      strengthsAlternate = _mapAccommodationStre.strengthsAlternate;

  var isDisplayable = [comfortType, label].every(function (item) {
    return !!item;
  });
  var isExclusiveCollection = isProductExclusiveCollection(resortComfort) || accommodation.exclusiveCollection;
  var images = photos.map(function (_ref4) {
    var url = _ref4.url;
    return {
      src: url
    };
  });
  var streetViews = !isEmpty_default()(streetView) && !!streetView.streetView ? [streetView.streetView] : undefined;
  var details = {
    areas: areas,
    categoryId: categoryId,
    comfort: resortComfort,
    comfortType: comfortType,
    comfortId: comfortId,
    description: description,
    floorPlans: floorPlans,
    immersive: {
      url: get_default()(photos, '[0].url')
    },
    isExclusiveCollection: isExclusiveCollection,
    label: label,
    categoryLabel: categoryLabel,
    overview: strengths,
    overviewCompact: strengthsCompact,
    overviewAlternate: strengthsAlternate,
    strengthsLabel: i18n.strengthsLabel,
    amenitiesLabel: i18n.amenitiesLabel,
    services: mapAccommodationServices(i18n, accommodation, isExclusiveCollection),
    slideshow: {
      groupeKey: 'roomCard',
      media: images
    },
    multimedia: {
      photos: photos,
      streetViews: streetViews
    },
    productId: productId
  };
  return isDisplayable && productAccommodations_utils_jsx(ProductRoomCard_ProductRoomCard, {
    fetchDetail: function fetchDetail() {
      return Promise.resolve(details);
    },
    isExclusiveCollection: isExclusiveCollection,
    key: id,
    labeledIconsList: strengths,
    media: images,
    seeMoreLabel: i18n.seeMore,
    title: label
  });
}

function renderDetail() {
  return function (_ref5) {
    var areas = _ref5.areas,
        comfort = _ref5.comfort,
        comfortType = _ref5.comfortType,
        description = _ref5.description,
        floorPlans = _ref5.floorPlans,
        isExclusiveCollection = _ref5.isExclusiveCollection,
        immersive = _ref5.immersive,
        label = _ref5.label,
        categoryLabel = _ref5.categoryLabel,
        overview = _ref5.overview,
        overviewCompact = _ref5.overviewCompact,
        overviewAlternate = _ref5.overviewAlternate,
        strengthsLabel = _ref5.strengthsLabel,
        amenitiesLabel = _ref5.amenitiesLabel,
        services = _ref5.services,
        slideshow = _ref5.slideshow,
        multimedia = _ref5.multimedia,
        productId = _ref5.productId;
    var customProps = {
      areas: areas,
      description: description,
      title: label,
      subtitle: categoryLabel,
      diamond: {
        label: comfortType
      },
      floorPlans: floorPlans,
      immersive: immersive,
      isExclusiveCollection: isProductExclusiveCollection(comfort) || isExclusiveCollection,
      overview: overview,
      overviewCompact: overviewCompact,
      overviewAlternate: overviewAlternate,
      strengthsLabel: strengthsLabel,
      amenitiesLabel: amenitiesLabel,
      services: services,
      slideshow: slideshow,
      multimedia: multimedia,
      productId: productId
    };
    return productAccommodations_utils_jsx(ProductRoomDetail_ProductRoomDetail, customProps);
  };
}

var productAccommodations_utils_getAllAvailableItems = function getAllAvailableItems(accommodationCategories, itemType) {
  return Object(dist["sortByRanking"])(accommodationCategories.reduce(function (items, accommodationCategory) {
    return unionBy_default()(items, accommodationCategory[itemType], 'id');
  }, []));
};

var isHighOrVeryHighRanking = function isHighOrVeryHighRanking(_ref6) {
  var ranking = _ref6.ranking;
  return [RANKINGS.VERY_HIGH, RANKINGS.HIGH].includes(ranking);
};

var withExclusiveCollectionTag = function withExclusiveCollectionTag(_ref7) {
  var _ref7$categoryId = _ref7.categoryId,
      categoryId = _ref7$categoryId === void 0 ? '' : _ref7$categoryId,
      isExclusiveCollection = _ref7.isExclusiveCollection;
  return ['typeoflodging_comfort_type_deluxe', 'typeoflodging_comfort_type_suite'].includes(categoryId) && isExclusiveCollection ? "".concat(categoryId, "_EC") : categoryId;
};
function groupAccommodationsByCategory(props) {
  var _props$accommodationC = props.accommodationCategory;
  _props$accommodationC = _props$accommodationC === void 0 ? {} : _props$accommodationC;
  var _props$accommodationC2 = _props$accommodationC.rankedCategories,
      rankedCategories = _props$accommodationC2 === void 0 ? [] : _props$accommodationC2,
      bathroomLabel = props.bathroomLabel,
      capacityOfPeopleLabel = props.capacityOfPeopleLabel,
      strengthsLabel = props.strengthsLabel,
      amenitiesLabel = props.amenitiesLabel,
      equipmentLabel = props.equipmentLabel,
      numberOfPeopleLabel = props.numberOfPeopleLabel,
      _props$resort = props.resort,
      _props$resort$accommo = _props$resort.accommodations,
      accommodations = _props$resort$accommo === void 0 ? [] : _props$resort$accommo,
      _props$resort$areas = _props$resort.areas,
      resortAreas = _props$resort$areas === void 0 ? [] : _props$resort$areas,
      _props$resort$comfort = _props$resort.comfort,
      resortComfort = _props$resort$comfort === void 0 ? 3 : _props$resort$comfort,
      type = _props$resort.type,
      productId = _props$resort.id,
      _props$roomConfigurat = props.roomConfiguration;
  _props$roomConfigurat = _props$roomConfigurat === void 0 ? {} : _props$roomConfigurat;
  var singleRoom = _props$roomConfigurat.singleRoom,
      connectingRooms = _props$roomConfigurat.connectingRooms,
      separatedRooms = _props$roomConfigurat.separatedRooms,
      seeMore = props.seeMore,
      servicesLabel = props.servicesLabel,
      streetViews = props.streetViews;
  var i18n = {
    bathroomLabel: bathroomLabel,
    capacityOfPeopleLabel: capacityOfPeopleLabel,
    strengthsLabel: strengthsLabel,
    amenitiesLabel: amenitiesLabel,
    connectingRooms: connectingRooms,
    equipmentLabel: equipmentLabel,
    numberOfPeopleLabel: numberOfPeopleLabel,
    seeMore: seeMore,
    separatedRooms: separatedRooms,
    servicesLabel: servicesLabel,
    singleRoom: singleRoom,
    surfaceLabel: Object(src_i18n["h" /* t */])('accommodations.surfaceLabel')
  }; // $FlowFixMe

  return Object.values( // $FlowFixMe
  accommodations.reduce(function (categories, accommodation) {
    // Ranking index to sort categories and accommodations within a category
    var rankedCategory = rankedCategories.find(function (c) {
      return c.id === accommodation.categoryId;
    });
    var categoryRanking = rankedCategory ? rankedCategory.ranking : DEFAULT_RANKING;
    var categoryIndex = getRankingIndex(categoryRanking);
    var streetView = streetViews && (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) > 0 ? streetViews.find(function (sv) {
      return sv.accommodationCategoryId === accommodation.categoryId;
    }) : []; // Accommodation tabs are now based on accommodation comfort, not category...

    var categoryId = accommodation.comfortId;
    var categoryLabel = accommodation.comfortType; // ...except for VILLA products

    if (type === PRODUCT_TYPES.VILLA) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = accommodation.categoryId;
      categoryLabel = accommodation.category;
    }

    if (!categoryId) {
      return categories;
    } // Ranking index to sort accommodations within a category


    var accommodationIndex = getRankingIndex(accommodation.ranking);
    var accommodationProps = {
      accommodation: productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, accommodation), {}, {
        areas: (accommodation.areas || []).map(function (area) {
          var _resortAreas$find;

          return {
            id: area.id,
            label: ((_resortAreas$find = resortAreas.find(function (_ref8) {
              var resortAreaId = _ref8.id;
              return resortAreaId === area.id;
            })) === null || _resortAreas$find === void 0 ? void 0 : _resortAreas$find.label) || ''
          };
        }),
        productId: productId
      }),
      accommodationIndex: accommodationIndex,
      categoryLabel: categoryLabel,
      categoryIndex: categoryIndex,
      colorId: accommodation.categoryId,
      resortComfort: resortComfort,
      streetView: streetView,
      i18n: i18n
    };
    categoryId = withExclusiveCollectionTag({
      categoryId: categoryId,
      isExclusiveCollection: accommodation.exclusiveCollection
    });

    if (categories[categoryId]) {
      var _accommodation$area, _categories$categoryI, _accommodation$area2, _accommodation$area3, _categories$categoryI2; // Add accommodation to category if it exists


      categories[categoryId].categoryAccommodations.push(accommodationProps);

      if (!categories[categoryId].minCapacity || accommodation.minCapacity && categories[categoryId].minCapacity > accommodation.minCapacity) {
        categories[categoryId].minCapacity = accommodation.minCapacity;
      }

      if (!categories[categoryId].maxCapacity || accommodation.maxCapacity && categories[categoryId].maxCapacity < accommodation.maxCapacity) {
        categories[categoryId].maxCapacity = accommodation.maxCapacity;
      }

      if (((_accommodation$area = accommodation.area) === null || _accommodation$area === void 0 ? void 0 : _accommodation$area.min) && accommodation.area.min < ((_categories$categoryI = categories[categoryId].area) === null || _categories$categoryI === void 0 ? void 0 : _categories$categoryI.min)) {
        categories[categoryId].area.min = accommodation.area.min;
      }

      if (((_accommodation$area2 = accommodation.area) === null || _accommodation$area2 === void 0 ? void 0 : _accommodation$area2.max) && ((_accommodation$area3 = accommodation.area) === null || _accommodation$area3 === void 0 ? void 0 : _accommodation$area3.max) > ((_categories$categoryI2 = categories[categoryId].area) === null || _categories$categoryI2 === void 0 ? void 0 : _categories$categoryI2.max)) {
        var _accommodation$area4;

        categories[categoryId].area.max = (_accommodation$area4 = accommodation.area) === null || _accommodation$area4 === void 0 ? void 0 : _accommodation$area4.max;
      }

      categories[categoryId].exclusiveCollection = accommodation.exclusiveCollection && categories[categoryId].exclusiveCollection;
      categories[categoryId].equipments = intersectionBy_default()(categories[categoryId].equipments, accommodation.equipments.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].services = intersectionBy_default()(categories[categoryId].services, accommodation.services.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].strengths = unionBy_default()(categories[categoryId].strengths, [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
          ranking: 1
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
          ranking: 2
        });
      })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
        return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
          ranking: 3
        });
      }))), 'id').sort(function (sA, sB) {
        return sA.ranking - sB.ranking;
      });
      categories[categoryId].bathroomEquipments = intersectionBy_default()(categories[categoryId].bathroomEquipments, accommodation.bathroomEquipments, 'id');
    } else {
      // Create category if it doesn't exist
      categories[categoryId] = {
        area: accommodation.area,
        bathroomEquipments: accommodation.bathroomEquipments,
        categoryAccommodations: [accommodationProps],
        categoryId: categoryId,
        categoryIndex: categoryIndex,
        categoryLabel: categoryLabel,
        equipments: accommodation.equipments.filter(isHighOrVeryHighRanking),
        exclusiveCollection: accommodation.exclusiveCollection,
        media: accommodation.media,
        maxCapacity: accommodation.maxCapacity,
        minCapacity: accommodation.minCapacity,
        productId: productId,
        services: accommodation.services.filter(isHighOrVeryHighRanking),
        strengths: [].concat(Object(toConsumableArray["a" /* default */])((accommodation.view ? [accommodation.view] : []).map(function (v) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, v), {}, {
            ranking: 1
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.strengths || []).map(function (strength) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, strength), {}, {
            ranking: 2
          });
        })), Object(toConsumableArray["a" /* default */])((accommodation.outsideFacilities || []).map(function (outsideFacility) {
          return productAccommodations_utils_objectSpread(productAccommodations_utils_objectSpread({}, outsideFacility), {}, {
            ranking: 3
          });
        })))
      };
    }

    return categories;
  }, {}) // $FlowFixMe
  ).sort(function (a, b) {
    return b.categoryIndex - a.categoryIndex;
  });
}
function getTabsItemsAndPropsFromAccommodations(props, accommodationCategories) {
  var isLineExclusiveCollection = props.isLineExclusiveCollection,
      resortIsExclusiveCollection = props.resort.isExclusiveCollection;
  var hiddenItemsCount = 0;
  var items = // I have no idea what's going on there and to be honest I don't care enough
  // sorry to the person who'll be reading that in the future but I give up
  // $FlowFixMe
  accommodationCategories.map(function (accommodationCategory, index) {
    // $FlowFixMe
    var categoryAccommodations = accommodationCategory.categoryAccommodations,
        categoryLabel = accommodationCategory.categoryLabel; // We need to sort with the upper index first. Since Array.sort is broken client side (why??),
    // we use the lodash function which only sorts from the lower to the upper. We knows that the
    // accomodations are already sorted by accomodationIdex so we have to sort by categoryIndex.
    // The tricky part is here: we cannot reverse the output of lodash.sortBy, so we sort with a
    // negative categoryIndex.

    var categoryAccommodationsProps = sortBy_default()(Object(toConsumableArray["a" /* default */])(categoryAccommodations), function (_ref9) {
      var categoryIndex = _ref9.categoryIndex;
      return -1 * categoryIndex;
    });

    var content = categoryAccommodationsProps.map(getAccommodation).filter(Boolean);

    if (content.length === 0) {
      return null;
    } // $FlowFixMe


    var isLarge = content.every(function (item) {
      return item.props.isExclusiveCollection;
    });
    var shouldDisplayAsExclusiveCollection = isLarge && !resortIsExclusiveCollection || resortIsExclusiveCollection;

    if (isLineExclusiveCollection && isLarge || !isLineExclusiveCollection) {
      return {
        header: {
          title: "".concat(categoryLabel, " ").concat(isLarge && !resortIsExclusiveCollection ? Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel') : ''),
          trackingData: {
            categoryGA: 'resort',
            actionGA: 'blockInfos',
            labelGA: "".concat(isLineExclusiveCollection ? 'eCollection' : 'accommodations', "_").concat(categoryLabel)
          },
          headerClassNames: shouldDisplayAsExclusiveCollection ? {
            active: 'font-sans text-ultramarine',
            inactive: 'font-sans'
          } : {}
        },
        content: [productAccommodations_utils_jsx(ProductInformationSlider_container["a" /* ProductInformationSliderContainer */], {
          backNavigationLabel: Object(src_i18n["h" /* t */])('common.backNavigation'),
          theme: "short",
          errorMessage: "error",
          isLarge: isLarge,
          key: "ProductAccommodationsSlider_".concat(categoryLabel),
          queryLayer: isLineExclusiveCollection ? 'accommodationLayerEC' : 'accommodationLayer',
          renderDetail: renderDetail(),
          scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
          scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
          sliderIndex: index - hiddenItemsCount
        }, content)]
      };
    }

    hiddenItemsCount++;
    return null;
  }).filter(function (item) {
    return item !== null;
  });

  var slot = function slot(activeIndexes) {
    return productAccommodations_utils_jsx(ProductRoomsComparatorLauncher["a" /* ProductRoomsComparatorLauncher */], {
      accommodationCategories: accommodationCategories,
      activeIndex: activeIndexes[0],
      exclusiveCollectionLabel: Object(src_i18n["h" /* t */])('common.exclusiveCollectionLabel'),
      resortIsExclusiveCollection: resortIsExclusiveCollection
    });
  };

  return {
    items: items,
    slot: slot
  };
}

/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_SPACINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateBackgroundStylesAndClassName; });
/* unused harmony export getBackgroundImageUrl */
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("m1JM");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_10__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-center justify-start',
  'center-middle': 'items-center justify-center',
  'center-right': 'items-center justify-end',
  'bottom-left': 'items-end justify-start',
  'bottom-middle': 'items-end justify-center',
  'bottom-right': 'items-end justify-end'
};
var LINK_SPACINGS = {
  left: 'md:p-30 md:-ms-30',
  middle: 'md:p-30',
  right: 'md:p-30 md:-me-30'
};
var TITLE_POSITIONS = {
  'top-left': 'mb-auto items-start text-start',
  'top-middle': 'mb-auto items-center text-center',
  'top-right': 'mb-auto items-end text-end',
  'center-left': 'my-auto items-start text-start',
  'center-middle': 'my-auto items-center text-center',
  'center-right': 'my-auto items-end text-end',
  'bottom-left': 'mt-auto items-start text-start',
  'bottom-middle': 'mt-auto items-center text-center',
  'bottom-right': 'mt-auto items-end text-end'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp) {
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  return {
    heightClassName: "immersiveHeight--".concat(sizeProp),
    paddingBottomClassName: "immersivePaddingBottom--".concat(sizeProp),
    paddingTopClassName: isHighlight ? 'immersivePaddingTop--highlight' : 'immersivePaddingTop'
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(_ref) {
  var backgroundURLDesktop = _ref.backgroundURLDesktop,
      backgroundURLMobile = _ref.backgroundURLMobile;

  if (!backgroundURLDesktop && !backgroundURLMobile) {
    return {
      style: '',
      className: ''
    };
  }

  var url = backgroundURLDesktop || backgroundURLMobile;
  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  var mobileUrl = backgroundURLMobile || backgroundURLDesktop;
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[1],
      width2x: widths[2]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[2],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[5],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[6],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ }),

/***/ "60DJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("C8GU").charAt;
var toString = __webpack_require__("vnfA");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("6WRp");
var createIterResultObject = __webpack_require__("b86L");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "6LKR":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var iterate = __webpack_require__("tXjT");
var createProperty = __webpack_require__("2sZ7");

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ "6R5o":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("1aYn"),
    findIndex = __webpack_require__("FllU");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ "6WRp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var call = __webpack_require__("we+H");
var IS_PURE = __webpack_require__("SRps");
var FunctionName = __webpack_require__("mu8A");
var isCallable = __webpack_require__("ANQd");
var createIteratorConstructor = __webpack_require__("Mv+R");
var getPrototypeOf = __webpack_require__("yvHl");
var setPrototypeOf = __webpack_require__("iBXc");
var setToStringTag = __webpack_require__("CGO5");
var createNonEnumerableProperty = __webpack_require__("g51W");
var defineBuiltIn = __webpack_require__("Swp0");
var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");
var IteratorsCore = __webpack_require__("JpEK");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "6aqx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("RWUY");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "6mUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addPassiveEventListener;
// feature detection for passive support
// see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
function hasPassiveSupport() {
  var passiveSupported = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
}

function addPassiveEventListener(element, eventName, func, capture) {
  element.addEventListener(eventName, func, hasPassiveSupport() ? {
    capture: capture,
    passive: true
  } : capture);
}

/***/ }),

/***/ "6qX7":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("1s2Y");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "p"], options);
}



/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export servicesWithSchedulePricingInfoQuery */
/* unused harmony export childcareWithSchedulePricingInfoQuery */
/* unused harmony export childcaresQuery */
/* unused harmony export transfersQuery */
/* unused harmony export insuranceAdditionalServicesQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autosaveProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return refreshProposal; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("H0gB");
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("MAH5");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("NLwV");


















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var paymentScheduleRequest = "paymentSchedule {\n  commissionIncluded\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      formattedValue(precision : ".concat(precision, ")\n      value\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n    unit\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n  vehicleType\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var servicesWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        rentedAmountWithoutDiscount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {\n            ...priceDetails\n            currency\n          }\n          rentedAmountWithoutDiscount {\n            ...priceDetails\n            currency\n          }\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
/**
 * childcare with schedule and childId
 */

var childcareWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        childId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {...priceDetails currency}\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
var childcaresQuery = "\nchildcares {\n  ".concat(childcareWithSchedulePricingInfoQuery, "\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n    timeSlots {\n      type\n      opening\n      closing\n    }\n  }\n}");
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var insuranceAdditionalServicesQuery = "insurance {\n        pricingInfo {\n          id\n          type\n          rentedAmount {...priceDetails, currency}\n          totalPrice {\n            value\n            formattedValue(precision: 2)\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          label\n          shortDescription\n          insuranceDetails {\n            id\n            label\n            images\n            description\n            shortDescription\n            videos\n            attachedDocuments {\n              label\n              url\n            }\n            company {\n              label\n              logo\n            }\n            coverageDescriptions\n            subscriptionConditions {\n              age_min\n              ageMax\n              byAttendees\n            }\n          }\n        }\n      }";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER, WELLNESS, INSURANCE]) {\n    activities {\n      ".concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n        description\n      }\n    }\n    rentals {\n      ").concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ").concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n    ").concat(insuranceAdditionalServicesQuery, "\n  }\n  ");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      insurance {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n        offerLabel\n        offerType\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      wellness {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n        offerLabel\n        offerType\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      transfer {...priceDetails}\n      insurance {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    attendeesPrice {\n      id\n      householdId\n      total {\n        ...priceDetails\n        currency\n      }\n      priceItems {\n        type\n        offerId\n        price {\n          ...priceDetails\n          currency\n        }\n      }\n    }\n    ";
}

function proposalFields(params, appContext) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    greatMembersLoyaltyPoints\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView || params.isUrbanOasis ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    persistenceExtended\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      exclusiveCollection\n      floorPlans\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n      ranking\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n        email\n        civility\n        firstName\n        lastName\n        gmNumber\n        optins {\n          channel\n          optin\n        }\n      }\n      adults {\n        id\n        customerId\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    households(withSchedule: ").concat((!!params.withSchedule).toString(), ") {\n      attendees {\n        id\n        customerId\n        birthdate\n        isAdult\n        isMain\n      }\n      ").concat(getPaymentScheduleRequest(appContext), "\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n    expirationDateTime\n    durationDisclaimer\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  selectorId\n  label\n  logo\n  categoryPaymentMethod\n  shouldSkipPayment\n  withBillingAddress\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        households(withSchedule: true) {\n          ").concat(getPaymentScheduleRequest(appContext), "\n        }\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "Pc"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var travelCompanionContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate;
    var customerId = index === 0 && neolaneId ? neolaneId : neolid; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated
    // adding connected user infos creates 2 households for travel companions context which should always only have one household

    return _objectSpread({
      customer_id: travelCompanionContext ? undefined : customerId
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* timestampToApiDate */ "n"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(_x, _x2) {
  return _proposalsQuery.apply(this, arguments);
}

function _proposalsQuery() {
  _proposalsQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee4(params, appContext) {
    var _params$adultsAttende, _params$kidsAttendees, _proposalsResponse$pr, _proposalsResponse$pr2, _proposalsResponse$pr3, _proposalsResponse$pr4, _proposalsResponse$pr5;

    var adults, _params$kids, kids, attendees, neolaneId, travelCompanionContext, knownAttendeesInformation, displayCommission, displayDurationsCounterProposals, displayCounterExtendedDurations, displayCounterDates, proposalArgs, proposalsResponse, validationSchema;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            adults = params.adults, _params$kids = params.kids, kids = _params$kids === void 0 ? [] : _params$kids;
            attendees = adults.concat(kids || []); // When quick logged neolaneId but should not call profile api
            // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

            neolaneId = appContext.isUserLogged ? appContext.neolaneId : null;
            travelCompanionContext = !appContext.isSeller && appContext.isUserLogged && Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.travelCompanions');
            knownAttendeesInformation = getKnownAttendeesInformation( // $FlowFixMe
            attendees, neolaneId, travelCompanionContext);
            displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            displayDurationsCounterProposals = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals').toString();
            displayCounterExtendedDurations = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayExtendedDurationsCounterProposals').toString();
            displayCounterDates = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDateCounterProposals').toString();
            proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isUrbanOasis ? ['isUrbanOasis: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.voucherCode ? ["voucherCode: \"".concat(params.voucherCode, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isPrebookingFormQuery ? ['isPrebookingFormQuery: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.accommodationIds ? ["accommodationIds : ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(params.accommodationIds))] : []), ["displayCounterDurations: ".concat(displayDurationsCounterProposals), "displayCounterExtendedDurations: ".concat(displayCounterExtendedDurations), "displayCounterDates: ".concat(displayCounterDates)]);
            _context4.next = 12;
            return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
            }), appContext), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              hasECSpace\n              href\n              id\n              images\n              isExplicitEC\n              isUrbanOasis\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getResort */ "c"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getAttendeesData */ "b"])(params), "\n    }\n\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityCategoryFragment */ "a"] : '', "\n    ").concat(params.fetchActivityCategories || _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"] ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityFragment */ "b"] : '', "\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* rentalsFragment */ "f"] : '', "\n    ").concat(_client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__[/* profileFragment */ "a"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    ").concat(((_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende[0]) || ((_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees[0]) ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SEVERAL */ "Rc"]
            });

          case 12:
            proposalsResponse = _context4.sent;

            if (!(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : (_proposalsResponse$pr2 = _proposalsResponse$pr.proposals) === null || _proposalsResponse$pr2 === void 0 ? void 0 : _proposalsResponse$pr2.length)) {
              _context4.next = 19;
              break;
            }

            _context4.next = 16;
            return Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* fetchValidationSchema */ "a"])(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr3 = proposalsResponse.proposals) === null || _proposalsResponse$pr3 === void 0 ? void 0 : (_proposalsResponse$pr4 = _proposalsResponse$pr3.proposals) === null || _proposalsResponse$pr4 === void 0 ? void 0 : (_proposalsResponse$pr5 = _proposalsResponse$pr4[0]) === null || _proposalsResponse$pr5 === void 0 ? void 0 : _proposalsResponse$pr5.id, appContext, 'profile');

          case 16:
            _context4.t0 = _context4.sent;
            _context4.next = 20;
            break;

          case 19:
            _context4.t0 = {};

          case 20:
            validationSchema = _context4.t0;
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, proposalsResponse), validationSchema));

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _proposalsQuery.apply(this, arguments);
}

function addTransportMutation(transportId, proposalsId, isJoyView, isUrbanOasis, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    isUrbanOasis: isUrbanOasis,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADD_TRANSPORT */ "Kc"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, isUrbanOasis, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    isUrbanOasis: isUrbanOasis,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ACCOMMODATION_ADD */ "Gc"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalsId), ", attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(services), ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "Jc"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee(proposalIds, attendees, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, attendees, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, attendees, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "Ic"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "Hc"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(type: \"".concat(params.type, "\", id: \"").concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', " ").concat(params.customerId && params.type === 'apply' ? ", customerId: ".concat(params.customerId) : '', ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            offerId\n            amount {...priceDetails}\n            offerName\n            offerColor\n            offerDescription\n            offerLabel\n            offerType\n            currentProposalCode {\n              id\n              label\n              description\n              value\n              unit\n            }\n          }\n        }\n        attendeesPrice {\n          id\n          householdId\n          total {\n            ...priceDetails\n            currency\n          }\n          priceItems {\n            type\n            offerId\n            price {\n              ...priceDetails\n              currency\n            }\n          }\n        }\n        households {\n          attendees {\n            id\n            customerId\n            birthdate\n            isAdult\n            isMain\n          }\n          paymentSchedule {\n            commissionIncluded\n            total {...priceDetails}\n            depositAmount {...priceDetails}\n            repaymentSchedules{\n              amount {...priceDetails}\n              deadline\n            }\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_USE_PROMO_CODE */ "Zc"]
  });
}

function autosaveProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      autosaveProposal(id: \"".concat(params.proposalId, "\") {\n        id\n        }\n    }\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_AUTOSAVE */ "Lc"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        greatMembersLoyaltyPoints\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_SWITCH_OFFER */ "Wc"]
  });
}

function refreshProposal(proposalId, salesNetworkId, appContext) {
  var graphqlParams = "id: \"".concat(proposalId, "\"").concat(salesNetworkId ? ", salesNetworkId: \"".concat(salesNetworkId, "\"") : '');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    query {\n      refreshProposal (".concat(graphqlParams, ") {\n        proposal {\n          id\n          productId\n          optionAvailable\n          optionDurability {\n            expirationDateTime\n            isReliable\n          },\n          duration\n          extendPersistence\n          price {\n            ...refreshProposalPrice\n          }\n          remainingStock\n          households {\n            attendees {\n              id\n              customerId\n              customerType\n              birthdate\n            }\n          }\n          transportationSummary {\n            way\n            departureCity\n            arrivalCity\n            transportationType\n            cancellationPolicyType\n            clubmedTransport\n            departureDate\n            arrivalDate\n          }\n          isBookable\n          creationDateTime\n          packageId\n          resortArrivalDate\n          resortDepartureDate\n          accommodations {\n            id\n            quantity\n            sharedRoom\n          }\n          label\n          locale\n          alternativePrice {\n            ...refreshProposalPrice\n          }\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n      }\n    }\n    fragment refreshProposalPrice on RefreshProposalPriceType {\n      currency\n      total {...priceDetails}\n      totalWithoutFees {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      discounts {\n        type\n        amount {...priceDetails}\n        offerId\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      yieldPricingVariation {...priceDetails}\n      trip {\n        initialPrice {...priceDetails}\n        initialPriceWithFees {...priceDetails}\n        fees {\n          type\n          amount {...priceDetails}\n        }\n      }\n      includedServices {\n        id\n        amount {...priceDetails}\n      }\n      packageOptions {\n        type\n        amount {...priceDetails}\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_REFRESH */ "Uc"]
  });
}



/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCta: 'font-bold underline',
  thCtaDefaultColor: colors["a" /* COLORS */].BLACK
};
var themes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx




var __jsx = react_default.a.createElement;







var CardBody_CardBody = function CardBody(_ref) {
  var ctaLabel = _ref.ctaLabel,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thCta = _themes$theme.thCta,
      thCtaDefaultColor = _themes$theme.thCtaDefaultColor;
  var isCollapsable = displayLoadMore && (!isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout));
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    dataTestIdPrefix: dataTestIdPrefix,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: Object(classnames_utils["a" /* classnames */])(thCta, {
      'mt-20': text === null || text === void 0 ? void 0 : text.text
    }),
    color: thCtaDefaultColor,
    iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var CardHeading_themes_themes = {
  "default": {
    thTitleTheme: 'title-brand-n2',
    thSmall: 'font-normal font-sans text-12',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-n3',
    thSmall: 'font-normal font-sans text-10',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx



var CardHeading_jsx = react_default.a.createElement;





var CardHeading_CardHeading = function CardHeading(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeading' : _ref$dataTestIdPrefix,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _themes$theme = CardHeading_themes_themes[theme],
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx(react["Fragment"], null, CardHeading_jsx(Title["a" /* Title */], {
    dataTestId: "".concat(dataTestIdPrefix, "-title"),
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])(thSubtitle, "text-".concat(color || 'black')),
    dataTestId: "".concat(dataTestIdPrefix, "-subtitle"),
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-20'
};
var CardHeader_themes_themes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx


var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeader' : _ref$dataTestIdPrefix,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = CardHeader_themes_themes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({}, introduction, {
    className: thIntro,
    "data-testid": "".concat(dataTestIdPrefix, "-introduction")
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var VideoWithFullScreen_themes_themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative transition-opacity duration-250 ease-in w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-black/60 leading-0 m-10 top-0 p-10 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) {
    return null;
  }

  if (!thumbnail) {
    return VideoWithFullScreen_jsx(Video["a" /* Video */], {
      className: className,
      ratioKey: ratioKey,
      url: url
    });
  }

  var _themes$theme = VideoWithFullScreen_themes_themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])(thThumbnailButton, className),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["a" /* Image */], {
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MEDIA_VIDEO,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["c" /* default */].M,
  thVideo: 'bg-black'
};
var CardMedia_themes_themes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx


var CardMedia_jsx = react_default.a.createElement;











var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      hasFullScreenMode = _ref.hasFullScreenMode,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var _themes$theme = CardMedia_themes_themes[theme],
      thVideo = _themes$theme.thVideo,
      thImageRatio = _themes$theme.thImageRatio;
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'fullScreen',
    labelGA: "blockTitle_".concat(title)
  });

  var _useState = Object(react["useState"])(false),
      shouldDisplayFullScreen = _useState[0],
      setShouldDisplayFullScreen = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      zoomLevel = _useState2[0],
      setZoomLevel = _useState2[1]; // eslint-disable-next-line clubmed/no-fake-component


  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx(react["Fragment"], null, hasFullScreenMode && CardMedia_jsx(react["Fragment"], null, CardMedia_jsx("button", {
    onClick: function onClick() {
      setShouldDisplayFullScreen(true);
      track();
    },
    className: "absolute end-0 top-0 m-15 rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-bg-color duration-250 ease-in hocus:bg-black/60 hocus:text-white",
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].EXPAND,
    width: "1.25rem"
  })), shouldDisplayFullScreen && CardMedia_jsx(Backdrop["a" /* Backdrop */], {
    onClose: function onClose() {
      setShouldDisplayFullScreen(false);
      setZoomLevel(0);
    },
    hasCloseButton: true
  }, zoomLevel === 0 ? CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1
  }) : CardMedia_jsx("div", {
    className: "max-h-full overflow-scroll"
  }, CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1,
    className: "mx-auto block",
    style: {
      maxWidth: "".concat(100 + zoomLevel * 100, "%")
    }
  })), CardMedia_jsx("div", {
    className: "absolute bottom-0 flex gap-x-10 p-20"
  }, CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel <= 4 ? setZoomLevel(zoomLevel + 1) : setZoomLevel(5);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS
  })), CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel >= 1 ? setZoomLevel(zoomLevel - 1) : setZoomLevel(0);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS
  }))))), CardMedia_jsx(Image["b" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio,
    ratioDisplay: media.ratioDisplay || 1 / 2
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var mediaClasses = 'overflow-hidden relative';
var Card_layouts_Inline1 = function Inline1(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row-reverse sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), header && Card_layouts_jsx("div", {
    className: media && 'mt-20'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-20'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "h-full overflow-hidden rounded-12 shadow-subtle"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-1 -mt-1"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-20"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col sm:flex-row gap-20', {
      'mt-20': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1"
  }, header), body && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex-1', {
      'mt-20': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx

var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      displayLoadMore = _ref.displayLoadMore,
      hasFullScreenMode = _ref.hasFullScreenMode,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    dataTestIdPrefix: dataTestIdPrefix,
    displayLoadMore: displayLoadMore,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    hasFullScreenMode: hasFullScreenMode,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme,
    title: heading === null || heading === void 0 ? void 0 : heading.title
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture, dataTestIdPrefix)) : null;
};

/***/ }),

/***/ "7BVm":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "7CPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggler; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


var Toggler = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Toggler, _Component);

  var _super = _createSuper(Toggler);

  function Toggler() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, Toggler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "state", {
      isActive: _this.props.isActive || false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "toggle", function () {
      var onToggle = _this.props.onToggle;

      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      }, function () {
        if (onToggle) {
          onToggle(_this.state.isActive);
        }
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Toggler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isActive = this.props.isActive;

      if (isActive !== prevProps.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isActive = this.state.isActive;
      return children(this.toggle, isActive);
    }
  }]);

  return Toggler;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

/***/ }),

/***/ "7F8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCountOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdultsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildrenOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDurationOptions; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);





function getCountOptions(labels, initial, limit) {
  var options = [];
  var messageFormat = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["messageFormat"])(labels);

  for (var count = initial; count <= limit; count++) {
    options.push({
      label: messageFormat.format({
        count: count
      }),
      value: count
    });
  }

  return options;
}
function getAdultsOptions(selectAdultsLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectAdultsLabels, initial, limit);
}
function getChildrenOptions(selectChildrenLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectChildrenLabels, initial, limit);
}
function getDurationOptions(messageFormat, durations) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'duration';
  var durationMessage = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["messageFormat"])(messageFormat);
  return durations.map(function (duration) {
    return {
      name: durationMessage.format(Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, key, duration)),
      label: durationMessage.format(Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, key, duration)),
      value: duration.toString()
    };
  });
}

/***/ }),

/***/ "7knX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExclusiveCollectionBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ExclusiveCollectionBadge = function ExclusiveCollectionBadge(_ref) {
  var className = _ref.className;
  return __jsx("span", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('text-initial inline-flex shrink-0 items-center gap-5 text-12 font-bold leading-1 text-ultramarine', className)
  }, __jsx("span", {
    className: "inline-flex aspect-square size-[1.65em] items-center justify-center rounded-full bg-ultramarine leading-0 text-white sm:size-[2em]"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].DIAMOND,
    width: "0.85em"
  })), Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('common.product.exclusiveCollectionTag'));
};

/***/ }),

/***/ "7pmY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = sortFields;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _toposort = _interopRequireDefault(__webpack_require__("VNI2"));

var _propertyExpr = __webpack_require__("dFUt");

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, _propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && value.isSibling) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];

/***/ }),

/***/ "7x6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Zoom; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1JJ2");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0IQ5");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var Zoom = function Zoom(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      inert = _ref.inert;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop,
      isRTL = _useResponsive.isRTL;

  var scrollArea = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (isRTL && (scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.current)) {
      scrollArea.current.scrollLeft = scrollArea.current.scrollWidth;
    }
  });
  return __jsx("div", {
    className: "direction-ltr relative h-400 lg:h-full"
  }, hint && !isDesktop && __jsx("span", {
    className: "absolute inset-x-0 top-0 mt-20 flex items-center justify-center gap-5 px-10 font-brand text-14 leading-0 text-saffron"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    width: "1.25rem",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].LIGHTBULB
  }), __jsx("span", {
    className: "leading-1"
  }, hint)), __jsx("div", {
    onTouchStart: function onTouchStart(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchMove: function onTouchMove(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchEnd: function onTouchEnd(e) {
      return inert ? e.stopPropagation() : null;
    },
    className: "flex h-full w-full items-center justify-start overflow-x-scroll",
    ref: scrollArea
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_2__[/* Image */ "a"], {
    classNameImg: "max-w-initial max-h-initial h-full",
    hasLazyLoading: false,
    imageUrl: imageUrl,
    altMsg: alt,
    dimensions: DIMENSIONS,
    fullscreen: true,
    transformation: "resize",
    className: "h-full py-20 pt-60 sm:mx-auto lg:p-0"
  })));
};

/***/ }),

/***/ "8+jV":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("SRps");
var store = __webpack_require__("l6h7");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.29.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "87KK":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("+xJO");
var anObject = __webpack_require__("ep/x");
var toPropertyKey = __webpack_require__("RWUY");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8D46":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "8Y4Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isPlainObject;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "8tyQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "accommodationResolverFactory", function() { return accommodationResolverFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolve", function() { return resolve; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("CcNa");














function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var getQuery = function getQuery(productArgs) {
  return "query {\n    config {\n      common {\n        backNavigation\n        exclusiveCollectionLabel\n        viewMore\n        loadLess\n        next\n        previous\n        scrollBackward\n        scrollForward\n        roomPlan {\n          title\n          disclaimer\n          swipeInstruction\n        }\n      }\n      accommodations {\n        surfaceLabel\n      }\n    }\n    accommodationCategory(".concat(productArgs, ") {\n      rankedCategories: accommodations {\n        id\n        ranking\n      }\n    }\n    resort(").concat(productArgs, ") {\n      areas {\n        id\n        label\n      }\n      id\n      accommodationsIntroduction {\n        description\n        shortDescription\n      }\n      accommodations {\n        areas {\n          id\n        }\n        area {\n          max\n          min\n          unit\n        }\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        description\n        equipments {\n          id\n          label\n          ranking\n        }\n        exclusiveCollection\n        floorPlans\n        id\n        label\n        maxCapacity\n        minCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n          ranking\n        }\n        outsideFacilities {\n          id\n          label\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      comfort\n      isExclusiveCollection\n      type\n    }\n  }");
};

var getStreetViewsQuery = function getStreetViewsQuery(productArgs, accommodationCategory) {
  var _accommodationCategor;

  var rankedIds = (accommodationCategory === null || accommodationCategory === void 0 ? void 0 : (_accommodationCategor = accommodationCategory.rankedCategories) === null || _accommodationCategor === void 0 ? void 0 : _accommodationCategor.map(function (_ref) {
    var id = _ref.id;
    return id ? "\"".concat(id, "\"") : '';
  })) || [];
  return "query {\n    streetViews(".concat(productArgs, ", accommodationCategoryIds:[").concat(rankedIds.join(','), "]) {\n      accommodationCategoryId\n      streetView {\n        latitude\n        longitude\n        heading\n        pitch\n        fov\n        url\n      }\n    }\n  }");
};

var CRUISE_RESORT_ID = 'CM2C';
var accommodationResolverFactory = function accommodationResolverFactory(_ref2) {
  var isLineExclusiveCollection = _ref2.isLineExclusiveCollection;
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(appContext, props, pageContext, location) {
      var urlParams, productId, productArgs, query, lineData, streetViewsQuery, streeviewData;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              urlParams = location.urlParams;
              productId = props.resortId;
              productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_14__[/* buildProductArgs */ "c"])(productId, urlParams);
              query = getQuery(productArgs);
              _context.next = 6;
              return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__[/* LINE_PRODUCT_ACCOMMODATIONS */ "Ab"],
                strictErrors: false
              });

            case 6:
              lineData = _context.sent;
              Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* addTranslationKeys */ "a"])(lineData.config);

              if (!(productId === CRUISE_RESORT_ID)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", _objectSpread(_objectSpread({}, lineData), {}, {
                isLineExclusiveCollection: isLineExclusiveCollection
              }));

            case 10:
              streetViewsQuery = getStreetViewsQuery(productArgs, lineData.accommodationCategory);
              _context.next = 13;
              return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"].runQuery(streetViewsQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__[/* LINE_PRODUCT_ACCOMMODATIONS_STREETVIEWS */ "Bb"],
                strictErrors: false
              });

            case 13:
              streeviewData = _context.sent;
              return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, lineData), streeviewData), {}, {
                isLineExclusiveCollection: isLineExclusiveCollection
              }));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var resolve = accommodationResolverFactory({
  isLineExclusiveCollection: false
});

/***/ }),

/***/ "8uyH":
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__("dpio"),
    baseAggregator = __webpack_require__("OekA"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ "93Yv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_MIN_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_MAX_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_MAX_CHILD_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ESCAPADE_MIN_CHILD_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_TOUR_MIN_CHILD_AGE; });
var DEFAULT_MIN_AGE = 0;
var DEFAULT_MAX_AGE = 18;
var DEFAULT_MAX_CHILD_AGE = 12;
var DEFAULT_ESCAPADE_MIN_CHILD_AGE = 48;
var DEFAULT_TOUR_MIN_CHILD_AGE = 84;

/***/ }),

/***/ "97Jx":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salesmanIDRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return internationalPhoneRegex; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__);




 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
var salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,20}$/);
};

var internationalPhoneRegex = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);


/***/ }),

/***/ "9BmX":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("dw5g");

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

module.exports = toUpper;


/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9OZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;






var ProductService = function ProductService(_ref) {
  var className = _ref.className,
      service = _ref.service;
  var description = service.description,
      icon = service.icon,
      label = service.label;
  return description ? __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_6__[/* CollapsePanel */ "a"], {
    className: className,
    collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
    collapseLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('common.included'),
    expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
    expandLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('common.included'),
    hasKeepCollapsedContent: false,
    iconName: icon,
    id: icon,
    isExpanded: false,
    key: icon,
    theme: "remote",
    title: label
  }, __jsx("p", {
    className: "px-15 pb-15 text-14"
  }, description)) : __jsx("section", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('animation-duration-500 flex animate-fadeIn items-center justify-between gap-10 rounded-12 border-1 border-lightGrey bg-white p-15 shadow-diffuse', className)
  }, __jsx("span", {
    className: "flex flex-1 items-center gap-10 font-semibold"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "shrink-0 text-sienna",
    name: icon,
    width: "1.875rem"
  }), label), __jsx("span", {
    className: "flex shrink-0 items-center whitespace-nowrap text-14 text-black"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('common.included')));
};

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FACETING_SET_SEARCH_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_SET_ORDER_BY_PRICE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_RESET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FACETING_UPDATE_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FACETING_UPDATE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_CLEAR_ALL = 'FACETING_CLEAR_ALL';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_CUSTOM_FILTERS = 'FACETING_SET_CUSTOM_FILTERS';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_SEARCH_FILTERS = 'FACETING_SET_SEARCH_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_ORDER_BY_PRICE = 'FACETING_SET_ORDER_BY_PRICE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_CUSTOM_FILTERS = 'FACETING_RESET_CUSTOM_FILTERS';
var FACETING_RESET_FILTERS = 'FACETING_RESET_FILTERS';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_CUSTOM_FILTERS = 'FACETING_UPDATE_CUSTOM_FILTERS';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';
var FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING = 'FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING';
var FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS = 'FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS';

/***/ }),

/***/ "9YYj":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "9jKB":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("bWWS");
var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");
var createNonEnumerableProperty = __webpack_require__("g51W");
var hasOwn = __webpack_require__("/GgU");
var shared = __webpack_require__("l6h7");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "9tk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js + 3 modules
var productAccommodations_utils = __webpack_require__("5svr");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparator.utils.js
var ITEMS_ORDER = ['services', 'equipments', 'bathroomEquipments'];
var SECTION_LABELS = {
  equipments: 'common.accommodations.equipments',
  services: 'common.accommodations.services',
  bathroomEquipments: 'common.accommodations.bathroomEquipments'
};
var sortCategoriesItems = function sortCategoriesItems(_ref, _ref2) {
  var rankingA = _ref.ranking;
  var rankingB = _ref2.ranking;

  if (rankingB < rankingA) {
    return 1;
  }

  if (rankingB > rankingA) {
    return -1;
  }
};
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLarge.jsx



var __jsx = react_default.a.createElement;









var ProductRoomsComparatorLarge_ProductRoomsComparatorLarge = function ProductRoomsComparatorLarge(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thTitle$thInfoTitle$ = {
    thTitle: 'font-brand text-20 text-black text-center',
    thInfoTitle: 'text-mediumGrey flex gap-15 items-center py-10',
    thInfo: 'font-bold text-16 flex items-center justify-center',
    thStrength: 'py-10 flex items-center justify-center',
    thSectionHeader: 'flex mb-20',
    thSectionTitle: 'font-bold text-22 text-black',
    thSectionHeaderItem: 'flex items-center justify-center',
    thIcon: 'text-black me-15 shrink-0',
    thTableCell: 'px-10',
    thCheck: 'flex items-center justify-center'
  },
      thTitle = _thTitle$thInfoTitle$.thTitle,
      thInfoTitle = _thTitle$thInfoTitle$.thInfoTitle,
      thInfo = _thTitle$thInfoTitle$.thInfo,
      thStrength = _thTitle$thInfoTitle$.thStrength,
      thSectionHeader = _thTitle$thInfoTitle$.thSectionHeader,
      thSectionTitle = _thTitle$thInfoTitle$.thSectionTitle,
      thSectionHeaderItem = _thTitle$thInfoTitle$.thSectionHeaderItem,
      thIcon = _thTitle$thInfoTitle$.thIcon,
      thTableCell = _thTitle$thInfoTitle$.thTableCell,
      thCheck = _thTitle$thInfoTitle$.thCheck;
  var columnWidth = "".concat(100 / (columns.length + 1), "%");

  var getHorizontalAvailabilityLinesFromItemType = function getHorizontalAvailabilityLinesFromItemType(itemType) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return __jsx("div", {
        className: "flex",
        key: index
      }, __jsx("div", {
        className: "flex items-center py-10 text-16",
        style: {
          width: columnWidth
        }
      }, __jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), availabilityBoards.map(function (board, boardIndex) {
        return __jsx("div", {
          key: boardIndex,
          className: Object(classnames_utils["a" /* classnames */])(thTableCell, thCheck),
          style: {
            width: columnWidth
          }
        }, __jsx(Icon["a" /* Icon */], {
          className: board[itemType][index] ? 'text-green' : 'text-grey',
          name: board[itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
          width: "1rem"
        }));
      }));
    });
  };

  return __jsx("div", {
    className: "mx-auto max-w-site px-20 pt-60"
  }, __jsx("div", {
    className: "flex justify-end"
  }, columns.map(function (column, index) {
    var _column$picture;

    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('text-center', thTableCell),
      key: index,
      style: {
        width: columnWidth
      }
    }, __jsx("div", {
      className: "mb-30 max-h-30"
    }, __jsx("div", {
      className: thTitle
    }, column.title), column.price && __jsx("div", {
      className: "font-sans font-bold text-black"
    }, column.price)), __jsx("div", {
      className: "overflow-hidden rounded-12"
    }, __jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    })));
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].SINGLE_ROOM,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.size')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.surface);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    width: "1.875rem"
  }), Object(i18n["h" /* t */])('common.accommodations.capacity')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thInfo),
      style: {
        width: columnWidth
      }
    }, column.capacity);
  })), __jsx("div", {
    className: "flex"
  }, __jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, Object(i18n["h" /* t */])('common.accommodations.strengths')), columns.map(function (column, index) {
    return __jsx("div", {
      key: index,
      className: Object(classnames_utils["a" /* classnames */])(thTableCell, thStrength),
      style: {
        width: columnWidth
      }
    }, __jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      items: column.strengths.map(function (strength) {
        return {
          icon: icons["a" /* ICONS */][strength.id] || icons["a" /* ICONS */].TRIDENT1,
          labels: [strength.label]
        };
      }),
      theme: "comparator"
    }));
  })), ITEMS_ORDER.map(function (itemType) {
    return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && __jsx("div", {
      key: itemType,
      className: "border-t-1 border-lightGrey py-30"
    }, __jsx("div", {
      className: thSectionHeader
    }, __jsx("div", {
      className: thSectionTitle,
      style: {
        width: columnWidth
      }
    }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType])), columns.map(function (column, index) {
      return __jsx("div", {
        key: index,
        className: Object(classnames_utils["a" /* classnames */])(thTitle, thSectionHeaderItem, thTableCell),
        style: {
          width: columnWidth
        }
      }, column.title);
    })), getHorizontalAvailabilityLinesFromItemType(itemType));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorNarrow.jsx



var ProductRoomsComparatorNarrow_jsx = react_default.a.createElement;









var ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow = function ProductRoomsComparatorNarrow(_ref) {
  var allCategoriesItems = _ref.allCategoriesItems,
      availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns;
  var _thColumn$thTitle$thI = {
    thColumn: 'bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
    thTitle: 'p-15 leading-tight font-brand text-20 text-black',
    thInfoTitle: 'flex items-center pt-10 text-mediumGrey text-14',
    thInfo: 'ms-auto font-bold text-16',
    thSectionHeader: 'flex',
    thSectionTitle: 'font-bold text-18 text-black',
    thIcon: 'text-black shrink-0',
    thCheck: 'flex items-center justify-center'
  },
      thColumn = _thColumn$thTitle$thI.thColumn,
      thTitle = _thColumn$thTitle$thI.thTitle,
      thInfoTitle = _thColumn$thTitle$thI.thInfoTitle,
      thInfo = _thColumn$thTitle$thI.thInfo,
      thSectionHeader = _thColumn$thTitle$thI.thSectionHeader,
      thSectionTitle = _thColumn$thTitle$thI.thSectionTitle,
      thIcon = _thColumn$thTitle$thI.thIcon,
      thCheck = _thColumn$thTitle$thI.thCheck;

  var getItemsAvailability = function getItemsAvailability(itemType, columnIndex) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (item, index) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: index,
        className: "flex items-baseline justify-between"
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: "flex items-center gap-15 pt-20 text-16"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        alt: "",
        className: thIcon,
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        width: "1.25rem"
      }), item.label), ProductRoomsComparatorNarrow_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thCheck)
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: availabilityBoards[columnIndex][itemType][index] ? 'text-green' : 'text-grey',
        name: availabilityBoards[columnIndex][itemType][index] ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
        width: "1rem"
      })));
    });
  };

  return ProductRoomsComparatorNarrow_jsx("div", {
    className: "mx-auto max-w-site px-20 pt-30"
  }, ProductRoomsComparatorNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    navPosition: "center",
    nbItemsToScroll: 1,
    scrollAreaClassName: "overflow-hidden -mx-10",
    scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
    scrollItemClassName: "overflow-hidden px-10 pb-20 flex-none max-w-full"
  }, columns.map(function (column, columnIndex) {
    var _column$picture;

    return ProductRoomsComparatorNarrow_jsx("div", {
      key: columnIndex,
      className: Object(classnames_utils["a" /* classnames */])(thColumn, 'w-[80vw]')
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thTitle
    }, column.title, column.price && ProductRoomsComparatorNarrow_jsx("div", {
      className: "font-sans"
    }, column.price)), ProductRoomsComparatorNarrow_jsx(Image["a" /* Image */], {
      altMsg: column.title,
      hasLazyLoading: true,
      imageUrl: (_column$picture = column.picture) === null || _column$picture === void 0 ? void 0 : _column$picture.url,
      ratioKey: ratios_utils["c" /* default */].XL
    }), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.size')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.surface)), ProductRoomsComparatorNarrow_jsx("p", {
      className: "flex items-baseline gap-5 px-15"
    }, ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.capacity')), ProductRoomsComparatorNarrow_jsx("span", {
      className: thInfo
    }, column.capacity)), column.strengths.length > 0 && ProductRoomsComparatorNarrow_jsx("div", {
      className: "px-15 pb-15 pt-10"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(i18n["h" /* t */])('common.accommodations.strengths')), column.strengths.map(function (strength) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: strength.id,
        className: "flex items-center gap-5 pt-5"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        className: "text-black",
        name: icons["a" /* ICONS */][strength.id],
        width: "1rem"
      }), strength.label);
    })), ITEMS_ORDER.map(function (itemType, itemIndex) {
      return !!allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].length && ProductRoomsComparatorNarrow_jsx("div", {
        key: itemIndex,
        className: Object(classnames_utils["a" /* classnames */])('border-t-1 border-lightGrey px-15 pb-30 pt-20', {
          'mt-10': itemIndex === 0
        })
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionHeader
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionTitle
      }, Object(i18n["h" /* t */])(SECTION_LABELS[itemType]))), getItemsAvailability(itemType, columnIndex));
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx










var ProductRoomsComparatorLauncher_jsx = react_default.a.createElement;

















var PriceBlock = function PriceBlock(_ref) {
  var _category$price6;

  var category = _ref.category,
      forceDiffPrice = _ref.forceDiffPrice,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;

  if (isActive && !forceDiffPrice) {
    var _category$price, _category$price2, _category$price2$init, _category$price3, _category$price3$best, _category$price4, _category$price4$init, _category$price5, _category$price5$best;

    return ProductRoomsComparatorLauncher_jsx("div", {
      className: "text-18 font-bold"
    }, ((_category$price = category.price) === null || _category$price === void 0 ? void 0 : _category$price.initialPrice) && ((_category$price2 = category.price) === null || _category$price2 === void 0 ? void 0 : (_category$price2$init = _category$price2.initialPrice) === null || _category$price2$init === void 0 ? void 0 : _category$price2$init.value) !== ((_category$price3 = category.price) === null || _category$price3 === void 0 ? void 0 : (_category$price3$best = _category$price3.bestPrice) === null || _category$price3$best === void 0 ? void 0 : _category$price3$best.value) ? ProductRoomsComparatorLauncher_jsx("span", {
      className: "text-14 line-through text-sienna font-normal pe-5"
    }, (_category$price4 = category.price) === null || _category$price4 === void 0 ? void 0 : (_category$price4$init = _category$price4.initialPrice) === null || _category$price4$init === void 0 ? void 0 : _category$price4$init.formattedValue) : null, (_category$price5 = category.price) === null || _category$price5 === void 0 ? void 0 : (_category$price5$best = _category$price5.bestPrice) === null || _category$price5$best === void 0 ? void 0 : _category$price5$best.formattedValue);
  }

  return ProductRoomsComparatorLauncher_jsx("div", {
    className: "text-18 font-bold"
  }, (_category$price6 = category.price) === null || _category$price6 === void 0 ? void 0 : _category$price6.diffPrice);
};

var ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher = function ProductRoomsComparatorLauncher(_ref2) {
  var accommodationCategories = _ref2.accommodationCategories,
      activeIndex = _ref2.activeIndex,
      className = _ref2.className,
      exclusiveCollectionLabel = _ref2.exclusiveCollectionLabel,
      _ref2$forceDiffPrice = _ref2.forceDiffPrice,
      forceDiffPrice = _ref2$forceDiffPrice === void 0 ? false : _ref2$forceDiffPrice,
      _ref2$resortIsExclusi = _ref2.resortIsExclusiveCollection,
      resortIsExclusiveCollection = _ref2$resortIsExclusi === void 0 ? false : _ref2$resortIsExclusi;

  var _useState = Object(react["useState"])(false),
      isLayerOpened = _useState[0],
      setIsLayerOpened = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var allCategoriesItems = ITEMS_ORDER.map(function (itemType) {
    return Object(productAccommodations_utils["a" /* getAllAvailableItems */])(accommodationCategories, itemType);
  });
  var columns = accommodationCategories.map(function (category, index) {
    var _category$price7, _category$area, _category$area2, _category$area3, _category$area4;

    var hasPrice = ((_category$price7 = category.price) === null || _category$price7 === void 0 ? void 0 : _category$price7.bestPrice) || forceDiffPrice;
    return {
      title: "".concat(category.categoryLabel, " ").concat(category.exclusiveCollection && !resortIsExclusiveCollection ? ' ' + exclusiveCollectionLabel : ''),
      picture: category.media.photos[0],
      price: hasPrice ? ProductRoomsComparatorLauncher_jsx(PriceBlock, {
        category: category,
        forceDiffPrice: forceDiffPrice,
        isActive: index === activeIndex
      }) : null,
      isExclusiveCollection: category.exclusiveCollection || resortIsExclusiveCollection,
      isExclusiveCollectionSpace: category.exclusiveCollection && !resortIsExclusiveCollection,
      surface: ((_category$area = category.area) === null || _category$area === void 0 ? void 0 : _category$area.min) !== ((_category$area2 = category.area) === null || _category$area2 === void 0 ? void 0 : _category$area2.max) ? ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.sizeFrom'),
        values: {
          min_area: "".concat(category.area.min).concat(category.area.unit),
          max_area: "".concat(category.area.max).concat(category.area.unit)
        }
      }) : "".concat((_category$area3 = category.area) === null || _category$area3 === void 0 ? void 0 : _category$area3.max).concat((_category$area4 = category.area) === null || _category$area4 === void 0 ? void 0 : _category$area4.unit),
      capacity: ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(i18n["h" /* t */])('common.accommodations.capacityFrom'),
        values: {
          min_capacity: "".concat(category.minCapacity),
          max_capacity: "".concat(category.maxCapacity)
        }
      }),
      strengths: Object(productAccommodations_utils["a" /* getAllAvailableItems */])([category], 'strengths').slice(0, 4)
    };
  });

  var getAvailabilityBoard = function getAvailabilityBoard(set, itemType) {
    var availableInCategory = new Set(set.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }));
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].sort(sortCategoriesItems).map(function (_ref4) {
      var id = _ref4.id;
      return availableInCategory.has(id);
    });
  };

  var availabilityBoards = accommodationCategories.map(function (category) {
    var availableEquipments = category.equipments;
    var availableServices = category.services;
    var availableBathroomEquipments = category.bathroomEquipments;
    var equipmentsAvailability = getAvailabilityBoard(availableEquipments, 'equipments');
    var servicesAvailability = getAvailabilityBoard(availableServices, 'services');
    var bathroomEquipmentsAvailability = getAvailabilityBoard(availableBathroomEquipments, 'bathroomEquipments');
    return {
      equipments: equipmentsAvailability,
      services: servicesAvailability,
      bathroomEquipments: bathroomEquipmentsAvailability
    };
  });
  return ProductRoomsComparatorLauncher_jsx(react["Fragment"], null, ProductRoomsComparatorLauncher_jsx(Button["a" /* Button */], {
    className: Object(classnames_utils["a" /* classnames */])('w-full', className),
    iconLeft: {
      name: icons["a" /* ICONS */].COMPARE
    },
    onClick: function onClick() {
      setIsLayerOpened(true);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'compare_rooms'
      });
    }
  }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')), isLayerOpened && ProductRoomsComparatorLauncher_jsx(Layer["b" /* Layer */], {
    ariaLabel: Object(i18n["h" /* t */])('common.accommodations.compareRooms'),
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(i18n["h" /* t */])('common.backNavigation'),
      onClick: function onClick() {
        setIsLayerOpened(false);
      }
    },
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    hasAnimateEnter: true,
    hasContainerHeader: true,
    header: ProductRoomsComparatorLauncher_jsx(Title["a" /* Title */], {
      className: "justify-center",
      theme: "title-brand-n3"
    }, Object(i18n["h" /* t */])('common.accommodations.compareRooms')),
    onClose: function onClose() {
      setIsLayerOpened(false);
    }
  }, isDesktop ? ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorLarge_ProductRoomsComparatorLarge, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  }) : ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  })));
};

/***/ }),

/***/ "9vpE":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "A+R+":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("4gXF");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "A0Zq":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ "A0wc":
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),

/***/ "ANQd":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("S8S5");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "AYG8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isEmpty = function isEmpty(val) {
  // check for empty object {}, array []
  if (val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    if (Object.keys(val).length === 0) {
      return true;
    }
  } else if (val === null || val === undefined || val === '') {
    // check for undefined, null and ""
    return true;
  }
  return false;
};

exports.default = isEmpty;

/***/ }),

/***/ "AZSF":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "AdY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    var isChanged = false;
    var castArray = value.map(function (v) {
      var castElement = _this2._subType.cast(v, _opts);

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  min: function min(_min, message) {
    message = message || _locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || _locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    var _this4 = this;

    return this.default(function () {
      return [];
    }).transform(function (val) {
      if (_this4.isType(val)) return val;
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "AiwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ allInclusiveServices_actions_getAllInclusiveServices; });

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.helper.js



var allInclusiveServices_helper_fetchAllInclusiveServices = function fetchAllInclusiveServices(appContext, criteria) {
  var allInclusiveServicesArgs = Object(graphql["a" /* buildArgs */])(criteria);
  var query = "query {\n      allInclusiveServices(".concat(allInclusiveServicesArgs, ") {\n        description\n        icon\n        label\n        type\n      }\n    }\n  ");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["ad" /* STATE_PRODUCT_ALL_INCLUSIVE_SERVICES */]
  });
};
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.actions.js



var allInclusiveServices_actions_getAllInclusiveServices = function getAllInclusiveServices(appContext, criteria) {
  return Object(createAction["a" /* createOptimisticAction */])(constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], {}, {
    optimist: true,
    promise: allInclusiveServices_helper_fetchAllInclusiveServices(appContext, criteria)
  });
};

/***/ }),

/***/ "Akr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSyncDepartureCity; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("loSl");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");





var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["constants"].NO_TRANSPORT_VALUE;
function useSyncDepartureCity(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      initialTransport = _ref.initialTransport,
      onChange = _ref.onChange,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();
  var isDepartureCityAvailable = Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* hasDepartureCityAvailable */ "l"])(departureCitiesOptions, departureCity);

  var _departureCity = withValidDepartureCity && departureCity && !isDepartureCityAvailable ? null : departureCity;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(_departureCity || initialTransport || NO_TRANSPORT_VALUE),
      inputDepartureCity = _useState[0],
      setInputDepartureCity = _useState[1]; // Store update effect


  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var newDepartureCity = departureCity;

    if (withValidDepartureCity && newDepartureCity && !isDepartureCityAvailable) {
      newDepartureCity = initialTransport || NO_TRANSPORT_VALUE;
      dispatch(Object(_client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__[/* changeDepartureCity */ "a"])(newDepartureCity));
    } // 1. Sync local state with store updates


    if (inputDepartureCity !== newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    } // 2. Sync criteria validation with store updates


    if (onChange) {
      onChange(newDepartureCity);
    }
  }, [departureCity]);
  return {
    inputDepartureCity: inputDepartureCity,
    setInputDepartureCity: setInputDepartureCity
  };
}

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ applyProposalPromoCode; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ removeProposalPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ putTransportAndDispatchProposals; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ proposals_action_saveCustomerProposalsOpportunityIdHandler; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ proposals_action_patchProposalHandler; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ proposals_action_deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addInsurances; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ refuseInsuranceAction; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* binding */ proposals_action_switchProposalsOffers; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ getTransportSearchCriteria; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ fetchRefreshProposal; });

// UNUSED EXPORTS: getNumberOfAttendees, handleError, setProposalAsAutosaved

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("IAdD");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("Qavd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__("CzFL");
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersection.js
var intersection = __webpack_require__("Nsha");
var intersection_default = /*#__PURE__*/__webpack_require__.n(intersection);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesUtils.js












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'healthPassId', 'travelDocuments', 'customerId', 'address', 'mainContactId', 'isChild', 'optinsCGU'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var attendeesUtils_removeUselessProperties = function removeUselessProperties(attendee) {
  var travelDocuments = attendee.document ? Object.keys(attendee.document).reduce(function (fullDocuments, type) {
    var document = attendee.document[type] || {};

    if (!isEmpty_default()(document)) {
      var newDocument = {}; // We fill all fields once we have a documentNumber

      if (document.documentNumber) {
        newDocument.document_number = document.documentNumber || undefined;
        newDocument.issuing_country = (document === null || document === void 0 ? void 0 : document.issuingCountry) || undefined;
        newDocument.birth_country = (document === null || document === void 0 ? void 0 : document.birthCountry) || undefined;
        newDocument.birth_city = (document === null || document === void 0 ? void 0 : document.birthCity) || undefined;
        newDocument.second_name = (document === null || document === void 0 ? void 0 : document.secondName) || undefined;
        newDocument.third_name = (document === null || document === void 0 ? void 0 : document.thirdName) || undefined;
        newDocument.fourth_name = (document === null || document === void 0 ? void 0 : document.fourthName) || undefined;
        newDocument.expiration_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.expirationDate) || undefined;
        newDocument.issuing_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.issuingDate) || undefined;
        newDocument.nationality = document.nationality || undefined;
        newDocument.type = (document === null || document === void 0 ? void 0 : document.type) || undefined;
      }

      if (!isEmpty_default()(newDocument)) {
        fullDocuments.push(newDocument);
      }
    }

    return fullDocuments;
  }, []) : [];
  return pick_default()(_objectSpread(_objectSpread({}, attendee), {}, {
    travelDocuments: travelDocuments,
    // keep customerId like this because we cannot update attendees for B2C
    customerId: attendee.neolid,
    birthdate: Object(apiDate["n" /* timestampToApiDate */])(attendee.birthdate)
  }), ATTENDEE_SCHEMA_PROPERTIES);
};
// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js








/**
 * Connected customer experience : Put attendees
 */

function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var adults = attendees.adults.map(attendeesUtils_removeUselessProperties);
  var children = attendees.children.map(attendeesUtils_removeUselessProperties);
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      modifyAttendees (\n        proposalId: \"".concat(proposalId, "\",\n        adults: ").concat(Object(graphql["d" /* graphqlify */])(adults), ",\n        children: ").concat(Object(graphql["d" /* graphqlify */])(children), "\n        ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n              civility\n              firstName\n              lastName\n              birthdate\n              email\n              optins {\n                channel\n                optin\n              }\n            }\n          }\n          households {\n            attendees {\n              id\n              customerId\n              birthdate\n              isAdult\n              isMain\n            }\n            ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n          }\n          ").concat(Object(proposalQuery["l" /* proposalPriceQuery */])(), "\n        }\n        errors {\n          concernedAttendees\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n        attendees {\n          id\n          ").concat(appContext.isSeller ? 'gmNumber' : '', "\n          customerId\n          customerType\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["Yc" /* PROPOSAL_UPDATE_ATTENDEES */]
  });
}

var attendeesQuery_queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return graphqlClient["a" /* default */].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      healthPassId\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};


// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js



























/* eslint-disable flowtype/no-weak-types */

var _BOOKING_ENGINE_ENTRY;

function proposals_action_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function proposals_action_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? proposals_action_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : proposals_action_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function throwFormatError(data) {
  // $FlowFixMe
  var error = Object.assign(new Error(), data);
  throw error;
}

function applyProposalPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["F" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["j" /* promoCodeProposalMutation */])(proposals_action_objectSpread(proposals_action_objectSpread({}, params), {}, {
      proposalId: proposalId,
      type: 'apply'
    }), appContext)
  });
}

function removeProposalPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["A" /* REMOVE_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["j" /* promoCodeProposalMutation */])(proposals_action_objectSpread(proposals_action_objectSpread({}, params), {}, {
      proposalId: proposalId,
      type: 'remove'
    }), appContext)
  });
}

function setProposalAsAutosaved(proposalId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["g" /* AUTOSAVE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["d" /* autosaveProposalMutation */])({
      proposalId: proposalId
    }, appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch, getState) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["e" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        selectedProposalId: Object(booking_selector["v" /* getSelectedProposalId */])(getState())
      }, appContext)
    }));
  };
}

function getNumberOfAttendees() {
  var nbAdults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nbKids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isSeller = arguments.length > 2 ? arguments[2] : undefined;
  var numberOfAttendees = nbAdults + nbKids;
  var maxPaxByUser = isSeller ? faceting_constants["L" /* MAX_PAX_SELLER */] : faceting_constants["K" /* MAX_PAX */];
  /** reset to default adults number if no adults or if the number exceeds the allowed sum (maxPaxByUser) */

  return numberOfAttendees === 0 || numberOfAttendees > maxPaxByUser ? adults_constants["a" /* DEFAULT_ADULTS_NB */] : numberOfAttendees;
}

function getTransportSearchCriteria(_ref2) {
  var _inbound$travelSectio;

  var proposal = _ref2.proposal,
      flightClass = _ref2.flightClass,
      _ref2$directFlights = _ref2.directFlights,
      directFlights = _ref2$directFlights === void 0 ? false : _ref2$directFlights,
      departureCity = _ref2.departureCity;

  if (!proposal.transports) {
    return {};
  }

  var _proposal$transports = proposal.transports,
      inbound = _proposal$transports.inbound,
      outbound = _proposal$transports.outbound;

  function formatTransportDetail(transportDetail, way) {
    var arrivalDate = proposal.arrivalDate,
        departureDate = proposal.departureDate;
    var firstTravelSection = transportDetail.travelSections[0];
    var lastTravelSection = transportDetail.travelSections[transportDetail.travelSections.length - 1];
    return {
      way: way,
      travelSections: [{
        departure: {
          city: {
            id: way === 'INBOUND' ? departureCity || firstTravelSection.departure.cityId : firstTravelSection.departure.cityId
          },
          date: way === 'INBOUND' ? '' : departureDate,
          location: {
            id: firstTravelSection.departure.id,
            terminalCode: firstTravelSection.departure.terminalCode
          }
        },
        arrival: {
          city: {
            id: way === 'INBOUND' ? lastTravelSection.arrival.cityId : departureCity || lastTravelSection.arrival.cityId
          },
          date: way === 'INBOUND' ? arrivalDate : '',
          location: {
            id: lastTravelSection.arrival.id,
            terminalCode: lastTravelSection.arrival.terminalCode
          }
        }
      }]
    };
  }

  return {
    journeys: [formatTransportDetail(inbound, 'INBOUND'), formatTransportDetail(outbound, 'OUTBOUND')],
    transportClass: flightClass || (inbound === null || inbound === void 0 ? void 0 : (_inbound$travelSectio = inbound.travelSections[0].transport) === null || _inbound$travelSectio === void 0 ? void 0 : _inbound$travelSectio["class"]),
    isDirectFlightOnly: directFlights,
    maxConnections: directFlights ? 0 : undefined,
    transportConnectionDuration: undefined,
    isTransportStationsChangesAllowed: undefined,
    isCabinMixingAllowed: undefined,
    isCompaniesMixingAllowed: undefined,
    imposedCompanies: undefined,
    imposedConnectionCities: undefined,
    excludedCompanies: undefined,
    excludedConnectionCities: undefined
  };
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, appContext, router) {
  var pageType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Booking Engine';
  return function (dispatch, getState) {
    var _queryParams$kids, _queryParams$kids$spl;

    var state = getState();
    var intArrivalDate = params.newArrivalDate || Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["n" /* timestampToApiDate */])(state.tripCriteria.departureDate);

    if (!intArrivalDate) {
      // $FlowFixMe
      logger["default"].error('the arrivalDate is required in fetchProposalsAndRedirect action');
      return;
    }

    var queryParams = omit_default()(router.query, ['dynamicPage']);

    var adultsAttendees = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var kidsAttendees = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var nbAdults = appContext.isSeller ? Number(queryParams.number_of_adults || adultsAttendees.length) : adultsAttendees.length;
    var nbKids = appContext.isSeller ? ((_queryParams$kids = queryParams.kids) === null || _queryParams$kids === void 0 ? void 0 : (_queryParams$kids$spl = _queryParams$kids.split('_')) === null || _queryParams$kids$spl === void 0 ? void 0 : _queryParams$kids$spl.length) || 0 : kidsAttendees.length;
    var allowedAttendeesNumber = getNumberOfAttendees(nbAdults, nbKids, appContext.isSeller);

    var proposalParams = proposals_action_objectSpread(proposals_action_objectSpread({
      arrivalDate: intArrivalDate.toString(),
      kids: kidsAttendees,
      adults: adultsAttendees,
      numberAttendees: allowedAttendeesNumber,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: queryParams.cxo_sales_network_id
    } : null), params);

    var redirectUri = Object(sellerUtils["d" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    /**  Method 5 steps
     * 1. fetch BE i18n config
     * 2. fetch proposal
     * 3. send tracking
     * 4. Set search criteria if transport for MoreTransports
     * 5. redirect to signin redirection URL
     */

    /* 1. fetch BE i18n config */

    dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext));
    /* 2. fetch proposal */

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    }, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposalParams, appContext).then(function (response) {
        var _proposals$errors, _proposals$errors$;

        var proposals = response.proposals;
        var isFetchProposalsFailed = Object(proposalUtils["p" /* hasFetchProposalsFailed */])(proposals);

        if (!isFetchProposalsFailed) {
          var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, queryParams);
          /* 5. redirect to signin redirection URL */

          router.push(bookingUrl);
        }

        var errorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;
        tracking_api["b" /* setDataLayer */]({
          categoryGA: 'resort',
          actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
          labelGA: isFetchProposalsFailed ? "errorCheckPrices".concat(errorCode ? "_".concat(snakeCase_default()(errorCode).toUpperCase()) : '') : 'checkPrices',
          siteSection: "Shopping_".concat(pageType)
        }, appContext);
        return response;
      }),
      redirect_uri: redirectUri
    }));
  };
}

function handleError(errors, appContext) {
  var _error$errors, _error$errors$; // We don't do anything specific with the errors, but this will let us display per field errors


  logger["default"].error(errors);
  var error = errors.errors ? errors : {
    errors: errors
  }; // Redirect to oidc if the statusCode is 401

  if (ple_utils["l" /* hasAuthResponseError */](error)) {
    Object(redirectUtils["a" /* redirectToOidc */])(appContext);
    return;
  } // Some errors are properly handled by graphql. But we don't handle them explicitly
  // We rely on the message to know the source of the error because of babel < 7


  throwFormatError(proposals_action_objectSpread(proposals_action_objectSpread({}, error), {}, {
    statusCode: error.message === 'Unhandled field form error' ? statusCode_constants["b" /* STATUS_CODE_400 */] : // $FlowFixMe
    error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.statusCode
  }));
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, queryParams) {
  return function (dispatch, getState) {
    var _attendees$kids;

    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();

    var _selectAttendeesWithI = Object(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */])(state),
        _selectAttendeesWithI2 = _selectAttendeesWithI.attendees,
        adultsAttendees = _selectAttendeesWithI2.adults,
        kidsAttendees = _selectAttendeesWithI2.children;

    var adults = new Array(attendees.adults).fill({}).map(function (_, index) {
      return {
        neolid: (adultsAttendees[index] || {}).customerId
      };
    });
    var kids = attendees.kids.map(function (kid) {
      var kidFromStore = kidsAttendees === null || kidsAttendees === void 0 ? void 0 : kidsAttendees.find(function (kidAtt) {
        return kidAtt.birthdate === kid.birthdate;
      });
      return {
        neolid: kidFromStore === null || kidFromStore === void 0 ? void 0 : kidFromStore.customerId,
        birthdate: kid.birthdate
      };
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        isJoyView: criteria.isJoyView,
        isUrbanOasis: criteria.isUrbanOasis,
        kids: kids,
        adults: adults,
        numberAttendees: getNumberOfAttendees(attendees.adults, (attendees === null || attendees === void 0 ? void 0 : (_attendees$kids = attendees.kids) === null || _attendees$kids === void 0 ? void 0 : _attendees$kids.length) || 0, appContext.isSeller),
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext.isSeller ? {
        salesNetworkId: queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };

  var sellerParams = proposals_action_objectSpread(proposals_action_objectSpread({}, Object(ContactInfoUtils["f" /* getAllAttendeesIds */])({
    adults: attendees.adults,
    kids: attendees.kids
  })), {}, {
    salesNetworkId: location.queryParams.cxo_sales_network_id
  });

  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread(proposals_action_objectSpread({}, appContext.isSeller ? sellerParams : null), {}, {
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults.length + attendees.kids.length,
      // $FlowFixMe
      adults: attendees.adults,
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }), appContext)
  });
}

function putTransportAndDispatchProposals(transportId, proposalsId, isJoyview, isUrbanOasis, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["f" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, isUrbanOasis, appContext)
    }));
  };
}

function fetchRefreshProposal(proposalId, salesNetworkId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["z" /* PROPOSAL_REFRESH */], {}, {
    optimist: true,
    promise: Object(proposalQuery["o" /* refreshProposal */])(proposalId, salesNetworkId, appContext)
  });
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["k" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref3) {
  var arrangement = _ref3.arrangement,
      proposalsId = _ref3.proposalsId,
      isJoyview = _ref3.isJoyview,
      isUrbanOasis = _ref3.isUrbanOasis,
      appContext = _ref3.appContext,
      globalLoaderLabel = _ref3.globalLoaderLabel,
      toastLabel = _ref3.toastLabel,
      _ref3$reduxAction = _ref3.reduxAction,
      reduxAction = _ref3$reduxAction === void 0 ? proposals_constants["a" /* ADD_ACCOMMODATION */] : _ref3$reduxAction;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(reduxAction, {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, isUrbanOasis, appContext)
    }));
  };
}

function updateAttendees(_ref4) {
  var proposalId = _ref4.proposalId,
      attendees = _ref4.attendees,
      appContext = _ref4.appContext;
  return function (dispatch) {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());
    return updateAttendeesMutation({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (_ref5) {
      var _proposal$attendees, _proposal$attendees$l, _proposal$attendees$l2, _modifiedAttendees$;

      var modifyAttendees = _ref5.modifyAttendees;
      var errors = modifyAttendees.errors,
          proposal = modifyAttendees.proposal,
          modifiedAttendees = modifyAttendees.attendees;

      if (errors) {
        throwFormatError({
          errors: errors
        });
      }

      var cookieToSet = proposals_action_objectSpread(proposals_action_objectSpread({}, tracking_storage_api["b" /* get */](constants["c" /* BE_TRACKING */])), {}, {
        neolaneId: proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : (_proposal$attendees$l2 = _proposal$attendees$l[0]) === null || _proposal$attendees$l2 === void 0 ? void 0 : _proposal$attendees$l2.customerId,
        BE_customerStatus: modifiedAttendees === null || modifiedAttendees === void 0 ? void 0 : (_modifiedAttendees$ = modifiedAttendees[0]) === null || _modifiedAttendees$ === void 0 ? void 0 : _modifiedAttendees$.customerType
      });

      tracking_storage_api["c" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["J" /* UPDATE_ATTENDEES */], modifyAttendees));
    })["catch"](function (error) {
      return handleError(error, appContext);
    })["finally"](function () {
      return dispatch(Object(globalLoader_action["c" /* endLoading */])());
    });
  };
}

function refuseInsuranceAction(insuranceId) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["h" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["h" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_patchProposalHandler = function patchProposalHandler(proposalId, appContext, extend) {
  var options = {
    operation: 'extend_persistence',
    parameters: extend.toString()
  };
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["u" /* PATCH_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["g" /* patchProposal */])(proposalId, appContext, options.operation, options.parameters)
    }));
  };
};

var proposals_action_saveCustomerProposalsOpportunityIdHandler = function saveCustomerProposalsOpportunityIdHandler(proposalId, appContext, customerId, opportunityId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["D" /* SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposalOpportunityId */])(proposalId, appContext, customerId, opportunityId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref6) {
  var attendees = _ref6.attendees,
      _ref6$showNotificatio = _ref6.showNotification,
      showNotification = _ref6$showNotificatio === void 0 ? false : _ref6$showNotificatio,
      appContext = _ref6.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["i" /* getCurrentProposal */])(getState());
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState());
    var servicesIds = attendees.map(function (_ref7) {
      var productInfoId = _ref7.productInfoId;
      return productInfoId;
    }); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var additionalServicesValues = Object.values(p.additionalServices);
      return additionalServicesValues === null || additionalServicesValues === void 0 ? void 0 : additionalServicesValues.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref8) {
          var pricingInfo = _ref8.pricingInfo;
          return servicesIds.includes(pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var proposalsWithServicesInAttendees = proposals.filter(function (_ref9) {
      var _Object$values;

      var additionalServices = _ref9.additionalServices;
      return (_Object$values = Object.values(additionalServices)) === null || _Object$values === void 0 ? void 0 : _Object$values.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            // $FlowFixMe
            return Object(proposalUtils["a" /* areAnyTimeSlotIdsPresent */])((typedServices === null || typedServices === void 0 ? void 0 : typedServices.pricingInfo.attendees) || [], servicesIds);
          });
        }
      });
    });
    var validProposalIds = (proposalsWithServices.length > 0 ? proposalsWithServices : proposalsWithServicesInAttendees).map(function (_ref10) {
      var id = _ref10.id;
      return id;
    });
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref11) {
          var pricingInfo = _ref11.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref12) {
          var pricingInfo = _ref12.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["L" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["n" /* putServicesMutation */])(validProposalIds, attendees, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref13) {
  var serviceIds = _ref13.serviceIds,
      attendeeIds = _ref13.attendeeIds,
      _ref13$showNotificati = _ref13.showNotification,
      showNotification = _ref13$showNotificati === void 0 ? false : _ref13$showNotificati,
      overloadForSpecificProposalIds = _ref13.overloadForSpecificProposalIds,
      appContext = _ref13.appContext,
      proposalsParam = _ref13.proposals;
  return function (dispatch, getState) {
    var proposals = proposalsParam || Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (_ref14) {
      var _Object$values2;

      var additionalServices = _ref14.additionalServices;
      return (_Object$values2 = Object.values(additionalServices)) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            var _typedServices$pricin, _typedServices$pricin2; // $FlowFixMe


            var schedules = (typedServices === null || typedServices === void 0 ? void 0 : (_typedServices$pricin = typedServices.pricingInfo) === null || _typedServices$pricin === void 0 ? void 0 : _typedServices$pricin.schedules) || [];
            var slots = Object.values(schedules[0].slots || {}); // $FlowFixMe

            var slotsIds = slots === null || slots === void 0 ? void 0 : slots.map(function (_ref15) {
              var id = _ref15.id;
              return id;
            });
            return (// $FlowFixMe
              serviceIds.includes(typedServices === null || typedServices === void 0 ? void 0 : (_typedServices$pricin2 = typedServices.pricingInfo) === null || _typedServices$pricin2 === void 0 ? void 0 : _typedServices$pricin2.id) || // $FlowFixMe
              (intersection_default()(slotsIds, serviceIds) || []).length > 0
            );
          });
        }
      });
    });
    var proposalsWithServicesInAttendees = proposals.filter(function (_ref16) {
      var _Object$values3;

      var additionalServices = _ref16.additionalServices;
      return (_Object$values3 = Object.values(additionalServices)) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            // $FlowFixMe
            return Object(proposalUtils["a" /* areAnyTimeSlotIdsPresent */])((typedServices === null || typedServices === void 0 ? void 0 : typedServices.pricingInfo.attendees) || [], serviceIds);
          });
        }
      });
    });
    var validProposalIds = (proposalsWithServices.length > 0 ? proposalsWithServices : proposalsWithServicesInAttendees).map(function (_ref17) {
      var id = _ref17.id;
      return id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: validProposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref18) {
  var proposalIds = _ref18.proposalIds,
      serviceId = _ref18.serviceId,
      attendeeIds = _ref18.attendeeIds,
      schedules = _ref18.schedules,
      _ref18$showNotificati = _ref18.showNotification,
      showNotification = _ref18$showNotificati === void 0 ? false : _ref18$showNotificati,
      overloadForSpecificProposalIds = _ref18.overloadForSpecificProposalIds,
      appContext = _ref18.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["d" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};
/**
INSURANCE ADD/DELETE
* */


var proposals_action_addInsurances = function addInsurances(_ref19) {
  var insurance = _ref19.insurance,
      attendeeIds = _ref19.attendeeIds,
      appContext = _ref19.appContext;
  var _insurance$pricingInf = insurance.pricingInfo,
      id = _insurance$pricingInf.id,
      schedules = _insurance$pricingInf.schedules;
  return function (dispatch, getState) {
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var _Object$values4;

      return (_Object$values4 = Object.values(p.additionalServices)) === null || _Object$values4 === void 0 ? void 0 : _Object$values4.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref20) {
          var pricingInfo = _ref20.pricingInfo;
          return id === (pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var validProposalIds = proposalsWithServices.map(function (_ref21) {
      var proposalId = _ref21.id;
      return proposalId;
    });
    return dispatch(proposals_action_addAdditionalService({
      proposalIds: validProposalIds,
      serviceId: id,
      attendeeIds: attendeeIds,
      schedules: schedules.map(function (_ref22) {
        var startDate = _ref22.startDate,
            endDate = _ref22.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["K" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["r" /* INSURANCE_ADDED */], id));
    });
  };
};

var proposals_action_deleteInsurances = function deleteInsurances(_ref23) {
  var insurance = _ref23.insurance,
      attendeeIds = _ref23.attendeeIds,
      appContext = _ref23.appContext;
  var insuranceId = insurance.pricingInfo.id;
  return function (dispatch, getState) {
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var _Object$values5;

      return (_Object$values5 = Object.values(p.additionalServices)) === null || _Object$values5 === void 0 ? void 0 : _Object$values5.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref24) {
          var pricingInfo = _ref24.pricingInfo;
          return insuranceId === (pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var validProposalIds = proposalsWithServices.map(function (_ref25) {
      var id = _ref25.id;
      return id;
    });
    return dispatch(proposals_action_deleteAdditionalServices({
      proposalIds: validProposalIds,
      serviceIds: [insuranceId],
      attendeeIds: attendeeIds,
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["i" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
    });
  };
};
/**
END INSURANCE
* */


var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["v" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["E" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(state); // isolate proposals elligible for switching offers because offers are not for all proposals sadly

    var validProposals = proposals.filter(function (_ref26) {
      var alternativePrice = _ref26.alternativePrice;
      return alternativePrice && alternativePrice.discounts && alternativePrice.discounts.length > 0 && intersection_default()(alternativePrice.discounts.map(function (_ref27) {
        var offerId = _ref27.offerId;
        return offerId;
      }), offers).length > 0;
    });
    var proposalsIds = validProposals.map(function (_ref28) {
      var id = _ref28.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["H" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_2__);




var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BU6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WECHAT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ECYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EPAYGATE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IXOPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPLIFT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PLEDG_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ONEY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAYPAL_PSP_ID; });
/* unused harmony export ESSPSCT_PSP_ID */
/* unused harmony export ESSPSDD_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NODELCRERE_TRANSFER_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NODELCRERE_CHEQUE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEPOSIT_OFFSET_PSP_ID; });
/* unused harmony export HIPAY_CMTA_PSP_ID */
/* unused harmony export EGLOBALCOLLECT_PSP_ID */
/* unused harmony export OGONE_CMTA_PSP_ID */
/* unused harmony export OGONE_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAYMENT_METHOD_LABEL; });
/* unused harmony export BANK_TRANSFER_LABEL */
/* unused harmony export CHEQUE_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREDIT_CARD_LABEL; });
/* unused harmony export PAYPAL_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VOXPAY_PSP_ID_PREFIX; });
/* unused harmony export VOXPAY_PHONE_PSP_ID */
/* unused harmony export VOXPAY_PHONE_LABEL */
/* unused harmony export VOXPAY_EMAIL_PSP_ID */
/* unused harmony export VOXPAY_EMAIL_LABEL */
/* unused harmony export VOXPAY_SMS_PSP_ID */
/* unused harmony export VOXPAY_SMS_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NAPAY_PSP_ID; });
/* unused harmony export PROVIDER_ID_EVOPAY_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PAYMENT_METHOD_CATEGORY; });
/* unused harmony export INVALID_EMAIL */
/* unused harmony export INVALID_PHONE */
var WECHAT_PSP_ID = 'M99BILLW';
var CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
var ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
var EPAYGATE_PSP_ID = 'EPAYGATE';
var IXOPAY_PSP_ID = 'EIXOPAY';
var UPLIFT_PSP_ID = 'MUPLIFT';
var PLEDG_PSP_ID = 'MPLEDG';
var ONEY_PSP_ID = 'EHIPAYBNPL';
var HIPAY_PSP_ID = 'MHIPAY';
var PAYPAL_PSP_ID = 'MHIPAYPP';
var ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER

var ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT

var NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER

var NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT

var DEPOSIT_OFFSET_PSP_ID = 'OF';
var HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
var EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT

var OGONE_CMTA_PSP_ID = 'MOGONE';
var OGONE_PSP_ID = 'EOGONE';
var PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
var BANK_TRANSFER_LABEL = 'Bank Transfer';
var CHEQUE_LABEL = 'Cheque';
var CREDIT_CARD_LABEL = 'Credit Card';
var PAYPAL_LABEL = 'Paypal';
var VOXPAY_PSP_ID_PREFIX = 'EVOXPAY';
var VOXPAY_PHONE_PSP_ID = 'EVOXPAY_PHONE';
var VOXPAY_PHONE_LABEL = 'Phone';
var VOXPAY_EMAIL_PSP_ID = 'EVOXPAY_EMAIL';
var VOXPAY_EMAIL_LABEL = 'Email';
var VOXPAY_SMS_PSP_ID = 'EVOXPAY_SMS';
var VOXPAY_SMS_LABEL = 'Sms';
var NAPAY_PSP_ID = 'NAPAY';
var PROVIDER_ID_EVOPAY_PREFIX = 'EVOXPAY';
var PAYMENT_METHOD_CATEGORY = {
  BUY_NOW_PAY_LATER: 'BuyNowPayLater',
  CREDIT_CARD: 'CreditCard',
  CARD: 'card',
  PAYPAL: 'Paypal',
  CHEQUE: 'Cheque',
  DIRECT_DEBIT: 'DirectDebit',
  BANK_TRANSFER: 'BankTransfer'
};
var INVALID_EMAIL = 'INVALID_EMAIL';
var INVALID_PHONE = 'INVALID_PHONE';

/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export documentFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profileFragment; });
/* unused harmony export commonProfileFieldsFragment */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kH/m");


var documentFragment = "{ issuingDate\n  expirationDate\n  nationality\n  documentNumber\n  issuingCountry\n  birthCountry\n  birthCity\n  secondName\n  thirdName\n  fourthName\n  type }";
var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    document {\n      passport {\n        ...".concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n    passport {\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n   identityNumber\n   travelCompanions {\n    id: customerId\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    birthdate: dateOfBirth\n    document {\n      passport {\n        ...").concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n   }\n  }\n  ").concat(_utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__[/* addressFragment */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id\n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "C56r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("kZDm");
var aCallable = __webpack_require__("eGzU");
var isObject = __webpack_require__("1YFU");
var hasOwn = __webpack_require__("/GgU");
var arraySlice = __webpack_require__("gp/v");
var NATIVE_BIND = __webpack_require__("vCWs");

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C8GU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var toIntegerOrInfinity = __webpack_require__("aXF+");
var toString = __webpack_require__("vnfA");
var requireObjectCoercible = __webpack_require__("4gXF");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* unused harmony export getServiceAgesLabelTranslateOptions */
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");



var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};

var createPropsForPictures = function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
};

var createPropsForProduct = function createPropsForProduct(resort) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
};



/***/ }),

/***/ "CGO5":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("87KK").f;
var hasOwn = __webpack_require__("/GgU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "CSQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allInclusiveServicesSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _priceRemote_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("l1aQ");


var allInclusiveServicesSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_1__[/* priceRemoteSelector */ "a"], function (_ref) {
  var data = _ref.allInclusiveServices.data;
  return data;
});

/***/ }),

/***/ "CzFL":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ "D092":
/***/ (function(module, exports, __webpack_require__) {

var defineBuiltIn = __webpack_require__("Swp0");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "DOIJ":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("aXF+");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasOverlappingClick = _ref.hasOverlappingClick,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('group relative', className)
    }, itemsNode, hasControls && __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-none absolute inset-0 z-2 m-auto flex w-full items-center justify-between transition-opacity duration-250 ease-in will-change-transform', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 me-auto shadow-sm', {
        '-translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 ms-auto shadow-sm', {
        'translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-10 sm:px-20"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 me-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 ms-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DYOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CrisisAlert; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VO9w");
/* harmony import */ var _frameworks_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jD8k");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var CrisisAlert = function CrisisAlert(_ref) {
  var hasSeeMore = _ref.hasSeeMore,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].WARNING : _ref$icon,
      linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl,
      message = _ref.message,
      onClick = _ref.onClick,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;

  if (!message) {
    return null;
  }

  var content = __jsx(_frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_2__[/* Notification */ "a"], {
    className: "text-sienna",
    iconName: icon,
    text: message
  }, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_4__[/* TextLink */ "a"], {
    label: linkLabel,
    onClick: onClick,
    url: linkUrl
  }));

  if (hasSeeMore) {
    return __jsx(_frameworks_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
      classNameButton: "text-end",
      hasNoScrollOnCollapse: true,
      isCollapseEnabled: true,
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      seeMoreSize: 110
    }, content);
  }

  return content;
};

/***/ }),

/***/ "Dcno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return QUOTATION_FORM_SECTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return QUOTATION_FORM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_FORM_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_FORM_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_FORM_TEENS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MIN_FORM_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MIN_FORM_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MIN_FORM_TEENS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NO_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RANGE_ESCAPADE; });
var QUOTATION_FORM_SECTION_ID = 'quotation-form-section';
var QUOTATION_FORM_ID = 'product-quotation-form';
var MAX_FORM_ADULTS = 6;
var MAX_FORM_KIDS = 6;
var MAX_FORM_TEENS = 6;
var MIN_FORM_ADULTS = 1;
var MIN_FORM_KIDS = 0;
var MIN_FORM_TEENS = 1;
var NO_VALUE = 'NO';
var RANGE_ESCAPADE = 'escapade';

/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex font-bold gap-10 items-center leading-1 my-10 text-14', "".concat(isError ? 'text-red' : 'text-success'), className),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('shrink-0', {
      'pt-5 px-5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "DyR2":
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__("v5ZW");

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),

/***/ "E+Ue":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("XywU");
var uncurryThis = __webpack_require__("kZDm");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "E8R/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = StringSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = _locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || _locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = _locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = _locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = _locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = _locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = _locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceTheme: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx



var __jsx = react_default.a.createElement;









var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? noop_default.a : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? noop_default.a : _ref$onEmptyPriceClic,
      _ref$onIconBubbleClic = _ref.onIconBubbleClick,
      onIconBubbleClick = _ref$onIconBubbleClic === void 0 ? noop_default.a : _ref$onIconBubbleClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? noop_default.a : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (isEmpty_default()(price)) {
    return null;
  }

  var thPriceTheme = themes[theme].thPriceTheme;
  var hasPrice = !isPriceLoading && Object(price_util["d" /* hasAtLeastOnePrice */])(price);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex gap-5"
  }, __jsx("button", {
    className: "flex w-full items-center justify-end",
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    type: "button"
  }, __jsx(Price["b" /* Price */], {
    bestPrice: price.bestPrice,
    color: price.color || colors["a" /* COLORS */].SIENNA,
    "data-testid": "Price-wrapper",
    from: price.from,
    hasInitialPrice: true,
    initialPrice: price.initialPrice,
    isLoading: isPriceLoading,
    theme: thPriceTheme,
    unit: price.unit,
    viewRates: price.viewRates
  })), hasPrice && Object(i18n["d" /* getKeyValue */])('price.displayIconBubble') && __jsx("button", {
    className: "mt-5",
    onClick: function onClick() {
      return onIconBubbleClick && onIconBubbleClick();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-sienna",
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.25rem"
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({}, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-5"
  }, priceNode);
};

/***/ }),

/***/ "EVS9":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var aCallable = __webpack_require__("eGzU");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Ed3r":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("XywU");
var toIndexedObject = __webpack_require__("dNjr");
var $getOwnPropertyNames = __webpack_require__("8D46").f;
var arraySlice = __webpack_require__("VrMS");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "F0GY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ "F9U4":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var classof = __webpack_require__("XywU");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "FaX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPANION_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_FORM_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAX_FORM_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MIN_FORM_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MIN_FORM_KIDS; });
/* unused harmony export MAX_COMPANIONS */
var ADULTS = 'adults';
var KIDS = 'kids';
var COMPANION_GROUPS = {
  ADULTS: ADULTS,
  KIDS: KIDS
};
var MAX_FORM_ADULTS = 6;
var MAX_FORM_KIDS = 6;
var MIN_FORM_ADULTS = 1;
var MIN_FORM_KIDS = 0;
var MAX_COMPANIONS = 7;

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCruiseExclusivity; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("igjW");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");







var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};
var getCruiseExclusivity = function getCruiseExclusivity() {
  var _data$cruiseExclusivi;

  var productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _runGQLQuery = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__[/* useGQL */ "a"])({
    query: "query {\n      cruiseExclusivity(productId: \"".concat(productId, "\") {\n        isExclusive\n      }\n    }"),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_CRUISE_EXCLUSIVITY */ "rb"]
    }
  }),
      data = _runGQLQuery.data,
      isCruiseExclusivityLoading = _runGQLQuery.isLoading;

  return {
    isCruiseExclusive: !!(data === null || data === void 0 ? void 0 : (_data$cruiseExclusivi = data.cruiseExclusivity) === null || _data$cruiseExclusivi === void 0 ? void 0 : _data$cruiseExclusivi.isExclusive),
    isCruiseExclusivityLoading: isCruiseExclusivityLoading
  };
};

/***/ }),

/***/ "FllU":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIteratee = __webpack_require__("S3pA"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jD8k");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHECK_OUTLINE : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLACK,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GREEN
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex gap-20 items-start sm:items-center text-12 sm:text-20', "text-".concat(colors[status]), className)
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "shrink-0",
    name: iconName,
    width: "4em"
  }), __jsx("div", {
    className: "flex-auto"
  }, __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('font-bold text-16 sm:text-20', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    text: text
  }), __jsx("p", null, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, link, {
    className: "mt-10 underline"
  }))), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, button, {
    className: "mt-10"
  }), button.children)));
};

/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /opt/webapp/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
    window.removeEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /opt/webapp/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_OF_STAY_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var PRICE_OF_STAY_REQUEST_ABORT = 'PRICE_OF_STAY_REQUEST_ABORT';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "GjC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTeaser; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_card_Card_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("syQ6");
/* harmony import */ var _frameworks_card_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("786X");
/* harmony import */ var _product_Product__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("XTOr");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var ProductTeaser = function ProductTeaser(_ref) {
  var card = _ref.card,
      product = _ref.product;

  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(card)) {
    return null;
  }

  var hasProduct = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(product);

  if (!hasProduct) {
    return __jsx(_frameworks_card_Card__WEBPACK_IMPORTED_MODULE_4__[/* Card */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      layout: _frameworks_card_Card_constants__WEBPACK_IMPORTED_MODULE_3__[/* INLINE_1 */ "d"]
    }, card));
  }

  return __jsx("div", {
    className: "flex flex-col gap-20 sm:flex-row"
  }, __jsx(_frameworks_card_Card__WEBPACK_IMPORTED_MODULE_4__[/* Card */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, card, {
    className: "lg:3/4 w-full sm:w-1/2 md:w-2/3",
    layout: _frameworks_card_Card_constants__WEBPACK_IMPORTED_MODULE_3__[/* INLINE_1 */ "d"]
  })), __jsx(_product_Product__WEBPACK_IMPORTED_MODULE_5__[/* Product */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, product, {
    className: "lg:1/4 w-full sm:w-1/2 md:w-1/3"
  })));
};

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].PEARL;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-grey") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "H0gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productChildcareDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productChildcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activityCategoryFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activityFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return thematicFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rentalsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productActivitiesQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");



function productFeatureServiceQuery(lineProps) {
  var ageInformation = lineProps.ageInformation,
      groupMin = lineProps.groupMin,
      groupMax = lineProps.groupMax,
      groupRange = lineProps.groupRange;
  return "\n    hasBookingOnline\n    hasBookingOnsite\n    id\n    isIdealForFamily\n    label\n    description\n    detailedDescription\n    durationDescription\n    ageRestriction(message: \"".concat(ageInformation, "\")\n    level\n    note\n    group(min: \"").concat(groupMin, "\" max: \"").concat(groupMax, "\" range: \"").concat(groupRange, "\")\n    specificConditions\n    equipments {\n      label\n      included\n    }\n    utilities {\n      label\n      included\n    }\n    targetPrice {\n      price\n      currency\n    }\n  ");
}

var productFeatureFacilityQuery = "\n    description\n    distance\n    id\n    label\n    localisation\n    nightLighting\n    onSite\n    outdoor\n    quantity\n    specificInformation {\n      type\n      value\n    }\n    technicalSpecificities {\n      typeDescription\n      length\n      width\n      minDepth\n      maxDepth\n      unit\n    }\n  ";
function productChildcareDetailQuery(productId, activityId, _ref) {
  var lineProps = _ref.lineProps,
      urlParams = _ref.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var productActivitiesArgs = "activityId : \"".concat(activityId, "\"");
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
  return "query {\n    config {\n      common { previous next }\n    }\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n      productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n    }\n    productActivities(").concat(productArgs, ") {\n      childcare(").concat(productActivitiesArgs, ") {\n        closingWeekdays\n        description\n        duration\n        furtherInformation\n        id\n        label\n        openingDates {\n          opening\n          closing\n        }\n        openingHours {\n          start\n          end\n        }\n        timeSlots {\n          type\n          opening\n          closing\n        }\n        philosophy\n        targetPrice {\n          currency\n          price\n        }\n      }\n      facilities(").concat(productActivitiesArgs, ") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    includedServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n  }");
}
/* lists of features */

var productFeaturesConfigQuery = "\n    config {\n      common {\n        allInclusive\n        backNavigation\n        bookOnlineOnly\n        bookOnlineOrOnsite\n        bookOnsiteOnly\n        childcarealacarte\n        downloadLeafletLabel\n        extraCost\n        howToBookLabel\n        idealForFamilyLabel\n        included\n        loadLess\n        onDemandService\n        philosophyLabel\n        price {\n          priceFrom\n        }\n        scrollBackward\n        scrollForward\n        treatmentsLabel\n        viewMore\n      }\n    }\n  ";

function productFeaturesCategoriesFields(defaultLabel) {
  var activityLabel = defaultLabel ? "label(defaultLabel: \"".concat(defaultLabel, "\")") : 'label';
  return "\n    activities: subCategories {\n      bookingDescription\n      bookletUrl\n      brandLogoUrl\n      description\n      equipmentRentalDescription\n      id\n      image: imageUrl\n      isChildrenClub\n      isIncluded\n      keywords\n      ".concat(activityLabel, "\n      name\n      numberOfIncludedActivities\n      numberOfOnDemandActivities\n      philosophy\n      ranking\n      rentalEquipmentsUsecasesId\n      supervisionDescription\n      termsAndConditionsDescription\n    }\n    id\n    label\n    ranking\n  ");
}

function productChildcaresQuery(productId, _ref2) {
  var urlParams = _ref2.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      kidsActivitiesIntroduction {\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        children {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}
/* ACTIVITIES */

var activityCategoryFragment = "fragment activityCategory on UpsellsActivityCategoryType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  bookingDescription\n  bookletUrl\n  description\n  equipmentRentalDescription\n  facilities {\n    areaId\n    categoriesIds\n    description\n    distanceAndTransferDescription\n    equipments {\n      id\n      label\n    }\n    hasFreeAccess\n    hasNightLighting\n    id\n    isOnSite\n    isOutdoor\n    level\n    localisation\n    name\n    quantity\n    ranking\n    specificInformation {\n      type\n      value\n    }\n    subTitle\n    technicalSpecificities {\n      height\n      isHeated\n      length\n      maxDepth\n      minDepth\n      typesDescription\n      unit\n      width\n    }\n  }\n  id\n  images\n  keywords\n  name\n  philosophy\n  ranking\n  shortDescription\n  supervisionDescription\n  termsAndConditionsDescription\n  upsellType\n}";
var activityFragment = "fragment activity on UpsellsActivityType {\n  ageRestriction {\n    formatted\n    min\n    max\n    specificConditions\n  }\n  categoriesIds\n  description\n  duration\n  equipments {\n    id\n    isIncluded\n    label\n  }\n  furtherInformation\n  hasBookingOnline\n  hasBookingOnsite\n  id\n  images\n  isIncluded\n  level\n  name\n  openingDates {\n    endDate\n    startDate\n  }\n  participants {\n    min\n    max\n  }\n  price {\n    currency\n    formattedValue\n    value\n  }\n  ranking\n  seasonality\n  services {\n    id\n    isIncluded\n    label\n  }\n  subtitle\n  transportation\n  treatments\n  upsellType\n}";
var thematicFragment = "fragment thematics on UpsellsActivityThematicType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  description\n  id\n  images\n  name\n}\n";
var rentalsFragment = "fragment rentals on RentalsTreeType {\n  id\n  label\n  items {\n    id\n    label\n    items {\n      ageRestriction {\n        formatted\n        max\n        min\n      }\n      availableBrands\n      furtherInformation\n      formalities\n      id\n      images\n      levels {\n        id\n        label\n      }\n      longDescription\n      name\n      price {\n        currency\n        formattedValue\n        value\n      }\n      productRange {\n        id\n        label\n      }\n      shortDescription\n      sizes {\n        max\n        min\n        unit\n      }\n      type {\n        id\n        label\n      }\n      upsellType\n      usecase {\n        id\n        label\n      }\n    }\n  }\n}";
var productActivitiesQuery = function productActivitiesQuery(_ref3) {
  var productId = _ref3.productId,
      urlParams = _ref3.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    resort(".concat(productArgs, ") {\n      activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      id\n      name\n      rentalsTree {\n        ...rentals\n      }\n    }\n  }\n  ").concat(activityCategoryFragment, "\n  ").concat(activityFragment, "\n  ").concat(rentalsFragment, "\n  ").concat(thematicFragment, "\n  ");
};

/***/ }),

/***/ "H5UF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TravelSherpa_TravelSherpa; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlert.jsx
var CrisisAlert = __webpack_require__("DYOT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/hooks/use-debounce/useDebounce.js
var useDebounce = __webpack_require__("ngAq");

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-sherpa/TravelSherpaWidget.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var supportedLang = ['de', 'en', 'es', 'fr', 'it', 'ja-JP', 'ko', 'pt-BR', 'pt-PT', 'nl', 'ru', 'sv-SE', 'tr', 'zh'];

var getLang = function getLang(_ref) {
  var locale = _ref.locale,
      language = _ref.language;

  if (locale === 'se-SE') {
    return 'sv-SE';
  }

  if (supportedLang.includes(locale)) {
    return locale;
  }

  if (supportedLang.includes(language)) {
    return language;
  }

  return 'en';
};

var travelSherpaScriptUrl = config_default.a.get('travelSherpa.scriptUrl');

var TravelSherpaWidget_formatDateforTravelSherpa = function formatDateforTravelSherpa(date) {
  return moment_default()(date).format('YYYY-MM-DD');
};

var elementConfig = function elementConfig(_ref2) {
  var departureDate = _ref2.departureDate,
      lang = _ref2.lang,
      product = _ref2.product,
      returnDate = _ref2.returnDate,
      withInboundOutbound = _ref2.withInboundOutbound;
  return _objectSpread({
    language: lang,
    placement: 'mmb'
  }, product && _objectSpread({
    travellers: [{
      nationality: product.travelSherpaOutbound,
      vaccinations: [{
        type: 'COVID_19',
        status: 'FULLY_VACCINATED'
      }]
    }]
  }, withInboundOutbound && product.travelSherpaOutbound !== product.travelSherpaInbound && {
    segments: [_objectSpread({
      segmentType: 'OUTBOUND',
      origin: {
        countryCode: product.travelSherpaOutbound
      },
      destination: {
        countryCode: product.travelSherpaInbound
      }
    }, departureDate && {
      departureDate: TravelSherpaWidget_formatDateforTravelSherpa(departureDate)
    }), _objectSpread(_objectSpread({
      segmentType: 'RETURN',
      origin: {
        countryCode: product.travelSherpaInbound
      },
      destination: {
        countryCode: product.travelSherpaOutbound
      }
    }, returnDate && {
      arrivalDate: returnDate
    }), returnDate && {
      departureDate: returnDate
    })]
  }));
};

var TravelSherpaWidget_TravelSherpaWidget = function TravelSherpaWidget(_ref3) {
  var className = _ref3.className,
      disclaimer = _ref3.disclaimer,
      isLoadingWidget = _ref3.isLoadingWidget,
      product = _ref3.product,
      _ref3$withInboundOutb = _ref3.withInboundOutbound,
      withInboundOutbound = _ref3$withInboundOutb === void 0 ? true : _ref3$withInboundOutb,
      departureDate = _ref3.departureDate,
      duration = _ref3.duration;
  Object(useScriptLoader["a" /* useScriptLoader */])(travelSherpaScriptUrl);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      language = _useAppContext.language,
      locale = _useAppContext.locale;

  var returnDate = departureDate && duration && TravelSherpaWidget_formatDateforTravelSherpa(moment_default()(departureDate).add(duration, 'days'));
  var debouncedCriteria = Object(useDebounce["a" /* useDebounce */])([departureDate, duration], 500);

  var _debouncedCriteria = Object(slicedToArray["a" /* default */])(debouncedCriteria, 2),
      dateCriteria = _debouncedCriteria[0],
      durationCriteria = _debouncedCriteria[1];

  var hasDebouncedCriteria = Boolean(isLoadingWidget && dateCriteria && durationCriteria);
  var lang = getLang({
    language: language,
    locale: locale
  });
  Object(react["useEffect"])(function () {
    var travelSherpaconfig = elementConfig({
      departureDate: departureDate,
      lang: lang,
      product: product,
      returnDate: returnDate,
      withInboundOutbound: withInboundOutbound
    });

    if (isLoadingWidget) {
      if (typeof window.$sherpa !== 'undefined') {
        // $FlowFixMe
        window.$sherpa.V2.createElement('trip', travelSherpaconfig).mount('#sherpa-trip-element');
      } else {
        window.onSherpaEvent = function (event) {
          if (event.type === 'sdkLoaded') {
            // sdk is ready, create and mount new elements
            // $FlowFixMe
            window.$sherpa.V2.createElement('trip', travelSherpaconfig).mount('#sherpa-trip-element');
          }
        };
      }
    }
  }, withInboundOutbound && product && product.travelSherpaOutbound !== product.travelSherpaInbound ? [isLoadingWidget, hasDebouncedCriteria] : []);
  return __jsx("div", {
    className: className
  }, __jsx("div", {
    id: "sherpa-trip-element"
  }), !!disclaimer && __jsx("p", {
    className: "font-sans text-10"
  }, disclaimer));
};
// CONCATENATED MODULE: ./src/client/components/widgets/travel-sherpa/TravelSherpa.jsx

var TravelSherpa_jsx = react_default.a.createElement;









var TravelSherpa_TravelSherpa = function TravelSherpa(_ref) {
  var _crisisAlert$link, _crisisAlert$link2;

  var className = _ref.className,
      crisisAlert = _ref.crisisAlert,
      departureDate = _ref.departureDate,
      duration = _ref.duration,
      loadMore = _ref.loadMore,
      product = _ref.product,
      _ref$travelSherpa = _ref.travelSherpa,
      travelSherpa = _ref$travelSherpa === void 0 ? {} : _ref$travelSherpa;

  var _useState = Object(react["useState"])(false),
      isLoadingWidget = _useState[0],
      setIsLoadingWidget = _useState[1];

  var disclaimer = travelSherpa.disclaimer;
  var track = Object(useTracking["a" /* useTracking */])();

  var onClickSeeMore = function onClickSeeMore(_, isExpanded) {
    setIsLoadingWidget(false);

    if (!isExpanded) {
      setIsLoadingWidget(true);
      track({
        actionGA: 'travelRestrictions',
        labelGA: 'checkCountryRestrictions'
      });
    }
  };

  var hasTravelSherpaWidget = !product || product.travelSherpaOutbound !== product.travelSherpaInbound;

  if (!hasTravelSherpaWidget && !(crisisAlert === null || crisisAlert === void 0 ? void 0 : crisisAlert.message)) {
    return null;
  }

  var messageWhenWidgetFail = TravelSherpa_jsx("div", {
    className: "py-10"
  }, TravelSherpa_jsx("p", {
    className: "pe-10"
  }, Object(i18n["h" /* t */])('travelRestriction.errorMessage.label')), TravelSherpa_jsx(TextLink["a" /* TextLink */], {
    className: "text-black",
    "data-testid": "TravelSherpaLinkFail",
    label: Object(i18n["h" /* t */])('travelRestriction.errorMessage.linkLabel'),
    onClick: function onClick() {
      return track({
        actionGA: 'travelRestrictions',
        categoryGA: 'resort',
        labelGA: 'errorMessage_link'
      });
    },
    target: "_blank",
    url: Object(i18n["h" /* t */])('travelRestriction.errorMessage.link')
  }));

  return TravelSherpa_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('md:flex', className)
  }, TravelSherpa_jsx("div", {
    className: "flex justify-center"
  }, TravelSherpa_jsx("img", {
    alt: "",
    className: "h-[135px] w-200 flex-none",
    src: Object(i18n["h" /* t */])('travelRestriction.iconLink')
  })), (crisisAlert === null || crisisAlert === void 0 ? void 0 : crisisAlert.message) ? TravelSherpa_jsx("div", null, TravelSherpa_jsx(SeeMore["a" /* SeeMore */], {
    className: "mt-10 flex-1 md:mt-0",
    classNameButton: "text-end",
    hasDynamicHeight: hasTravelSherpaWidget,
    hasNoScrollOnCollapse: !hasTravelSherpaWidget,
    isCollapseEnabled: true,
    onClick: onClickSeeMore,
    seeLessLabel: Object(i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: loadMore,
    seeMoreSize: 90,
    seeMoreSizeTolerance: 0
  }, TravelSherpa_jsx(CrisisAlert["a" /* CrisisAlert */], {
    icon: icons["a" /* ICONS */].WARNING,
    linkLabel: (_crisisAlert$link = crisisAlert.link) === null || _crisisAlert$link === void 0 ? void 0 : _crisisAlert$link.label,
    linkUrl: (_crisisAlert$link2 = crisisAlert.link) === null || _crisisAlert$link2 === void 0 ? void 0 : _crisisAlert$link2.url,
    message: crisisAlert.message,
    onClick: function onClick() {
      return track({
        actionGA: 'travelRestrictions',
        categoryGA: 'resort',
        labelGA: 'learnMore'
      });
    }
  }), hasTravelSherpaWidget && TravelSherpa_jsx(TravelSherpaWidget_TravelSherpaWidget, {
    className: "mt-25 md:mt-30",
    disclaimer: disclaimer,
    isLoadingWidget: isLoadingWidget,
    product: product,
    departureDate: departureDate,
    duration: duration
  })), messageWhenWidgetFail) : TravelSherpa_jsx("div", null, messageWhenWidgetFail, TravelSherpa_jsx(TravelSherpaWidget_TravelSherpaWidget, {
    className: "flex-1",
    disclaimer: disclaimer,
    isLoadingWidget: true,
    product: product,
    departureDate: departureDate,
    duration: duration
  })));
};

/***/ }),

/***/ "H8O8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacilitiesHours_FacilitiesHours; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.themes.js
var Text_themes = __webpack_require__("UJ9Y");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-html/TextHtml.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/no-danger */



var TextHtml_TextHtml = function TextHtml(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'text-sans-n1' : _ref$theme;

  if (!children) {
    return null;
  }

  var thRoot = Text_themes["a" /* themes */][theme].thRoot;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    dangerouslySetInnerHTML: {
      __html: children
    }
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/facility-hours/FacilityHours.jsx






var FacilityHours_jsx = react_default.a.createElement;









var FacilityHours_FacilityHours = function FacilityHours(_ref) {
  var buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      facility = _ref.facility,
      onClick = _ref.onClick,
      openingHoursLabel = _ref.openingHoursLabel;
  var additionalDescription = facility.additionalDescription,
      description = facility.description,
      id = facility.id,
      _facility$images = facility.images,
      images = _facility$images === void 0 ? [] : _facility$images,
      label = facility.label,
      _facility$menu = facility.menu,
      menu = _facility$menu === void 0 ? [] : _facility$menu,
      _facility$openingDays = facility.openingDays,
      openingDays = _facility$openingDays === void 0 ? [] : _facility$openingDays,
      reservationLink = facility.reservationLink;

  var getFormattedDate = function getFormattedDate(hour) {
    return Object(dateUtils["a" /* formatDate */])('HH:mm')(hour, 'HH:mm:ss');
  };

  return FacilityHours_jsx("article", {
    className: Object(classnames_utils["a" /* classnames */])('space-y-20', className),
    id: id
  }, FacilityHours_jsx("div", {
    className: "flex flex-col gap-30 md:flex-row"
  }, Boolean(images.length) && FacilityHours_jsx(Image["a" /* Image */], {
    className: "overflow-hidden rounded-12 md:flex-1 md:self-start",
    imageUrl: images[0],
    ratioKey: ratios_utils["c" /* default */].XL
  }), FacilityHours_jsx("div", {
    className: "space-y-10 md:flex-1"
  }, FacilityHours_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-brand-n2"
  }, label), FacilityHours_jsx(TextHtml_TextHtml, {
    theme: "text-sans-n3"
  }, additionalDescription), FacilityHours_jsx(Text["a" /* Text */], {
    text: description,
    theme: "text-sans-n3"
  }), menu.map(function (_ref2) {
    var href = _ref2.href,
        menuLabel = _ref2.label;
    return FacilityHours_jsx(Button["a" /* Button */], {
      key: menuLabel,
      className: "hidden md:inline-flex",
      onClick: onClick,
      url: href
    }, menuLabel);
  }), reservationLink && FacilityHours_jsx(Button["a" /* Button */], {
    className: "hidden md:inline-flex",
    onClick: onClick,
    url: reservationLink
  }, buttonLabel))), Boolean(openingDays.length) && FacilityHours_jsx(react["Fragment"], null, FacilityHours_jsx(Title["a" /* Title */], {
    className: "text-sienna",
    hLevel: 4,
    theme: "title-sans-n4"
  }, openingHoursLabel), FacilityHours_jsx("ul", {
    className: "gap-30 space-y-20 text-16 md:columns-2"
  }, openingDays.filter(function (_ref3) {
    var businessHours = _ref3.businessHours;
    return !!businessHours.length;
  }).map(function (_ref4) {
    var businessHours = _ref4.businessHours,
        day = _ref4.day;
    return FacilityHours_jsx("li", {
      className: "break-inside-avoid",
      key: day
    }, FacilityHours_jsx("p", {
      className: "mb-10 font-bold"
    }, day), FacilityHours_jsx("ul", null, businessHours.map(function (hour, i) {
      return FacilityHours_jsx("li", {
        className: "flex justify-between",
        key: "".concat(day, "-").concat(i)
      }, hour.label, FacilityHours_jsx("span", null, [getFormattedDate(hour.opening), getFormattedDate(hour.closing)].join(' - ')));
    })));
  }))), reservationLink && FacilityHours_jsx(Button["a" /* Button */], {
    className: "w-full md:hidden",
    onClick: onClick,
    url: reservationLink
  }, buttonLabel));
};
// CONCATENATED MODULE: ./src/client/components/widgets/facilities-hours/FacilitiesHours.jsx

var FacilitiesHours_jsx = react_default.a.createElement;





var FacilitiesHours_FacilitiesHours = function FacilitiesHours(_ref) {
  var bookATable = _ref.bookATable,
      facilities = _ref.facilities,
      onFacilityClick = _ref.onFacilityClick,
      onTabClick = _ref.onTabClick,
      openingHours = _ref.openingHours;
  var items = facilities.map(function (item) {
    return {
      header: {
        color: colors["a" /* COLORS */].BLACK,
        title: item.label
      },
      content: FacilitiesHours_jsx(FacilityHours_FacilityHours, {
        buttonLabel: bookATable,
        facility: item,
        key: item.id,
        onClick: onFacilityClick,
        openingHoursLabel: openingHours
      })
    };
  });
  return FacilitiesHours_jsx(Tabs["a" /* Tabs */], {
    id: "product-facilities-line-tabs",
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    onTabClick: onTabClick,
    scrollBackwardLabel: Object(i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(i18n["h" /* t */])('common.scrollForward')
  });
};

/***/ }),

/***/ "HKmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StreetView; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UlIv");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;




var GoogleMapReact = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 3).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var addStreetView = function addStreetView(_ref) {
  var hideFloorControls = _ref.hideFloorControls,
      map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      pov = _ref.pov,
      ref = _ref.ref;
  var panorama = new maps.StreetViewPanorama(ref, {
    addressControl: true,
    addressControlOptions: {
      position: maps.ControlPosition.TOP_LEFT
    },
    disableDefaultUI: hideFloorControls,
    fullscreenControl: false,
    position: position,
    pov: pov,
    linksControl: true,
    panControl: true,
    zoomControl: true
  });
  map.setStreetView(panorama);
};

function StreetView(props) {
  var _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$hideFloorContr = props.hideFloorControls,
      hideFloorControls = _props$hideFloorContr === void 0 ? false : _props$hideFloorContr,
      latitude = props.latitude,
      longitude = props.longitude;

  var _map = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])();

  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  return __jsx("div", {
    className: "h-full",
    "data-testid": "StreetViewComponent",
    ref: _map
  }, __jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: _config__WEBPACK_IMPORTED_MODULE_5___default.a.get(_utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__[/* GOOGLE_API_KEY */ "c"])
    },
    defaultCenter: coordinates,
    defaultZoom: fov,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addStreetView({
        hideFloorControls: hideFloorControls,
        map: map,
        maps: maps,
        position: coordinates,
        pov: {
          heading: heading,
          pitch: 0
        },
        // same here, for now
        ref: _map.current
      });
    },
    yesIWantToUseGoogleMapApiInternals: true
  }));
}

/***/ }),

/***/ "HKx7":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("+xJO");
var definePropertyModule = __webpack_require__("87KK");
var anObject = __webpack_require__("ep/x");
var toIndexedObject = __webpack_require__("dNjr");
var objectKeys = __webpack_require__("X95k");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "HRNz":
/***/ (function(module, exports, __webpack_require__) {

var isIndex = __webpack_require__("pnw1");

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

module.exports = baseNth;


/***/ }),

/***/ "HXK1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _eventemitter = __webpack_require__("Gpi5");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkerDispatcher = function (_EventEmitter) {
  _inherits(MarkerDispatcher, _EventEmitter);

  function MarkerDispatcher(gmapInstance) {
    _classCallCheck(this, MarkerDispatcher);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.gmapInstance = gmapInstance;
    return _this;
  }

  MarkerDispatcher.prototype.getChildren = function getChildren() {
    return this.gmapInstance.props.children;
  };

  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
    return this.gmapInstance.mouse_;
  };

  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
    return this.gmapInstance.updateCounter_;
  };

  MarkerDispatcher.prototype.dispose = function dispose() {
    this.gmapInstance = null;
    this.removeAllListeners();
  };

  return MarkerDispatcher;
}(_eventemitter2.default);

exports.default = MarkerDispatcher;

/***/ }),

/***/ "HnVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TourInformation; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var TourInformation = function TourInformation(_ref) {
  var infos = _ref.infos;
  return __jsx("div", {
    className: "gap-20 grid grid-cols-1 sm:grid-cols-2"
  }, infos.map(function (_ref2) {
    var items = _ref2.items,
        text = _ref2.text,
        title = _ref2.title;
    return __jsx("div", {
      key: title
    }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_3__[/* Title */ "a"], {
      className: "mb-10",
      theme: "title-brand-n2"
    }, title), items && __jsx("ul", {
      className: "leading-normal text-14 text-black"
    }, items.map(function (item) {
      return __jsx("li", {
        className: "list-disc py-5",
        key: item
      }, item);
    })), text && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
      text: text
    }));
  }));
};

/***/ }),

/***/ "HnW7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "Hz96":
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__("HRNz"),
    toInteger = __webpack_require__("m2YG");

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
}

module.exports = nth;


/***/ }),

/***/ "I+bD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductCatering; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("EkOT");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _frameworks_card_Card_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("syQ6");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_card_Card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("786X");
/* harmony import */ var _frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3+yQ");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;







var ProductCatering = function ProductCatering(_ref) {
  var _ref$intros = _ref.intros,
      intros = _ref$intros === void 0 ? [] : _ref$intros,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_5__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMicePage = _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__["b2cPagesService"].isMicePage(pageType);
  var hasIntros = !!intros.length;
  var hasList = !!list.length;

  if (!hasIntros && !hasList) {
    return null;
  }

  return __jsx("div", {
    className: "pb-30",
    "data-testid": "ProductCatering"
  }, hasIntros && __jsx("div", {
    className: "flex"
  }, intros.map(function (_ref2) {
    var description = _ref2.description,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return __jsx(_frameworks_card_Card__WEBPACK_IMPORTED_MODULE_9__[/* Card */ "a"], {
      className: "w-full md:w-1/2",
      key: title,
      heading: {
        title: title
      },
      text: {
        text: description
      }
    });
  })), hasIntros && hasList && __jsx(_frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_10__[/* Hr */ "a"], {
    className: "my-20"
  }), hasList && list.map(function (_ref3, index) {
    var description = _ref3.description,
        seminarDescription = _ref3.seminarDescription,
        _ref3$image = _ref3.image,
        image = _ref3$image === void 0 ? '' : _ref3$image,
        _ref3$name = _ref3.name,
        name = _ref3$name === void 0 ? '' : _ref3$name;
    var descriptionToUse = isMicePage ? seminarDescription : description;
    return (descriptionToUse || name) && __jsx(react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], {
      key: name
    }, index > 0 && __jsx(_frameworks_hr_Hr__WEBPACK_IMPORTED_MODULE_10__[/* Hr */ "a"], {
      className: "my-20"
    }), __jsx(_frameworks_card_Card__WEBPACK_IMPORTED_MODULE_9__[/* Card */ "a"], {
      heading: {
        title: name
      },
      layout: _frameworks_card_Card_constants__WEBPACK_IMPORTED_MODULE_7__[/* INLINE_1 */ "d"],
      media: {
        url: image,
        ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_8__[/* default */ "c"].M
      },
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      text: {
        text: descriptionToUse
      }
    }));
  }));
};

/***/ }),

/***/ "I2c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("dNjr");
var addToUnscopables = __webpack_require__("3K/D");
var Iterators = __webpack_require__("oa0l");
var InternalStateModule = __webpack_require__("9jKB");
var defineProperty = __webpack_require__("87KK").f;
var defineIterator = __webpack_require__("6WRp");
var createIterResultObject = __webpack_require__("b86L");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "I7/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutoScrollToError; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RUiN");

 // scroll to error after a submit and a validation

var useAutoScrollToError = function useAutoScrollToError(formik) {
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var isSubmitting = formik.isSubmitting,
        isValidating = formik.isValidating,
        isValid = formik.isValid;
    var formikErrored = '.formik-errored';

    if (isSubmitting && !isValidating && !isValid) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__[/* scrollToElement */ "a"])(formikErrored);
      var firstErroredElement = document.querySelector(formikErrored);
      firstErroredElement && firstErroredElement.focus();
    }
  });
};

/***/ }),

/***/ "IGGJ":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "IYAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var isForced = __webpack_require__("wxLG");
var defineBuiltIn = __webpack_require__("Swp0");
var InternalMetadataModule = __webpack_require__("wKkN");
var iterate = __webpack_require__("ZuH9");
var anInstance = __webpack_require__("V/va");
var isCallable = __webpack_require__("ANQd");
var isNullOrUndefined = __webpack_require__("nnO8");
var isObject = __webpack_require__("1YFU");
var fails = __webpack_require__("fhLv");
var checkCorrectnessOfIteration = __webpack_require__("AZSF");
var setToStringTag = __webpack_require__("CGO5");
var inheritIfRequired = __webpack_require__("XmKO");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "IrNZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = detectBrowser;
// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
var detectBrowserResult_ = null;

function detectBrowser() {
  if (detectBrowserResult_) {
    return detectBrowserResult_;
  }

  if (typeof navigator !== 'undefined') {
    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    var isSafari = navigator.userAgent.indexOf('Safari') > -1;

    if (isChrome && isSafari) {
      isSafari = false;
    }

    if (isChrome && isOpera) {
      isChrome = false;
    }

    detectBrowserResult_ = {
      isExplorer: isExplorer,
      isFirefox: isFirefox,
      isOpera: isOpera,
      isChrome: isChrome,
      isSafari: isSafari
    };
    return detectBrowserResult_;
  }

  detectBrowserResult_ = {
    isChrome: true,
    isExplorer: false,
    isFirefox: false,
    isOpera: false,
    isSafari: false
  };

  return detectBrowserResult_;
}

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ INSTALMENT_LOCALES; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js

var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        hasInitialPriceDisplayed = _ref.hasInitialPriceDisplayed;
    return {
      thRoot: 'flex flex-wrap gap-x-10 isolate items-baseline relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: Object(classnames_utils["a" /* classnames */])('text-12 first-letter:uppercase', {
        'absolute top-0': hasInitialPriceDisplayed
      }),
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-32',
      thUnit: 'text-12'
    };
  },
  column: function column(_ref2) {
    var color = _ref2.color;
    return {
      thRoot: 'flex flex-col isolate leading-tight relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-20 sm:text-28 w-full',
      thUnit: 'text-12'
    };
  },
  inline: function inline(_ref3) {
    var color = _ref3.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline shrink-0',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold shrink-0 text-20 underline',
      thUnit: 'text-10 sm:text-12'
    };
  },
  inlineSmall: function inlineSmall(_ref4) {
    var color = _ref4.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-14 sm:text-20',
      thUnit: 'text-10 sm:text-12'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx


var __jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      _ref$hasDiscount = _ref.hasDiscount,
      hasDiscount = _ref$hasDiscount === void 0 ? false : _ref$hasDiscount,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? false : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      hasTaxesAndFeesIncludedLabel = _ref.hasTaxesAndFeesIncludedLabel,
      _ref$hasTotalPrice = _ref.hasTotalPrice,
      hasTotalPrice = _ref$hasTotalPrice === void 0 ? false : _ref$hasTotalPrice,
      initialPrice = _ref.initialPrice,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      unit = _ref.unit,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasDiscount", "hasInitialPrice", "hasInstalment", "hasTaxesAndFeesIncludedLabel", "hasTotalPrice", "initialPrice", "theme", "unit"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var initialPriceFormattedValue = hasInstalment && initialPrice ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
    precision: 0
  }) : initialPrice && initialPrice.formattedValue;
  var totalBestPrice = bestPrice && bestPrice.formattedValue;
  var bestPriceFormattedValue = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : totalBestPrice;
  var hasInitialPriceDisplayed = hasInitialPrice && initialPriceFormattedValue && (hasDiscount || !bestPrice);
  var hasTotalPriceDisplayed = hasTotalPrice && hasInstalment && bestPriceFormattedValue !== totalBestPrice;

  var _themes$theme = themes[theme]({
    color: color,
    hasInitialPriceDisplayed: hasInitialPriceDisplayed
  }),
      thBestPrice = _themes$theme.thBestPrice,
      thFirstLine = _themes$theme.thFirstLine,
      thFrom = _themes$theme.thFrom,
      thInitialPrice = _themes$theme.thInitialPrice,
      thRoot = _themes$theme.thRoot,
      thTotalPrice = _themes$theme.thTotalPrice,
      thUnit = _themes$theme.thUnit;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), (hasInitialPriceDisplayed || hasTotalPriceDisplayed || from) && __jsx("span", {
    className: thFirstLine
  }, from && __jsx("span", {
    className: thFrom
  }, from), hasInitialPriceDisplayed && __jsx("span", {
    className: thInitialPrice,
    "data-testid": "PriceItem-value"
  }, initialPriceFormattedValue), hasTotalPriceDisplayed && __jsx("span", {
    className: thTotalPrice,
    "data-testid": "PriceItem-value"
  }, totalBestPrice)), bestPriceFormattedValue && __jsx("span", {
    className: thBestPrice,
    "data-testid": "PriceItem-value"
  }, bestPriceFormattedValue), unit && __jsx("div", {
    className: thUnit
  }, hasTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) ? null : unit, hasAsterisk && __jsx("sup", null, "*"), hasTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) && __jsx("div", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel'))));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "default": {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx


var PriceViewRate_jsx = react_default.a.createElement;





var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var className = _ref.className,
      label = _ref.label,
      theme = _ref.theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "theme"]);

  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), label);
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/prices/Prices.jsx


var Prices_jsx = react_default.a.createElement;






var Prices_PriceLoader = function PriceLoader(_ref) {
  var className = _ref.className;
  return Prices_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('block w-[2em] pr-30 text-32 after:animate-loadingDots after:content-["."]', className),
    "data-testid": "Price-loader"
  });
};

var Prices_Prices = function Prices(_ref2) {
  var bestPrice = _ref2.bestPrice,
      className = _ref2.className,
      color = _ref2.color,
      from = _ref2.from,
      hasAsterisk = _ref2.hasAsterisk,
      hasInitialPrice = _ref2.hasInitialPrice,
      hasInstalment = _ref2.hasInstalment,
      hasTaxesAndFeesIncludedLabel = _ref2.hasTaxesAndFeesIncludedLabel,
      hasTotalPrice = _ref2.hasTotalPrice,
      initialPrice = _ref2.initialPrice,
      isLoading = _ref2.isLoading,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      unit = _ref2.unit,
      viewRates = _ref2.viewRates,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasInitialPrice", "hasInstalment", "hasTaxesAndFeesIncludedLabel", "hasTotalPrice", "initialPrice", "isLoading", "theme", "unit", "viewRates"]);

  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (isLoading) {
    return Prices_jsx(Prices_PriceLoader, {
      className: className
    });
  }

  if (!displayPrice && !viewRates) {
    return null;
  }

  if (!displayPrice) {
    return Prices_jsx(PriceViewRate_PriceViewRate, Object(esm_extends["a" /* default */])({}, rest, {
      className: className,
      label: viewRates,
      theme: theme
    }));
  }

  return Prices_jsx(PriceDiscount_PriceDiscount, Object(esm_extends["a" /* default */])({}, rest, {
    bestPrice: bestPrice,
    className: className,
    color: color,
    from: from,
    hasAsterisk: hasAsterisk,
    hasDiscount: Object(price_util["e" /* hasDiscount */])({
      bestPrice: bestPrice,
      initialPrice: initialPrice
    }),
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    hasTaxesAndFeesIncludedLabel: hasTaxesAndFeesIncludedLabel,
    hasTotalPrice: hasTotalPrice,
    initialPrice: initialPrice,
    unit: unit,
    theme: theme
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx


var Price_jsx = react_default.a.createElement;



var INSTALMENT_LOCALES = ['pt-BR', 'es-AR'];
var Price_Price = function Price(_ref) {
  var isOnLastPage = _ref.isOnLastPage,
      displayInstalment = _ref.displayInstalment,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["isOnLastPage", "displayInstalment"]);

  return Price_jsx(Prices_Prices, Object(esm_extends["a" /* default */])({}, props, {
    hasInstalment: displayInstalment,
    unit: displayInstalment ? Object(i18n["h" /* t */])('common.price.instalmentWithFees') : props.unit
  }));
};

/***/ }),

/***/ "Iz3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinkTagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLinkProps; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("i5Mr");










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var getLinkTagName = function getLinkTagName(link) {
  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(link)) {
    return 'div';
  }

  return link.url ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"] : 'button';
};
var getLinkProps = function getLinkProps(link) {
  return (link === null || link === void 0 ? void 0 : link.url) ? _objectSpread({}, link) : _objectSpread(_objectSpread({}, link), {}, {
    type: 'button'
  });
};

/***/ }),

/***/ "J+Il":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}

/***/ }),

/***/ "JFtY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("oNVP");
var imageExtensions = __webpack_require__("y147");
var exts = Object.create(null);

imageExtensions.forEach(function (el) {
	exts[el] = true;
});

module.exports = function (filepath) {
	return path.extname(filepath).slice(1).toLowerCase() in exts;
};


/***/ }),

/***/ "JOeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOAST_DURATION; });
/* unused harmony export getAdditionalServiceFromUpsellId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSmallerPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mapActivitiesCategoriesWithAdditionnalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mapRentalsWithAdditionnalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAttendeesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updatePriceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return excludePaidSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatServiceToUpdateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return servicesWithSchedulePricingInfoQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return childcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return transfersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return whiteLabelServicesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return insuranceQuery; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("+DnP");
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_filter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("mbB6");
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_partial__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("naLQ");
/* harmony import */ var lodash_partial__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_partial__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_flow__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("jPI1");
/* harmony import */ var lodash_flow__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_flow__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_curry__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("kUU+");
/* harmony import */ var lodash_curry__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(lodash_curry__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var lodash_add__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("/yCi");
/* harmony import */ var lodash_add__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(lodash_add__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("lKOy");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(lodash_difference__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("1xil");
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(lodash_flatten__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("0iyY");
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(lodash_values__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("Rj53");
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__);





























function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/* eslint-disable no-shadow */







var AGE_OF_MAJORITY = 18;

var isAdult = function isAdult(birthday) {
  return !moment__WEBPACK_IMPORTED_MODULE_28___default()(birthday, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_29__[/* API_DATE_FORMAT */ "a"]).isAfter(moment__WEBPACK_IMPORTED_MODULE_28___default()().startOf('day').subtract(AGE_OF_MAJORITY, 'years'));
};

var TOAST_DURATION = 4000;
var getAdditionalServiceFromUpsellId = function getAdditionalServiceFromUpsellId(id) {
  var availableUpsellsUpdatedWithCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return availableUpsellsUpdatedWithCart.find(function (a) {
    return a.pricingInfo.id === id;
  }) || null;
};
function getSmallerPrice(prev, next) {
  if (!(prev === null || prev === void 0 ? void 0 : prev.value)) {
    return next;
  }

  if (next === null || next === void 0 ? void 0 : next.value) {
    return next.value < prev.value ? next : prev;
  }
}

var mergeActivitiesCategoriesWithAdditionnalServices = function mergeActivitiesCategoriesWithAdditionnalServices(cat, availableActivities, options) {
  var _cat$categories, _cat$activities;

  if ((_cat$categories = cat.categories) === null || _cat$categories === void 0 ? void 0 : _cat$categories.length) {
    var _category$categories, _category$categories2;

    var category = _objectSpread(_objectSpread({}, cat), {}, {
      categories: cat.categories.map(function (subcat) {
        return mergeActivitiesCategoriesWithAdditionnalServices(subcat, availableActivities, options);
      }).filter(function (subcat) {
        var _subcat$categories, _subcat$activities;

        return !!((_subcat$categories = subcat.categories) === null || _subcat$categories === void 0 ? void 0 : _subcat$categories.length) || !!((_subcat$activities = subcat.activities) === null || _subcat$activities === void 0 ? void 0 : _subcat$activities.length);
      })
    });

    return _objectSpread(_objectSpread({}, category), {}, {
      bestPrice: (_category$categories = category.categories) === null || _category$categories === void 0 ? void 0 : _category$categories.reduce(function (acc, _ref) {
        var bestPrice = _ref.bestPrice;
        return getSmallerPrice(acc, bestPrice);
      }, null),
      onlineBookableCount: (_category$categories2 = category.categories) === null || _category$categories2 === void 0 ? void 0 : _category$categories2.reduce(function (acc, _ref2) {
        var onlineBookableCount = _ref2.onlineBookableCount;
        return acc + onlineBookableCount;
      }, 0)
    });
  }

  if ((_cat$activities = cat.activities) === null || _cat$activities === void 0 ? void 0 : _cat$activities.length) {
    var mergedActivities = (cat.activities || []).map(function (a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        additionalService: getAdditionalServiceFromUpsellId(a.id, availableActivities)
      });
    }) // filter depending on additionalService (nullable)
    // then merge activities received from resort and the result of '/additional_services'
    .filter(function (a) {
      return (options === null || options === void 0 ? void 0 : options.filtered) ? !!a.additionalService : true;
    }) // and display online bookable activities first
    .sort(function (activity1, activity2) {
      return Number(!!activity2.additionalService) - Number(!!activity1.additionalService);
    });
    var onlineBookableActivities = mergedActivities.filter(function (_ref3) {
      var additionalService = _ref3.additionalService;
      return !!additionalService;
    });
    var mergedActivitiesWithPrice = onlineBookableActivities.filter(function (_ref4) {
      var _additionalService$pr, _additionalService$pr2, _additionalService$pr3;

      var additionalService = _ref4.additionalService;
      return Boolean(additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr = additionalService.pricingInfo) === null || _additionalService$pr === void 0 ? void 0 : _additionalService$pr.startingPricePerAdult) && typeof (additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr2 = additionalService.pricingInfo) === null || _additionalService$pr2 === void 0 ? void 0 : (_additionalService$pr3 = _additionalService$pr2.startingPricePerAdult) === null || _additionalService$pr3 === void 0 ? void 0 : _additionalService$pr3.value) === 'number';
    });
    return _objectSpread(_objectSpread({}, cat), {}, {
      activities: mergedActivities,
      bestPrice: mergedActivitiesWithPrice.length ? mergedActivitiesWithPrice.reduce(function (acc, _ref5) {
        var _additionalService$pr4;

        var additionalService = _ref5.additionalService;
        return getSmallerPrice(acc, additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr4 = additionalService.pricingInfo) === null || _additionalService$pr4 === void 0 ? void 0 : _additionalService$pr4.startingPricePerAdult);
      }, null) : null,
      onlineBookableCount: onlineBookableActivities.length
    });
  }

  return cat;
};

var mapActivitiesCategoriesWithAdditionnalServices = function mapActivitiesCategoriesWithAdditionnalServices(categories, availableActivities, options) {
  return (categories || []).map(function (category) {
    return mergeActivitiesCategoriesWithAdditionnalServices(category, availableActivities, options);
  });
};
var mapRentalsWithAdditionnalServices = function mapRentalsWithAdditionnalServices(rentals, availableRentals, options) {
  return rentals.map(function (useCase) {
    return _objectSpread(_objectSpread({}, useCase), {}, {
      items: useCase.items.map(function (type) {
        return _objectSpread(_objectSpread({}, type), {}, {
          items: type.items.map(function (rental) {
            return _objectSpread(_objectSpread({}, rental), {}, {
              additionalService: getAdditionalServiceFromUpsellId(rental.id, availableRentals)
            });
          }).filter(function (r) {
            return (options === null || options === void 0 ? void 0 : options.filtered) ? r.additionalService : true;
          })
        });
      }).filter(function (uc) {
        return !!uc.items.length;
      })
    });
  });
};
var getAttendeesFromCart = function getAttendeesFromCart(cart) {
  return ((cart === null || cart === void 0 ? void 0 : cart.attendees) || []).map(function (_ref6) {
    var birthday = _ref6.birthday,
        firstname = _ref6.firstname,
        id = _ref6.id,
        lastname = _ref6.lastname,
        unicodeFirstname = _ref6.unicodeFirstname,
        unicodeLastname = _ref6.unicodeLastname;
    return {
      birthdate: birthday,
      firstName: firstname,
      id: id,
      lastName: lastname,
      unicodeFirstName: unicodeFirstname,
      unicodeLastName: unicodeLastname
    };
  });
};

var updatePrice = function updatePrice(obj, price, currency, locale) {
  var value = obj.value + price;
  return _objectSpread(_objectSpread({}, obj), {}, {
    value: value,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__[/* formatAmount */ "a"])(value, currency, locale)
  });
};

var compose2 = function compose2(g, f) {
  return function (x) {
    return g(f(x));
  };
};

var deepClone = compose2(JSON.parse, JSON.stringify); // The updatePriceInfo function updates the pricingInfo of one activity get from the activity tree
// and the booking cart in order to give the GM a correct feedback of what he can or has, already or not rented
// The activity tree containes all the activities that can be ranted online, ordered and classed by categories.
// It's build from the v0/additional_services API endpoint by the graphql server. The goal of the data
// transformations made by the graphql endpoint is to deliver to the front, for each activity, a data structure
// that fits well into the ReservationBlock UI form.

var updatePriceInfo = function updatePriceInfo(pInfo, cActivities, locale) {
  if (!pInfo || !cActivities) {
    return pInfo;
  } // pricingInfo should be unmutable since updatePriceInfo could be called multiple times


  var pricingInfo = deepClone(pInfo);
  var cartActivities = deepClone(cActivities); // we explode the cart structure to update easyly the pricingInfo
  // we use implepmented the unwind function of the mongodb aggregate framework
  // In that example, unwinding on 'size' turns
  // { id: 1, item: 'ABC1', sizes: [ 'S', 'M', 'L'] }
  // into
  // [
  //   { id : 1, item : ABC1, sizes : 'S' }
  //   { id : 1, item : ABC1, sizes : 'M' }
  //   { id : 1, item : ABC1, sizes : 'L' }
  // ]

  var cardRawTable = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(cartActivities, 'schedules'), 'schedules.attendees').map(function (_ref7) {
    var id = _ref7.id,
        schedules = _ref7.schedules,
        others = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref7, ["id", "schedules"]);

    var startDate = schedules.startDate,
        endDate = schedules.endDate;
    var _schedules$attendees = schedules.attendees,
        attendeeId = _schedules$attendees.id,
        price = _schedules$attendees.price;
    return _objectSpread(_objectSpread({}, others), {}, {
      attendeeId: attendeeId,
      price: price,
      startDate: startDate,
      endDate: endDate,
      slotId: id
    });
  }); // we update the pricingInfo with the content of the cart

  pricingInfo.attendees.forEach(function (attendee) {
    attendee.schedules.forEach(function (schedule) {
      schedule.timeSlots && schedule.timeSlots.forEach(function (slot) {
        var foundSlot = lodash_find__WEBPACK_IMPORTED_MODULE_27___default()(cardRawTable, function (cardEntry) {
          return cardEntry.attendeeId === attendee.id && cardEntry.startDate === schedule.startDate && cardEntry.endDate === schedule.endDate && cardEntry.slotId === slot.id;
        });

        var isRented = !!foundSlot;
        slot.isRented = isRented;

        if (isRented) {
          pricingInfo.isPartiallyRented = true;
          schedule.isPartiallyRented = true;
          attendee.rentedAmount = updatePrice(attendee.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
          schedule.rentedAmount = updatePrice(schedule.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
          pricingInfo.rentedAmount = updatePrice(pricingInfo.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
        }
      });

      if (schedule.timeSlots && schedule.timeSlots.every(function (_ref8) {
        var isRented = _ref8.isRented;
        return isRented;
      })) {
        schedule.isFullyRented = true;
      }
    });
    pricingInfo.isFullyRented = pricingInfo.attendees.every(function (attendee) {
      return attendee.schedules.every(function (_ref9) {
        var isFullyRented = _ref9.isFullyRented;
        return isFullyRented;
      });
    });
  });
  return pricingInfo;
};

var filterAvailableServices = function filterAvailableServices(_ref10) {
  var availableActivities = _ref10.availableActivities,
      availableRentals = _ref10.availableRentals,
      paymentStatus = _ref10.paymentStatus;
  return availableActivities.concat(availableRentals).filter(function (activity) {
    return paymentStatus === 'isPaid' ? activity.pricingInfo.isPartiallyPaid || activity.pricingInfo.isFullyPaid : activity.pricingInfo.isPartiallyRented || activity.pricingInfo.isFullyRented;
  });
};

var gatherPrimaryKeys = function gatherPrimaryKeys(_ref11) {
  var pricingInfo = _ref11.pricingInfo,
      productInfo = _ref11.productInfo;

  var attendees = pricingInfo.attendees,
      drop = pricingInfo.schedules,
      othersP = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(pricingInfo, ["attendees", "schedules"]);

  var id = attendees.id,
      schedules = attendees.schedules,
      othersA = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(attendees, ["id", "schedules"]);

  var startDate = schedules.startDate,
      endDate = schedules.endDate,
      timeSlot = schedules.timeSlots,
      othersS = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(schedules, ["startDate", "endDate", "timeSlots"]);

  return {
    attendeeId: attendees.id,
    startDate: startDate,
    endDate: endDate,
    slotId: timeSlot.id,
    attendee: _objectSpread({
      id: id
    }, othersA),
    schedule: _objectSpread({
      startDate: startDate,
      endDate: endDate
    }, othersS),
    timeSlot: timeSlot,
    pricingInfo: _objectSpread({}, othersP),
    productInfo: productInfo
  };
};

var explodeToJoinTable = lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees.schedules'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees.schedules.timeSlots'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_map__WEBPACK_IMPORTED_MODULE_18___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, gatherPrimaryKeys));

var reaggragateRentedServicesOverJoinTable = function reaggragateRentedServicesOverJoinTable(pricingInfoJoinTable, locale, attendee, paymentStatus) {
  return lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(pricingInfoJoinTable, 'pricingInfo.id')).map(function (rentedService) {
    var services = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(rentedService, 'slotId')).filter(function (entries) {
      return entries.some(function (entry) {
        return entry.attendeeId === attendee.id && entry.timeSlot[paymentStatus];
      });
    }).map(function (entries) {
      var rentedAmountValue = entries.map(function (_ref12) {
        var timeSlot = _ref12.timeSlot;
        return timeSlot;
      }).filter(function (timeSlot) {
        return timeSlot[paymentStatus];
      }).map(function (_ref13) {
        var price = _ref13.price;
        return price.value;
      }).reduce(lodash_add__WEBPACK_IMPORTED_MODULE_22___default.a, 0);
      return {
        pricingInfo: {
          id: entries[0].slotId,
          productId: entries[0].pricingInfo.id,
          timeSlot: entries[0].timeSlot.slotName,
          type: entries[0].pricingInfo.type,
          rentedAmount: {
            value: rentedAmountValue,
            formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__[/* formatAmount */ "a"])(rentedAmountValue, entries[0].pricingInfo.currency, locale),
            currency: entries[0].pricingInfo.currency
          },
          startingPricePerAdult: entries[0].pricingInfo.startingPricePerAdult,
          isPartiallyRented: true,
          isPartiallyPaid: entries.map(function (_ref14) {
            var timeSlot = _ref14.timeSlot;
            return timeSlot;
          }).filter(function (_ref15) {
            var isPaid = _ref15.isPaid;
            return isPaid;
          }).length > 0,
          isFullyPaid: entries.map(function (_ref16) {
            var timeSlot = _ref16.timeSlot;
            return timeSlot;
          }).filter(function (_ref17) {
            var isPaid = _ref17.isPaid;
            return isPaid;
          }).length === entries.length,
          schedules: lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(entries, 'startDate')).map(function (entries) {
            return {
              startDate: entries[0].startDate,
              endDate: entries[0].endDate,
              attendees: entries.map(function (entry) {
                return _objectSpread(_objectSpread({}, entry.timeSlot), {}, {
                  id: entry.attendeeId
                });
              })
            };
          })
        },
        productInfo: entries[0].productInfo
      };
    });

    return {
      price: lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default()(lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default()(services.map(function (service) {
        return service.pricingInfo.schedules;
      })).map(function (_ref18) {
        var attendees = _ref18.attendees;
        return attendees;
      })).filter(function (entry) {
        return entry.id === attendee.id && entry[paymentStatus];
      }).map(function (_ref19) {
        var price = _ref19.price;
        return price.value;
      }).reduce(lodash_add__WEBPACK_IMPORTED_MODULE_22___default.a, 0),
      services: services
    };
  });
}; // In order to send to the CartComponent the data turned into the right format, we have to reverse
// the strcuture of it. We do this by exploding it and reaggregating over it. It'as a generic way to
// make that kind of transformation.


var transformToCardFormat = function transformToCardFormat(_ref20) {
  var attendees = _ref20.attendees,
      locale = _ref20.locale,
      paymentStatus = _ref20.paymentStatus,
      availableActivities = _ref20.availableActivities,
      availableRentals = _ref20.availableRentals;
  return lodash_map__WEBPACK_IMPORTED_MODULE_18___default()(attendees, function (attendee, index) {
    var id = attendee.id,
        firstname = attendee.firstname,
        lastname = attendee.lastname,
        unicodeLastname = attendee.unicodeLastname,
        unicodeFirstname = attendee.unicodeFirstname,
        birthday = attendee.birthday;
    return {
      id: id,
      firstName: firstname,
      lastName: lastname,
      unicodeLastName: unicodeLastname,
      unicodeFirstName: unicodeFirstname,
      isAdult: isAdult(birthday),
      index: index + 1,
      rentedServices: lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(filterAvailableServices, explodeToJoinTable, lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(reaggragateRentedServicesOverJoinTable), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, locale, attendee, paymentStatus))({
        availableActivities: availableActivities,
        availableRentals: availableRentals,
        paymentStatus: paymentStatus
      })
    };
  });
};

var keepOnlyAttendeesWithRentedServices = function keepOnlyAttendeesWithRentedServices(attendee) {
  return attendee.rentedServices.some(function (_ref21) {
    var services = _ref21.services;
    return services.length > 0;
  });
};

var cleanRentedServices = function cleanRentedServices(attendee) {
  return _objectSpread(_objectSpread({}, attendee), {}, {
    rentedServices: attendee.rentedServices.filter(function (_ref22) {
      var services = _ref22.services;
      return services.length > 0;
    })
  });
}; // The BIG function that make the structure upside down. Turns pricingInfo strcture to the Cart one.


var getReservedServicesByAttendee = function getReservedServicesByAttendee(_ref23) {
  var attendees = _ref23.attendees,
      _ref23$availableActiv = _ref23.availableActivities,
      availableActivities = _ref23$availableActiv === void 0 ? [] : _ref23$availableActiv,
      _ref23$availableRenta = _ref23.availableRentals,
      availableRentals = _ref23$availableRenta === void 0 ? [] : _ref23$availableRenta,
      locale = _ref23.locale,
      paymentStatus = _ref23.paymentStatus;
  return lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(transformToCardFormat, lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_filter__WEBPACK_IMPORTED_MODULE_17___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, keepOnlyAttendeesWithRentedServices), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_map__WEBPACK_IMPORTED_MODULE_18___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, cleanRentedServices))({
    attendees: attendees,
    locale: locale,
    paymentStatus: paymentStatus,
    availableActivities: deepClone(availableActivities),
    availableRentals: deepClone(availableRentals)
  });
};
var excludePaidSlots = function excludePaidSlots(updatedService, activities) {
  return updatedService.map(function (attendee) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      schedules: attendee.schedules.map(function (schedule) {
        return _objectSpread(_objectSpread({}, schedule), {}, {
          slots: schedule.slots.filter(function (slotId) {
            return !activities.find(function (activity) {
              return activity.pricingInfo.id === attendee.productInfoId;
            }).pricingInfo.attendees.find(function (att) {
              return att.id === attendee.customerId;
            }).schedules.find(function (sched) {
              return sched.startDate === schedule.startDate && sched.endDate === schedule.endDate;
            }).timeSlots.find(function (slot) {
              return slot.id === slotId;
            }).isPaid;
          })
        });
      }).filter(function (schedule) {
        return schedule.slots.length !== 0;
      })
    });
  }).filter(function (attendee) {
    return attendee.schedules.length !== 0;
  });
}; // The same technic is used here to reverse the strcture shape: explode (unwind) and reaggregate (groupBy)
// This transformation resolves to the POST /v0/customers/{customer_id}/bookings/{booking_id}/cart/services payload format

var formatServiceToUpdateBookingCart = function formatServiceToUpdateBookingCart(_ref24) {
  var appContext = _ref24.appContext,
      bookingId = _ref24.bookingId,
      serviceIds = _ref24.serviceIds,
      type = _ref24.type,
      updatedService = _ref24.updatedService,
      stayIndex = _ref24.stayIndex;
  var table = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(updatedService, 'schedules');
  table = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(table, 'schedules.slots');
  table = table.map(function (_ref25) {
    var attendeeId = _ref25.customerId,
        schedules = _ref25.schedules,
        productInfoId = _ref25.productInfoId;
    var slots = schedules.slots,
        startDate = schedules.startDate,
        endDate = schedules.endDate;
    return {
      attendeeId: attendeeId,
      productInfoId: productInfoId,
      startDate: startDate,
      endDate: endDate,
      slotId: slots
    };
  });

  var card = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(table, 'slotId')).map(function (entries) {
    var schedules = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(entries, 'startDate')).map(function (entries) {
      return {
        start_date: entries[0].startDate,
        end_date: entries[0].endDate,
        attendees: entries.map(function (entry) {
          return {
            id: entry.attendeeId
          };
        })
      };
    });

    return {
      id: entries[0].slotId,
      action: 'update',
      context: appContext,
      bookingId: bookingId,
      serviceName: type,
      schedules: schedules,
      stayIndex: stayIndex
    };
  });

  var diff = lodash_difference__WEBPACK_IMPORTED_MODULE_23___default()(serviceIds, card.map(function (_ref26) {
    var id = _ref26.id;
    return id;
  }));

  if (diff.length) {
    diff.forEach(function (id) {
      card.push({
        id: id,
        action: 'remove',
        context: appContext,
        bookingId: bookingId,
        serviceName: type,
        schedules: [],
        stayIndex: stayIndex
      });
    });
  }

  return card;
};
var servicesWithSchedulePricingInfoQuery = "\npricingInfo {\n        id\n        ids\n        progId\n        childId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isFullyPaid\n        isPartiallyRented\n        isPartiallyPaid\n        attendees {\n          id\n          rentedAmount {...priceDetails}\n          price {\n            currency\n            discount\n            discountUnit\n            formattedInitialValue\n            formattedValue(precision:0)\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
var childcaresQuery = "\nchildcares {\n  ".concat(servicesWithSchedulePricingInfoQuery, "\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    openingHours {\n      start\n      end\n    }\n    timeSlots {\n      type\n      opening\n      closing\n    }\n    closingWeekdays\n  }\n}");
var transfersQuery = function transfersQuery(appContext) {
  return "\n      transfers {\n        pricingInfo {\n          id\n          ids\n          isFullyPaid\n          isFullyRented\n          isIncluded\n          isPartiallyPaid\n          isPartiallyRented\n          price: startingPricePerAdult {\n            ...priceDetails\n            formattedValueRounded : formattedValue(precision : 0)\n          }\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          rentedAmount {\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            remainingStock\n            attendees {\n              id\n            }\n          }\n          type\n        }\n        productInfo {\n          accessId\n          description\n          durationInMinutes\n          id\n          label\n          vehicle {\n            id\n            label\n          }\n          waitingInMinutes\n        }\n      }\n      ");
};
var whiteLabelServicesQuery = function whiteLabelServicesQuery(appContext) {
  return "whiteLabelServices {\n        pricingInfo {\n          id\n          ids\n          type\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          startingPricePerAdult {\n            value\n            formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            remainingStock\n            isPartiallyPaid\n            isFullyPaid\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          image\n          type\n          title\n          description\n        }\n      }\n      ");
};
var insuranceQuery = function insuranceQuery(appContext) {
  return "insurance {\n        pricingInfo {\n          id\n          type\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          label\n          shortDescription\n          insuranceDetails {\n            id\n            label\n            images\n            description\n            shortDescription\n            videos\n            attachedDocuments {\n              label\n              url\n            }\n            company {\n              label\n              logo\n            }\n            coverageDescriptions\n            subscriptionConditions {\n              age_min\n              ageMax\n              byAttendees\n            }\n          }\n        }\n      }");
};

/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");


/* eslint-disable react/require-default-props */





var AutoFocusInside = function AutoFocusInside(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JSB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BookingEngineForm_container_mapStateToProps; });

// UNUSED EXPORTS: mapDispatchToProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.action.js
var tripDateCriteria_action = __webpack_require__("6wD6");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/utils/trip-information/tripInformationUtils.js
var tripInformationUtils = __webpack_require__("bMF2");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/constants.js
var BOOKING_ENGINE_FORM_SELECTOR = '#booking';
// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/constants.js
var price_remote_constants = __webpack_require__("Lc/n");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineI18n.query.js
var BookingEngineI18n_query = __webpack_require__("9LZ4");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'bg-white cursor-pointer leading-0 m-20 p-15 rounded-full text-black text-16',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-full',
    style: 'max-h-[calc(100%-100px)]',
    button: 'ltr:animate-slideInRight rtl:animate-slideInLeft animation-duration-500 bottom-0 end-0'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-full',
    style: 'max-h-[calc(100%-100px)]',
    button: 'ltr:animate-slideInRight rtl:animate-slideInLeft animation-duration-500 top-0 end-0'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-full',
    style: 'max-w-[calc(100vw-100px)]',
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-full',
    style: 'max-w-[calc(100vw-100px)]',
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx




var __jsx = react_default.a.createElement;










var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "closeLabel", "isExpanded", "onClose", "portalName", "position", "theme"]);

  var sidePanelBodyref = Object(react["useRef"])();

  var onScroll = throttle_default()(function () {
    Object(lib["forceCheck"])();
  }, 250);

  Object(react["useEffect"])(function () {
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "animation-duration-500 fixed inset-0 h-screen animate-fadeIn bg-black opacity-80",
    "data-testid": "SidePanel-backdrop"
  }), __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    "aria-hidden": !isExpanded,
    role: "dialog"
  }), __jsx("div", {
    className: "isolate",
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, positionClasses.pin, positionClasses.style, 'fixed z-1 h-full w-full transform overflow-y-scroll transition-all duration-250 ease-in', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-x-0 translate-y-0', isExpanded), _classnames), className),
    ref: sidePanelBodyref
  }, isExpanded && children))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx + 20 modules
var AlternativeProposals = __webpack_require__("YRNe");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals-modal/AlternativeProposalsModal.jsx

var AlternativeProposalsModal_jsx = react_default.a.createElement;







var AlternativeProposalsModal_AlternativeProposalsModal = function AlternativeProposalsModal(_ref) {
  var trackingDefaultPayload = _ref.trackingDefaultPayload,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["trackingDefaultPayload"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var modal = Object(react["useRef"])();
  var track = Object(useTracking["a" /* useTracking */])(trackingDefaultPayload);
  var proposal = props.proposals[0];
  Object(react["useEffect"])(function () {
    var trackingData = Object(AlternativeProposalsUtils["b" /* getSuggestionsTrackingData */])({
      appContext: appContext,
      disableAlternativePrice: props.disableAlternativePrice,
      proposal: proposal,
      suggestions: props.suggestions
    });
    track(trackingData);
  }, [proposal]);
  return AlternativeProposalsModal_jsx(SidePanel_SidePanel, {
    "aria-label": Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    isExpanded: true,
    onClose: function onClose(event) {
      if (modal.current && !modal.current.contains(event.target)) {
        props.onClose();
        track({
          labelGA: 'exit'
        });
      }
    }
  }, AlternativeProposalsModal_jsx("div", {
    ref: modal
  }, AlternativeProposalsModal_jsx(AlternativeProposals["a" /* AlternativeProposals */], props)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.action.js
var duration_action = __webpack_require__("C5R2");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/values.js
var values = __webpack_require__("0iyY");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/participantsErrors.jsx
var participantsErrors = __webpack_require__("tPlR");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/participants.validator.js
var participants_validator = __webpack_require__("PhFM");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// CONCATENATED MODULE: ./src/client/components/utils/watch-location-query-change/WatchLocationQueryChange.jsx









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var WatchLocationQueryChange_WatchLocationQueryChange = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_WatchLocationQueryChange, _Component);

  var _super = _createSuper(_WatchLocationQueryChange);

  function _WatchLocationQueryChange() {
    Object(classCallCheck["a" /* default */])(this, _WatchLocationQueryChange);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(_WatchLocationQueryChange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryKey = _this$props.queryKey,
          onChange = _this$props.onChange,
          router = _this$props.router;

      if (router.query[queryKey]) {
        onChange(router.query[queryKey]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          queryKey = _this$props2.queryKey,
          onChange = _this$props2.onChange,
          router = _this$props2.router;
      var previousPathname = new URI_default.a(prevProps.router.asPath).pathname();
      var pathname = new URI_default.a(router.asPath).pathname();

      if (prevProps.router.query[queryKey] !== router.query[queryKey] && previousPathname === pathname) {
        onChange(router.query[queryKey]);
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _WatchLocationQueryChange;
}(react["Component"]); // $FlowFixMe


var WatchLocationQueryChange = Object(next_router["withRouter"])(WatchLocationQueryChange_WatchLocationQueryChange);
// CONCATENATED MODULE: ./src/client/components/widgets/booking-step-title/BookingStepTitle.jsx
var BookingStepTitle_jsx = react_default.a.createElement;


var BookingStepTitle_BookingStepTitle = function BookingStepTitle(_ref) {
  var className = _ref.className,
      number = _ref.number,
      title = _ref.title;
  return BookingStepTitle_jsx("h3", {
    className: Object(classnames_utils["a" /* classnames */])('font-bold font-sans leading-tight text-20', className),
    "data-testid": "BookingCriteriaStep-title--".concat(number)
  }, BookingStepTitle_jsx("span", {
    className: "text-28 lg:text-22"
  }, number, "."), " ", title);
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx + 1 modules
var Participants = __webpack_require__("rFVZ");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var participants_constants = __webpack_require__("93Yv");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/ReassuranceBlock.jsx


var ReassuranceBlock_jsx = react_default.a.createElement;








var ReassuranceBlock_ReassuranceBlock = function ReassuranceBlock(_ref) {
  var _t;

  var items = _ref.items;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice',
    labelGA: 'reinsuranceTravel_readMore',
    siteSection: 'Shopping_Resort'
  });
  var reinsuranceLinkURL = Object(src_i18n["d" /* getKeyValue */])('booking.form.reinsuranceLinkURL');
  var reinsuranceLegalMentions = (_t = Object(src_i18n["h" /* t */])('booking.form.reinsuranceLegalMentions')) === null || _t === void 0 ? void 0 : _t.trim();
  var TagName = isTablet ? react["Fragment"] : SeeMore["a" /* SeeMore */];
  var seeMoreProps = isTablet ? null : {
    classNameButton: 'text-end',
    color: colors["a" /* COLORS */].LIGHT_SAND,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isTablet,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.loadMore'),
    seeMoreSize: 110
  };
  return ReassuranceBlock_jsx("aside", {
    className: "border-1 border-lightGrey font-sans p-15 rounded-12 space-y-15 text-14 text-black"
  }, ReassuranceBlock_jsx("header", null, ReassuranceBlock_jsx("h4", {
    className: "font-bold text-16"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceTitle')), ReassuranceBlock_jsx("p", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceSubtitle'))), ReassuranceBlock_jsx(TagName, seeMoreProps, !!items.length && ReassuranceBlock_jsx("ul", {
    className: "space-y-10"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return ReassuranceBlock_jsx("li", {
      className: "flex gap-5 items-center",
      key: iconName
    }, ReassuranceBlock_jsx(Icon["a" /* Icon */], {
      className: "shrink-0",
      name: iconName,
      width: "1.25rem"
    }), label);
  })), !!reinsuranceLinkURL && ReassuranceBlock_jsx(DynamicLink["a" /* default */], {
    className: "inline-block mt-15 md:mt-0 hocus:text-black-active underline",
    onClick: function onClick() {
      return track();
    },
    target: "_blank",
    url: reinsuranceLinkURL
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceLinkLabel')), !!reinsuranceLegalMentions && ReassuranceBlock_jsx("p", {
    className: "mt-15 md:mt-0"
  }, reinsuranceLegalMentions)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-criteria/TransportCriteria.jsx
var TransportCriteria = __webpack_require__("yFoA");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.jsx









var BookingCriteria_jsx = react_default.a.createElement;




























var BookingCriteria_BookingCriteriaComponent = function BookingCriteriaComponent(props) {
  var _i18n$bookingCriteria, _i18n$bookingCriteria2, _i18n$booking, _i18n$booking$form, _bookingConfig$form;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var adultOnly = props.adultOnly,
      _props$adultsNumber = props.adultsNumber,
      adultsNumber = _props$adultsNumber === void 0 ? 2 : _props$adultsNumber,
      bookingConfig = props.bookingConfig,
      _props$childAge = props.childAge,
      childAge = _props$childAge === void 0 ? 0 : _props$childAge,
      children = props.children,
      config = props.config,
      _props$departureCity = props.departureCity,
      departureCity = _props$departureCity === void 0 ? '' : _props$departureCity,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n,
      isDepartureDateAvailaible = props.isDepartureDateAvailaible,
      _props$isWinterResort = props.isWinterResort,
      isWinterResort = _props$isWinterResort === void 0 ? false : _props$isWinterResort,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      resort = props.resort;

  var _useState = Object(react["useState"])(props.departureDate),
      departureDate = _useState[0],
      setDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(props.tripDurationCriteria),
      tripDurationCriteria = _useState2[0],
      setTripDurationCriteria = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isLoading = _useState3[0];

  var _useState4 = Object(react["useState"])(false),
      hasCheckedPrice = _useState4[0],
      setHasCheckedPrice = _useState4[1];

  var departureCities = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria = i18n.bookingCriteria) === null || _i18n$bookingCriteria === void 0 ? void 0 : _i18n$bookingCriteria.departureCities.map(function (departureCityToMap) {
    return {
      value: departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.value,
      label: (departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.name) || ''
    };
  })) || [];
  var initialTransport = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria2 = i18n.bookingCriteria) === null || _i18n$bookingCriteria2 === void 0 ? void 0 : _i18n$bookingCriteria2.initialTransport) || '';
  var transportIcon = (resort === null || resort === void 0 ? void 0 : resort.transportType) || '';
  var withTransport = departureCities.some(function (_ref) {
    var value = _ref.value;
    return value !== 'NO';
  });

  if (departureDate !== props.departureDate || tripDurationCriteria !== props.tripDurationCriteria) {
    setDepartureDate(props.departureDate);
    setHasCheckedPrice(false);
    setTripDurationCriteria(props.tripDurationCriteria);
  }

  Object(react["useEffect"])(function () {
    var _kids = props.tripInformation.kids;

    if (adultOnly && (_kids === null || _kids === void 0 ? void 0 : _kids.length)) {
      props.resetKids();
    }
  }, []);

  var checkFormErrors = function checkFormErrors() {
    var dateFormat = get_default()(props, 'i18n.dateFormat', 'DD/MM/YYYY');

    var birthdays = Object(tripInformationUtils["a" /* getFormattedKidsBirthdate */])(kids, dateFormat);
    var adultAgeInYear = +get_default()(props, 'i18n.adultAge', participants_constants["b" /* DEFAULT_MAX_AGE */]);

    var _childAge = typeof childAge === 'number' ? childAge : participants_constants["d" /* DEFAULT_MIN_AGE */];

    var childAgeInYear = _childAge / 12;
    return participants_validator["a" /* default */].checkFormErrors({
      adults: adultsNumber,
      children: kids.length,
      departureDate: tripDurationCriteria ? departureDate : null,
      birthdays: birthdays,
      dateFormat: dateFormat,
      adultAge: adultAgeInYear,
      childAge: childAgeInYear,
      birthdayFormatErrorMessage: get_default()(props, 'i18n.birthdayFormatErrorMessage'),
      adultAgeErrorMessage: get_default()(props, 'i18n.adultAgeErrorMessage'),
      minAgeErrorMessage: get_default()(props, 'i18n.minAgeErrorMessage'),
      isSeller: appContext.isSeller
    });
  };

  var handleChange = function handleChange(action) {
    return function (payload) {
      setHasCheckedPrice(false); // $FlowExpectedError

      action(payload);
    };
  };

  var handleCheckPrice = function handleCheckPrice() {
    var haveError = values_default()(checkFormErrors()).some(function (error) {
      return error;
    });

    if (!haveError) {
      return props.getPackages(departureDate);
    }
  };

  var onSubmit = function onSubmit() {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      id: resort.resortId,
      be: true,
      timestamp: Date.now()
    });
    setHasCheckedPrice(!!isDepartureDateAvailaible || hasCheckedPrice);

    if (isDepartureDateAvailaible) {
      handleCheckPrice();
    }

    if (tripDurationCriteria !== null && window.pageYOffset > 0) {
      window.scrollTo(0, 0);
    }
  };

  var formErrors = checkFormErrors();
  return BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    onChange: function onChange(value) {
      return value && Object(duration_action["a" /* setDuration */])(parseInt(value, 10) || duration_constants["a" /* DEFAULT_NO_DURATION */]);
    },
    queryKey: uri_constants["h" /* QUERY_DURATION */]
  }), withTransport && BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    onChange: function onChange(value) {
      return value && Object(departureCity_action["a" /* setDepartureCity */])({
        value: value
      });
    },
    queryKey: uri_constants["m" /* QUERY_TRANSPORT */]
  }), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: 1,
    title: Object(src_i18n["h" /* t */])('booking.form.transportFrom')
  }), BookingCriteria_jsx("div", {
    className: "mb-30 gap-x-100 md:flex"
  }, BookingCriteria_jsx("div", {
    className: "mb-20 md:mb-0 md:flex-1"
  }, BookingCriteria_jsx(TransportCriteria["a" /* TransportCriteria */], {
    departureCitiesOptions: departureCities,
    departureCity: departureCity,
    initialTransport: initialTransport,
    isJoyview: resort.isJoyview,
    transportIcon: transportIcon,
    withValidDepartureCity: true
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "hidden px-5 md:mt-30 md:block",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-n2"
  })), BookingCriteria_jsx("div", {
    className: "md:flex-2"
  }, BookingCriteria_jsx(ReassuranceBlock_ReassuranceBlock, {
    items: (i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$form = _i18n$booking.form) === null || _i18n$booking$form === void 0 ? void 0 : _i18n$booking$form.items) || []
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "mt-20 md:hidden",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-n2"
  })))), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: withTransport ? 2 : 1,
    title: Object(src_i18n["h" /* t */])('booking.form.resortCriteriaDatesSelectionTitle')
  }), react["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react["cloneElement"])(child, {
      handleChange: handleChange
    });
  }), isWinterResort && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.reinsuranceSkiPass') && BookingCriteria_jsx(Notification["a" /* Notification */], {
    className: "mb-40 text-sienna",
    text: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedDescription,
    title: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedLabel
  }), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: withTransport ? 3 : 2,
    title: bookingConfig === null || bookingConfig === void 0 ? void 0 : (_bookingConfig$form = bookingConfig.form) === null || _bookingConfig$form === void 0 ? void 0 : _bookingConfig$form.guestCriteriaTitle
  }), BookingCriteria_jsx(Participants["a" /* Participants */], {
    adultAge: get_default()(props, 'i18n.adultAge'),
    adultsLabel: get_default()(props, 'i18n.common.participants.adultsLabel'),
    adultOnly: adultOnly,
    adultsNumber: adultsNumber,
    childAge: get_default()(props, 'childAge'),
    childrenBirthdayDateFormatPlaceholder: get_default()(props, 'i18n.childrenBirthdayDateFormatPlaceholder', ''),
    dateFormat: get_default()(props, 'i18n.dateFormat'),
    dayPlaceholder: get_default()(props, 'i18n.dayPlaceholder'),
    departureDate: get_default()(props, 'departureDate'),
    kids: kids,
    kidsAgeLimit: get_default()(props, 'i18n.common.participants.kidsAgeLimit'),
    kidsLabel: get_default()(props, 'i18n.common.participants.kidsLabel'),
    minAgeInformation: get_default()(props, 'i18n.minAgeInformation'),
    monthPlaceholder: get_default()(props, 'i18n.monthPlaceholder'),
    selectAdultsLabels: get_default()(props, 'i18n.selectAdultsLabels'),
    selectChildrenLabels: get_default()(props, 'i18n.selectChildrenLabels'),
    setAdultsNumber: handleChange(props.setAdultsNumber),
    setKids: handleChange(function (_ref2) {
      var _kids = _ref2.kids,
          kidsValidations = _ref2.kidsValidations;
      Object(es["b" /* batch */])(function () {
        props.setKids(_kids);
        props.setKidsValidationState(kidsValidations);
      });
    }),
    yearPlaceholder: get_default()(props, 'i18n.yearPlaceholder')
  }), (resort === null || resort === void 0 ? void 0 : resort.isResort) && !!kids.length && BookingCriteria_jsx(Notification["a" /* Notification */], {
    className: "mt-20 text-saffron",
    text: "**".concat(i18n.didYouKnowLabel, "** ").concat(i18n.kidStayIncludedDescription),
    title: i18n === null || i18n === void 0 ? void 0 : i18n.kidStayIncludedLabel
  }), BookingCriteria_jsx(participantsErrors["a" /* ParticipantsErrors */], {
    className: "mt-20 justify-end",
    config: pick_default()(config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
    errors: formErrors,
    isSubmitted: hasCheckedPrice
  }), BookingCriteria_jsx("div", {
    className: "mt-40 flex justify-end"
  }, BookingCriteria_jsx(Button["a" /* Button */], {
    className: "w-full md:w-auto",
    "data-testid": "BookingCriteria-checkPrice",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_RIGHT
    },
    isDisabled: isLoading || !!formErrors.maxPax,
    onClick: onSubmit
  }, i18n === null || i18n === void 0 ? void 0 : i18n.checkPriceLabel)));
}; // $FlowFixMe


var BookingCriteria_BookingCriteria = function BookingCriteria(_ref3) {
  var myRef = _ref3.myRef,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref3, ["myRef"]);

  return BookingCriteria_jsx(BookingCriteria_BookingCriteriaComponent, Object(esm_extends["a" /* default */])({
    ref: myRef
  }, otherProps));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.container.jsx












var mapDispatchToProps = {
  resetKids: kids_action["a" /* resetKids */],
  setKidsValidationState: facetingSearch_action["o" /* setKidsValidationState */],
  setAdultsNumber: adults_action["a" /* setAdultsNumber */],
  setDepartureCity: departureCity_action["a" /* setDepartureCity */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  setDuration: duration_action["a" /* setDuration */],
  setKids: kids_action["b" /* setKids */],
  endLoading: globalLoader_action["c" /* endLoading */]
};

var BookingCriteria_container_mapStateToProps = function mapStateToProps(state) {
  return {
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    tripDurationCriteria: Object(tripCriteria_selector["c" /* getTripDuration */])(state)
  };
};

var BookingCriteriaContainer = Object(redux["d" /* compose */])(Object(es["c" /* connect */])(BookingCriteria_container_mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
}))(BookingCriteria_BookingCriteria);
// EXTERNAL MODULE: ./src/client/components/widgets/booking-errors/BookingErrors.jsx
var BookingErrors = __webpack_require__("rFb4");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/has.js
var has = __webpack_require__("1mr4");
var has_default = /*#__PURE__*/__webpack_require__.n(has);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/month/BookingCalendarMonth.jsx

var BookingCalendarMonth_jsx = react_default.a.createElement;



var BookingCalendarMonth_BookingCalendarMonth = function BookingCalendarMonth(_ref) {
  var className = _ref.className,
      id = _ref.id,
      isActive = _ref.isActive,
      name = _ref.name,
      _onClick = _ref.onClick,
      price = _ref.price,
      shortName = _ref.shortName,
      year = _ref.year;
  return BookingCalendarMonth_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full cursor-pointer flex-col items-center justify-center overflow-hidden rounded-12 sm:p-10', {
      'bg-white text-black': !isActive,
      'bg-ultramarine font-bold text-white': isActive
    }, className),
    onClick: function onClick() {
      return _onClick(id);
    },
    type: "button"
  }, BookingCalendarMonth_jsx("div", {
    className: "w-full truncate text-center text-12 uppercase sm:text-14"
  }, isActive ? name : shortName, isActive && BookingCalendarMonth_jsx("span", null, " ", year)), !!price && BookingCalendarMonth_jsx(react["Fragment"], null, BookingCalendarMonth_jsx("div", {
    className: "w-full truncate text-10 uppercase sm:text-12"
  }, Object(src_i18n["h" /* t */])('price.format.from')), BookingCalendarMonth_jsx("div", {
    className: "text-10 sm:mt-10 sm:text-14"
  }, price)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/BookingCalendarMonths.jsx



var BookingCalendarMonths_jsx = react_default.a.createElement;






var BookingCalendarMonths_BookingCalendarMonths = function BookingCalendarMonths(_ref) {
  var _ref$current;

  var className = _ref.className,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? [] : _ref$months,
      onClick = _ref.onClick;

  var _useState = Object(react["useState"])(null),
      hovering = _useState[0],
      setHovering = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      initialPosition = _useState2[0],
      setInitialPosition = _useState2[1];

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      setInitialPosition(months.findIndex(function (m) {
        return m.isActive;
      }));
    }
  }, [isLoading]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var containerWidth = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth) || 0; // eslint-disable-next-line no-nested-ternary

  var width = !isTablet ? containerWidth / 4 : isDesktop ? containerWidth / 8 : containerWidth / 5;
  var elementWidth = isTablet ? width : width * 0.95;
  return BookingCalendarMonths_jsx("div", {
    className: ('relative isolate', className)
  }, BookingCalendarMonths_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('booking.common.previousMonths'),
    className: "z-1",
    controlsClassName: "mb-20 pb-10 sm:pb-20",
    deltaScrollFactorClick: elementWidth * 2,
    elementWidth: elementWidth,
    forwardLabel: Object(src_i18n["h" /* t */])('booking.common.nextMonths'),
    initialPosition: elementWidth ? initialPosition : null,
    theme: "calendar"
  }, BookingCalendarMonths_jsx("div", {
    className: "mx-5 mb-20 flex sm:mx-15 md:mx-0",
    ref: ref
  }, months.map(function (month) {
    return BookingCalendarMonths_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('relative flex-none px-5 transition-width duration-250 ease-in sm:px-10', {
        'w-1/4 sm:w-1/5 md:w-1/8': !month.isActive && hovering !== month.id,
        'w-1/2 sm:w-2/5 md:w-1/4': month.isActive,
        'w-3/10 sm:w-1/4 md:w-1/6': !month.isActive && hovering === month.id
      }),
      key: month.id,
      onMouseEnter: function onMouseEnter() {
        return setHovering(month.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovering(null);
      },
      style: !isTablet && elementWidth ? {
        width: month.isActive ? elementWidth * 2 : elementWidth
      } : null
    }, BookingCalendarMonths_jsx(BookingCalendarMonth_BookingCalendarMonth, Object(esm_extends["a" /* default */])({}, month, {
      className: "mb-10 h-52 sm:mb-15 md:h-84",
      onClick: onClick
    })), month.isActive && BookingCalendarMonths_jsx("div", {
      className: "arrow-down arrow-large arrow-lightSand arrow-bg arrow-bg-large arrow-bg-ultramarine bottom-0 start-0 -mb-1 w-full border-b-2 border-ultramarine transition-opacity duration-250 ease-in"
    }));
  }))), BookingCalendarMonths_jsx("hr", {
    className: "border-ligthGrey absolute z-0 m-0 -mt-20 block h-1 w-full border-0 border-t-1 border-solid p-0"
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/widgets/rate-messages/RateMessages.jsx
var RateMessages = __webpack_require__("/Sb8");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-resume/BookingCalendarResume.jsx



var BookingCalendarResume_jsx = react_default.a.createElement;










var BookingCalendarResume_BookingCalendarResume = function BookingCalendarResume(_ref) {
  var className = _ref.className,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      id = _ref.id,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      onClose = _ref.onClose,
      onReset = _ref.onReset,
      price = _ref.price,
      priceIsLoading = _ref.priceIsLoading,
      rate = _ref.rate,
      realPrice = _ref.realPrice,
      realPriceIsLoading = _ref.realPriceIsLoading,
      startDate = _ref.startDate,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "endDate", "hasTransport", "id", "isJoyview", "onClose", "onReset", "price", "priceIsLoading", "rate", "realPrice", "realPriceIsLoading", "startDate"]);

  var track = Object(useTracking["a" /* useTracking */])();

  var onClickSeeMore = function onClickSeeMore(_, isExpanded) {
    if (!isExpanded) {
      track({
        actionGA: 'calendarPrice',
        labelGA: 'viewMore'
      });
    }
  };

  return BookingCalendarResume_jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])('rounded-12 bg-white shadow', className),
    id: id
  }), BookingCalendarResume_jsx("div", {
    className: "relative isolate"
  }, BookingCalendarResume_jsx("button", {
    className: "absolute end-0 top-0 m-10 text-14 leading-0",
    onClick: onClose,
    type: "button"
  }, BookingCalendarResume_jsx("span", {
    className: "sr-only"
  }, Object(src_i18n["h" /* t */])('common.close')), BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  })), BookingCalendarResume_jsx("div", {
    className: "p-20"
  }, BookingCalendarResume_jsx("p", {
    className: "mb-30 flex items-start gap-10 text-12 sm:text-14"
  }, BookingCalendarResume_jsx("span", {
    className: "text-28 leading-0 text-sienna"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "1em"
  })), ' ', BookingCalendarResume_jsx("span", null, BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex gap-5",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.stayDeparture'),
    values: {
      departure_date: startDate.charAt(0).toUpperCase() + startDate.slice(1)
    },
    valuesClassName: {
      departure_date: 'text-sienna'
    }
  }), BookingCalendarResume_jsx("br", null), BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex gap-5",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.endDateLabel'),
    values: {
      end_date: endDate.charAt(0).toUpperCase() + endDate.slice(1)
    },
    valuesClassName: {
      departure_date: 'text-sienna'
    }
  }))), (priceIsLoading || realPriceIsLoading) && BookingCalendarResume_jsx("div", {
    className: "flex justify-center py-10"
  }, BookingCalendarResume_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), (realPrice && !realPriceIsLoading || price && !priceIsLoading) && BookingCalendarResume_jsx("div", {
    className: "mb-20 flex items-center justify-center gap-10 text-12"
  }, BookingCalendarResume_jsx("span", {
    className: "hidden text-18 leading-0 text-sienna md:inline-block"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ACCOMODATIONS,
    width: "1em"
  }), hasTransport && BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "ms-5",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "1em"
  })), BookingCalendarResume_jsx("span", null, "".concat(Object(src_i18n["h" /* t */])('price.format.unitTotalPerTripIndicative'), " ")), BookingCalendarResume_jsx("span", {
    className: "text-20 font-bold text-sienna"
  }, realPrice || price)), BookingCalendarResume_jsx("p", {
    className: "flex flex-col text-center text-10 sm:text-12"
  }, isJoyview ? BookingCalendarResume_jsx("span", {
    className: "leading-1 text-blueWave"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CLUBMED_JOYVIEW,
    isNotSquare: true,
    width: "10em"
  })) : BookingCalendarResume_jsx(react["Fragment"], null, price && !priceIsLoading ? Object(src_i18n["h" /* t */])('booking.form.priceIsLabel') : '', ' ', BookingCalendarResume_jsx("span", {
    className: "font-brand text-14 leading-1 text-sienna sm:text-16"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "-mb-2",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), ' ', Object(src_i18n["h" /* t */])('resort.startingPrice.allInclusive'))))), BookingCalendarResume_jsx("button", {
    className: "w-full px-20 py-10 text-center text-14 underline",
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        labelGA: 'resetDates'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar')), !!rate && BookingCalendarResume_jsx("div", {
    className: "font-text-start border-t-1 border-mediumGrey p-20"
  }, BookingCalendarResume_jsx(SeeMore["a" /* SeeMore */], {
    className: "mt-10 flex-1 md:mt-0",
    classNameButton: "text-end",
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    onClick: onClickSeeMore,
    seeMoreSize: 70,
    seeMoreSizeTolerance: 0
  }, BookingCalendarResume_jsx(RateMessages["a" /* RateMessages */], {
    rate: rate
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/ArrivalDepartureDate.jsx
var ArrivalDepartureDate_jsx = react_default.a.createElement;


var ArrivalDepartureDate_ArrivalDepartureDate = function ArrivalDepartureDate(_ref) {
  var arrivalDate = _ref.arrivalDate,
      departureDate = _ref.departureDate;
  return ArrivalDepartureDate_jsx("div", {
    className: "block sm:hidden p-10 text-14"
  }, ArrivalDepartureDate_jsx("p", {
    className: "flex gap-5 justify-between mb-5"
  }, Object(src_i18n["h" /* t */])('faceting.when.arrivalDateTitle'), ArrivalDepartureDate_jsx("span", {
    className: "font-bold text-sienna"
  }, arrivalDate ? arrivalDate : ' -')), ArrivalDepartureDate_jsx("p", {
    className: "flex gap-5 justify-between"
  }, Object(src_i18n["h" /* t */])('faceting.when.departureDateTitle'), ArrivalDepartureDate_jsx("span", {
    className: "font-bold text-sienna"
  }, departureDate ? departureDate : ' -')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-form/useAvailableDurations.js
var useAvailableDurations = __webpack_require__("jLVw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 4 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/hooks/use-block-input-departure-date/useBlockInputDepartureDate.js
var useBlockInputDepartureDate = __webpack_require__("VQ9C");

// EXTERNAL MODULE: ./src/hooks/use-price-of-stay/usePriceOfStay.js
var usePriceOfStay = __webpack_require__("QkNd");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.action.js
var calendar_action = __webpack_require__("rueY");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 1 modules
var calendar_selector = __webpack_require__("05PS");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceLegend.jsx
var PriceLegend_jsx = react_default.a.createElement;





var PriceLegend_PriceLegend = function PriceLegend(_ref) {
  var canReset = _ref.canReset,
      durationLabel = _ref.durationLabel,
      onReset = _ref.onReset;
  var track = Object(useTracking["a" /* useTracking */])();
  return PriceLegend_jsx("div", {
    className: "p-20 md:px-0 w-full"
  }, PriceLegend_jsx("div", {
    className: "flex gap-10 items-center justify-between"
  }, PriceLegend_jsx("p", {
    className: "text-16"
  }, Object(src_i18n["h" /* t */])('faceting.when.pricesBasedOn'), PriceLegend_jsx("strong", {
    "data-testid": "prices-duration-label"
  }, "\xA0", durationLabel)), PriceLegend_jsx(Button["a" /* Button */], {
    "data-testid": "PriceLegend-calendarReset",
    iconLeft: {
      name: icons["a" /* ICONS */].RELOAD
    },
    isDisabled: !canReset,
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        categoryGA: 'resort',
        labelGA: 'resetCalendar'
      });
    },
    size: "small"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar'))), PriceLegend_jsx("ul", {
    className: "flex flex-wrap font-bold gap-15 mt-10"
  }, PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-green"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.bestPrice')), PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-orange"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.lastAvailability')), PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-grey"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.notAvailable'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceCalendar.jsx











var PriceCalendar_jsx = react_default.a.createElement;
































var NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var HASH = 'PriceCalendarResume';
var SCROLL_ANCHOR = 'PriceCalendar';
var YEAR_MONTH = 'YYYYMM';

var defaultHandleChange = function defaultHandleChange(cb) {
  return function () {
    return cb();
  };
};

var PriceCalendar_PriceCalendar = function PriceCalendar(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var uri = new URI_default.a(router.asPath);
  var uriRef = react_default.a.useRef(null);
  uriRef.current = uri;
  var queryParams = router.query;
  var bookingConfig = props.bookingConfig,
      didMountCallback = props.didMountCallback,
      duration = props.duration,
      _props$handleChange = props.handleChange,
      handleChange = _props$handleChange === void 0 ? defaultHandleChange : _props$handleChange,
      isJoyview = props.isJoyview,
      offsetSell = props.offsetSell,
      product = props.product,
      productId = props.productId,
      transport = props.transport;
  var urgentisationRate = bookingConfig.priceCalendar.offers.urgentisation.rateToDisplay;
  var dispatch = Object(es["d" /* useDispatch */])();
  var calendar = Object(es["e" /* useSelector */])(calendar_selector["c" /* getCalendar */]);
  var days = Object(es["e" /* useSelector */])(calendar_selector["i" /* getDays */]);
  var selectedMonth = Object(es["e" /* useSelector */])(calendar_selector["n" /* getSelectedMonth */]);
  var selectedDay = Object(es["e" /* useSelector */])(storeHelper["b" /* getDepartureDate */]);
  var isLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarLoading */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["m" /* getPricesByDays */]);
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    return state.tripCriteria.departureDate;
  });
  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);

  var _useBlockInputDepartu = Object(useBlockInputDepartureDate["a" /* useBlockInputDepartureDate */])(true),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate,
      setBlockInputDepartureDate = _useBlockInputDepartu.setBlockInputDepartureDate;

  var _useState = Object(react["useState"])(duration),
      durationPrice = _useState[0];

  var price = Object(es["e" /* useSelector */])(calendar_selector["g" /* getCalendarTripPrice */]);
  var priceIsLoading = Object(es["e" /* useSelector */])(calendar_selector["h" /* getCalendarTripPriceLoading */]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice'
  });

  var _useState2 = Object(react["useState"])(false),
      hasToaster = _useState2[0],
      setHasToaster = _useState2[1];

  var _useState3 = Object(react["useState"])(tripDuration),
      inputDuration = _useState3[0],
      setInputDuration = _useState3[1];

  var _usePriceOfStay = Object(usePriceOfStay["a" /* usePriceOfStay */])(productId, transport),
      hasValidCriteria = _usePriceOfStay.hasValidCriteria,
      isPriceOfStayLoading = _usePriceOfStay.isLoading,
      priceOfStay = _usePriceOfStay.priceOfStay;

  Object(react["useEffect"])(function () {
    if (inputDuration && inputDuration !== durationPrice) {
      dispatch(Object(calendar_action["d" /* fetchCalendarTripPrice */])({
        appContext: appContext,
        duration: inputDuration,
        forceAdultPerTrip: true,
        // $FlowFixMe
        location: {
          // this done to avoid regression, to do clean this when every thing is migrated
          queryParams: queryParams,
          urlParams: queryParams
        },
        productId: productId,
        transport: transport
      }));
    }
  }, [productId, inputDuration, transport]);

  var _useState4 = Object(react["useState"])(!blockInputDepartureDate && departureDate ? moment_default()(departureDate) : moment_default()(selectedMonth, YEAR_MONTH)),
      openCalendarToDate = _useState4[0],
      setCalendarToDate = _useState4[1];

  Object(react["useEffect"])(function () {
    if (tripDuration !== inputDuration) {
      setInputDuration(tripDuration);
    }
  }, [tripDuration]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }
  }, [selectedMonth]);
  var availableDurations = Object(useAvailableDurations["a" /* useAvailableDurations */])({
    productId: productId,
    initialTransport: transport
  });

  var setUrlQueries = function setUrlQueries(queries) {
    if (uriRef.current) {
      var searchPageUrl = uriRef.current.clone().setQuery(queries);
      router.replace(searchPageUrl.toString(), undefined, {
        shallow: true,
        scroll: false
      });
      Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */]));
    }
  };

  var onSelect = function onSelect(dates) {
    var timestamp = dates.from && moment_default()(dates.from).valueOf();

    if (blockInputDepartureDate) {
      setBlockInputDepartureDate(false);
    }

    if (departureDate !== timestamp) {
      handleChange(function () {
        Object(es["b" /* batch */])(function () {
          dispatch(Object(departureDate_action["a" /* setDepartureDate */])(timestamp));
          dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
        });
        setInputDuration(null);
        requestAnimationFrame(function () {
          var _setUrlQueries;

          setUrlQueries((_setUrlQueries = {}, Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["g" /* QUERY_DEPARTURE_DATE */], (timestamp || undefined) && moment_default()(timestamp).format(uri_constants["f" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries));
        });

        if (timestamp) {
          track({
            labelGA: "when_".concat(moment_default()(timestamp).format('DD/MM/YYYY'))
          });
          setCalendarToDate(moment_default()(timestamp));
        }
      })();
    }

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      track({
        labelGA: "duration_".concat(updatedDuration)
      });
      setInputDuration(updatedDuration);
      Object(es["b" /* batch */])(function () {
        dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(updatedDuration));
        var dayId = parseInt(moment_default()(dates.from).format(apiDate["a" /* API_DATE_FORMAT */]), 10);
        var day = days.find(function (calendarDay) {
          return calendarDay.dayContent.id === dayId;
        });
        day && dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
          day: day.dayContent
        }));
        dispatch(Object(calendar_action["h" /* setIsPriceCalendarSelection */])(true));
      });
      setHasToaster(true);
      setUrlQueries(Object(defineProperty["a" /* default */])({}, uri_constants["h" /* QUERY_DURATION */], updatedDuration));
    } else {
      setInputDuration(null);
      dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])(null));
      setHasToaster(false);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["g" /* setInitialDuration */])(duration));
    return function () {
      dispatch(Object(calendar_action["a" /* clearCalendar */])());
    };
  }, []);
  var transportQueryValue = queryParams[uri_constants["m" /* QUERY_TRANSPORT */]];
  Object(react["useEffect"])(function () {
    var hasProposalIdQueryParam = has_default()(queryParams, 'proposalId');

    if (hasProposalIdQueryParam || !productId || transportQueryValue && transportQueryValue !== transport) {
      return; // because a Redux action will fetch the calendar
    }

    if (selectedMonth) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }

    dispatch(Object(calendar_action["c" /* fetchCalendar */])({
      resortId: productId,
      transport: transport,
      duration: durationPrice,
      urgentisationRate: urgentisationRate
    }, appContext));

    if (hasToaster) {
      setHasToaster(false);
    }
  }, [productId, transport, transportQueryValue, urgentisationRate]);
  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["i" /* setPossibleDepartureDate */])());
    /**
     * Should fetch proposals after state update for arrivaldate
     * see BookingEngineForm, ligne 170.
     * */

    didMountCallback && didMountCallback();
  }, [calendar.months]);

  var onSelectDate = function onSelectDate(day) {
    props.onSelectDate(day);
  };
  /**
   * make sure the selected date is up to date after a transport update
   */


  Object(react["useEffect"])(function () {
    if (selectedDay) {
      var day = days.find(function (calendarDay) {
        return calendarDay.dayContent.id === selectedDay;
      });
      day && onSelectDate(day.dayContent);
    }
  }, [JSON.stringify(calendar), transport, selectedDay]);
  Object(react["useEffect"])(function () {
    if (hasToaster) {
      requestAnimationFrame(function () {
        Object(scrollToElement["a" /* scrollToElement */])("#".concat(HASH), 500, ".".concat(Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */]));
      });
    }
  }, [hasToaster]);
  var offsetCalendar = appContext.isSeller ? 0 : offsetSell;
  var from = departureDate && !blockInputDepartureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && inputDuration ? moment_default()(from).add({
    days: inputDuration
  }).toDate() : null;

  var _useState5 = Object(react["useState"])(from),
      hovered = _useState5[0],
      setHovered = _useState5[1];

  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onSelectMonth = function onSelectMonth(monthId) {
    if (monthId !== selectedMonth) {
      if (!from && departureDate) {
        var _setUrlQueries3;

        setUrlQueries((_setUrlQueries3 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries3));
        dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
        dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
      }

      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
      requestAnimationFrame(function () {
        setCalendarToDate(moment_default()(monthId, YEAR_MONTH));
        dispatch(Object(calendar_action["e" /* selectMonth */])(monthId));
      });
    }
  };

  var onReset = function onReset() {
    var _setUrlQueries4;

    requestAnimationFrame(function () {
      Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */]));
    });
    setUrlQueries((_setUrlQueries4 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries4));
    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
    setInputDuration(null);
    setHasToaster(false);
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || durationPrice : durationPrice;
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(src_i18n["h" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(src_i18n["h" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  var locale = appContext.locale;
  var selectedDayPrice = selectedDay && prices && prices[selectedDay];
  var instalmentSelectedDayPrice = Object(price_util["b" /* getInstallmentPrice */])({
    currency: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.currency,
    formattedValue: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.price,
    value: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.priceValue
  }, locale);
  var selectedBestPrice = inputDuration && inputDuration !== durationPrice ? Object(price_util["b" /* getInstallmentPrice */])(price === null || price === void 0 ? void 0 : price.bestPrice, locale) : instalmentSelectedDayPrice;
  var shouldRenderRealPrice = Boolean(!isLoading && !isPriceOfStayLoading && priceOfStay && hasValidCriteria);
  var selectedRealPrice = shouldRenderRealPrice ? Object(price_util["b" /* getInstallmentPrice */])(priceOfStay.bestPrice, locale) : '';
  var selectedDuration = inputDuration ? inputDuration : 0;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.form.dateFormat');
  var longDateFormat = Object(src_i18n["h" /* t */])('resort.startingPrice.longDateFormat');
  return PriceCalendar_jsx("div", {
    className: "relative isolate -mx-20 min-h-450 md:mx-0",
    "data-scroll-anchor": SCROLL_ANCHOR,
    id: "calendar"
  }, !isEmpty_default()(calendar) && PriceCalendar_jsx(react["Fragment"], null, PriceCalendar_jsx(BookingCalendarMonths_BookingCalendarMonths, {
    isLoading: isLoading,
    months: calendar.blocks.map(function (b) {
      return {
        id: b.id,
        isActive: b.id === selectedMonth,
        name: b.name,
        price: Object(price_util["b" /* getInstallmentPrice */])(b.price, locale),
        shortName: b.shortName,
        year: b.year
      };
    }),
    onClick: onSelectMonth
  }), PriceCalendar_jsx(PriceLegend_PriceLegend, {
    durationLabel: durationLabel,
    canReset: !!from,
    onReset: onReset
  }), PriceCalendar_jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "-mx-1 md:mx-0 md:mb-40",
    displayPrices: true,
    duration: durationPrice,
    hasInstalment: true,
    isJoyview: isJoyview,
    navbarElement: function navbarElement(_ref) {
      var month = _ref.month;
      var datePickerMonth = Number(moment_default()(month).format(YEAR_MONTH));

      if (datePickerMonth !== selectedMonth && !isLoading && (from || to)) {
        dispatch(Object(calendar_action["e" /* selectMonth */])(datePickerMonth));
      }

      return null;
    },
    onSelect: onSelect,
    onDayMouseOver: onDayMouseOver,
    optionsDuration: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    openCalendarToDate: openCalendarToDate,
    prices: prices,
    product: product,
    offsetCalendar: offsetCalendar,
    selectedBestPrice: selectedBestPrice,
    selectedRealPrice: selectedRealPrice,
    selectedDays: {
      from: from,
      to: to
    },
    selectedDuration: selectedDuration,
    selectedMonth: selectedMonth,
    withLongDayFormat: isTablet,
    withPriceDetails: isDesktop
  }), PriceCalendar_jsx(ArrivalDepartureDate_ArrivalDepartureDate, {
    arrivalDate: from && moment_default()(from).format(dateFormat),
    departureDate: to && moment_default()(to).format(dateFormat)
  }), from && to && hasToaster && !isLoading && PriceCalendar_jsx(BookingCalendarResume_BookingCalendarResume, {
    className: "absolute bottom-0 end-0 z-3 mx-20 mt-[-100px] w-[calc(100%-2.5rem)] md:bottom-auto md:mx-0 md:mt-[-350px] md:w-380 ltr:animate-slideInRight rtl:animate-slideInLeft",
    hasTransport: Boolean(transport && transport !== NO_TRANSPORT_VALUE),
    id: HASH,
    isJoyview: isJoyview,
    endDate: moment_default()(to).format(longDateFormat),
    onClose: function onClose() {
      return setHasToaster(false);
    },
    onReset: onReset,
    price: selectedBestPrice,
    priceIsLoading: priceIsLoading,
    rate: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.rate,
    realPrice: selectedRealPrice,
    realPriceIsLoading: isPriceOfStayLoading,
    startDate: moment_default()(from).format(longDateFormat)
  })), isLoading && PriceCalendar_jsx("div", {
    className: "absolute inset-0 z-1 flex w-full items-center justify-center bg-lightSand"
  }, PriceCalendar_jsx(AsyncLoader["a" /* AsyncLoader */], null)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.jsx


























var BookingEngineForm_jsx = react_default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BookingEngineForm_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngineForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngineForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

























var defaultProps = {
  clearProposals: noop_default.a,
  kids: [],
  i18n: null,
  dataSelector: 'BookingEngineForm',
  // $FlowFixMe
  fetchProposalsAndRedirect: noop_default.a,
  // $FlowFixMe
  suggestions: {
    dates: [],
    resorts: []
  }
};

var BookingEngineForm_BookingEngineForm = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(BookingEngineForm, _Component);

  var _super = BookingEngineForm_createSuper(BookingEngineForm);

  function BookingEngineForm(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineForm);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "bookingCriteriaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setShouldFetchProposals", function () {
      var queryParams = _this.props.queryParams;
      var fetch = queryParams.fetch;
      var shouldFetch = Boolean(fetch && "".concat(fetch) === '1');
      return function () {
        _this.setState({
          shouldFetchProposals: shouldFetch
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkLoading", function () {
      if (_this.props.suggestions.dates.length > 0 || _this.props.suggestions.durations.length > 0 || _this.props.suggestions.resorts.length > 0 || // errors are so badly handle that it's easier to check if there is no proposal rather that there is an error
      _this.props.proposals.some(function (_ref) {
        var id = _ref.id;
        return !id;
      }) || _this.props.proposals.some(function (proposal) {
        return proposal.price.gap > proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
      })) {
        _this.props.endLoading();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleDepartureDate", function () {
      var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var newDepartureDate = moment_default()(String(day === null || day === void 0 ? void 0 : day.id)).valueOf();

      if (_this.props.departureDate !== (day === null || day === void 0 ? void 0 : day.id)) {
        _this.props.setDepartureDate(newDepartureDate);
      }

      _this.props.updateTripDateCriteria({
        day: day
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFormSubmit", function (event) {
      event.preventDefault();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getPackages", function (newArrivalDate) {
      var router = _this.props.router;

      var fetchParams = _objectSpread(_objectSpread({
        productId: _this.props.resort.id,
        departureCity: _this.props.departureCity,
        duration: _this.props.duration,
        isJoyView: _this.props.resort.isJoyview,
        isUrbanOasis: _this.props.resort.isUrbanOasis,
        // $FlowFixMe it's a recomposition
        globalLoaderLabel: _this.context.isSeller ? _this.props.i18n.booking.partners.form.proposalsLoaderLabel : _this.props.i18n.booking.form.proposalsLoaderLabel
      }, Object(sellerUtils["f" /* isSeller */])(_this.context) ? Object(ContactInfoUtils["f" /* getAllAttendeesIds */])(_this.props.tripInformation) : null), {}, {
        newArrivalDate: newArrivalDate,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR
      });

      return _this.props.fetchProposalsAndRedirect(fetchParams, _this.context, router);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBE", function (newArrivalDate) {
      _this.setState({
        showModal: false
      });

      _this.getPackages(newArrivalDate).then(function () {
        _this.setState({
          showModal: true
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldDisplayModal", function () {
      return _this.hasCounterProposals() && _this.canDisplayCounterProposals() && _this.state.showModal;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props, resort, router, proposals, attendees, setCms, setAttendees, prepareBe, _yield$fetchBookingEn, config, legalInformations, proposalId;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, resort = _this$props.resort, router = _this$props.router, proposals = _this$props.proposals, attendees = _this$props.attendees, setCms = _this$props.setCms, setAttendees = _this$props.setAttendees, prepareBe = _this$props.prepareBe;

              _this.setState({
                showModal: false
              });

              _context.next = 4;
              return Object(BookingEngineI18n_query["a" /* fetchBookingEngineI18nQuery */])(_this.context);

            case 4:
              _yield$fetchBookingEn = _context.sent;
              config = _yield$fetchBookingEn.config;
              legalInformations = _yield$fetchBookingEn.legalInformations;

              if (config && legalInformations) {
                setCms(config, legalInformations);
                setAttendees(attendees);
              }

              proposalId = proposals[0].id;
              prepareBe({
                resort: resort,
                proposals: {
                  proposals: proposals,
                  resort: resort
                },
                proposalId: proposalId
              });
              router.push(Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals, resort, proposalId, omit_default()(router.query, ['dynamicPage'])));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      showModal: true,
      shouldFetchProposals: false,
      isDepartureDateAvailaible: true
    };
    _this.bookingCriteriaNode = /*#__PURE__*/Object(react["createRef"])();
    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineForm, [{
    key: "scrollToBookingEngineEntryPoint",
    value: function scrollToBookingEngineEntryPoint() {
      var _this2 = this;

      /**
       * The setTimeout is needed to make sure the modal is closed before trying to scroll
       */
      setTimeout(function () {
        var bookingEngineEntry = _this2.props.bookingEngineEntry;
        var PRICE_CALENDAR = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR,
            PRICE_REMOTE = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE;
        var bookingEngineFormSelector = document.querySelector(BOOKING_ENGINE_FORM_SELECTOR);
        var priceRemoteSelector = document.querySelector(price_remote_constants["c" /* PRICE_REMOTE_STICKY_WRAPPER_SELECTOR */]);

        if (bookingEngineEntry === PRICE_CALENDAR && bookingEngineFormSelector) {
          // $FlowFixMe the validity of this check in the condition above
          bookingEngineFormSelector.scrollIntoView();
        } else if (bookingEngineEntry === PRICE_REMOTE && priceRemoteSelector) {
          // $FlowFixMe the validity of this check in the condition above
          priceRemoteSelector.scrollIntoView();
        }
      }, 0);
    }
  }, {
    key: "setIsDepartureDateAvailaible",
    value: function setIsDepartureDateAvailaible(departureDate, offsetSell) {
      this.setState({
        isDepartureDateAvailaible: !Object(BookingPagesUtils["g" /* checkIsDepartureDateAvailaible */])(String(departureDate), offsetSell)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // We assume that if we have proposals, it implies we come from the booking engine.
      this.props.clearSelectedProposal();
      this.props.clearProposals();
      this.setIsDepartureDateAvailaible(this.props.departureDate, this.props.bookingCriteria.offsetSell);
      /**
       * This setTimeout is needed also (plus the one used in scrollToBookingEngineEntryPoint)
       * because of a race condition with RouteChangeListener scroll (a bugfix for hash)
       * See RouteChangeListener line 29
       */

      setTimeout(function () {
        return _this3.scrollToBookingEngineEntryPoint();
      }, 0);
    }
    /**
     * #10731
     * This means the user comes from a metasearch and has already selected trip criterias.
     * We force fetching proposals to avoid one more click on continue button
     * but we cannot make the query on componentDidMount hook because state is not yet hydrated from query params
     * arrivalDate is mandatory and will be set after calendar did mount.
     * See PriceCalendar & didMountCallback
     * url format: ?duration=6&date=2019-04-30&number_of_adults=2&kids=2015-03-02_2014-12-20&fetch=1&_ab2=b
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.departureDate !== prevProps.departureDate) {
        this.setIsDepartureDateAvailaible(this.props.departureDate, this.props.bookingCriteria.offsetSell);
      }

      if (this.state.shouldFetchProposals && !prevState.shouldFetchProposals && this.bookingCriteriaNode.current) {
        // $FlowFixMe
        this.bookingCriteriaNode.current.onSubmit();
      }

      var oldProposal = prevProps.proposals[0];
      var newProposal = this.props.proposals[0];

      if (!isEqual_default()(oldProposal, newProposal) || !isEqual_default()(prevProps.suggestions, this.props.suggestions)) {
        this.checkLoading(); // scroll to errors if any

        if (Object(proposalUtils["o" /* hasErroredProposals */])(this.props.proposals) || this.hasCounterProposals() && !this.canDisplayCounterProposals()) {
          // the setTimeout is needed to make sure the global loader is closed before trying to scroll
          setTimeout(function () {
            Object(scrollToElement["a" /* scrollToElement */])('#Package-error', 600, ".".concat(Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */]));
          });
        }
      } // makes sure the counter proposal modal will be closed on resort change


      if (prevProps.resort.id !== this.props.resort.id) {
        this.setState({
          showModal: false
        });
      }
    }
    /**
     * In case the fetch proposals return counter proposals the global loader stay so we need to end it ourself
     * IT stay because we want to keep it when we redirect to the BE for prevent any flickering
     */

  }, {
    key: "canDisplayCounterProposals",
    value: function canDisplayCounterProposals() {
      var _this$props$proposals, _this$props$proposals2;

      return ((_this$props$proposals = this.props.proposals[0]) === null || _this$props$proposals === void 0 ? void 0 : (_this$props$proposals2 = _this$props$proposals.price) === null || _this$props$proposals2 === void 0 ? void 0 : _this$props$proposals2.gap) >= proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] || this.props.suggestions.dates.length > 0 || this.props.suggestions.durations.length > 0 || this.props.suggestions.resorts.length > 0;
    }
  }, {
    key: "hasCounterProposals",
    value: function hasCounterProposals() {
      var _proposal$price;

      var proposal = this.props.proposals[0];
      var _this$props$suggestio = this.props.suggestions,
          dates = _this$props$suggestio.dates,
          durations = _this$props$suggestio.durations,
          resorts = _this$props$suggestio.resorts;
      return dates.length > 0 || durations.length > 0 || resorts.length > 0 || !isEmpty_default()(proposal) && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) >= proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$bookingCo,
          _this$props$bookingCo2,
          _this$props$bookingCo3,
          _this$props$bookingCo4,
          _this$props$resort,
          _this$props$resort2,
          _this4 = this,
          _this$props$proposals3;

      var failedProposals = Object(proposalUtils["o" /* hasErroredProposals */])(this.props.proposals);

      var i18n = _objectSpread(_objectSpread({}, this.props.i18n), {}, {
        adultAge: get_default()(this.props, 'bookingConfig.form.adultAge'),
        bookingCriteria: this.props.bookingCriteria,
        childrenBirthdayDateFormatPlaceholder: get_default()(this.props, 'bookingConfig.form.childrenBirthdayDateFormatPlaceholder'),
        dateFormat: get_default()(this.props, 'bookingConfig.form.dateFormat'),
        dayPlaceholder: get_default()(this.props, 'bookingConfig.form.dayPlaceholder'),
        monthPlaceholder: get_default()(this.props, 'bookingConfig.form.monthPlaceholder'),
        yearPlaceholder: get_default()(this.props, 'bookingConfig.form.yearPlaceholder'),
        dateValidate: get_default()(this.props, 'bookingConfig.form.dateValidate'),
        durationTitle: get_default()(this.props, 'bookingConfig.form.durationTitle'),
        durationOptionsFormat: get_default()(this.props, 'bookingConfig.form.selectDuration'),
        selectAdultsLabels: get_default()(this.props, 'bookingConfig.form.selectAdultsLabels'),
        selectChildrenLabels: get_default()(this.props, 'bookingConfig.form.selectChildrenLabels'),
        legalNotice: get_default()(this.props, 'bookingConfig.form.legalNotice'),
        minAgeInformation: get_default()(this.props, 'resort.minAuthorizedAge.formattedValue'),
        birthdayFormatErrorMessage: get_default()(this.props, 'bookingConfig.form.errors.birthdayFormat'),
        adultAgeErrorMessage: get_default()(this.props, 'bookingConfig.form.errors.adultChild'),
        skiPassIncludedLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedLabel'),
        skiPassIncludedDescription: get_default()(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedDescription'),
        kidStayIncludedLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedLabel'),
        didYouKnowLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.didYouKnowLabel'),
        kidStayIncludedDescription: get_default()(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedDescription'),
        minAgeErrorMessage: get_default()(this.props, 'resort.minAgeErrorMessage.formattedValue'),
        proposalsLoaderLabel: get_default()(this.props, 'bookingConfig.form.proposalsLoaderLabel')
      });

      Object(src_i18n["a" /* addTranslationKeys */])({
        booking: this.props.i18n.booking,
        common: this.props.i18n.common,
        package: this.props.i18n.package,
        priceRemote: this.props.i18n.priceRemote,
        resort: this.props.i18n.resort,
        bookingConfig: {
          form: {
            legalNotice: (_this$props$bookingCo = this.props.bookingConfig) === null || _this$props$bookingCo === void 0 ? void 0 : (_this$props$bookingCo2 = _this$props$bookingCo.form) === null || _this$props$bookingCo2 === void 0 ? void 0 : _this$props$bookingCo2.legalNotice
          }
        }
      });
      return BookingEngineForm_jsx(SiteContainer["a" /* SiteContainer */], {
        className: "bg-lightSand"
      }, BookingEngineForm_jsx("form", {
        className: "py-30 lg:py-40",
        id: "booking",
        onSubmit: this.onFormSubmit
      }, BookingEngineForm_jsx("h2", {
        className: "air360-replay-ignore mb-20 border-b-1 border-sand pb-10 font-brand text-24 font-bold leading-tight text-black md:text-28 lg:pb-20",
        "data-cs-mask": true
      }, (_this$props$bookingCo3 = this.props.bookingConfig) === null || _this$props$bookingCo3 === void 0 ? void 0 : (_this$props$bookingCo4 = _this$props$bookingCo3.form) === null || _this$props$bookingCo4 === void 0 ? void 0 : _this$props$bookingCo4.title), BookingEngineForm_jsx(BookingCriteriaContainer, {
        myRef: this.bookingCriteriaNode,
        adultOnly: get_default()(this.props, 'resort.adultOnly'),
        isWinterResort: Object(resortUtils["b" /* isWinterResort */])(this.props.resort),
        adultsNumber: this.props.adultsNumber,
        bookingConfig: this.props.bookingConfig,
        duration: this.props.duration,
        departureDate: this.props.departureDate,
        isDepartureDateAvailaible: this.state.isDepartureDateAvailaible,
        departureCity: this.props.departureCity,
        enableTransfer: get_default()(this.props, 'bookingConfig.enableTransfer'),
        kids: this.props.kids,
        getPackages: this.getPackages,
        isJoyView: get_default()(this.props, 'resort.isJoyview', false),
        isTransportEnabled: get_default()(this.props, 'package.transport.enableTransport', false),
        pushImage: this.props.pushImage,
        config: this.props.config,
        childAge: get_default()(this.props, 'resort.minAuthorizedAge.value'),
        resort: get_default()(this.props, 'resort'),
        i18n: i18n
      }, BookingEngineForm_jsx(PriceCalendar_PriceCalendar, {
        bookingConfig: this.props.bookingConfig,
        cmsPrice: this.props.cmsPrice,
        cmsStartingPrice: this.props.cmsStartingPrice,
        duration: this.props.duration,
        didMountCallback: this.setShouldFetchProposals(),
        isJoyview: !!((_this$props$resort = this.props.resort) === null || _this$props$resort === void 0 ? void 0 : _this$props$resort.isJoyview),
        key: (_this$props$resort2 = this.props.resort) === null || _this$props$resort2 === void 0 ? void 0 : _this$props$resort2.id,
        offsetSell: this.props.bookingCriteria.offsetSell,
        onSelectDate: this.handleDepartureDate,
        product: this.props.resort,
        productId: this.props.resort.id,
        selectedDay: this.props.departureDate,
        transport: this.props.departureCity,
        travelAdvisorConfig: this.props.travelAdvisorConfig
      })), !this.state.isDepartureDateAvailaible || failedProposals || this.props.proposals.some(function (proposal) {
        return proposal.price && proposal.price.gap >= proposals_constants["x" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["f" /* isSeller */])(_this4.context);
      }) ? BookingEngineForm_jsx(BookingErrors["a" /* BookingErrors */], {
        className: "mt-20 md:mt-30",
        errorCode: (_this$props$proposals3 = this.props.proposals.find(function (_ref3) {
          var errorCode = _ref3.errorCode;
          return !!errorCode;
        })) === null || _this$props$proposals3 === void 0 ? void 0 : _this$props$proposals3.errorCode
      }) : null, this.shouldDisplayModal() && BookingEngineForm_jsx(AlternativeProposalsModal_AlternativeProposalsModal, {
        trackingDefaultPayload: {
          categoryGA: 'resort',
          actionGA: 'checkPricesKO'
        },
        searchCriteria: {
          arrivalDate: String(this.props.arrivalDate),
          duration: this.props.duration,
          adultsCount: this.props.adultsNumber,
          kidsCount: this.props.kids.length,
          departureCity: this.props.departureCity
        } // $FlowFixMe
        ,
        i18n: i18n,
        onClose: this.props.clearProposals,
        onSubmit: this.redirectToBE,
        proposals: this.props.proposals,
        suggestions: this.props.suggestions,
        resort: this.props.resort,
        goToBookingEngine: this.goToBookingEngine,
        bookingEngineEntryPoint: this.props.bookingEngineEntry,
        scrollToBookingEngineEntryPoint: function scrollToBookingEngineEntryPoint() {
          return _this4.scrollToBookingEngineEntryPoint();
        },
        onSelectNewDuration: function onSelectNewDuration(_ref4) {
          var proposalIds = _ref4.proposalIds;

          var queryParams = _objectSpread(_objectSpread({}, omit_default()(_this4.props.router.query, ['dynamicPage'])), {}, {
            proposalIds: proposalIds,
            selectedProposalId: proposalIds[0]
          });

          _this4.props.router.push(routeBuilder["a" /* buildUrl */]('booking', {
            page: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */]
          }, queryParams));
        }
      })));
    }
  }]);

  return BookingEngineForm;
}(react["Component"]);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "defaultProps", defaultProps);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/* harmony default export */ var booking_engine_form_BookingEngineForm = (Object(next_router["withRouter"])(BookingEngineForm_BookingEngineForm));
// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.container.jsx













function BookingEngineForm_container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_container_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function getValue(value, initialValue) {
  return !value && initialValue ? initialValue : value;
}

function getQueryParamValue(name, queryParams) {
  return get_default()(queryParams, name);
}

function getValidDepartureCity(state, props) {
  var _props$bookingCriteri;

  var availableTransports = (props === null || props === void 0 ? void 0 : (_props$bookingCriteri = props.bookingCriteria) === null || _props$bookingCriteri === void 0 ? void 0 : _props$bookingCriteri.departureCities) || [];
  var transportIATACodes = availableTransports.map(function (t) {
    return t.value;
  });
  var departureCity = Object(tripCriteria_selector["a" /* getDepartureCity */])(state) || getQueryParamValue(uri_constants["m" /* QUERY_TRANSPORT */], props.queryParams);
  return transportIATACodes.includes(departureCity) ? departureCity : '';
} // $FlowFixMe


function BookingEngineForm_container_mapStateToProps(state, props) {
  var _props$bookingCriteri2, _props$bookingCriteri3;

  var kids = Object(trip_information_storeHelper["c" /* getKids */])(state);
  var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state).length;
  var duration = Object(tripCriteria_selector["c" /* getTripDuration */])(state);
  var departureCity = getValidDepartureCity(state, props);
  var departureDate = Object(storeHelper["b" /* getDepartureDate */])(state);
  return {
    adultsNumber: getValue(adults, props === null || props === void 0 ? void 0 : (_props$bookingCriteri2 = props.bookingCriteria) === null || _props$bookingCriteri2 === void 0 ? void 0 : _props$bookingCriteri2.initialNumberOfAdults) || constants["a" /* DEFAULT_ADULTS_NB */],
    arrivalDate: Object(storeHelper["a" /* getArrivalDate */])(state),
    bookingEngineEntry: state.booking.bookingEngineEntry,
    departureDate: departureDate,
    departureCity: departureCity,
    duration: getValue(duration, props === null || props === void 0 ? void 0 : (_props$bookingCriteri3 = props.bookingCriteria) === null || _props$bookingCriteri3 === void 0 ? void 0 : _props$bookingCriteri3.initialDuration) || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
    kids: Object(tripInformationUtils["b" /* getResortInitialKids */])(kids, get_default()(props, 'bookingCriteria.initialNumberOfChildren'), get_default()(props, 'resort.adultOnly')),
    proposals: Object(booking_selector["t" /* getProposals */])(state),
    selectedProposalId: Object(booking_selector["v" /* getSelectedProposalId */])(state),
    resort: BookingEngineForm_container_objectSpread(BookingEngineForm_container_objectSpread({}, Object(booking_selector["j" /* getCurrentResort */])(state)), props.resort),
    attendees: Object(booking_selector["l" /* getDetailedAttendees */])(state),
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    suggestions: Object(booking_selector["x" /* getSuggestions */])(state)
  };
}
var BookingEngineForm_container_mapDispatchToProps = {
  clearProposals: proposals_action["f" /* clearProposals */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  updateTripDateCriteria: tripDateCriteria_action["a" /* updateTripDateCriteria */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  clearSelectedProposal: selectedProposalId_action["c" /* clearSelectedProposal */],
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  fetchProposalsAndRedirect: proposals_action["k" /* fetchProposalsAndRedirect */],
  setCms: cms_actions["d" /* setCms */],
  setAttendees: adults_action["b" /* setAttendees */],
  prepareBe: proposals_action["q" /* prepareBe */]
};
/* harmony default export */ var BookingEngineForm_container = __webpack_exports__["a"] = (Object(es["c" /* connect */])(BookingEngineForm_container_mapStateToProps, BookingEngineForm_container_mapDispatchToProps)(booking_engine_form_BookingEngineForm));

/***/ }),

/***/ "JYr1":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dSaG");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "JeoY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.createErrorFactory = createErrorFactory;
exports.default = createValidation;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _synchronousPromise = __webpack_require__("V5RX");

var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return _synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(item) {
      return _Reference.default.isRef(item) ? item.getValue({
        value: value,
        parent: parent,
        context: options.context
      }) : item;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.OPTIONS = options;
  return validate;
}

/***/ }),

/***/ "JgIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceTicketRequest; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _priceTicket_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q/8t");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0OJc");



function priceTicketRequest(_ref) {
  var appContext = _ref.appContext,
      duration = _ref.duration,
      forceAdultPerTrip = _ref.forceAdultPerTrip,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      withDate = _ref.withDate;
  var productArgs = Object(_priceTicket_helper__WEBPACK_IMPORTED_MODULE_1__[/* getProductArgs */ "b"])({
    duration: duration,
    location: location,
    productId: productId,
    transport: transport,
    withDate: withDate
  });
  return function (dispatch, getState) {
    var _state$priceTicket;

    var state = getState();

    if (((_state$priceTicket = state.priceTicket) === null || _state$priceTicket === void 0 ? void 0 : _state$priceTicket.productArgs) === productArgs) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_TICKET_REQUEST_ABORT */ "c"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_TICKET_REQUEST */ "b"], {
      productArgs: productArgs
    }, {
      optimist: true,
      promise: Object(_priceTicket_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetchPrice */ "a"])({
        appContext: appContext,
        duration: duration,
        forceAdultPerTrip: forceAdultPerTrip,
        location: location,
        productId: productId,
        transport: transport,
        withDate: withDate
      })
    }));
  };
}

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "JjZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductInformationSlider_container_ProductInformationSliderContainer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationLayer.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductInformationLayer_ProductInformationLayer = function ProductInformationLayer(_ref) {
  var activeItem = _ref.activeItem,
      backNavigationLabel = _ref.backNavigationLabel,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      renderDetail = _ref.renderDetail,
      toggleLayer = _ref.toggleLayer;

  var _useState = Object(react["useState"])({
    activeItem: activeItem,
    isLoading: false,
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  Object(react["useEffect"])(function () {
    loadDetails();
  }, [activeItem]);

  var closeLayer = function closeLayer() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      isOpen: false
    })); // -1 to indicate that no product has been selected

    toggleLayer(-1, false);
  };

  var updateDetail = function updateDetail(active, detailInfo) {
    setState({
      activeItem: active,
      detail: detailInfo,
      isLoading: false,
      isOpen: true
    });
  };

  var getItem = function getItem(index) {
    return react["Children"].toArray(children)[index];
  };

  var loadDetails = function loadDetails() {
    var item = getItem(activeItem) || {};
    var props = item.props;

    if (props && props.fetchDetail) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      }));
      props.fetchDetail().then(function (data) {
        updateDetail(activeItem, data);
      }).catch(function () {
        updateDetail(activeItem, null);
      });
    }
  };

  var renderActiveDetail = function renderActiveDetail() {
    var item = getItem(activeItem);

    if (!item) {
      return null;
    }

    var leftButton = {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      onClick: closeLayer,
      label: backNavigationLabel
    };
    var ariaLabel = state.detail ? state.detail.label || state.detail.title : '';
    return __jsx(Layer["b" /* Layer */], {
      ariaLabel: ariaLabel,
      bgColor: colors["a" /* COLORS */].WHITE,
      buttonLeft: leftButton,
      closeLabel: Object(i18n["h" /* t */])('common.close'),
      hasAnimateEnter: true,
      hasContainerHeader: true,
      onClose: closeLayer
    }, state.detail ? renderDetail(state.detail) : __jsx("div", {
      "data-testid": "error",
      className: "p-20"
    }, __jsx("div", {
      className: "mx-auto flex max-w-site justify-center"
    }, __jsx(Confirmation["a" /* Confirmation */], {
      status: "error",
      title: errorMessage
    }))));
  };

  return state.isOpen && !state.isLoading ? renderActiveDetail() : state.isLoading && __jsx("div", {
    id: "loading",
    className: "relative z-4"
  }, __jsx(Backdrop["a" /* Backdrop */], {
    className: "bg-white opacity-90"
  }, __jsx("div", {
    "aria-live": "polite",
    className: "absolute left-1/2 top-1/2 w-[208px] -translate-x-1/2 -translate-y-1/2 transform text-center"
  }, __jsx("span", {
    className: "sr-only"
  }, "Loading"), __jsx(Spinner["a" /* Spinner */], {
    "data-testid": "Spinner",
    iconName: icons["a" /* ICONS */].TRIDENT1
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.jsx




















var ProductInformationSlider_jsx = react_default.a.createElement;

function ProductInformationSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationSlider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var themes = {
  default: {
    largeCols: 2,
    desktopCols: 4,
    tabletCols: 3,
    navPosition: ''
  },
  short: {
    largeCols: 2,
    desktopCols: 3,
    tabletCols: 3,
    navPosition: 'center'
  }
};
var ProductInformationSlider_ProductInformationSlider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductInformationSlider, _Component);

  var _super = _createSuper(ProductInformationSlider);

  function ProductInformationSlider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductInformationSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (activeItem) {
      return _this.props.toggleLayer ? _this.props.toggleLayer(activeItem, true) : null;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ProductInformationSlider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isLarge = _this$props.isLarge,
          _this$props$theme = _this$props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme,
          queryLayer = _this$props.queryLayer,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$context = this.context,
          isDesktop = _this$context.isDesktop,
          isTablet = _this$context.isTablet;
      var _themes$theme = themes[theme],
          largeCols = _themes$theme.largeCols,
          desktopCols = _themes$theme.desktopCols,
          tabletCols = _themes$theme.tabletCols,
          navPosition = _themes$theme.navPosition;

      var renderItem = function renderItem(element, index) {
        var _element$props$link = element.props.link,
            link = _element$props$link === void 0 ? {} : _element$props$link;

        if (!link.url) {
          link = ProductInformationSlider_objectSpread(ProductInformationSlider_objectSpread({}, link), {}, {
            onClick: function onClick() {
              return _this2.openLayer && _this2.openLayer(index);
            }
          });
        }

        return /*#__PURE__*/react_default.a.createElement('div', {
          className: 'h-full w-280 md:w-auto'
        }, /*#__PURE__*/react_default.a.cloneElement(element, {
          link: link,
          isLarge: isLarge
        }));
      };

      var getCols = function getCols() {
        if (isTablet) {
          if (isLarge) {
            return largeCols;
          }

          if (isDesktop) {
            return desktopCols;
          }

          return tabletCols;
        }

        return 0;
      };

      var clonedChildren = react["Children"].map(children, renderItem);
      return ProductInformationSlider_jsx("section", null, ProductInformationSlider_jsx(Slider["a" /* Slider */], {
        cols: getCols(),
        hasControls: isTablet,
        id: queryLayer,
        navPosition: navPosition || (isTablet ? 'top' : 'center'),
        nbItemsToScroll: isTablet ? 2 : 1,
        nextLabel: scrollForwardLabel,
        previousLabel: scrollBackwardLabel,
        scrollAreaClassName: "overflow-hidden -mx-10",
        scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
        scrollItemClassName: "overflow-hidden px-10 pb-10 flex-none max-w-full"
      }, clonedChildren));
    }
  }]);

  return ProductInformationSlider;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductInformationSlider_ProductInformationSlider, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);
// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx








var ProductInformationSlider_container_jsx = react_default.a.createElement;






var ProductInformationSlider_container_ProductInformationSliderContainer = function ProductInformationSliderContainer(props) {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var router = Object(next_router["useRouter"])();
  var queryLayer = props.queryLayer,
      sliderIndex = props.sliderIndex;
  var asPath = router.asPath;

  var _getOpenLayersFromLoc = Object(uriUtils["h" /* getOpenLayersFromLocation */])(asPath, queryLayer),
      _getOpenLayersFromLoc2 = Object(slicedToArray["a" /* default */])(_getOpenLayersFromLoc, 2),
      uriSliderIndex = _getOpenLayersFromLoc2[0],
      uriActiveItem = _getOpenLayersFromLoc2[1];

  var uri = new URI_default.a(asPath);
  Object(react["useEffect"])(function () {
    if (uri.hasQuery(queryLayer) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [asPath]);
  /**
   * Close the layer from back navigation button
   */

  var closeLayer = function closeLayer() {
    setActiveItem(-1);
  };

  Object(react["useEffect"])(function () {
    window.addEventListener('popstate', closeLayer);
    return function () {
      window.removeEventListener('popstate', closeLayer);
    };
  }, []);

  var toggleLayer = function toggleLayer(item, layer) {
    var newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.hash('').addQuery(queryLayer, "".concat(sliderIndex, "_").concat(item));
      router.push(newUrl.toString(), undefined, {
        shallow: true
      });
    } else {
      newUrl = newUrl.removeQuery(queryLayer);
      router.replace(newUrl.toString(), undefined, {
        shallow: true
      });
    }

    setActiveItem(item);
  };

  return ProductInformationSlider_container_jsx(react["Fragment"], null, ProductInformationSlider_container_jsx(ProductInformationSlider_ProductInformationSlider, Object(esm_extends["a" /* default */])({}, props, {
    toggleLayer: toggleLayer
  })), ProductInformationSlider_container_jsx(ProductInformationLayer_ProductInformationLayer, Object(esm_extends["a" /* default */])({}, props, {
    activeItem: activeItem,
    toggleLayer: toggleLayer
  })));
};

/***/ }),

/***/ "Jm8J":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("aXF+");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "JpEK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var getPrototypeOf = __webpack_require__("yvHl");
var defineBuiltIn = __webpack_require__("Swp0");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(state) {
  return (state === null || state === void 0 ? void 0 : state.tripInformation) || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref2) {
  var adults = _ref2.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var kids = _ref4.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var mainContact = _ref5.mainContact;
  return mainContact;
});


/***/ }),

/***/ "KXRF":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "Kl3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useGQLErrorsHandler; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("L7OA");










var redirectOnLoginPage = _ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* redirectOnLoginPage */ "n"],
    hasAuthResponseError = _ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* hasAuthResponseError */ "l"],
    hasNotFoundError = _ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* hasNotFoundError */ "m"];
function useGQLErrorsHandler() {
  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_3__["useRouter"])(),
      asPath = _useRouter.asPath;

  var pathname = new urijs__WEBPACK_IMPORTED_MODULE_5___default.a(asPath).pathname();
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* useAppContext */ "c"])(); // Need at least Query & Options

  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (params.length < 2) {
    throw new Error('useGQLErrorsHandler must have at least an error and an option configuration');
  }

  var options = params[params.length - 1];
  var errors = params.slice(0, params.length - 1);

  if (!options.hasOwnProperty('catchAuthError') && !options.hasOwnProperty('catchNotFoundError') && !options.hasOwnProperty('handler')) {
    throw new Error('The last params must be the options configuration (catchAuthError, catchNotFoundError, handler)');
  }

  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    var containAuthError = !!errors.find(hasAuthResponseError);
    var containNotFoundError = !!errors.find(hasNotFoundError);

    if (options.catchAuthError && containAuthError) {
      redirectOnLoginPage({
        locale: appContext.locale,
        redirectPath: pathname,
        isQuickLoginFirst: Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_9__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.isQuickLoginFirst'),
        isSeller: appContext.isSeller,
        isCmta: appContext.isCmta
      });
      return;
    }

    if (options.catchNotFoundError && containNotFoundError) {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__["windowWrapper"].setLocation('/404');
      return;
    }

    if (options.handler && errors.some(Boolean)) {
      options.handler(errors);
    }
  }, errors);
}

/***/ }),

/***/ "L/zD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloneTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return transformToViewState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyViewStateToTransform; });
/**
 * Make a copy of a transform
 * @param tr
 */
function cloneTransform(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
/**
 * Capture a transform's current state
 * @param transform
 * @returns descriptor of the view state
 */
function transformToViewState(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
/* eslint-disable complexity */
/**
 * Mutate a transform to match the given view state
 * @param transform
 * @param viewState
 * @returns true if the transform has changed
 */
function applyViewStateToTransform(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ('longitude' in v && 'latitude' in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    if ('zoom' in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ('bearing' in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ('pitch' in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    return changed;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ "LEY8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _passiveEvents = __webpack_require__("6mUV");

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reliable `window` and `document` detection
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Check `document` and `window` in case of server-side rendering
/* eslint-disable */
/**
* Detect Element Resize.
* Forked in order to guard against unsafe 'window' and 'document' references.
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

var _window;
if (canUseDOM) {
  _window = window;
} else if (typeof self !== 'undefined') {
  _window = self;
} else {
  _window = undefined;
}

var attachEvent = typeof document !== 'undefined' && document.attachEvent;
var stylesCreated = false;

if (canUseDOM && !attachEvent) {
  var requestFrame = function () {
    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
      return _window.setTimeout(fn, 20);
    };
    return function (fn) {
      return raf(fn);
    };
  }();

  var cancelFrame = function () {
    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
    return function (id) {
      return cancel(id);
    };
  }();

  var resetTriggers = function resetTriggers(element) {
    var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
    contract.scrollLeft = contract.scrollWidth;
    contract.scrollTop = contract.scrollHeight;
    expandChild.style.width = expand.offsetWidth + 1 + 'px';
    expandChild.style.height = expand.offsetHeight + 1 + 'px';
    expand.scrollLeft = expand.scrollWidth;
    expand.scrollTop = expand.scrollHeight;
  };

  var checkTriggers = function checkTriggers(element) {
    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
  };

  var scrollListener = function scrollListener(e) {
    var element = this;
    resetTriggers(this);
    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
    this.__resizeRAF__ = requestFrame(function () {
      if (checkTriggers(element)) {
        element.__resizeLast__.width = element.offsetWidth;
        element.__resizeLast__.height = element.offsetHeight;
        element.__resizeListeners__.forEach(function (fn) {
          fn.call(element, e);
        });
      }
    });
  };

  /* Detect CSS Animations support to detect element display/re-attach */
  var animation = false,
      animationstring = 'animation',
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';

  if (canUseDOM) {
    var elm = document.createElement('fakeelement');
    if (elm.style.animationName !== undefined) {
      animation = true;
    }

    if (animation === false) {
      for (var i = 0; i < domPrefixes.length; i++) {
        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
          pfx = domPrefixes[i];
          animationstring = pfx + 'Animation';
          keyframeprefix = '-' + pfx.toLowerCase() + '-';
          animationstartevent = startEvents[i];
          animation = true;
          break;
        }
      }
    }
  }

  var animationName = 'resizeanim';
  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
}

var createStyles = function createStyles() {
  if (!stylesCreated) {
    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    stylesCreated = true;
  }
};

var addResizeListener = function addResizeListener(element, fn) {
  if (element.parentNode === undefined) {
    var tempParentDiv = document.createElement('div');
    element.parentNode = tempParentDiv;
  }
  element = element.parentNode;
  if (attachEvent) element.attachEvent('onresize', fn);else {
    if (!element.__resizeTriggers__) {
      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
      createStyles();
      element.__resizeLast__ = {};
      element.__resizeListeners__ = [];
      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
      element.appendChild(element.__resizeTriggers__);
      resetTriggers(element);

      (0, _passiveEvents2.default)(element, 'scroll', scrollListener, true);

      /* Listen for a css animation to detect element display/re-attach */
      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
        if (e.animationName == animationName) resetTriggers(element);
      });
    }
    element.__resizeListeners__.push(fn);
  }
};

var removeResizeListener = function removeResizeListener(element, fn) {
  element = element.parentNode;
  if (attachEvent) element.detachEvent('onresize', fn);else {
    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
    if (!element.__resizeListeners__.length) {
      element.removeEventListener('scroll', scrollListener);
      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
    }
  }
};

module.exports = {
  addResizeListener: addResizeListener,
  removeResizeListener: removeResizeListener
};

/***/ }),

/***/ "LFxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("kZDm");
var defineBuiltIns = __webpack_require__("D092");
var getWeakData = __webpack_require__("wKkN").getWeakData;
var anInstance = __webpack_require__("V/va");
var anObject = __webpack_require__("ep/x");
var isNullOrUndefined = __webpack_require__("nnO8");
var isObject = __webpack_require__("1YFU");
var iterate = __webpack_require__("ZuH9");
var ArrayIterationModule = __webpack_require__("VrMI");
var hasOwn = __webpack_require__("/GgU");
var InternalStateModule = __webpack_require__("9jKB");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ "LR4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LabeledIconsList_LabeledIconsList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/chunk.js
var chunk = __webpack_require__("RBiB");
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center',
    thListWidth: 'w-1/2',
    thListRoot: 'flex flex-row flex-wrap gap-x-10 gap-y-20 justify-between w-full',
    thItem: 'flex gap-30 items-center leading-normal text-center text-current text-16 w-280',
    thIcon: 'flex items-center justify-center leading-0',
    thIconWidth: '2.5rem',
    thLabels: 'text-black'
  },
  list: {
    thRoot: 'flex flex-wrap',
    thListWidth: 'md:w-1/2',
    thListRoot: 'flex flex-col gap-20',
    thItem: 'flex gap-10 items-start w-280',
    thIcon: 'flex shrink-0 items-center justify-center leading-0',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal text-14 text-black'
  },
  listCondensed: {
    thRoot: 'flex',
    thListWidth: 'md:w-1/2',
    thListRoot: 'flex flex-col gap-20',
    thItem: 'flex gap-10 items-start',
    thIcon: 'flex shrink-0 items-center justify-center leading-0',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal text-14 text-black'
  },
  comparator: {
    thRoot: 'h-full',
    thListRoot: 'flex font-bold h-1/2',
    thListFirst: 'py-15 border-lightGrey',
    thListSubsequent: 'border-t-1 py-15 border-lightGrey -mt-1',
    thItem: 'flex flex-1 px-20 flex-col items-center text-center',
    thItemNth: 'border-s-1 border-lightGrey',
    thIconWidth: '2.5rem',
    thLabels: 'text-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx






var __jsx = react_default.a.createElement;






var LabeledIconsList_LabeledIconsListItems = function LabeledIconsListItems(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      isMoreThanOneList = _ref.isMoreThanOneList,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$listIndex = _ref.listIndex,
      listIndex = _ref$listIndex === void 0 ? 0 : _ref$listIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thItemNth = _themes$theme.thItemNth,
      thLabels = _themes$theme.thLabels,
      thListRoot = _themes$theme.thListRoot,
      thListWidth = _themes$theme.thListWidth,
      thListFirst = _themes$theme.thListFirst,
      thListSubsequent = _themes$theme.thListSubsequent;
  return __jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])("text-".concat(color), thListRoot, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListWidth, isMoreThanOneList), Object(defineProperty["a" /* default */])(_classnames, thListFirst, listIndex === 0), Object(defineProperty["a" /* default */])(_classnames, thListSubsequent, listIndex !== 0), _classnames))
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return __jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])(thItem, Object(defineProperty["a" /* default */])({}, thItemNth, idx > 0)),
      "data-testid": "LabeledIconsList-item",
      key: idx
    }, __jsx("div", {
      className: thIcon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth,
      alt: (labels || []).join('/')
    })), !!labels.length && __jsx("div", {
      className: thLabels
    }, labels.map(function (label) {
      return __jsx("div", {
        "data-testid": "LabeledIconsList-label",
        key: label
      }, label);
    })));
  }));
};

var LabeledIconsList_LabeledIconsList = function LabeledIconsList(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  if (!items.length) {
    return null;
  }

  var shouldSplitItems = theme !== 'default' && items.length > 2;
  var thRoot = themes[theme].thRoot;

  var splitItems = chunk_default()(Object(toConsumableArray["a" /* default */])(items), Math.ceil(items.length / 2));

  var isMoreThanOneList = splitItems.length > 1;
  return __jsx("div", {
    className: thRoot
  }, shouldSplitItems ? splitItems.map(function (splitItem, idx) {
    return __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
      key: idx,
      listIndex: idx,
      isMoreThanOneList: isMoreThanOneList,
      items: splitItem
    }));
  }) : __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
    listIndex: 0,
    items: items
  })));
};

/***/ }),

/***/ "LTtw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var getOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var createNonEnumerableProperty = __webpack_require__("g51W");
var defineBuiltIn = __webpack_require__("Swp0");
var defineGlobalProperty = __webpack_require__("9vpE");
var copyConstructorProperties = __webpack_require__("sfoL");
var isForced = __webpack_require__("wxLG");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "Lc/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_REMOTE_STICKY_WRAPPER_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_REMOTE_FORM_ID; });
var PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME = 'PriceRemoteStickyWrapper-initialPosition';
var PRICE_REMOTE_STICKY_WRAPPER_SELECTOR = ".".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME);
var PRICE_REMOTE_FORM_ID = 'price-remote-form';

/***/ }),

/***/ "LdEA":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "Lf/v":
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__("fysP");

/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = createRound('ceil');

module.exports = ceil;


/***/ }),

/***/ "Lo6J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = setLocale;

var _locale = _interopRequireDefault(__webpack_require__("qr7w"));

function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    Object.keys(custom[type]).forEach(function (method) {
      _locale.default[type][method] = custom[type][method];
    });
  });
}

module.exports = exports["default"];

/***/ }),

/***/ "M2Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapbox; });
/* harmony import */ var _utils_transform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("L/zD");
/* harmony import */ var _utils_style_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("r2he");
/* harmony import */ var _utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("/xkv");



const pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
/**
 * A wrapper for mapbox-gl's Map class
 */
class Mapbox {
    constructor(MapClass, props, container) {
        // mapboxgl.Map instance. Not using type here because we are accessing
        // private members and methods
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e) => {
            // @ts-ignore
            const cb = this.props[otherEvents[e.type]];
            if (cb) {
                cb(e);
            }
        };
        this._onPointerEvent = (e) => {
            if (e.type === 'mousemove' || e.type === 'mouseout') {
                this._updateHover(e);
            }
            // @ts-ignore
            const cb = this.props[pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') {
                    const features = this._hoveredFeatures ||
                        this._map.queryRenderedFeatures(e.point, {
                            layers: this.props.interactiveLayerIds
                        });
                    e.features = features;
                }
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e) => {
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[cameraEvents[e.type]];
                if (cb) {
                    cb(e);
                }
            }
            if (e.type in this._deferredEvents) {
                this._deferredEvents[e.type] = false;
            }
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) {
            this._createShadowTransform(this._map);
        }
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || (viewStateChanged && !this._map.isMoving())) {
            this.redraw();
        }
    }
    static reuse(props, container) {
        const that = Mapbox.savedMaps.pop();
        if (!that) {
            return null;
        }
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while (oldContainer.childNodes.length > 0) {
            container.appendChild(oldContainer.childNodes[0]);
        }
        // Step2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // Step 3: apply new props
        if (props.initialViewState) {
            that._updateViewState(props.initialViewState, false);
        }
        map.resize();
        that.setProps({ ...props, styleDiffing: false });
        // Simulate load event
        if (map.isStyleLoaded()) {
            map.fire('load');
        }
        else {
            map.once('styledata', () => map.fire('load'));
        }
        return that;
    }
    /* eslint-disable complexity,max-statements */
    _initialize(container) {
        const { props } = this;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || getAccessTokenFromEnv() || null,
            container,
            style: Object(_utils_style_utils__WEBPACK_IMPORTED_MODULE_1__[/* normalizeStyle */ "a"])(props.mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [viewState.longitude || 0, viewState.latitude || 0],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = () => {
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) {
            map.setPadding(viewState.padding);
        }
        if (props.cursor) {
            map.getCanvas().style.cursor = props.cursor;
        }
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg) => {
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg) => {
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on('render', () => this._onAfterRepaint());
        // Insert code into map's event pipeline
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('resize', () => {
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on('styledata', () => this._updateStyleComponents(this.props, {}));
        map.on('sourcedata', () => this._updateStyleComponents(this.props, {}));
        for (const eventName in pointerEvents) {
            map.on(eventName, this._onPointerEvent);
        }
        for (const eventName in cameraEvents) {
            map.on(eventName, this._onCameraEvent);
        }
        for (const eventName in otherEvents) {
            map.on(eventName, this._onEvent);
        }
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */
    recycle() {
        Mapbox.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = Object(_utils_transform__WEBPACK_IMPORTED_MODULE_0__[/* cloneTransform */ "b"])(map.transform);
        map.painter.transform = renderTransform;
        // Terrain update is called by the painter
        // Elevation changes must be reflected back to the original transform so that input handlers work correctly
        // @ts-ignore method may be undefined
        const updateElevation = renderTransform.updateElevation;
        if (updateElevation) {
            // @ts-ignore
            renderTransform.updateElevation = arg => {
                map.transform.elevation = renderTransform.elevation;
                updateElevation.call(renderTransform, arg);
                updateElevation.call(map.transform, arg);
            };
        }
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */
    _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */
    _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) {
            return false;
        }
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom, pitch, bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) {
            // All movement of the camera is done relative to the sea level
            tr.cameraElevationReference = 'sea';
        }
        const changed = Object(_utils_transform__WEBPACK_IMPORTED_MODULE_0__[/* applyViewStateToTransform */ "a"])(tr, {
            ...Object(_utils_transform__WEBPACK_IMPORTED_MODULE_0__[/* transformToViewState */ "c"])(map.transform),
            ...nextProps
        });
        if (isMoving) {
            // Reset camera reference
            tr.cameraElevationReference = 'ground';
        }
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) {
            Object(_utils_transform__WEBPACK_IMPORTED_MODULE_0__[/* applyViewStateToTransform */ "a"])(map.transform, nextProps);
        }
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */
    _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of settingNames) {
            if (propName in nextProps && !Object(_utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__[/* deepEqual */ "b"])(nextProps[propName], currProps[propName])) {
                changed = true;
                map[`set${propName[0].toUpperCase()}${propName.slice(1)}`](nextProps[propName]);
            }
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */
    _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) {
            this._map.getCanvas().style.cursor = nextProps.cursor;
        }
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const options = {
                diff: nextProps.styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) {
                options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            }
            this._map.setStyle(Object(_utils_style_utils__WEBPACK_IMPORTED_MODULE_1__[/* normalizeStyle */ "a"])(nextProps.mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */
    _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.style.loaded()) {
            if ('light' in nextProps && !Object(_utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__[/* deepEqual */ "b"])(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && !Object(_utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__[/* deepEqual */ "b"])(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && !Object(_utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__[/* deepEqual */ "b"])(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */
    _updateHandlers(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of handlerNames) {
            const newValue = nextProps[propName];
            if (!Object(_utils_deep_equal__WEBPACK_IMPORTED_MODULE_2__[/* deepEqual */ "b"])(newValue, currProps[propName])) {
                changed = true;
                if (newValue) {
                    map[propName].enable(newValue);
                }
                else {
                    map[propName].disable();
                }
            }
        }
        return changed;
    }
    _updateHover(e) {
        var _a;
        const { props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            let features;
            if (eventType === 'mousemove') {
                try {
                    features = this._map.queryRenderedFeatures(e.point, {
                        layers: props.interactiveLayerIds
                    });
                }
                catch (_b) {
                    features = [];
                }
            }
            else {
                features = [];
            }
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        }
        else {
            this._hoveredFeatures = null;
        }
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === 'string' ? event : event.type;
        if (eventType === 'move') {
            this._updateViewState(this.props, false);
        }
        if (eventType in cameraEvents) {
            if (typeof event === 'object') {
                event.viewState = Object(_utils_transform__WEBPACK_IMPORTED_MODULE_0__[/* transformToViewState */ "c"])(tr);
            }
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for (const eventType in this._deferredEvents) {
            if (this._deferredEvents[eventType]) {
                map.fire(eventType);
            }
        }
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        this._map.transform = this._renderTransform;
        this._onAfterRepaint = () => {
            // Restores camera state before render/load events are fired
            this._map.transform = tr;
        };
    }
}
Mapbox.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */
function getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */
    if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || process.env.MapboxAccessToken;
    }
    catch (_a) {
        // ignore
    }
    try {
        accessToken = accessToken || process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    }
    catch (_b) {
        // ignore
    }
    return accessToken;
}
//# sourceMappingURL=mapbox.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");





var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["constants"].NO_TRANSPORT_VALUE;
var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      toggleCriteriaExpansion = _ref.toggleCriteriaExpansion,
      validateDepartureCity = _ref.validateDepartureCity,
      withNoTransport = _ref.withNoTransport,
      _ref$shouldShowNoTran = _ref.shouldShowNoTransportButtonMobile,
      shouldShowNoTransportButtonMobile = _ref$shouldShowNoTran === void 0 ? true : _ref$shouldShowNoTran;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var value = departureCity || '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  var otherDepartureCities = withNoTransport ? optionsDepartureCities : optionsDepartureCities.filter(function (_ref2) {
    var departureCityCode = _ref2.value;
    return departureCityCode !== NO_TRANSPORT_VALUE;
  });
  var mainCities = Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* getListValue */ "e"])('faceting.transport.departureCities.mainCitiesList') || [];
  var optionsMainDepartureCities = optionsDepartureCities.filter(function (_ref3) {
    var cityCode = _ref3.value;
    return mainCities.includes(cityCode);
  });

  var renderTitle = function renderTitle(shouldShowNoTransportButton) {
    if (!isDesktop) {
      return __jsx("div", {
        className: "flex flex-col"
      }, shouldShowNoTransportButton && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('px-20 py-15', {
          'font-bold text-success': value === NO_TRANSPORT_VALUE
        })
      }, __jsx("label", {
        className: "flex cursor-pointer items-baseline justify-between rounded-2 hocus:bg-lightGrey",
        htmlFor: NO_TRANSPORT_VALUE
      }, __jsx("input", {
        checked: value === NO_TRANSPORT_VALUE,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(NO_TRANSPORT_VALUE),
        disabled: isDisabled,
        id: NO_TRANSPORT_VALUE,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        onClick: function onClick(e) {
          return validateDepartureCity(e.target.value);
        },
        type: "radio",
        value: NO_TRANSPORT_VALUE
      }), Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.noTransportNeededMobile'), value === NO_TRANSPORT_VALUE && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      }))), __jsx("div", {
        className: "border-b-1 border-lightGrey p-20 py-15"
      }, __jsx("p", {
        className: "text-16 font-bold"
      }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.transportNeededMobile'))));
    }

    return __jsx("div", {
      className: "border-b-1 border-lightGrey p-20 py-15"
    }, __jsx("p", {
      className: "text-16 font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.when.from')));
  };

  var renderDepartureCitiesOptions = function renderDepartureCitiesOptions(departureCities) {
    return departureCities.map(function (o) {
      return __jsx("li", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])({
          'font-bold text-success': o.value === value
        }),
        key: o.value,
        "data-testid": "filterTransport-city"
      }, __jsx("label", {
        className: "-mx-20 flex cursor-pointer items-baseline justify-between rounded-2 px-20 py-5 hocus:bg-lightGrey",
        htmlFor: o.value
      }, __jsx("input", {
        checked: o.value === value,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(o.value),
        disabled: o.isDisabled || isDisabled,
        id: o.value,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        type: "radio",
        value: o.value
      }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      })));
    });
  };

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('flex flex-col', className),
    "data-testid": "FilterTransport"
  }, renderTitle(shouldShowNoTransportButtonMobile), loading ? __jsx("div", {
    className: "flex flex-1 items-center justify-center p-20 leading-0"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("div", {
    className: "max-h-none overflow-y-auto px-20 text-14 lg:max-h-240"
  }, optionsMainDepartureCities.length > 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.mainCities')), __jsx("ul", {
    className: "mb-10 flex-1 pb-5 lg:flex-none"
  }, renderDepartureCitiesOptions(optionsMainDepartureCities)), __jsx("p", {
    className: "border-b-1 border-dashed border-grey py-5 text-mediumGrey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.allCities'))), __jsx("ul", {
    className: "flex-1 lg:flex-none"
  }, renderDepartureCitiesOptions(otherDepartureCities))));
};

/***/ }),

/***/ "M4Qz":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var hasOwn = __webpack_require__("/GgU");
var toIndexedObject = __webpack_require__("dNjr");
var indexOf = __webpack_require__("5LiQ").indexOf;
var hiddenKeys = __webpack_require__("qXr/");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchValidationSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return streetViewsByAccommodationCategoryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidationSchema; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("H0gB");
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SQLw");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("BYx+");
/* harmony import */ var _store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("2GfD");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      accommodations {\n        area {\n          max\n          min\n          unit\n        }\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        description\n        equipments {\n          id\n          label\n          ranking\n        }\n        exclusiveCollection\n        floorPlans\n        id\n        label\n        maxCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        minCapacity\n        outsideFacilities {\n          id\n          label\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n          ranking\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      ".concat(fetchActivityCategories ? "activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }" : '', "\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childcareDetails {\n        isIncluded: included\n        ageInMonths {\n          min\n          max\n        }\n      }\n      childrenActivities: productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\",\"PARKING\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n        type\n      }\n      factSheetUrl\n      href\n      id\n      image\n      images\n      hasECSpace\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      isUrbanOasis\n      isWinter\n      name\n      offsetSell\n      openingDates {\n        opening\n        closing\n      }\n      ").concat(fetchActivityCategories ? "rentalsTree {\n        ...rentals\n      }" : '', "\n      seasonName\n      seasons\n      title\n      transportType\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            startDate\n            endDate\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n        wellness {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema(proposalIds, resource, locale) {
  var proposalId = Array.isArray(proposalIds) ? proposalIds[0] : proposalIds;
  return "\n    {\n      validationSchema(\n        proposalId: \"".concat(proposalId || '', "\",\n        resource : \"").concat(resource, "\",\n        fields: [\"address\"],\n        locale: \"").concat(locale || '', "\") {\n        ...ValidationSchemaField\n      }\n    }\n    ").concat(_store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"], "\n    ");
}

function fetchValidationSchema(_x, _x2, _x3) {
  return _fetchValidationSchema.apply(this, arguments);
}

function _fetchValidationSchema() {
  _fetchValidationSchema = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(proposalId, appContext, resource) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery(getValidationSchema(proposalId, resource), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_SCHEMA */ "Qc"]
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchValidationSchema.apply(this, arguments);
}

var getAttendeesData = function getAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n          identityNumber\n          healthPassId\n          address {\n            streetNumber\n            streetName\n            additionalInformation1\n            additionalInformation2\n            addOn\n            zipCode\n            city\n            town\n            stateOrDistrict\n            countryCode\n            country\n          }\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              birthCity\n              secondName\n              thirdName\n              fourthName\n              type\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              birthCity\n              secondName\n              thirdName\n              fourthName\n              type\n            }\n          }\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          healthPassId\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n          }\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v2/proposals/{proposal_id}
 */


function proposalsByIdQuery(_x4, _x5) {
  return _proposalsByIdQuery.apply(this, arguments);
}
/*
 * * Used in fetchStreetViewsByAccommodationCategoryId to get street views list for <AccommodationRoomSlideshow/>
 * * Uses  API route GET /v0/products/{product_id}/accommodation_categories/{accommodation_category_id}/virtual_visits
 */


function _proposalsByIdQuery() {
  _proposalsByIdQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(params, appContext) {
    var _proposalsResponse$pr, _params$adultsAttende, _params$kidsAttendees;

    var proposalsArgs, displayCommission, proposalsResponse, proposals, selectedProposal, adultsAttendeesIds, kidsAttendeesIds, hasAttendeeIds, validationSchema, attendeesResponse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalsArgs = ["ids: [\"".concat(Array.isArray(params.proposalsId) ? params.proposalsId.join('","') : params.proposalsId, "\"]")];
            displayCommission = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            _context2.next = 4;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n          ... on ProposalsType {\n            proposals {\n              ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* proposalFields */ "k"])({
              isJoyView: true,
              isUrbanOasis: true,
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission,
              withSchedule: params.shouldRequestPayment
            }, appContext), "\n            }\n            ").concat(getResort(params.fetchActivityCategories), "\n          }\n        }\n        ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n        ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* paymentProvidersRequest */ "i"])() : '', "\n      }\n      ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* transportDetailsFragment */ "q"], "\n      ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* getPriceDetailFragment */ "h"])(lodash_get__WEBPACK_IMPORTED_MODULE_14___default()(appContext, 'locale')), "\n      ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__[/* profileFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityCategoryFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories || _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"] ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityFragment */ "b"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* rentalsFragment */ "f"] : '', "\n      ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"], "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Oc"]
            });

          case 4:
            proposalsResponse = _context2.sent;
            proposals = ((_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : _proposalsResponse$pr.proposals) || [];
            selectedProposal = params.selectedProposalId && proposals.find(function (_ref2) {
              var id = _ref2.id;
              return id === params.selectedProposalId;
            }) || proposals[0];

            if (selectedProposal) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", _objectSpread({}, proposalsResponse));

          case 9:
            adultsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende.length) ? params.adultsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.adults) || []).map(function (_ref3) {
              var customerId = _ref3.customerId;
              return customerId;
            }).filter(Boolean);
            kidsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees.length) ? params.kidsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.children) || []).map(function (_ref4) {
              var customerId = _ref4.customerId;
              return customerId;
            }).filter(Boolean);
            hasAttendeeIds = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(adultsAttendeesIds) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(kidsAttendeesIds);
            _context2.next = 14;
            return fetchValidationSchema(selectedProposal.id, appContext, 'profile');

          case 14:
            validationSchema = _context2.sent;

            if (!(!appContext.isSeller || !hasAttendeeIds)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", _objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), validationSchema));

          case 17:
            _context2.next = 19;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        ".concat( // When it is an attendee identified on the Cxo side we already know the customerIds
            // via the cxo_traveler query param
            getAttendeesData({
              adultsAttendeesIds: adultsAttendeesIds,
              kidsAttendeesIds: kidsAttendeesIds
            }), "\n      }\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat(adultsAttendeesIds && adultsAttendeesIds[0] || kidsAttendeesIds && kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Oc"]
            });

          case 19:
            attendeesResponse = _context2.sent;
            return _context2.abrupt("return", _objectSpread(_objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), attendeesResponse), validationSchema));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _proposalsByIdQuery.apply(this, arguments);
}

function streetViewsByAccommodationCategoryId(params, appContext) {
  var streetViewsArgs = ["productId: \"".concat(params.productId, "\"")];
  streetViewsArgs.push(Array.isArray(params.accommodationCategoryIds) ? "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds.join('","'), "\"]") : "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds, "\"]"));
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n    {\n      streetViews(".concat(streetViewsArgs.join(', '), ") {\n        accommodationCategoryId\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n          url\n        }\n      }\n    }\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* STREET_VIEW_GET_SEVERAL */ "ld"]
  });
}



/***/ }),

/***/ "MRpX":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var setPrototypeOf = __webpack_require__("iBXc");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "MU85":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");
var getMethod = __webpack_require__("Uey1");
var isNullOrUndefined = __webpack_require__("nnO8");
var Iterators = __webpack_require__("oa0l");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "MX/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_TRANSPORT_EVENT; });
var OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';

/***/ }),

/***/ "MaE1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = global;


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "Mv+R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("JpEK").IteratorPrototype;
var create = __webpack_require__("Znn2");
var createPropertyDescriptor = __webpack_require__("OouP");
var setToStringTag = __webpack_require__("CGO5");
var Iterators = __webpack_require__("oa0l");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "N+pC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HappyToCare; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("u/u4");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("Gy6l");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("A5Hi");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */













var mainBlockStyles = {
  default: {
    maxHeight: 'min(calc(300rem / 16), 100vw)',
    maxWidth: '320px'
  },
  large: {
    maxHeight: 'min(calc(300rem / 16), 100vw)',
    maxWidth: '700px'
  }
};
var sliderContainerStyles = {
  margin: '0 calc(-1 * ((100vw - min(320px, calc(100vw - 30px))) / 2 + 20px))',
  padding: '0 calc((100vw - min(320px, calc(100vw - 30px))) / 2 + 15px)' // I plead guilty for layout crimes, put me in jail ASAP

};

var getSlideItem = function getSlideItem(item, index, hasTwoItems) {
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mx-auto px-5 leading-tight text-black md:p-0 lg:w-full', {
      'order-first': hasTwoItems && index === 0,
      'max-w-300 lg:mt-80': hasTwoItems,
      'max-w-360': !hasTwoItems
    }),
    key: item.title
  }, item.imageUrl && __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_24__[/* default */ "b"], {
    className: "overflow-hidden rounded-12",
    imageUrl: item.imageUrl,
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_17__[/* default */ "c"].XL
  }), __jsx("div", {
    className: "pt-15 text-16 font-bold"
  }, item.title), __jsx("div", {
    className: "pt-10 text-14 leading-normal"
  }, item.description));
};

var getSeeMoreButton = function getSeeMoreButton(url, hasTwoItems, isTablet, onClick) {
  var TagName = url ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"] : 'div';
  var props = url ? {
    onClick: onClick,
    target: '_blank',
    url: url
  } : {};
  return __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])({
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-auto flex flex-col items-center text-center text-12', {
      'text-verdigris active:text-verdigris-active hocus:text-verdigris-active': !hasTwoItems && isTablet || !isTablet,
      'text-ultramarine': hasTwoItems && isTablet
    })
  }, props), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].NEEDLE,
    width: "1.875rem"
  }), !!url && __jsx("span", {
    className: "underline",
    "data-testid": "HTCLink"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('common.seeMore')));
};

var Background = function Background() {
  return __jsx("svg", {
    className: "-z-1 shrink-0 overflow-visible lg:mt-50",
    height: 460,
    viewBox: "0 0 680 680",
    width: 460
  }, __jsx("path", {
    d: "M172 339c0 5-49 14-83 13-35 0-89-10-89-15s53-13 88-13c36 1 84 9 84 15m55 226c14-32 41-72 46-70 4 2-6 50-20 81s-45 76-50 75c-5-2 9-53 24-86Zm-49-32c21-28 56-61 61-58 4 3-18 47-39 74-20 28-60 65-65 62-4-3 21-50 43-78Zm-40-43c27-22 68-46 72-42s-27 42-54 63c-27 22-74 49-78 45-3-4 32-43 60-66Zm-30-51c32-15 78-29 81-24 2 4-37 34-68 49s-84 30-86 26c-2-5 41-35 73-51Zm-16-56c34-8 82-10 84-6v1c1 5-44 25-78 32-33 8-87 10-89 6l-1-1c-1-5 49-24 84-32Zm218 123c5 1 6 50 0 84-7 34-26 86-31 85s-4-54 3-89c6-36 23-81 28-80m40 3c5 0 17 47 18 82 2 34-5 89-10 89s-16-52-18-87c-2-36 4-84 10-84m150-110c2-5 50 3 82 15s79 40 78 45-54-6-87-18c-33-13-74-37-73-42Zm-18 35c3-4 48 14 77 34 28 19 67 57 65 61v1c-3 4-51-19-81-39-29-19-63-52-61-57Zm-26 30c4-4 44 25 67 50 23 26 53 71 50 76-4 3-46-30-70-56s-50-66-47-70Zm-32 23h1c4-3 36 35 53 65 17 29 35 81 31 84-5 3-38-39-55-70-18-31-34-76-30-79Zm-36 15c5-1 28 42 37 76 10 32 16 86 11 89-5 1-28-47-37-81-10-34-15-81-11-84Zm121-141c1-5 50-9 84-4 34 4 87 20 86 25 0 5-53 7-89 3-35-5-82-19-81-24m0-40c0-5 47-19 81-23s89 0 90 5-51 19-86 23c-36 4-84 0-85-5m65-79c32-12 86-20 88-16 2 5-45 30-78 42-34 12-81 20-83 15s40-30 73-41Zm-29-51c29-19 79-40 82-36h1c2 5-37 40-67 59s-74 38-78 34c-3-4 33-39 62-57Zm-40-43c24-25 68-57 72-54 4 4-27 47-51 73-25 25-63 54-68 51-4-4 23-45 47-70Zm-49-33c18-29 53-70 58-69 5 3-15 52-33 83s-49 67-54 65c-5-3 12-49 29-79Zm-55-20c10-33 36-82 41-81 5 2-3 54-14 89-10 33-32 76-37 75s0-50 10-83ZM364 0c5 0 10 53 7 89-2 36-14 82-19 82s-11-49-9-83c2-35 16-88 21-88m-79 4c5-1 22 49 27 85 6 35 6 83 1 84s-23-45-28-79c-6-34-5-89 0-90m-76 22c4-2 32 43 46 76s25 79 20 82c-5 2-32-39-46-71-13-31-25-85-20-87Zm-69 39c4-3 42 34 63 63 20 29 42 72 38 75s-40-30-61-58c-20-27-44-76-40-80Zm-58 54c3-4 48 23 75 47 27 23 58 60 55 64s-46-20-72-42c-27-23-62-66-58-69Zm-44 65c2-4 52 12 84 29 32 16 70 45 68 50-2 4-49-9-80-25s-75-49-72-54Zm-28 74c1-5 54 0 89 9 34 8 78 27 77 32v1c-1 5-50 2-83-6-34-8-83-30-83-36Z",
    fill: "#F7F7F7"
  }));
};

var HappyToCare = function HappyToCare(_ref) {
  var className = _ref.className,
      items = _ref.items,
      title = _ref.title,
      url = _ref.url;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_20__[/* useTracking */ "a"])();

  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return null;
  }

  var onSeeMoreClick = function onSeeMoreClick() {
    track({
      actionGA: 'happyToCare_Info',
      labelGA: 'Cta_SeeMore_happyToCare'
    });
  };

  var getBottomControls = function getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index) {
    return __jsx("div", {
      className: "mt-20 flex items-center justify-center"
    }, __jsx(_frameworks_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_21__[/* ArrowButton */ "a"], {
      className: "me-20 h-12 flex-none text-8",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].TRANSPARENT,
      isDisabled: isPreviousControlDisabled,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('common.previous'),
      onClick: onPrevious,
      theme: "ghost"
    }), __jsx("span", {
      className: "flex items-baseline justify-center text-12 text-black"
    }, __jsx("span", {
      className: "text-14 font-bold"
    }, index + 1), "/", items.length), __jsx(_frameworks_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_21__[/* ArrowButton */ "a"], {
      className: "ms-20 h-12 flex-none text-8",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].TRANSPARENT,
      isDisabled: isNextControlDisabled,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('common.next'),
      onClick: onNext,
      rotation: 180,
      theme: "ghost"
    }));
  };

  var hasTwoItems = items.length === 2 || isDesktop;
  var mainBlockTheme = !hasTwoItems && isTablet ? 'large' : 'default';

  var containerStyle = _objectSpread(_objectSpread({}, mainBlockStyles[mainBlockTheme]), isDesktop && !hasTwoItems || !isDesktop ? {
    maxHeight: 'none'
  } : {});

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('relative isolate px-15 lg:flex lg:p-0', className)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mx-auto flex w-full shrink-0 flex-col items-center rounded-12 p-20 text-ultramarine', {
      'lg:mx-20': hasTwoItems
    }, {
      'lg:pb-0': !hasTwoItems
    }),
    style: containerStyle
  }, !isTablet ? __jsx("div", {
    className: "pointer-events-none absolute left-0 right-0 top-0 -mt-60 flex items-center justify-center overflow-hidden"
  }, __jsx(Background, null)) : null, __jsx("div", {
    className: "pointer-events-none absolute inset-0 -z-1 mx-15 flex items-center justify-center md:m-0"
  }, __jsx("div", {
    className: "absolute inset-x-0 top-0 mx-auto flex h-full w-full items-center justify-center rounded-12 bg-verdigris",
    style: mainBlockStyles[mainBlockTheme]
  }, isTablet ? __jsx(Background, null) : null)), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "a"], {
    className: "mb-15 shrink-0 lg:my-15",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_16__[/* ICONS */ "a"].HAPPY_TO_CARE_TEXT,
    width: isTablet ? '6.875rem' : '6.25rem'
  }), __jsx("div", {
    className: "mb-20 flex min-h-52 items-center text-center font-brand text-24 leading-tight md:text-28"
  }, title), !isTablet ? __jsx(react__WEBPACK_IMPORTED_MODULE_13__["Fragment"], null, __jsx(_frameworks_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_25__[/* SliderHandler */ "a"], {
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: 0,
    items: items.map(function (item, index) {
      return getSlideItem(item, index);
    }),
    style: sliderContainerStyles
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        index = _ref2.index,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return __jsx("div", {
      className: "relative flex flex-1 flex-col pb-20"
    }, itemsNode, hasControls && getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index));
  }), getSeeMoreButton(url, hasTwoItems, isTablet, onSeeMoreClick)) : __jsx(react__WEBPACK_IMPORTED_MODULE_13__["Fragment"], null, hasTwoItems && getSeeMoreButton(url, hasTwoItems, isTablet, onSeeMoreClick), (!isDesktop || !hasTwoItems) && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('my-20 flex w-screen', {
      'justify-between': hasTwoItems,
      'justify-center': !hasTwoItems
    })
  }, items.map(function (item, index) {
    return getSlideItem(item, index, hasTwoItems);
  })), !hasTwoItems && getSeeMoreButton(url, hasTwoItems, isTablet, onSeeMoreClick))), isDesktop && hasTwoItems && (items.length > 1 ? items : [{
    imageUrl: '',
    title: '',
    description: ''
  }].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(items))).map(function (item, index) {
    return getSlideItem(item, index, hasTwoItems);
  }));
};

/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag_Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js

var themes = {
  "default": {
    thRoot: Object(classnames_utils["a" /* classnames */])('border-saffron bg-saffron text-black', 'inline-flex items-center gap-5 overflow-hidden whitespace-nowrap rounded-pill px-10 py-5 font-sans text-12 font-bold leading-1')
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;




var Tag_Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      iconName = _ref.iconName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "iconName", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: iconName,
    width: "1em"
  }), children);
};

/***/ }),

/***/ "NEd/":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var isArray = __webpack_require__("gIGD");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("XywU");
var toString = __webpack_require__("vnfA");

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* unused harmony export hasPrice */
/* unused harmony export isLongFormat */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = price || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;

  var totalWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(total, 'value', 0);

  var totalWithoutDiscountWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(totalWithoutDiscount, 'value', 0);

  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) {
    return '';
  }

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NdXQ":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ "Nsha":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm");

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),

/***/ "O034":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return priceOfStaySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceOfStayArgsSelector; });
/* unused harmony export proposalsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return priceOfStayIsLoadingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shouldDisplayAlternativePriceTitleSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UIAR");
/* harmony import */ var _calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("05PS");
/* harmony import */ var _priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("l1aQ");
/* harmony import */ var _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("RBO1");





var priceOfStaySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref) {
  var data = _ref.priceOfStay.data;
  return data;
});
var priceOfStayArgsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref2) {
  var priceOfStayArgs = _ref2.priceOfStay.priceOfStayArgs;
  return priceOfStayArgs;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(priceOfStaySelector, function (_ref3) {
  var proposals = _ref3.proposals;
  return proposals || {};
});
var priceOfStayIsLoadingSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__[/* getCalendarLoading */ "e"], _priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDate */ "b"], _calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__[/* getBlockInputDepartureDate */ "b"], _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__[/* getTripDuration */ "c"], function (calendarIsLoading, _ref4, departureDate, blockInputDepartureDate, duration) {
  var _ref4$priceOfStay = _ref4.priceOfStay,
      priceOfStayIsLoading = _ref4$priceOfStay.isLoading,
      lastRequestId = _ref4$priceOfStay.lastRequestId;
  return calendarIsLoading || (lastRequestId !== -1 || !blockInputDepartureDate && !!departureDate && !!duration) && priceOfStayIsLoading;
});
var shouldDisplayAlternativePriceTitleSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref5) {
  var _data$gap;

  var data = _ref5.priceOfStay.data;
  var gap = (_data$gap = data === null || data === void 0 ? void 0 : data.gap) !== null && _data$gap !== void 0 ? _data$gap : 0;
  return gap >= _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "y"] && gap < _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD */ "w"];
});

/***/ }),

/***/ "O94r":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "OFzH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;

/***/ }),

/***/ "OOYD":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("W0vE"),
    baseFilter = __webpack_require__("sjzV"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD"),
    negate = __webpack_require__("J4/4");

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OekA":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ "OhDV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "Ohju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateString; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

var TEMPLATE_REGEXP = /{\w+}/g;

function escapeCurlyBrackets(string) {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes(_ref) {
  var staticClassName = _ref.staticClassName,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? '' : _ref$template,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$valuesClassName = _ref.valuesClassName,
      valuesClassName = _ref$valuesClassName === void 0 ? {} : _ref$valuesClassName;
  var templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  var templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce(function (templateNodes, staticValue, index, array) {
    if (index === array.length - 1) {
      return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
        className: staticClassName,
        key: staticValue
      }, staticValue) : staticValue]);
    }

    var variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
      className: staticClassName,
      key: staticValue
    }, staticValue) : staticValue, encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName])]);
  }, []);
}

function encapsulateWithClassName() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var className = arguments.length > 2 ? arguments[2] : undefined;
  var v = value ? value.toString() : '';
  return className && v ? __jsx("span", {
    key: keyName,
    className: className
  }, v) : v;
}

var TemplateString = function TemplateString(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      staticClassName = _ref2.staticClassName,
      _ref2$template = _ref2.template,
      template = _ref2$template === void 0 ? '' : _ref2$template,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      valuesClassName = _ref2.valuesClassName;
  return template ? __jsx("span", {
    className: className,
    "data-testid": dataTestId
  }, generateTemplateNodes({
    staticClassName: staticClassName,
    template: template,
    values: values,
    valuesClassName: valuesClassName
  })) : null;
};

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BlockLink_BlockLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex gap-5 items-center font-bold font-sans leading-1 no-underline text-12',
    thIconWidth: '2.5rem',
    thSText: 'text-14 uppercase',
    thCustomText1: 'text-14 uppercase'
  },
  black: {
    thRoot: 'flex gap-5 sm:gap-10 justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-black text-16',
    thIconWidth: '2rem',
    thCustomText2: 'text-saffron'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row gap_10 items-center text-center lg:text-initial text-black',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-black text-14',
    thCustomText0: 'font-bold text-16',
    thCustomText1: 'font-bold text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx





var __jsx = react_default.a.createElement;




var DEFAULT_DATA_TEST_ID = 'BlockLink-text';

var BlockLink_BlockLinkTexts = function BlockLinkTexts(_ref) {
  var className = _ref.className,
      _ref$texts = _ref.texts,
      texts = _ref$texts === void 0 ? [] : _ref$texts,
      _ref$textsDataTestIds = _ref.textsDataTestIds,
      textsDataTestIds = _ref$textsDataTestIds === void 0 ? [] : _ref$textsDataTestIds,
      theme = _ref.theme;
  return texts.filter(function (text) {
    return !isEmpty_default()(text);
  }).map(function (text, idx) {
    var dataTestId = idx < textsDataTestIds.length ? textsDataTestIds[idx] : DEFAULT_DATA_TEST_ID;
    return __jsx("span", {
      className: Object(classnames_utils["a" /* classnames */])('block', themes[theme]["thCustomText".concat(idx)], className),
      "data-testid": dataTestId,
      key: idx
    }, text);
  });
};

var BlockLink_BlockLink = function BlockLink(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      icon = _ref2.icon,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      _ref2$secondaryTexts = _ref2.secondaryTexts,
      secondaryTexts = _ref2$secondaryTexts === void 0 ? [] : _ref2$secondaryTexts,
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? '_blank' : _ref2$target,
      _ref2$texts = _ref2.texts,
      texts = _ref2$texts === void 0 ? [] : _ref2$texts,
      _ref2$textsDataTestId = _ref2.textsDataTestIds,
      textsDataTestIds = _ref2$textsDataTestId === void 0 ? [] : _ref2$textsDataTestId,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      _ref2$url = _ref2.url,
      url = _ref2$url === void 0 ? '' : _ref2$url;
  var title = (texts || []).filter(function (t) {
    return typeof t === 'string';
  }).join(' ');
  var linkTarget = url.startsWith('tel:') ? '' : target;
  var _themes$theme = themes[theme],
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thTexts = _themes$theme.thTexts,
      thSText = _themes$theme.thSText;
  return !!texts.length || icon ? __jsx("a", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId,
    href: url,
    onClick: onClick,
    rel: "noopener noreferrer",
    target: linkTarget,
    title: title
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icon,
    width: thIconWidth
  }), !!texts.length && __jsx("span", {
    className: thTexts
  }, __jsx(BlockLink_BlockLinkTexts, {
    texts: texts,
    textsDataTestIds: textsDataTestIds,
    theme: theme
  }), __jsx(BlockLink_BlockLinkTexts, {
    className: thSText,
    texts: secondaryTexts,
    theme: theme
  }))) : null;
};

/***/ }),

/***/ "OoaE":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var hasOwn = __webpack_require__("/GgU");
var DESCRIPTORS = __webpack_require__("uGjT");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("mu8A").CONFIGURABLE;
var inspectSource = __webpack_require__("/ExG");
var InternalStateModule = __webpack_require__("9jKB");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "OouP":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "OsvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NO_VIEW_ICON_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_OUTSIDE_FACILITY_ICON_ID; });
/* unused harmony export roomTypeIcons */
/* unused harmony export viewIcons */
/* unused harmony export outsideFacilitiesIcons */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isRoomTypeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isViewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isOutsideFacilityItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isItemFilterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addViewIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addOutsideFacilitiesIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addRoomTypeIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTypedFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasTypedAlternative; });
/* unused harmony export submitAccommodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return chooseOption; });
/* unused harmony export DefaultAccommodationFilterRadioButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultAccommodationViewRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAccommodationOutsideFacilitiesRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultAccommodationRoomTypeRadioButton; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("dm5U");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("SPKZ");
/* harmony import */ var _accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("cb6o");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("K0Lv");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("829J");
/* harmony import */ var _store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("AnR0");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("47Eh");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("ljKo");
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("UIAR");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("/1vS");



















var __jsx = react__WEBPACK_IMPORTED_MODULE_19___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var NO_VIEW_ICON_ID = 'no_view';
var NO_OUTSIDE_FACILITY_ICON_ID = 'no_outside_facility';
var roomTypeIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SINGLE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SUITE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATE_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATE_ROOMS_3, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].CONNECTING_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATED_BUILDINGS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].separate_rooms, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SHARED_ROOM];
var viewIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].fir_tree_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].pool_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].mountain_view_or_slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].river_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].sea_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].seaview, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].garden_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].mountain_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].forest_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].golf_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].valley_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_chailifts_or_cable_railway, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_of_the_grounds, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_of_the_ski_resort];
var outsideFacilitiesIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].Balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].furnished_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].double_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_garden, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_pool, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].with_balcony_or_resort_view]; // used to identify the type of each item on accommodationRoomInfos

var isRoomTypeItem = function isRoomTypeItem(itemIcon) {
  return roomTypeIcons.includes(itemIcon);
};
var isViewItem = function isViewItem(itemIcon) {
  return viewIcons.includes(itemIcon);
};
var isOutsideFacilityItem = function isOutsideFacilityItem(itemIcon) {
  return outsideFacilitiesIcons.includes(itemIcon);
};
var isItemFilterable = function isItemFilterable(itemIcon) {
  return isRoomTypeItem(itemIcon) || isViewItem(itemIcon) || isOutsideFacilityItem(itemIcon);
};
var addViewIconPropertiesToFilters = function addViewIconPropertiesToFilters(filtersView) {
  return filtersView === null || filtersView === void 0 ? void 0 : filtersView.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getViewIconItem */ "g"])({
        id: filter.id,
        label: filter.label
      })
    });
  });
};
var addOutsideFacilitiesIconPropertiesToFilters = function addOutsideFacilitiesIconPropertiesToFilters(outsideFacilitiesFilter) {
  return outsideFacilitiesFilter === null || outsideFacilitiesFilter === void 0 ? void 0 : outsideFacilitiesFilter.map(function (filter) {
    var accommodationOutsideFacility = [{
      id: filter.id,
      label: filter.label
    }];
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getOutsideFacilitiesIconItem */ "e"])(accommodationOutsideFacility)
    });
  });
};
var addRoomTypeIconPropertiesToFilters = function addRoomTypeIconPropertiesToFilters(filtersRoomType, product) {
  return filtersRoomType === null || filtersRoomType === void 0 ? void 0 : filtersRoomType.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getSurfaceIconItem */ "f"])(filter.id, product, '')
    }); // filter.surface
  });
};
var getTypedFilters = function getTypedFilters(_ref, type) {
  var filtersView = _ref.filtersView,
      filtersOutsideFacilities = _ref.filtersOutsideFacilities,
      filtersRoomType = _ref.filtersRoomType;

  switch (type) {
    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].VIEW:
      return filtersView || [];

    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].OUTSIDE_FACILITIES:
      return filtersOutsideFacilities || [];

    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].ROOM_TYPE:
      return filtersRoomType || [];

    default:
      return [];
  }
};
var hasTypedAlternative = function hasTypedAlternative(_ref2) {
  var _currentComfortAltern, _currentComfortAltern2, _currentComfortAltern3;

  var currentComfortAlternatives = _ref2.currentComfortAlternatives,
      icon = _ref2.icon,
      proposal = _ref2.proposal;
  var viewAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern === void 0 ? void 0 : _currentComfortAltern.view;
  var outsideFacilityAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern2 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern2 === void 0 ? void 0 : _currentComfortAltern2.outsideFacilities;
  var roomTypeAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern3 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern3 === void 0 ? void 0 : _currentComfortAltern3.roomType;

  if (isViewItem(icon) && viewAlternatives) {
    var _proposal$accommodati, _proposal$accommodati2;

    var viewAlternativeExceptNoView = viewAlternatives.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== NO_VIEW_ICON_ID;
    });
    var proposalCurrentViewId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati = proposal.accommodations[0]) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati.view) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.id;
    var pureViewAlternatives = proposalCurrentViewId ? viewAlternatives.filter(function (_ref4) {
      var id = _ref4.id;
      return id !== proposalCurrentViewId;
    }) : viewAlternativeExceptNoView;
    return pureViewAlternatives.length >= 1;
  }

  if (isOutsideFacilityItem(icon) && outsideFacilityAlternatives) {
    var _proposal$accommodati3, _proposal$accommodati4, _proposal$accommodati5;

    var outsideFacilityAlternativesExceptNoOF = outsideFacilityAlternatives.filter(function (_ref5) {
      var id = _ref5.id;
      return id !== NO_OUTSIDE_FACILITY_ICON_ID;
    });
    var proposalCurrentOutsideFacilityId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati3 = proposal.accommodations[0]) === null || _proposal$accommodati3 === void 0 ? void 0 : (_proposal$accommodati4 = _proposal$accommodati3.outsideFacilities) === null || _proposal$accommodati4 === void 0 ? void 0 : (_proposal$accommodati5 = _proposal$accommodati4[0]) === null || _proposal$accommodati5 === void 0 ? void 0 : _proposal$accommodati5.id; // remove same id option if necessary

    var pureOutsideFacilityAlternatives = proposalCurrentOutsideFacilityId ? outsideFacilityAlternatives.filter(function (_ref6) {
      var id = _ref6.id;
      return id !== proposalCurrentOutsideFacilityId;
    }) : outsideFacilityAlternativesExceptNoOF;
    return pureOutsideFacilityAlternatives.length >= 1;
  }

  if (isRoomTypeItem(icon) && roomTypeAlternatives) {
    var _proposal$accommodati6; // there is always a roomType


    var proposalCurrentRoomTypeId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati6 = proposal.accommodations[0]) === null || _proposal$accommodati6 === void 0 ? void 0 : _proposal$accommodati6.roomType; // remove same id option if necessary

    var pureRoomTypeAlternatives = proposalCurrentRoomTypeId ? roomTypeAlternatives.filter(function (_ref7) {
      var id = _ref7.id;
      return id !== proposalCurrentRoomTypeId;
    }) : roomTypeAlternatives;
    return pureRoomTypeAlternatives.length >= 1;
  }
};
var submitAccommodation = function submitAccommodation(_ref8) {
  var _selectedAccommodatio, _selectedAccommodatio2;

  var accommodationsSets = _ref8.accommodationsSets,
      proposal = _ref8.proposal,
      formSelectedAlternativeId = _ref8.formSelectedAlternativeId,
      resort = _ref8.resort,
      optionId = _ref8.optionId,
      optionCategory = _ref8.optionCategory,
      dispatch = _ref8.dispatch,
      appContext = _ref8.appContext,
      onClose = _ref8.onClose,
      trackRoomPersonalization = _ref8.trackRoomPersonalization;
  var selectedAccommodationSet = accommodationsSets === null || accommodationsSets === void 0 ? void 0 : accommodationsSets.find(function (_ref9) {
    var id = _ref9.id;
    return id === formSelectedAlternativeId;
  });

  if (!formSelectedAlternativeId) {
    return onClose();
  }

  var _ref10 = selectedAccommodationSet || {},
      totalDifferentialPrice = _ref10.totalDifferentialPrice;

  var storage = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"]); // $FlowFixMe

  var selectedProposalId = storage.contextNumber; // $FlowFixMe

  var roomFilters = (storage.roomFilters || []).filter(function (roomFilter) {
    return roomFilter.proposalId === selectedProposalId;
  });
  var roomFilterIndex = roomFilters.findIndex(function (_ref11) {
    var upsellCategory = _ref11.upsellCategory;
    return upsellCategory === optionCategory;
  });

  if (roomFilterIndex > -1) {
    var upsellRevenue = totalDifferentialPrice.value + roomFilters[roomFilterIndex].upsellRevenue;
    trackRoomPersonalization(upsellRevenue === 0 ? 'remove' : 'add');
    _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* set */ "c"](_objectSpread(_objectSpread({}, _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"])), {}, {
      roomFilters: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters.slice(0, roomFilterIndex)), [{
        upsellRevenue: upsellRevenue,
        upsellCategory: optionCategory,
        upsellName: optionId,
        proposalId: selectedProposalId
      }], Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters.slice(roomFilterIndex + 1)))
    }));
  } else {
    trackRoomPersonalization('add');
    _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* set */ "c"](_objectSpread(_objectSpread({}, _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"])), {}, {
      roomFilters: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters), [{
        upsellRevenue: totalDifferentialPrice.value,
        upsellCategory: optionCategory,
        upsellName: optionId,
        proposalId: selectedProposalId
      }])
    }));
  } // get the arrangement


  var arrangement = selectedAccommodationSet === null || selectedAccommodationSet === void 0 ? void 0 : (_selectedAccommodatio = selectedAccommodationSet.accommodations) === null || _selectedAccommodatio === void 0 ? void 0 : (_selectedAccommodatio2 = _selectedAccommodatio.map(function (_ref12) {
    var attendeesDistribution = _ref12.attendeesDistribution;
    return attendeesDistribution;
  })) === null || _selectedAccommodatio2 === void 0 ? void 0 : _selectedAccommodatio2.filter(Boolean);
  arrangement && dispatch(Object(_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_25__[/* addAccommodation */ "a"])({
    arrangement: arrangement,
    globalLoaderLabel: '',
    toastLabel: '',
    isJoyview: resort.isJoyview,
    isUrbanOasis: resort.isUrbanOasis,
    proposalsId: Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_26__[/* getAllProposalsIdWithAlternative */ "b"])(proposal),
    appContext: appContext,
    reduxAction: _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_28__[/* ADD_ACCOMMODATION_FROM_ALTERNATIVES */ "c"]
  })).then(function () {
    // switch offers maybe ( Warning )
    return onClose();
  });
};
var chooseOption = function chooseOption(_ref13) {
  var appContext = _ref13.appContext,
      formik = _ref13.formik,
      filters = _ref13.filters,
      accommodationsSets = _ref13.accommodationsSets,
      proposal = _ref13.proposal,
      resort = _ref13.resort,
      optionCategory = _ref13.optionCategory,
      dispatch = _ref13.dispatch,
      onClose = _ref13.onClose,
      trackRoomPersonalization = _ref13.trackRoomPersonalization; // set the alternative

  var selectedOptionValueId = formik.values.selectedFilterValueId;
  var selectedOption = filters.find(function (_ref14) {
    var id = _ref14.id;
    return id === selectedOptionValueId;
  });

  if (selectedOption && selectedOption.firstAlternativeId) {
    var selectedOptionFirstAlternativeId = selectedOption.firstAlternativeId;
    submitAccommodation({
      accommodationsSets: accommodationsSets,
      proposal: proposal,
      formSelectedAlternativeId: selectedOptionFirstAlternativeId,
      resort: resort,
      optionId: selectedOptionValueId,
      optionCategory: optionCategory,
      dispatch: dispatch,
      appContext: appContext,
      onClose: onClose,
      trackRoomPersonalization: trackRoomPersonalization
    });
  }
};
var DefaultAccommodationFilterRadioButton = function DefaultAccommodationFilterRadioButton(_ref15) {
  var _accommodationIconPro, _accommodationIconPro2, _formik$values;

  var accommodationIconProps = _ref15.accommodationIconProps,
      value = _ref15.value;
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_27__[/* useFormikContext */ "e"])();
  return __jsx("li", {
    className: "w-150 flex-none",
    key: 0
  }, __jsx(_radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_20__[/* RadioButtonWithIcon */ "a"], {
    name: "selectedFilterValueId",
    title: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro = accommodationIconProps.labels) === null || _accommodationIconPro === void 0 ? void 0 : _accommodationIconPro[0]) || '',
    description: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro2 = accommodationIconProps.labels) === null || _accommodationIconPro2 === void 0 ? void 0 : _accommodationIconPro2[1]) || '',
    value: value,
    priceDifference: "",
    icon: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : accommodationIconProps.icon) || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRIDENT,
    isChecked: (formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.selectedFilterValueId) === value
  }));
};
var getTitle = function getTitle(type) {
  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].VIEW) {
    return 'booking.accommodation.roomFinder.viewFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].OUTSIDE_FACILITIES) {
    return 'booking.accommodation.roomFinder.facilitiesFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].ROOM_TYPE) {
    return 'booking.accommodation.roomFinder.roomConfigurationFilterTitle';
  }

  return 'booking.accommodation.roomFinder.filtersTitle';
};
var DefaultAccommodationViewRadioButton = function DefaultAccommodationViewRadioButton(_ref16) {
  var defaultAccommodationViewIcon = _ref16.defaultAccommodationViewIcon,
      value = _ref16.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationViewIcon,
    value: value
  });
};
var DefaultAccommodationOutsideFacilitiesRadioButton = function DefaultAccommodationOutsideFacilitiesRadioButton(_ref17) {
  var defaultAccommodationOutsideFacilitiesIcon = _ref17.defaultAccommodationOutsideFacilitiesIcon,
      value = _ref17.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationOutsideFacilitiesIcon,
    value: value
  });
};
var DefaultAccommodationRoomTypeRadioButton = function DefaultAccommodationRoomTypeRadioButton(_ref18) {
  var defaultAccommodationRoomTypeIcon = _ref18.defaultAccommodationRoomTypeIcon,
      value = _ref18.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationRoomTypeIcon,
    value: value
  });
};

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["n"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PFSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHO_EVENT; });
var OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';

/***/ }),

/***/ "PhFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasTooManyPax; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cjjV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");




var maxAge = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* maxAge */ "c"],
    minAge = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* minAge */ "d"],
    date = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* date */ "b"];
var API_DATE_FORMAT = 'YYYYMMDD';
function hasTooManyPax(adults, children, isSeller) {
  if (isSeller) {
    return false;
  }

  return adults + children > _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* MAX_PAX */ "K"];
}

function getBirthDayErrorMessage(params) {
  var departureDate = params.departureDate,
      birthday = params.birthday,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      childAge = params.childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage;
  var onDate = departureDate ? String(departureDate) : '';
  var nowDate = moment__WEBPACK_IMPORTED_MODULE_1___default()().format(API_DATE_FORMAT);
  var adultAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: nowDate,
    onDateFormat: API_DATE_FORMAT
  });
  var maxAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var minAgeValidator = minAge({
    ageRequired: +childAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var isChildBorn = minAge({
    ageRequired: 0,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var dateValidator = date(dateFormat);

  if (!dateValidator.isValid(birthday) || !adultAgeValidator.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!isChildBorn.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!maxAgeValidator.isValid(birthday)) {
    return adultAgeErrorMessage;
  }

  if (!minAgeValidator.isValid(birthday)) {
    return minAgeErrorMessage;
  }

  return '';
}

function checkFormErrors(params) {
  var _params$adults = params.adults,
      adults = _params$adults === void 0 ? 2 : _params$adults,
      _params$children = params.children,
      children = _params$children === void 0 ? 0 : _params$children,
      _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$birthdays = params.birthdays,
      birthdays = _params$birthdays === void 0 ? [] : _params$birthdays,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      _params$childAge = params.childAge,
      childAge = _params$childAge === void 0 ? 0 : _params$childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage,
      isSeller = params.isSeller;
  var birthdaysErrorMessage = birthdays.reduce(function (errorMessage, birthday) {
    return errorMessage || getBirthDayErrorMessage({
      dateFormat: dateFormat,
      departureDate: departureDate,
      adultAge: adultAge,
      childAge: childAge,
      birthday: birthday,
      birthdayFormatErrorMessage: birthdayFormatErrorMessage,
      adultAgeErrorMessage: adultAgeErrorMessage,
      minAgeErrorMessage: minAgeErrorMessage
    });
  }, null);
  var birthdaysNotValid = birthdays.length !== children || !!birthdaysErrorMessage;
  return {
    maxPax: hasTooManyPax(+adults, +children, isSeller),
    departureDate: !departureDate,
    birthdays: birthdaysNotValid,
    birthdaysErrorMessage: birthdaysErrorMessage || birthdaysNotValid && birthdayFormatErrorMessage || ''
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  checkFormErrors: checkFormErrors
});

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

/* global window, document */


__webpack_require__("ZVqJ");

__webpack_require__("vuE1");

__webpack_require__("qs2G");

__webpack_require__("i2OK");

__webpack_require__("5iaM");

__webpack_require__("I2c1");

__webpack_require__("60DJ");

__webpack_require__("QRET");

__webpack_require__("bMl7");

__webpack_require__("zSnQ");

__webpack_require__("MRpX");

__webpack_require__("ieZH");

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _propTypes = _interopRequireDefault(__webpack_require__("aWzz"));

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = _interopRequireDefault(__webpack_require__("O94r"));

var _shallowequal = _interopRequireDefault(__webpack_require__("Pu0A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform'; // global variable for all instances

var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = /*#__PURE__*/function (_Component) {
  _inherits(Sticky, _Component);

  var _super = _createSuper(Sticky);

  function Sticky(props, context) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props, context);
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollStart = _this.handleScrollStart.bind(_assertThisInitialized(_this));
    _this.delta = 0;
    _this.stickyTop = 0;
    _this.stickyBottom = 0;
    _this.frozen = false;
    _this.skipNextScrollEvent = false;
    _this.scrollTop = -1;
    _this.bottomBoundaryTarget;
    _this.topTarget;
    _this.subscribers;
    _this.state = {
      top: 0,
      // A top offset from viewport top where Sticky sticks to when scrolling up
      bottom: 0,
      // A bottom offset from viewport top where Sticky sticks to when scrolling down
      width: 0,
      // Sticky width
      height: 0,
      // Sticky height
      x: 0,
      // The original x of Sticky
      y: 0,
      // The original y of Sticky
      topBoundary: 0,
      // The top boundary on document
      bottomBoundary: Infinity,
      // The bottom boundary on document
      status: STATUS_ORIGINAL,
      // The Sticky status
      pos: 0,
      // Real y-axis offset for rendering position-fixed and position-relative
      activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

    };
    return _this;
  }

  _createClass(Sticky, [{
    key: "getTargetHeight",
    value: function getTargetHeight(target) {
      return target && target.offsetHeight || 0;
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(top) {
      // a top argument can be provided to override reading from the props
      top = top || this.props.top || 0;

      if (typeof top === 'string') {
        if (!this.topTarget) {
          this.topTarget = doc.querySelector(top);
        }

        top = this.getTargetHeight(this.topTarget);
      }

      return top;
    }
  }, {
    key: "getTargetBottom",
    value: function getTargetBottom(target) {
      if (!target) {
        return -1;
      }

      var rect = target.getBoundingClientRect();
      return this.scrollTop + rect.bottom;
    }
  }, {
    key: "getBottomBoundary",
    value: function getBottomBoundary(bottomBoundary) {
      // a bottomBoundary can be provided to avoid reading from the props
      var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

      if (_typeof(boundary) === 'object') {
        boundary = boundary.value || boundary.target || 0;
      }

      if (typeof boundary === 'string') {
        if (!this.bottomBoundaryTarget) {
          this.bottomBoundaryTarget = doc.querySelector(boundary);
        }

        boundary = this.getTargetBottom(this.bottomBoundaryTarget);
      }

      return boundary && boundary > 0 ? boundary : Infinity;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        status: STATUS_ORIGINAL,
        pos: 0
      });
    }
  }, {
    key: "release",
    value: function release(pos) {
      this.setState({
        status: STATUS_RELEASED,
        pos: pos - this.state.y
      });
    }
  }, {
    key: "fix",
    value: function fix(pos) {
      this.setState({
        status: STATUS_FIXED,
        pos: pos
      });
    }
    /**
     * Update the initial position, width, and height. It should update whenever children change.
     * @param {Object} options optional top and bottomBoundary new values
     */

  }, {
    key: "updateInitialDimension",
    value: function updateInitialDimension(options) {
      options = options || {};

      if (!this.outerElement || !this.innerElement) {
        return;
      }

      var outerRect = this.outerElement.getBoundingClientRect();
      var innerRect = this.innerElement.getBoundingClientRect();
      var width = outerRect.width || outerRect.right - outerRect.left;
      var height = innerRect.height || innerRect.bottom - innerRect.top;
      ;
      var outerY = outerRect.top + this.scrollTop;
      this.setState({
        top: this.getTopPosition(options.top),
        bottom: Math.min(this.state.top + height, winHeight),
        width: width,
        height: height,
        x: outerRect.left,
        y: outerY,
        bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
        topBoundary: outerY
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(e, ae) {
      if (this.props.shouldFreeze()) {
        return;
      }

      winHeight = ae.resize.height;
      this.updateInitialDimension();
      this.update();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart(e, ae) {
      this.frozen = this.props.shouldFreeze();

      if (this.frozen) {
        return;
      }

      if (this.scrollTop === ae.scroll.top) {
        // Scroll position hasn't changed,
        // do nothing
        this.skipNextScrollEvent = true;
      } else {
        this.scrollTop = ae.scroll.top;
        this.updateInitialDimension();
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e, ae) {
      // Scroll doesn't need to be handled
      if (this.skipNextScrollEvent) {
        this.skipNextScrollEvent = false;
        return;
      }

      scrollDelta = ae.scroll.delta;
      this.scrollTop = ae.scroll.top;
      this.update();
    }
    /**
     * Update Sticky position.
     */

  }, {
    key: "update",
    value: function update() {
      var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

      if (disabled) {
        if (this.state.status !== STATUS_ORIGINAL) {
          this.reset();
        }

        return;
      }

      var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
      // on document from viewport.

      var top = this.scrollTop + this.state.top;
      var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
      // 1. Reset Sticky to the original postion when "top" <= topBoundary
      // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

      if (top <= this.state.topBoundary) {
        // #1
        this.reset();
      } else if (bottom >= this.state.bottomBoundary) {
        // #2
        this.stickyBottom = this.state.bottomBoundary;
        this.stickyTop = this.stickyBottom - this.state.height;
        this.release(this.stickyTop);
      } else {
        if (this.state.height > winHeight - this.state.top) {
          // In this case, Sticky is higher then viewport minus top offset
          switch (this.state.status) {
            case STATUS_ORIGINAL:
              this.release(this.state.y);
              this.stickyTop = this.state.y;
              this.stickyBottom = this.stickyTop + this.state.height;
            // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
            // from ORIGINAL when calling window.scrollTo().
            // break;

            case STATUS_RELEASED:
              // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
              // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
              // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
              this.stickyBottom = this.stickyTop + this.state.height;

              if (delta > 0 && bottom > this.stickyBottom) {
                this.fix(this.state.bottom - this.state.height);
              } else if (delta < 0 && top < this.stickyTop) {
                this.fix(this.state.top);
              }

              break;

            case STATUS_FIXED:
              var toRelease = true;
              var pos = this.state.pos;
              var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
              // 1. it's top will stick to the screen top,
              // 2. it's bottom will stick to the screen bottom,
              // 3. if not the cases above, then it's height gets changed

              if (delta > 0 && pos === this.state.top) {
                // case 1, and scrolling down
                this.stickyTop = top - delta;
                this.stickyBottom = this.stickyTop + height;
              } else if (delta < 0 && pos === this.state.bottom - height) {
                // case 2, and scrolling up
                this.stickyBottom = bottom - delta;
                this.stickyTop = this.stickyBottom - height;
              } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                // case 3
                // This case only happens when Sticky's bottom sticks to the screen bottom and
                // its height gets changed. Sticky should be in RELEASE status and update its
                // sticky bottom by calculating how much height it changed.
                var deltaHeight = pos + height - this.state.bottom;
                this.stickyBottom = bottom - delta + deltaHeight;
                this.stickyTop = this.stickyBottom - height;
              } else {
                toRelease = false;
              }

              if (toRelease) {
                this.release(this.stickyTop);
              }

              break;
          }
        } else {
          // In this case, Sticky is shorter then viewport minus top offset
          // and will always fix to the top offset of viewport
          this.fix(this.state.top);
        }
      }

      this.delta = delta;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.status !== this.state.status && this.props.onStateChange) {
        this.props.onStateChange({
          status: this.state.status
        });
      }

      var arePropsChanged = !(0, _shallowequal.default)(this.props, prevProps);

      if (arePropsChanged) {
        // if the props for enabling are toggled, then trigger the update or reset depending on the current props
        if (prevProps.enabled !== this.props.enabled) {
          if (this.props.enabled) {
            this.setState({
              activated: true
            }, function () {
              _this2.updateInitialDimension();

              _this2.update();
            });
          } else {
            this.setState({
              activated: false
            }, function () {
              _this2.reset();
            });
          }
        } // if the top or bottomBoundary props were changed, then trigger the update
        else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
            this.updateInitialDimension();
            this.update();
          }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var subscribers = this.subscribers || [];

      for (var i = subscribers.length - 1; i >= 0; i--) {
        this.subscribers[i].unsubscribe();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Only initialize the globals if this is the first
      // time this component type has been mounted
      if (!win) {
        win = window;
        doc = document;
        docEl = doc.documentElement;
        docBody = doc.body;
        winHeight = win.innerHeight || docEl.clientHeight;
        M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

        if (M && M.prefixed) {
          canEnableTransforms = M.csstransforms3d;
          TRANSFORM_PROP = M.prefixed('transform');
        }
      } // when mount, the scrollTop is not necessary on the top


      this.scrollTop = docBody.scrollTop + docEl.scrollTop;

      if (this.props.enabled) {
        this.setState({
          activated: true
        });
        this.updateInitialDimension();
        this.update();
      } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


      this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
        useRAF: true
      }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
        useRAF: true,
        enableScrollInfo: true
      }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
        enableResizeInfo: true
      })];
    }
  }, {
    key: "translate",
    value: function translate(style, pos) {
      var enableTransforms = canEnableTransforms && this.props.enableTransforms;

      if (enableTransforms && this.state.activated) {
        style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
      } else {
        style.top = pos + 'px';
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.props.shouldFreeze() && !((0, _shallowequal.default)(this.props, nextProps) && (0, _shallowequal.default)(this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      // TODO, "overflow: auto" prevents collapse, need a good way to get children height
      var innerStyle = {
        position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
        top: this.state.status === STATUS_FIXED ? '0px' : '',
        zIndex: this.props.innerZ
      };
      var outerStyle = {}; // always use translate3d to enhance the performance

      this.translate(innerStyle, this.state.pos);

      if (this.state.status !== STATUS_ORIGINAL) {
        innerStyle.width = this.state.width + 'px';
        outerStyle.height = this.state.height + 'px';
      }

      var outerClasses = (0, _classnames.default)('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
      var innerClasses = (0, _classnames.default)('sticky-inner-wrapper', this.props.innerClass, _defineProperty({}, this.props.innerActiveClass, this.state.status === STATUS_FIXED));
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(outer) {
          _this3.outerElement = outer;
        },
        className: outerClasses,
        style: outerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(inner) {
          _this3.innerElement = inner;
        },
        className: innerClasses,
        style: innerStyle
      }, typeof children === 'function' ? children({
        status: this.state.status
      }) : children));
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  shouldFreeze: function shouldFreeze() {
    return false;
  },
  enabled: true,
  top: 0,
  bottomBoundary: 0,
  enableTransforms: true,
  activeClass: 'active',
  releasedClass: 'released',
  onStateChange: null,
  innerClass: '',
  innerActiveClass: ''
};
/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */

Sticky.propTypes = {
  enabled: _propTypes.default.bool,
  top: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  bottomBoundary: _propTypes.default.oneOfType([_propTypes.default.object, // TODO, may remove
  _propTypes.default.string, _propTypes.default.number]),
  enableTransforms: _propTypes.default.bool,
  activeClass: _propTypes.default.string,
  releasedClass: _propTypes.default.string,
  innerClass: _propTypes.default.string,
  innerActiveClass: _propTypes.default.string,
  className: _propTypes.default.string,
  onStateChange: _propTypes.default.func,
  shouldFreeze: _propTypes.default.func,
  innerZ: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;
module.exports = Sticky;

/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "PuIx":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("MzY2"),
    createAssigner = __webpack_require__("wpQC");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "Q4AL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var BASE_URL = 'https://maps';
var DEFAULT_URL = BASE_URL + '.googleapis.com';
var API_PATH = '/maps/api/js?callback=_$_google_map_initialize_$_';

var getUrl = function getUrl(region) {
  if (region && region.toLowerCase() === 'cn') {
    return BASE_URL + '.google.cn';
  }
  return DEFAULT_URL;
};

var $script_ = null;

var loadPromise_ = void 0;

var resolveCustomPromise_ = void 0;

var _customPromise = new Promise(function (resolve) {
  resolveCustomPromise_ = resolve;
});

// TODO add libraries language and other map options

exports.default = function (bootstrapURLKeys, heatmapLibrary) {
  if (!$script_) {
    $script_ = __webpack_require__("h9IM"); // eslint-disable-line
  }

  // call from outside google-map-react
  // will be as soon as loadPromise_ resolved
  if (!bootstrapURLKeys) {
    return _customPromise;
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = function () {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };

    if (false) { var message; }

    var params = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
      return r + '&' + key + '=' + bootstrapURLKeys[key];
    }, '');

    var baseUrl = getUrl(bootstrapURLKeys.region);
    var libraries = heatmapLibrary ? '&libraries=visualization' : '';

    $script_('' + baseUrl + API_PATH + params + libraries, function () {
      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
    });
  });

  resolveCustomPromise_(loadPromise_);

  return loadPromise_;
};

/***/ }),

/***/ "Q78w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
  );
};

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _google_map_markers = __webpack_require__("T3et");

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  width: '50%',
  height: '50%',
  left: '50%',
  top: '50%',
  // backgroundColor: 'red',
  margin: 0,
  padding: 0,
  position: 'absolute'
  // opacity: 0.3
};

/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("C/y5");

var themes = function themes(_ref) {
  var _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow;
  return {
    "default": {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey mt-15 p-10 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow
      })
    },
    hollow: {
      thBody: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_0__[/* classnames */ "a"])('bg-white border-1 border-lightGrey rounded-12 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow
      })
    }
  };
};

/***/ }),

/***/ "QRET":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var DOMIterables = __webpack_require__("YQkA");
var DOMTokenListPrototype = __webpack_require__("k4ez");
var ArrayIteratorMethods = __webpack_require__("I2c1");
var createNonEnumerableProperty = __webpack_require__("g51W");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "QRI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPrePaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBookingTransportQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return packagesFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return priceDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStayAccommodationFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStayTeaserBookingFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCustomerProfileQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCutomersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCustomerBookingAttendeesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCustomerBookingDocumentsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCustomerBookingPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCustomerBookingPriceAndPaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getRenewedOptionById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getVouchersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_PAGINATED_TRIPS_LIST_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NOT_PAGINATED_TRIPS_LIST_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_TRIPS_LIST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCustomerBookingsQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("H0gB");
/* harmony import */ var _components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JOeK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tI+f");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");









var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PACKAGES,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY;
var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
var getPrePaymentQuery = function getPrePaymentQuery(_ref) {
  var bookingId = _ref.bookingId,
      customerId = _ref.customerId,
      isCartPayment = _ref.isCartPayment,
      isUpgradeRoomPayment = _ref.isUpgradeRoomPayment;
  return "query {\n      config {\n        booking {\n          banking {\n            freeDepositDeadline\n          }\n          sellers {\n            banking {\n              freeDepositDeadline\n            }\n          }\n        }\n      }\n      bookingsCart(bookingIds : [\"".concat(bookingId, "\"]) @include(if: ").concat(String(isCartPayment), ") {\n        cartBookings {\n          count\n          price {\n            total {\n              value\n              currency\n            }\n          }\n        }\n      }\n      bookingAccomodationsCart(bookingId: \"").concat(bookingId, "\", customerId: \"").concat(customerId, "\") @include(if: ").concat(String(isUpgradeRoomPayment), ") {\n        cart {\n          count\n          price {\n            total {\n              value\n              currency\n            }\n          }\n        }\n\n      }\n      userBooking(bookingId : \"").concat(bookingId, "\") {\n        information {\n          shouldProposeOnlinePayment\n          status\n          stays {\n            id\n            departureDate\n          }\n        }\n        paymentDetails {\n          duePayment {\n            deadline\n            amount {\n              value\n            }\n          }\n        }\n      }\n  }");
};
var getBookingTransportQuery = function getBookingTransportQuery(bookingId) {
  return "query {\n      userBooking(bookingId: \"".concat(bookingId, "\") {\n        transports {\n          inbounds {\n            ...transportsDetails\n          }\n          multiTransport\n          outbounds {\n            ...transportsDetails\n          }\n        }\n      }\n    }\n    fragment transportsDetails on TransportDetailType {\n      stayId\n      transferIncluded\n      travelSections {\n        arrival {\n          airportLabel\n          cityId\n          date\n          id\n          label\n          terminalCode\n          time\n        }\n        connectionDurationInMin\n        departure {\n          airportLabel\n          cityId\n          date\n          id\n          label\n          terminalCode\n          time\n        }\n        durationInMin\n        isClubmedTransport\n        stopDurationInMin\n        technicalStops\n        transport {\n          baggage {\n            quantity\n            weight\n            unit\n          }\n          class\n          companyExploiter {\n            id\n            label\n            logo\n          }\n          companyOperator {\n            id\n            label\n            logo\n            url\n          }\n          reference\n          travelNumber\n          type\n        }\n      }\n    }");
}; // FRAGMENTS

var packagesFragment = "\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      ... on ProductPackageType {\n        additionalInfo\n        description\n        id\n        image\n        label\n        prices {\n          perAdultPerNight {\n            currency\n            formattedValue\n            value\n          }\n          perKidPerNight {\n            currency\n            formattedValue\n            value\n          }\n        }\n      }\n    }");
var priceDetailsFragment = function priceDetailsFragment(appContext) {
  return "\n    fragment priceDetails on PriceDetailType {\n        formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale), ")\n        value\n    }");
};
var getStayAccommodationFragment = function getStayAccommodationFragment() {
  return "\n  fragment accommodations on AccommodationType {\n    attendeesDistribution {\n      attendees {\n        birthdate\n        customerId\n        id\n        type\n      }\n      id\n      quantity\n    }\n    bathroomEquipments {\n      id\n      label\n    }\n    category\n    categoryId\n    comfortId\n    comfortType\n    description\n    endDate\n    equipments {\n      id\n      label\n    }\n    exclusiveCollection\n    guest\n    id\n    label\n    maxCapacity\n    media {\n      photos {\n        url\n      }\n    }\n    outsideFacilities {\n      id\n      label\n    }\n    quantity\n    ranking\n    rooms {\n      number\n    }\n    roomType\n    services {\n      id\n      label\n    }\n    startDate\n    strengths {\n      id\n      label\n    }\n    surface\n    view {\n      id\n      label\n    }\n    floorPlans\n  }";
};

var getStayUpsellsQuery = function getStayUpsellsQuery(appContext) {
  return "\nupsells(types: [CHILDCARE, EXCURSION, INSURANCE, LAND_SPORT, RENTAL, TRANSFER, WATER_SPORT, WINTER_SPORT, WELLNESS, PARKING, CONCIERGERIE]) {\n  activities {\n    ".concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* servicesWithSchedulePricingInfoQuery */ "k"], "\n    productInfo {\n      id\n      isIncluded\n      label\n      parentActivityCategoriesId\n    }\n  }\n  rentals {\n    ").concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* servicesWithSchedulePricingInfoQuery */ "k"], "\n    productInfo {\n      id\n      label\n      ageInMonths {\n        min\n        max\n      }\n      useCase {\n        id\n        label\n      }\n      typeId: type\n      typeLabel\n      description: longDescription\n      sizes {\n        min\n        max\n        unit\n      }\n      practiceLevels {\n        id\n        label\n      }\n    }\n  }\n  ").concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* childcaresQuery */ "b"], "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* insuranceQuery */ "h"])(appContext), "\n  ").concat(packagesFragment, "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* transfersQuery */ "l"])(appContext), "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* whiteLabelServicesQuery */ "n"])(appContext), "\n}\n");
};

var getStayTeaserBookingWithoutStaysFragment = function getStayTeaserBookingWithoutStaysFragment() {
  return "fragment stayBooking on CustomerBookingWithoutStaysType {\n    attendees {\n      birthday\n      civility\n      customerId\n      email\n      firstName:firstname\n      id\n      lastName:lastname\n      mainContact\n      type\n      unicodeFirstname\n      unicodeLastname\n    }\n    creationDate\n    dates {\n      duration\n      endDate\n      startDate\n    }\n    categories {\n      isOption\n      isOptionRenewed\n      isExpiredOption\n      isFromRenewal\n      isStandard\n      isTravelPlan\n      isTravelPlanPrebooking\n      isTravelPlanStandard\n    }\n    id\n    isMultiSaleContracts\n    isMultiStays\n    optionDurability {\n      expirationDateTime\n      isReliable\n    }\n    payment {\n      due {\n        deadlineDate\n        formattedValue\n        value\n      }\n      isEnabled\n      status {\n        isPaid\n        isPending\n        isUnPaid\n      }\n    }\n    status {\n      name\n      isArchived\n      isExpiredOption\n      isCanceled\n      isValidated\n    }\n    totalPrice {\n      value\n    }\n    vendor {\n      isSoldByClubmed\n      isSoldByPartners\n      name\n      phoneNumber\n      type\n    }\n  }";
};

var getStayTeaserBookingStayProductFragment = function getStayTeaserBookingStayProductFragment() {
  return "fragment stayProduct on Resort {\n    activityTree {\n      ...activityCategory\n      activities {\n        ...activity\n      }\n      categories {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n        }\n      }\n    }\n    associatedResort {\n      id\n      productTypeId\n    }\n    category\n    childrenActivities: productActivities(idFilter: \"".concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n      ageInMonths {\n        max\n        min\n      }\n      description\n      equipments {\n        id\n        label\n      }\n      id\n      isIncluded\n      label\n      subtitle\n    }\n    comfort\n    destination {\n      country\n    }\n    esfResortId\n    facilities(types: [\"CHILDREN\"], withEquipments: true) {\n      equipments {\n        id\n        label\n      }\n      label\n      subtitle\n    }\n    href\n    id\n    images\n    isCruise\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isTour\n    name\n    rangeLabel\n    rentalsTree {\n      ...rentals\n    }\n    seasonTrad\n    type\n  }\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* activityFragment */ "b"], "\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* activityCategoryFragment */ "a"], "\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* rentalsFragment */ "f"]);
};

var getStayTeaserBookingFragment = function getStayTeaserBookingFragment(appContext, options) {
  return "\n  fragment booking on CustomerBookingType {\n    categories {\n      isOption\n      isOptionRenewed\n      isExpiredOption\n      isFromRenewal\n      isStandard\n      isTravelPlan\n    }\n    dates {\n      duration\n      endDate\n      startDate\n    }\n    id\n    optionDurability {\n      expirationDateTime\n      isReliable\n    }\n    status {\n      name\n    }\n    stays {\n      ".concat(options.withUpsells ? 'accommodations {  ...accommodations }' : '', "\n      accommodationsCount\n      booking {\n        ...stayBooking\n      }\n      dates {\n        duration\n        endDate\n        isCurrent\n        isPast\n        isToCome\n        startDate\n      }\n      features {\n        easyArrival {\n          status {\n            isAvailable\n            isDone\n          }\n          url\n        }\n        easyCheckInOut {\n          easyCheckIn {\n            isActivated\n            status {\n              isAvailable\n              isUneditable\n            }\n          }\n          easyCheckOut {\n            isActivated\n            status {\n              isAvailable\n              isUneditable\n            }\n          }\n        }\n        easyTransfer {\n          serviceStatus {\n            isUpsellAvailable\n            isValidated\n          }\n        }\n        policyForm {\n          status {\n            isAvailable\n          }\n        }\n        feedback {\n          status {\n            isAvailable\n          }\n          url\n        }\n        pickYourRoom {\n          status {\n            name\n          }\n        }\n      }\n      id\n      participants {\n        attendees {\n          id\n        }\n        adultsCount\n        children {\n          birthday\n        }\n        childrenCount\n      }\n      product {\n        ...stayProduct\n      }\n      stayIndex\n      transfers {\n        id\n      }\n      transport {\n        fromCity\n        fromCityCode\n        inbounds {\n          stayId\n        }\n        outbounds {\n          stayId\n        }\n        type\n        types\n      }\n      ").concat(options.withUpsells ? getStayUpsellsQuery(appContext) : '', "\n      vouchers {\n        value\n        unit\n        currency\n        dateOfUse\n        isAvailable\n        isFTC\n        validityEndDate\n      }\n    }\n  }\n  ").concat(options.withUpsells ? [priceDetailsFragment(appContext), getStayAccommodationFragment()].join('') : '', "\n  ").concat(getStayTeaserBookingWithoutStaysFragment(), "\n  ").concat(getStayTeaserBookingStayProductFragment(), "\n");
}; // QUERIES

var profileQuery = "\n  profile {\n    civility\n    firstName\n    GMNumber\n    isProspect\n    lastName\n    loyaltyProgram {\n      points\n      status\n    }\n    unicodeCivility\n    unicodeFirstName\n    unicodeLastName\n  }";
var getCustomerProfileQuery = function getCustomerProfileQuery(_ref2) {
  var _ref2$isQuickLogged = _ref2.isQuickLogged,
      isQuickLogged = _ref2$isQuickLogged === void 0 ? false : _ref2$isQuickLogged;
  return "query {\n  loyaltyProgram {\n    status\n    threshold\n  }\n    ".concat(isQuickLogged ? '' : profileQuery, "\n}");
};
var getCutomersQuery = function getCutomersQuery() {
  return "query {\n  customers {\n    currentTripsCount\n    futureTripsCount\n    hasSponsorship\n    pastTripsCount\n    searchesCount\n    type\n  }\n}";
};
var getCustomerBookingAttendeesQuery = function getCustomerBookingAttendeesQuery(_ref3) {
  var bookingId = _ref3.bookingId,
      isJoyview = _ref3.isJoyview,
      productId = _ref3.productId,
      _ref3$withPackage = _ref3.withPackage,
      withPackage = _ref3$withPackage === void 0 ? false : _ref3$withPackage;
  var packageQuery = withPackage ? "\n        package(productId : \"".concat(productId, "\", packageId : \"").concat(_utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_ALL_INCLUSIVE */ "f"], "\") {\n            description\n            id\n            label\n            prices {\n              perAdultPerNight {\n                formattedValue\n              }\n              perKidPerNight {\n                formattedValue\n              }\n            }\n          }\n        ") : '';
  var packageFragment = isJoyview ? "\n          package {\n            id\n            isAllInclusive\n            isRoomOnly\n            label\n          }\n        " : '';
  var packagesUpsellQuery = withPackage ? "\n            packagesUpsell {\n              amount\n              currency\n              id\n            }\n          " : '';
  return "query {\n          customerBooking(id: \"".concat(bookingId, "\") {\n            attendees {\n              birthday\n              civility\n              customerId\n              email\n              firstname\n              id\n              lastname\n              mainContact\n              type\n              unicodeFirstname\n              unicodeLastname\n              ").concat(packageFragment, "\n              ").concat(packagesUpsellQuery, "\n            }\n          }\n          ").concat(packageQuery, "\n        }");
};
var getCustomerBookingDocumentsQuery = function getCustomerBookingDocumentsQuery(bookingId) {
  return "\n  query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      documents {\n        clicType\n        id\n        label\n        type\n      }\n    }\n  }");
};
var getCustomerBookingPriceQuery = function getCustomerBookingPriceQuery(appContext, bookingId) {
  var precision = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale);
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n        totalPrice {\n          formattedValue(precision: ").concat(precision, ")\n          value\n        }\n      }\n    }");
};
var getCustomerBookingPriceAndPaymentQuery = function getCustomerBookingPriceAndPaymentQuery(appContext, bookingId) {
  var precision = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale);
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      payment {\n        due {\n          deadlineDate\n          formattedValue\n          schedules {\n            deadlineDate\n            formattedValue\n            value\n          }\n          value\n        }\n        paid {\n          formattedValue\n          value\n        }\n        status {\n          isPending\n        }\n      }\n      totalPrice {\n        details {\n          cancellationInsurance {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          discount {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          donation {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          fees {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          onDemand {\n            formattedValue(precision: ").concat(precision, ")\n            id\n            label\n            value\n          }\n          package {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          total {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n        }\n      }\n      vendor {\n        isSoldByClubmed\n      }\n    }\n  }");
};

var getRenewedOptionByIdQuery = function getRenewedOptionByIdQuery(bookingId) {
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      optionDurability {\n        expirationDateTime\n      }\n    }\n  }");
};

var getRenewedOptionById = function getRenewedOptionById(appContext, bookingId) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].runNoCacheQuery(getRenewedOptionByIdQuery(bookingId), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_GET_BOOKING_DATA */ "k"],
    strictErrors: false
  });
};
var getVouchersQuery = function getVouchersQuery() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$isSponsorship = _ref4.isSponsorship,
      isSponsorship = _ref4$isSponsorship === void 0 ? false : _ref4$isSponsorship;

  return "query {\n    vouchers {\n      items {\n        advantageCode\n        currency\n        dateOfUse\n        godchildInformation {\n          firstName\n          lastName\n          unicodeFirstName\n          unicodeLastName\n        }\n        godfatherInformation {\n          firstName\n          lastName\n          unicodeFirstName\n          unicodeLastName\n        }\n        id\n        isAvailable\n        isExpired\n        isFTC\n        isTargetedOffer\n        ".concat(!isSponsorship ? "offer {\n          description\n          id\n          name\n          shortDescription}" : '', "\n        \n        origin {\n          bookingId\n          stay {\n            endDate\n            product {\n              destination {\n                country\n              }\n              href\n              name\n            }\n            startDate\n          }\n        }\n        originType\n        status\n        type\n        validityEndDate\n        value\n        unit\n      }\n      type\n    }\n }");
};
var DEFAULT_PAGINATED_TRIPS_LIST_LIMIT = 5;
var DEFAULT_NOT_PAGINATED_TRIPS_LIST_LIMIT = 10;
var DEFAULT_TRIPS_LIST_PAGE = 1;
var getCustomerBookingsQuery = function getCustomerBookingsQuery(appContext, params, options) {
  var _params$isCanceled = params.isCanceled,
      isCanceled = _params$isCanceled === void 0 ? false : _params$isCanceled,
      limit = params.limit,
      _params$page = params.page,
      page = _params$page === void 0 ? DEFAULT_TRIPS_LIST_PAGE : _params$page,
      period = params.period;
  var periods = period === 'all' ? '"CURRENTS" "FUTURS" "PASTS"' : '"' + {
    past: 'PASTS',
    future: 'FUTURS',
    current: 'CURRENTS'
  }[period] + '"';
  var statuses = isCanceled ? '"CANCELED"' : '"VALIDATED"';
  var limits = !isCanceled ? 'limit:' + limit + ' page:' + page : '';
  return "query {\n    customerBookings(period: [".concat(periods, "], status: [").concat(statuses, "], ").concat(limits, ") {\n        ...BookingsFragment\n    }\n  }\n  ").concat(getStayTeaserBookingFragment(appContext, options), "\n  fragment BookingsFragment on PaginatedCustomerBookings {\n    data {\n      ...booking\n    }\n    pageInfo {\n      currentPage\n      hasNextPage\n    }\n  }\n  ");
};

/***/ }),

/***/ "Qavd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var IS_PURE = __webpack_require__("DpO5");
var NativePromise = __webpack_require__("KQNt");
var fails = __webpack_require__("ct80");
var getBuiltIn = __webpack_require__("VCi3");
var speciesConstructor = __webpack_require__("Qzre");
var promiseResolve = __webpack_require__("nDYR");
var redefine = __webpack_require__("uLp7");

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && typeof NativePromise == 'function') {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "QkNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePriceOfStay; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uDfI");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05PS");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("cDU8");
/* harmony import */ var _client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBO1");
/* harmony import */ var _client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fuxG");
/* harmony import */ var _client_components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("1JJ2");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("O034");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("L7OA");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}














function usePriceOfStay(productId, departureCity) {
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__[/* useAppContext */ "c"])();
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useResponsive = Object(_client_components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_8__["useRouter"])(),
      offerName = _useRouter.query.offer;

  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getAdults */ "a"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getBlockInputDepartureDate */ "b"]);
  var calendarIsLoading = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarLoading */ "e"]);
  var calendarDepartureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarDepartureCity */ "d"]);
  var calendarProductId = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarProductId */ "f"]);
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__[/* getDepartureDate */ "b"]);
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__[/* getTripDuration */ "c"]);
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"]);
  var priceOfStayArgs = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStayArgsSelector */ "a"]);
  var priceOfStayIsLoading = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStayIsLoadingSelector */ "b"]);

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(function (state) {
    return {
      priceOfStay: Object(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStaySelector */ "c"])(state),
      priceOfStayError: state.priceRemote.priceOfStay.error,
      priceTicketIsLoading: state.priceTicket.isLoading
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceOfStayError = _useSelector.priceOfStayError,
      priceTicketIsLoading = _useSelector.priceTicketIsLoading;

  var calendarSynchronized = calendarDepartureCity === departureCity && calendarProductId === productId;
  var calendarIsReady = calendarSynchronized && !calendarIsLoading;
  var hasValidCriteria = !blockInputDepartureDate && !!departureDate && !!duration;
  var withCustomCriteria = hasValidCriteria && calendarIsReady;

  var searchCriteria = _objectSpread(_objectSpread(_objectSpread({
    productId: productId,
    departureDate: withCustomCriteria ? departureDate : null,
    departureCity: departureCity,
    duration: duration
  }, kids && withCustomCriteria ? {
    kids: kids
  } : null), adults && withCustomCriteria ? {
    adults: adults
  } : null), {}, {
    offerName: offerName
  }); // Fixme: refactor kids and adults reducers so that their state does not change unnecessarily


  var debouncedSearchCriteria = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_12__[/* useDebounce */ "a"])([departureCity, withCustomCriteria ? departureDate : null, duration, JSON.stringify(withCustomCriteria ? kids : null), JSON.stringify(withCustomCriteria ? adults : null), productId], 500);
  Object(react__WEBPACK_IMPORTED_MODULE_9__["useEffect"])(function () {
    if (withCustomCriteria && departureCity) {
      dispatch(Object(_client_store_price_remote_price_of_stay_priceOfStay_actions__WEBPACK_IMPORTED_MODULE_14__[/* getPriceOfStay */ "a"])(appContext, searchCriteria));
    }
  }, debouncedSearchCriteria);
  var searchCriteriaNotSynchronized = withCustomCriteria && JSON.stringify(priceOfStayArgs) !== JSON.stringify(Object(_client_store_price_remote_price_of_stay_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_17__[/* getPriceOfStayArgs */ "b"])(searchCriteria));
  var isLoading = !isAppMounted || !calendarIsReady || searchCriteriaNotSynchronized || Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__[/* isFeatureFlipped */ "a"])(appContext)('remoteBasePriceDisplay') && priceTicketIsLoading || priceOfStayIsLoading;
  var hasValidPriceTicketCriteria = departureCity && productId;
  var shouldDisplayPriceTicket = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__[/* isFeatureFlipped */ "a"])(appContext)('remoteBasePriceDisplay');
  var shouldDisplaySpinnerForPriceTicket = shouldDisplayPriceTicket && hasValidPriceTicketCriteria && (!calendarSynchronized || priceTicketIsLoading);
  var shouldDisplaySpinnerForPriceOfStay = !shouldDisplayPriceTicket && hasValidCriteria && (!calendarSynchronized || priceOfStayIsLoading);
  var shouldDisplaySpinner = searchCriteriaNotSynchronized || shouldDisplaySpinnerForPriceTicket || shouldDisplaySpinnerForPriceOfStay;
  return {
    hasValidCriteria: hasValidCriteria,
    isLoading: isLoading,
    priceOfStay: priceOfStay,
    priceOfStayError: priceOfStayError,
    shouldDisplaySpinner: shouldDisplaySpinner
  };
}

/***/ }),

/***/ "QkOM":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("9JhN");
var trim = __webpack_require__("Ya2h").trim;
var whitespaces = __webpack_require__("+/eK");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "QknU":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "Qq9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleStreetView; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_google_google_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UlIv");
/* harmony import */ var _utils_google_google_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("elUy");
/* harmony import */ var _Map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Vazi");
/* harmony import */ var _StreetView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("HKmi");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;






var GoogleStreetView = function GoogleStreetView(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$fov = _ref.fov,
      fov = _ref$fov === void 0 ? 2 : _ref$fov,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 2 : _ref$heading,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 120 : _ref$height,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      title = _ref.title,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 640 : _ref$width;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_2__[/* useTracking */ "a"])();
  var staticMapOptions = {
    size: "".concat(width, "x").concat(height),
    location: "".concat(latitude, ",").concat(longitude),
    fov: fov,
    heading: heading,
    pitch: 0 // guess what, the pitch that gets returned from the API is all kinds of wrong
    // because it really likes looking at ceilings; people don't want to look at
    // ceilings, so we hardcode the pitch to 0 until the API gets its act together
    // and returns 0; tbh we shouldn't even need the API to provide this to us.

  };
  return __jsx(_Map__WEBPACK_IMPORTED_MODULE_5__[/* Map */ "a"], {
    className: className,
    closeLabel: closeLabel,
    dataTestId: "streetview-preview",
    imageSrc: Object(_utils_google_google_utils__WEBPACK_IMPORTED_MODULE_4__[/* getStaticMapURL */ "b"])(_utils_google_google_constants__WEBPACK_IMPORTED_MODULE_3__[/* GOOGLE_API_STREET_VIEW_PATH */ "e"], staticMapOptions),
    onClick: function onClick() {
      return track({
        categoryGA: 'resort',
        actionGA: 'mapClick',
        labelGA: 'GoogleStreetView'
      });
    },
    ratio: {
      w: width,
      h: height
    },
    title: title
  }, __jsx(_StreetView__WEBPACK_IMPORTED_MODULE_6__[/* StreetView */ "a"], {
    fov: fov,
    heading: heading,
    latitude: latitude,
    longitude: longitude
  }));
};

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrivalDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var arrivalDate = _ref5.arrivalDate;
  return arrivalDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinEmail = _ref6.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinSms = _ref7.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinMail = _ref8.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinPhone = _ref9.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref10) {
  var optinFosun = _ref10.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var duration = _ref11.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref12) {
  var flexibility = _ref12.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBiB":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("0Ocv"),
    isIterateeCall = __webpack_require__("R5u7"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RHTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sheet; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 7 modules
var Multimedia = __webpack_require__("h3D+");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasDiamond = _ref.hasDiamond,
        hasSlideshow = _ref.hasSlideshow,
        isExclusiveCollection = _ref.isExclusiveCollection,
        fullWidthContent = _ref.fullWidthContent;
    return {
      thRoot: 'bg-white',
      thHeader: '',
      thHeaderContainer: 'mx-auto w-full max-w-site-medium',
      thTop: Object(classnames_utils["a" /* classnames */])('relative', {
        'mb-35 lg:mb-55': hasDiamond,
        'md:mb-[11px] md:mt-54': !hasDiamond
      }),
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroImmersive: hasSlideshow ? 'min-h-[102%] filter-[blur(10px)] opacity-25' : '',
      thSlideshow: "my-0 mx-auto w-full ".concat(isExclusiveCollection ? 'bg-ultramarine' : 'bg-darkGrey'),
      thMultimediaOverlay: 'absolute inset-0 mb-10',
      thDiamond: 'absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 -mb-2',
      thDiamondClassName: 'font-bold uppercase text-10 sm:text-12 size-60 lg:size-75',
      thBody: "".concat(fullWidthContent ? '' : 'px-20', " py-20 lg:py-15"),
      thContent: "".concat(fullWidthContent ? '' : 'max-w-site-medium', " mx-auto w-full"),
      thFooter: 'bg-pearl overflow-hidden px-20'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx



var __jsx = react_default.a.createElement;









function Sheet(_ref) {
  var children = _ref.children,
      header = _ref.header,
      className = _ref.className,
      diamond = _ref.diamond,
      immersive = _ref.immersive,
      isExclusiveCollection = _ref.isExclusiveCollection,
      footer = _ref.footer,
      fullWidthContent = _ref.fullWidthContent,
      multimedia = _ref.multimedia,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(0),
      imageIndex = _useState[0],
      setImageIndex = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasSlideshow = !isEmpty_default()(slideshow.media);
  var hasDiamond = !isEmpty_default()(diamond);

  var _themes$theme = themes[theme]({
    hasDiamond: hasDiamond,
    hasSlideshow: hasSlideshow,
    isExclusiveCollection: isExclusiveCollection,
    fullWidthContent: fullWidthContent
  }),
      thBody = _themes$theme.thBody,
      thContent = _themes$theme.thContent,
      thDiamond = _themes$theme.thDiamond,
      thDiamondClassName = _themes$theme.thDiamondClassName,
      thFooter = _themes$theme.thFooter,
      thHeader = _themes$theme.thHeader,
      thHeaderContainer = _themes$theme.thHeaderContainer,
      thHero = _themes$theme.thHero,
      thHeroImmersive = _themes$theme.thHeroImmersive,
      thMultimediaOverlay = _themes$theme.thMultimediaOverlay,
      thRoot = _themes$theme.thRoot,
      thSlideshow = _themes$theme.thSlideshow,
      thTop = _themes$theme.thTop;

  return __jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, header && __jsx("div", {
    className: thHeaderContainer,
    "data-testid": "Sheet-header"
  }, __jsx("div", {
    className: thHeader
  }, header)), (!isEmpty_default()(immersive) || hasSlideshow) && __jsx("div", {
    className: thTop
  }, !isEmpty_default()(immersive) && !hasSlideshow && __jsx("div", {
    className: thHero
  }, __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, immersive, {
    className: Object(classnames_utils["a" /* classnames */])(thHeroImmersive, immersive.className),
    size: "medium"
  }))), hasSlideshow && __jsx(react_default.a.Fragment, null, __jsx("div", {
    className: thSlideshow
  }, __jsx(ImageSlideShow["a" /* ImageSlideShow */], Object(esm_extends["a" /* default */])({
    media: slideshow.media,
    nbItemsToShow: 1,
    centerPadding: isTablet ? 0.25 : 0,
    fadeUnseenItems: isTablet,
    spacerWidth: isTablet ? 5 : 0,
    ratio: ratios_utils["c" /* default */].XL,
    onChangeIndex: setImageIndex
  }, slideshow)), __jsx("div", {
    className: "absolute start-0 top-0 mx-10 my-10 rounded-4 bg-darkGrey/80 px-15 py-10 text-14 text-white shadow-sm md:bottom-0 md:top-auto md:mx-20"
  }, "".concat(imageIndex + 1, "/").concat(slideshow.media.length))), !isEmpty_default()(multimedia) && __jsx("div", {
    className: thMultimediaOverlay
  }, __jsx(Multimedia["a" /* Multimedia */], Object(esm_extends["a" /* default */])({}, multimedia, {
    className: "flex h-full flex-col",
    hasFullScreenButton: true,
    initialIndex: imageIndex
  })))), hasDiamond && __jsx("div", {
    className: thDiamond
  }, __jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, diamond, {
    className: Object(classnames_utils["a" /* classnames */])(thDiamondClassName, diamond === null || diamond === void 0 ? void 0 : diamond.className),
    variant: "diamond"
  })))), __jsx("div", {
    className: thBody,
    "data-testid": "Sheet-body"
  }, __jsx("div", {
    className: thContent
  }, children)), !!footer && __jsx("footer", {
    className: thFooter
  }, __jsx("div", {
    className: thContent
  }, footer)));
}

/***/ }),

/***/ "RWUY":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("pfAP");
var isSymbol = __webpack_require__("km0D");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "RYcy":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("m2YG");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "Rj53":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    createAggregator = __webpack_require__("8uyH");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ "RlI+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FREEZING = __webpack_require__("+pJz");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var defineBuiltIns = __webpack_require__("D092");
var InternalMetadataModule = __webpack_require__("wKkN");
var collection = __webpack_require__("IYAN");
var collectionWeak = __webpack_require__("LFxm");
var isObject = __webpack_require__("1YFU");
var enforceInternalState = __webpack_require__("9jKB").enforce;
var fails = __webpack_require__("fhLv");
var NATIVE_WEAK_MAP = __webpack_require__("bWWS");

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var FROZEN = {};
var SEALED = {};
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel == FROZEN) freeze(key);
      if (arrayIntegrityLevel == SEALED) seal(key);
      return this;
    }
  });
}


/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_COLOR_CLASS_NAMES; });
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* unused harmony export stringToDateFormatted */
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dLd+");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var PRICE_COLOR_CLASS_NAMES = {
  DARK_GREY: 'text-black hocus:text-black-active',
  GREEN: 'text-green',
  GREEN_OPACITY_45: 'text-green bestPrice',
  GREY: 'text-grey hocus:text-black-active',
  ORANGE: 'text-orange',
  ORANGE_OPACITY_45: 'text-orange lastAvailability',
  WHITE: 'text-white',
  TURQUOISE: 'text-turquoise'
};
var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_12___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(day1), 'days'));
};
var stringToDateFormatted = function stringToDateFormatted(date, format) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(date).format(format);
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_DATE */ "t"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound && firstSiblingOpenDayFound !== dateToInt(day) || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = dateToInt(day);
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) {
      return false;
    }

    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) {
      return true;
    }

    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_12___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_12___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_12___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function getPriceColor(_ref2) {
  var classColor = _ref2.classColor,
      from = _ref2.from,
      hasPrices = _ref2.hasPrices,
      resolvePrice = _ref2.resolvePrice,
      selectedMonth = _ref2.selectedMonth,
      to = _ref2.to;
  return function (day) {
    var dayAsInt = dateToInt(day);

    if (selectedMonth) {
      var firstDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "01"), 10);
      var lastDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "31"), 10); // Handle dates outside current month & without prices

      var isDayBeforeSelectedMonth = Boolean(dayAsInt < firstDayOfCurrentMonth);
      var isDayAfterSelectedMonth = Boolean(dayAsInt > lastDayOfCurrentMonth);

      if (isDayBeforeSelectedMonth || !from && isDayAfterSelectedMonth || !hasPrices) {
        return classColor === PRICE_COLOR_CLASS_NAMES.GREY;
      }
    }

    if (from) {
      var fromDateAsInt = dateToInt(from);

      if (to) {
        var toDateAsInt = dateToInt(to); // Handle dates between from and to dates

        if (dayAsInt >= fromDateAsInt && dayAsInt <= toDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        }
      } else {
        if (dayAsInt === fromDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        } // Handle dates before and after from date


        switch (classColor) {
          case PRICE_COLOR_CLASS_NAMES.WHITE:
            return false;

          case PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45:
          case PRICE_COLOR_CLASS_NAMES.GREY:
          case PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45:
            if (dayAsInt >= fromDateAsInt) {
              return false;
            }

            break;

          default:
            if (dayAsInt < fromDateAsInt) {
              return false;
            }

            break;
        }
      }
    } // Get the correct color based on price


    if (resolvePrice) {
      var dayWithPrice = resolvePrice(dateToInt(day)) || {
        isBestPrice: false,
        lastAvailability: false,
        price: ''
      };
      var isBestPrice = dayWithPrice.isBestPrice,
          lastAvailability = dayWithPrice.lastAvailability,
          price = dayWithPrice.price,
          siblingOpen = dayWithPrice.siblingOpen;

      if (siblingOpen) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE || classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE : classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE;
      }

      if (lastAvailability) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.ORANGE || classColor === PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.ORANGE;
      }

      if (isBestPrice) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.GREEN || classColor === PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.GREEN;
      }

      if (price) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY || classColor === PRICE_COLOR_CLASS_NAMES.GREY : classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY;
      }
    }

    return false;
  };
}
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "S8S5":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    customerId\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    dateOfBirth\n  }\n");

/***/ }),

/***/ "SRps":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C/y5");
/* harmony import */ var _exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7knX");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var ProductBanner = function ProductBanner(_ref) {
  var _product$destination;

  var className = _ref.className,
      product = _ref.product;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__[/* classnames */ "a"])('flex flex-col items-start text-black', className)
  }, __jsx("span", {
    className: "order-last inline-flex flex-wrap items-center gap-5 font-sans text-20 font-semibold",
    "data-testid": "ProductBlockHeader-name"
  }, product.name, product.isExplicitEC && __jsx(_exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__[/* ExclusiveCollectionBadge */ "a"], {
    className: "md:mx-5"
  }), product.seasonTrad && __jsx("span", {
    className: "shrink-0 whitespace-nowrap rounded-pill bg-turquoise px-10 py-5 text-center text-10 font-bold leading-1 text-white"
  }, product.seasonTrad)), __jsx("span", {
    className: "truncate font-sans text-14 font-semibold text-sienna",
    "data-testid": "ProductBlockHeader-country"
  }, product === null || product === void 0 ? void 0 : (_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country));
};

/***/ }),

/***/ "SqqE":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ "Swp0":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var definePropertyModule = __webpack_require__("87KK");
var makeBuiltIn = __webpack_require__("OoaE");
var defineGlobalProperty = __webpack_require__("9vpE");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "SyAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEDIA_TYPES_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDERED_MEDIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERED_MEDIAS_LAUNCHER; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var _ICONS, _MEDIA_TYPES_NAMES;


var MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  STREETVIEWS: 'streetViews',
  FLOORPLAN: 'floorPlans'
};
var ORDERED_MEDIAS = [MEDIA_TYPES.PHOTOS, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.FLOORPLAN, MEDIA_TYPES.STREETVIEWS];
var ORDERED_MEDIAS_LAUNCHER = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS];
var ICONS = (_ICONS = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.PHOTOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_PICTURE), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS360, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_360_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.STREETVIEWS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].STREET_VIEWS_360), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.FLOORPLAN, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].FLOOR_PLAN), _ICONS);
var MEDIA_TYPES_NAMES = (_MEDIA_TYPES_NAMES = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.FLOORPLAN, 'media_room_plan'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.PHOTOS, 'media_photos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.STREETVIEWS, 'media_streetviews'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS, 'media_videos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS360, 'media_360_view'), _MEDIA_TYPES_NAMES);


/***/ }),

/***/ "T3et":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("aWzz");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__("o+/o");

var _omit2 = _interopRequireDefault(_omit);

var _shallowEqual = __webpack_require__("aJtP");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// utils


var mainStyle = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var style = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  backgroundColor: 'transparent',
  position: 'absolute'
};

var GoogleMapMarkers = function (_Component) {
  _inherits(GoogleMapMarkers, _Component);

  /* eslint-disable react/forbid-prop-types */
  function GoogleMapMarkers(props) {
    _classCallCheck(this, GoogleMapMarkers);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getState = function () {
      return {
        children: _this.props.dispatcher.getChildren(),
        updateCounter: _this.props.dispatcher.getUpdateCounter()
      };
    };

    _this._onChangeHandler = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var prevChildCount = (_this.state.children || []).length;
      var state = _this._getState();

      _this.setState(state, function () {
        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
      });
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // click works only on hovered item
          _this.props.onChildClick(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseDown = function () {
      if (_this.props.onChildMouseDown) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // works only on hovered item
          _this.props.onChildMouseDown(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseEnter = function (hoverKey, childProps) {
      if (!_this.dimensionsCache_) {
        return;
      }

      if (_this.props.onChildMouseEnter) {
        _this.props.onChildMouseEnter(hoverKey, childProps);
      }

      _this.hoverChildProps_ = childProps;
      _this.hoverKey_ = hoverKey;
      _this.setState({ hoverKey: hoverKey });
    };

    _this._onChildMouseLeave = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var hoverKey = _this.hoverKey_;
      var childProps = _this.hoverChildProps_;

      if (hoverKey !== undefined && hoverKey !== null) {
        if (_this.props.onChildMouseLeave) {
          _this.props.onChildMouseLeave(hoverKey, childProps);
        }

        _this.hoverKey_ = null;
        _this.hoverChildProps_ = null;
        _this.setState({ hoverKey: null });
      }
    };

    _this._onMouseAllow = function (value) {
      if (!value) {
        _this._onChildMouseLeave();
      }

      _this.allowMouse_ = value;
    };

    _this._onMouseChangeHandler = function () {
      if (_this.allowMouse_) {
        _this._onMouseChangeHandlerRaf();
      }
    };

    _this._onMouseChangeHandlerRaf = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var mp = _this.props.dispatcher.getMousePosition();

      if (mp) {
        var distances = [];
        var hoverDistance = _this.props.getHoverDistance();

        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
          if (!child) return;
          // layers
          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
            return;
          }

          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
          var dist = _this.props.distanceToMouse(_this.dimensionsCache_[childKey], mp, child.props);
          if (dist < hoverDistance) {
            distances.push({
              key: childKey,
              dist: dist,
              props: child.props
            });
          }
        });

        if (distances.length) {
          distances.sort(function (a, b) {
            return a.dist - b.dist;
          });
          var hoverKey = distances[0].key;
          var childProps = distances[0].props;

          if (_this.hoverKey_ !== hoverKey) {
            _this._onChildMouseLeave();

            _this._onChildMouseEnter(hoverKey, childProps);
          }
        } else {
          _this._onChildMouseLeave();
        }
      } else {
        _this._onChildMouseLeave();
      }
    };

    _this._getDimensions = function (key) {
      var childKey = key;
      return _this.dimensionsCache_[childKey];
    };

    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);

    _this.dimensionsCache_ = {};
    _this.hoverKey_ = null;
    _this.hoverChildProps_ = null;
    _this.allowMouse_ = true;

    _this.state = _extends({}, _this._getState(), { hoverKey: null });
    return _this;
  }
  /* eslint-enable react/forbid-prop-types */

  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.experimental === true) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
    }

    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);

    this.dimensionsCache_ = null;
  };

  GoogleMapMarkers.prototype.render = function render() {
    var _this2 = this;

    var mainElementStyle = this.props.style || mainStyle;
    this.dimensionsCache_ = {};

    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
      if (!child) return undefined;
      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
        return _react2.default.cloneElement(child, {
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        });
      }

      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };

      var pt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(latLng) : _this2.props.geoService.fromLatLngToCenterPixel(latLng);

      var stylePtPos = {
        left: pt.x,
        top: pt.y
      };

      // If the component has a southeast corner defined (either as a LatLng, or a separate
      // lat and lng pair), set the width and height based on the distance between the northwest
      // and the southeast corner to lock the overlay to the correct geographic bounds.
      if (child.props.seLatLng !== undefined || child.props.seLat !== undefined && child.props.seLng !== undefined) {
        var seLatLng = child.props.seLatLng !== undefined ? child.props.seLatLng : { lat: child.props.seLat, lng: child.props.seLng };

        var sePt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(seLatLng) : _this2.props.geoService.fromLatLngToCenterPixel(seLatLng);

        stylePtPos.width = sePt.x - pt.x;
        stylePtPos.height = sePt.y - pt.y;
      }

      var containerPt = _this2.props.geoService.fromLatLngToContainerPixel(latLng);

      // to prevent rerender on child element i need to pass
      // const params $getDimensions and $dimensionKey instead of dimension object
      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;

      _this2.dimensionsCache_[childKey] = _extends({
        x: containerPt.x,
        y: containerPt.y
      }, latLng);

      return _react2.default.createElement(
        'div',
        {
          key: childKey,
          style: _extends({}, style, stylePtPos),
          className: child.props.$markerHolderClassName
        },
        _react2.default.cloneElement(child, {
          $hover: childKey === _this2.state.hoverKey,
          $getDimensions: _this2._getDimensions,
          $dimensionKey: childKey,
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        })
      );
    });

    return _react2.default.createElement(
      'div',
      { style: mainElementStyle },
      markers
    );
  };

  return GoogleMapMarkers;
}(_react.Component);

GoogleMapMarkers.propTypes = {
  geoService: _propTypes2.default.any,
  style: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  dispatcher: _propTypes2.default.any,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  getHoverDistance: _propTypes2.default.func,
  insideMapPanes: _propTypes2.default.bool,
  prerender: _propTypes2.default.bool
};
GoogleMapMarkers.defaultProps = {
  insideMapPanes: false,
  prerender: false
};
exports.default = GoogleMapMarkers;

/***/ }),

/***/ "TF5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductProgram; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("MWZw");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;





function ProductProgramSectionTitles(_ref) {
  var className = _ref.className,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return __jsx("div", {
    className: className
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__[/* Title */ "a"], {
    hLevel: 2,
    theme: "title-brand-n2"
  }, title), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__[/* Title */ "a"], {
    hLevel: 3,
    theme: "title-sans-n2"
  }, subtitle));
}

function ProductProgramFull(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      stops = _ref2.stops;
  return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(stops) ? null : __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, __jsx(ProductProgramSectionTitles, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('mb-30', className),
    subtitle: subtitle,
    title: title
  }), __jsx("div", {
    className: "gap-20 grid grid-cols-1 sm:grid-cols-2"
  }, stops.map(function (_ref3) {
    var day = _ref3.day,
        description = _ref3.description,
        stopTitle = _ref3.title,
        departureTime = _ref3.departureTime,
        arrivalTime = _ref3.arrivalTime;
    var departureArrivalTime = [arrivalTime, departureTime].filter(Boolean).join('\n');
    return day || description || stopTitle ? __jsx("div", {
      key: "".concat(day, " - ").concat(departureTime, " - ").concat(arrivalTime)
    }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__[/* Title */ "a"], {
      className: "mb-5",
      hLevel: 3,
      theme: "title-sans-n3"
    }, "".concat(day, " - ").concat(stopTitle)), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_9__[/* Text */ "a"], {
      text: description
    }), !!departureArrivalTime && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_9__[/* Text */ "a"], {
      text: departureArrivalTime
    })) : null;
  })));
}

function ProductProgramLite(_ref4) {
  var className = _ref4.className,
      title = _ref4.title,
      subtitle = _ref4.subtitle,
      stops = _ref4.stops;
  return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(stops) ? null : __jsx("section", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_8__[/* classnames */ "a"])('flex flex-col sm:flex-row gap-20', className)
  }, __jsx(ProductProgramSectionTitles, {
    className: "w-full sm:w-1/2",
    subtitle: subtitle,
    title: title
  }), __jsx("div", {
    className: "w-full sm:w-1/2"
  }, __jsx("ul", {
    className: "leading-normal text-14 text-black"
  }, stops.map(function (_ref5) {
    var day = _ref5.day,
        stopTitle = _ref5.title;
    return day || stopTitle ? __jsx("li", {
      className: "list-disc py-5",
      key: day
    }, __jsx("strong", null, day), " - ", stopTitle) : null;
  }))));
}

function ProductProgram(props) {
  var _props$extension = props.extension,
      extension = _props$extension === void 0 ? {} : _props$extension,
      isDetailed = props.isDetailed,
      _props$program = props.program,
      program = _props$program === void 0 ? {} : _props$program;

  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(program.stops)) {
    return null;
  }

  return isDetailed ? __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, __jsx(ProductProgramFull, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), __jsx(ProductProgramFull, {
    className: "mt-40",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  })) : __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, __jsx(ProductProgramLite, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), __jsx(ProductProgramLite, {
    className: "mt-40",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  }));
}

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhenIsOpen: true
          });
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_9__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaDisplayContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "TuHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorNote; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ErrorNote = function ErrorNote(_ref) {
  var className = _ref.className,
      errorMessage = _ref.errorMessage,
      _ref$errorNoteId = _ref.errorNoteId,
      errorNoteId = _ref$errorNoteId === void 0 ? 'error-note' : _ref$errorNoteId,
      _ref$isErrored = _ref.isErrored,
      isErrored = _ref$isErrored === void 0 ? false : _ref$isErrored;
  return __jsx("div", {
    "aria-live": "assertive",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-12 text-red', className),
    id: errorNoteId
  }, isErrored && errorMessage && __jsx("p", {
    className: "pt-5 pb-10"
  }, errorMessage));
};

/***/ }),

/***/ "U0R4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pointGeometry = __webpack_require__("aeo5");

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__("4GH7");

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _transform = __webpack_require__("XKJl");

var _transform2 = _interopRequireDefault(_transform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Geo = function () {
  function Geo(tileSize) {
    _classCallCheck(this, Geo);

    // left_top view пользует гугл
    // super();
    this.hasSize_ = false;
    this.hasView_ = false;
    this.transform_ = new _transform2.default(tileSize || 512);
  }

  Geo.prototype.setView = function setView(center, zoom, bearing) {
    this.transform_.center = _lat_lng2.default.convert(center);
    this.transform_.zoom = +zoom;
    this.transform_.bearing = +bearing;
    this.hasView_ = true;
  };

  Geo.prototype.setViewSize = function setViewSize(width, height) {
    this.transform_.width = width;
    this.transform_.height = height;
    this.hasSize_ = true;
  };

  Geo.prototype.setMapCanvasProjection = function setMapCanvasProjection(maps, mapCanvasProjection) {
    this.maps_ = maps;
    this.mapCanvasProjection_ = mapCanvasProjection;
  };

  Geo.prototype.canProject = function canProject() {
    return this.hasSize_ && this.hasView_;
  };

  Geo.prototype.hasSize = function hasSize() {
    return this.hasSize_;
  };

  /** Returns the pixel position relative to the map center. */


  Geo.prototype.fromLatLngToCenterPixel = function fromLatLngToCenterPixel(ptLatLng) {
    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
  };

  /**
   * Returns the pixel position relative to the map panes,
   * or relative to the map center if there are no panes.
   */


  Geo.prototype.fromLatLngToDivPixel = function fromLatLngToDivPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToDivPixel(latLng);
    }
    return this.fromLatLngToCenterPixel(ptLatLng);
  };

  /** Returns the pixel position relative to the map top-left. */


  Geo.prototype.fromLatLngToContainerPixel = function fromLatLngToContainerPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToContainerPixel(latLng);
    }

    var pt = this.fromLatLngToCenterPixel(ptLatLng);
    pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);

    pt.x += this.transform_.width / 2;
    pt.y += this.transform_.height / 2;

    return pt;
  };

  /** Returns the LatLng for the given offset from the map top-left. */


  Geo.prototype.fromContainerPixelToLatLng = function fromContainerPixelToLatLng(ptXY) {
    if (this.mapCanvasProjection_) {
      var latLng = this.mapCanvasProjection_.fromContainerPixelToLatLng(ptXY);
      return { lat: latLng.lat(), lng: latLng.lng() };
    }

    var ptxy = _extends({}, ptXY);
    ptxy.x -= this.transform_.width / 2;
    ptxy.y -= this.transform_.height / 2;
    var ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));

    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
    return ptRes;
  };

  Geo.prototype.getWidth = function getWidth() {
    return this.transform_.width;
  };

  Geo.prototype.getHeight = function getHeight() {
    return this.transform_.height;
  };

  Geo.prototype.getZoom = function getZoom() {
    return this.transform_.zoom;
  };

  Geo.prototype.getCenter = function getCenter() {
    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });

    return ptRes;
  };

  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
    var bndT = margins && margins[0] || 0;
    var bndR = margins && margins[1] || 0;
    var bndB = margins && margins[2] || 0;
    var bndL = margins && margins[3] || 0;

    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
      var topLeftCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: bndL - this.getWidth() / 2,
        y: bndT - this.getHeight() / 2
      }));
      var bottomRightCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: this.getWidth() / 2 - bndR,
        y: this.getHeight() / 2 - bndB
      }));

      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
      bottomRightCorner.lat, bottomRightCorner.lng, // SE
      bottomRightCorner.lat, topLeftCorner.lng, // SW
      topLeftCorner.lat, bottomRightCorner.lng];

      if (roundFactor) {
        res = res.map(function (r) {
          return Math.round(r * roundFactor) / roundFactor;
        });
      }
      return res;
    }

    return [0, 0, 0, 0];
  };

  return Geo;
}();

exports.default = Geo;

/***/ }),

/***/ "U2fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LAYER_HEADER_HEIGHT; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Layer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.themes.js
var themes = function themes(_ref) {
  var isActive = _ref.isActive,
      hasIcon = _ref.hasIcon;
  return {
    "default": {
      thRoot: "cursor-pointer flex flex-col sm:flex-row items-center p-5 rounded-4 text-12 text-black transition-colors duration-250 ease-in".concat(isActive ? ' bg-saffron hocus:bg-saffron-active' : ' hocus:text-black-active'),
      thIcon: 'm-5 shrink-0',
      thIconWidth: '1.25rem',
      thLabel: hasIcon ? 'sr-only' : ''
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.jsx

var __jsx = react_default.a.createElement;




var LayerHeaderButton_LayerHeaderButton = function LayerHeaderButton(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconClassName = _ref.iconClassName,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!label && !iconName) {
    return null;
  }

  var hasIcon = !!iconName;
  var _themes$theme = themes({
    isActive: isActive,
    hasIcon: hasIcon
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId,
    onClick: onClick
  }, tabIndex === -1 ? {
    tabIndex: tabIndex
  } : null, {
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thIcon, iconClassName),
    hasRtl: true,
    name: iconName,
    width: thIconWidth
  }), !!label && __jsx("span", {
    className: thLabel
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.themes.js
var LayerHeader_themes_themes = {
  "default": {
    thRoot: 'bg-white border-b-1 fixed overflow-hidden px-20 transition-heights duration-250 ease-in w-full z-3',
    thInner: 'flex h-full items-center w-full',
    thChild: 'w-full',
    thClose: 'leading-0 ms-auto order-1 p-10 text-black hocus:text-black-active transition-color',
    thCloseIconWidth: '1rem',
    thCloseLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.jsx

var LayerHeader_jsx = react_default.a.createElement;






var LayerHeader_LayerHeader = function LayerHeader(_ref) {
  var buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasContainer = _ref.hasContainer,
      height = _ref.height,
      onClose = _ref.onClose,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var layerButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  var _themes$theme = LayerHeader_themes_themes[theme],
      thChild = _themes$theme.thChild,
      thClose = _themes$theme.thClose,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thCloseLabel = _themes$theme.thCloseLabel,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  return LayerHeader_jsx("header", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    style: {
      height: height,
      maxHeight: height
    }
  }, LayerHeader_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thInner, {
      'm-auto w-full max-w-site': hasContainer
    }),
    "data-testid": "LayerHeader-body"
  }, LayerHeader_jsx("button", {
    className: thClose,
    "data-testid": "Layer-close",
    onClick: onClose,
    ref: layerButtonRef,
    type: "button"
  }, !!closeLabel && LayerHeader_jsx("span", {
    className: thCloseLabel
  }, closeLabel), LayerHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-left"
  }, buttonLeft, {
    theme: theme
  })), !!react["Children"].count(children) && LayerHeader_jsx("div", {
    className: thChild
  }, children), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-right"
  }, buttonRight, {
    theme: theme
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/Layer.jsx







var Layer_jsx = react_default.a.createElement;









var LAYER_HEADER_HEIGHT = 60;

var onScroll = throttle_default()(function () {
  Object(lib["forceCheck"])();
}, 250);

var Layer_LayerComponent = function LayerComponent(_ref, layerRef) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref$bgColor,
      buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      customHeader = _ref.customHeader,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Layer' : _ref$dataTestId,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? 'ltr:animate-slideInRight rtl:animate-slideInLeft' : _ref$enterAnimation,
      _ref$externalFocusTra = _ref.externalFocusTrapRefs,
      externalFocusTrapRefs = _ref$externalFocusTra === void 0 ? [] : _ref$externalFocusTra,
      hasAnimateEnter = _ref.hasAnimateEnter,
      hasContainer = _ref.hasContainer,
      hasContainerHeader = _ref.hasContainerHeader,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      header = _ref.header,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(ToastContext["a" /* ToastContext */]),
      ref = _useContext.ref;

  var layerBody = Object(react["useRef"])(null);
  Object(react["useImperativeHandle"])(layerRef, function () {
    return layerBody.current;
  }, [layerBody]);
  Object(react["useEffect"])(function () {
    var _layerBody$current;

    (_layerBody$current = layerBody.current) === null || _layerBody$current === void 0 ? void 0 : _layerBody$current.addEventListener('scroll', onScroll);
    return function () {
      var _layerBody$current2;

      (_layerBody$current2 = layerBody.current) === null || _layerBody$current2 === void 0 ? void 0 : _layerBody$current2.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasHeader = buttonLeft || buttonRight || header;

  var getStyle = function getStyle() {
    return hasHeader || !hasHeader && customHeader ? {
      paddingTop: customHeader ? customHeader.height : LAYER_HEADER_HEIGHT
    } : {};
  };

  var shards = ref ? [ref].concat(Object(toConsumableArray["a" /* default */])(externalFocusTrapRefs)) : externalFocusTrapRefs;
  return Layer_jsx(Portal["a" /* default */], {
    name: portalName
  }, Layer_jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: shards.filter(Boolean)
  }, Layer_jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, Layer_jsx("aside", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, Layer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])("animation-duration-500 bg-".concat(bgColor), 'fixed inset-0 w-full', Object(defineProperty["a" /* default */])({}, enterAnimation, hasAnimateEnter), className),
    "data-testid": dataTestId,
    role: "document"
  }, hasHeader && Layer_jsx(LayerHeader_LayerHeader, {
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    closeLabel: [closeLabel, ariaLabel].join(' ').trim(),
    hasContainer: hasContainerHeader,
    height: LAYER_HEADER_HEIGHT,
    onClose: onClose,
    theme: theme
  }, header), !hasHeader && customHeader && customHeader.content, Layer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('scroll-y z-0 h-full transition-all duration-250 ease-in', {
      'px-20': hasContainer
    }),
    "data-testid": "Layer-body",
    ref: layerBody,
    style: getStyle()
  }, Layer_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('h-full min-h-full', {
      'mx-auto w-full max-w-site': hasContainer
    }),
    "data-testid": "Layer-content"
  }, children)))))));
}; // $FlowFixMe


var Layer = /*#__PURE__*/Object(react["forwardRef"])(Layer_LayerComponent);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */




var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      lodash_get__WEBPACK_IMPORTED_MODULE_10___default()(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          contentClassName = _this$props.contentClassName,
          hasArrow = _this$props.hasArrow,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          noLayout = _this$props.noLayout,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = Object(_DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"])({
        hasArrow: hasArrow
      })[theme].thBody;
      return __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])('inline-block', className),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_12__[/* classnames */ "a"])({
          'absolute left-1/2 w-full min-w-full -translate-x-1/2 transform': !noLayout
        }, contentClassName, thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  hasArrow: true,
  isExpanded: false,
  noLayout: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "U7t3":
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),

/***/ "UAZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ EventForm_EventForm; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// CONCATENATED MODULE: ./src/client/components/widgets/event-form/eventForm.utils.js












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var EVENT_TYPES = dist["constants"].EVENT_TYPES,
    CLIENT_TYPES = dist["constants"].CLIENT_TYPES,
    USER_SALUTATIONS = dist["constants"].USER_SALUTATIONS;
var FORM_ACTIONS = {
  SUBMIT_EVENT: 'SUBMIT_EVENT',
  SUBMIT_EVENT_ERROR: 'SUBMIT_EVENT_ERROR',
  SUBMIT_EVENT_SUCCESS: 'SUBMIT_EVENT_SUCCESS'
};
var FORM_STATUS = {
  NEW: 'neutral',
  SUCCESS: 'success',
  ERROR: 'error'
};
var getInitialFormValues = function getInitialFormValues() {
  return {
    type: '',
    numberOfParticipants: '',
    withRooms: false,
    numberOfRooms: '',
    withServices: false,
    withTransport: false,
    departureCity: '',
    logisticsComment: '',
    withMeetingRooms: false,
    region: '',
    resort: '',
    dates: '',
    withFlexibleDates: false,
    company: '',
    salutation: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    postcode: '',
    city: '',
    country: '',
    generalComment: '',
    optinEmail: false,
    optinSMS: false,
    optinPhone: false
  };
};

var encodeStringValues = function encodeStringValues(values) {
  var encodedValues = {};
  Object.keys(values).forEach(function (key) {
    if (typeof values[key] === 'string') {
      encodedValues[key] = encodeURIComponent(values[key]);
    }
  });
  return _objectSpread(_objectSpread({}, values), encodedValues);
};

var eventForm_utils_getEventQuery = function getEventQuery(values, formType) {
  var _encodeStringValues = encodeStringValues(values),
      address = _encodeStringValues.address,
      city = _encodeStringValues.city,
      company = _encodeStringValues.company,
      country = _encodeStringValues.country,
      dates = _encodeStringValues.dates,
      departureCity = _encodeStringValues.departureCity,
      email = _encodeStringValues.email,
      firstName = _encodeStringValues.firstName,
      generalComment = _encodeStringValues.generalComment,
      lastName = _encodeStringValues.lastName,
      logisticsComment = _encodeStringValues.logisticsComment,
      numberOfParticipants = _encodeStringValues.numberOfParticipants,
      numberOfRooms = _encodeStringValues.numberOfRooms,
      optinEmail = _encodeStringValues.optinEmail,
      optinPhone = _encodeStringValues.optinPhone,
      optinSMS = _encodeStringValues.optinSMS,
      phone = _encodeStringValues.phone,
      postcode = _encodeStringValues.postcode,
      region = _encodeStringValues.region,
      resort = _encodeStringValues.resort,
      salutation = _encodeStringValues.salutation,
      type = _encodeStringValues.type,
      withFlexibleDates = _encodeStringValues.withFlexibleDates,
      withMeetingRooms = _encodeStringValues.withMeetingRooms,
      withRooms = _encodeStringValues.withRooms,
      withTransport = _encodeStringValues.withTransport; // We need to encode special chars in order to send them via the graphQL query


  var departureDate = dates.from ? "\"".concat(moment_default()(dates.from).format('YYYY-MM-DD'), "\"") : 'null';
  var returnDate = dates.to ? "\"".concat(moment_default()(dates.to).format('YYYY-MM-DD'), "\"") : 'null';
  var numberOfRoomsValue = withRooms ? numberOfRooms : 'null';
  var salutationValue = salutation ? salutation : 'null';
  return "mutation {\n    event(eventInput: {\n      address: \"".concat(address, "\",\n      city: \"").concat(city, "\",\n      company: \"").concat(company, "\",\n      country: \"").concat(country, "\",\n      departureDate: ").concat(departureDate, ",\n      departureCity: \"").concat(departureCity, "\",\n      email: \"").concat(email, "\",\n      firstName: \"").concat(firstName, "\",\n      generalComment: \"").concat(generalComment, "\",\n      interest: ").concat(type, ",\n      lastName: \"").concat(lastName, "\",\n\t\t\tlogisticsComment: \"").concat(logisticsComment, "\",\n      numberOfParticipants: ").concat(numberOfParticipants, ",\n      numberOfRooms: ").concat(numberOfRoomsValue, ",\n      optinEmail: ").concat(optinEmail.toString(), ",\n      optinPhone: ").concat(optinPhone.toString(), ",\n      optinSMS: ").concat(optinSMS.toString(), ",\n      phone: \"").concat(phone, "\",\n      postcode: \"").concat(postcode, "\",\n      region: \"").concat(region, "\",\n      resort: \"").concat(resort, "\",\n      returnDate: ").concat(returnDate, ",\n      salutation: ").concat(salutationValue, ",\n      withFlexibleDates: ").concat(withFlexibleDates.toString(), ",\n      withMeetingRooms: ").concat(withMeetingRooms.toString(), ",\n      withTransport: ").concat(withTransport.toString(), ",\n    }, formType: \"").concat(formType, "\") {\n      __typename\n      ...on EventError {\n        statusCode\n        statusMessage\n        errorCode\n        errorDescription\n      }\n      ...on Event {\n        id\n      }\n    }\n  }");
};
var eventForm_utils_getEventSchema = function getEventSchema(_ref) {
  var displayAddressFields = _ref.displayAddressFields,
      resortIds = _ref.resortIds; // N.B: the salesforce API as a max length limit of 255 characters for strings

  var addressGroupSchema = displayAddressFields ? {
    address: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.streetPlaceholder')).max(255),
    postcode: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.postcodePlaceholder')).max(255),
    city: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.cityPlaceholder')).max(255),
    country: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.countryPlaceholder')).max(255)
  } : null;
  return lib["object"]().shape(_objectSpread(_objectSpread({
    type: lib["mixed"]().oneOf(Object.keys(EVENT_TYPES)).required(Object(i18n["h" /* t */])('eventForm.packageSection.eventTypePlaceholder')),
    numberOfRooms: lib["number"]().min(1),
    withFlexibleDates: lib["boolean"](),
    withMeetingRooms: lib["boolean"](),
    withRooms: lib["boolean"](),
    withServices: lib["boolean"](),
    withTransport: lib["boolean"](),
    departureCity: lib["string"]().max(255),
    logisticsComment: lib["string"]().max(255),
    region: lib["string"](),
    resort: lib["mixed"]().oneOf(resortIds),
    dates: lib["object"]().shape({
      from: lib["date"]().nullable(),
      to: lib["date"]().nullable()
    }),
    company: lib["string"]().max(255),
    salutation: lib["mixed"]().oneOf(Object.keys(USER_SALUTATIONS)).required(Object(i18n["h" /* t */])('eventForm.userSection.salutationPlaceholder')),
    firstName: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder')).max(255),
    lastName: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder')).max(255),
    email: lib["string"]().email(Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')).required(Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')).max(255),
    numberOfParticipants: lib["number"]().min(1, Object(i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')).required(Object(i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')),
    phone: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.phonePlaceholder')).max(255)
  }, addressGroupSchema), {}, {
    generalComment: lib["string"]().max(255),
    optinEmail: lib["boolean"](),
    optinSMS: lib["boolean"](),
    optinPhone: lib["boolean"]()
  }));
};
var eventForm_utils_getEventAffinitySchema = function getEventAffinitySchema(_ref2) {
  var displayAddressFields = _ref2.displayAddressFields,
      resortIds = _ref2.resortIds; // N.B: the salesforce API as a max length limit of 255 characters for strings

  var addressGroupSchema = displayAddressFields ? {
    address: lib["string"]().max(255),
    postcode: lib["string"]().max(255),
    city: lib["string"]().max(255),
    country: lib["string"]().max(255)
  } : null;
  return lib["object"]().shape(_objectSpread(_objectSpread({
    type: lib["mixed"]().oneOf(Object.keys(CLIENT_TYPES)).required(Object(i18n["h" /* t */])('eventForm.userSection.clientTypePlaceholder')),
    region: lib["string"](),
    resort: lib["mixed"]().oneOf(resortIds),
    dates: lib["object"]().shape({
      from: lib["date"]().nullable(),
      to: lib["date"]().nullable()
    }).required(Object(i18n["h" /* t */])('eventForm.groupSection.datesPlaceholder')),
    company: lib["string"]().max(255),
    firstName: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder')).max(255),
    lastName: lib["string"]().required(Object(i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder')).max(255),
    email: lib["string"]().email(Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')).required(Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')).max(255),
    numberOfParticipants: lib["number"]().min(1, Object(i18n["h" /* t */])('eventForm.groupSection.numberOfParticipantsPlaceholder')).required(Object(i18n["h" /* t */])('eventForm.groupSection.numberOfParticipantsPlaceholder')),
    phone: lib["string"]().max(255)
  }, addressGroupSchema), {}, {
    generalComment: lib["string"]().max(255),
    optinEmail: lib["boolean"](),
    optinSMS: lib["boolean"](),
    optinPhone: lib["boolean"]()
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventFormForm.jsx

var __jsx = react_default.a.createElement;









var EventFormForm_EventFormForm = function EventFormForm(_ref) {
  var isSending = _ref.isSending,
      formStatus = _ref.formStatus,
      confirmation = _ref.confirmation,
      children = _ref.children;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  return __jsx(formik_esm["c" /* Form */], {
    "data-testid": "form"
  }, children, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('mt-15', {
      'text-right': formStatus === FORM_STATUS.NEW,
      'flex justify-center': formStatus !== FORM_STATUS.NEW
    })
  }, formStatus === FORM_STATUS.NEW ? __jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].SAFFRON,
    colorBorder: colors["a" /* COLORS */].SAFFRON,
    "data-testid": "event-submit",
    isLoading: isSending,
    type: "submit"
  }, Object(i18n["h" /* t */])('eventForm.formButton')) : __jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, confirmation, {
    status: formStatus
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 13 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventFormFields.jsx






var EventFormFields_jsx = react_default.a.createElement;








var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var EventFormFields_EventFormFields = function EventFormFields(_ref) {
  var _ref$displayAddressFi = _ref.displayAddressFields,
      displayAddressFields = _ref$displayAddressFi === void 0 ? true : _ref$displayAddressFi,
      typeOptions = _ref.typeOptions,
      regions = _ref.regions,
      resorts = _ref.resorts,
      userSalutationOptions = _ref.userSalutationOptions;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values;

  var openedResorts = resorts.filter(function (_ref2) {
    var openingStatus = _ref2.openingStatus;
    return openingStatus === OPENING_STATUS.OPEN;
  });
  return EventFormFields_jsx(react_default.a.Fragment, null, EventFormFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.packageSection.title')), EventFormFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-type",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.packageSection.eventTypeLabel'),
    name: "type",
    options: uniqBy_default()(typeOptions, 'value'),
    placeholder: Object(i18n["h" /* t */])('eventForm.packageSection.eventTypePlaceholder'),
    type: "select"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-participants",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsLabel'),
    min: 1,
    name: "numberOfParticipants",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder'),
    type: "number"
  }))), EventFormFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.staySection.title')), EventFormFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormFields_jsx("div", {
    className: "w-full md:w-1/2"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-region",
    label: Object(i18n["h" /* t */])('eventForm.staySection.destinationLabel'),
    name: "region",
    options: regions,
    placeholder: Object(i18n["h" /* t */])('eventForm.staySection.destinationPlaceholder'),
    type: "select"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-resort",
    label: Object(i18n["h" /* t */])('eventForm.staySection.resortLabel'),
    name: "resort",
    options: openedResorts.filter(function (resort) {
      return !values.region || resort.regionId === values.region;
    }).map(function (resort) {
      return {
        name: resort.name,
        value: resort.id
      };
    }),
    placeholder: Object(i18n["h" /* t */])('eventForm.staySection.resortPlaceholder'),
    type: "select"
  }))), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/4"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "z-1",
    isDateRange: true,
    label: Object(i18n["h" /* t */])('eventForm.staySection.datesLabel'),
    minDate: moment_default()().add({
      days: 1
    }).toDate(),
    name: "dates",
    placeholder: Object(i18n["h" /* t */])('eventForm.staySection.datesPlaceholder'),
    type: "datepicker"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/4"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10 md:mt-30",
    dataTestId: "event-flexible-dates",
    label: Object(i18n["h" /* t */])('eventForm.staySection.flexibleDatesLabel'),
    name: "withFlexibleDates",
    type: "checkbox"
  })), EventFormFields_jsx("p", {
    className: "mb-10 w-full px-10 pt-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.packageServicesLabel')), EventFormFields_jsx("div", {
    className: "flex w-full flex-wrap md:w-1/2"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    dataTestId: "event-with-rooms",
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsCheckboxLabel'),
    name: "withRooms",
    optimized: true,
    type: "checkbox"
  }), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-number-rooms",
    hideErrorMessage: true,
    isDisabled: !values.withRooms,
    isRequired: values.withRooms,
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputLabel'),
    min: 1,
    name: "numberOfRooms",
    placeholder: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputPlaceholder'),
    type: "number"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationCheckboxLabel'),
    name: "withTransport",
    optimized: true,
    type: "checkbox"
  }), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: !values.withTransport,
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputLabel'),
    maxLength: 255,
    name: "departureCity",
    placeholder: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputPlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.meetingRoomsCheckboxLabel'),
    name: "withMeetingRooms",
    optimized: true,
    type: "checkbox"
  }))), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesCheckboxLabel'),
    name: "withServices",
    optimized: true,
    type: "checkbox"
  }), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: !values.withServices,
    label: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputLabel'),
    name: "logisticsComment",
    maxLength: 255,
    placeholder: Object(i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputPlaceholder'),
    type: "textarea"
  }))), EventFormFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.userSection.title')), EventFormFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormFields_jsx("div", {
    className: "w-full"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-company",
    label: Object(i18n["h" /* t */])('eventForm.userSection.companyLabel'),
    maxLength: 255,
    name: "company",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.companyPlaceholder'),
    type: "text"
  }))), EventFormFields_jsx("div", {
    className: "w-1/2 p-10 md:w-1/6"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-salutation",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.salutationLabel'),
    name: "salutation",
    optimized: true,
    options: userSalutationOptions,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.salutationPlaceholder'),
    type: "select"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/3"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-firstName",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.firstNameLabel'),
    maxLength: 255,
    name: "firstName",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-lastName",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.lastNameLabel'),
    maxLength: 255,
    name: "lastName",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-email",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.emailLabel'),
    maxLength: 255,
    name: "email",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-phone",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.phoneLabel'),
    maxLength: 255,
    name: "phone",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.phonePlaceholder'),
    type: "text"
  })), displayAddressFields && EventFormFields_jsx("div", {
    className: "flex w-full flex-wrap"
  }, EventFormFields_jsx("p", {
    className: "mb-10 w-full px-10 pt-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('eventForm.userSection.addressLabel')), EventFormFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-address",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.streetLabel'),
    maxLength: 255,
    name: "address",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.streetPlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-1/2 p-10 md:w-1/6"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-postcode",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.postcodeLabel'),
    maxLength: 255,
    name: "postcode",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.postcodePlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full md:w-1/3"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-city",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.cityLabel'),
    maxLength: 255,
    name: "city",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.cityPlaceholder'),
    type: "text"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-country",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.countryLabel'),
    maxLength: 255,
    name: "country",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.countryPlaceholder'),
    type: "text"
  }))))), EventFormFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.commentSection.title')), EventFormFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(i18n["h" /* t */])('eventForm.commentSection.commentLabel'),
    maxLength: 255,
    name: "generalComment",
    placeholder: Object(i18n["h" /* t */])('eventForm.commentSection.commentPlaceholder'),
    type: "textarea"
  })), EventFormFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormFields_jsx("p", {
    className: "mb-5"
  }, Object(i18n["h" /* t */])('eventForm.commentSection.optinLabel')), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.commentSection.emailOptinLabel'),
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.commentSection.smsOptinLabel'),
    name: "optinSMS",
    optimized: true,
    type: "checkbox"
  }), EventFormFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.commentSection.phoneOptinLabel'),
    name: "optinPhone",
    optimized: true,
    type: "checkbox"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventFormAffinityFields.jsx






var EventFormAffinityFields_jsx = react_default.a.createElement;








var EventFormAffinityFields_OPENING_STATUS = dist["constants"].OPENING_STATUS;
var EventFormAffinityFields_EventFormAffinityFields = function EventFormAffinityFields(_ref) {
  var _ref$displayAddressFi = _ref.displayAddressFields,
      displayAddressFields = _ref$displayAddressFi === void 0 ? true : _ref$displayAddressFi,
      typeOptions = _ref.typeOptions,
      regions = _ref.regions,
      resorts = _ref.resorts;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values;

  var openedResorts = resorts.filter(function (_ref2) {
    var openingStatus = _ref2.openingStatus;
    return openingStatus === EventFormAffinityFields_OPENING_STATUS.OPEN;
  });
  return EventFormAffinityFields_jsx(react_default.a.Fragment, null, EventFormAffinityFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.groupSection.title')), EventFormAffinityFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/4"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    className: "z-1",
    isDateRange: true,
    label: Object(i18n["h" /* t */])('eventForm.groupSection.datesLabel'),
    minDate: moment_default()().add({
      days: 1
    }).toDate(),
    name: "dates",
    placeholder: Object(i18n["h" /* t */])('eventForm.groupSection.datesPlaceholder'),
    type: "datepicker"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    dataTestId: "event-participants",
    label: Object(i18n["h" /* t */])('eventForm.groupSection.numberOfParticipantsLabel'),
    min: 1,
    name: "numberOfParticipants",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.groupSection.numberOfParticipantsPlaceholder'),
    type: "number"
  }))), EventFormAffinityFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full md:w-1/2"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-region",
    label: Object(i18n["h" /* t */])('eventForm.groupSection.destinationLabel'),
    name: "region",
    options: regions,
    placeholder: Object(i18n["h" /* t */])('eventForm.groupSection.destinationPlaceholder'),
    type: "select"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-resort",
    label: Object(i18n["h" /* t */])('eventForm.groupSection.resortLabel'),
    name: "resort",
    options: openedResorts.filter(function (resort) {
      return !values.region || resort.regionId === values.region;
    }).map(function (resort) {
      return {
        name: resort.name,
        value: resort.id
      };
    }),
    placeholder: Object(i18n["h" /* t */])('eventForm.groupSection.resortPlaceholder'),
    type: "select"
  }))), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    label: Object(i18n["h" /* t */])('eventForm.groupSection.commentLabel'),
    maxLength: 255,
    name: "generalComment",
    placeholder: Object(i18n["h" /* t */])('eventForm.groupSection.commentPlaceholder'),
    type: "textarea"
  }))), EventFormAffinityFields_jsx(Title["a" /* Title */], {
    className: "mb-10 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('eventForm.userSection.title')), EventFormAffinityFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-type",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.clientTypeLabel'),
    name: "type",
    options: uniqBy_default()(typeOptions, 'value'),
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.clientTypePlaceholder'),
    type: "select"
  })), EventFormAffinityFields_jsx("div", {
    className: "flex w-full flex-wrap"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/6"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-company",
    label: Object(i18n["h" /* t */])('eventForm.userSection.companyLabel'),
    maxLength: 255,
    name: "company",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.companyPlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-lastName",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.lastNameLabel'),
    maxLength: 255,
    name: "lastName",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/3"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-firstName",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.firstNameLabel'),
    maxLength: 255,
    name: "firstName",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder'),
    type: "text"
  }))), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-email",
    isRequired: true,
    label: Object(i18n["h" /* t */])('eventForm.userSection.emailLabel'),
    maxLength: 255,
    name: "email",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.emailPlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-phone",
    label: Object(i18n["h" /* t */])('eventForm.userSection.phoneLabel'),
    maxLength: 255,
    name: "phone",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.phonePlaceholder'),
    type: "text"
  })), displayAddressFields && EventFormAffinityFields_jsx("div", {
    className: "flex w-full flex-wrap"
  }, EventFormAffinityFields_jsx("p", {
    className: "mb-10 w-full px-10 pt-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('eventForm.userSection.addressLabel')), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-address",
    label: Object(i18n["h" /* t */])('eventForm.userSection.streetLabel'),
    maxLength: 255,
    name: "address",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.streetPlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-1/2 p-10 md:w-1/6"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-postcode",
    label: Object(i18n["h" /* t */])('eventForm.userSection.postcodeLabel'),
    maxLength: 255,
    name: "postcode",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.postcodePlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full md:w-1/3"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-city",
    label: Object(i18n["h" /* t */])('eventForm.userSection.cityLabel'),
    maxLength: 255,
    name: "city",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.cityPlaceholder'),
    type: "text"
  })), EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "event-owner-country",
    label: Object(i18n["h" /* t */])('eventForm.userSection.countryLabel'),
    maxLength: 255,
    name: "country",
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('eventForm.userSection.countryPlaceholder'),
    type: "text"
  }))))), EventFormAffinityFields_jsx("div", {
    className: "flex flex-wrap"
  }, EventFormAffinityFields_jsx("div", {
    className: "w-full p-10"
  }, EventFormAffinityFields_jsx("p", {
    className: "mb-5"
  }, Object(i18n["h" /* t */])('eventForm.userSection.optinLabel')), EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.userSection.emailOptinLabel'),
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.userSection.smsOptinLabel'),
    name: "optinSMS",
    optimized: true,
    type: "checkbox"
  }), EventFormAffinityFields_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    label: Object(i18n["h" /* t */])('eventForm.userSection.phoneOptinLabel'),
    name: "optinPhone",
    optimized: true,
    type: "checkbox"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventForm.jsx











var EventForm_jsx = react_default.a.createElement;


function EventForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EventForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var EventForm_OPENING_STATUS = dist["constants"].OPENING_STATUS;
var EventForm_EventForm = function EventForm(_ref) {
  var type = _ref.type,
      _ref$displayAddressFi = _ref.displayAddressFields,
      displayAddressFields = _ref$displayAddressFi === void 0 ? true : _ref$displayAddressFi,
      typeOptions = _ref.typeOptions,
      formError = _ref.formError,
      formSuccess = _ref.formSuccess,
      regions = _ref.regions,
      resorts = _ref.resorts,
      userSalutationOptions = _ref.userSalutationOptions;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: constants["n" /* MEETING_EVENT */].REQUEST
  });

  var _useReducer = Object(react["useReducer"])(function (state, action) {
    switch (action.type) {
      case FORM_ACTIONS.SUBMIT_EVENT:
        return EventForm_objectSpread(EventForm_objectSpread({}, state), {}, {
          isSending: true
        });

      case FORM_ACTIONS.SUBMIT_EVENT_ERROR:
        return {
          isSending: false,
          formStatus: FORM_STATUS.ERROR,
          confirmation: formError
        };

      case FORM_ACTIONS.SUBMIT_EVENT_SUCCESS:
        return {
          isSending: false,
          formStatus: FORM_STATUS.SUCCESS,
          confirmation: formSuccess
        };

      default:
        return state;
    }
  }, {
    isSending: false,
    formStatus: FORM_STATUS.NEW,
    confirmation: {}
  }),
      _useReducer$ = _useReducer[0],
      isSending = _useReducer$.isSending,
      formStatus = _useReducer$.formStatus,
      confirmation = _useReducer$.confirmation,
      dispatch = _useReducer[1];

  var onFormSubmit = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values) {
      var query, labelGA, _yield$graphQLClient$, event;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: FORM_ACTIONS.SUBMIT_EVENT
              });
              query = eventForm_utils_getEventQuery(values, type);
              labelGA = values.resort || null;
              _context.prev = 3;
              _context.next = 6;
              return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
                requestName: requestDictionary["nd" /* WIDGET_EVENT_FORM_SUBMIT */]
              });

            case 6:
              _yield$graphQLClient$ = _context.sent;
              event = _yield$graphQLClient$.event;

              if (event.errorCode) {
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
                });
                track({
                  actionGA: constants["n" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                  labelGA: labelGA
                });
              } else {
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT_SUCCESS
                });
                track({
                  actionGA: constants["n" /* MEETING_EVENT */].SEND_REQUEST_SUCCESS,
                  labelGA: labelGA
                });
              }

              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              dispatch({
                type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
              });
              track({
                actionGA: constants["n" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                labelGA: labelGA
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11]]);
    }));

    return function onFormSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var openedResorts = resorts.filter(function (_ref3) {
    var openingStatus = _ref3.openingStatus;
    return openingStatus === EventForm_OPENING_STATUS.OPEN;
  });
  var schemaArgs = {
    displayAddressFields: displayAddressFields,
    resortIds: openedResorts.map(function (resort) {
      return resort.id;
    })
  };
  return EventForm_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-40",
    id: "event-form"
  }, EventForm_jsx(LineTitle["a" /* LineTitle */], null, Object(i18n["h" /* t */])('eventForm.formTitle')), EventForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: getInitialFormValues(),
    validationSchema: type === 'classic' ? eventForm_utils_getEventSchema(schemaArgs) : eventForm_utils_getEventAffinitySchema(schemaArgs),
    onSubmit: onFormSubmit
  }, EventForm_jsx(EventFormForm_EventFormForm, {
    isSending: isSending,
    formStatus: formStatus,
    confirmation: confirmation
  }, type === 'classic' ? EventForm_jsx(EventFormFields_EventFormFields, {
    displayAddressFields: displayAddressFields,
    typeOptions: typeOptions,
    regions: regions,
    resorts: resorts,
    userSalutationOptions: userSalutationOptions
  }) : EventForm_jsx(EventFormAffinityFields_EventFormAffinityFields, {
    displayAddressFields: displayAddressFields,
    typeOptions: typeOptions,
    regions: regions,
    resorts: resorts
  }))));
};

/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ACCOMMODATION_FROM_ALTERNATIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IS_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PATCH_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOSAVE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INSURANCE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return INIT_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return TOGGLE_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PROPOSAL_REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDIT_HOUSEHOLDS; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_FROM_ALTERNATIVES = 'ADD_ACCOMMODATION_FROM_ALTERNATIVES';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var IS_BOOKING = 'IS_BOOKING';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var PATCH_PROPOSAL = 'PATCH_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID = 'SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE';
var AUTOSAVE = 'AUTOSAVE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_DELETED = 'INSURANCE_DELETED';
var INSURANCE_ADDED = 'INSURANCE_ADDED';
var INIT_INSURANCES = 'INIT_INSURANCES';
var TOGGLE_TERMS = 'TOGGLE_TERMS';
var PROPOSAL_REFRESH = 'PROPOSAL_REFRESH';
var EDIT_HOUSEHOLDS = 'EDIT_HOUSEHOLDS';

/***/ }),

/***/ "Uey1":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");
var isNullOrUndefined = __webpack_require__("nnO8");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "UlIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_API_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GOOGLE_API_STREET_VIEW_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOGLE_API_JS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GOOGLE_API_STATIC_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_PLACE_URL; });
var GOOGLE_API_DOMAIN = 'googlemap.api.domain';
var GOOGLE_API_KEY = 'googlemap.api.key';
var GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
var GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
var GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
var GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';


/***/ }),

/***/ "V/va":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("VXxY");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "V163":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ResortDistrict", function() { return /* binding */ ResortDistrict_ResortDistrict; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("c2re");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/client/store/pick-your-room/map/map.actions.js





var MAPBOX_TOKEN = config_default.a.get('pickYourRoom.mapbox.token');
var MAPBOX_API_HOST = config_default.a.get('pickYourRoom.mapbox.host');
var STYLE_ID = 'cjy7bs8eo09t31cld8nipbd6t';

function isResortLayer(layer) {
  return layer.type === 'raster' && !!layer.source && layer.source.indexOf('clubmed') > -1;
}

function selectResortLayer(mapStyle, resortId) {
  mapStyle.layers = mapStyle.layers.filter(function (layer) {
    var keepResort = !isResortLayer(layer) || layer.id === resortId;

    if (!keepResort) {
      delete mapStyle.sources[layer.source];
    }

    return keepResort;
  });
  return mapStyle;
}

function fetchMapBoxStyle() {
  return axios_default.a.get("".concat(MAPBOX_API_HOST, "/styles/v1/clubmed/").concat(STYLE_ID, "?access_token=").concat(MAPBOX_TOKEN), {
    headers: {
      accept: 'application/json'
    }
  }).then(function (res) {
    return res.data;
  });
}

function fetchResortMapBoxStyle(resortId) {
  return fetchMapBoxStyle().then(function (data) {
    return selectResortLayer(data, resortId);
  });
}
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-district/resortDistrict.utils.js
var resortDistrict_utils = __webpack_require__("dAFS");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/index.js + 18 modules
var esm = __webpack_require__("xP4S");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/AreaMarker.jsx
var __jsx = react_default.a.createElement;


var AreaMarker_AreaMarker = function AreaMarker(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      onClick = _ref.onClick;
  return __jsx(esm["b" /* Marker */], {
    latitude: latitude,
    longitude: longitude,
    offsetLeft: -9,
    offsetTop: -35,
    size: 16
  }, __jsx("div", {
    className: "cursor-pointer",
    onClick: onClick
  }, __jsx("div", {
    className: "z-5 size-16 rounded-half border-[0.25em] border-solid border-white bg-black"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/Map.jsx
















var Map_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var Map_MAPBOX_TOKEN = config_default.a.get('pickYourRoom.mapbox.token');
var MAPBOX_HOST = config_default.a.get('pickYourRoom.mapbox.host');

var getAreaCoordinates = function getAreaCoordinates(_ref) {
  var _areasCenter$find;

  var areasCenter = _ref.areasCenter,
      areaId = _ref.areaId;
  return (_areasCenter$find = areasCenter.find(function (_ref2) {
    var properties = _ref2.properties;
    return properties.area_id === areaId;
  })) === null || _areasCenter$find === void 0 ? void 0 : _areasCenter$find.geometry.coordinates;
};

var Map_Markers = function Markers(_ref3) {
  var areas = _ref3.areas,
      areasCenter = _ref3.areasCenter,
      roomAreas = _ref3.roomAreas,
      roomLabel = _ref3.roomLabel,
      selectedAreaId = _ref3.selectedAreaId,
      setSelectedAreaId = _ref3.setSelectedAreaId,
      shouldNavigateToArea = _ref3.shouldNavigateToArea,
      trackingData = _ref3.trackingData;

  var _useMap = Object(esm["g" /* useMap */])(),
      mapRef = _useMap.current;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  Object(react["useEffect"])(function () {
    var coordinates = getAreaCoordinates({
      areasCenter: areasCenter,
      areaId: selectedAreaId
    });

    if (coordinates && shouldNavigateToArea) {
      mapRef.easeTo({
        center: coordinates
      });
    }
  }, [selectedAreaId]);
  return areasCenter.map(function (point, i) {
    var _areas$find, _areas$find2;

    var _point$geometry$coord = Object(slicedToArray["a" /* default */])(point.geometry.coordinates, 2),
        longitude = _point$geometry$coord[0],
        latitude = _point$geometry$coord[1];

    var label = (_areas$find = areas.find(function (_ref4) {
      var id = _ref4.id;
      return id === point.properties.area_id;
    })) === null || _areas$find === void 0 ? void 0 : _areas$find.localizedLabel;
    var isExclusiveCollection = (_areas$find2 = areas.find(function (_ref5) {
      var id = _ref5.id;
      return id === point.properties.area_id;
    })) === null || _areas$find2 === void 0 ? void 0 : _areas$find2.isExclusiveCollection;
    var areaId = point.properties.area_id;
    var isActive = selectedAreaId === areaId;

    var onAreaMarkerClick = function onAreaMarkerClick() {
      track({
        labelGA: label
      });
      setSelectedAreaId(areaId);
    };

    var isRoomInArea = roomAreas.some(function (_ref6) {
      var roomAreaId = _ref6.id;
      return roomAreaId === areaId;
    });
    return Map_jsx(react["Fragment"], {
      key: "marker-".concat(i)
    }, Map_jsx(AreaMarker_AreaMarker, {
      latitude: latitude,
      longitude: longitude,
      onClick: onAreaMarkerClick
    }), Map_jsx(esm["d" /* Popup */], {
      anchor: "bottom",
      className: Object(classnames_utils["a" /* classnames */])('z-1 text-center font-brand text-16', {
        'ResortDistrictMapPopup--inactive text-white': !isActive && (isTablet || !roomAreas.length),
        'ResortDistrictMapPopup--active text-black': isActive || !isTablet && roomAreas.length,
        'text-ultramarine': isActive && isExclusiveCollection
      }),
      closeButton: false,
      closeOnClick: false,
      latitude: latitude,
      longitude: longitude,
      offsetTop: -40,
      tipSize: 4
    }, isTablet && isActive && roomAreas.length ? Map_jsx("div", {
      className: "cursor-pointer p-15",
      onClick: onAreaMarkerClick
    }, Map_jsx(Icon["a" /* Icon */], {
      name: isRoomInArea ? icons["a" /* ICONS */].ACCOMODATIONS : icons["a" /* ICONS */].NO_ACCOMMODATION,
      width: "2.1875rem",
      className: "my-10"
    }), Map_jsx("div", {
      className: "font-sans text-14 font-bold text-black"
    }, roomLabel), Map_jsx("div", {
      className: "mb-30 px-15 pb-5 font-sans text-12 text-black"
    }, isRoomInArea ? Object(i18n["h" /* t */])('common.resortDistrict.layerDistrictTooltip.availableLabel') : Object(i18n["h" /* t */])('common.resortDistrict.layerDistrictTooltip.unavailableLabel')), Map_jsx("div", null, label)) : Map_jsx("div", {
      className: "flex cursor-pointer items-stretch px-10 py-10 text-black",
      onClick: onAreaMarkerClick
    }, roomAreas.length && !isTablet ? Map_jsx(Icon["a" /* Icon */], {
      name: isRoomInArea ? icons["a" /* ICONS */].ACCOMODATIONS : icons["a" /* ICONS */].NO_ACCOMMODATION,
      width: "1.375rem"
    }) : label)));
  });
};

var Map = /*#__PURE__*/Object(react["memo"])(function (props) {
  var areas = props.areas,
      areasCenter = props.areasCenter,
      baseViewport = props.baseViewport,
      height = props.height,
      mapStyle = props.mapStyle,
      maxBounds = props.maxBounds,
      _props$roomAreas = props.roomAreas,
      roomAreas = _props$roomAreas === void 0 ? [] : _props$roomAreas,
      roomLabel = props.roomLabel,
      selectedAreaId = props.selectedAreaId,
      setMapIsLoaded = props.setMapIsLoaded,
      setSelectedAreaId = props.setSelectedAreaId,
      shouldNavigateToArea = props.shouldNavigateToArea,
      trackingData = props.trackingData;
  return Map_jsx("div", {
    className: "tap-highlight-color-transparent relative h-full w-full"
  }, Map_jsx("div", {
    className: "pointer-events-none absolute inset-0 z-1 bg-white opacity-25"
  }), Map_jsx(esm["f" /* default */], {
    mapboxAccessToken: Map_MAPBOX_TOKEN,
    mapStyle: mapStyle,
    reuseMaps: true,
    initialViewState: _objectSpread({}, baseViewport),
    style: {
      height: height,
      width: '100%'
    },
    onLoad: function onLoad() {
      setMapIsLoaded(true);
    },
    scrollZoom: false,
    doubleClickZoom: false,
    maxZoom: maxBounds.maxZoom,
    minZoom: maxBounds.minZoom,
    transformRequest: function transformRequest(url) {
      var uri = new URI_default.a(url).removeQuery('sku');
      var mapboxHost = uri.protocol() + '://' + uri.hostname();
      return {
        url: uri.toString().replace(mapboxHost, MAPBOX_HOST)
      };
    }
  }, Map_jsx(Map_Markers, {
    areas: areas,
    areasCenter: areasCenter,
    roomAreas: roomAreas,
    roomLabel: roomLabel,
    selectedAreaId: selectedAreaId,
    setSelectedAreaId: setSelectedAreaId,
    shouldNavigateToArea: shouldNavigateToArea,
    trackingData: trackingData
  })));
});
// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/SilderBottomControls.jsx
var SilderBottomControls_jsx = react_default.a.createElement;





var SilderBottomControls_SilderBottomControls = function SilderBottomControls(_ref) {
  var isPreviousControlDisabled = _ref.isPreviousControlDisabled,
      isNextControlDisabled = _ref.isNextControlDisabled,
      onPrevious = _ref.onPrevious,
      onNext = _ref.onNext,
      index = _ref.index,
      resortAreas = _ref.resortAreas,
      trackingData = _ref.trackingData;
  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  return SilderBottomControls_jsx("div", {
    className: "pointer-events-auto absolute inset-x-0 mt-15 flex items-center justify-center gap-20"
  }, SilderBottomControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "h-12 flex-none text-8",
    isDisabled: isPreviousControlDisabled,
    color: colors["a" /* COLORS */].TRANSPARENT,
    label: Object(i18n["h" /* t */])('common.previous'),
    onClick: function onClick(e) {
      var _resortAreas$areas;

      track({
        labelGA: "arrowsBelow_".concat((_resortAreas$areas = resortAreas.areas[index - 1]) === null || _resortAreas$areas === void 0 ? void 0 : _resortAreas$areas.label)
      });
      onPrevious(e);
    },
    theme: "ghost"
  }), SilderBottomControls_jsx("span", {
    className: "flex items-baseline justify-center text-12 text-black"
  }, SilderBottomControls_jsx("span", {
    className: "text-14 font-bold"
  }, index + 1), "/", resortAreas.areas.length), SilderBottomControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "h-12 flex-none text-8",
    color: colors["a" /* COLORS */].TRANSPARENT,
    isDisabled: isNextControlDisabled,
    label: Object(i18n["h" /* t */])('common.next'),
    onClick: function onClick(e) {
      var _resortAreas$areas2;

      track({
        labelGA: "arrowsBelow_".concat((_resortAreas$areas2 = resortAreas.areas[index + 1]) === null || _resortAreas$areas2 === void 0 ? void 0 : _resortAreas$areas2.label)
      });
      onNext(e);
    },
    rotation: 180,
    theme: "ghost"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/resort-district/ResortDistrict.jsx















var ResortDistrict_jsx = react_default.a.createElement;

function ResortDistrict_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ResortDistrict_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ResortDistrict_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ResortDistrict_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var AREAS_STYLE = [{
  id: 'areas',
  source: 'areasSource',
  type: 'fill',
  filter: ['==', 'area_id', ''],
  interactive: true,
  paint: {
    'fill-color': '#0480A9',
    'fill-opacity': 0.5
  }
}, {
  id: 'areas_line',
  source: 'areasSource',
  type: 'line',
  filter: ['==', 'area_id', ''],
  interactive: true,
  paint: {
    'line-color': '#FFFFFF',
    'line-width': 2
  }
}];

function addAreas(mapStyle, areaConfig, selectedAreaId) {
  if (!areaConfig || !mapStyle) {
    return mapStyle;
  }

  var newAreaConfig = cloneDeep_default()(areaConfig);

  var layers = newAreaConfig.layers || [];
  var areas = layers.find(function (l) {
    return l.id === 'areas';
  });

  if (areas) {
    areas.filter[2] = selectedAreaId || '';
  }

  var areasLine = layers.find(function (l) {
    return l.id === 'areas_line';
  });

  if (areasLine) {
    areasLine.filter[2] = selectedAreaId || '';
  }

  return ResortDistrict_objectSpread(ResortDistrict_objectSpread({}, mapStyle), {}, {
    layers: (mapStyle.layers || []).concat(newAreaConfig.layers || []),
    sources: ResortDistrict_objectSpread(ResortDistrict_objectSpread({}, mapStyle.sources), {}, {
      areasSource: {
        type: 'geojson',
        data: areaConfig.geoJSON
      }
    })
  });
}

var ResortDistrict_ResortDistrict = function ResortDistrict(props) {
  var _roomAreas$, _resortAreas$areas$, _props$pickYourRoom, _resortAreas$geoData$, _resortAreas$geoData$2;

  var _useState = Object(react["useState"])(false),
      isMapLoaded = _useState[0],
      setMapIsLoaded = _useState[1];

  var resortAreas = props.resortAreas,
      resortId = props.resortId,
      title = props.title,
      access = props.access,
      _props$roomAreas = props.roomAreas,
      roomAreas = _props$roomAreas === void 0 ? [] : _props$roomAreas,
      roomLabel = props.roomLabel,
      trackingData = props.trackingData;

  var _useState2 = Object(react["useState"])(null),
      mapStyle = _useState2[0],
      setMapStyle = _useState2[1];

  var sliderContainerRef = Object(react["useRef"])(null);

  var _useState3 = Object(react["useState"])(true),
      isLoadingMapBoxStyle = _useState3[0],
      setIsLoadingMapBoxStyle = _useState3[1];

  var _useState4 = Object(react["useState"])(((_roomAreas$ = roomAreas[0]) === null || _roomAreas$ === void 0 ? void 0 : _roomAreas$.id) || ((_resortAreas$areas$ = resortAreas.areas[0]) === null || _resortAreas$areas$ === void 0 ? void 0 : _resortAreas$areas$.id)),
      selectedAreaId = _useState4[0],
      setSelectedAreaId = _useState4[1];

  var _useState5 = Object(react["useState"])(0),
      initialIndex = _useState5[0],
      setInitialIndex = _useState5[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState6 = Object(react["useState"])(false),
      showLayer = _useState6[0],
      toggleLayer = _useState6[1];

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  Object(react["useEffect"])(function () {
    if (resortId) {
      fetchResortMapBoxStyle(resortId).then(setMapStyle).then(function () {
        return setIsLoadingMapBoxStyle(false);
      }).catch(function () {
        return setIsLoadingMapBoxStyle(false);
      });
    }
  }, [resortId]);
  Object(react["useEffect"])(function () {
    if (sliderContainerRef === null || sliderContainerRef === void 0 ? void 0 : sliderContainerRef.current) {
      sliderContainerRef.current.style.setProperty('--resortDistrictSliderHeight', "".concat(-1 * sliderContainerRef.current.offsetHeight / 2, "px"));
    }
  }, [sliderContainerRef.current, isTablet, isMapLoaded]);
  Object(react["useEffect"])(function () {
    if (selectedAreaId) {
      var index = resortAreas.areas.findIndex(function (_ref) {
        var id = _ref.id;
        return id === selectedAreaId;
      });

      if (index !== -1) {
        setInitialIndex(index);
      }
    }
  }, [selectedAreaId]);
  var areaConfig = {
    geoJSON: resortAreas.geoData.areas_geo_json,
    layers: AREAS_STYLE
  };
  var mapAreaStyle = Object(react["useMemo"])(function () {
    if (!mapStyle) {
      return mapStyle;
    }

    return addAreas(mapStyle, areaConfig, selectedAreaId);
  }, [selectedAreaId, !!mapStyle]);

  if (isLoadingMapBoxStyle) {
    return ResortDistrict_jsx("div", {
      className: "flex h-full w-full items-center justify-center"
    }, ResortDistrict_jsx(AsyncLoader["a" /* AsyncLoader */], null));
  }

  var resortSettings = (_props$pickYourRoom = props.pickYourRoom) === null || _props$pickYourRoom === void 0 ? void 0 : _props$pickYourRoom.resortSettings;
  var view = {
    baseViewport: resortSettings.targetViewport,
    maxBounds: resortSettings.maxBounds
  };

  if (!mapAreaStyle) {
    return null;
  }

  var getSlides = function getSlides() {
    var isInLayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var desktopImageRatio = ratios_utils["c" /* default */].XL;
    var mobileImageRatio = isInLayer ? undefined : ratios_utils["c" /* default */].XL;
    var hasRoomAreas = !!roomAreas.length;
    var areSlidesHorizontal = isInLayer && !isTablet;
    return resortAreas.areas.map(function (area, index) {
      var isExclusiveCollection = Object(resortDistrict_utils["b" /* isAreaExclusiveCollection */])(area);
      var isActive = index === initialIndex;
      var isRoomInArea = roomAreas.some(function (_ref2) {
        var roomAreaId = _ref2.id;
        return roomAreaId === area.id;
      });
      return ResortDistrict_jsx("div", {
        key: area.id,
        className: "mx-5 h-full px-2 py-10 sm:m-0 sm:p-10"
      }, ResortDistrict_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('pointer-events-auto flex h-full overflow-hidden rounded-12 bg-white sm:mx-0 sm:flex-row', {
          'flex-col': !isInLayer
        }),
        key: area.id
      }, ResortDistrict_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('shrink-0 sm:w-1/2 sm:pe-10', {
          'flex w-full': !isInLayer,
          'px-15': !isTablet && !isInLayer && hasRoomAreas,
          'flex w-1/3': areSlidesHorizontal
        }),
        "data-testid": isActive ? 'ResortDistrict-slider-area-image' : ''
      }, !isTablet && !isInLayer && hasRoomAreas ? ResortDistrict_jsx("div", {
        className: "mb-10 w-full border-b-1 border-lightGrey py-20 text-center font-sans"
      }, ResortDistrict_jsx(Icon["a" /* Icon */], {
        className: "mb-10 text-black",
        name: isRoomInArea ? icons["a" /* ICONS */].ACCOMODATIONS : icons["a" /* ICONS */].NO_ACCOMMODATION,
        width: "2.1875rem"
      }), ResortDistrict_jsx("div", {
        className: "text-14 font-bold"
      }, roomLabel), ResortDistrict_jsx("div", {
        className: "text-12"
      }, Object(i18n["h" /* t */])(isRoomInArea ? 'common.resortDistrict.layerDistrictTooltip.availableLabel' : 'common.resortDistrict.layerDistrictTooltip.unavailableLabel'))) : ResortDistrict_jsx(Img["a" /* Img */], {
        className: "h-full",
        ratioKey: isTablet ? desktopImageRatio : mobileImageRatio,
        url: area.images[0]
      })), ResortDistrict_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('flex h-full flex-col px-15 py-10 text-14 sm:w-1/2 sm:py-20 sm:pe-15 sm:ps-10', {
          'font-sans': isExclusiveCollection,
          'w-2/3': areSlidesHorizontal
        }),
        "data-testid": isActive ? 'ResortDistrict-slider-area-content' : ''
      }, ResortDistrict_jsx("div", {
        className: "pb-10 font-brand text-18 leading-tight sm:text-20"
      }, area.label), !isInLayer && (!hasRoomAreas || isTablet) && ResortDistrict_jsx("div", {
        className: "flex items-center gap-5 pb-10"
      }, ResortDistrict_jsx(Icon["a" /* Icon */], {
        name: !hasRoomAreas || isRoomInArea ? icons["a" /* ICONS */].ACCOMODATIONS : icons["a" /* ICONS */].NO_ACCOMMODATION,
        width: "1.375rem"
      }), ResortDistrict_jsx("div", {
        className: "font-sans text-14"
      }, hasRoomAreas ? Object(i18n["h" /* t */])(isRoomInArea ? 'common.resortDistrict.layerDistrictTooltip.availableLabel' : 'common.resortDistrict.layerDistrictTooltip.unavailableLabel') : area.shortDescription)), !isInLayer && ResortDistrict_jsx("div", {
        className: "line-clamp-2",
        title: area.description
      }, area.description), ResortDistrict_jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])('mt-30 leading-normal sm:mt-0', {
          'mt-auto': isInLayer
        })
      }, ResortDistrict_jsx("div", {
        className: "sm:mb-10"
      }, access), resortAreas.areas.map(function (resortArea) {
        var _area$associatedAcces;

        var canAccessArea = area.id === resortArea.id || ((_area$associatedAcces = area.associatedAccess) === null || _area$associatedAcces === void 0 ? void 0 : _area$associatedAcces.some(function (_ref3) {
          var id = _ref3.id;
          return id === resortArea.id;
        }));
        return ResortDistrict_jsx("div", {
          className: "flex justify-between gap-5",
          key: resortArea.id
        }, ResortDistrict_jsx("div", {
          className: Object(classnames_utils["a" /* classnames */])('truncate font-bold text-black', {
            'opacity-25': !canAccessArea
          })
        }, resortArea.label), ResortDistrict_jsx("div", {
          className: "flex items-center justify-center"
        }, ResortDistrict_jsx(Icon["a" /* Icon */], {
          className: canAccessArea ? 'text-green' : 'text-grey',
          name: icons["a" /* ICONS */].CHECK,
          width: "0.6125rem"
        })));
      })))));
    });
  };

  var formattedGeoData = (resortAreas.geoData.areas || []).map(function (area) {
    var matchingArea = resortAreas.areas.find(function (a) {
      return a.id === area.id;
    });
    return ResortDistrict_objectSpread(ResortDistrict_objectSpread({}, area), {}, {
      isExclusiveCollection: Object(resortDistrict_utils["b" /* isAreaExclusiveCollection */])(matchingArea),
      localizedLabel: (matchingArea === null || matchingArea === void 0 ? void 0 : matchingArea.label) || area.label
    });
  });
  return ResortDistrict_jsx(ErrorBoundary["a" /* ErrorBoundary */], null, ResortDistrict_jsx("div", {
    className: "ResortDistrict isolate"
  }, !!title && ResortDistrict_jsx(LineTitle["a" /* LineTitle */], {
    className: "justify-center text-center"
  }, title), ResortDistrict_jsx("div", {
    className: "relative z-0 md:h-full"
  }, ResortDistrict_jsx(Map, {
    areasCenter: ((_resortAreas$geoData$ = resortAreas.geoData.areas_center_geo_json) === null || _resortAreas$geoData$ === void 0 ? void 0 : _resortAreas$geoData$.features) || [],
    areas: formattedGeoData || [],
    baseViewport: view.baseViewport,
    height: isTablet ? '500px' : '67vw',
    mapStyle: mapAreaStyle,
    maxBounds: view.maxBounds,
    roomAreas: roomAreas,
    roomLabel: roomLabel,
    selectedBuildingId: selectedAreaId,
    selectedAreaId: selectedAreaId,
    setMapIsLoaded: setMapIsLoaded,
    setSelectedAreaId: setSelectedAreaId,
    shouldNavigateToArea: true,
    trackingData: trackingData
  }), !isTablet && ResortDistrict_jsx("div", {
    className: "absolute end-0 top-0 z-3 p-20"
  }, ResortDistrict_jsx("button", {
    onClick: function onClick() {
      toggleLayer(true);
    },
    className: "rounded-full bg-white p-5 leading-0 text-black shadow-sm",
    type: "button"
  }, ResortDistrict_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].EXPAND,
    width: "1.25rem"
  }))), showLayer && !isTablet && ResortDistrict_jsx(Layer["b" /* Layer */], null, ResortDistrict_jsx("button", {
    onClick: function onClick() {
      toggleLayer(false);
    },
    className: "absolute right-0 top-0 z-3 m-20 mb-15 ms-auto rounded-full bg-white p-5 leading-0 text-black shadow-sm",
    type: "button"
  }, ResortDistrict_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.9375rem"
  })), ResortDistrict_jsx(Map, {
    areas: formattedGeoData || [],
    areasCenter: ((_resortAreas$geoData$2 = resortAreas.geoData.areas_center_geo_json) === null || _resortAreas$geoData$2 === void 0 ? void 0 : _resortAreas$geoData$2.features) || [],
    baseViewport: view.baseViewport,
    height: "100%",
    mapStyle: mapAreaStyle,
    maxBounds: view.maxBounds,
    roomAreas: roomAreas,
    roomLabel: roomLabel,
    selectedAreaId: selectedAreaId,
    selectedBuildingId: selectedAreaId,
    setMapIsLoaded: setMapIsLoaded,
    setSelectedAreaId: setSelectedAreaId,
    shouldNavigateToArea: true,
    trackingData: trackingData
  }), ResortDistrict_jsx("div", {
    className: "absolute bottom-0 z-1 mb-10 flex w-full justify-center",
    "data-testid": "ResortDistrict-slider-area"
  }, ResortDistrict_jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    className: "h-full w-full",
    initialIndex: initialIndex,
    items: getSlides(true),
    centerPadding: 0.04,
    onChangeIndex: function onChangeIndex(index) {
      var _resortAreas$areas$in;

      var areaId = (_resortAreas$areas$in = resortAreas.areas[index]) === null || _resortAreas$areas$in === void 0 ? void 0 : _resortAreas$areas$in.id;
      setSelectedAreaId(areaId);
    }
  }, function (_ref4) {
    var itemsNode = _ref4.itemsNode;
    return itemsNode;
  }))), ResortDistrict_jsx("div", {
    className: "ResortDistrict-slider pointer-events-none relative z-2 -mt-50 mb-30 flex w-full transform justify-center sm:mt-0 sm:-translate-y-1/2 sm:px-20",
    ref: sliderContainerRef
  }, ResortDistrict_jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    className: "h-full w-full",
    items: getSlides(),
    initialIndex: initialIndex,
    onChangeIndex: function onChangeIndex(index) {
      var _resortAreas$areas$in2;

      var areaId = (_resortAreas$areas$in2 = resortAreas.areas[index]) === null || _resortAreas$areas$in2 === void 0 ? void 0 : _resortAreas$areas$in2.id;
      setSelectedAreaId(areaId);
    },
    centerPadding: !isTablet ? 0.04 : 0
  }, function (_ref5) {
    var hasControls = _ref5.hasControls,
        isNextControlDisabled = _ref5.isNextControlDisabled,
        isPreviousControlDisabled = _ref5.isPreviousControlDisabled,
        itemsNode = _ref5.itemsNode,
        index = _ref5.index,
        onNext = _ref5.onNext,
        onPrevious = _ref5.onPrevious;
    return ResortDistrict_jsx("div", {
      className: "ResortDistrict-area w-full"
    }, ResortDistrict_jsx("div", {
      className: "relative sm:flex sm:justify-center"
    }, itemsNode, hasControls && isTablet && ResortDistrict_jsx("div", {
      className: "pointer-events-none absolute inset-x-0 top-1/2 flex -translate-y-1/2 transform items-center justify-between"
    }, ResortDistrict_jsx(ArrowButton["a" /* ArrowButton */], {
      className: Object(classnames_utils["a" /* classnames */])('pointer-events-auto -ms-10 h-30 flex-none shadow-sm', {
        invisible: isPreviousControlDisabled
      }),
      color: colors["a" /* COLORS */].WHITE,
      "data-testid": "ResortDistrict-slider-left-arrow",
      isDisabled: isPreviousControlDisabled,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: function onClick(e) {
        var _resortAreas$areas;

        track({
          labelGA: "arrowsOn_".concat((_resortAreas$areas = resortAreas.areas[index - 1]) === null || _resortAreas$areas === void 0 ? void 0 : _resortAreas$areas.label)
        });
        onPrevious(e);
      }
    }), ResortDistrict_jsx(ArrowButton["a" /* ArrowButton */], {
      className: Object(classnames_utils["a" /* classnames */])('pointer-events-auto -me-10 h-30 flex-none shadow-sm', {
        invisible: isNextControlDisabled
      }),
      color: colors["a" /* COLORS */].WHITE,
      "data-testid": "ResortDistrict-slider-right-arrow",
      isDisabled: isNextControlDisabled,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: function onClick(e) {
        var _resortAreas$areas2;

        track({
          labelGA: "arrowsOn_".concat((_resortAreas$areas2 = resortAreas.areas[index + 1]) === null || _resortAreas$areas2 === void 0 ? void 0 : _resortAreas$areas2.label)
        });
        onNext(e);
      },
      rotation: 180
    }))), ResortDistrict_jsx(SilderBottomControls_SilderBottomControls, {
      isPreviousControlDisabled: isPreviousControlDisabled,
      isNextControlDisabled: isNextControlDisabled,
      onPrevious: onPrevious,
      onNext: onNext,
      index: index,
      resortAreas: resortAreas,
      trackingData: trackingData
    }));
  })))));
};

/***/ }),

/***/ "V5RX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node: true */


function makeArrayFrom(obj) {
  return Array.prototype.slice.apply(obj);
}

var
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected";

function SynchronousPromise(handler) {
  this.status = PENDING;
  this._continuations = [];
  this._parent = null;
  this._paused = false;
  if (handler) {
    handler.call(
      this,
      this._continueWith.bind(this),
      this._failWith.bind(this)
    );
  }
}

function looksLikeAPromise(obj) {
  return obj && typeof (obj.then) === "function";
}

function passThrough(value) {
  return value;
}

SynchronousPromise.prototype = {
  then: function (nextFn, catchFn) {
    var next = SynchronousPromise.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused) {
        this._continuations.push({
          promise: next,
          nextFn: nextFn,
          catchFn: catchFn
        });
        return next;
      }
      if (catchFn) {
        try {
          var catchResult = catchFn(this._error);
          if (looksLikeAPromise(catchResult)) {
            this._chainPromiseData(catchResult, next);
            return next;
          } else {
            return SynchronousPromise.resolve(catchResult)._setParent(this);
          }
        } catch (e) {
          return SynchronousPromise.reject(e)._setParent(this);
        }
      }
      return SynchronousPromise.reject(this._error)._setParent(this);
    }
    this._continuations.push({
      promise: next,
      nextFn: nextFn,
      catchFn: catchFn
    });
    this._runResolutions();
    return next;
  },
  catch: function (handler) {
    if (this._isResolved()) {
      return SynchronousPromise.resolve(this._data)._setParent(this);
    }
    var next = SynchronousPromise.unresolved()._setParent(this);
    this._continuations.push({
      promise: next,
      catchFn: handler
    });
    this._runRejections();
    return next;
  },
  finally: function (callback) {
    var ran = false;

    function runFinally(result, err) {
      if (!ran) {
        ran = true;
        if (!callback) {
          callback = passThrough;
        }
        var callbackResult = callback(result);
        if (looksLikeAPromise(callbackResult)) {
          return callbackResult.then(function () {
            if (err) {
              throw err;
            }
            return result;
          });
        } else {
          return result;
        }
      }
    }

    return this
      .then(function (result) {
        return runFinally(result);
      })
      .catch(function (err) {
        return runFinally(null, err);
      });
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    var firstPaused = this._findFirstPaused();
    if (firstPaused) {
      firstPaused._paused = false;
      firstPaused._runResolutions();
      firstPaused._runRejections();
    }
    return this;
  },
  _findAncestry: function () {
    return this._continuations.reduce(function (acc, cur) {
      if (cur.promise) {
        var node = {
          promise: cur.promise,
          children: cur.promise._findAncestry()
        };
        acc.push(node);
      }
      return acc;
    }, []);
  },
  _setParent: function (parent) {
    if (this._parent) {
      throw new Error("parent already set");
    }
    this._parent = parent;
    return this;
  },
  _continueWith: function (data) {
    var firstPending = this._findFirstPending();
    if (firstPending) {
      firstPending._data = data;
      firstPending._setResolved();
    }
  },
  _findFirstPending: function () {
    return this._findFirstAncestor(function (test) {
      return test._isPending && test._isPending();
    });
  },
  _findFirstPaused: function () {
    return this._findFirstAncestor(function (test) {
      return test._paused;
    });
  },
  _findFirstAncestor: function (matching) {
    var test = this;
    var result;
    while (test) {
      if (matching(test)) {
        result = test;
      }
      test = test._parent;
    }
    return result;
  },
  _failWith: function (error) {
    var firstRejected = this._findFirstPending();
    if (firstRejected) {
      firstRejected._error = error;
      firstRejected._setRejected();
    }
  },
  _takeContinuations: function () {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function () {
    if (this._paused || !this._isRejected()) {
      return;
    }
    var
      error = this._error,
      continuations = this._takeContinuations(),
      self = this;
    continuations.forEach(function (cont) {
      if (cont.catchFn) {
        try {
          var catchResult = cont.catchFn(error);
          self._handleUserFunctionResult(catchResult, cont.promise);
        } catch (e) {
          cont.promise.reject(e);
        }
      } else {
        cont.promise.reject(error);
      }
    });
  },
  _runResolutions: function () {
    if (this._paused || !this._isResolved() || this._isPending()) {
      return;
    }
    var continuations = this._takeContinuations();
    var data = this._data;
    var self = this;
    continuations.forEach(function (cont) {
      if (cont.nextFn) {
        try {
          var result = cont.nextFn(data);
          self._handleUserFunctionResult(result, cont.promise);
        } catch (e) {
          self._handleResolutionError(e, cont);
        }
      } else if (cont.promise) {
        cont.promise.resolve(data);
      }
    });
    if (looksLikeAPromise(this._data)) {
      return this._handleWhenResolvedDataIsPromise(this._data);
    }
  },
  _handleResolutionError: function (e, continuation) {
    this._setRejected();
    if (continuation.catchFn) {
      try {
        continuation.catchFn(e);
        return;
      } catch (e2) {
        e = e2;
      }
    }
    if (continuation.promise) {
      continuation.promise.reject(e);
    }
  },
  _handleWhenResolvedDataIsPromise: function (data) {
    var self = this;
    return data.then(function (result) {
      self._data = result;
      self._runResolutions();
    }).catch(function (error) {
      self._error = error;
      self._setRejected();
      self._runRejections();
    });
  },
  _handleUserFunctionResult: function (data, nextSynchronousPromise) {
    if (looksLikeAPromise(data)) {
      this._chainPromiseData(data, nextSynchronousPromise);
    } else {
      nextSynchronousPromise.resolve(data);
    }
  },
  _chainPromiseData: function (promiseData, nextSynchronousPromise) {
    promiseData.then(function (newData) {
      nextSynchronousPromise.resolve(newData);
    }).catch(function (newError) {
      nextSynchronousPromise.reject(newError);
    });
  },
  _setResolved: function () {
    this.status = RESOLVED;
    if (!this._paused) {
      this._runResolutions();
    }
  },
  _setRejected: function () {
    this.status = REJECTED;
    if (!this._paused) {
      this._runRejections();
    }
  },
  _isPending: function () {
    return this.status === PENDING;
  },
  _isResolved: function () {
    return this.status === RESOLVED;
  },
  _isRejected: function () {
    return this.status === REJECTED;
  }
};

SynchronousPromise.resolve = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    if (looksLikeAPromise(result)) {
      result.then(function (newResult) {
        resolve(newResult);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve(result);
    }
  });
};

SynchronousPromise.reject = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    reject(result);
  });
};

SynchronousPromise.unresolved = function () {
  return new SynchronousPromise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  });
};

SynchronousPromise.all = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};

function createAggregateErrorFrom(errors) {
  /* jshint ignore:start */
  if (typeof window !== "undefined" && "AggregateError" in window) {
    return new window.AggregateError(errors);
  }
  /* jshint ignore:end */

  return { errors: errors };
}

SynchronousPromise.any = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.reject(createAggregateErrorFrom([]));
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allErrors = [],
      numRejected = 0,
      doReject = function () {
        if (numRejected === args.length) {
          reject(createAggregateErrorFrom(allErrors));
        }
      },
      resolved = false,
      doResolve = function (result) {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve(result);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        doResolve(thisResult);
      }).catch(function (err) {
        allErrors[idx] = err;
        numRejected += 1;
        doReject();
      });
    });
  });
};

SynchronousPromise.allSettled = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve) {
    var
      allData = [],
      numSettled = 0,
      doSettled = function () {
        numSettled += 1;
        if (numSettled === args.length) {
          resolve(allData);
        }
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = {
          status: "fulfilled",
          value: thisResult
        };
        doSettled();
      }).catch(function (err) {
        allData[idx] = {
          status: "rejected",
          reason: err
        };
        doSettled();
      });
    });
  });
};

/* jshint ignore:start */
if (Promise === SynchronousPromise) {
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
}
var RealPromise = Promise;
SynchronousPromise.installGlobally = function (__awaiter) {
  if (Promise === SynchronousPromise) {
    return __awaiter;
  }
  var result = patchAwaiterIfRequired(__awaiter);
  Promise = SynchronousPromise;
  return result;
};

SynchronousPromise.uninstallGlobally = function () {
  if (Promise === SynchronousPromise) {
    Promise = RealPromise;
  }
};

function patchAwaiterIfRequired(__awaiter) {
  if (typeof (__awaiter) === "undefined" || __awaiter.__patched) {
    return __awaiter;
  }
  var originalAwaiter = __awaiter;
  __awaiter = function () {
    var Promise = RealPromise;
    originalAwaiter.apply(this, makeArrayFrom(arguments));
  };
  __awaiter.__patched = true;
  return __awaiter;
}

/* jshint ignore:end */

module.exports = {
  SynchronousPromise: SynchronousPromise
};


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js
var variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var variant = _ref.variant;
    return {
      thRoot: "".concat(variant ? variants[variant].root : '', " bg-saffron border-saffron text-black relative isolate bg-saffron border-saffron size-50 text-black border-1 flex-none inline-flex items-center justify-center leading-0 overflow-hidden"),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-[1em] text-center ".concat(variant ? variants[variant].item : '')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx


var __jsx = react_default.a.createElement;




var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["alt", "className", "iconName", "iconSize", "label", "theme", "variant"]);

  if (!iconName && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), !!iconName && __jsx("span", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("span", {
    className: thLabel
  }, label));
};

/***/ }),

/***/ "VNI2":
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAttendees; });
/* unused harmony export setAdults */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VO9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Notification_Notification; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.themes.js
var themes = {
  "default": {
    thRoot: 'relative isolate flex items-start rounded-12 border-1 border-current bg-white p-10 text-sienna',
    thInner: 'flex flex-col flex-1 sm:items-center sm:flex-row',
    thIcon: 'pt-5 pe-10',
    thMessage: 'sm:flex-1 p-10',
    thTitle: 'font-bold font-sans text-14 text-current',
    thText: 'font-sans text-14',
    thTextTheme: 'text-sans-n1',
    thSlot: 'max-w-full overflow-hidden p-10',
    thCloseButton: 'absolute p-10 end-0 top-0 z-1',
    thCloseButtonLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.jsx


var __jsx = react_default.a.createElement;






var Notification_Notification = function Notification(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasClose = _ref.hasClose,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? icons["a" /* ICONS */].LIGHTBULB : _ref$iconName,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '1.875rem' : _ref$iconWidth,
      id = _ref.id,
      onClose = _ref.onClose,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "closeLabel", "hasClose", "iconName", "iconWidth", "id", "onClose", "text", "theme", "title"]);

  if (!title && !text && !react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thIcon = _themes$theme.thIcon,
      thInner = _themes$theme.thInner,
      thMessage = _themes$theme.thMessage,
      thRoot = _themes$theme.thRoot,
      thSlot = _themes$theme.thSlot,
      thText = _themes$theme.thText,
      thTextTheme = _themes$theme.thTextTheme,
      thTitle = _themes$theme.thTitle;
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    id: id
  }), !!iconName && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('leading-0', thIcon)
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: iconWidth
  })), __jsx("div", {
    className: thInner
  }, (text || title) && __jsx("div", {
    className: thMessage
  }, !!title && !text && __jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('m-0', thTitle)
  }, title), !!title && !!text && __jsx("h3", {
    className: Object(classnames_utils["a" /* classnames */])(thTitle)
  }, title), __jsx(Text["a" /* Text */], {
    className: thText,
    text: text,
    theme: thTextTheme
  })), react["Children"].count(children) > 0 && __jsx("div", {
    className: thSlot
  }, children)), hasClose && onClose && __jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('leading-0', thCloseButton),
    onClick: onClose,
    type: "button"
  }, !!closeLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};

/***/ }),

/***/ "VQ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBlockInputDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rueY");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05PS");




function useBlockInputDepartureDate() {
  var checkIfDepartureDateIsBookable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var departureDateIsBookable = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getDepartureDateBookable */ "j"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getBlockInputDepartureDate */ "b"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();

  var setBlockInputDepartureDate = function setBlockInputDepartureDate(value) {
    if (value !== blockInputDepartureDate) {
      dispatch(Object(_client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__[/* setCalendarBlockInputDepartureDate */ "f"])(value));
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (departureDateIsBookable) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable]);
  return {
    blockInputDepartureDate: checkIfDepartureDateIsBookable && blockInputDepartureDate,
    departureDateIsBookable: departureDateIsBookable,
    setBlockInputDepartureDate: setBlockInputDepartureDate
  };
}

/***/ }),

/***/ "VQXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PriceTicketContentWrapper_PriceTicketContentWrapper; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/chunk.js
var chunk = __webpack_require__("RBiB");
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/ceil.js
var ceil = __webpack_require__("Lf/v");
var ceil_default = /*#__PURE__*/__webpack_require__.n(ceil);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx + 1 modules
var BlockLink = __webpack_require__("Onl6");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-details-toggle/PriceRemoteDetailsToggle.jsx
var PriceRemoteDetailsToggle = __webpack_require__("y64Y");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-service-list/PriceRemoteServiceList.jsx
var PriceRemoteServiceList = __webpack_require__("YOLo");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-large/PriceTicketLarge.jsx







var __jsx = react_default.a.createElement;



















var PriceTicketLarge_PriceTicketLarge = function PriceTicketLarge(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      button = _ref.button,
      className = _ref.className,
      _ref$fromPriceTicketC = _ref.fromPriceTicketCustom,
      fromPriceTicketCustom = _ref$fromPriceTicketC === void 0 ? false : _ref$fromPriceTicketC,
      _ref$hasCallCenter = _ref.hasCallCenter,
      hasCallCenter = _ref$hasCallCenter === void 0 ? false : _ref$hasCallCenter,
      id = _ref.id,
      _ref$isLite = _ref.isLite,
      isLite = _ref$isLite === void 0 ? false : _ref$isLite,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      subtitle = _ref.subtitle,
      title = _ref.title,
      travelAdvisorConfig = _ref.travelAdvisorConfig;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  var track = Object(useTracking["a" /* useTracking */])();
  Object(react["useEffect"])(function () {
    setIsDetailOpened(false);
  }, [isLite]);

  if (!title) {
    return null;
  }

  var openClosePriceDetails = function openClosePriceDetails() {
    track({
      actionGA: 'priceBar',
      labelGA: isDetailOpened ? 'closeAllInclusive' : 'openAllInclusive'
    });
    setIsDetailOpened(!isDetailOpened);
  };

  var hasDetail = !isLite && !hasCallCenter && !isEmpty_default()(items);
  var hasAllInclusiveServices = !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length);
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : noop_default.a;
  var splitServices = allInclusiveServices && allInclusiveServices.length > 0 ? chunk_default()(Object(toConsumableArray["a" /* default */])(allInclusiveServices), ceil_default()(allInclusiveServices.length / 2)) : [];

  var _getCruiseExclusivity = Object(Product_utils["d" /* getCruiseExclusivity */])(id),
      isCruiseExclusive = _getCruiseExclusivity.isCruiseExclusive,
      isCruiseExclusivityLoading = _getCruiseExclusivity.isCruiseExclusivityLoading;

  var exclusivityKey = isSeller ? 'booking.common.exclusivityb2b' : 'booking.common.exclusivity';
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-750 relative isolate animate-fadeIn', className),
    "data-testid": "PriceTicketLarge"
  }, __jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isLite
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate min-h-68 rounded-12 bg-white p-20 shadow-diffuse', {
      'border-1 border-pearl': !isLite,
      'border-t-1 border-lightGrey py-10': isLite,
      'flex items-center justify-center': isLoading
    })
  }, isLoading || isCruiseExclusivityLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: "text-black",
    size: "small"
  }) : __jsx(react["Fragment"], null, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center justify-between gap-20')
  }, __jsx(Title["a" /* Title */], {
    className: "flex-1 flex-col !items-start",
    dataTestId: "priceTicket-title",
    hLevel: 1,
    theme: "title-sans-n1"
  }, __jsx("span", {
    className: "text-16 text-sienna",
    "data-testid": "priceTicket-subtitle"
  }, subtitle), title), !hasCallCenter && !isEmpty_default()(price) && price.bestPrice && __jsx(Price["b" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: Object(classnames_utils["a" /* classnames */])({
      'items-end text-right': !isLite
    }),
    from: Object(i18n["h" /* t */])('price.format.from'),
    hasInitialPrice: false,
    hasTotalPrice: true,
    theme: isLite ? 'default' : 'column'
  })), __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center justify-end gap-20', {
      'flex-1': isLite
    })
  }, hasAllInclusiveServices && isLite && __jsx(PriceRemoteDetailsToggle["a" /* PriceRemoteDetailsToggle */], {
    handleClick: openClosePriceDetails,
    isCollapsed: !isDetailOpened
  }), !isCruiseExclusive && hasCallCenter && travelAdvisorConfig && __jsx(BlockLink["a" /* BlockLink */], {
    className: Object(classnames_utils["a" /* classnames */])('text-black', {
      hidden: isLite
    }),
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), !isCruiseExclusive && (fromPriceTicketCustom || isLite || hasCallCenter) && __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: Object(classnames_utils["a" /* classnames */])('self-center'),
    size: "small",
    onClick: scroll
  })), isCruiseExclusive && __jsx("div", {
    className: "rounded-pill bg-orange px-15 py-10 text-12 font-bold text-white",
    "data-testid": "exclusivity-label"
  }, Object(i18n["h" /* t */])(exclusivityKey)))), hasDetail && __jsx("div", {
    className: "flex items-center justify-between gap-20 pt-10"
  }, __jsx("p", {
    className: "w-auto font-sans text-16 font-bold text-black"
  }, Object(i18n["h" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), __jsx("div", {
    className: "flex flex-1 items-center gap-20"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label,
        longDesc = _ref2.longDesc,
        subDesc = _ref2.subDesc;
    return __jsx(DynamicLink["a" /* default */], {
      className: "flex items-center gap-10 font-sans text-14 text-black",
      "data-testid": "PriceTicketLarge-item",
      key: iconName,
      url: button === null || button === void 0 ? void 0 : button.url
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-sienna",
      name: iconName,
      title: label,
      width: "1rem"
    }), longDesc, subDesc && __jsx("span", {
      className: "font-bold"
    }, subDesc));
  })), __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-1/4",
    size: "small",
    onClick: scroll
  }))), hasAllInclusiveServices && isDetailOpened && __jsx(lib["Collapse"], {
    isOpened: isDetailOpened,
    theme: {
      content: 'pt-20'
    }
  }, __jsx("div", {
    className: "flex gap-10"
  }, splitServices[0] && __jsx(PriceRemoteServiceList["a" /* PriceRemoteServiceList */], {
    className: "flex-1",
    services: splitServices[0]
  }), splitServices[1] && __jsx(PriceRemoteServiceList["a" /* PriceRemoteServiceList */], {
    className: "flex-1",
    services: splitServices[1]
  }))), hasAllInclusiveServices && !isLite && __jsx("div", {
    className: "mt-10 flex justify-end"
  }, __jsx(PriceRemoteDetailsToggle["a" /* PriceRemoteDetailsToggle */], {
    handleClick: openClosePriceDetails,
    isCollapsed: !isDetailOpened
  }))))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-details-layer/PriceRemoteDetailsLayer.jsx
var PriceRemoteDetailsLayer = __webpack_require__("WW32");

// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-narrow/PriceTicketNarrow.jsx




var PriceTicketNarrow_jsx = react_default.a.createElement;

















var PriceTicketNarrow_PriceTicketNarrow = function PriceTicketNarrow(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      button = _ref.button,
      className = _ref.className,
      hasCallCenter = _ref.hasCallCenter,
      isLite = _ref.isLite,
      isLoading = _ref.isLoading,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      subtitle = _ref.subtitle,
      title = _ref.title,
      travelAdvisorConfig = _ref.travelAdvisorConfig;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();

  var openClosePriceDetails = function openClosePriceDetails() {
    track({
      actionGA: 'priceBar',
      labelGA: isDetailOpened ? 'closeAllInclusive' : 'openAllInclusive'
    });
    setIsDetailOpened(!isDetailOpened);
  };

  var hasPrice = !hasCallCenter && !isEmpty_default()(price) && price.bestPrice;
  var hasBlockLink = hasCallCenter && !isLite;
  var hasDetail = !isLite && !hasCallCenter && !isEmpty_default()(items);
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : noop_default.a;
  return PriceTicketNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'opacity-75': isLoading,
      'animation-duration-750 animate-fadeIn': !isLite,
      'animation-duration-500 animate-slideInBottom': isLite
    }, className),
    "data-testid": "PriceTicketNarrow"
  }, PriceTicketNarrow_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isLite
  }, PriceTicketNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate rounded-12 bg-white p-10 shadow-diffuse', {
      'border-1 border-pearl': !isLite,
      'border-t-1 border-lightGrey': isLite,
      'flex items-center justify-center': isLoading
    })
  }, isLoading ? PriceTicketNarrow_jsx(Spinner["a" /* Spinner */], {
    className: "text-black",
    size: "small"
  }) : PriceTicketNarrow_jsx(react["Fragment"], null, !isLite && PriceTicketNarrow_jsx(Title["a" /* Title */], {
    className: "mb-10 flex-1 flex-col !items-start",
    dataTestId: "priceTicket-title",
    hLevel: 1,
    theme: "title-sans-n1"
  }, PriceTicketNarrow_jsx("span", {
    className: "text-16 text-sienna",
    "data-testid": "priceTicket-subtitle"
  }, subtitle), title), hasBlockLink && travelAdvisorConfig && PriceTicketNarrow_jsx(BlockLink["a" /* BlockLink */], {
    className: Object(classnames_utils["a" /* classnames */])('mb-10 text-black', {
      hidden: isLite
    }),
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), hasPrice && PriceTicketNarrow_jsx(Price["b" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: Object(classnames_utils["a" /* classnames */])('mb-10', {
      'justify-center': isLite
    }),
    from: Object(i18n["h" /* t */])('price.format.from'),
    hasInitialPrice: false,
    hasTotalPrice: true
  })), hasDetail && PriceTicketNarrow_jsx(react["Fragment"], null, PriceTicketNarrow_jsx("p", {
    className: "mb-10 text-center font-sans text-14 font-bold text-black"
  }, Object(i18n["h" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), PriceTicketNarrow_jsx("div", {
    className: "mb-20 flex flex-1 items-center gap-20"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label,
        shortDesc = _ref2.shortDesc,
        subDesc = _ref2.subDesc;
    return PriceTicketNarrow_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center gap-10 font-sans text-12 text-black",
      "data-testid": "PriceTicketNarrow-item",
      key: iconName,
      url: button === null || button === void 0 ? void 0 : button.url
    }, PriceTicketNarrow_jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-sienna",
      name: iconName,
      title: label,
      width: "1rem"
    }), shortDesc, " ", subDesc && PriceTicketNarrow_jsx("div", {
      className: "font-bold"
    }, subDesc));
  }))), PriceTicketNarrow_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-full",
    onClick: scroll,
    size: "small"
  })), !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) && PriceTicketNarrow_jsx(react["Fragment"], null, PriceTicketNarrow_jsx("div", {
    className: "mt-10 flex justify-center"
  }, PriceTicketNarrow_jsx(PriceRemoteDetailsToggle["a" /* PriceRemoteDetailsToggle */], {
    handleClick: openClosePriceDetails,
    isCollapsed: !isDetailOpened
  })), isDetailOpened && PriceTicketNarrow_jsx(PriceRemoteDetailsLayer["a" /* PriceRemoteDetailsLayer */], {
    allInclusiveServices: allInclusiveServices,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    isLoading: isLoading,
    nameRender: Portal_constants["b" /* AFTER_APP */],
    onBack: function onBack() {
      return setIsDetailOpened(false);
    }
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/PriceTicketContentWrapper.jsx

var PriceTicketContentWrapper_jsx = react_default.a.createElement;












var PriceTicketContentWrapper_PriceTicketContentWrapper = function PriceTicketContentWrapper(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var onStateChange = function onStateChange(status) {
    setIsSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  };

  return PriceTicketContentWrapper_jsx(react["Fragment"], null, PriceTicketContentWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, Object(sellerUtils["f" /* isSeller */])(appContext) && PriceTicketContentWrapper_jsx("button", {
    className: "flex gap-5 items-center mb-10 text-sienna",
    "data-testid": "PriceTicketBackToSearch",
    onClick: router.back,
    type: "button"
  }, PriceTicketContentWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_LEFT,
    hasRtl: true,
    width: "0.9rem"
  }), Object(i18n["h" /* t */])('common.comparator.backToSearch'))), PriceTicketContentWrapper_jsx(Sticky_default.a, {
    activeClass: "sticky-bottom",
    bottomBoundary: ".PriceTicket-sticky-beacon",
    innerZ: 6,
    onStateChange: onStateChange,
    releasedClass: "opacity-0"
  }, isDesktop ? PriceTicketContentWrapper_jsx(PriceTicketLarge_PriceTicketLarge, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  })) : PriceTicketContentWrapper_jsx(PriceTicketNarrow_PriceTicketNarrow, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  }))));
};

/***/ }),

/***/ "VXxY":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "VZDm":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__("Ndl3");

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),

/***/ "Vazi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0IQ5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var Map = function Map(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      dataTestId = _ref.dataTestId,
      imageSrc = _ref.imageSrc,
      _onClick = _ref.onClick,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? {
    w: 29,
    h: 32
  } : _ref$ratio,
      title = _ref.title;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  if (!imageSrc) {
    return null;
  }

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx("button", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('relative block w-full cursor-pointer overflow-hidden', className),
    "data-testid": dataTestId,
    onClick: function onClick() {
      setOpen(true);
      !isOpen && (_onClick === null || _onClick === void 0 ? void 0 : _onClick());
    },
    type: "button"
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_3__[/* Image */ "a"], {
    imageUrl: imageSrc,
    dimensions: ratio
  })), isOpen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_2__[/* Backdrop */ "a"], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, __jsx("div", {
    className: "h-full flex-1"
  }, children)));
};

/***/ }),

/***/ "Vk6K":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    copyArray = __webpack_require__("QT01"),
    getTag = __webpack_require__("kkM+"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    iteratorToArray = __webpack_require__("U7t3"),
    mapToArray = __webpack_require__("aURW"),
    setToArray = __webpack_require__("XlL0"),
    stringToArray = __webpack_require__("f2p0"),
    values = __webpack_require__("0iyY");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),

/***/ "VqLN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var isInteger = __webpack_require__("JYr1");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "VrMI":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var uncurryThis = __webpack_require__("kZDm");
var IndexedObject = __webpack_require__("F9U4");
var toObject = __webpack_require__("A+R+");
var lengthOfArrayLike = __webpack_require__("XhyO");
var arraySpeciesCreate = __webpack_require__("kjCq");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "VrMS":
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__("Jm8J");
var lengthOfArrayLike = __webpack_require__("XhyO");
var createProperty = __webpack_require__("6aqx");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n                offerId\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit;
  var bookableDatesQueryArs = {
    productId: productId,
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "k"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "g"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2, _priceConfig$termsAnd5;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              rate: priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd5 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd5 === void 0 ? void 0 : _priceConfig$termsAnd5.offerId,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled;
  var hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  var hasFilledStyle = isFilled && !isDisabled;
  var hasActiveStyle = isActive && !isDisabled && !isFilled;
  return {
    thRoot: Object(classnames_utils["a" /* classnames */])('flex w-full items-center rounded-pill border text-14 leading-normal text-black transition-all duration-250 ease-in', {
      'border-lightGrey hocus:border-black': hasDefaultStyle,
      'border-black': hasActiveStyle,
      'border-success text-black': hasFilledStyle,
      'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled
    }),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: Object(classnames_utils["a" /* classnames */])('flex-none shrink-0', {
      'text-success': isFilled
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadge: 'size-24 text-black bg-saffron border-saffron',
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0 text-current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: Object(classnames_utils["a" /* classnames */])('flex h-24 w-40 overflow-hidden rounded-pill border-current bg-current p-2 leading-0 transition-all duration-250 ease-in', {
      'text-lightGrey': !isFilled,
      'text-success': isFilled
    }),
    thSwitchToggler: Object(classnames_utils["a" /* classnames */])('flex size-20 items-center justify-center rounded-pill bg-white text-center text-10 font-bold leading-0 shadow', {
      'text-lightGrey': !isFilled,
      'transform text-success ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled
    })
  };
};

var themes = function themes(props) {
  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/jsx-no-useless-fragment */







var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      badgeCount = _ref.badgeCount,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = themes({
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thBadge = _themes$theme.thBadge,
      thButton = _themes$theme.thButton,
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thIcon = _themes$theme.thIcon,
      thIconRight = _themes$theme.thIconRight,
      thIconCaret = _themes$theme.thIconCaret,
      thIconSize = _themes$theme.thIconSize,
      thSpinner = _themes$theme.thSpinner,
      thRoot = _themes$theme.thRoot,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchToggler = _themes$theme.thSwitchToggler;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && isFilled && !isLoading && !isDisabled;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thIcon),
    name: iconName,
    width: thIconSize
  }), __jsx("span", {
    className: thChildren
  }, children), !!badgeCount && __jsx(Badge["a" /* Badge */], {
    className: thBadge,
    label: __jsx("span", {
      className: "-me-1 mt-1"
    }, badgeCount),
    variant: "pill"
  })), !hasSwitch && __jsx(react["Fragment"], null, hasClear ? __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })) : __jsx("button", {
    className: thIconRight,
    onClick: onClick,
    type: "button"
  }, isLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: thSpinner,
    size: "small"
  }) : __jsx(Icon["a" /* Icon */], {
    className: thIconCaret,
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem"
  }))), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler
  }, __jsx(Icon["a" /* Icon */], {
    name: isFilled ? icons["a" /* ICONS */].ON : icons["a" /* ICONS */].OFF,
    width: "0.5rem"
  })))));
};

/***/ }),

/***/ "W0vE":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "WGoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTravelSectionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluralizeLabel; });
/* unused harmony export prefixWithPlusIfPositive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalizeName; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");





function pluralizeLabel(singularLabel, pluralLabel, value) {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value, label) {
  return value >= 0 ? "+".concat(label) : label;
}

function capitalizeName(text) {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, function (a) {
    return a.toUpperCase();
  });
}

var getAttendeesSummary = function getAttendeesSummary(_ref) {
  var adultsCount = _ref.adultsCount,
      kidsCount = _ref.kidsCount;
  return "".concat(adultsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adults'), adultsCount), " ").concat(kidsCount > 0 ? " - ".concat(kidsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.children'), kidsCount)) : '');
};
var getTravelSectionSummary = function getTravelSectionSummary(_ref2) {
  var travelSection = _ref2.travelSection;
  return "".concat(travelSection.label.toLowerCase(), " (").concat(travelSection.id.toUpperCase(), ")");
};


/***/ }),

/***/ "WSQK":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "WW32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceRemoteDetailsLayer; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_portal_Portal_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Yd/I");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("U2fG");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7amT");
/* harmony import */ var _price_remote_service_list_PriceRemoteServiceList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("YOLo");
/* harmony import */ var _PriceRemoteContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("wFQJ");
/* harmony import */ var _rate_messages_RateMessages__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("/Sb8");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;












var PriceRemoteDetailsLayer = function PriceRemoteDetailsLayer(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      closeLabel = _ref.closeLabel,
      isLoading = _ref.isLoading,
      onBack = _ref.onBack,
      nameRender = _ref.nameRender,
      children = _ref.children,
      rate = _ref.rate,
      shouldDisplayRate = _ref.shouldDisplayRate;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_PriceRemoteContext__WEBPACK_IMPORTED_MODULE_10__[/* PriceRemoteContext */ "a"]),
      isTotalPrice = _useContext[0].isTotalPrice,
      setPriceRemoteContext = _useContext[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setPriceRemoteContext({
      isInLayer: true
    });
    return function () {
      setPriceRemoteContext({
        isInLayer: false
      });
    };
  }, []);
  var layerHeaderTitle = Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('priceRemote.openAllInclusiveDetails');
  return __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_7__[/* Layer */ "b"], {
    ariaLabel: layerHeaderTitle,
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__[/* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */ "q"],
    bgColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].WHITE,
    buttonLeft: {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('common.backNavigation'),
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
      onClick: onBack
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: __jsx("span", {
      id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__[/* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */ "q"],
      className: "block w-full text-center"
    }, layerHeaderTitle),
    onClose: onBack,
    portalName: nameRender || _frameworks_portal_Portal_constants__WEBPACK_IMPORTED_MODULE_2__[/* BEFORE_APP */ "c"]
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('scroll-y flex flex-col items-center p-15 transition-opacity duration-250 ease-in', 'h-[calc(100% -(250px-60px))]', {
      'opacity-25': isLoading
    }),
    "data-testid": "price-remote-details-layer-container"
  }, isTotalPrice ? __jsx("div", {
    className: "pb-5 pt-20 text-center text-14 font-bold text-sienna lg:pt-10"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('priceRemote.priceForAll')) : null, allInclusiveServices && allInclusiveServices.length > 0 ? __jsx(_price_remote_service_list_PriceRemoteServiceList__WEBPACK_IMPORTED_MODULE_9__[/* PriceRemoteServiceList */ "a"], {
    className: "w-full",
    services: allInclusiveServices
  }) : __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_8__[/* Spinner */ "a"], {
    size: "small"
  }), !isLoading && shouldDisplayRate && __jsx("div", {
    className: "text-start"
  }, __jsx(_rate_messages_RateMessages__WEBPACK_IMPORTED_MODULE_11__[/* RateMessages */ "a"], {
    rate: rate
  }))), children);
};

/***/ }),

/***/ "WeO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAttendeeNamePlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNumberOfAdultsAndChildren; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var getAttendeeNamePlaceholder = function getAttendeeNamePlaceholder(attendee, isKid, isMain) {
  var firstName = attendee.firstName,
      lastName = attendee.lastName,
      civility = attendee.civility;
  var attendeeLabel = isKid ? Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherKidsInfosHeader.title') : Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherAdultsInfosHeader.title');

  if (isMain) {
    attendeeLabel = Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.personnalInfosHeader.title');
  }

  if (firstName && lastName && civility) {
    attendeeLabel = "".concat(civility, " ").concat(firstName, " ").concat(lastName);
  }

  return attendeeLabel;
};
var getNumberOfAdultsAndChildren = function getNumberOfAdultsAndChildren(quantityOfChildren, quantityOfAdults) {
  if (quantityOfChildren === 0) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'));
  }

  if (quantityOfChildren === 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.child'));
  }

  if (quantityOfChildren > 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.children'));
  }
};

/***/ }),

/***/ "WeoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductStrengths; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("NPTU");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;








var ProductStrengths = function ProductStrengths(_ref) {
  var className = _ref.className,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isExclusiveCollection = _ref.isExclusiveCollection,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_8__[/* useTracking */ "a"])();

  if (!items.length) {
    return null;
  }

  var content = __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('flex flex-wrap', {
      '-mx-20': isExclusiveCollection,
      '-mx-10': !isExclusiveCollection
    }, className),
    "data-testid": dataTestId
  }, items.map(function (_ref2, idx) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].SAFFRON : _ref2$color,
        iconName = _ref2.iconName,
        label = _ref2.label,
        trackingData = _ref2.trackingData,
        url = _ref2.url;
    var TagName = url ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"] : 'div';
    return __jsx(react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], {
      key: label
    }, idx > 0 && !isExclusiveCollection && __jsx("span", {
      className: "animation-duration-750 mt-10 hidden animate-fadeIn font-sans text-44 text-grey opacity-50 sm:block"
    }, "/"), idx > 0 && (isTablet || idx % 2 !== 0) && isExclusiveCollection && __jsx("div", {
      className: "min-h-full"
    }, __jsx("div", {
      className: "m-0 mt-40 h-50 w-1 border-r-1 border-grey p-0"
    })), __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])("flex w-1/2 max-w-1/2 flex-col items-center sm:w-auto sm:flex-1 ".concat(isExclusiveCollection ? 'px-20' : 'p-10', " text-").concat(color, " text-center text-12 sm:text-14"), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
        '-mr-1': !isTablet && idx % 2 === 0
      }, "hocus:text-".concat(color, "-active transition-color"), url)),
      onClick: trackingData ? function () {
        return track(trackingData);
      } : undefined
    }, url ? {
      url: url
    } : null), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
      className: isExclusiveCollection ? 'mb-20 mt-40 text-ultramarine' : 'mb-10 text-sienna',
      name: iconName,
      width: isExclusiveCollection ? '3.125rem' : '3.75rem'
    }), __jsx("span", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('block w-full', {
        'font-sans': isExclusiveCollection,
        'mb-30': isExclusiveCollection
      })
    }, label)));
  }));

  if (!isDesktop && isTablet && displayLoadMore) {
    return __jsx(_frameworks_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_11__[/* SeeMore */ "a"], {
      classNameButton: "text-center",
      isCollapseEnabled: true,
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      seeMoreSize: 150
    }, content);
  }

  return content;
};

/***/ }),

/***/ "X95k":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "XKJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */


var _pointGeometry = __webpack_require__("aeo5");

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__("4GH7");

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _wrap = __webpack_require__("Zk8D");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
var Transform = function () {
  function Transform(tileSize, minZoom, maxZoom) {
    _classCallCheck(this, Transform);

    this.tileSize = tileSize || 512; // constant

    this._minZoom = minZoom || 0;
    this._maxZoom = maxZoom || 52;

    this.latRange = [-85.05113, 85.05113];

    this.width = 0;
    this.height = 0;
    this.zoom = 0;
    this.center = new _lat_lng2.default(0, 0);
    this.angle = 0;
  }

  Transform.prototype.zoomScale = function zoomScale(zoom) {
    return Math.pow(2, zoom);
  };

  Transform.prototype.scaleZoom = function scaleZoom(scale) {
    return Math.log(scale) / Math.LN2;
  };

  Transform.prototype.project = function project(latlng, worldSize) {
    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
  };

  Transform.prototype.unproject = function unproject(point, worldSize) {
    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
  };

  // lat/lon <-> absolute pixel coords convertion
  Transform.prototype.lngX = function lngX(lon, worldSize) {
    return (180 + lon) * (worldSize || this.worldSize) / 360;
  };

  // latitude to absolute y coord


  Transform.prototype.latY = function latY(lat, worldSize) {
    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
    return (180 - y) * (worldSize || this.worldSize) / 360;
  };

  Transform.prototype.xLng = function xLng(x, worldSize) {
    return x * 360 / (worldSize || this.worldSize) - 180;
  };

  Transform.prototype.yLat = function yLat(y, worldSize) {
    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  };

  Transform.prototype.locationPoint = function locationPoint(latlng) {
    var p = this.project(latlng);
    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
  };

  Transform.prototype.pointLocation = function pointLocation(p) {
    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
    return this.unproject(this.point.sub(p2));
  };

  _createClass(Transform, [{
    key: 'minZoom',
    get: function get() {
      return this._minZoom;
    },
    set: function set(zoom) {
      this._minZoom = zoom;
      this.zoom = Math.max(this.zoom, zoom);
    }
  }, {
    key: 'maxZoom',
    get: function get() {
      return this._maxZoom;
    },
    set: function set(zoom) {
      this._maxZoom = zoom;
      this.zoom = Math.min(this.zoom, zoom);
    }
  }, {
    key: 'worldSize',
    get: function get() {
      return this.tileSize * this.scale;
    }
  }, {
    key: 'centerPoint',
    get: function get() {
      return new _pointGeometry2.default(0, 0); // this.size._div(2);
    }
  }, {
    key: 'size',
    get: function get() {
      return new _pointGeometry2.default(this.width, this.height);
    }
  }, {
    key: 'bearing',
    get: function get() {
      return -this.angle / Math.PI * 180;
    },
    set: function set(bearing) {
      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
    }
  }, {
    key: 'zoom',
    get: function get() {
      return this._zoom;
    },
    set: function set(zoom) {
      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
      this._zoom = zoomV;
      this.scale = this.zoomScale(zoomV);
      this.tileZoom = Math.floor(zoomV);
      this.zoomFraction = zoomV - this.tileZoom;
    }
  }, {
    key: 'x',
    get: function get() {
      return this.lngX(this.center.lng);
    }
  }, {
    key: 'y',
    get: function get() {
      return this.latY(this.center.lat);
    }
  }, {
    key: 'point',
    get: function get() {
      return new _pointGeometry2.default(this.x, this.y);
    }
  }]);

  return Transform;
}();

exports.default = Transform;

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var _discount$amount;

  var className = _ref.className,
      discount = _ref.discount,
      i18n = _ref.i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultLabel) || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultColor) || null;
  return (discount === null || discount === void 0 ? void 0 : (_discount$amount = discount.amount) === null || _discount$amount === void 0 ? void 0 : _discount$amount.value) ? __jsx(Tag["a" /* Tag */], {
    className: Object(classnames_utils["a" /* classnames */])('text-white', className),
    style: {
      backgroundColor: backgroundColor,
      borderColor: backgroundColor
    }
  }, offerName) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!isEligible) {
    return ProductComparison_jsx("div", {
      className: "absolute bg-white/60 flex font-bold inset-0 items-center justify-center p-20 rounded-12 text-14 text-center z-1"
    }, eligibilityLabel);
  }

  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('absolute bg-darkGrey/40 flex h-full inset-0 items-center justify-center p-20 rounded-12 text-white w-full z-1', className)
  }, buttonProps), isSelectable && ProductComparison_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('aspect-square border-2 leading-0 p-10 rounded-full transition-colors duration-250 ease-in', {
      'bg-transparent border-white': !isSelected,
      'bg-saffron border-saffron text-black': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx
var ProductThumbnail = __webpack_require__("Z+2E");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none shrink gap-5 items-center text-".concat(color, " text-end")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx

var AvailabilityAge_jsx = react_default.a.createElement;




var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel,
      timeSlot = _ref.timeSlot;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  var timeSlotLabel = '';

  switch (timeSlot) {
    case 'MORNING':
      timeSlotLabel = Object(src_i18n["h" /* t */])('booking.activities.timeSlot.morningTitle');
      break;

    case 'AFTERNOON':
      timeSlotLabel = Object(src_i18n["h" /* t */])('booking.activities.timeSlot.afternoonTitle');
      break;

    default:
      timeSlotLabel = Object(src_i18n["h" /* t */])('booking.activities.timeSlot.allDayTitle');
      break;
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " - ").concat(timeSlotLabel), "\xA0", AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-nowrap"
  }, "(", message, ")"), "\xA0");
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx

var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].GREEN,
      icon: icons["a" /* ICONS */].CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].MEDIUM_GREY,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var ageMax = _ref2.ageMax,
        ageMin = _ref2.ageMin,
        availability = _ref2.availability,
        id = _ref2.id,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock,
        timeSlot = _ref2.timeSlot;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-10 text-14 text-black"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel,
      timeSlot: timeSlot
    }), productChildcareAvailabilities_jsx("span", {
      className: Object(classnames_utils["a" /* classnames */])('font-brand font-normal me-5 text-12', {
        'text-black': isIncluded,
        'text-sienna': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["h" /* t */])('common.included') : Object(src_i18n["h" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx
















var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice, _flag$price2, _flag$price2$bestPric, _minAuthorizedAge$val;

  var childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      ratioDisplay = _ref.ratioDisplay,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var router = Object(next_router["useRouter"])();

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var clickIconBubbleTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: "".concat(id, "_infoIcon"),
    resortCode: id,
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price2 = flag.price) === null || _flag$price2 === void 0 ? void 0 : (_flag$price2$bestPric = _flag$price2.bestPrice) === null || _flag$price2$bestPric === void 0 ? void 0 : _flag$price2$bestPric.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1,
    siteSection: siteSection
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison || isGsa;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    router.push(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor(((_minAuthorizedAge$val = minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) !== null && _minAuthorizedAge$val !== void 0 ? _minAuthorizedAge$val : 0) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && isEmpty_default()(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', {
      'animation-duration-750 animate-fadeIn': hasFadeIn
    }, className),
    onClick: onClick
  }, Product_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', {
      'flex gap-10': isCompact
    })
  }, Product_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative', {
      'w-1/2 shrink-0': isCompact
    }),
    "data-testid": "Product-Header-Wrapper"
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx(Tag["a" /* Tag */], {
    className: "absolute start-0 z-2 mx-10 -translate-y-1/2 border-sienna bg-white text-sienna",
    "data-testid": "Product-departure"
  }, departureDateOn), hasDiscount && Product_jsx(OfferDiscount_OfferDiscount, {
    className: "absolute end-0 z-2 mx-10 -translate-y-1/2",
    discount: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.discount,
    i18n: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.i18n
  }), Product_jsx(ProductThumbnail["a" /* ProductThumbnail */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: "overflow-hidden rounded-12",
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: ratioDisplay
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: Object(classnames_utils["a" /* classnames */])({
      'overflow-hidden': isCompact,
      'mt-10': !isCompact
    }),
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["e" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), !isEmpty_default()(flag) && Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    onIconBubbleClick: function onIconBubbleClick() {
      if (Object(src_i18n["d" /* getKeyValue */])('price.displayIconBubble')) {
        track(_objectSpread(_objectSpread({}, clickIconBubbleTrackingData), {}, {
          labelGA: "".concat(id, "_infoIcon")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "mt-5 flex gap-5 rounded-12 border-1 border-lightGrey p-10 text-12"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0 text-red",
    name: icons["a" /* ICONS */].WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "text-initial mt-5 flex cursor-pointer gap-5 rounded-12 bg-sand p-10 text-12 font-bold leading-1 text-black transition-colors duration-250 ease-in hocus:bg-sand-active",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["h" /* t */])('faceting.availabilities.enterBirthdate')), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !isEmpty_default()(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XTsI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var call = __webpack_require__("we+H");
var uncurryThis = __webpack_require__("kZDm");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var fails = __webpack_require__("fhLv");
var hasOwn = __webpack_require__("/GgU");
var isPrototypeOf = __webpack_require__("VXxY");
var anObject = __webpack_require__("ep/x");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var $toString = __webpack_require__("vnfA");
var createPropertyDescriptor = __webpack_require__("OouP");
var nativeObjectCreate = __webpack_require__("Znn2");
var objectKeys = __webpack_require__("X95k");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternal = __webpack_require__("Ed3r");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");
var definePropertiesModule = __webpack_require__("HKx7");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var defineBuiltIn = __webpack_require__("Swp0");
var defineBuiltInAccessor = __webpack_require__("yYuE");
var shared = __webpack_require__("8+jV");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");
var uid = __webpack_require__("rvZv");
var wellKnownSymbol = __webpack_require__("nJrx");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineWellKnownSymbol = __webpack_require__("lPgN");
var defineSymbolToPrimitive = __webpack_require__("sCYz");
var setToStringTag = __webpack_require__("CGO5");
var InternalStateModule = __webpack_require__("9jKB");
var $forEach = __webpack_require__("VrMI").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "XhyO":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("DOIJ");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "XiOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaContextProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
  setFacetHasSeeMore: function setFacetHasSeeMore() {},
  displayActivityFilter: true,
  displayChildcareFilter: true,
  displayDestinationFilter: true,
  displaySeasonFilter: true,
  displayTypeOfStayFilter: true,
  displayFlightDurationFilter: true
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var CriteriaContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_8__["createContext"])([initialState, function () {}]);
var CriteriaContextProvider = function CriteriaContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "XiXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPriceTicketButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceTicketSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceTicketItems; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SPKZ");
/* harmony import */ var _product_quotation_form_productQuotationForm_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Dcno");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ldK3");
















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_16__["constants"].PRODUCT_TYPES;
var getPriceTicketButton = function getPriceTicketButton(product) {
  var props = {
    children: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.seeAllPrices'),
    iconLeft: {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].DATE
    },
    url: '#booking',
    trackingData: {
      actionGA: 'priceBar',
      labelGA: 'checkPrices'
    }
  };

  switch (product.type) {
    case PRODUCT_TYPES.TOUR:
      return _objectSpread(_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.askForQuotation'),
        url: "#".concat(_product_quotation_form_productQuotationForm_constants__WEBPACK_IMPORTED_MODULE_18__[/* QUOTATION_FORM_SECTION_ID */ "i"])
      });

    case PRODUCT_TYPES.CRUISE:
      return _objectSpread(_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.book')
      });

    default:
      return props;
  }
};
var getPriceTicketSubtitle = function getPriceTicketSubtitle(product, cruise) {
  var _product$destination = product.destination,
      destination = _product$destination === void 0 ? {} : _product$destination,
      _product$type = product.type,
      type = _product$type === void 0 ? '' : _product$type;

  switch (type) {
    case PRODUCT_TYPES.CRUISE:
      return (cruise === null || cruise === void 0 ? void 0 : cruise.fromToDestination) || '';

    default:
      return destination.country || '';
  }
};

var getPriceTicketItem = function getPriceTicketItem(item) {
  return item.longDesc || item.shortDesc ? item : null;
};

var getPriceTicketItems = function getPriceTicketItems(_ref) {
  var _price$termsAndCondit, _price$termsAndCondit2, _price$termsAndCondit3, _price$termsAndCondit4, _price$termsAndCondit5, _price$termsAndCondit6, _price$termsAndCondit7;

  var product = _ref.product,
      price = _ref.price,
      fromStore = _ref.fromStore;
  var type = product.type;
  var duration = fromStore.duration || product.duration || '';
  /* departureDate */

  var departureDateValue = fromStore.departureDate ? moment__WEBPACK_IMPORTED_MODULE_15___default()(fromStore.departureDate).format(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* API_DATE_FORMAT */ "a"]) : ((_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.departureDate) || 0;
  var longDateFormat = Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.departureDateFormat');
  var shortDateFormat = Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.condensedDepartureDateFormat');
  var dValue = moment__WEBPACK_IMPORTED_MODULE_15___default()(departureDateValue, 'YYYYMMDD');
  var departureDate = type !== PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].DATE,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.departureDateLabel'),
    longDesc: "".concat(dValue.format(longDateFormat), " - ").concat(moment__WEBPACK_IMPORTED_MODULE_15___default()(dValue).add(((_price$termsAndCondit2 = price.termsAndConditions) === null || _price$termsAndCondit2 === void 0 ? void 0 : _price$termsAndCondit2.duration) || 0, 'days').format(longDateFormat)),
    shortDesc: "".concat(dValue.format(shortDateFormat), " - ").concat(moment__WEBPACK_IMPORTED_MODULE_15___default()(dValue).add(((_price$termsAndCondit3 = price.termsAndConditions) === null || _price$termsAndCondit3 === void 0 ? void 0 : _price$termsAndCondit3.duration) || 0, 'days').format(shortDateFormat)),
    subDesc: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.form.selectDuration', {
      duration: ((_price$termsAndCondit4 = price.termsAndConditions) === null || _price$termsAndCondit4 === void 0 ? void 0 : _price$termsAndCondit4.duration) || 0
    })
  }) : null;
  /* duration */

  var durationTour = type === PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].DURATION,
    longDesc: duration,
    shortDesc: duration
  }) : null;
  /* transport */

  var departureCityName = fromStore.departureCity || ((_price$termsAndCondit5 = price.termsAndConditions) === null || _price$termsAndCondit5 === void 0 ? void 0 : (_price$termsAndCondit6 = _price$termsAndCondit5.departureCity) === null || _price$termsAndCondit6 === void 0 ? void 0 : _price$termsAndCondit6.name);
  var transport = departureCityName && departureCityName !== 'NO' ? getPriceTicketItem({
    iconName: product.transportType || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].TRANSPORT,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.departureCityLabel'),
    longDesc: departureCityName
  }) : getPriceTicketItem({
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].NO_TRANSPORT,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.departureCityLabel'),
    longDesc: Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('booking.form.withoutTransport')
  });
  /* persons */

  var numberOfAdults = fromStore.adultsNumber || Number((_price$termsAndCondit7 = price.termsAndConditions) === null || _price$termsAndCondit7 === void 0 ? void 0 : _price$termsAndCondit7.numberOfAdults) || 0;
  var personLabel = numberOfAdults > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.adults') : Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('productPriceTicketLine.adult');
  var persons = getPriceTicketItem({
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_17__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    label: numberOfAdults.toString(),
    longDesc: [numberOfAdults.toString(), personLabel].join(' ').trim(),
    shortDesc: numberOfAdults.toString()
  });
  return [departureDate, durationTour, persons, transport].filter(Boolean);
};

/***/ }),

/***/ "XmKO":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var setPrototypeOf = __webpack_require__("iBXc");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "XpIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LEGAL_INFO_WEBTHEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEGAL_INFO_NDC_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LEGAL_INFO_THEO_ID; });
/* unused harmony export LEGAL_INFO_SMS_ID */
/* unused harmony export LEGAL_INFO_EMAIL_ID */
/* unused harmony export LEGAL_INFO_MAIL_ID */
/* unused harmony export LEGAL_INFO_FOSUN_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGAL_INFO_CGV_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEALTH_REGULATION; });
var LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
var LEGAL_INFO_NDC_ID = 'NDC';
var LEGAL_INFO_THEO_ID = 'THEO';
var LEGAL_INFO_SMS_ID = 'SMS_OPTIN';
var LEGAL_INFO_EMAIL_ID = 'EMAIL_OPTIN';
var LEGAL_INFO_MAIL_ID = 'MAIL_OPTIN';
var LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
var LEGAL_INFO_CGV_ID = 'CGV';
var HEALTH_REGULATION = 'HEALTH_REGULATION';

/***/ }),

/***/ "XywU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white after:drop-shadow-md mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full animate-fadeIn animation-duration-500 mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md mb-20 rounded-2',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black after:drop-shadow-md mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 end-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], {
    className: Object(classnames_utils["a" /* classnames */])(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "Y3fD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__("ERkP");
var factory = __webpack_require__("ttFy");

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ "Y8c0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var userAgent = __webpack_require__("xe/R");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "YF+p":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isObject = __webpack_require__("1YFU");
var classof = __webpack_require__("XywU");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("ZE1B");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "YOLo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceRemoteServiceList; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C/y5");
/* harmony import */ var _product_services_product_service_ProductService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9OZL");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var PriceRemoteServiceList = function PriceRemoteServiceList(_ref) {
  var className = _ref.className,
      services = _ref.services;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__[/* classnames */ "a"])('flex flex-col gap-10', className)
  }, services.map(function (service) {
    return __jsx(_product_services_product_service_ProductService__WEBPACK_IMPORTED_MODULE_3__[/* ProductService */ "a"], {
      key: service.label,
      service: service
    });
  }));
};

/***/ }),

/***/ "YQkA":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "YRNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AlternativeProposals_AlternativeProposals; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionHeader.jsx

var __jsx = react_default.a.createElement;









var AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader = function AlternativeDateSuggestionHeader(_ref) {
  var arrivalDate = _ref.arrivalDate,
      className = _ref.className,
      duration = _ref.duration,
      resort = _ref.resort;
  var getFormattedDateTitle = Object(dateUtils["a" /* formatDate */])('DD/MM');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return __jsx("h2", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-start gap-10 font-brand text-24 leading-tight text-black md:text-28 lg:text-32', className),
    "data-testid": "AlternativeDate"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-orange",
    hasRtl: true,
    name: icons["a" /* ICONS */].WARNING,
    width: "2em"
  }), __jsx("span", null, __jsx(TemplateString["a" /* TemplateString */], {
    className: "block",
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel') // $FlowFixMe
    ,
    values: {
      resortName: resort.name
    }
  }), __jsx(TemplateString["a" /* TemplateString */], {
    className: "block text-orange",
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.notAvailableDates') // $FlowFixMe
    ,
    values: {
      arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || ''
    }
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx



var DateSummary_jsx = react_default.a.createElement;






var DateSummary_DateSummary = function DateSummary(_ref) {
  var className = _ref.className,
      template = _ref.template,
      values = _ref.values;
  return DateSummary_jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].DEPARTURE
  }, DateSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    hasRtl: true,
    name: icons["a" /* ICONS */].DATE,
    width: "1.875rem"
  }), DateSummary_jsx(TemplateString["a" /* TemplateString */], {
    dataTestId: "DateSummary",
    template: template // $FlowFixMe
    ,
    values: values,
    valuesClassName: {
      arrivalDate: 'font-bold text-sienna',
      departureDate: 'font-bold text-sienna'
    }
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// CONCATENATED MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx


var Flipper_jsx = react_default.a.createElement;

var Flipper_Flipper = function Flipper(_ref) {
  var description = _ref.description,
      value = _ref.value;

  var _useState = Object(react["useState"])(value),
      oldValue = _useState[0],
      setOldValue = _useState[1];

  var _useState2 = Object(react["useState"])(value),
      latestValue = _useState2[0],
      setLatestValue = _useState2[1];

  var _useState3 = Object(react["useState"])(''),
      transition = _useState3[0],
      setTransition = _useState3[1];

  Object(react["useEffect"])(function () {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('animate-flipperLeave');
    }
  }, [value]);
  return Flipper_jsx("span", {
    "data-testid": value,
    className: "isolate relative"
  }, !!description && Flipper_jsx("span", {
    className: "sr-only",
    "data-testid": "srOnly"
  }, description), Flipper_jsx("span", {
    className: "text-center block ".concat(transition),
    "data-testid": "Flipper-value",
    key: transition,
    onAnimationEnd: function onAnimationEnd(event) {
      switch (event.animationName) {
        case 'animate-flipperLeave':
          setTransition('animate-flipperEnter');
          break;

        case 'animate-flipperEnter':
          setTransition('animate-flipperEnter');
          break;

        default:
          break;
      }
    }
  }, transition === 'animate-flipperLeave' ? oldValue : latestValue));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria.jsx
var AlternativeSuggestionCriteria_jsx = react_default.a.createElement;







var AlternativeSuggestionCriteria_AlternativeSuggestionCriteria = function AlternativeSuggestionCriteria(_ref) {
  var buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      onSubmit = _ref.onSubmit,
      suggestion = _ref.suggestion,
      title = _ref.title;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  return AlternativeSuggestionCriteria_jsx("div", {
    className: className,
    "data-testid": "AlternativeDateSuggestionCriteria"
  }, title && AlternativeSuggestionCriteria_jsx("p", {
    className: "mb-5 text-16 text-black"
  }, title), AlternativeSuggestionCriteria_jsx(Capsule["a" /* Capsule */], {
    contentClassName: "flex flex-col gap-10 p-20"
  }, AlternativeSuggestionCriteria_jsx(DateSummary_DateSummary, {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeSuggestionCriteria_jsx("div", {
    className: "flex items-center justify-center gap-10 font-bold text-sienna"
  }, AlternativeSuggestionCriteria_jsx(Flipper_Flipper, {
    value: suggestion.price.total
  }), AlternativeSuggestionCriteria_jsx(Flipper_Flipper, {
    value: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  })), AlternativeSuggestionCriteria_jsx(Button["a" /* Button */], {
    className: "w-full",
    "data-testid": "AlternativeProposalsModalButton",
    onClick: function onClick() {
      return onSubmit(suggestion.resortArrivalDate);
    }
  }, buttonLabel)));
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive.jsx

var AlternativeDateSuggestionImmersive_jsx = react_default.a.createElement;







var DIMENSIONS = {
  h: 408,
  w: 734
};
var AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive = function AlternativeDateSuggestionImmersive(_ref) {
  var className = _ref.className,
      onClose = _ref.onClose,
      resort = _ref.resort;
  var trackClick = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: 'search'
  });
  return AlternativeDateSuggestionImmersive_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-full', className)
  }, AlternativeDateSuggestionImmersive_jsx("div", {
    className: "overflow-hidden rounded-12"
  }, AlternativeDateSuggestionImmersive_jsx(Image["a" /* Image */], {
    altMsg: resort.name,
    dimensions: DIMENSIONS,
    hasLazyLoading: false,
    imageUrl: resort.image
  })), !!onClose && AlternativeDateSuggestionImmersive_jsx("button", {
    className: "flex font-sans gap-5 items-center mt-20 text-16 text-sienna",
    onClick: function onClick() {
      onClose && onClose();
      trackClick({
        labelGA: 'backResortPage'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.doNotCheckPriceLabel'), AlternativeDateSuggestionImmersive_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_RIGHT
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions.jsx
var AlternativeSuggestions_jsx = react_default.a.createElement;







var AlternativeSuggestions_AlternativeSuggestions = function AlternativeSuggestions(_ref) {
  var children = _ref.children,
      className = _ref.className,
      immersiveResort = _ref.immersiveResort,
      onClose = _ref.onClose,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return AlternativeSuggestions_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(className)
  }, AlternativeSuggestions_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n1"
  }, title), AlternativeSuggestions_jsx("div", {
    className: "flex gap-20"
  }, isTablet ? AlternativeSuggestions_jsx("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 gap-20"
  }, children) : AlternativeSuggestions_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    className: "-mx-20",
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, AlternativeSuggestions_jsx("div", {
    className: "flex gap-10 px-20"
  }, children)), immersiveResort && AlternativeSuggestions_jsx(AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive, {
    onClose: onClose,
    resort: immersiveResort
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeDurationSuggestions.jsx









var AlternativeDurationSuggestions_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AlternativeDurationSuggestions_AlternativeDurationSuggestions = function AlternativeDurationSuggestions(_ref) {
  var durations = _ref.durations,
      onSelectNewDuration = _ref.onSelectNewDuration,
      trackingData = _ref.trackingData;
  return AlternativeDurationSuggestions_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsLabel')
  }, durations.map(function (suggestion) {
    var duration = suggestion.data.duration;
    var multi = durations.length > 1;
    return AlternativeDurationSuggestions_jsx(AlternativeSuggestionCriteria_AlternativeSuggestionCriteria, {
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelDuration'),
      className: Object(classnames_utils["a" /* classnames */])({
        'last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-280 flex-none sm:w-auto': multi,
        'flex-1': !multi
      }),
      key: duration,
      onSubmit: function onSubmit() {
        onSelectNewDuration({
          proposalIds: suggestion.ids,
          duration: duration
        });
        trackingData('duration_check');
      },
      suggestion: _objectSpread(_objectSpread({}, suggestion.data), {}, {
        price: {
          total: suggestion.data.price.total.formattedValue
        }
      }),
      title: AlternativeDurationSuggestions_jsx(react["Fragment"], null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationLabel'), ' ', AlternativeDurationSuggestions_jsx("span", {
        className: "text-18 font-bold text-sienna"
      }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsSuggestions', {
        duration: duration
      })))
    });
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes.js
var themes = {
  "default": {
    thRoot: 'w-full bg-white border-1 rounded-4 shadow-sm relative',
    thButton: 'min-h-50 flex flex-1 border-1 leading-0 overflow-hidden rounded-4 text-14 bg-saffron border-saffron text-white items-center text-current text-initial lg:me-10 justify-center md:justify-between',
    thClear: 'px-10 shrink-0 text-current',
    thClearSize: '0.625rem',
    thIcon: 'shrink-0 mx-10',
    thLabel: 'min-h-50 flex-1 mx-10 overflow-hidden flex items-center whitespace-nowrap',
    thSubmitButton: 'bg-success cursor-pointer font-bold flex justify-center items-center leading-0 rounded-4 text-14 text-white mt-15 lg:mt-0 lg:flex-1 w-full lg:w-auto'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/constants.js
var ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD = 4;
var ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD = 2;
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/constants.js
var criteria_transport_constants = __webpack_require__("MX/n");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/constants.js
var criteria_when_constants = __webpack_require__("393O");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/constants.js
var criteria_who_constants = __webpack_require__("PFSw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var store_booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-criteria-button/AlternativePriceCriteriaButton.jsx
var AlternativePriceCriteriaButton_jsx = react_default.a.createElement;




var AlternativePriceCriteriaButton_AlternativePriceCriteriaButton = function AlternativePriceCriteriaButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel;
  return AlternativePriceCriteriaButton_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])(thButton, className),
    onClick: onClick,
    type: "button"
  }, AlternativePriceCriteriaButton_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: "1em"
  }), AlternativePriceCriteriaButton_jsx("span", {
    className: thLabel
  }, children));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.jsx





var AlternativePrice_jsx = react_default.a.createElement;
























var AlternativePrice_AlternativePrice = function AlternativePrice(_ref) {
  var bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      continueToBookingEngine = _ref.continueToBookingEngine,
      departureCities = _ref.departureCities,
      hasOtherProposals = _ref.hasOtherProposals,
      onModify = _ref.onModify,
      proposals = _ref.proposals,
      resort = _ref.resort,
      _ref$searchCriteria = _ref.searchCriteria,
      adultsCount = _ref$searchCriteria.adultsCount,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      departureCity = _ref$searchCriteria.departureCity,
      duration = _ref$searchCriteria.duration,
      kidsCount = _ref$searchCriteria.kidsCount,
      seeOtherProposalsCallback = _ref.seeOtherProposalsCallback,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();
  var _proposals$ = proposals[0],
      price = _proposals$.price,
      allInclusiveServices = _proposals$.allInclusiveServices;

  if (!price) {
    return null;
  }

  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thSubmitButton = _themes$theme.thSubmitButton;
  var noTransport = departureCity === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  var openCriteriaWhenEvent = document.createEvent('Event');
  openCriteriaWhenEvent.initEvent(criteria_when_constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], true, true);
  var openCriteriaWhoEvent = document.createEvent('Event');
  openCriteriaWhoEvent.initEvent(criteria_who_constants["a" /* OPEN_CRITERIA_WHO_EVENT */], true, true);
  var openCriteriaTransportEvent = document.createEvent('Event');
  openCriteriaTransportEvent.initEvent(criteria_transport_constants["a" /* OPEN_CRITERIA_TRANSPORT_EVENT */], true, true);

  var criteriaClickHandlerFactory = function criteriaClickHandlerFactory(event) {
    return function () {
      if (onModify) {
        onModify();
      }

      if (bookingEngineEntryPoint === store_booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE) {
        setTimeout(function () {
          document.dispatchEvent(event);
        }, 200);
      }
    };
  };

  var firstDay = moment_default()(arrivalDate);
  var city = departureCities.find(function (d) {
    return departureCity === d.value;
  });
  var bestPrice = price.bestPrice,
      total = price.total;
  var overflowThreshold = isDesktop ? ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD : ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD;
  return AlternativePrice_jsx(react["Fragment"], null, hasOtherProposals && AlternativePrice_jsx(Button["a" /* Button */], {
    className: "lg:mt-30",
    color: isDesktop ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].SAFFRON,
    colorBg: isDesktop ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].LIGHT_GREY,
    colorBorder: isDesktop ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].LIGHT_GREY,
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'seeOtherProposals'
      });
      seeOtherProposalsCallback();
    }
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.seeOtherProposalsButton')), AlternativePrice_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot)
  }, AlternativePrice_jsx("div", {
    className: "flex flex-col items-center p-10"
  }, AlternativePrice_jsx("div", {
    className: "flex w-full justify-between"
  }, AlternativePrice_jsx(ProductBanner["a" /* ProductBanner */], {
    product: resort
  }), AlternativePrice_jsx("div", {
    className: "w-full text-center lg:flex lg:w-auto lg:items-center lg:text-right"
  }, AlternativePrice_jsx("div", {
    className: "hidden gap-10 lg:flex lg:items-center"
  }, AlternativePrice_jsx(Icon["a" /* Icon */], {
    className: "text-saffron",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), AlternativePrice_jsx("div", {
    className: "font-brand text-16 text-saffron"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.allInclusive'))), AlternativePrice_jsx(Price["b" /* Price */], {
    bestPrice: bestPrice,
    className: "inline-flex",
    hasInitialPrice: true,
    hasInstalment: false,
    initialPrice: total,
    unit: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }))), AlternativePrice_jsx("div", {
    className: "flex-between mt-10 flex w-full flex-wrap lg:flex-nowrap"
  }, AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].DATE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhenEvent) : undefined
  }, "".concat(firstDay.format('DD MMM'), " - ").concat(firstDay.add(duration, 'd').format('DD MMM'))), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhoEvent) : undefined
  }, Object(labelUtils["b" /* getAttendeesSummary */])({
    adultsCount: adultsCount,
    kidsCount: kidsCount
  })), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaTransportEvent) : undefined
  }, city ? city.name : ''), AlternativePrice_jsx(Button["a" /* Button */], {
    className: Object(classnames_utils["a" /* classnames */])(thSubmitButton, 'w-full min-w-80 lg:w-[250px]'),
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'rate_check'
      });
      continueToBookingEngine();
    },
    type: "submit"
  }, Object(src_i18n["h" /* t */])('common.continue'))), onModify && AlternativePrice_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].SAFFRON,
    colorBg: colors["a" /* COLORS */].TRANSPARENT,
    colorBorder: colors["a" /* COLORS */].SAFFRON,
    iconLeft: {
      name: icons["a" /* ICONS */].PEN
    },
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'rate_modify'
      });
      onModify();
    }
  }, Object(src_i18n["h" /* t */])('common.modify')), AlternativePrice_jsx("div", {
    className: "w-full px-25"
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap"
  }, allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.slice(0, overflowThreshold).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  })), (allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) > overflowThreshold && AlternativePrice_jsx(react["Fragment"], null, AlternativePrice_jsx(lib["Collapse"], {
    isOpened: isDetailOpened
  }, AlternativePrice_jsx("div", {
    className: "flex-wra flex"
  }, allInclusiveServices.slice(overflowThreshold, allInclusiveServices.length).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  }))), !isDetailOpened ? AlternativePrice_jsx("div", {
    className: "w-full"
  }) : null))), (allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) > overflowThreshold && AlternativePrice_jsx("div", {
    className: "absolute left-1/2 flex -translate-x-1/2 transform items-center justify-center"
  }, AlternativePrice_jsx(StripButton["a" /* StripButton */], {
    className: "text-center text-12 font-bold text-saffron underline",
    height: 30,
    onClick: function onClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    orientation: "bottom"
  }, AlternativePrice_jsx("div", {
    className: "flex items-center gap-10 text-14"
  }, !isDetailOpened ? Object(src_i18n["h" /* t */])('priceRemote.openAllInclusiveDetails') : Object(src_i18n["h" /* t */])('priceRemote.closeAllInclusiveDetails'), AlternativePrice_jsx(Icon["a" /* Icon */], {
    className: "transition-transform text-saffron",
    name: icons["a" /* ICONS */].ARROW_DOWN,
    rotation: isDetailOpened ? 180 : 0,
    width: "0.625rem"
  }))))));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle.jsx
var AlternativePriceTitle_jsx = react_default.a.createElement;







var AlternativePriceTitle_AlternativePriceTitle = function AlternativePriceTitle(_ref) {
  var className = _ref.className,
      price = _ref.proposal.price,
      title = _ref.title;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!price) {
    return null;
  }

  return AlternativePriceTitle_jsx("h2", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-bold gap-10 items-center leading-tight text-24 md:text-28 lg:text-32 text-orange', className)
  }, Object(sellerUtils["f" /* isSeller */])(appContext) && price.gap >= 30 || price.gap < 30 ? AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1em"
  }), title) : AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "4rem"
  }), Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterAdvise'), AlternativePriceTitle_jsx("span", {
    className: "flex gap-5 items-center text-18"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem"
  }), AlternativePriceTitle_jsx("span", null, AlternativePriceTitle_jsx("span", null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.pleaseCallLabel')), ' ', Object(src_i18n["h" /* t */])('travelAdvisor.phoneNumber'), ' ', AlternativePriceTitle_jsx("span", {
    className: "text-16 text-black"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-proposal-header/AlternativeProposalHeader.jsx
var AlternativeProposalHeader_jsx = react_default.a.createElement;





var AlternativeProposalHeader_AlternativeProposalHeader = function AlternativeProposalHeader(_ref) {
  var className = _ref.className,
      proposal = _ref.proposal,
      title = _ref.title;
  return proposal ? AlternativeProposalHeader_jsx(AlternativePriceTitle_AlternativePriceTitle, {
    className: className,
    proposal: proposal,
    title: title
  }) : AlternativeProposalHeader_jsx("h2", {
    className: Object(classnames_utils["a" /* classnames */])('flex font-brand gap-10 items-start leading-tight text-24 md:text-28 lg:text-32 text-orange', className)
  }, AlternativeProposalHeader_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1em"
  }), title);
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestion.jsx


var AlternativeDateSuggestion_jsx = react_default.a.createElement;




var AlternativeDateSuggestion_AlternativeDateSuggestion = function AlternativeDateSuggestion(_ref) {
  var className = _ref.className,
      dates = _ref.dates,
      onClose = _ref.onClose,
      _onSubmit = _ref.onSubmit,
      resort = _ref.resort,
      trackingData = _ref.trackingData;
  return AlternativeDateSuggestion_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    className: className,
    immersiveResort: resort,
    onClose: onClose,
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.weSuggestLabel', {
      resortName: resort.name
    })
  }, dates.map(function (suggestion) {
    return AlternativeDateSuggestion_jsx(AlternativeSuggestionCriteria_AlternativeSuggestionCriteria, {
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabel'),
      key: suggestion.dateOffset,
      onSubmit: function onSubmit(newArrivalDate) {
        _onSubmit(newArrivalDate);

        trackingData('date_check');
      },
      suggestion: suggestion
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsSeparatorDashed.jsx
var AlternativeProposalsSeparatorDashed_jsx = react_default.a.createElement;



var AlternativeProposalsSeparatorDashed = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return AlternativeProposalsSeparatorDashed_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex justify-center isolate relative w-full', props.className),
    "data-testid": "AlternativeProposalsSeparatorDashed",
    ref: ref
  }, AlternativeProposalsSeparatorDashed_jsx("hr", {
    className: "absolute block border-0 border-t-1 border-dashed border-grey h-1 m-0 p-0 top-1/2 w-full"
  }), AlternativeProposalsSeparatorDashed_jsx("p", {
    className: "bg-white font-bold px-25 py-10 text-24 text-black z-1"
  }, Object(src_i18n["h" /* t */])('booking.common.or')));
});
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 5 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortThumbnail.jsx



var AlternativeResortThumbnail_jsx = react_default.a.createElement;









var AlternativeResortThumbnail_AlternativeResortThumbnail = function AlternativeResortThumbnail(_ref) {
  var _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA,
      className = _ref.className,
      onClick = _ref.onClick,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      suggestion = _ref.suggestion;
  var router = Object(next_router["useRouter"])();
  var trackClick = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: categoryGA
  });

  var handleClick = function handleClick() {
    var _suggestion$resort = suggestion.resort,
        id = _suggestion$resort.id,
        name = _suggestion$resort.name,
        href = _suggestion$resort.href;
    var url = "".concat(href, "?").concat(URI_default.a.buildQuery(omit_default()(router.query, ['dynamicPage'])));
    onClick ? onClick(id, name) : router.push(url).then(function () {
      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    });
  };

  return AlternativeResortThumbnail_jsx("div", {
    className: className,
    "data-testid": "AlternativeResortThumbnail"
  }, AlternativeResortThumbnail_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({}, Object(product_utils["d" /* createPropsForProduct */])(suggestion.resort), {
    hasLazyLoading: false // Allows to avoid to launch the tracking on the arrows of the slider
    ,
    onClick: function onClick(e) {
      if (e.target instanceof HTMLImageElement) {
        handleClick();
        trackClick({
          labelGA: 'resort_checkThumbnail'
        });
      }
    }
  })), AlternativeResortThumbnail_jsx(Button["a" /* Button */], {
    className: "mt-20 w-full",
    "data-testid": "AlernativeResortThumbnailButton",
    onClick: function onClick() {
      handleClick();
      trackClick({
        actionGA: 'checkPricesKO',
        categoryGA: 'resort',
        labelGA: 'resort_check'
      });
    }
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelResort')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary_jsx = react_default.a.createElement;







var AttendeesSummary_AttendeesSummary = function AttendeesSummary(_ref) {
  var adults = _ref.adults,
      className = _ref.className,
      kids = _ref.kids;
  return AttendeesSummary_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].ATTENDEES
  }, AttendeesSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    hasRtl: true,
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    width: "1.875rem"
  }), AttendeesSummary_jsx("div", null, AttendeesSummary_jsx("p", {
    "data-testid": "PackagePriceSummary-guestsItem",
    key: "adults"
  }, AttendeesSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, adults), " ".concat(Object(labelUtils["d" /* pluralizeLabel */])(Object(src_i18n["h" /* t */])('booking.common.adult'), Object(src_i18n["h" /* t */])('booking.common.adults'), adults))), kids > 0 && AttendeesSummary_jsx("p", {
    "data-testid": "PackagePriceSummary-guestsItem",
    key: "children"
  }, AttendeesSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, kids), " ".concat(Object(labelUtils["d" /* pluralizeLabel */])(Object(src_i18n["h" /* t */])('booking.common.child'), Object(src_i18n["h" /* t */])('booking.common.children'), kids)))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary_jsx = react_default.a.createElement;






var TransportSummary_TransportSummary = function TransportSummary(_ref) {
  var className = _ref.className,
      departure = _ref.departure,
      transportIcon = _ref.transportIcon;
  var noTransportIcon = icons["a" /* ICONS */].NO_TRANSPORT;
  return TransportSummary_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].TRANSPORT
  }, TransportSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    hasRtl: true,
    name: departure ? transportIcon : noTransportIcon,
    width: "1.875rem"
  }), departure ? TransportSummary_jsx(react["Fragment"], null, Object(src_i18n["h" /* t */])('common.transport.from'), " ", TransportSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, departure)) : Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.noTransport'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortCriteria.jsx
var AlternativeResortCriteria_jsx = react_default.a.createElement;











var AlternativeResortCriteria_AlternativeResortCriteria = function AlternativeResortCriteria(_ref) {
  var adultsNumber = _ref.adultsNumber,
      arrivalDate = _ref.arrivalDate,
      className = _ref.className,
      departureCity = _ref.departureCity,
      duration = _ref.duration,
      kidsNumber = _ref.kidsNumber;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeResortCriteria_jsx(Capsule["a" /* Capsule */], {
    className: className,
    contentClassName: "flex flex-col gap-10 p-20",
    dataTestId: "AlternativeResortCriteria"
  }, AlternativeResortCriteria_jsx(DateSummary_DateSummary, {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeResortCriteria_jsx(AttendeesSummary_AttendeesSummary, {
    adults: adultsNumber,
    kids: kidsNumber
  }), AlternativeResortCriteria_jsx(TransportSummary_TransportSummary, {
    departure: departureCity !== 'NO' ? departureCity : null,
    transportIcon: icons["a" /* ICONS */].TRANSPORT
  }), AlternativeResortCriteria_jsx("p", {
    className: "flex items-start gap-5 text-12 font-bold text-orange"
  }, AlternativeResortCriteria_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 translate-y-[0.2em]",
    name: icons["a" /* ICONS */].WARNING,
    width: "1em"
  }), Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResort.jsx

var AlternativeResort_jsx = react_default.a.createElement;







var AlternativeResort_AlternativeResort = function AlternativeResort(_ref) {
  var adultsNumber = _ref.adultsNumber,
      arrivalDate = _ref.arrivalDate,
      _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA,
      departureCity = _ref.departureCity,
      duration = _ref.duration,
      kidsNumber = _ref.kidsNumber,
      suggestions = _ref.suggestions,
      selectResortHandler = _ref.selectResortHandler,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return AlternativeResort_jsx("div", {
    "data-testid": "AlternativeResort"
  }, AlternativeResort_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n1"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTitle')), AlternativeResort_jsx("div", {
    className: "grid grid-cols-1 gap-20 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
  }, AlternativeResort_jsx(AlternativeResortCriteria_AlternativeResortCriteria, {
    adultsNumber: adultsNumber,
    arrivalDate: arrivalDate,
    className: "flex-1",
    departureCity: departureCity,
    duration: duration,
    kidsNumber: kidsNumber
  }), isTablet ? AlternativeResort_jsx(react["Fragment"], null, suggestions.map(function (suggestion) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      categoryGA: categoryGA,
      key: suggestion.resort.id,
      onClick: selectResortHandler,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
      suggestion: suggestion
    });
  })) : AlternativeResort_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-20",
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, AlternativeResort_jsx("div", {
    className: "flex gap-10 px-20"
  }, suggestions.map(function (suggestion) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      categoryGA: categoryGA,
      className: "last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-280 flex-none",
      key: suggestion.resort.id,
      onClick: selectResortHandler,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
      suggestion: suggestion
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx
var AlternativeProposals_jsx = react_default.a.createElement;















var AlternativeProposals_AlternativeProposals = function AlternativeProposals(_ref) {
  var _proposal$price, _proposal$price2, _i18n$bookingCriteria;

  var bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      _ref$disableAlternati = _ref.disableAlternativePrice,
      disableAlternativePrice = _ref$disableAlternati === void 0 ? false : _ref$disableAlternati,
      goToBookingEngine = _ref.goToBookingEngine,
      i18n = _ref.i18n,
      onClose = _ref.onClose,
      onSelectNewDuration = _ref.onSelectNewDuration,
      onSubmit = _ref.onSubmit,
      proposals = _ref.proposals,
      resort = _ref.resort,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      _ref$searchCriteria = _ref.searchCriteria,
      adultsCount = _ref$searchCriteria.adultsCount,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      departureCity = _ref$searchCriteria.departureCity,
      duration = _ref$searchCriteria.duration,
      kidsCount = _ref$searchCriteria.kidsCount,
      searchCriteria = _ref.searchCriteria,
      selectResortHandler = _ref.selectResortHandler,
      _ref$suggestions = _ref.suggestions,
      dates = _ref$suggestions.dates,
      resorts = _ref$suggestions.resorts,
      durations = _ref$suggestions.durations;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: 'search'
  });
  var separatorComponent = Object(react["useRef"])(null);
  var proposal = proposals[0];
  var shouldDisplayAlternativePriceCriteria = !disableAlternativePrice && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) > constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] && (appContext.isSeller || proposal.price.gap < constants["x" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */]);
  var shouldDisplayAlternativePriceTitle = !disableAlternativePrice && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : _proposal$price2.gap) > constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];

  var seeOtherProposalsCallback = function seeOtherProposalsCallback() {
    if (separatorComponent.current) {
      separatorComponent.current.scrollIntoView();
    }
  };

  var atLeastOneDateCounterProposal = dates.length > 0;
  var atLeastOneResortCounterProposal = resorts.length > 0;
  var atLeastOneDurationCounterProposal = durations.length > 0;
  var hasSuggestions = atLeastOneDateCounterProposal || atLeastOneResortCounterProposal || atLeastOneDurationCounterProposal;

  var trackingData = function trackingData(labelGA) {
    track({
      labelGA: labelGA
    });
  };

  return AlternativeProposals_jsx("div", {
    "data-testid": "AlternativeProposalsModal"
  }, shouldDisplayAlternativePriceTitle && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    proposal: proposal,
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle')
  })), shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativePrice_AlternativePrice, {
    bookingEngineEntryPoint: bookingEngineEntryPoint // $FlowFixMe
    ,
    continueToBookingEngine: goToBookingEngine,
    departureCities: ((_i18n$bookingCriteria = i18n.bookingCriteria) === null || _i18n$bookingCriteria === void 0 ? void 0 : _i18n$bookingCriteria.departureCities) || [],
    hasOtherProposals: hasSuggestions,
    onModify: onClose ? function () {
      onClose();

      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    } : undefined,
    proposals: proposals,
    resort: resort,
    searchCriteria: searchCriteria,
    seeOtherProposalsCallback: seeOtherProposalsCallback
  })), hasSuggestions && shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, {
    ref: separatorComponent
  }), hasSuggestions && !shouldDisplayAlternativePriceTitle && !disableAlternativePrice ? AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader, {
    arrivalDate: arrivalDate,
    duration: duration,
    resort: resort
  })) : AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], null, AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    className: "my-40",
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.otherProposals')
  })), atLeastOneDateCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDateSuggestion_AlternativeDateSuggestion, {
    dates: dates,
    onClose: onClose,
    onSubmit: onSubmit,
    resort: resort,
    trackingData: trackingData
  })), atLeastOneDateCounterProposal && (atLeastOneDurationCounterProposal || atLeastOneResortCounterProposal) && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneDurationCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDurationSuggestions_AlternativeDurationSuggestions, {
    durations: durations,
    onSelectNewDuration: onSelectNewDuration,
    trackingData: trackingData
  })), atLeastOneDurationCounterProposal && atLeastOneResortCounterProposal && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneResortCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeResort_AlternativeResort, {
    adultsNumber: adultsCount,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    kidsNumber: kidsCount,
    scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
    selectResortHandler: selectResortHandler,
    suggestions: resorts
  })), !appContext.isCmta && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mt-40 border-t-1 border-grey"
  }, AlternativeProposals_jsx("div", {
    className: "flex items-center justify-center gap-5 py-20 text-18 font-bold text-black"
  }, AlternativeProposals_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-green",
    hasRtl: true,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "3em"
  }), AlternativeProposals_jsx("p", null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.contactCallCenter'), ' ', AlternativeProposals_jsx("span", {
    className: "text-green"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterNumber')), ' ', AlternativeProposals_jsx("span", {
    className: "text-12 font-normal"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
};

/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* unused harmony export ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__MORE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* unused harmony export ID_MODAL_HEADER__BE__CXO_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* unused harmony export ID_MODAL_HEADER__BE__CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__EASY_ARRIVAL_INFO; });
/* unused harmony export ID_MODAL_HEADER__BE__HOUSEHOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE_REFRESH_PROPOSAL; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE = 'TransportsFiltersMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
var ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
var ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';

/***/ }),

/***/ "Z+2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductThumbnail; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DQFb");
/* harmony import */ var _frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("N5WC");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;








var OPENING_STATUS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["constants"].OPENING_STATUS;
var ProductThumbnail = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])(function ProductThumbnail(_ref) {
  var _ref$bottomTags = _ref.bottomTags,
      bottomTags = _ref$bottomTags === void 0 ? [] : _ref$bottomTags,
      className = _ref.className,
      closedLabel = _ref.closedLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isLinkDisabled = _ref.isLinkDisabled,
      isSliderDisabled = _ref.isSliderDisabled,
      _ref$isTagsDisabled = _ref.isTagsDisabled,
      isTagsDisabled = _ref$isTagsDisabled === void 0 ? false : _ref$isTagsDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 / 3 : _ref$ratioDisplay,
      _ref$topTags = _ref.topTags,
      topTags = _ref$topTags === void 0 ? [] : _ref$topTags;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"];
  var defaultPicture = pictures[0] || {};
  return __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('relative block', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? __jsx(_frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__[/* ImageSlideShow */ "a"], {
    hasLazyLoading: true,
    itemClassName: "isolate overflow-hidden rounded-12 will-change-transform",
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay
  }) : __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* Image */ "a"], {
    altMsg: defaultPicture.alt,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay,
    hasLazyLoading: hasLazyLoading
  }), !!(topTags === null || topTags === void 0 ? void 0 : topTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute top-0 flex w-full justify-end gap-5 p-10",
    "data-testid": "ProductThumbnail-topTags"
  }, topTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      className: tag.className,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.dataTestId || tag.label,
      style: tag.style
    }, tag.label);
  })), openingStatus === OPENING_STATUS.CLOSED && __jsx("div", {
    className: "absolute inset-0 z-1 inline-flex items-center justify-center overflow-hidden rounded-12 bg-black/60 text-20 font-bold uppercase text-white",
    "data-testid": "ProductThumbnail-closed"
  }, closedLabel), !!(bottomTags === null || bottomTags === void 0 ? void 0 : bottomTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute bottom-0 flex w-full justify-start gap-5 p-10",
    "data-testid": "ProductThumbnail-bottomTags"
  }, bottomTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      className: tag.className,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.label,
      style: tag.style
    }, tag.label);
  })));
});

/***/ }),

/***/ "ZE1B":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("fhLv");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "ZFcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Slider; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-5 mt-10',
    thControl: 'mx-5'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 transform -translate-y-1/2 w-full',
    thControl: 'pointer-events-auto before:absolute before:content-[""] before:h-120 before:right-0 before:h-40',
    thControlLeft: 'transform -translate-x-1/2',
    thControlRight: 'transform translate-x-1/2',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-5',
    thControl: 'mx-5'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-5 mb-10 order-first',
    thControl: 'mx-5'
  }
};
var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND
    });
  },
  brand: function brand(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].SAFFRON
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx









var __jsx = react_default.a.createElement;






function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      scrollItemStyle = props.scrollItemStyle,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = throttle_default()(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, 'relative', {
      '-scale-x-1 transform': isRTL
    }, className),
    dir: "ltr",
    id: id
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('h-full', thInner)
  }, __jsx("div", {
    className: scrollAreaClassName
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full flex-row flex-nowrap', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return __jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: Object(classnames_utils["a" /* classnames */])(isFunction_default()(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, (_classnames = {
        'snap-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, '-scale-x-1 transform', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null, {
      style: scrollItemStyle
    }), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr'
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(scrollControlsClassName, thControls)
  }, __jsx(ArrowButton["a" /* ArrowButton */], {
    className: Object(classnames_utils["a" /* classnames */])(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), __jsx(ArrowButton["a" /* ArrowButton */], {
    className: Object(classnames_utils["a" /* classnames */])(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}

/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSchemaValidators; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getNonAsciiNameValidatorByLocale; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ ContactInfoUtils_getTravelDocumentsValidators; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ ContactInfoUtils_getLegalAgreementValidator; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getChildCivilities; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* binding */ ContactInfoUtils_trackAttendeesFormError; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ ContactInfoUtils_isChildWillBeAdultByArrivalDate; });
__webpack_require__.d(__webpack_exports__, "A", function() { return /* binding */ ContactInfoUtils_travelCompanionMapper; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createId; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ ContactInfoUtils_filterSearchedChildren; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ findAlphabetIndex; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ setTravelCompanionBlockFormErrors; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ getTravelCompanionInfos; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ ContactInfoUtils_setTravelCompanionField; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getConcernedAttendees; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* binding */ submitOptionFromProposal; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ ContactInfoUtils_handleSetErrorsForConcernedAttendees; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ ContactInfoUtils_shouldHideField; });

// UNUSED EXPORTS: verifyChildrenSiblings, getLegalAgreementValidatorMulti, getSalesmanIdValidator, tripInformationToAttendeesList, getNextCharacter, getChildrenToAdultsTransferList, compareById, compareByBirthdate, getSortedTravelCompanionList, getFieldErrors, getCNILLegalMessage, getLegalInformation, getLegalInputInformation, shouldDisplayLegalInformation, getDocumentsFields, getHouseholdsAttendees

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("6LKR");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("TYRa");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isObject.js
var isObject = __webpack_require__("tQYX");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flatten.js
var flatten = __webpack_require__("1xil");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var booking_process_constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/option-validity/constants.js
var option_validity_constants = __webpack_require__("l/UU");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js








var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/identityNumberValidator.reducer.js









var identityNumberRule = lib["string"]().matches(/[a-zA-Z0-9]{6,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var fiscalCodeRule = lib["string"]().matches(/[a-zA-Z0-9]{16,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var identityNumberValidator_reducer_identityNumberValidatorReducer = function identityNumberValidatorReducer(locale, attendeeSchema) {
  var _attendeeSchema$find;

  var isIdentityNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref) {
    var name = _ref.name;
    return name === 'identity_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var brazilCpfRule = lib["string"]().test('is-brazil-cpf-rule-valid', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
    var trimValue = value ? value.trim() : '';

    if (!isIdentityNumberRequired) {
      // field isn't required: check cpf validity is has truthy value or return true
      return trimValue ? isValidCPF(value) : true;
    } // field is required: return cpf validity if has truthy value or return false


    var invalidCpfFormat = value.length < 11 || value.length > 14 || !isValidCPF(value);
    return trimValue && !invalidCpfFormat;
  });

  switch (locale) {
    case locale_constants["a" /* LOCALES */].PT_BR:
      return brazilCpfRule;

    case locale_constants["a" /* LOCALES */].IT_IT:
      return fiscalCodeRule;

    default:
      return identityNumberRule;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js














































function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




















 // removing mergeSchemas method cause it does not have expected behavior.
// https://github.com/jquense/yup#schemaconcatschema-schema-schema -> doc explaning that is does not merge content but override previous schema.
// https://github.com/jquense/yup/issues/1535 -> issue explaining that it does not merge content but override previous schema.
// Using yup.addMethods that allows us to add custom methods to Yup when needed so it's possible to chain schemas in prefered order.

function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === contact_info_constants["d" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && pick_default()(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id && (type && legalMessage.type ? legalMessage.type === type : true);
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["c" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["k" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["g" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["d" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["i" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(booking_process_constants["d" /* LEGAL_INFO_THEO_ID */]),
    webTheo: getLegalInfo(booking_process_constants["e" /* LEGAL_INFO_WEBTHEO_ID */]),
    ndc: getLegalInfo(booking_process_constants["c" /* LEGAL_INFO_NDC_ID */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(params, hasSaveOption, isChequeOrTransferPaymentLabel) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        ").concat(hasSaveOption || isChequeOrTransferPaymentLabel ? 'bookingStatus: OPTION' : 'bookingStatus: PENDING_PAYMENT', "\n      ) {\n        bookingId\n        expirationDateTime\n        isReliable\n      }\n    }");
}

function submitOptionFromProposal(_ref) {
  var appContext = _ref.appContext,
      hasNoRedirection = _ref.hasNoRedirection,
      hasSaveOption = _ref.hasSaveOption,
      productId = _ref.productId,
      router = _ref.router,
      selectedProposalId = _ref.selectedProposalId,
      providerId = _ref.providerId,
      withfutureTravelCredits = _ref.withfutureTravelCredits;
  return function () {
    var redirectTo = Object(redirectUtils["b" /* redirectToUri */])(router);
    var params = {
      proposalId: selectedProposalId
    };
    var paymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["m" /* PAYMENT_METHOD_LABEL */]);
    var isChequeOrTransferPaymentLabel = [PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].CHEQUE, PaymentInfo_const["l" /* PAYMENT_METHOD_CATEGORY */].BANK_TRANSFER].includes(upperFirst_default()(camelCase_default()(paymentMethodLabel)));

    var query = _getOptionSubmissionRequest(params, hasSaveOption, isChequeOrTransferPaymentLabel);

    var handleSuccess = function handleSuccess(response) {
      var _response$bookings, _response$bookings2, _response$bookings3, _response$bookings4;

      var queryParams = _objectSpread({
        bi: (response === null || response === void 0 ? void 0 : (_response$bookings = response.bookings) === null || _response$bookings === void 0 ? void 0 : _response$bookings.bookingId) || '',
        expirationTime: (response === null || response === void 0 ? void 0 : (_response$bookings2 = response.bookings) === null || _response$bookings2 === void 0 ? void 0 : _response$bookings2.expirationDateTime) || '',
        isReliable: response === null || response === void 0 ? void 0 : (_response$bookings3 = response.bookings) === null || _response$bookings3 === void 0 ? void 0 : _response$bookings3.isReliable,
        selectedProposalId: selectedProposalId,
        providerId: providerId,
        productId: productId
      }, hasSaveOption && {
        hasSaveOption: hasSaveOption
      });

      if (withfutureTravelCredits) {
        queryParams.futureTravelCreditOption = true;
      }

      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, queryParams))();
      return {
        isRedirectionPerfomed: false,
        reason: null,
        bookingId: response === null || response === void 0 ? void 0 : (_response$bookings4 = response.bookings) === null || _response$bookings4 === void 0 ? void 0 : _response$bookings4.bookingId
      };
    };

    var handleError = function handleError(error) {
      var status = get_default()(error, 'errors[0].statusCode', statusCode_constants["b" /* STATUS_CODE_400 */]);

      var errorCode = get_default()(error, 'errors[0].errorCode', 'BOOKING_UNAVAILABLE');

      var isBookingInSameTimeOfProposalError = hasSaveOption && errorCode === option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */];
      !hasNoRedirection && !isBookingInSameTimeOfProposalError && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
        status: status,
        error_code: errorCode
      }, {
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
      return {
        isRedirectionPerfomed: false,
        reason: isBookingInSameTimeOfProposalError ? option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */] : null,
        bookingId: null,
        response: null
      };
    };

    return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["Xc" /* PROPOSAL_UPDATE */]
    }).then(handleSuccess)["catch"](handleError);
  };
}

function submitOption(_ref2) {
  var appContext = _ref2.appContext,
      router = _ref2.router,
      hasSaveOption = _ref2.hasSaveOption,
      withfutureTravelCredits = _ref2.withfutureTravelCredits;
  var _router$query = router.query,
      selectedProposalId = _router$query.selectedProposalId,
      productId = _router$query.product;
  return submitOptionFromProposal({
    appContext: appContext,
    selectedProposalId: selectedProposalId,
    productId: productId,
    hasSaveOption: hasSaveOption,
    router: router,
    withfutureTravelCredits: withfutureTravelCredits
  });
}

function renderErrorUpdatingAttendees(_ref3) {
  var errors = _ref3.errors,
      statusCode = _ref3.statusCode;

  if (statusCode && (statusCode === statusCode_constants["f" /* STATUS_CODE_500 */] || statusCode === statusCode_constants["c" /* STATUS_CODE_401 */])) {
    return Object(i18n["h" /* t */])('booking.form.errors.technicalErrorParticipants');
  }

  if (errors === null || errors === void 0 ? void 0 : errors.length) {
    var _errors$;

    var errorCode = errors === null || errors === void 0 ? void 0 : (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.errorCode;
    var cmsErrorKey = "booking.participants.errorMessage.".concat(errorCode);

    if (errorCode && cmsErrorKey !== Object(i18n["h" /* t */])(cmsErrorKey)) {
      return Object(i18n["h" /* t */])(cmsErrorKey);
    }
  }

  return Object(i18n["h" /* t */])('booking.form.errorLabel');
}

function getConcernedAttendees(_ref4) {
  var _errors$2, _errors$3;

  var errors = _ref4.errors;
  return (errors === null || errors === void 0 ? void 0 : (_errors$2 = errors[0]) === null || _errors$2 === void 0 ? void 0 : _errors$2.errorCode) === 'invalidPassportExpirationDate' ? errors === null || errors === void 0 ? void 0 : (_errors$3 = errors[0]) === null || _errors$3 === void 0 ? void 0 : _errors$3.concernedAttendees : [];
}

var getAttendeeId = function getAttendeeId(_ref5) {
  var neolid = _ref5.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref6) {
  var adults = _ref6.adults,
      kids = _ref6.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids && kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_verifyChildrenSiblings = function verifyChildrenSiblings(childBirthdate, connectedUserInfo, siblingsIndexes) {
  var _connectedUserInfo$tr, _connectedUserInfo$tr2;

  var childIndex = connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr === void 0 ? void 0 : _connectedUserInfo$tr.findIndex(function (_ref7, index) {
    var birthdate = _ref7.birthdate;
    return moment_default()(childBirthdate).isSame(birthdate) && !siblingsIndexes.includes(index);
  });

  if (childIndex === undefined || childIndex === -1 || siblingsIndexes.includes(childIndex)) {
    return null;
  }

  siblingsIndexes.push(childIndex);
  return connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr2 = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr2 === void 0 ? void 0 : _connectedUserInfo$tr2[childIndex];
};
var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref8) {
  var bookingProcess = _ref8.bookingProcess,
      adultCivilityDefaultValue = _ref8.adultCivilityDefaultValue,
      childCivilityDefaultValue = _ref8.childCivilityDefaultValue,
      attendees = _ref8.attendees,
      connectedUserInfo = _ref8.connectedUserInfo,
      hasAddress = _ref8.hasAddress,
      locale = _ref8.locale,
      getAttendeeSchema = _ref8.getAttendeeSchema,
      displayParticipantsSelectInput = _ref8.displayParticipantsSelectInput,
      _ref8$preCheckedOptin = _ref8.preCheckedOptins,
      preCheckedOptins = _ref8$preCheckedOptin === void 0 ? {} : _ref8$preCheckedOptin;
  var optins = ContactInfoUtils_getOptinsInfos(bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    var _preCheckedOptins$opt;

    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return Boolean((_preCheckedOptins$opt = preCheckedOptins[optinName]) !== null && _preCheckedOptins$opt !== void 0 ? _preCheckedOptins$opt : optin.preChecked);
  };

  var defaultCountryCode = locale.split('-')[1];

  var getDocumentInfo = function getDocumentInfo(documents, documentType, type, attendeeSchema) {
    var document = documents === null || documents === void 0 ? void 0 : documents[documentType];

    var getFieldDefaultValue = function getFieldDefaultValue(value, schemaFieldName, field) {
      var defaultValue = {}; // should only initialize these values if they exist in the schema V1

      if (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(schemaFieldName);
      })) {
        defaultValue[field] = value || defaultCountryCode;
      }

      return defaultValue;
    };

    var getFieldDefaulDate = function getFieldDefaulDate(value, field) {
      if (value && (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(field);
      }))) {
        return Object(apiDate["e" /* apiDateToTimestamp */])(value);
      }

      return value;
    };

    var issuingDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.issuingDate, 'issuing_date');
    var expirationDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.expirationDate, 'expiration_date');
    var nationality = getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.nationality, 'nationality', 'nationality');
    var issuingCountry = getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.issuingCountry, 'issuing_country', 'issuingCountry');
    var birthCountry = getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.birthCountry, 'birth_country', 'birthCountry');

    var formattedDocument = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, document || {}), nationality), issuingCountry), birthCountry), issuingDate ? {
      issuingDate: issuingDate
    } : {}), expirationDate ? {
      expirationDate: expirationDate
    } : {}); // type is to be sent in Put Attendees should be in [PASSPORT, IDCARD]


    return _objectSpread(_objectSpread({}, formattedDocument), {}, {
      type: type
    });
  };

  var getBirthday = function getBirthday(birthdate) {
    return birthdate && typeof birthdate === 'number' ? birthdate : Object(apiDate["e" /* apiDateToTimestamp */])(birthdate);
  };

  var siblingsIndexes = [];
  var adults = attendees.adults,
      children = attendees.children;
  return {
    adults: adults.map(function (adult, index) {
      var _adult$address;

      return _objectSpread(_objectSpread(_objectSpread({}, adult), {}, {
        attendeeIndex: index,
        civility: displayParticipantsSelectInput && !(connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.isLoggedIn) ? '' : adult.civility || adultCivilityDefaultValue,
        document: {
          passport: getDocumentInfo(adult.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(!!adult.isMain, false)),
          idcard: getDocumentInfo(adult.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(!!adult.isMain, false))
        },
        birthdate: adult.birthdate && getBirthday(adult.birthdate),
        address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, adult.address), {}, {
          countryCode: ((_adult$address = adult.address) === null || _adult$address === void 0 ? void 0 : _adult$address.countryCode) || defaultCountryCode
        }) : undefined
      }, adult.isMain ? {
        optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
        optinSms: getOptinValue(optins.sms, 'optinSms', adult),
        optinMail: getOptinValue(optins.mail, 'optinMail', adult),
        optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
        optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
        optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
        optinsCGU: [],
        checkAll: false
      } : null), {}, {
        mainContactId: !adult.gmNumber && adults[0].neolid ? adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    }),
    children: children.map(function (child, index) {
      var _adults$, _adults$2;

      var childTravelCompanionData = ContactInfoUtils_verifyChildrenSiblings(child.birthdate, connectedUserInfo, siblingsIndexes);
      var childWithInfos = childTravelCompanionData ? {
        birthdate: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.birthdate,
        civility: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.civility,
        document: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.document,
        firstName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.firstName,
        lastName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.lastName,
        unicodeFirstName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.unicodeFirstName,
        unicodeLastName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.unicodeLastName
      } : {};
      return _objectSpread(_objectSpread(_objectSpread({}, child || {}), childWithInfos), {}, {
        attendeeIndex: index,
        civility: (child === null || child === void 0 ? void 0 : child.civility) || childCivilityDefaultValue,
        document: {
          passport: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(false, true)),
          idcard: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(false, true))
        },
        birthdate: child.birthdate && getBirthday(child.birthdate),
        mainContactId: !(child === null || child === void 0 ? void 0 : child.gmNumber) && ((_adults$ = adults[0]) === null || _adults$ === void 0 ? void 0 : _adults$.neolid) ? (_adults$2 = adults[0]) === null || _adults$2 === void 0 ? void 0 : _adults$2.neolid : '0'
      });
    })
  };
};
function getSchemaValidators(schema) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref9$withRequired = _ref9.withRequired,
      withRequired = _ref9$withRequired === void 0 ? true : _ref9$withRequired,
      _ref9$requiredMessage = _ref9.requiredMessage,
      requiredMessage = _ref9$requiredMessage === void 0 ? function (fieldValidation) {
    return Object(i18n["h" /* t */])("booking.participants.errorMessage.".concat(camelCase_default()(fieldValidation.name)));
  } : _ref9$requiredMessage,
      _ref9$messages = _ref9.messages,
      messages = _ref9$messages === void 0 ? {} : _ref9$messages,
      _ref9$isDateType = _ref9.isDateType,
      isDateType = _ref9$isDateType === void 0 ? false : _ref9$isDateType,
      _ref9$isNullable = _ref9.isNullable,
      isNullable = _ref9$isNullable === void 0 ? false : _ref9$isNullable;

  return schema === null || schema === void 0 ? void 0 : schema.reduce(function (addressValidators, fieldValidation) {
    var rule = isDateType ? lib["date"]() : lib["string"]();

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required(requiredMessage(fieldValidation));
      }
    }

    fieldValidation.validators.forEach(function (validator) {
      var _messages$fieldValida;

      var message = messages === null || messages === void 0 ? void 0 : (_messages$fieldValida = messages[fieldValidation.name]) === null || _messages$fieldValida === void 0 ? void 0 : _messages$fieldValida[validator.name];

      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(new RegExp(validator.value), message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooShort', {
            minlength: validator.value
          }));
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooLong', {
            maxlength: validator.value
          }));
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });
    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, isNullable ? rule.nullable() : rule));
  }, {});
}

var getDateSchemaByName = function getDateSchemaByName(attendeeSchema, validatorName) {
  return getSchemaValidators(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.filter(function (_ref10) {
    var name = _ref10.name;
    return name === validatorName;
  }), {
    isDateType: true
  }) || {};
};

var korean = /(\S*[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+\S*)/;
var japanese = /(\S*[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤ヶ]+\S*)/;
var hebrew = /^[\u0590-\u05fe]+$/;
var cyrillic = /(\S*[u0400-\u04FF]+$)/;
var chinese = /(\S*[\u4e00-\u9fff]+$)/;
var thai = /(\S*[\u0E01-\u0E5B]+|[\u1980-\u19DF]+|[\u1950-\u197F]+|[\u1A20-\u1AAF]+|[\uAA80-\uAADF]+$)/;
var asciiWordRegex = /^[\x20-\xFF]+$/; // ASCII

var getNonAsciiNameValidatorByLocale = function getNonAsciiNameValidatorByLocale(locale) {
  switch (locale) {
    case 'ko-KR':
      return korean;

    case 'zh-CN':
    case 'zh-HK':
    case 'zh-TW':
      return chinese;

    case 'ja-JP':
      return japanese;

    case 'ru-RU':
    case 'uk-UA':
    case 'sr-RS':
      return cyrillic;

    case 'he-IL':
      return hebrew;

    case 'th-TH':
      return thai;

    default:
      return asciiWordRegex;
  }
};
var ContactInfoUtils_getValidators = function getValidators(_ref11) {
  var attendeeSchema = _ref11.attendeeSchema,
      addressSchema = _ref11.addressSchema,
      locale = _ref11.locale,
      arrivalDate = _ref11.arrivalDate,
      adultCivilities = _ref11.adultCivilities,
      childCivilities = _ref11.childCivilities; // Validators coming from API, to be merged with local validators

  var addressSchemaValidators = getSchemaValidators(addressSchema, {
    isNullable: true
  }) || {};
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var birthdateValidator = getDateSchemaByName(attendeeSchema, 'birthdate');
  lib["addMethod"](lib["string"], 'asciiNameValidator', function () {
    return this.matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  lib["addMethod"](lib["string"], 'unicodeNameValidator', function () {
    return this.matches(getNonAsciiNameValidatorByLocale(locale), Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')),
    childCivilities: lib["string"]().oneOf(childCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')),
    firstName: (attendeeSchemaValidators.first_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(20).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.firstName')),
    lastName: (attendeeSchemaValidators.last_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(30).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.lastName')),
    unicodeFirstName: (attendeeSchemaValidators.unicode_first_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeFirstName')),
    unicodeLastName: (attendeeSchemaValidators.unicode_last_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeLastName')),
    adultBirthDate: (birthdateValidator.birthdate || lib["date"]()).transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(contact_info_constants["i" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["f" /* MAX_AGE */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(contact_info_constants["i" /* YEAR_OF_MAJORITY */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    email: (attendeeSchemaValidators.email || lib["string"]()).matches(RegexHelper["a" /* emailRegex */], Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.email')),
    mobile: lib["string"]().matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.mobilePhone')),
    healthPassId: (attendeeSchemaValidators.health_pass_id || lib["string"]()).length(10),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')),
    gmNumber: (attendeeSchemaValidators.gm_number || lib["string"]()).required()
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: addressSchemaValidators
  });
};
var ContactInfoUtils_getTravelDocumentsValidators = function getTravelDocumentsValidators(_ref12) {
  var _attendeeSchema$find, _attendeeSchema$find2;

  var attendeeSchema = _ref12.attendeeSchema,
      locale = _ref12.locale,
      departureDate = _ref12.departureDate,
      arrivalDate = _ref12.arrivalDate; // Validators coming from API, to be merged with local validators

  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var idcardExpDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_expiration_date');
  var idcardIssuingDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_issuing_date');
  var passportExpDateValidator = getDateSchemaByName(attendeeSchema, 'passport_expiration_date');
  var passportIssDateValidator = getDateSchemaByName(attendeeSchema, 'passport_issuing_date');
  var isPassportNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref13) {
    var name = _ref13.name;
    return name === 'passport_document_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var isIdCardNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find2 = attendeeSchema.find(function (_ref14) {
    var name = _ref14.name;
    return name === 'idcard_document_number';
  })) === null || _attendeeSchema$find2 === void 0 ? void 0 : _attendeeSchema$find2.required);
  var identityNumberGeneralRule = identityNumberValidator_reducer_identityNumberValidatorReducer(locale, attendeeSchema);
  lib["addMethod"](lib["string"], 'passportNumberRule', function () {
    return this.test('is-passport-required', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
      var trimmedDocNumber = value === null || value === void 0 ? void 0 : value.trim();

      if (trimmedDocNumber) {
        // typed somthing apart from white spaces
        var isValidDocNumber = Boolean(trimmedDocNumber === null || trimmedDocNumber === void 0 ? void 0 : trimmedDocNumber.match(/[a-zA-Z0-9]{6,}$/));
        return isValidDocNumber;
      }

      return !isPassportNumberRequired;
    }).max(30);
  });
  lib["addMethod"](lib["string"], 'idcardNumberRule', function () {
    return this.test('is-idcard-required', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
      var trimmedDocNumber = value === null || value === void 0 ? void 0 : value.trim();

      if (trimmedDocNumber) {
        // typed somthing apart from white spaces
        var isValidDocNumber = Boolean(trimmedDocNumber === null || trimmedDocNumber === void 0 ? void 0 : trimmedDocNumber.match(/[a-zA-Z0-9]{6,}$/));
        return isValidDocNumber;
      }

      return !isIdCardNumberRequired;
    }).max(30);
  });
  lib["addMethod"](lib["date"], 'expirationDateRule', function () {
    return this.transform(function (value, initialValue) {
      // $FlowFixMe ugly but works
      return initialValue ? new Date(moment_default()(initialValue)) : initialValue;
    }).min(moment_default()(departureDate).add(1, 'd'));
  });
  lib["addMethod"](lib["date"], 'issuingDateRule', function () {
    return this.transform(function (value, initialValue) {
      // $FlowFixMe ugly but works
      return initialValue ? new Date(moment_default()(initialValue)) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(1, 'd'));
  });
  var rawValidators = {
    idcardDocumentNumber: (attendeeSchemaValidators.idcard_document_number || lib["string"]()).nullable().idcardNumberRule(),
    passportDocumentNumber: (attendeeSchemaValidators.passport_document_number || lib["string"]()).nullable().passportNumberRule(),
    idcardExpirationDate: (idcardExpDateValidator.idcard_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    passportExpirationDate: (passportExpDateValidator.passport_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    idcardIssuingDate: (idcardIssuingDateValidator.idcard_issuing_date || lib["date"]()).nullable().issuingDateRule(),
    passportIssuingDate: (passportIssDateValidator.passport_issuing_date || lib["date"]()).nullable().issuingDateRule(),
    idcardNationality: (attendeeSchemaValidators.idcard_nationality || lib["string"]()).nullable(),
    passportNationality: (attendeeSchemaValidators.passport_nationality || lib["string"]()).nullable(),
    idcardAuthority: (attendeeSchemaValidators.idcard_authority || lib["string"]()).nullable(),
    passportAuthority: (attendeeSchemaValidators.passport_authority || lib["string"]()).nullable(),
    idcardBirthCountry: (attendeeSchemaValidators.idcard_birth_country || lib["string"]()).nullable(),
    idcardBirthCity: (attendeeSchemaValidators.idcard_birth_city || lib["string"]()).nullable(),
    passportBirthCountry: attendeeSchemaValidators.passport_birth_country || lib["string"](),
    passportBirthCity: (attendeeSchemaValidators.passport_birth_city || lib["string"]()).nullable(),
    identityNumber: attendeeSchemaValidators.identity_number || identityNumberGeneralRule
  }; // $FlowFixMe

  return rawValidators;
};
var ContactInfoUtils_getLegalAgreementValidator = function getLegalAgreementValidator() {
  return lib["mixed"]().oneOf([true]).required();
};
var ContactInfoUtils_getLegalAgreementValidatorMulti = function getLegalAgreementValidatorMulti(requiredIds) {
  return lib["object"]().shape(Object.fromEntries(requiredIds.map(function (id) {
    return [id, lib["object"]({
      optin: lib["boolean"]().oneOf([true]).required(),
      optin_partners: lib["boolean"](),
      channel: lib["string"]()
    })];
  })));
};
var ContactInfoUtils_getSalesmanIdValidator = function getSalesmanIdValidator(_ref15) {
  var attendeeSchema = _ref15.attendeeSchema;
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema);
  return ((attendeeSchemaValidators === null || attendeeSchemaValidators === void 0 ? void 0 : attendeeSchemaValidators.salesman_id) || lib["string"]()).matches(RegexHelper["e" /* salesmanIDRegex */]);
};

function getDocumentsFields(bookingProcess) {
  return legalInformationIds_constants["b" /* DOCUMENT_TYPES */].reduce(function (fields, type) {
    var filteredFields = {
      type: type.toLowerCase(),
      values: bookingProcess.filter(function (field) {
        return field.type === type;
      })
    }; // returns all fields in bookingProcess or TransportBookingProcess with the current type(s)

    filteredFields.values.length > 0 && fields.push(filteredFields);
    return fields;
  }, []);
}

var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultConfigCivilities = Object(domains_service_dist["getAdultsCivilities"])(locale) || [];
  return isEmpty_default()(defaultCivilities) ? adultConfigCivilities : defaultCivilities;
};
var ContactInfoUtils_getChildCivilities = function getChildCivilities(defaultCivilities, locale) {
  var childConfigCivilities = Object(domains_service_dist["getKidsCivilities"])(locale) || [];
  return isEmpty_default()(defaultCivilities) ? childConfigCivilities : defaultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref16) {
  var isMain = _ref16.isMain,
      isChild = _ref16.isChild,
      hasUnicodeFields = _ref16.hasUnicodeFields,
      formValues = _ref16.formValues,
      attendeeIdentifier = _ref16.attendeeIdentifier,
      attendeeIndex = _ref16.attendeeIndex,
      isValid = _ref16.isValid;

  if (hasUnicodeFields && isValid) {
    return "".concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
  }

  var firstName = get_default()(formValues, "".concat(attendeeIdentifier, ".firstName"));

  var lastName = get_default()(formValues, "".concat(attendeeIdentifier, ".lastName"));

  if (!!firstName && !!lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }

  if (isMain) {
    return Object(i18n["h" /* t */])('booking.participants.personnalInfosHeader.title');
  }

  if (isChild) {
    return "".concat(Object(i18n["h" /* t */])('booking.participants.otherKidsInfosHeader.title'), " ").concat(attendeeIndex + 1);
  }

  return "".concat(Object(i18n["h" /* t */])('booking.participants.otherAdultsInfosHeader.title'), " ").concat(attendeeIndex);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref17) {
  var _childTravelCompanion;

  var formInitialValues = _ref17.formInitialValues,
      connectedUserInfo = _ref17.connectedUserInfo,
      attendeeIdentifier = _ref17.attendeeIdentifier,
      fieldName = _ref17.fieldName,
      isMain = _ref17.isMain,
      fieldNameConnectedUserOverride = _ref17.fieldNameConnectedUserOverride,
      _ref17$isChild = _ref17.isChild,
      isChild = _ref17$isChild === void 0 ? false : _ref17$isChild;
  var siblingsIndexes = [];
  var childTravelCompanionData = null;

  if (attendeeIdentifier) {
    var childAttendeeFirstName = get_default()(formInitialValues, "".concat(attendeeIdentifier, ".firstName"));

    if (!childAttendeeFirstName) {
      ContactInfoUtils_verifyChildrenSiblings(Object(apiDate["n" /* timestampToApiDate */])(get_default()(formInitialValues, "".concat(attendeeIdentifier, ".birthdate"))), connectedUserInfo, siblingsIndexes);
    }

    childTravelCompanionData = (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.travelCompanions) && ContactInfoUtils_verifyChildrenSiblings(Object(apiDate["n" /* timestampToApiDate */])(get_default()(formInitialValues, "".concat(attendeeIdentifier, ".birthdate"))), connectedUserInfo, siblingsIndexes);
  }

  return connectedUserInfo && !isChild && isMain && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName]) || isChild && connectedUserInfo && ((_childTravelCompanion = childTravelCompanionData) === null || _childTravelCompanion === void 0 ? void 0 : _childTravelCompanion[fieldName]);
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var _Object$keys;

  var duplicates = attendees === null || attendees === void 0 ? void 0 : attendees.reduce(function (acc, attendee, index) {
    if (attendee) {
      var birthdate = attendee.birthdate,
          lastName = attendee.lastName,
          firstName = attendee.firstName;

      if (birthdate && lastName && firstName) {
        var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

        if (acc[key]) {
          acc[key].push(index);
        } else {
          acc[key] = [index];
        }
      }
    }

    return acc;
  }, {});
  (_Object$keys = Object.keys(duplicates)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (key) {
    var _duplicates$key;

    if ((duplicates === null || duplicates === void 0 ? void 0 : (_duplicates$key = duplicates[key]) === null || _duplicates$key === void 0 ? void 0 : _duplicates$key.length) < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return flatten_default()(Object.values(duplicates));
};

var ContactInfoUtils_generateErrorFieldsObj = function generateErrorFieldsObj(erroredFieldsArray) {
  // Initialize the result object with 'no-error' for each field
  var result = {};

  for (var i = 0; i < Object.keys(contact_info_constants["e" /* FORM_ERROR_OBJECT */]).length; i++) {
    result[i] = 'no-error';
  } // Update the result for selected fields based on the input array


  erroredFieldsArray.forEach(function (field) {
    var key = Object.keys(contact_info_constants["e" /* FORM_ERROR_OBJECT */]).find(function (k) {
      return contact_info_constants["e" /* FORM_ERROR_OBJECT */][k] === field;
    });

    if (key !== undefined) {
      result[key] = field;
    }
  });
  return [result];
};

var ContactInfoUtils_trackAttendeesFormError = function trackAttendeesFormError(trackEvent, formik) {
  var _formik$errors, _formik$errors2;

  var getFields = function getFields(errors) {
    return Object.entries(errors || {}).reduce(function (acc, _ref18) {
      var _ref19 = Object(slicedToArray["a" /* default */])(_ref18, 2),
          key = _ref19[0],
          value = _ref19[1];

      if (isObject_default()(value)) {
        return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(getFields(value)));
      }

      return [].concat(Object(toConsumableArray["a" /* default */])(acc), [key]);
    }, []).sort();
  };

  var trackFormErrors = function trackFormErrors(formName, errors) {
    trackEvent(constants["F" /* TRACK_EVENT_NAMES */].FORM_ERROR, {
      error_status: {
        form_name: formName,
        fields: ContactInfoUtils_generateErrorFieldsObj(getFields(errors))
      }
    });
  };

  var trackForms = function trackForms(prefix) {
    var forms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    forms.forEach(function (errors, i) {
      trackFormErrors("".concat(prefix, "_").concat(i + 1), errors);
    });
  };

  trackForms('adult', (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.adults);
  trackForms('child', (_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.children);
};

var ContactInfoUtils_parseBirthdate = function parseBirthdate(birthdate) {
  if (typeof birthdate === 'string') {
    return moment_default()(birthdate).valueOf();
  }

  return birthdate;
};

var ContactInfoUtils_isChildWillBeAdultByArrivalDate = function isChildWillBeAdultByArrivalDate(childBirthdate, arrivalDate) {
  var childBirthdateValue = ContactInfoUtils_parseBirthdate(childBirthdate);
  var childAge = moment_default()().diff(childBirthdateValue, 'years');
  var childAgeByArrivalDate = moment_default()(arrivalDate).diff(childBirthdateValue, 'years');
  return childAge < 18 && childAgeByArrivalDate >= 18;
};
var ContactInfoUtils_tripInformationToAttendeesList = function tripInformationToAttendeesList(tripInformation) {
  var _tripInformation$kids;

  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(tripInformation.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      isMain: index === 0
    });
  })), Object(toConsumableArray["a" /* default */])(((_tripInformation$kids = tripInformation.kids) === null || _tripInformation$kids === void 0 ? void 0 : _tripInformation$kids.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      isChild: true
    });
  })) || []));
  return {
    adults: attendeesList.filter(function (_ref20) {
      var isChild = _ref20.isChild;
      return !isChild;
    }),
    children: attendeesList.filter(function (_ref21) {
      var isChild = _ref21.isChild;
      return isChild;
    }),
    all: attendeesList.map(function (attendee, index) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        attendeeIndex: Number(index)
      });
    })
  };
};
var ContactInfoUtils_travelCompanionMapper = function travelCompanionMapper(_ref22) {
  var companionId = _ref22.companionId,
      civility = _ref22.civility,
      firstName = _ref22.firstName,
      lastName = _ref22.lastName,
      birthdate = _ref22.birthdate,
      document = _ref22.document,
      mobile = _ref22.mobile,
      email = _ref22.email,
      customerId = _ref22.customerId,
      mainContactId = _ref22.mainContactId,
      isSelected = _ref22.isSelected,
      isChild = _ref22.isChild,
      unicodeFirstName = _ref22.unicodeFirstName,
      unicodeLastName = _ref22.unicodeLastName,
      identityNumber = _ref22.identityNumber;
  return _objectSpread(_objectSpread({
    companionId: companionId,
    civility: civility,
    firstName: firstName,
    lastName: lastName,
    document: document,
    mobile: mobile,
    email: email,
    customerId: customerId,
    mainContactId: mainContactId,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName,
    identityNumber: identityNumber,
    isSelected: isSelected || false
  }, (isChild || dist["attendees"].isKid({
    birthdate: birthdate
  })) && {
    isChild: true
  }), birthdate && {
    birthdate: ContactInfoUtils_parseBirthdate(birthdate)
  });
};
var getNextCharacter = function getNextCharacter(_char) {
  return String.fromCharCode(_char.charCodeAt(0) + 1);
};
var createId = function createId(index, _char2) {
  return String.fromCharCode(_char2.charCodeAt(0) + index);
};
var ContactInfoUtils_getChildrenToAdultsTransferList = function getChildrenToAdultsTransferList(attendeesList, arrivalDate) {
  var adults = attendeesList.adults,
      children = attendeesList.children;

  var toBeAdultFilter = function toBeAdultFilter(_ref23) {
    var birthdate = _ref23.birthdate;
    return birthdate && ContactInfoUtils_isChildWillBeAdultByArrivalDate(birthdate, arrivalDate);
  };

  var indexMap = function indexMap(attendee, index) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      attendeeIndex: Number(index)
    });
  };

  var adultMapper = function adultMapper(_ref24) {
    var id = _ref24.id,
        civility = _ref24.civility,
        firstName = _ref24.firstName,
        lastName = _ref24.lastName,
        birthdate = _ref24.birthdate,
        neolid = _ref24.neolid,
        gmNumber = _ref24.gmNumber;
    return {
      id: id,
      civility: civility,
      firstName: firstName,
      lastName: lastName,
      birthdate: birthdate,
      neolid: neolid,
      gmNumber: gmNumber,
      isMain: false
    };
  }; // Collect existing IDs to avoid duplicates


  var existingIds = new Set(); // First pass: collect all existing IDs

  adults.forEach(function (adult) {
    if (adult.id) {
      existingIds.add(adult.id);
    }
  });
  children.forEach(function (child) {
    if (child.id) {
      existingIds.add(child.id);
    }
  });

  var getNextAvailableId = function getNextAvailableId() {
    var currentChar = 'A';

    for (var i = 0; existingIds.has(currentChar) && i < 26; i++) {
      currentChar = getNextCharacter(currentChar);
    }

    existingIds.add(currentChar);
    return currentChar;
  };

  var adultsList = [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children.filter(toBeAdultFilter).map(adultMapper))).map(function (el) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: el.id || getNextAvailableId()
    });
  });
  var childrenList = children.filter(function (child) {
    return !children.filter(toBeAdultFilter).includes(child);
  }).map(function (el) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: el.id || getNextAvailableId()
    });
  });
  return {
    adultsList: adultsList,
    childrenList: childrenList,
    allList: [].concat(Object(toConsumableArray["a" /* default */])(adultsList.map(indexMap)), Object(toConsumableArray["a" /* default */])(childrenList.map(indexMap)))
  };
};
var compareById = function compareById(a, b) {
  return a.id.localeCompare(b.id);
};
var ContactInfoUtils_compareByBirthdate = function compareByBirthdate(a, b) {
  return moment_default()(a.birthdate).valueOf() - moment_default()(b.birthdate).valueOf();
};
var ContactInfoUtils_getSortedTravelCompanionList = function getSortedTravelCompanionList() {
  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var travelCompanionListWithoutBirthdate = travelCompanionList.filter(function (_ref25) {
    var birthdate = _ref25.birthdate;
    return !birthdate;
  }).map(function (_ref26) {
    var birthdate = _ref26.birthdate,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref26, ["birthdate"]);

    return _objectSpread({}, rest);
  });
  var sortedTravelCompanionList = travelCompanionList.filter(function (_ref27) {
    var birthdate = _ref27.birthdate;
    return birthdate;
  }).sort(ContactInfoUtils_compareByBirthdate);
  return [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionListWithoutBirthdate), Object(toConsumableArray["a" /* default */])(sortedTravelCompanionList)).filter(function (_ref28) {
    var isMain = _ref28.isMain;
    return !isMain;
  }).map(function (travelCompanion, index) {
    return _objectSpread(_objectSpread({}, travelCompanion), {}, {
      companionId: index
    });
  }).map(ContactInfoUtils_travelCompanionMapper);
};
var ContactInfoUtils_filterSearchedChildren = function filterSearchedChildren() {
  var _uniqBy2, _allAttendees$adults;

  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allAttendees = arguments.length > 1 ? arguments[1] : undefined;
  var sortedCompanionsList = ContactInfoUtils_getSortedTravelCompanionList(travelCompanionList);
  var travelCompanionAdultList = sortedCompanionsList.filter(function (_ref29) {
    var isChild = _ref29.isChild;
    return !isChild;
  });
  var travelCompanionChildrenList = sortedCompanionsList.filter(function (_ref30) {
    var isChild = _ref30.isChild;
    return isChild;
  });
  var formattedCompanionChildrenList = (_uniqBy2 = uniqBy_default()(travelCompanionChildrenList, 'birthdate')) === null || _uniqBy2 === void 0 ? void 0 : _uniqBy2.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      birthdate: child.birthdate,
      isChild: true,
      isMain: false
    });
  });
  var selectedCompanionChildrenList = formattedCompanionChildrenList.filter(function (_ref31) {
    var isSelected = _ref31.isSelected;
    return isSelected;
  });
  var firstChildIndex = allAttendees === null || allAttendees === void 0 ? void 0 : (_allAttendees$adults = allAttendees.adults) === null || _allAttendees$adults === void 0 ? void 0 : _allAttendees$adults.length;
  var selectedChildrenIndexes = selectedCompanionChildrenList.map(function (_, i) {
    return {
      index: firstChildIndex + i,
      position: i
    };
  });
  var finalCompanionsList = [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionAdultList), Object(toConsumableArray["a" /* default */])(selectedCompanionChildrenList));
  return {
    travelCompanions: finalCompanionsList,
    selectedIndexes: selectedChildrenIndexes
  };
};
var getFieldErrors = function getFieldErrors(_ref32) {
  var _errors$children, _errors$adults;

  var errors = _ref32.errors,
      index = _ref32.index,
      isChild = _ref32.isChild;
  return isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children = errors.children) === null || _errors$children === void 0 ? void 0 : _errors$children[index] : errors === null || errors === void 0 ? void 0 : (_errors$adults = errors.adults) === null || _errors$adults === void 0 ? void 0 : _errors$adults[index];
};

var isLetter = function isLetter(_char3) {
  return !!((_char3 === null || _char3 === void 0 ? void 0 : _char3.length) === 1 && (_char3 === null || _char3 === void 0 ? void 0 : _char3.match(/[a-z]/i)));
};

var findAlphabetIndex = function findAlphabetIndex(_char4) {
  var base = 'a'.charCodeAt(0);
  return isLetter(_char4) ? _char4.toLowerCase().charCodeAt(0) - base : 0;
};
var setTravelCompanionBlockFormErrors = function setTravelCompanionBlockFormErrors(_ref33) {
  var _errors$children2, _errors$adults2;

  var errors = _ref33.errors,
      isChild = _ref33.isChild,
      travelCompanionIndex = _ref33.travelCompanionIndex,
      setFieldTouched = _ref33.setFieldTouched;
  var fieldErrors = isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children2 = errors.children) === null || _errors$children2 === void 0 ? void 0 : _errors$children2[travelCompanionIndex] : errors === null || errors === void 0 ? void 0 : (_errors$adults2 = errors.adults) === null || _errors$adults2 === void 0 ? void 0 : _errors$adults2[travelCompanionIndex];
  var fieldErrorNames = fieldErrors ? Object.keys(fieldErrors) : [];
  fieldErrorNames.forEach(function (fieldErrorName) {
    setFieldTouched("".concat(isChild ? 'children' : 'adults', "[").concat(travelCompanionIndex, "].").concat(fieldErrorName), true);
  });
};
var getTravelCompanionInfos = function getTravelCompanionInfos(_ref34) {
  var travelCompanionSelector = _ref34.travelCompanionSelector,
      isChild = _ref34.isChild,
      parentIndex = _ref34.parentIndex;
  var travelCompanionAdultList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return !travelCompanion.isChild;
  }); // $FlowFixMe

  var travelCompanionChildrenList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return travelCompanion.isChild;
  });
  var travelCompanionList = isChild ? travelCompanionChildrenList : travelCompanionAdultList;
  var hasSelectedTravelCompanion = !!travelCompanionList.find(function (_ref35) {
    var isSelected = _ref35.isSelected;
    return isSelected;
  });
  var hasParentIndexInSelectedIndexes = travelCompanionSelector.selectedIndexes.some(function (indexes) {
    return indexes.index === parentIndex;
  });
  return {
    travelCompanionList: travelCompanionList,
    hasParentIndexInSelectedIndexes: hasParentIndexInSelectedIndexes,
    isDisabled: hasSelectedTravelCompanion && hasParentIndexInSelectedIndexes
  };
};
var ContactInfoUtils_setTravelCompanionField = function setTravelCompanionField(_ref36) {
  var _values$adults, _values$children;

  var travelCompanion = _ref36.travelCompanion,
      isChild = _ref36.isChild,
      parentIndex = _ref36.parentIndex,
      values = _ref36.values,
      setFieldValue = _ref36.setFieldValue,
      attendeeIdentifier = _ref36.attendeeIdentifier; // Collect all existing IDs to avoid duplicates, excluding the current participant being edited

  var existingIds = new Set();
  (_values$adults = values.adults) === null || _values$adults === void 0 ? void 0 : _values$adults.forEach(function (adult, index) {
    // Exclude the current participant if it's an adult
    if (adult.id && !(index === parentIndex && !isChild)) {
      existingIds.add(adult.id);
    }
  });
  (_values$children = values.children) === null || _values$children === void 0 ? void 0 : _values$children.forEach(function (child, index) {
    // Exclude the current participant if it's a child
    if (child.id && !(index === parentIndex && isChild)) {
      existingIds.add(child.id);
    }
  }); // Find the first available ID starting from 'A'

  var newId = 'A';

  for (var i = 0; existingIds.has(newId) && i < 26; i++) {
    newId = getNextCharacter(newId);
  }

  var fieldObject = _objectSpread(_objectSpread({}, travelCompanion), {}, {
    // Here we create the actual id that will be in sync with number of fields we have in the form
    id: newId,
    mainContactId: values.adults[0].mainContactId,
    birthdate: moment_default()(travelCompanion === null || travelCompanion === void 0 ? void 0 : travelCompanion.birthdate),
    customerId: '',
    attendeeIndex: parentIndex
  }, !isChild && {
    isMain: false
  });

  return setFieldValue(attendeeIdentifier, fieldObject);
};

var ContactInfoUtils_getHouseholdsAttendees = function getHouseholdsAttendees(householdsList) {
  var tempAttendees = [];
  householdsList.forEach(function (_ref37) {
    var adults = _ref37.adults,
        children = _ref37.children;
    var mainAdultsInCurrentHousehold = adults.filter(function (attendee) {
      return attendee === null || attendee === void 0 ? void 0 : attendee.isMain;
    }).length;

    var newAdults = Object(toConsumableArray["a" /* default */])(adults); // if the Main adult was selected else where; redefine a new main adult in the current household


    if (adults.length && mainAdultsInCurrentHousehold === 0) {
      newAdults = newAdults.map(function (adult, index) {
        return _objectSpread(_objectSpread({}, adult), {}, {
          isMain: index === 0
        });
      });
    }

    tempAttendees = [].concat(Object(toConsumableArray["a" /* default */])(tempAttendees), Object(toConsumableArray["a" /* default */])(newAdults), Object(toConsumableArray["a" /* default */])(children));
  });
  return tempAttendees.sort(function (a, b) {
    if (a.id < b.id) {
      return -1;
    }

    if (a.id > b.id) {
      return 1;
    }

    return 0;
  });
};

var setErrorsForConcernedAttendees = function setErrorsForConcernedAttendees(_ref38) {
  var _proposalAttendees$ad, _proposalAttendees$ch;

  var concernedAttendees = _ref38.concernedAttendees,
      proposalAttendees = _ref38.proposalAttendees,
      errors = _ref38.errors,
      fieldsOnError = _ref38.fieldsOnError;

  var updatedErrors = _objectSpread({}, errors);

  (_proposalAttendees$ad = proposalAttendees.adults) === null || _proposalAttendees$ad === void 0 ? void 0 : _proposalAttendees$ad.forEach(function (adult, index) {
    if (concernedAttendees.includes(adult.id)) {
      updatedErrors.adults[index] = _objectSpread(_objectSpread({}, updatedErrors.adults[index]), fieldsOnError);
    }
  });
  (_proposalAttendees$ch = proposalAttendees.children) === null || _proposalAttendees$ch === void 0 ? void 0 : _proposalAttendees$ch.forEach(function (child, index) {
    if (concernedAttendees.includes(child.id)) {
      updatedErrors.children[index] = _objectSpread(_objectSpread({}, updatedErrors.children[index]), fieldsOnError);
    }
  });
  return updatedErrors;
};

var ContactInfoUtils_handleSetErrorsForConcernedAttendees = function handleSetErrorsForConcernedAttendees(_ref39) {
  var concernedAttendees = _ref39.concernedAttendees,
      proposalAttendees = _ref39.proposalAttendees,
      setErrors = _ref39.setErrors;

  if ((concernedAttendees === null || concernedAttendees === void 0 ? void 0 : concernedAttendees.length) > 0) {
    var _proposalAttendees$ad2, _proposalAttendees$ch2;

    var fieldsOnError = {
      document: {
        passport: {
          expirationDate: Object(i18n["h" /* t */])('booking.participants.errorMessage.invalidPassportExpirationDate')
        }
      }
    };
    var errors = {
      adults: Array((_proposalAttendees$ad2 = proposalAttendees.adults) === null || _proposalAttendees$ad2 === void 0 ? void 0 : _proposalAttendees$ad2.length).fill(null),
      children: Array(((_proposalAttendees$ch2 = proposalAttendees.children) === null || _proposalAttendees$ch2 === void 0 ? void 0 : _proposalAttendees$ch2.length) || 0).fill(null)
    };
    var updatedErrors = setErrorsForConcernedAttendees({
      concernedAttendees: concernedAttendees,
      proposalAttendees: proposalAttendees,
      errors: errors,
      fieldsOnError: fieldsOnError
    });
    setErrors(updatedErrors);
  }
};



/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js




var themes = {
  "default": function _default(_ref) {
    var _classnames;

    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
        isAccordion = _ref.isAccordion,
        isActive = _ref.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex font-bold font-sans gap-5 items-center px-20 py-10 rounded-pill text-16 text-black transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "border-1 border-".concat(color), isAccordion), Object(defineProperty["a" /* default */])(_classnames, "bg-white hocus:bg-".concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  simple: function simple(_ref2) {
    var _classnames2;

    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref2$color,
        isActive = _ref2.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex font-bold font-sans gap-5 items-center p-10 rounded-12 text-12 text-center transition-colors duration-250 ease-in uppercase', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "bg-white hocus:bg-".concat(color, " border-lightGrey hocus:border-").concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames2, "arrow-down arrow-".concat(color, " bg-").concat(color, " border-").concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames2)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  underlined: function underlined(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref3$color,
        isActive = _ref3.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-b-2 border-current flex font-bold gap-5 h-full items-center overflow-hidden shrink-0 text-16', Object(defineProperty["a" /* default */])({
        'text-mediumGrey': !isActive
      }, "text-".concat(color), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  rounded: function rounded(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref4$color,
        isActive = _ref4.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 border-lightGrey flex gap-5 items-center overflow-hidden rounded-t-12', Object(defineProperty["a" /* default */])({
        'bg-pearl': !isActive
      }, "arrow-down-top arrow-".concat(color, " bg-white border-b-0"), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  flat: function flat(_ref5) {
    var isActive = _ref5.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex h-full items-center p-10 md:px-20 rounded-2 transition-colors duration-250 ease-in', {
        'bg-pearl': !isActive,
        'bg-white border-b-0': isActive
      }),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isActive && trackingData ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  var _themes$theme = themes[theme](props),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track();
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: style,
    tabIndex: tabIndex,
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children);
});

/***/ }),

/***/ "ZQ8D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerLogin; });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e0Ti");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Ub5k");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("DqI1");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nv//");
var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var CustomerLogin = function CustomerLogin(_ref) {
  var hasLoginButton = _ref.hasLoginButton,
      hasUser = _ref.hasUser,
      _ref$labels = _ref.labels,
      memberSpace = _ref$labels.memberSpace,
      memberSpaceTitle = _ref$labels.memberSpaceTitle,
      labelCTA = _ref$labels.labelCTA;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_5__[/* useAppContext */ "c"])(),
      locale = _useAppContext.locale,
      originalUrl = _useAppContext.originalUrl;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_0__["useRouter"])(),
      asPath = _useRouter.asPath;

  var origin = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_9__[/* convertUrlToOrigin */ "c"])(originalUrl);
  var redirectUri = origin + asPath;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_7__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (!hasLoginButton || hasUser) {
    return null;
  }

  return __jsx("div", {
    "data-testid": "CustomerLogin",
    className: "mb-20 h-full rounded-16 border-1 border-lightGrey bg-white p-20"
  }, __jsx("div", {
    className: "block items-center justify-between md:flex"
  }, __jsx("div", {
    className: "mb-20 flex items-start gap-20 md:mb-0"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_2__[/* Badge */ "a"], {
    className: "size-48 border-black bg-black text-white",
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PEOPLE,
    variant: "pill"
  }), __jsx("div", {
    className: "text-start"
  }, __jsx("p", {
    className: "text-20 font-semibold leading-normal"
  }, memberSpaceTitle), __jsx("p", {
    className: "mt-4 text-14 leading-normal"
  }, memberSpace))), __jsx("div", {
    className: "flex w-full justify-center md:w-1/3 md:justify-end"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "a"], {
    "data-testid": "prebooking-form-login",
    className: "text-center",
    isExternalLink: true,
    onClick: function onClick() {
      return trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_6__[/* TRACK_EVENT_NAMES */ "F"].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'login_to_my_space'
      });
    },
    url: _utils_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSigninUrl */ "f"]({
      locale: locale,
      redirectUri: redirectUri,
      previousUri: redirectUri
    })
  }, labelCTA))));
};

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tuzA");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EkOT");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? '' : _ref$rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.buttonLabel');

  var _getRateMessagesPrope = Object(_rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_8__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle; // Display text only in product Thumbnails popin


  var rateObject = onClick ? {
    rateContent: rateContent,
    rateTitle: rateTitle
  } : {};
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    className: "p-20",
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.roomAvailability'), rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateTitle, rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateContent].join(' '),
    theme: "text-sans-n2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-lightGrey p-20"
  }, isAllInclusive && __jsx("p", {
    className: "flex max-w-full flex-col gap-5 text-center text-12 text-black sm:flex-row sm:flex-wrap sm:items-center sm:justify-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "flex items-center gap-5 font-brand text-16 text-sienna"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "text-sienna",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "-mt-5 text-blueWave",
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], {
    className: "mt-10",
    "data-testid": "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZVqJ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var apply = __webpack_require__("KXRF");
var bind = __webpack_require__("C56r");
var aConstructor = __webpack_require__("jCye");
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var fails = __webpack_require__("fhLv");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "Zk8D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}

/***/ }),

/***/ "Znn2":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("ep/x");
var definePropertiesModule = __webpack_require__("HKx7");
var enumBugKeys = __webpack_require__("WSQK");
var hiddenKeys = __webpack_require__("qXr/");
var html = __webpack_require__("QknU");
var documentCreateElement = __webpack_require__("a4SZ");
var sharedKey = __webpack_require__("mmil");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "ZoVA":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js

var themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse relative',
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-1 overflow-hidden px-5 p").concat(orientation === 'top' ? 't' : 'b', "-5 text-center whitespace-nowrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: Object(classnames_utils["a" /* classnames */])('fill-current', "text-".concat(color), className),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].LIGHT_GREY : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('-scale-x-1 transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)));
};

/***/ }),

/***/ "ZuH9":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var call = __webpack_require__("we+H");
var anObject = __webpack_require__("ep/x");
var tryToString = __webpack_require__("xS1b");
var isArrayIteratorMethod = __webpack_require__("zcYo");
var lengthOfArrayLike = __webpack_require__("XhyO");
var isPrototypeOf = __webpack_require__("VXxY");
var getIterator = __webpack_require__("cUh7");
var getIteratorMethod = __webpack_require__("MU85");
var iteratorClose = __webpack_require__("yUod");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "a4SZ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "aJtP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  // eslint-disable-next-line no-self-compare
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;
/* src: https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js */

/***/ }),

/***/ "aURW":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "aWOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ isUpsellBooked; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ bookingUtils_getFlatUpsells; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ hasSomeActivityBooked; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getTransferFromAccessId; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ hasSomeUpsellsPartiallyRented; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ hasSomeUpsellsAlreadyPaid; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ hasAllUpsellsPaid; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ bookingUtils_hasFreeDepositEnabled; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ isOptionBooking; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ doNotHaveValidStay; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ bookingUtils_getStayAccommodation; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ bookingUtils_getCGVFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ bookingUtils_getHealthRegulationsFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ bookingUtils_tAlt; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bookingUtils_getActivityTypeName; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bookingUtils_getBookingEngineUrl; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ bookingUtils_getShoppingUrl; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ bookingUtils_getOptionById; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ isOptionAboutToExpire; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ bookingUtils_getStaffChief; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ bookingUtils_getStaffCategories; });

// UNUSED EXPORTS: hasSomeUpsellsInCartOrPaid, isEasyArrivalEnabled, hasStayTransport

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("+2Ph");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var constants = __webpack_require__("54uq");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var booking_process_constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/utils/legacy-booking-engine/legacyBookingUrlBuilder.js





/* eslint-disable flowtype/no-weak-types */



function buildProposalUrl(_ref) {
  var productId = _ref.productId,
      proposalId = _ref.proposalId,
      currentUri = _ref.currentUri,
      fromSearches = _ref.fromSearches;
  var redirectionQueryParameters = {
    proposalIds: proposalId,
    selectedProposalId: proposalId,
    product: productId,
    coderesort: productId,
    fromSearches: fromSearches
  };
  var uri = new URI_default.a(currentUri);
  var queryParams = URI_default.a.parseQuery(uri.search());

  if (queryParams.locale) {
    // $FlowFixMe
    redirectionQueryParameters.locale = queryParams.locale;
  }

  return uri.segment([config_default.a.get('booking.endpoints.responsive')]).query(redirectionQueryParameters).toString();
}

function buildUrlFromContextNumber(formData, appContext, currentUri) {
  return buildProposalUrl({
    appContext: appContext,
    productId: formData.resortId,
    proposalId: formData.reference,
    fromSearches: formData.fromSearches,
    currentUri: currentUri
  });
}


// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/views/account/dashboard/DashboardView.queries.js
var DashboardView_queries = __webpack_require__("+M7m");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingUtils.js























/* eslint-disable camelcase */

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



















var BOOKING_STATUSES = dist["constants"].BOOKING_STATUSES,
    PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var BOOKING_STATUS_EXPIRED_OPTION = BOOKING_STATUSES.BOOKING_STATUS_EXPIRED_OPTION,
    BOOKING_STATUS_OPTION = BOOKING_STATUSES.BOOKING_STATUS_OPTION;
var isUpsellBooked = function isUpsellBooked(upsell) {
  var _upsell$pricingInfo, _upsell$pricingInfo2, _upsell$pricingInfo3;

  return Boolean((upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo = upsell.pricingInfo) === null || _upsell$pricingInfo === void 0 ? void 0 : _upsell$pricingInfo.isPartiallyRented) || (upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo2 = upsell.pricingInfo) === null || _upsell$pricingInfo2 === void 0 ? void 0 : _upsell$pricingInfo2.isPartiallyPaid) || (upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo3 = upsell.pricingInfo) === null || _upsell$pricingInfo3 === void 0 ? void 0 : _upsell$pricingInfo3.isFullyPaid));
};
var bookingUtils_getFlatUpsells = function getFlatUpsells(stay) {
  // $FlowFixMe
  return Object.values((stay === null || stay === void 0 ? void 0 : stay.upsells) || {}).reduce(function (acc, items) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(items));
  }, []);
};
var hasSomeActivityBooked = function hasSomeActivityBooked(category) {
  var _category$activities, _category$categories;

  var hasSomeBooked = false;

  if ((_category$activities = category.activities) === null || _category$activities === void 0 ? void 0 : _category$activities.length) {
    hasSomeBooked = category.activities.some(function (_ref) {
      var additionalService = _ref.additionalService;
      return isUpsellBooked(additionalService);
    });
  }

  if (((_category$categories = category.categories) === null || _category$categories === void 0 ? void 0 : _category$categories.length) && !hasSomeBooked) {
    hasSomeBooked = category.categories.some(function (cat) {
      return hasSomeActivityBooked(cat);
    });
  }

  return hasSomeBooked;
};
var getTransferFromAccessId = function getTransferFromAccessId(transfers, accessId) {
  return transfers.find(function (trans) {
    var _trans$access;

    return ((_trans$access = trans.access) === null || _trans$access === void 0 ? void 0 : _trans$access.id) === accessId && Number(trans.duration) > 0 && !trans.id.includes('MICE_');
  });
};
var hasSomeUpsellsPartiallyRented = function hasSomeUpsellsPartiallyRented(upsells) {
  return (upsells || []).some(function (_ref2) {
    var _ref2$pricingInfo = _ref2.pricingInfo,
        pricingInfo = _ref2$pricingInfo === void 0 ? {} : _ref2$pricingInfo;
    return pricingInfo.isPartiallyRented;
  });
};
var hasSomeUpsellsAlreadyPaid = function hasSomeUpsellsAlreadyPaid(upsells) {
  return (upsells || []).some(function (_ref3) {
    var _ref3$pricingInfo = _ref3.pricingInfo,
        pricingInfo = _ref3$pricingInfo === void 0 ? {} : _ref3$pricingInfo;
    return pricingInfo.isFullyPaid || pricingInfo.isPartiallyPaid;
  });
};
var hasSomeUpsellsInCartOrPaid = function hasSomeUpsellsInCartOrPaid(upsells) {
  return (upsells || []).some(function (_ref4) {
    var _ref4$pricingInfo = _ref4.pricingInfo,
        pricingInfo = _ref4$pricingInfo === void 0 ? {} : _ref4$pricingInfo;
    return pricingInfo.isPartiallyRented || pricingInfo.isPartiallyPaid || pricingInfo.isFullyPaid;
  });
};
var hasAllUpsellsPaid = function hasAllUpsellsPaid(upsells) {
  if (!(upsells === null || upsells === void 0 ? void 0 : upsells.length)) {
    return false;
  }

  return upsells.every(function (_ref5) {
    var _ref5$pricingInfo = _ref5.pricingInfo,
        pricingInfo = _ref5$pricingInfo === void 0 ? {} : _ref5$pricingInfo;
    return pricingInfo.isFullyPaid;
  });
};
var bookingUtils_isEasyArrivalEnabled = function isEasyArrivalEnabled(formalities, product) {
  var _formalities$easyArri;

  return !product.isJoyview && [constants["b" /* API_AVAILABLE */], constants["c" /* API_DONE */]].includes(formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri = formalities.easyArrival) === null || _formalities$easyArri === void 0 ? void 0 : _formalities$easyArri.status);
};
var bookingUtils_hasFreeDepositEnabled = function hasFreeDepositEnabled(b, appContext) {
  var _b$paymentDetails, _b$paymentDetails$due, _b$paymentDetails$due2, _b$paymentDetails2, _b$paymentDetails2$du, _b$information, _b$information$stays, _b$information$stays$;

  return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.banking.enableFreeDeposit') && (((_b$paymentDetails = b.paymentDetails) === null || _b$paymentDetails === void 0 ? void 0 : (_b$paymentDetails$due = _b$paymentDetails.duePayment) === null || _b$paymentDetails$due === void 0 ? void 0 : (_b$paymentDetails$due2 = _b$paymentDetails$due.amount) === null || _b$paymentDetails$due2 === void 0 ? void 0 : _b$paymentDetails$due2.value) || 0) > 0 && (appContext.freeDepositDeadline === 999 ? moment_default()((_b$paymentDetails2 = b.paymentDetails) === null || _b$paymentDetails2 === void 0 ? void 0 : (_b$paymentDetails2$du = _b$paymentDetails2.duePayment) === null || _b$paymentDetails2$du === void 0 ? void 0 : _b$paymentDetails2$du.deadline, apiDate["a" /* API_DATE_FORMAT */]).diff(moment_default()()) > 0 : moment_default()((_b$information = b.information) === null || _b$information === void 0 ? void 0 : (_b$information$stays = _b$information.stays) === null || _b$information$stays === void 0 ? void 0 : (_b$information$stays$ = _b$information$stays[0]) === null || _b$information$stays$ === void 0 ? void 0 : _b$information$stays$.departureDate, apiDate["a" /* API_DATE_FORMAT */]).subtract(appContext.freeDepositDeadline, 'day').diff(moment_default()()) > 0);
};
var isOptionBooking = function isOptionBooking(status) {
  return [BOOKING_STATUS_OPTION, BOOKING_STATUS_EXPIRED_OPTION].includes(status);
};
var doNotHaveValidStay = function doNotHaveValidStay(booking) {
  return booking && (((booking === null || booking === void 0 ? void 0 : booking.stays) || []).length === 0 || ((booking === null || booking === void 0 ? void 0 : booking.stays) || []).every(function (stay) {
    return !stay.product;
  }));
};
var bookingUtils_getStayAccommodation = function getStayAccommodation(accommodations, product, streetViews) {
  return accommodations ? Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
    accommodations: accommodations,
    accommodationsCount: accommodations.length || 0,
    attendeesWithDistributionData: [],
    product: product,
    proposal: null,
    remainingStock: accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] + 1,
    streetViews: streetViews !== null && streetViews !== void 0 ? streetViews : []
  }) : {};
};
var bookingUtils_getCGVFromLegalInfos = function getCGVFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["b" /* LEGAL_INFO_CGV_ID */];
  }) || {
    label: ''
  };
};
var bookingUtils_getHealthRegulationsFromLegalInfos = function getHealthRegulationsFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["a" /* HEALTH_REGULATION */];
  }) || null;
};
var bookingUtils_tAlt = function tAlt(_ref6) {
  var cruiseKeyPath = _ref6.cruiseKeyPath,
      product = _ref6.product,
      resortKeyPath = _ref6.resortKeyPath,
      variables = _ref6.variables;
  return Object(i18n["h" /* t */])((product === null || product === void 0 ? void 0 : product.type) === PRODUCT_TYPES.CRUISE ? cruiseKeyPath : resortKeyPath, variables);
};
var bookingUtils_getActivityTypeName = function getActivityTypeName(type) {
  return Object(string_util["c" /* snakeToCamel */])(type.toLowerCase().replace('rental', 'ski'));
};
var bookingUtils_getBookingEngineUrl = function getBookingEngineUrl(appContext, bookingId, productId, currentUri) {
  var params = {
    reference: bookingId,
    resortId: productId,
    fromSearches: 'true'
  };
  return buildUrlFromContextNumber(params, appContext, currentUri);
};
var bookingUtils_getShoppingUrl = function getShoppingUrl(stay) {
  var _stay$transport, _participants$childre, _objectSpread2;

  var dates = stay.dates,
      participants = stay.participants,
      product = stay.product;
  var departureCity = (_stay$transport = stay.transport) === null || _stay$transport === void 0 ? void 0 : _stay$transport.fromCityCode;
  return new URI_default.a(product.href).setQuery(_objectSpread(_objectSpread({}, (_objectSpread2 = {}, Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["g" /* QUERY_DEPARTURE_DATE */], dates.startDate && Object(apiDate["j" /* momentFromApiDate */])(dates.startDate).format(uri_constants["f" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["h" /* QUERY_DURATION */], Object(apiDate["j" /* momentFromApiDate */])(dates.endDate).diff(Object(apiDate["j" /* momentFromApiDate */])(dates.startDate), 'days')), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["j" /* QUERY_KIDS */], ((_participants$childre = participants.children) === null || _participants$childre === void 0 ? void 0 : _participants$childre.length) > 0 && Object(facetingUtils["o" /* serializeKidsToQueryParam */])({
    kids: participants.children,
    kidsValidationState: []
  }) || undefined), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["l" /* QUERY_NUMBER_OF_ADULTS */], participants.adultsCount), _objectSpread2)), !!departureCity && Object(defineProperty["a" /* default */])({}, uri_constants["m" /* QUERY_TRANSPORT */], departureCity)));
};
var bookingUtils_getOptionById = function getOptionById(appContext, bookingId) {
  return graphqlClient["a" /* default */].runNoCacheQuery(Object(DashboardView_queries["c" /* getOptionByIdQuery */])(bookingId, appContext), appContext, {
    requestName: requestDictionary["k" /* CUSTOMER_ACCOUNT_GET_BOOKING_DATA */],
    strictErrors: false
  });
};
var isOptionAboutToExpire = function isOptionAboutToExpire(optionDateTimeEnd) {
  return optionDateTimeEnd ? optionDateTimeEnd - 3600000 * 1
  /* 1h */
  <= new Date().valueOf() : false;
};
var bookingUtils_getStaffChief = function getStaffChief() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return staff.find(function (_ref8) {
    var _ref8$categories = _ref8.categories,
        categories = _ref8$categories === void 0 ? [] : _ref8$categories;
    return categories.some(function (_ref9) {
      var code = _ref9.code,
          label = _ref9.label;
      return [code, label].includes(booking_constants["s" /* STAFF_CHIEF_CODE */]);
    });
  }) || staff[0];
};
var bookingUtils_getStaffCategories = function getStaffCategories() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (// $FlowFixMe
    sortBy_default()(uniqBy_default()(staff.reduce(function (acc, s) {
      return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(s.categories));
    }, []).map(function (_ref10) {
      var code = _ref10.code,
          label = _ref10.label;
      return {
        label: label,
        value: code
      };
    }), 'value'), ['label'])
  );
};
var hasStayTransport = function hasStayTransport(stay) {
  var _ref11 = (stay === null || stay === void 0 ? void 0 : stay.transport) || {},
      _ref11$inbounds = _ref11.inbounds,
      inbounds = _ref11$inbounds === void 0 ? [] : _ref11$inbounds,
      _ref11$outbounds = _ref11.outbounds,
      outbounds = _ref11$outbounds === void 0 ? [] : _ref11$outbounds,
      type = _ref11.type;

  var hasTransport = inbounds.length > 0 || outbounds.length > 0 || !!type;
  return hasTransport;
};

/***/ }),

/***/ "aXF+":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("7BVm");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "aeo5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};


/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "b86L":
/***/ (function(module, exports) {

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "bGCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getProductUrlFromDestinationLine; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Product_mapper_getProductProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Product_mapper_getProductPriceInfoProps; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ setProductHref; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ Product_mapper_updateProductUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_mapper_createProductUrlWithParams; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ updateProduct; });

// UNUSED EXPORTS: getProductTags, getProductOfferDiscountProps, getProductChildcareAvailabilitiesProps, getProductComparisonProps, getProductFlagProps, getProductHeaderProps, getProductPriceProps, getProductThumbnailProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// CONCATENATED MODULE: ./src/client/components/widgets/products-comparison/ProductsComparisonUtils.js



function getAggregateDiscount(product) {
  var proposals = get_default()(product, 'proposals.proposals', []);

  var selectedProposal = proposals.find(function (proposal) {
    return get_default()(proposal, 'selected', true);
  });
  return get_default()(selectedProposal, 'price.aggregateDiscount', null);
}


// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.mapper.js






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var DEFAULT_COMPARISON = {
  isDisabled: false,
  isSelected: false
};

var getSubTitle = function getSubTitle(product) {
  var _product$destination;

  if (product.isCruise) {
    return product.timingDescription;
  }

  return ((_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || '';
};

var Product_mapper_getUrl = function getUrl(href, termsAndConditions) {
  var _termsAndConditions$d;

  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var departureDate = "".concat((termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.departureDate) || '');
  var url = new URI_default.a(href).setQuery({
    locale: queryParams === null || queryParams === void 0 ? void 0 : queryParams.locale,
    departure_city: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : (_termsAndConditions$d = termsAndConditions.departureCity) === null || _termsAndConditions$d === void 0 ? void 0 : _termsAndConditions$d.value,
    duration: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.duration,
    date: departureDate !== 'null' && departureDate ? Object(apiDate["g" /* formatApiDate */])(departureDate, constants["f" /* QUERY_DATE_FORMAT */]) : undefined
  });
  return url.toString();
};

var getProductUrl = function getProductUrl(props) {
  var _props$product$price;

  var isMice = !!props.product.mice;

  if (!props.contextualizeUrl) {
    return "".concat(isMice ? '/me' : '').concat(props.product.href);
  }

  var url = Product_mapper_getUrl(props.product.href, ((_props$product$price = props.product.price) === null || _props$product$price === void 0 ? void 0 : _props$product$price.termsAndConditions) || {});
  return "".concat(isMice ? '/me' : '').concat(url);
};

var getProductUrlFromDestinationLine = function getProductUrlFromDestinationLine(price, queryParams) {
  return Product_mapper_getUrl(price.productHref || '', price.termsAndConditions, queryParams);
};

var getProductHeaderProps = function getProductHeaderProps(props) {
  var product = props.product;
  var link = {
    url: getProductUrl(props)
  };
  var heading = {
    title: product.name,
    subtitle: getSubTitle(product)
  };
  return {
    heading: heading,
    link: link
  };
};

var Product_mapper_getProductComparisonProps = function getProductComparisonProps(_ref) {
  var _config$faceting;

  var _ref$comparison = _ref.comparison,
      comparison = _ref$comparison === void 0 ? DEFAULT_COMPARISON : _ref$comparison,
      config = _ref.config,
      product = _ref.product;

  var _ref2 = (config === null || config === void 0 ? void 0 : (_config$faceting = config.faceting) === null || _config$faceting === void 0 ? void 0 : _config$faceting.compare) || {},
      selected = _ref2.selected,
      selectResort = _ref2.selectResort,
      unavailableThumbnail = _ref2.unavailableThumbnail;

  var status = product_utils["b" /* IS_ENABLED */];

  if (comparison.isDisabled) {
    status = product_utils["a" /* IS_DISABLED */];
  } else if (comparison.isSelected) {
    status = product_utils["c" /* IS_SELECTED */];
  }

  var label = comparison.isSelected ? selected : selectResort;

  var _ref3 = product || {},
      isCruise = _ref3.isCruise,
      isTour = _ref3.isTour;

  return {
    status: status,
    label: label,
    isEligible: !isTour && !isCruise,
    eligibilityLabel: unavailableThumbnail
  };
};

var Product_mapper_getProductPriceProps = function getProductPriceProps(_ref4) {
  var _config$price;

  var config = _ref4.config,
      product = _ref4.product,
      _ref4$offer = _ref4.offer,
      offer = _ref4$offer === void 0 ? {} : _ref4$offer;
  var color = product.isJoyview ? colors["a" /* COLORS */].BLUE_WAVE : colors["a" /* COLORS */].SIENNA; // $FlowFixMe

  return _objectSpread(_objectSpread({
    style: {
      color: offer.color
    },
    color: offer.color || color
  }, (config === null || config === void 0 ? void 0 : (_config$price = config.price) === null || _config$price === void 0 ? void 0 : _config$price.format) || {}), product.price || product.mice || {});
};

var getChildCareAgeInMonths = function getChildCareAgeInMonths(_ref5) {
  var _product$childcareDet;

  var product = _ref5.product;

  if ((_product$childcareDet = product.childcareDetails) === null || _product$childcareDet === void 0 ? void 0 : _product$childcareDet.length) {
    return product.childcareDetails.map(function (_ref6) {
      var ageInMonths = _ref6.ageInMonths;
      return {
        ageInMonthsMin: ageInMonths.min,
        ageInMonthsMax: ageInMonths.max
      };
    });
  }
};

var Product_mapper_getProductChildcareAvailabilitiesProps = function getProductChildcareAvailabilitiesProps(_ref7) {
  var _config$faceting2;

  var config = _ref7.config,
      product = _ref7.product;

  var _ref8 = (config === null || config === void 0 ? void 0 : (_config$faceting2 = config.faceting) === null || _config$faceting2 === void 0 ? void 0 : _config$faceting2.availabilities) || {},
      monthsLabel = _ref8.months,
      yearsLabel = _ref8.years,
      yearLabel = _ref8.year,
      availableLabel = _ref8.available,
      unknownLabel = _ref8.unknown,
      unavailableLabel = _ref8.unavailable,
      urgentizationSingular = _ref8.urgentizationSingular,
      urgentizationPlural = _ref8.urgentizationPlural,
      childcareLabel = _ref8.childcare;

  var sortedChildcareAvailabilities = (product.childcareAvailabilities || []).sort(function (a, b) {
    return a.ageMin - b.ageMin;
  });

  var _sortedChildcareAvail = sortedChildcareAvailabilities,
      _sortedChildcareAvail2 = Object(slicedToArray["a" /* default */])(_sortedChildcareAvail, 2),
      _sortedChildcareAvail3 = _sortedChildcareAvail2[0],
      first = _sortedChildcareAvail3 === void 0 ? {} : _sortedChildcareAvail3,
      _sortedChildcareAvail4 = _sortedChildcareAvail2[1],
      second = _sortedChildcareAvail4 === void 0 ? {} : _sortedChildcareAvail4;

  var hasChildBetween4And23Months = first.ageMin === 4 || first.ageMax === 23;
  var hasOnlyBetween4And13Months = first.ageMin === 4 && second.ageMax !== 23;
  var hasOnlyBetween14And23Months = first.ageMax === 23;

  if (hasOnlyBetween4And13Months) {
    first.ageMax = 23;
  } else if (hasOnlyBetween14And23Months) {
    first.ageMin = 4;
  } else if (hasChildBetween4And23Months) {
    var stock = first.remainingStock === null && second.remainingStock === null ? null : (first.remainingStock || 0) + (second.remainingStock || 0);
    var availability = 'UNKNOWN';

    if (stock === 0) {
      availability = 'UNAVAILABLE';
    } else if (stock) {
      availability = stock <= 10 ? 'PARTIAL' : 'AVAILABLE';
    }

    sortedChildcareAvailabilities = [_objectSpread(_objectSpread({}, second), {}, {
      remainingStock: stock,
      ageMin: 4,
      ageMax: 23,
      availability: availability
    })].concat(Object(toConsumableArray["a" /* default */])(sortedChildcareAvailabilities.slice(2)));
  }

  return {
    items: sortedChildcareAvailabilities,
    monthsLabel: monthsLabel,
    yearsLabel: yearsLabel,
    yearLabel: yearLabel,
    availableLabel: availableLabel,
    unavailableLabel: unavailableLabel,
    unknownLabel: unknownLabel,
    remainingLabel: {
      n: urgentizationPlural,
      _1: urgentizationSingular
    },
    childcareLabel: childcareLabel
  };
};

var Product_mapper_getProductPriceInfoProps = function getProductPriceInfoProps(_ref9) {
  var _config$resort, _config$resort$starti, _product$price, _product$price$termsA, _product$price2, _product$price2$terms, _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price4$terms2, _product$price5, _product$price5$terms, _product$price5$terms2, _product$price6, _product$price6$terms, _product$price7, _product$mice;

  var config = _ref9.config,
      product = _ref9.product;
  var startDate = '';
  var endDate = '';
  var dateFormat = (config === null || config === void 0 ? void 0 : (_config$resort = config.resort) === null || _config$resort === void 0 ? void 0 : (_config$resort$starti = _config$resort.startingPrice) === null || _config$resort$starti === void 0 ? void 0 : _config$resort$starti.dateFormat) || Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  startDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(dateFormat);
  endDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.departureDate, apiDate["a" /* API_DATE_FORMAT */]).add({
    days: ((_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.duration) || 0
  }).format(dateFormat);
  return {
    city: (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : (_product$price4$terms2 = _product$price4$terms.departureCity) === null || _product$price4$terms2 === void 0 ? void 0 : _product$price4$terms2.name) || '',
    endDate: endDate,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : (_product$price5$terms2 = _product$price5$terms.departureCity) === null || _product$price5$terms2 === void 0 ? void 0 : _product$price5$terms2.value),
    isCruise: product.isCruise,
    isJoyview: product.isJoyview,
    isTour: product.isTour,
    rate: product === null || product === void 0 ? void 0 : (_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : (_product$price6$terms = _product$price6.termsAndConditions) === null || _product$price6$terms === void 0 ? void 0 : _product$price6$terms.offerId,
    startDate: startDate,
    transportIcon: product.transportType,
    unit: ((_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : _product$price7.unit) || ((_product$mice = product.mice) === null || _product$mice === void 0 ? void 0 : _product$mice.unit) || ''
  };
};

var Product_mapper_getTopTags = function getTopTags(_ref10) {
  var _product$price8, _product$price8$terms, _product$price8$terms2;

  var hasTransport = _ref10.hasTransport,
      product = _ref10.product;
  var openingStatus = product.openingStatus,
      tags = product.tags;
  var hasDepartureCity = Boolean(product === null || product === void 0 ? void 0 : (_product$price8 = product.price) === null || _product$price8 === void 0 ? void 0 : (_product$price8$terms = _product$price8.termsAndConditions) === null || _product$price8$terms === void 0 ? void 0 : (_product$price8$terms2 = _product$price8$terms.departureCity) === null || _product$price8$terms2 === void 0 ? void 0 : _product$price8$terms2.value);
  var isOpeningSoon = openingStatus === OPENING_STATUS.OPENING_SOON;
  var priorityTagslength = hasDepartureCity + isOpeningSoon + !!product.seasonTrad;

  var productTopTags = Object(toConsumableArray["a" /* default */])((tags || []).slice(0, 3 - priorityTagslength).map(function (tag, i) {
    return {
      dataTestId: "ProductThumbnail-tag-".concat(i),
      label: tag.title,
      style: {
        backgroundColor: tag.backgroundColor,
        borderColor: tag.backgroundColor,
        color: tag.textColor
      }
    };
  }));

  if (product.seasonTrad) {
    productTopTags.push({
      className: 'text-white border-turquoise bg-turquoise',
      dataTestId: 'ProductThumbnail-seasonBadge',
      label: product.seasonTrad
    });
  }

  if (hasDepartureCity || hasTransport) {
    productTopTags.push({
      dataTestId: 'ProductThumbnail-transport',
      iconName: product.transportType,
      label: Object(i18n["h" /* t */])('price.format.flightIncluded')
    });
  }

  if (isOpeningSoon) {
    productTopTags.push({
      className: 'text-white border-orange bg-orange',
      dataTestId: 'ProductThumbnail-openingSoon',
      label: Object(i18n["h" /* t */])('common.openingSoon')
    });
  }

  return productTopTags;
};

var Product_mapper_getProductTags = function getProductTags(product) {
  var productTags = [];

  if (product.mice) {
    var _product$productMeeti, _product$productMeeti2, _product$accommodatio;

    var maxConferenceRoomCapacity = (_product$productMeeti = product.productMeetingRooms) === null || _product$productMeeti === void 0 ? void 0 : (_product$productMeeti2 = _product$productMeeti.meetingRooms) === null || _product$productMeeti2 === void 0 ? void 0 : _product$productMeeti2.reduce(function (roomMaxCapacity, _ref11) {
      var shapes = _ref11.shapes;
      return Math.max(roomMaxCapacity, shapes.reduce(function (maxShape, _ref12) {
        var maxCapacity = _ref12.maxCapacity;
        return Math.max(maxCapacity, maxShape);
      }, 0));
    }, 0);

    if (maxConferenceRoomCapacity) {
      productTags.push({
        className: 'text-sienna bg-white border-white',
        label: Object(i18n["h" /* t */])('common.conferenceRoomCapacity', {
          maxConferenceRoomCapacity: maxConferenceRoomCapacity
        })
      });
    }

    if ((_product$accommodatio = product.accommodationsIntroduction) === null || _product$accommodatio === void 0 ? void 0 : _product$accommodatio.roomsCount) {
      productTags.push({
        className: 'text-sienna border-white bg-white',
        label: Object(i18n["h" /* t */])('common.numberOfRooms', {
          numberOfRooms: product.accommodationsIntroduction.roomsCount
        })
      });
    }

    return productTags;
  }

  if (product.isTour) {
    var _product$rangeLabel;

    var rangeLabel = (_product$rangeLabel = product.rangeLabel) === null || _product$rangeLabel === void 0 ? void 0 : _product$rangeLabel.toUpperCase();
    return [{
      className: 'text-white border-sienna bg-sienna',
      label: product.duration ? "".concat(rangeLabel, " : ").concat(product.duration) : rangeLabel
    }];
  }

  if (product.isCruise) {
    var _product$thematics, _product$thematics$;

    var label = [(_product$thematics = product.thematics) === null || _product$thematics === void 0 ? void 0 : (_product$thematics$ = _product$thematics[0]) === null || _product$thematics$ === void 0 ? void 0 : _product$thematics$.label, product.duration].filter(Boolean).join(' - ');
    return [{
      className: 'text-white border-ultramarine bg-ultramarine',
      label: label
    }];
  }

  if (product.hasECSpace) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionSpaceTag')
    }];
  }

  if (product.isExplicitEC) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionTag')
    }];
  }
};

var Product_mapper_getProductThumbnailProps = function getProductThumbnailProps(props) {
  var product = props.product,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl;
  var openingStatus = product.openingStatus;
  return {
    bottomTags: Product_mapper_getProductTags(product),
    closedLabel: Object(i18n["h" /* t */])('common.closed'),
    isSliderDisabled: isSliderDisabled,
    link: {
      url: getProductUrl(props)
    },
    openingStatus: openingStatus,
    pictures: (product.images || []).map(function (image) {
      return {
        alt: product.name,
        src: image || ''
      };
    }),
    topTags: Product_mapper_getTopTags(props)
  };
};

var getProductFlagProps = function getProductFlagProps(props) {
  var _props$isPriceLoading = props.isPriceLoading,
      isPriceLoading = _props$isPriceLoading === void 0 ? false : _props$isPriceLoading,
      product = props.product;
  var _product$openingStatu = product.openingStatus,
      openingStatus = _product$openingStatu === void 0 ? OPENING_STATUS.OPEN : _product$openingStatu;
  var price = openingStatus === OPENING_STATUS.OPEN ? Product_mapper_getProductPriceProps(props) : {};
  return {
    price: price,
    priceInfo: Product_mapper_getProductPriceInfoProps(props),
    isPriceLoading: isPriceLoading
  };
};

var Product_mapper_getProductOfferDiscountProps = function getProductOfferDiscountProps(_ref13) {
  var product = _ref13.product,
      config = _ref13.config;
  return {
    discount: getAggregateDiscount(product),
    i18n: config.offerDiscount
  };
};

var Product_mapper_createProductUrlWithParams = function createProductUrlWithParams(href, product) {
  var currentLocation = dist["windowWrapper"].getLocation();
  var possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["h" /* QUERY_DURATION */], constants["m" /* QUERY_TRANSPORT */], constants["j" /* QUERY_KIDS */]];

  if (product.isCruise) {
    possibleQueries = [constants["m" /* QUERY_TRANSPORT */]];
  } else if (product.isTour) {
    possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["m" /* QUERY_TRANSPORT */]];
  }

  var getDepartureDate = function getDepartureDate() {
    var _product$flag, _product$flag$price, _product$flag$price$t; // $FlowFixMe


    if (product.departureDateOn && (product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : (_product$flag$price = _product$flag.price) === null || _product$flag$price === void 0 ? void 0 : (_product$flag$price$t = _product$flag$price.termsAndConditions) === null || _product$flag$price$t === void 0 ? void 0 : _product$flag$price$t.departureDate)) {
      return Object(apiDate["j" /* momentFromApiDate */])(product.flag.price.termsAndConditions.departureDate).format(constants["f" /* QUERY_DATE_FORMAT */]);
    }

    return Object(uriUtils["j" /* getQueryParameters */])(currentLocation)[constants["g" /* QUERY_DEPARTURE_DATE */]] || '';
  };

  return Object(uriUtils["f" /* generateUrlWithParams */])(href, {
    queryParams: possibleQueries.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, curr, curr === constants["g" /* QUERY_DEPARTURE_DATE */] ? getDepartureDate() : Object(uriUtils["j" /* getQueryParameters */])(currentLocation)[curr] || ''));
    }, // $FlowFixMe
    {})
  });
};

var setProductHref = function setProductHref(props) {
  var _props$product = props.product,
      product = _props$product === void 0 ? {} : _props$product;
  var href = product.href;

  if (href && true) {
    return _objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      product: _objectSpread(_objectSpread({}, product), {}, {
        href: Product_mapper_createProductUrlWithParams(href, product)
      })
    });
  }

  return props;
};

var Product_mapper_getProductProps = function getProductProps(props) {
  var _props$product3, _props$product3$child, _product$destination2;

  var _props$hasComparison = props.hasComparison,
      hasComparison = _props$hasComparison === void 0 ? false : _props$hasComparison,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer,
      _props$product2 = props.product,
      product = _props$product2 === void 0 ? {} : _props$product2;
  var flag = getProductFlagProps(props);
  var flagPrice = flag.price || {};
  var matchingOfferProducts = offer.products && offer.products.length > 0 ? offer.products.filter(function (offerProduct) {
    return offerProduct.id === product.id;
  }) : [];
  var price = matchingOfferProducts.length === 1 ? matchingOfferProducts.map(function (matchingOfferProduct) {
    return matchingOfferProduct.price;
  }).shift() : flagPrice;
  return {
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    childcareAgeInMonths: getChildCareAgeInMonths(props),
    childcareIncluded: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : (_props$product3$child = _props$product3.childcareDetails) === null || _props$product3$child === void 0 ? void 0 : _props$product3$child.some(function (childcare) {
      return childcare.included;
    }),
    comfort: product.comfort,
    comparison: Product_mapper_getProductComparisonProps(props),
    coordinates: product.coordinates,
    departureDateOn: product.departureDateOn,
    flag: flag,
    hasComparison: hasComparison,
    header: getProductHeaderProps(props),
    id: product.id,
    isCruise: product.isCruise,
    isTour: product.isTour,
    kids: kids,
    minAuthorizedAge: props.product.minAuthorizedAge,
    price: !isEmpty_default()(price) ? price : undefined,
    resortRegion: (_product$destination2 = product.destination) === null || _product$destination2 === void 0 ? void 0 : _product$destination2.area,
    thumbnail: Product_mapper_getProductThumbnailProps(props),
    type: product.type,
    url: getProductUrl(props)
  };
};

var updateProduct = function updateProduct(product, props) {
  return _objectSpread(_objectSpread({}, product), {}, {
    hasComparison: props.hasComparison,
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    comparison: Product_mapper_getProductComparisonProps(props),
    flag: getProductFlagProps(props)
  });
};

var Product_mapper_updateProductUrl = function updateProductUrl(product) {
  var newProductUrl = Product_mapper_createProductUrlWithParams(new URI_default.a(product.url).pathname(), product);
  return _objectSpread(_objectSpread({}, product), {}, {
    url: newProductUrl,
    header: _objectSpread(_objectSpread({}, product.header), {}, {
      link: {
        url: newProductUrl
      }
    }),
    // $FlowFixMe
    thumbnail: _objectSpread(_objectSpread({}, product.thumbnail), {}, {
      link: {
        url: newProductUrl
      }
    })
  });
};



/***/ }),

/***/ "bMF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAdultsWithoutMainContact */
/* unused harmony export getKidsBirthdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormattedKidsBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResortInitialKids; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wQ38");













/* eslint-disable flowtype/no-weak-types */

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




function getAdultsWithoutMainContact(adults) {
  return (adults || []).slice(1);
}

function getKidsBirthdate(kids) {
  return (kids || []).map(function (kid) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(kid, 'birthdate');
  }).filter(Boolean) // kids may not have a birthdate
  .map(function (birthdate) {
    return moment__WEBPACK_IMPORTED_MODULE_13___default()(birthdate);
  });
}

function getFormattedKidsBirthdate(kids, dateFormat) {
  return getKidsBirthdate(kids).map(function (birthdate) {
    return moment__WEBPACK_IMPORTED_MODULE_13___default()(birthdate).format(dateFormat);
  });
}

function getResortInitialKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var initialKidsNumber = arguments.length > 1 ? arguments[1] : undefined;
  var isAdultOnlyResort = arguments.length > 2 ? arguments[2] : undefined;

  if (isAdultOnlyResort) {
    return [];
  }

  return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(kids) && initialKidsNumber > -1 ? Array(initialKidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_14__[/* DEFAULT_KID_VALUE */ "a"])) : kids;
}



/***/ }),

/***/ "bMl7":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("RlI+");


/***/ }),

/***/ "bWWS":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "c2re":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ "c8jO":
/***/ (function(module, exports) {

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
module.exports = _taggedTemplateLiteralLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "cDU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPriceOfStay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetPriceOfStay; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fuxG");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("GZgf");



var getPriceOfStay = function getPriceOfStay(appContext, searchCriteria) {
  var args = Object(_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__[/* getPriceOfStayArgs */ "b"])(searchCriteria);
  return function (dispatch, getState) {
    var _state$priceRemote$pr, _state$priceRemote, _state$priceRemote$pr2;

    var state = getState();

    if (JSON.stringify(args) === JSON.stringify((_state$priceRemote$pr = (_state$priceRemote = state.priceRemote) === null || _state$priceRemote === void 0 ? void 0 : (_state$priceRemote$pr2 = _state$priceRemote.priceOfStay) === null || _state$priceRemote$pr2 === void 0 ? void 0 : _state$priceRemote$pr2.priceOfStayArgs) !== null && _state$priceRemote$pr !== void 0 ? _state$priceRemote$pr : {})) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_OF_STAY_REQUEST_ABORT */ "c"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_OF_STAY_REQUEST */ "b"], {
      args: args
    }, {
      optimist: true,
      promise: Object(_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetchPriceOfStay */ "a"])(appContext, searchCriteria)
    }));
  };
};
var resetPriceOfStay = function resetPriceOfStay() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* RESET_PRICE_OF_STAY */ "d"]);
};

/***/ }),

/***/ "cUh7":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var aCallable = __webpack_require__("eGzU");
var anObject = __webpack_require__("ep/x");
var tryToString = __webpack_require__("xS1b");
var getIteratorMethod = __webpack_require__("MU85");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "cb6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccommodationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aggregateIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBabyBedIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCapacityIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSurfaceIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOutsideFacilitiesIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getViewIconItem; });
/* unused harmony export getNbBabies */
/* unused harmony export hasLowStock */
/* unused harmony export getAccommodationCategoryComfortIndex */
/* unused harmony export getBestAccommodationCategory */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2dTi");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("cFQB");
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lozs");
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("3dHC");
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("OsvN");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("lZ21");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("oL6k");




























var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var ICONS_ROOM_TYPE = {
  CONNECTING_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS_3,
  SEPARATE_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS,
  SINGLE_ROOM: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SINGLE_ROOM
};

function getCapacityIconItem(capacity) {
  var label = Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.numberPeople');

  if (!capacity || !label) {
    return null;
  }

  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].PEOPLE,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.capacityOfPeople'), Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_20__["messageFormat"])(label).format({
      count: capacity
    })]
  };
}

function getSurfaceIconItem(roomType, product, surface) {
  return {
    icon: ICONS_ROOM_TYPE[roomType] || null,
    labels: [Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_21__[/* tAlt */ "u"])({
      cruiseKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* CORRESPONDENCE_CABIN_TYPE */ "d"][roomType]),
      product: product,
      resortKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* CORRESPONDANCE_ROOM_TYPE */ "c"][roomType])
    }), surface || roomType && ' ' || '']
  };
}

function getNbBabies(occupancies) {
  if (!occupancies) {
    return 0;
  }

  return occupancies.reduce(function () {
    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var occupancy = arguments.length > 1 ? arguments[1] : undefined;
    return acc + occupancy.baby_count;
  }, 0);
}

function getBabyBedIconItem(babyCount) {
  if (!babyCount || babyCount <= 0) {
    return null;
  }

  var label = babyCount > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincludedPlural') : Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincluded');
  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].baby_bed,
    labels: [label]
  };
}

function getOutsideFacilitiesIconItem(outsideFacilities) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities, '[0].label') ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities[0], 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [outsideFacilities[0].label]
  } : null;
}

function getViewIconItem(view) {
  return view ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(view, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [view.label]
  } : null;
}

function aggregateIconList(strengths, surface, capacity, outsideFacility, view, babyBed) {
  var isComparator = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isInMoreRoomLayer = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var proposal = arguments.length > 8 ? arguments[8] : undefined;
  var currentComfortAlternatives = arguments.length > 9 ? arguments[9] : undefined; // add a "strengths slot" for each missing item

  var maxStrengths = 3 - [view, capacity, babyBed, outsideFacility].filter(function (item) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(item, 'labels.0');
  }).length;
  var strengthsItems = (strengths || []).slice(0, Math.max(maxStrengths, 0)).map(function (strength) {
    return {
      icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
      labels: [lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'label') || '']
    };
  });
  var chooseYourViewItem = {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.roomFinder.viewFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.common.add')
  };
  var chooseYourFacilityItem = {
    icon: 'terrace',
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.roomFinder.facilitiesFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.common.add')
  };
  var hasViewAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    proposal: proposal
  });
  var hasOFAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: 'terrace',
    proposal: proposal
  });
  var viewWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasViewAlternative ? view || chooseYourViewItem : view;
  var outsideFacilityWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasOFAlternative ? outsideFacility || chooseYourFacilityItem : outsideFacility;
  return lodash_compact__WEBPACK_IMPORTED_MODULE_17___default()([surface, capacity, outsideFacilityWithDefaultIfNone, babyBed].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(strengthsItems), [viewWithDefaultIfNone])).filter(function (_ref) {
    var _ref$labels = _ref.labels,
        labels = _ref$labels === void 0 ? [] : _ref$labels;
    return labels.length && labels[0];
  });
}

function hasLowStock(threshold, stock) {
  return stock <= threshold;
}

function getAccommodationCategoryComfortIndex(category) {
  return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(category.id);
}

function getBestAccommodationCategory(categories) {
  if (categories.length === 1) {
    return categories[0];
  }

  return lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default()(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default()(getAccommodationCategoryComfortIndex), lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default.a)(categories);
}

var getAccommodationRoomsProps = function getAccommodationRoomsProps(_ref2) {
  var _ref2$accommodations = _ref2.accommodations,
      accommodations = _ref2$accommodations === void 0 ? [] : _ref2$accommodations,
      accommodationsCount = _ref2.accommodationsCount,
      attendeesWithDistributionData = _ref2.attendeesWithDistributionData,
      _ref2$proposal = _ref2.proposal,
      proposal = _ref2$proposal === void 0 ? {} : _ref2$proposal,
      remainingStock = _ref2.remainingStock,
      product = _ref2.product,
      streetViews = _ref2.streetViews,
      _ref2$isComparator = _ref2.isComparator,
      isComparator = _ref2$isComparator === void 0 ? false : _ref2$isComparator,
      _ref2$isInMoreRoomLay = _ref2.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref2$isInMoreRoomLay === void 0 ? false : _ref2$isInMoreRoomLay,
      alternatives = _ref2.alternatives;

  var sortedAccommodations = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(accommodations).sort(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* compareAccommodationsByComfort */ "b"]).filter(Boolean);

  var sortedAttendees = {
    adults: attendeesWithDistributionData.filter(function (_ref3) {
      var type = _ref3.type;
      return type === ATTENDEE_CATEGORIES.ADULT;
    }),
    babies: attendeesWithDistributionData.filter(function (_ref4) {
      var type = _ref4.type;
      return type === ATTENDEE_CATEGORIES.BABY;
    }),
    children: attendeesWithDistributionData.filter(function (_ref5) {
      var type = _ref5.type;
      return type === ATTENDEE_CATEGORIES.CHILD;
    })
  };
  return sortedAccommodations.map(function (a) {
    var _a$attendeesDistribut, _proposal$attendees, _proposal$attendees$a, _proposal$attendees2, _proposal$attendees2$, _a$media, _proposal$attendees3, _proposal$attendees3$;

    var attendeesIds = (((_a$attendeesDistribut = a.attendeesDistribution) === null || _a$attendeesDistribut === void 0 ? void 0 : _a$attendeesDistribut.attendees) || []).map(function (at) {
      return at.id;
    });
    var matchingStreetViewElement = (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) ? streetViews.find(function (_ref6) {
      var accommodationCategoryId = _ref6.accommodationCategoryId;
      return accommodationCategoryId === a.categoryId;
    }) : {};
    var isPremium = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isPremiumAccommodation */ "w"])(a);
    var isExclusiveCollection = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isExclusiveCollectionRoom */ "s"])(a, product);

    var getSplitServices = function getSplitServices(services) {
      var servicesToSplit = services.slice(0);

      if (isExclusiveCollection) {
        var mainServices = servicesToSplit.splice(0, 6);
        return [servicesToSplit, mainServices];
      }

      return [servicesToSplit];
    };

    var services = a.services && getSplitServices(a.services);

    var getServicesIconsList = function getServicesIconsList() {
      var _services$; // $FlowFixMe


      if ((services === null || services === void 0 ? void 0 : (_services$ = services[1]) === null || _services$ === void 0 ? void 0 : _services$.length) > 0) {
        // $FlowFixMe
        return services[1].map(function (_ref7) {
          var id = _ref7.id,
              label = _ref7.label;
          return {
            icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][id] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
            labels: [label]
          };
        });
      }

      return null;
    };

    var currentComfortAlternatives = alternatives === null || alternatives === void 0 ? void 0 : alternatives.find(function (_ref8) {
      var categoryId = _ref8.categoryId;
      return categoryId === a.categoryId;
    });
    return {
      bathroomEquipments: a.bathroomEquipments,
      categoryId: a.categoryId,
      description: a.description,
      dates: {
        endDate: moment__WEBPACK_IMPORTED_MODULE_19___default()(a.endDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* API_DATE_FORMAT */ "a"]).valueOf(),
        startDate: moment__WEBPACK_IMPORTED_MODULE_19___default()(a.startDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* API_DATE_FORMAT */ "a"]).valueOf()
      },
      distribution: (sortedAccommodations.length > 1 || a.quantity > 1) && !!attendeesIds.length ? {
        adults: sortedAttendees.adults.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        babies: sortedAttendees.babies.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        children: sortedAttendees.children.filter(function (at) {
          return attendeesIds.includes(at.id);
        })
      } : null,
      equipments: a.equipments,
      hasArrangement: accommodations.length !== (accommodationsCount ? accommodationsCount : proposal === null || proposal === void 0 ? void 0 : proposal.accommodationsCount),
      hasDistribution: sortedAccommodations.length > 1 && !!attendeesIds.length,
      hasSharedRoom: ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$a = _proposal$attendees.adults) === null || _proposal$attendees$a === void 0 ? void 0 : _proposal$attendees$a.length) || 0) + ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees2 = proposal.attendees) === null || _proposal$attendees2 === void 0 ? void 0 : (_proposal$attendees2$ = _proposal$attendees2.children) === null || _proposal$attendees2$ === void 0 ? void 0 : _proposal$attendees2$.length) || 0) === 1 && product.id === 'KEMC',
      id: a.id,
      images: (((_a$media = a.media) === null || _a$media === void 0 ? void 0 : _a$media.photos) || []).map(function (m) {
        return {
          src: m.url
        };
      }),
      floorPlans: a.floorPlans,
      name: a.label,
      infosList: aggregateIconList(a.strengths, getSurfaceIconItem(a.roomType, product, a.surface), undefined, // $FlowFixMe
      getOutsideFacilitiesIconItem(a.outsideFacilities), getViewIconItem(a.view), getBabyBedIconItem(getNbBabies(a.occupancies)), isComparator, isInMoreRoomLayer, proposal, currentComfortAlternatives),
      servicesIconsList: getServicesIconsList(),
      isBestFamilyDeal: (a.familyRoom || a.connectingRoom) && ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees3 = proposal.attendees) === null || _proposal$attendees3 === void 0 ? void 0 : (_proposal$attendees3$ = _proposal$attendees3.children) === null || _proposal$attendees3$ === void 0 ? void 0 : _proposal$attendees3$.length) || 0) > 0,
      isCabin: product.isCruise,
      isPremium: isPremium,
      isExclusiveCollectionRoom: isExclusiveCollection,
      isExclusiveCollectionSpace: Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isExclusiveCollectionSpace */ "t"])(a, product),
      outsideFacilities: a.outsideFacilities,
      quantity: a.quantity,
      // $FlowFixMe
      services: services === null || services === void 0 ? void 0 : services[0],
      stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0,
      streetView: matchingStreetViewElement === null || matchingStreetViewElement === void 0 ? void 0 : matchingStreetViewElement.streetView,
      type: a.roomType
    };
  });
};

var getAccommodationProps = function getAccommodationProps(_ref9) {
  var _proposal$price;

  var _ref9$accommodations = _ref9.accommodations,
      accommodations = _ref9$accommodations === void 0 ? [] : _ref9$accommodations,
      accommodationsCount = _ref9.accommodationsCount,
      attendeesWithDistributionData = _ref9.attendeesWithDistributionData,
      _ref9$proposal = _ref9.proposal,
      proposal = _ref9$proposal === void 0 ? {} : _ref9$proposal,
      product = _ref9.product,
      remainingStock = _ref9.remainingStock,
      streetViews = _ref9.streetViews,
      _ref9$isComparator = _ref9.isComparator,
      isComparator = _ref9$isComparator === void 0 ? false : _ref9$isComparator,
      _ref9$isInMoreRoomLay = _ref9.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref9$isInMoreRoomLay === void 0 ? false : _ref9$isInMoreRoomLay,
      _ref9$isUpgradableOnl = _ref9.isUpgradableOnline,
      isUpgradableOnline = _ref9$isUpgradableOnl === void 0 ? true : _ref9$isUpgradableOnl,
      alternatives = _ref9.alternatives;
  var rooms = getAccommodationRoomsProps({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    attendeesWithDistributionData: attendeesWithDistributionData,
    proposal: proposal,
    remainingStock: remainingStock,
    product: product,
    streetViews: streetViews,
    isComparator: isComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    alternatives: alternatives
  });
  return {
    hasFlexRates: proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.hasFlexRates,
    isCabin: product.isCruise,
    isUpgradableOnline: isUpgradableOnline,
    proposal: proposal,
    rooms: rooms,
    stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0,
    streetViews: streetViews || []
  };
};


/***/ }),

/***/ "cdI6":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),

/***/ "cdJH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var fails = __webpack_require__("fhLv");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var toObject = __webpack_require__("A+R+");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "chol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCivilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTravelAgencyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdultsNumberOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getKidsNumberOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNewsletterOptins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProductOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFormProducts; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1IsZ");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _utils_legal_information_legalInformationIds_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("y5Lu");
/* harmony import */ var _store_utils_selectOptionsBuilders__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("7F8I");
/* harmony import */ var _widgets_prebooking_form_PrebookingForm_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("FaX5");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("1qsz");






















 // Line props
// Resolver props
// PrebookingForm props
// CIVILITIES

var getCivilities = function getCivilities(adultCivilities, locale) {
  return {
    adults: adultCivilities,
    kids: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_18__["getKidsCivilities"])(locale).map(function (_ref) {
      var value = _ref.value,
          label = _ref.label;
      return {
        value: value,
        name: label
      };
    })
  };
}; // TRAVEL AGENCY OPTIONS

var getAgencyName = function getAgencyName(travelAgency) {
  var _travelAgency$address;

  return "".concat(((_travelAgency$address = travelAgency.address) === null || _travelAgency$address === void 0 ? void 0 : _travelAgency$address.city) || '', " - ").concat(travelAgency.name);
};

var getFilteredAgencyName = function getFilteredAgencyName(travelAgency) {
  /**
   * ^[.+?\s]*            Match 0 or more chars or white space at the beginning
   * (?:<T1>|<T2>)?       Do not capture group of 1st or 2nd potential terms
   * \s*                  Match 0 or more white spaces
   * (.+?)$               Capture group of any chars up to the end
   * /i                   Case insensitive Flags
   */
  var agencyNameFilter = /^[.+?\s]*(?:CLUB MED VOYAGES|APPARTEMENT BOUTIQUE)?\s*(.+?)$/i;
  var trimmedName = agencyNameFilter.exec(travelAgency.name);
  return trimmedName && trimmedName[1] ? trimmedName[1] : getAgencyName(travelAgency);
};

var getTravelAgencyOptions = function getTravelAgencyOptions(travelAgencies, locale) {
  if (!travelAgencies) {
    return [];
  }

  return travelAgencies.map(function (travelAgency) {
    return {
      name: locale === 'fr-FR' ? getFilteredAgencyName(travelAgency) : getAgencyName(travelAgency),
      value: travelAgency.id
    };
  }).sort(function (travelAgencyA, travelAgencyB) {
    return travelAgencyA.name.localeCompare(travelAgencyB.name) > 0 ? 1 : -1;
  });
}; // ADULTS/KIDS NUMBER OPTIONS

var getAdultsNumberOptions = function getAdultsNumberOptions(adultsAge) {
  return Object(_store_utils_selectOptionsBuilders__WEBPACK_IMPORTED_MODULE_20__[/* getAdultsOptions */ "a"])(adultsAge, _widgets_prebooking_form_PrebookingForm_constants__WEBPACK_IMPORTED_MODULE_21__[/* MIN_FORM_ADULTS */ "f"], _widgets_prebooking_form_PrebookingForm_constants__WEBPACK_IMPORTED_MODULE_21__[/* MAX_FORM_ADULTS */ "d"]).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
};
var getKidsNumberOptions = function getKidsNumberOptions(kidsAge) {
  return Object(_store_utils_selectOptionsBuilders__WEBPACK_IMPORTED_MODULE_20__[/* getChildrenOptions */ "b"])(kidsAge, _widgets_prebooking_form_PrebookingForm_constants__WEBPACK_IMPORTED_MODULE_21__[/* MIN_FORM_KIDS */ "g"], _widgets_prebooking_form_PrebookingForm_constants__WEBPACK_IMPORTED_MODULE_21__[/* MAX_FORM_KIDS */ "e"]).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
}; // NEWSLETTER OPTINS

var getNewsletterOptin = function getNewsletterOptin(optin) {
  return optin ? {
    title: optin.title,
    description: optin.description,
    preChecked: optin.preChecked
  } : null;
};

var getNewsletterOptins = function getNewsletterOptins(consentOptins) {
  var optinEmail = consentOptins.find(function (optin) {
    return optin.id === _utils_legal_information_legalInformationIds_constants__WEBPACK_IMPORTED_MODULE_19__[/* EMAIL_OPTIN */ "c"];
  });
  var optinPhone = consentOptins.find(function (optin) {
    return optin.id === _utils_legal_information_legalInformationIds_constants__WEBPACK_IMPORTED_MODULE_19__[/* PHONE_OPTIN */ "i"];
  });
  var optinSms = consentOptins.find(function (optin) {
    return optin.id === _utils_legal_information_legalInformationIds_constants__WEBPACK_IMPORTED_MODULE_19__[/* SMS_OPTIN */ "k"];
  });
  var optinProfile = consentOptins.find(function (optin) {
    return optin.id === _utils_legal_information_legalInformationIds_constants__WEBPACK_IMPORTED_MODULE_19__[/* PROFILING */ "j"];
  });
  return {
    optinEmail: getNewsletterOptin(optinEmail),
    optinPhone: getNewsletterOptin(optinPhone),
    optinSms: getNewsletterOptin(optinSms),
    optinProfile: getNewsletterOptin(optinProfile)
  };
}; // PRODUCT OPTIONS

var getProductOption = function getProductOption(isTopProduct) {
  return function (product) {
    return {
      key: "".concat(product.productId, "-").concat(isTopProduct ? 'top' : 'regular'),
      name: "".concat(product.name, ", ").concat(product.destination.country),
      value: product.productId
    };
  };
};

function getProductOptions(lineProducts, products) {
  var topProducts = lineProducts.filter(function (lineProduct) {
    return lineProduct.sortedFirst;
  }).map(function (_ref4) {
    var productId = _ref4.productId;
    return products[productId];
  }).filter(Boolean).map(getProductOption(true));
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(topProducts), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(topProducts.length ? [{
    key: 'separator',
    name: '──────────',
    value: null,
    isDisabled: true
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(Object.values(products).map(getProductOption(false)).sort(function (productOptionA, productOptionB) {
    if (!productOptionA.name) {
      return 1;
    }

    if (!productOptionB.name) {
      return -1;
    }

    return productOptionA.name.localeCompare(productOptionB.name);
  })));
} // PRODUCT DATA

function getAccommodationsOptions() {
  var accommodations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var accommodationCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return accommodationCategories.map(function (accommodationCategory) {
    var categoryId = accommodationCategory.id,
        categoryLabel = accommodationCategory.label,
        categoryRanking = accommodationCategory.ranking;
    var types = accommodations.filter(function (accommodation) {
      return accommodation.categories.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      }).includes(categoryId);
    }).map(function (_ref6) {
      var id = _ref6.id,
          label = _ref6.label;
      return {
        name: label,
        value: id
      };
    });
    return {
      value: categoryId,
      name: categoryLabel,
      rankingIndex: Object.values(_clubmed_utils__WEBPACK_IMPORTED_MODULE_17__["constants"].RANKINGS).findIndex(function (ranking) {
        return ranking === categoryRanking;
      }),
      types: types
    };
  }).sort(function (accommodationsOptionA, accommodationsOptionB) {
    return accommodationsOptionB.rankingIndex - accommodationsOptionA.rankingIndex;
  });
}

function getFormProducts(_ref7) {
  var resorts = _ref7.resorts,
      bookingsCriteria = _ref7.bookingsCriteria,
      accommodationCategories = _ref7.accommodationCategories,
      durationLabels = _ref7.durationLabels;
  return resorts.reduce(function (products, product, productIndex) {
    var _bookingsCriteria$pro, _bookingsCriteria$pro2;

    var name = product.name,
        destination = product.destination,
        adultOnly = product.adultOnly,
        openingDates = product.openingDates,
        accommodations = product.accommodations,
        minAuthorizedAge = product.minAuthorizedAge;
    var durations = ((_bookingsCriteria$pro = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro === void 0 ? void 0 : _bookingsCriteria$pro.durations) || [];
    var transports = ((_bookingsCriteria$pro2 = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro2 === void 0 ? void 0 : _bookingsCriteria$pro2.departureCities) || [];
    var productAccommodationCategories = accommodationCategories.filter(Boolean).find(function (category) {
      return category.productId === product.id;
    });
    var categories = (productAccommodationCategories === null || productAccommodationCategories === void 0 ? void 0 : productAccommodationCategories.accommodations) || [];
    products[product.id] = {
      productId: product.id,
      isSki: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_22__[/* isWinterMountainResort */ "a"])(product),
      name: name,
      destination: destination,
      openingDates: openingDates,
      minAuthorizedAge: minAuthorizedAge.formattedValue || '',
      minAuthorizedAgeInMonths: minAuthorizedAge.value || '',
      durations: Object(_store_utils_selectOptionsBuilders__WEBPACK_IMPORTED_MODULE_20__[/* getDurationOptions */ "c"])(durationLabels, durations, 'count'),
      transports: transports,
      accommodations: getAccommodationsOptions(accommodations, categories),
      adultOnly: adultOnly
    };
    return products;
  }, {});
}

/***/ }),

/***/ "cjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMAIL_PATTERN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GM_NUMBER_PATTERN; });
/* unused harmony export email */
/* unused harmony export firstName */
/* unused harmony export lastName */
/* unused harmony export unicodeFirstName */
/* unused harmony export unicodeLastName */
/* unused harmony export notContainsUnicode */
/* unused harmony export strictName */
/* unused harmony export ASCII */
/* unused harmony export minLength */
/* unused harmony export haveLength */
/* unused harmony export maxLength */
/* unused harmony export regexp */
/* unused harmony export enum */
/* unused harmony export phoneNumber */
/* unused harmony export mandatory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return minAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return maxAge; });
/* unused harmony export gmNumber */
/* unused harmony export inRange */
/* unused harmony export legalAgreement */
/* unused harmony export optionalBirthdate */
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("mGvo");
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");




var EMAIL_PATTERN = /^(?!.*@.*\.{2})[^\s@]+@[^\s@]+\.[^\s@.]+$/;
var GM_NUMBER_PATTERN = /^[0-9]{0,9}$/;
var UNICODE_CHAR_REGEXP = /[^\u0000-\u00ff]/;

function _regexp(reg) {
  return function (value) {
    return reg.test(value);
  };
}

function _minLength(length) {
  return function (value) {
    return value.length >= length;
  };
}

function _maxLength(length) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.length <= length;
  };
}

function _haveLength(length) {
  return function (value) {
    return value.length === length;
  };
}

function _enum(values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  };
}

function _mandatory() {
  return function (value) {
    return !!value;
  };
}

function _checkDate(format) {
  return function (dateToCheck) {
    return !!(dateToCheck && format && moment__WEBPACK_IMPORTED_MODULE_2___default()(dateToCheck, format, true).isValid());
  };
}

function _getAge(birthday, birthdayFormat, onDate, onDateFormat) {
  var fromDate = onDate && onDateFormat ? moment__WEBPACK_IMPORTED_MODULE_2___default()(onDate, onDateFormat) : moment__WEBPACK_IMPORTED_MODULE_2___default()();
  return fromDate.diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(birthday, birthdayFormat), 'years', true);
}

function _notContainsUnicode(str) {
  return !UNICODE_CHAR_REGEXP.test(str);
}

function _inRange(min, max) {
  return function (value) {
    return value >= min && value <= max;
  };
}
/* Validators */


var email = {
  name: 'email',
  isValid: _regexp(EMAIL_PATTERN)
};
var firstName = {
  name: 'firstName',
  isValid: function isValid(value) {
    return _maxLength(20)(value) && _notContainsUnicode(value);
  }
};
var lastName = {
  name: 'lastName',
  isValid: function isValid(value) {
    return _maxLength(30)(value) && _notContainsUnicode(value);
  }
};
var notContainsUnicode = {
  name: 'notContainsUnicode',
  isValid: function isValid(value) {
    return _notContainsUnicode(value);
  }
};
var unicodeFirstName = {
  name: 'unicodeFirstName',
  isValid: _maxLength(100)
};
var unicodeLastName = {
  name: 'unicodeLastName',
  isValid: _maxLength(100)
};
var strictName = {
  name: 'strictName',
  isValid: function isValid(value) {
    return _mandatory()(value) && _regexp(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/)(value);
  }
};
var ASCII = {
  name: 'ASCII',
  isValid: _regexp(/^[\x20-\xFF]+$/)
};

function minLength(length) {
  return {
    name: 'minLength',
    isValid: _minLength(length)
  };
}

function haveLength(length) {
  return {
    name: 'haveLength',
    isValid: _haveLength(length)
  };
}

function maxLength(length) {
  return {
    name: 'maxLength',
    isValid: _maxLength(length)
  };
}

function regexp(exp) {
  return {
    name: 'regexp',
    isValid: _regexp(exp)
  };
}

function enum1() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return {
    name: 'enum',
    isValid: _enum(values)
  };
}

function phoneNumber(locale) {
  var phoneRegexp = Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* getPhoneRegex */ "b"])(locale);
  return {
    name: 'phoneNumber',
    isValid: _regexp(phoneRegexp)
  };
}

function mandatory() {
  return {
    name: 'mandatory',
    isValid: _mandatory()
  };
}

function date(format) {
  return {
    name: 'date',
    isValid: _checkDate(format)
  };
}

var optionalBirthdate = function optionalBirthdate(_ref) {
  var ageRequired = _ref.ageRequired,
      birthdayFormat = _ref.birthdayFormat,
      onDate = _ref.onDate,
      onDateFormat = _ref.onDateFormat;
  return {
    name: 'optionalBirthdate',
    isValid: function isValid(birthdate) {
      return !birthdate || birthdayFormat && moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate, birthdayFormat, true).isValid() && lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthdate) && _getAge(birthdate, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
};

function minAge(_ref2) {
  var ageRequired = _ref2.ageRequired,
      birthdayFormat = _ref2.birthdayFormat,
      onDate = _ref2.onDate,
      onDateFormat = _ref2.onDateFormat;
  return {
    name: 'minAge',
    isValid: function isValid(birthday) {
      return lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
}

function maxAge() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ageRequired = _ref3.ageRequired,
      birthdayFormat = _ref3.birthdayFormat,
      onDate = _ref3.onDate,
      onDateFormat = _ref3.onDateFormat;

  return {
    name: 'maxAge',
    isValid: function isValid(birthday) {
      return lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) < ageRequired;
    }
  };
}

function inRange(min, max) {
  return {
    name: 'inRange',
    isValid: _inRange(min, max)
  };
}

var gmNumber = {
  name: 'gmNumber',
  isValid: function isValid(value) {
    return _regexp(GM_NUMBER_PATTERN)(value);
  }
};

function legalAgreement(required) {
  return {
    name: 'legalAgreement',
    // if legalAgreement is not required, return true to bypass validation
    isValid: function isValid(value) {
      return required ? value === true : true;
    }
  };
}



/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* unused harmony export FETCH_USER_PAST_TRIPS */
/* unused harmony export FETCH_USER_PAST_TRIPS_RESOLVED */
/* unused harmony export RESET_USER_PAST_TRIPS */
/* unused harmony export FETCH_USER_FUTURE_TRIPS */
/* unused harmony export FETCH_USER_FUTURE_TRIPS_FETCHED */
/* unused harmony export FETCH_USER_FUTURE_TRIPS_RESOLVED */
/* unused harmony export RESET_USER_FUTURE_TRIPS */
/* unused harmony export FETCH_USER_SEARCHES */
/* unused harmony export FETCH_USER_SEARCHES_RESOLVED */
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE = 'CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION = 'CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "d0l/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var GoogleMapMap = function (_Component) {
  _inherits(GoogleMapMap, _Component);

  function GoogleMapMap() {
    _classCallCheck(this, GoogleMapMap);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false; // disable react on this div
  };

  GoogleMapMap.prototype.render = function render() {
    var registerChild = this.props.registerChild;

    return _react2.default.createElement('div', { ref: registerChild, style: style });
  };

  return GoogleMapMap;
}(_react.Component);

exports.default = GoogleMapMap;

/***/ }),

/***/ "dAFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAreaExclusiveCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResortDistrictQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);

var isAreaExclusiveCollection = function isAreaExclusiveCollection(area) {
  var _area$comfort, _area$comfort2;

  return ((_area$comfort = area.comfort) === null || _area$comfort === void 0 ? void 0 : _area$comfort.id) === 'area_comfort_level_5_tridents' || ((_area$comfort2 = area.comfort) === null || _area$comfort2 === void 0 ? void 0 : _area$comfort2.id) === 'area_comfort_level_villas_and_chalets';
};
var getResortDistrictQuery = function getResortDistrictQuery(resortId) {
  return "query {\n  pickYourRoom {\n    resortSettings(resortId : \"".concat(resortId, "\") {\n      initialViewport { ...viewPort }\n      targetViewport { ...viewPort }\n      maxBounds { minLon maxLon minLat maxLat minZoom maxZoom }\n    }\n  }\n  resortAreas(resortId: \"").concat(resortId, "\") {\n    areas {\n      associatedAccess {\n        id\n        label\n      }\n      description\n      id\n      images\n      label\n      comfort {\n        id\n      }\n      shortDescription\n    }\n    geoData(resortId: \"").concat(resortId, "\") {\n      areas {\n        id\n        label\n        pickable\n      }\n      areas_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n      areas_center_geo_json {\n        features {\n          geometry {\n            coordinates\n            type\n          }\n          properties {\n            area_id: id\n          }\n          type\n        }\n        type\n      }\n    }\n  }\n}\n    \nfragment viewPort on ViewportType {\n  latitude\n  longitude\n  zoom\n  bearing\n  pitch\n}");
};

/***/ }),

/***/ "dFUt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function() {
  this._size = 0
  this._values = {}
}
Cache.prototype.get = function(key) {
  return this._values[key]
}
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear()
  if (!this._values.hasOwnProperty(key)) {
    this._size++
  }
  return this._values[key] = value
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var contentSecurityPolicy = false,
  pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

try {
  new Function('')
} catch (error) {
  contentSecurityPolicy = true
}

module.exports = {
  Cache: Cache,

  expr: expr,

  split: split,

  normalizePath: normalizePath,

  setter: contentSecurityPolicy
    ? function(path) {
      var parts = normalizePath(path)
      return function(data, value) {
        return setterFallback(parts, data, value)
      }
    }
    : function(path) {
      return setCache.get(path) || setCache.set(
        path,
        new Function(
          'data, value',
          expr(path, 'data') + ' = value'
        )
      )
    },

  getter: contentSecurityPolicy
    ? function(path, safe) {
      var parts = normalizePath(path)
      return function(data) {
        return getterFallback(parts, safe, data)
      }
    }
    : function(path, safe) {
      var key = path + '_' + safe
      return getCache.get(key) || getCache.set(
        key,
        new Function('data', 'return ' + expr(path, safe, 'data'))
      )
    },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(split(path), cb, thisArg)
  }
}

function setterFallback(parts, data, value) {
  var index = 0,
    len = parts.length
  while (index < len - 1) {
    data = data[parts[index++]]
  }
  data[parts[index]] = value
}

function getterFallback(parts, safe, data) {
  var index = 0,
    len = parts.length
  while (index < len) {
    if (data != null || !safe) {
      data = data[parts[index++]]
    } else {
      return
    }
  }
  return data
}

function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2')
    })
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function expr(expression, safe, param) {
  expression = expression || ''

  if (typeof safe === 'string') {
    param = safe
    safe = false
  }

  param = param || 'data'

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = split(path),
    isLast

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1

    part = isBracket || isArray ? '[' + part + ']' : '.' + part

    result += part + (!isLast ? ' || {})' : ')')
  })

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ "dLd+":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var parseInt = __webpack_require__("QkOM");

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "dNjr":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("F9U4");
var requireObjectCoercible = __webpack_require__("4gXF");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "dm5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButtonWithIcon; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/HC4");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;




var RadioButtonWithIcon = function RadioButtonWithIcon(_ref) {
  var icon = _ref.icon,
      isChecked = _ref.isChecked,
      title = _ref.title,
      description = _ref.description,
      value = _ref.value,
      name = _ref.name,
      priceDifference = _ref.priceDifference,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'RadioButtonWithIcon' : _ref$testId;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('flex h-full flex-col overflow-hidden rounded-12 border-1 p-15 text-center leading-normal', {
      'border-lightGrey': !isChecked,
      'border-saffron': isChecked
    }),
    "data-testid": testId
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "m-auto mb-10",
    dataTestid: "RadioButtonWithIcon-icon",
    name: icon,
    width: "2em"
  }), __jsx("div", {
    className: "w-full text-12 font-bold leading-tight"
  }, title), __jsx("div", {
    className: "w-full text-10 leading-tight text-black"
  }, description), __jsx("div", {
    className: "m-auto"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    className: "ml-10",
    name: name,
    value: value,
    type: "radio"
  })), !!priceDifference && __jsx("div", {
    className: "w-full text-12 font-bold leading-tight"
  }, priceDifference));
};

/***/ }),

/***/ "dpio":
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ "e4lk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Address; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;


function toLine() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.filter(Boolean).join(' ');
}

function AddressLine(_ref) {
  var children = _ref.children;
  return children ? __jsx("li", {
    className: "leading-normal text-14 text-black"
  }, children) : null;
}

var Address = function Address(_ref2) {
  var additionalInformation1 = _ref2.additionalInformation1,
      additionalInformation2 = _ref2.additionalInformation2,
      addOn = _ref2.addOn,
      city = _ref2.city,
      className = _ref2.className,
      country = _ref2.country,
      _ref2$displayAddOnFir = _ref2.displayAddOnFirst,
      displayAddOnFirst = _ref2$displayAddOnFir === void 0 ? false : _ref2$displayAddOnFir,
      stateOrDistrict = _ref2.stateOrDistrict,
      streetNumber = _ref2.streetNumber,
      streetName = _ref2.streetName,
      town = _ref2.town,
      zipCode = _ref2.zipCode;
  return __jsx("ul", {
    className: className
  }, displayAddOnFirst && __jsx(AddressLine, null, toLine(addOn)), __jsx(AddressLine, null, toLine(streetNumber, streetName)), __jsx(AddressLine, null, toLine(additionalInformation1)), __jsx(AddressLine, null, toLine(additionalInformation2)), displayAddOnFirst ? __jsx(AddressLine, null, toLine(city)) : __jsx(AddressLine, null, toLine(addOn, city)), __jsx(AddressLine, null, toLine(town, zipCode)), __jsx(AddressLine, null, toLine(stateOrDistrict, country)));
};

/***/ }),

/***/ "eGzU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var tryToString = __webpack_require__("xS1b");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "eZ08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectAttendeesByHouseholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAttendeesWithInfosByHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInfosToProposalAttendees; });
/* unused harmony export selectNumberOfHouseholds */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("PuIx");
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("zytj");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("WeO/");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("apzf");





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var selectAttendeesByHouseholds = function selectAttendeesByHouseholds(state) {
  return state.booking.attendees.attendeesByHouseHolds;
};

var findFittingChild = function findFittingChild(childBirthdate, connectedUserInfo, childrenIds) {
  var _connectedUserInfo$tr;

  var siblinds = (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr === void 0 ? void 0 : _connectedUserInfo$tr.filter(function (travelCompanion) {
    return moment__WEBPACK_IMPORTED_MODULE_21___default()(childBirthdate).isSame(travelCompanion.birthdate);
  })) || [];

  if (siblinds.length === 1 && !childrenIds.includes(siblinds[0].id)) {
    childrenIds.push(siblinds[0].id);
    return siblinds[0];
  }

  return null;
};

var formatHouseholds = function formatHouseholds(proposal, attendeesAfterPut) {
  var _proposal$households;

  return (proposal === null || proposal === void 0 ? void 0 : (_proposal$households = proposal.households) === null || _proposal$households === void 0 ? void 0 : _proposal$households.length) ? // $FlowFixMe
  proposal.households.map(function (household, index) {
    var _ref;

    var householdAttendees = (_ref = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])((household === null || household === void 0 ? void 0 : household.attendees) || [])) === null || _ref === void 0 ? void 0 : _ref.map(function (attendee) {
      var _proposal$attendees, _proposal$attendees$l;

      var attendeeWithInfos = proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : _proposal$attendees$l.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      });
      var attendeeWithGmNumber = (attendeesAfterPut === null || attendeesAfterPut === void 0 ? void 0 : attendeesAfterPut.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      })) || {};
      return lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default()(_objectSpread(_objectSpread({}, attendee), attendeeWithGmNumber), attendeeWithInfos || {}, function (a, b) {
        return a || b;
      });
    });
    return {
      all: householdAttendees,
      adults: householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return attendee.isAdult;
      }),
      children: (householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return !attendee.isAdult;
      })) || [],
      key: index
    };
  }) : [{
    all: [],
    adults: [],
    children: [],
    key: 0
  }];
};

var attendeeLabel = function attendeeLabel(proposalAttendee) {
  return Object(_utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__[/* getAttendeeNamePlaceholder */ "a"])(proposalAttendee, !proposalAttendee.isAdult, proposalAttendee.id === 'A');
};

var getAttendees = function getAttendees(_ref2) {
  var householdAttendees = _ref2.householdAttendees,
      householdId = _ref2.householdId,
      identifiedAttendees = _ref2.identifiedAttendees,
      connectedUserInfo = _ref2.connectedUserInfo;
  var childrenIds = [];
  return householdAttendees.map(function (_ref3, attendeeIndex) {
    var id = _ref3.id,
        customerId = _ref3.customerId,
        birthdate = _ref3.birthdate,
        neolid = _ref3.neolid,
        householdAttendee = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref3, ["id", "customerId", "birthdate", "neolid"]);

    var tripInformationAttendee = identifiedAttendees === null || identifiedAttendees === void 0 ? void 0 : identifiedAttendees.find(function (att) {
      return customerId ? att.customerId === customerId || att.neolid === customerId : att.id === id;
    });
    var connectedUserInfos = householdAttendee.isAdult && householdId === 0 && attendeeIndex === 0 && !!(connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.neolaneId) ? _objectSpread(_objectSpread({}, connectedUserInfo), {}, {
      neolid: connectedUserInfo.neolid || connectedUserInfo.customerId || connectedUserInfo.neolaneId,
      birthdate: connectedUserInfo.birthdate || connectedUserInfo.dateOfBirth,
      mobile: connectedUserInfo.mobilePhoneNumber
    }) : {};
    var child = findFittingChild(birthdate, connectedUserInfo, childrenIds) || {};

    var attendeeWithInfos = lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default()(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      birthdate: birthdate,
      customerId: customerId,
      neolid: customerId
    }, householdAttendee), connectedUserInfos), !householdAttendee.isAdult ? lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(child, 'id') : {}), {}, {
      householdId: householdId,
      isChild: !householdAttendee.isAdult,
      // should be kept here to change all attendees last name in case of travel companions
      lastName: householdAttendee.lastName || (tripInformationAttendee === null || tripInformationAttendee === void 0 ? void 0 : tripInformationAttendee.lastName) || (!householdAttendee.isAdult ? child === null || child === void 0 ? void 0 : child.lastName : '') || (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.lastName),
      id: id,
      attendeeIndex: attendeeIndex
    }), tripInformationAttendee || {}, function (objValue, srcValue) {
      return objValue || srcValue;
    });

    var lastValue = {};

    for (var _i = 0, _Object$entries = Object.entries(attendeeWithInfos); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      lastValue[key] = value === null ? undefined : value;
    }

    return _objectSpread(_objectSpread({}, lastValue), {}, {
      name: attendeeLabel(lastValue)
    });
  });
};

var getFormattedHouseholds = function getFormattedHouseholds(_ref4) {
  var households = _ref4.households,
      tripInformationAttendees = _ref4.tripInformationAttendees,
      connectedUserInfo = _ref4.connectedUserInfo;
  return households === null || households === void 0 ? void 0 : households.map(function (_ref5, householdId) {
    var adults = _ref5.adults,
        children = _ref5.children;
    var newAdultsList = getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(adults),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(tripInformationAttendees.adults) : [],
      connectedUserInfo: connectedUserInfo
    });
    var newChildrenList = children.length ? getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(children),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(tripInformationAttendees.kids) : [],
      connectedUserInfo: connectedUserInfo
    }) : [];
    return {
      key: householdId,
      adults: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newAdultsList),
      children: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newChildrenList),
      all: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newAdultsList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newChildrenList))
    };
  });
};

var selectAttendeesWithInfosByHouseholds = function selectAttendeesWithInfosByHouseholds(state) {
  var formattedHouseholds = selectAttendeesByHouseholds(state);
  var tripInformationAttendees = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"])(state);
  var connectedUserInfo = Object(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_24__[/* userInfoSelector */ "a"])(state) || {};

  try {
    var households = getFormattedHouseholds({
      households: formattedHouseholds,
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    return {
      households: households,
      attendees: households.reduce(function (attendees, value) {
        return {
          adults: attendees.adults.concat(value.adults),
          children: attendees.children.concat(value.children),
          list: attendees.list.concat(value.all)
        };
      }, {
        list: [],
        adults: [],
        children: []
      })
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_20__["default"].error(error);
    return {
      households: [],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var addInfosToProposalAttendees = function addInfosToProposalAttendees(_ref6) {
  var proposal = _ref6.proposal,
      tripInformationAttendees = _ref6.tripInformationAttendees,
      connectedUserInfo = _ref6.connectedUserInfo;

  try {
    var formattedHouseholds = getFormattedHouseholds({
      households: formatHouseholds(proposal),
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    var formattedAttendees = {
      list: [],
      adults: [],
      children: []
    };
    formattedHouseholds.map(function (value) {
      formattedAttendees.adults = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.adults), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.adults));
      formattedAttendees.children = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.children), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.children));
      formattedAttendees.list = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.list), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.all));
    });
    return {
      households: formattedHouseholds,
      attendees: formattedAttendees
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_20__["default"].error(error);
    return {
      households: [{
        all: [],
        adults: [],
        children: [],
        key: 0
      }],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var selectNumberOfHouseholds = function selectNumberOfHouseholds(state) {
  return state.booking.attendees.numberOfHouseHolds;
};

/***/ }),

/***/ "elUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getGoogleBaseUrl */
/* unused harmony export getGoogleScriptUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStaticMapURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGoogleMapURL; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _google_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UlIv");






function getGoogleBaseUrl() {
  var googleDomain = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get(_google_constants__WEBPACK_IMPORTED_MODULE_5__[/* GOOGLE_API_DOMAIN */ "a"]);
  var googleKey = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get(_google_constants__WEBPACK_IMPORTED_MODULE_5__[/* GOOGLE_API_KEY */ "c"]);
  return new urijs__WEBPACK_IMPORTED_MODULE_3___default.a(googleDomain).query({
    key: googleKey
  });
}
function getGoogleScriptUrl() {
  return getGoogleBaseUrl().path(_config__WEBPACK_IMPORTED_MODULE_4___default.a.get(_google_constants__WEBPACK_IMPORTED_MODULE_5__[/* GOOGLE_API_JS_PATH */ "b"])).toString();
}
function getStaticMapURL(path, query) {
  var baseUrl = getGoogleBaseUrl();
  baseUrl.path(_config__WEBPACK_IMPORTED_MODULE_4___default.a.get(path));
  baseUrl.addQuery(query);
  return baseUrl.toString();
}
function getGoogleMapURL(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "".concat(_google_constants__WEBPACK_IMPORTED_MODULE_5__[/* GOOGLE_PLACE_URL */ "f"], "/").concat(latitude, ",").concat(longitude);
}

/***/ }),

/***/ "ep/x":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLastVisitedProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("829J");













var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProducts() {
  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "B"]);
  var lastVisitedProducts = (trackingShopping === null || trackingShopping === void 0 ? void 0 : trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "y"]]) || []; // it handles old data: string[]
  // to delete when it's safe

  return lastVisitedProducts.map(function (visitedProduct, index) {
    if (typeof visitedProduct === 'string') {
      return {
        id: visitedProduct,
        be: false,
        timestamp: Date.now() + index
      };
    }

    return visitedProduct;
  });
}
function getLastVisitedProductIds() {
  return getLastVisitedProducts().map(function (_ref) {
    var id = _ref.id;
    return id;
  });
}
function trackLastVisitedProducts(pageType, product) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageType) && (product === null || product === void 0 ? void 0 : product.id)) {
    var lastVisitedProducts = getLastVisitedProducts();
    var targetProduct = lastVisitedProducts.find(function (visitedProduct) {
      return visitedProduct.id === product.id;
    });

    if (targetProduct) {
      // once it's true (BE) it can't go back to false
      targetProduct.be = product.be || targetProduct.be;
    } else {
      lastVisitedProducts = [product].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(lastVisitedProducts));
    }

    lastVisitedProducts = lastVisitedProducts.sort(function (a, b) {
      return Number(b.be) - Number(a.be) || b.timestamp - a.timestamp;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "z"]);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* setInLocalStorage */ "c"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "B"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "y"], lastVisitedProducts));
  }
}

/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "o"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "fhLv":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "fnDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ValidationError;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];

/***/ }),

/***/ "fuxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceOfStayArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPriceOfStay; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var getChildrenBirthdates = function getChildrenBirthdates(_ref) {
  var _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids;
  return (// $FlowFixMe flow could not predict value after a filter and a map
    kids.filter(function (_ref2) {
      var birthdate = _ref2.birthdate;
      return !!birthdate;
    }).map(function (kid) {
      return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(kid.birthdate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* API_DATE_FORMAT */ "a"]);
    })
  );
};

var getNumberAttendees = function getNumberAttendees(_ref3) {
  var _ref3$adults = _ref3.adults,
      adults = _ref3$adults === void 0 ? [] : _ref3$adults,
      _ref3$kids = _ref3.kids,
      kids = _ref3$kids === void 0 ? [] : _ref3$kids;
  var kidsWithBirthdates = kids.filter(function (_ref4) {
    var birthdate = _ref4.birthdate;
    return !!birthdate;
  });
  return adults.length + kidsWithBirthdates.length;
};

var getPriceOfStayArgs = function getPriceOfStayArgs(searchCriteria) {
  var productId = searchCriteria.productId,
      departureDate = searchCriteria.departureDate,
      duration = searchCriteria.duration,
      departureCity = searchCriteria.departureCity,
      offerName = searchCriteria.offerName;
  var numberAttendees = getNumberAttendees(searchCriteria);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    productId: productId,
    departureDate: Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(departureDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* API_DATE_FORMAT */ "a"]),
    duration: duration
  }, numberAttendees && {
    numberAttendees: numberAttendees
  }), numberAttendees && {
    childrenBirthdates: getChildrenBirthdates(searchCriteria)
  }), departureCity !== _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* DEFAULT_DEPARTURE_CITY_VALUE */ "q"] && {
    departureCity: departureCity
  }), offerName && {
    offerName: _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__["url"].decodePath(offerName)
  });
};
var fetchPriceOfStay = function fetchPriceOfStay(appContext, searchCriteria) {
  var args = getPriceOfStayArgs(searchCriteria);
  var argsString = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_13__[/* buildArgs */ "a"])(args);
  var query = "query {\n      priceOfStay(".concat(argsString, ") {\n        ... on ErrorsPriceOfStayType {\n          errors {\n            errorCode\n            errorDescription\n            errorValue\n          }\n        }\n        ... on PriceOfStayType {\n          accommodationId\n          accommodationLabel\n          bestPrice {\n            value\n            formattedValue\n          }\n          currency\n          gap\n          includesChildcare\n          includesTransportation\n          initialPrice {\n            value\n            formattedValue\n          }\n          rate\n          resource\n          unit {\n            id\n            label\n          }\n          offerColor\n          productId\n          yieldPricingVariation\n        }\n      }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* STATE_PRODUCT_PRICE_OF_STAY */ "dd"]
  });
};

/***/ }),

/***/ "fw2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kq48");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "fysP":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("IBsm"),
    toInteger = __webpack_require__("m2YG"),
    toNumber = __webpack_require__("nvU9"),
    toString = __webpack_require__("dw5g");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),

/***/ "g51W":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js
var themes = {
  "default": function _default() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'border-b-1 border-lightGrey flex isolate relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-sienna border-b-2 border-sienna -mb-1 opacity-0 bottom-0 start-0 w-full sm:w-1/5 sm:ms-25 transition-opacity duration-250 ease-in z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden py-20 text-initial text-black hocus:text-black-active transition-color',
      thTitle: 'flex-1 flex gap-10 items-center font-bold font-sans leading-tight max-w-full text-current text-20',
      thTitleHasEllipsis: true,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-black transition-transform duration-250 ease-in ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom',
      thContentInner: 'py-40'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative text-14',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden p-20 text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  homeDetails: function homeDetails() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center max-w-full text-14 font-bold',
      thTitleHasEllipsis: false,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.75rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500 bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
      thHeader: 'flex isolate relative',
      thButton: 'flex flex-1 items-center max-w-full overflow-hidden p-15 text-initial text-black',
      thTitle: 'flex flex-1 font-semibold gap-10 items-center max-w-full',
      thTitleIcon: 'text-sienna',
      thTitleIconSize: '1.875rem',
      thLabels: 'flex items-center ms-auto shrink-0 text-14 text-black whitespace-nowrap',
      thLabelIcon: 'ms-10 text-black',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].ARROW_DOWN : _collapsePanelProps$e,
      _collapsePanelProps$h = collapsePanelProps.headerClassName,
      headerClassName = _collapsePanelProps$h === void 0 ? '' : _collapsePanelProps$h,
      iconName = collapsePanelProps.iconName,
      iconSize = collapsePanelProps.iconSize,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: Object(classnames_utils["a" /* classnames */])(headerClassName, thHeader)
  }, __jsx("button", {
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button"
  }, !!title && __jsx("span", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0', thTitleIcon),
    name: iconName,
    width: iconSize || thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "w-full truncate"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("span", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: Object(classnames_utils["a" /* classnames */])(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children)))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "gIGD":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("XywU");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "gp/v":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "gqH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function (value, options) {
      var schema = mapFn(value, options);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(options) {
    return this._resolve(options.value, options);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  _proto.validateSync = function validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  };

  _proto.validateAt = function validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  };

  _proto.validateSyncAt = function validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "h3D+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Multimedia; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flattenDeep.js
var flattenDeep = __webpack_require__("cdI6");
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/medias/medias.js
var medias_medias = __webpack_require__("SyAd");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.themes.js

var ActionButtonsGroup_themes_themes = function themes(_ref) {
  var isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      reverseLabelAndNumber = _ref.reverseLabelAndNumber;
  return {
    "default": {
      thRoot: 'flex flex-wrap -m-1',
      thButton: 'cursor-pointer bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thButtonActive: 'cursor-default bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 pointer-events-none p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thIcon: '',
      thIconLgSize: '3.25rem',
      thIconSize: '1.625rem',
      thText: 'text-initial',
      thNumber: 'block leading-1'
    },
    overlay: {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex gap-10', {
        'mt-auto flex-wrap justify-center': !isScrollable,
        'mt-auto overflow-x-scroll sm:overflow-hidden': isScrollable
      }),
      thButton: 'bg-white hocus:bg-white-active capitalize cursor-pointer flex font-bold gap-5 items-center justify-center px-20 py-10 rounded-pill text-12 text-black hocus:text-black-active duration-250 ease-in transition-all',
      thButtonActive: 'cursor-default bg-black/60 capitalize flex font-bold gap-5 items-center justify-center px-20 py-10 pointer-events-none rounded-pill text-12 text-white duration-250 ease-in transition-all',
      thIcon: 'shrink-0 overflow-visible',
      thIconLgSize: '3rem',
      thIconSize: '1.5rem',
      thText: "flex ".concat(reverseLabelAndNumber ? 'flex-row-reverse ' : '', " font-bold justify-between w-full text-initial"),
      thNumber: 'ps-5'
    },
    overlayCompact: {
      thRoot: Object(classnames_utils["a" /* classnames */])('lg:hidden', {
        'mt-auto flex flex-wrap justify-center rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active': !isScrollable,
        'mt-auto flex overflow-x-scroll rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active sm:overflow-hidden': isScrollable
      }),
      thButton: 'text-inherit leading-none mx-5',
      thButtonActive: 'text-inherit leading-none',
      thIcon: 'shrink-0 overflow-visible align-middle',
      thIconLgSize: '3rem',
      thIconSize: '1rem',
      thText: '',
      thHideLabel: true,
      thOverrideMinWidth: true,
      thNumber: ''
    },
    accommodation: {
      thRoot: "divide-y md:divide-x flex flex-col md:flex-row h-full justify-center overflow-hidden border-1 border-t-0 border-".concat(isExclusiveCollection ? 'ultramarine' : 'lightGrey', " rounded-b-12 w-full"),
      thButton: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thButtonActive: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thIcon: "overflow-visible text-".concat(isExclusiveCollection ? 'ultramarine' : 'black'),
      thIconLgSize: '4rem',
      thIconSize: '2rem',
      thText: 'font-bold text-initial text-black duration-250 ease-in transition-all',
      thNumber: 'ps-5'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.jsx


var __jsx = react_default.a.createElement;





var ActionButtonsGroup_ActionButtonsGroup = function ActionButtonsGroup(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$minWidth = _ref.minWidth,
      minWidthProp = _ref$minWidth === void 0 ? 'initial' : _ref$minWidth,
      _ref$reverseLabelAndN = _ref.reverseLabelAndNumber,
      reverseLabelAndNumber = _ref$reverseLabelAndN === void 0 ? true : _ref$reverseLabelAndN,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  var _themes$theme = ActionButtonsGroup_themes_themes({
    isExclusiveCollection: isExclusiveCollection,
    isScrollable: isScrollable,
    reverseLabelAndNumber: reverseLabelAndNumber
  })[theme],
      thRoot = _themes$theme.thRoot,
      thButton = _themes$theme.thButton,
      thButtonActive = _themes$theme.thButtonActive,
      thIcon = _themes$theme.thIcon,
      thIconLgSize = _themes$theme.thIconLgSize,
      thIconSize = _themes$theme.thIconSize,
      thText = _themes$theme.thText,
      thHideLabel = _themes$theme.thHideLabel,
      thOverrideMinWidth = _themes$theme.thOverrideMinWidth,
      thNumber = _themes$theme.thNumber;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, items.map(function (_ref2) {
    var ariaLabel = _ref2.ariaLabel,
        buttonClassName = _ref2.buttonClassName,
        dataTestId = _ref2.dataTestId,
        iconIsNotSquare = _ref2.iconIsNotSquare,
        iconName = _ref2.iconName,
        id = _ref2.id,
        isActive = _ref2.isActive,
        label = _ref2.label,
        minWidth = _ref2.minWidth,
        number = _ref2.number,
        _onClick = _ref2.onClick,
        trackingData = _ref2.trackingData;
    return __jsx("button", {
      "aria-disabled": isActive,
      "aria-label": ariaLabel,
      className: Object(classnames_utils["a" /* classnames */])(buttonClassName, Object(defineProperty["a" /* default */])({}, thButtonActive, isActive), Object(defineProperty["a" /* default */])({}, thButton, !isActive)),
      "data-testid": dataTestId,
      key: "ActionButtonsGroup-".concat(id),
      onClick: function onClick() {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        trackingData && track(trackingData);
      },
      style: {
        minWidth: thOverrideMinWidth ? 'initial' : minWidth || minWidthProp
      },
      type: "button"
    }, iconName && __jsx(Icon["a" /* Icon */], {
      className: thIcon,
      isNotSquare: iconIsNotSquare,
      name: iconName,
      width: iconIsNotSquare ? thIconLgSize : thIconSize
    }), label && !thHideLabel && __jsx("span", {
      className: thText
    }, number && __jsx("span", {
      className: thNumber
    }, "".concat(number, " ")), label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/frameworks/carousel/Carousel.jsx

var Carousel_jsx = react_default.a.createElement;






var Carousel_Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;
  var childrenCount = react["Children"].toArray(children).filter(Boolean).length;

  if (!childrenCount) {
    return null;
  }

  return Carousel_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate overflow-hidden', className)
  }, Carousel_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "h-full w-full",
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: initialIndex,
    items: children
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        index = _ref2.index,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return Carousel_jsx("div", {
      className: "relative isolate flex w-full flex-1 pb-20"
    }, itemsNode, hasControls && Carousel_jsx("div", {
      className: "fap-10 pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-20"
    }, !isPreviousControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 me-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 ms-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasControls && Carousel_jsx("div", {
      className: "absolute bottom-0 left-0 w-full"
    }, Carousel_jsx(ProgressBar["a" /* ProgressBar */], {
      color: colors["a" /* COLORS */].WHITE,
      max: childrenCount,
      min: 1,
      value: index + 1
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/utils/youku-api/index.js






function getVideoThumbnailUrl(videoId) {
  var clientId = config_default.a.get('youku.clientId');

  if (!clientId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku client Id'));
  }

  if (!videoId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku video Id'));
  }

  return axios_default.a.get("https://api.youku.com/videos/show.json?client_id=".concat(clientId, "&video_id=").concat(videoId)).then(function (response) {
    return response.data.bigThumbnail || response.data.thumbnail || new errors["d" /* NotFoundError */]('Youku video not found');
  })["catch"](function () {
    return null;
  });
}
// CONCATENATED MODULE: ./src/client/components/frameworks/image/YoukuThumbnail.jsx











var YoukuThumbnail_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var YoukuThumbnail_YoukuThumbnail = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(YoukuThumbnail, _Component);

  var _super = _createSuper(YoukuThumbnail);

  function YoukuThumbnail(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, YoukuThumbnail);

    _this = _super.call(this, props);
    _this.state = {
      thumbnailUrl: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(YoukuThumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
      var urlMatch = youkuRegEx.exec(this.props.imageUrl);

      if (urlMatch && urlMatch[1]) {
        getVideoThumbnailUrl(urlMatch[1]).then(function (youkuThumbnail) {
          _this2.setState({
            thumbnailUrl: youkuThumbnail
          });
        }).catch(function () {
          return null;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thumbnailUrl = this.state.thumbnailUrl;
      return YoukuThumbnail_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, this.props, {
        imageUrl: thumbnailUrl
      }));
    }
  }]);

  return YoukuThumbnail;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ./src/client/components/frameworks/media-thumbnail/MediaThumbnail.jsx

var MediaThumbnail_jsx = react_default.a.createElement;






var MediaThumbnail_MediaThumbnail = function MediaThumbnail(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      hasLazyLoading = _ref.hasLazyLoading,
      iconName = _ref.iconName,
      _onClick = _ref.onClick,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].M : _ref$ratio,
      src = _ref.src,
      trackingData = _ref.trackingData,
      ratioDisplay = _ref.ratioDisplay;
  var hasChildren = !!react["Children"].count(children);
  var track = Object(useTracking["a" /* useTracking */])(trackingData);

  if (!hasChildren && isEmpty_default()(src)) {
    return null;
  }

  return MediaThumbnail_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('relative block h-full w-full overflow-hidden bg-white transition-opacity duration-250 ease-in hover:opacity-75', className),
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      trackingData && track();
    },
    type: "button"
  }, hasChildren ? children : MediaThumbnail_jsx(Image["b" /* default */], {
    altMsg: alt,
    hasLazyLoading: hasLazyLoading,
    imageUrl: src,
    ratioKey: ratio,
    ratioDisplay: ratioDisplay
  }), !!iconName && MediaThumbnail_jsx("div", {
    className: "absolute end-0 top-0 m-5 size-50 bg-black/60 p-10 leading-0 text-white"
  }, MediaThumbnail_jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: "100%"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia-launcher/MultimediaLauncher.jsx





var MultimediaLauncher_jsx = react_default.a.createElement;









var YOUKU_SRC = 'vthumb.ykimg.com';

function MultimediaLauncherThumbnail(props) {
  return props.src ? MultimediaLauncher_jsx(MediaThumbnail_MediaThumbnail, Object(esm_extends["a" /* default */])({}, props, {
    hasLazyLoading: props.hasLazyLoading
  }), props.src.includes(YOUKU_SRC) ? MultimediaLauncher_jsx(YoukuThumbnail_YoukuThumbnail, {
    imageUrl: props.src,
    ratioKey: props.ratio
  }) : null) : null;
}

function MultimediaLauncher(_ref) {
  var buttons = _ref.buttons,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isImageSlideShow = _ref.isImageSlideShow,
      isOverlay = _ref.isOverlay,
      _ref$medias = _ref.medias,
      medias = _ref$medias === void 0 ? [] : _ref$medias,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      theme = _ref.theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var defaultTheme = isOverlay ? 'overlay' : 'default';
  var computedTheme = theme || defaultTheme;
  return MultimediaLauncher_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-full overflow-hidden', {
      'rounded-12': computedTheme === 'default'
    }, className)
  }, !isOverlay && !isImageSlideShow && (isTablet ? MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 -m-1 flex animate-fadeIn border-b-1 border-transparent"
  }, MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-1"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading,
    ratioDisplay: 1 / 2
  }))), MultimediaLauncher_jsx("div", {
    className: "flex w-1/2 flex-wrap"
  }, medias.slice(1, 5).map(function (media) {
    return MultimediaLauncher_jsx("div", {
      className: "w-1/2 p-1",
      key: "MultimediaLauncherThumbnail-".concat(media.src)
    }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, media, {
      hasLazyLoading: hasLazyLoading,
      ratioDisplay: 1 / 4
    })));
  }))) : MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn border-b-2 border-transparent"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading
  })))), !isOverlay && isImageSlideShow && MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn"
  }, medias.length > 0 ? MultimediaLauncher_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    className: className,
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    hasInfiniteScroll: true,
    hasLazyLoading: false,
    media: medias.map(function (_ref2) {
      var alt = _ref2.alt,
          onClick = _ref2.onClick,
          src = _ref2.src;
      return {
        alt: alt,
        onClick: onClick,
        src: src
      };
    }),
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["c" /* default */].XL
  }) : MultimediaLauncher_jsx(Image["b" /* default */], {
    altMsg: medias[0].alt,
    hasLazyLoading: false,
    imageUrl: medias[0].src,
    ratioKey: ratios_utils["c" /* default */].XL
  })), MultimediaLauncher_jsx(ActionButtonsGroup_ActionButtonsGroup, {
    className: "animation-duration-500 animate-fadeIn",
    isExclusiveCollection: isExclusiveCollection,
    items: buttons,
    minWidth: isOverlay ? '6.25rem' : '8.4375rem',
    theme: computedTheme
  }));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/map/StreetView.jsx
var StreetView = __webpack_require__("HKmi");

// CONCATENATED MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx


























var Multimedia_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Multimedia_createSuper(Derived) { var hasNativeReflectConstruct = Multimedia_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Multimedia_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};

var Multimedia_Multimedia = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_Multimedia, _Component);

  var _super = Multimedia_createSuper(_Multimedia);

  function _Multimedia(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _Multimedia);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeCarousel", function () {
      _this.setState({
        activeMedias: '',
        carouselIndex:  false || _this.props.initialIndex
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showCarousel", function (type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState({
        activeMedias: type,
        carouselIndex: index
      });
    });

    _this.state = {
      activeMedias: '',
      carouselIndex: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_Multimedia, [{
    key: "getCarouselItem",

    /* Carousel */
    // eslint-disable-next-line max-params, class-methods-use-this, clubmed/no-fake-component
    value: function getCarouselItem(type, _ref, altMsg, isDesktop) {
      var fov = _ref.fov,
          heading = _ref.heading,
          latitude = _ref.latitude,
          longitude = _ref.longitude,
          url = _ref.url;

      switch (type) {
        case medias_medias["b" /* MEDIA_TYPES */].PHOTOS:
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaPhoto",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }));

        case medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS:
          if (url === null || url === void 0 ? void 0 : url.includes('matterport')) {
            return Multimedia_jsx("iframe", {
              title: "matterport iframe",
              width: "100%",
              height: "100%",
              src: "".concat(url, "&play=1"),
              frameBorder: "0",
              id: "matterport-iframe"
            });
          }

          return Multimedia_jsx(StreetView["a" /* StreetView */], {
            fov: fov,
            heading: heading,
            key: "CarouselItem-".concat(type, "-").concat(latitude, "-").concat(longitude),
            latitude: latitude,
            longitude: longitude
          });

        case medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN:
          return isDesktop ? Multimedia_jsx("div", {
            className: "h-full pt-20"
          }, Multimedia_jsx("div", {
            "data-testid": "MultimediaFloorplan",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }))) : Multimedia_jsx("div", {
            className: "flex h-full max-w-screen flex-col justify-center"
          }, Multimedia_jsx(Zoom["a" /* Zoom */], {
            imageUrl: url,
            altMsg: "Floor plan",
            inert: true
          }));

        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS:
        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS360:
          return Multimedia_jsx(Video["a" /* Video */], {
            className: "static m-auto flex h-full flex-1 items-center justify-center overflow-hidden md:w-4/5 md:max-w-4/5",
            key: "CarouselItem-".concat(type, "-").concat(url),
            url: url
          });

        default:
          return null;
      }
    }
  }, {
    key: "getCarouselItems",
    value: function getCarouselItems(type, isDesktop) {
      var _this2 = this;

      var _this$props = this.props,
          medias = _this$props.medias,
          _this$props$pictureAl = _this$props.pictureAltLabel,
          pictureAltLabel = _this$props$pictureAl === void 0 ? '' : _this$props$pictureAl;
      return (medias[type] || []).map(function (media, idx) {
        var altMsg = (media === null || media === void 0 ? void 0 : media.alt) || Object(dist["messageFormat"])(pictureAltLabel).format({
          nb: idx + 1,
          total: medias[type].length
        });

        var carouselItem = _this2.getCarouselItem(type, media, altMsg, isDesktop);

        return Multimedia_jsx(react["Fragment"], {
          key: "CarouselItemWrapper-".concat(type, "-").concat(media.url)
        }, carouselItem);
      });
    }
    /* Medias */

  }, {
    key: "hasMedias",
    value: function hasMedias(isDesktop) {
      var _this3 = this;

      return Object.keys(this.props.medias).reduce(function (has, type) {
        return has || _this3.hasTypeMedias(type, isDesktop);
      }, false);
    }
  }, {
    key: "hasTypeMedias",
    value: function hasTypeMedias(type, isDesktop) {
      var hasTypeMedias = Array.isArray(get_default()(this.props, ['medias', type])) && get_default()(this.props, ['medias', type]).length > 0;

      if (type === medias_medias["b" /* MEDIA_TYPES */].VIDEOS360) {
        return hasTypeMedias && isDesktop;
      }

      return hasTypeMedias;
    }
  }, {
    key: "mapLauncherMedias",
    value: function mapLauncherMedias(type, isDesktop) {
      var _this4 = this;

      var medias = this.hasTypeMedias(type, isDesktop) ? this.props.medias[type] : [];
      return medias.map(function (media, index) {
        return {
          alt: Object(dist["messageFormat"])(_this4.props.launcherPictureAltLabel || '').format({
            nb: index + 1,
            mediaType: _this4.props.labels && _this4.props.labels[type]
          }),
          hasForcedImage: !!media.thumbnailUrl,
          iconName: type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? '' : medias_medias["a" /* ICONS */][type],
          onClick: function onClick() {
            var _this4$props, _this4$props$onClickM;

            (_this4$props = _this4.props) === null || _this4$props === void 0 ? void 0 : (_this4$props$onClickM = _this4$props.onClickMediaBtn) === null || _this4$props$onClickM === void 0 ? void 0 : _this4$props$onClickM.call(_this4$props, type);

            _this4.showCarousel(type, index);
          },
          ratio: _this4.props.ratioKey,
          src: media.thumbnailUrl || media.url || media.imageLarge || ''
        };
      });
    }
  }, {
    key: "getLauncherMedias",
    value: function getLauncherMedias(isDesktop, hasImageSlideShowLauncher) {
      var _this5 = this;

      var types = hasImageSlideShowLauncher ? [medias_medias["b" /* MEDIA_TYPES */].PHOTOS] : medias_medias["e" /* ORDERED_MEDIAS_LAUNCHER */];
      return flattenDeep_default()(types.map(function (type) {
        return _this5.mapLauncherMedias(type, isDesktop);
      })).filter(function (i) {
        return !!i.src;
      });
    }
  }, {
    key: "getLauncherProps",
    value: function getLauncherProps(isDesktop) {
      var _this6 = this;

      var _this$props2 = this.props,
          _this$props2$hasImage = _this$props2.hasImageSlideShowLauncher,
          hasImageSlideShowLauncher = _this$props2$hasImage === void 0 ? false : _this$props2$hasImage,
          _this$props2$hasFullS = _this$props2.hasFullScreenButton,
          hasFullScreenButton = _this$props2$hasFullS === void 0 ? false : _this$props2$hasFullS,
          _this$props2$labels = _this$props2.labels,
          labels = _this$props2$labels === void 0 ? {} : _this$props2$labels,
          _this$props2$medias = _this$props2.medias,
          medias = _this$props2$medias === void 0 ? {} : _this$props2$medias,
          openGalleryLabel = _this$props2.openGalleryLabel,
          initialIndex = _this$props2.initialIndex;
      var hasPhotosTypeMedias = this.hasTypeMedias(medias_medias["b" /* MEDIA_TYPES */].PHOTOS, isDesktop);

      var getIndexToOpenTo = function getIndexToOpenTo(type, index) {
        if (type !== medias_medias["b" /* MEDIA_TYPES */].PHOTOS) {
          return index;
        }

        return initialIndex || index;
      };

      var getButton = function getButton(type, index) {
        var numberOfItems = Array.isArray(medias === null || medias === void 0 ? void 0 : medias[type]) && type !== medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN ? medias[type].length : null;
        return {
          ariaLabel: openGalleryLabel ? "".concat(labels[type], " (").concat(get_default()(medias, [type], []).length, ") - ").concat(openGalleryLabel) : null,
          dataTestId: "Multimedia-".concat(type, "-button"),
          iconIsNotSquare: type === medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS,
          iconName: medias_medias["a" /* ICONS */][type],
          id: type,
          isActive: type === _this6.state.activeMedias,
          label: labels[type],
          number: numberOfItems,
          onClick: function onClick() {
            var _this6$props, _this6$props$onClickM;

            (_this6$props = _this6.props) === null || _this6$props === void 0 ? void 0 : (_this6$props$onClickM = _this6$props.onClickMediaBtn) === null || _this6$props$onClickM === void 0 ? void 0 : _this6$props$onClickM.call(_this6$props, type);

            _this6.showCarousel(type, getIndexToOpenTo(type, index));
          }
        };
      };

      var buttons = medias_medias["d" /* ORDERED_MEDIAS */].map(function (type, index) {
        var internalIndex = type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? index : 0;
        return _this6.hasTypeMedias(type, isDesktop) ? getButton(type, internalIndex) : null;
      }).filter(Boolean);
      var extraButtons = [hasFullScreenButton ? _objectSpread(_objectSpread({}, getButton(medias_medias["b" /* MEDIA_TYPES */].PHOTOS)), {}, {
        iconName: icons["a" /* ICONS */].EXPAND,
        label: '',
        minWidth: 'initial',
        buttonClassName: 'absolute end-0 md:bottom-0 md:top-auto top-0 mt-10 md:mx-10 md:mx-20 mb-0'
      }) : null].filter(Boolean);
      return {
        buttons: buttons,
        extraButtons: extraButtons,
        medias: hasImageSlideShowLauncher && hasPhotosTypeMedias ? this.getLauncherMedias(isDesktop, hasImageSlideShowLauncher) // $FlowFixMe
        : this.getLauncherMedias(isDesktop).slice(0, 5)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return Multimedia_jsx(ResponsiveContext["a" /* ResponsiveContext */].Consumer, null, function (_ref2) {
        var isDesktop = _ref2.isDesktop;

        if (!_this7.hasMedias(isDesktop)) {
          return null;
        }

        var _this7$state = _this7.state,
            activeMedias = _this7$state.activeMedias,
            carouselIndex = _this7$state.carouselIndex;
        var _this7$props = _this7.props,
            className = _this7$props.className,
            closeLabel = _this7$props.closeLabel,
            descriptionLabels = _this7$props.descriptionLabels,
            galleryLabel = _this7$props.galleryLabel,
            hasImageSlideShowLauncher = _this7$props.hasImageSlideShowLauncher,
            isExclusiveCollection = _this7$props.isExclusiveCollection,
            isOverlay = _this7$props.isOverlay,
            nextLabel = _this7$props.nextLabel,
            portalName = _this7$props.portalName,
            previousLabel = _this7$props.previousLabel,
            theme = _this7$props.theme; // $FlowFixMe

        var descriptionLabel = descriptionLabels === null || descriptionLabels === void 0 ? void 0 : descriptionLabels[activeMedias];

        var items = _this7.getCarouselItems(activeMedias, isDesktop);

        var launcherProps = _this7.getLauncherProps(isDesktop);

        return Multimedia_jsx(react["Fragment"], null, Multimedia_jsx(MultimediaLauncher, {
          buttons: [].concat(Object(toConsumableArray["a" /* default */])(launcherProps.buttons), Object(toConsumableArray["a" /* default */])(launcherProps.extraButtons)),
          className: className,
          closeLabel: closeLabel,
          galleryLabel: galleryLabel,
          isExclusiveCollection: isExclusiveCollection,
          hasLazyLoading: true,
          isImageSlideShow: hasImageSlideShowLauncher,
          isOverlay: isOverlay,
          medias: launcherProps.medias,
          nextLabel: nextLabel,
          previousLabel: previousLabel,
          theme: theme
        }), !!activeMedias && Multimedia_jsx(Backdrop["a" /* Backdrop */], {
          ariaLabel: galleryLabel,
          className: "backdrop-blur-[4px] backdrop-saturate-0",
          closeLabel: closeLabel,
          hasCloseButton: true,
          onClose: _this7.closeCarousel,
          portalName: portalName
        }, Multimedia_jsx("div", {
          className: "flex h-full w-full flex-col"
        }, Multimedia_jsx(Carousel_Carousel, {
          className: "flex flex-1",
          hasInfiniteScroll: true,
          initialIndex: carouselIndex,
          key: Math.random(),
          nextLabel: nextLabel,
          previousLabel: previousLabel
        }, items), descriptionLabel && Multimedia_jsx("div", {
          className: "flex w-full justify-center p-20 py-10"
        }, Multimedia_jsx("span", {
          className: "text-center text-12 text-white"
        }, descriptionLabel)), Multimedia_jsx("div", {
          className: "flex h-[72px] items-center justify-center px-10"
        }, Multimedia_jsx(ActionButtonsGroup_ActionButtonsGroup, {
          isScrollable: true,
          items: launcherProps.buttons,
          minWidth: "6.25rem",
          reverseLabelAndNumber: theme !== 'accommodation',
          theme: "overlay"
        })))));
      });
    }
  }]);

  return _Multimedia;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Multimedia_Multimedia, "defaultProps", {
  medias: {},
  ratioKey: ratios_utils["c" /* default */].L
});

var Multimedia = Multimedia_Multimedia;

/***/ }),

/***/ "h6Ot":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _google_map = __webpack_require__("xny9");

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _google_map2.default;

/***/ }),

/***/ "h9IM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if ( true && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else {}
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: Object(classnames_utils["a" /* classnames */])('mb-15', {
        'rounded-full bg-lightSand p-15 text-black': !isExclusiveCollection
      }, {
        'rounded-12 border-5 border-ultramarine p-10 text-ultramarine': isExclusiveCollection
      }),
      thIconWidth: '6.25rem',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "hB/3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}

/***/ }),

/***/ "hCAA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Condition =
/*#__PURE__*/
function () {
  function Condition(refs, options) {
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  var _proto = Condition.prototype;

  _proto.resolve = function resolve(base, options) {
    var values = this.refs.map(function (ref) {
      return ref.getValue(options);
    });
    var schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  };

  return Condition;
}();

var _default = Condition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "hLcx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _propertyExpr = __webpack_require__("dFUt");

var prefixes = {
  context: '$',
  value: '.'
};

var Reference =
/*#__PURE__*/
function () {
  function Reference(key, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0, _propertyExpr.getter)(this.path, true);
    this.map = options.map;
  }

  var _proto = Reference.prototype;

  _proto.getValue = function getValue(options) {
    var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  };

  _proto.cast = function cast(value, options) {
    return this.getValue((0, _extends2.default)({}, options, {
      value: value
    }));
  };

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.describe = function describe() {
    return {
      type: 'ref',
      key: this.key
    };
  };

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  Reference.isRef = function isRef(value) {
    return value && value.__isYupRef;
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];

/***/ }),

/***/ "hU7e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var hasOwn = __webpack_require__("/GgU");
var isSymbol = __webpack_require__("km0D");
var tryToString = __webpack_require__("xS1b");
var shared = __webpack_require__("8+jV");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("6qX7");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "hUUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Legend; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Legend = function Legend(_ref) {
  var className = _ref.className,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo;
  return __jsx("legend", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('font-bold inline-block text-14 text-black', className)
  }, label, isRequired && '*', labelAdditionalInfo && __jsx("span", {
    className: "font-normal ms-10 text-12 text-grey"
  }, labelAdditionalInfo));
};

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(function ProductHeader(_ref) {
  var className = _ref.className,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {
    url: ''
  } : _ref$link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  return __jsx("header", {
    className: className,
    "data-testid": "Product-Header"
  }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
    className: "flex min-w-0 flex-col-reverse",
    "data-testid": "ProductHeader-link",
    onClick: onClick,
    tagname: "div",
    url: isLinkDisabled ? '' : link.url
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], {
    className: "flex font-sans text-18 font-semibold",
    hasEllipsis: true,
    hLevel: 2,
    theme: "none"
  }, title), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], {
    className: "flex font-sans text-14 font-semibold text-sienna",
    hasEllipsis: true,
    hLevel: 3,
    theme: "none"
  }, subtitle)));
});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i0Sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];

/***/ }),

/***/ "i2OK":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var defineBuiltIn = __webpack_require__("Swp0");
var toString = __webpack_require__("3dm5");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "i3Ve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modal_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("EvYw");
/* harmony import */ var _toggler_Toggler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7CPK");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRdV");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;




var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      isExpanded = _ref.isExpanded,
      modalProps = _ref.modalProps,
      renderTrigger = _ref.renderTrigger,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_4__[/* useTracking */ "a"])(trackingData);
  return __jsx(_toggler_Toggler__WEBPACK_IMPORTED_MODULE_3__[/* Toggler */ "a"], {
    isActive: isExpanded,
    onToggle: function onToggle(isActive) {
      if (trackingData && isActive) {
        track();
      }
    }
  }, function (toggle, isActive) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, renderTrigger(toggle, isActive), isActive && __jsx(_modal_Modal__WEBPACK_IMPORTED_MODULE_2__[/* Modal */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, modalProps, {
      onClose: toggle
    }), children));
  });
};

/***/ }),

/***/ "iBXc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("EVS9");
var anObject = __webpack_require__("ep/x");
var aPossiblePrototype = __webpack_require__("2CYk");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "ieZH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toObject = __webpack_require__("A+R+");
var nativeGetPrototypeOf = __webpack_require__("yvHl");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "j6YP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductAccommodationsLine; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C/y5");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1JJ2");
/* harmony import */ var _productAccommodations_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5svr");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nv//");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("L7OA");
/* harmony import */ var _frameworks_introduction_Introduction__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("pNXd");
/* harmony import */ var _frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ZNfd");
/* harmony import */ var _frameworks_tabs_Tabs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4/4b");


var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;











var ProductAccommodationsLine = function ProductAccommodationsLine(props) {
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* useAppContext */ "c"])();

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_3__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  var _props$config = props.config;
  _props$config = _props$config === void 0 ? {} : _props$config;
  var _props$config$common = _props$config.common;
  _props$config$common = _props$config$common === void 0 ? {} : _props$config$common;
  var loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      _props$isLineExclusiv = props.isLineExclusiveCollection,
      isLineExclusiveCollection = _props$isLineExclusiv === void 0 ? false : _props$isLineExclusiv,
      accommodationsIntroduction = props.resort.accommodationsIntroduction;
  var queryLayer = isLineExclusiveCollection ? 'accommodationLayerEC' : 'accommodationLayer';
  var initialSelectedItem = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_8__[/* getOpenLayersFromLocation */ "h"])(asPath, queryLayer)[0];

  if (!props.config || !props.resort) {
    return null;
  }

  var accommodationCategories = Object(_productAccommodations_utils__WEBPACK_IMPORTED_MODULE_6__[/* groupAccommodationsByCategory */ "c"])(props);

  var _getTabsItemsAndProps = Object(_productAccommodations_utils__WEBPACK_IMPORTED_MODULE_6__[/* getTabsItemsAndPropsFromAccommodations */ "b"])(props, accommodationCategories),
      items = _getTabsItemsAndProps.items,
      slot = _getTabsItemsAndProps.slot;

  var displayRoomsComparator = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_9__[/* isFeatureFlipped */ "a"])(appContext)('displayRoomsComparator') && !isLineExclusiveCollection && accommodationCategories.length > 1;

  var content = __jsx(react__WEBPACK_IMPORTED_MODULE_4__["Fragment"], null, !isLineExclusiveCollection && accommodationsIntroduction && __jsx(_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_11__[/* SiteContainer */ "a"], {
    isWide: isTablet
  }, __jsx(_frameworks_introduction_Introduction__WEBPACK_IMPORTED_MODULE_10__[/* Introduction */ "a"], {
    className: "mb-50 mt-30 text-center",
    dataTestId: "Line-Product-Accommodations__Introduction",
    isTextSeeMoreCollapseEnabled: true,
    seeMoreLabel: viewMore,
    seeLessLabel: loadLess,
    text: accommodationsIntroduction.description,
    theme: "column",
    title: accommodationsIntroduction.shortDescription
  })), __jsx(_frameworks_tabs_Tabs__WEBPACK_IMPORTED_MODULE_12__[/* Tabs */ "a"], {
    hasControlsOnTouch: true,
    id: "product-accommodations-line-tabs",
    initialSelectedItem: initialSelectedItem,
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    slotRight: displayRoomsComparator ? function (activeIndexes) {
      return slot(activeIndexes);
    } : null
  }));

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_2__[/* classnames */ "a"])('Line', 'max-w-1220', 'md:site-container md:relative md:mx-auto md:w-full md:px-20'),
    id: id
  }, content);
};

/***/ }),

/***/ "jCye":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("ydRd");
var tryToString = __webpack_require__("xS1b");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "jHPj":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    pullAll = __webpack_require__("DyR2");

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),

/***/ "jLVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAvailableDurations; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rueY");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("RBO1");
/* harmony import */ var _store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("05PS");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");











var SUMMER = 'SUMMER';
var WINTER = 'WINTER';
var useAvailableDurations = function useAvailableDurations(_ref) {
  var _prices$apiDate;

  var initialTransport = _ref.initialTransport,
      productId = _ref.productId;
  var availableDurations = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__[/* getAvailableDurations */ "a"]);
  var prices = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__[/* getPricesByDays */ "m"]);
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureDate */ "b"]);
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureCity */ "a"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useDispatch */ "d"])();
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* useAppContext */ "c"])();
  var apiDate = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* timestampToApiDate */ "n"])(departureDate);
  var isSiblingOpen = !!(prices === null || prices === void 0 ? void 0 : (_prices$apiDate = prices[apiDate]) === null || _prices$apiDate === void 0 ? void 0 : _prices$apiDate.siblingOpen);
  var seasonProductId = isSiblingOpen ? productId.includes(SUMMER) && productId.replace(SUMMER, WINTER) || productId.replace(WINTER, SUMMER) : productId;
  var transport = departureCity || initialTransport;
  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    if (!availableDurations && transport) {
      dispatch(Object(_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_7__[/* fetchBookableDates */ "b"])({
        departureCity: departureCity || initialTransport,
        productId: seasonProductId
      }, appContext));
    }
  }, [seasonProductId, transport]);
  return availableDurations;
};

/***/ }),

/***/ "jLkM":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "jldR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Capsule_Capsule; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.styles.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var style = {
  capsule: {
    width: '100%',
    isolation: 'isolate',
    position: 'relative'
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  header: {
    borderRadius: '12px 12px 0 0',
    backgroundColor: '#924833',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
  },
  upsideHeader: {
    borderRadius: '0 0 12px 12px'
  },
  headerLarge: {
    backgroundColor: '#1E2643',
    height: '48px',
    position: 'relative'
  },
  headerAuto: {
    backgroundColor: '#1E2643',
    position: 'relative',
    padding: '10px',
    height: 'auto'
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 12px 12px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    border: 'solid 1px #d1d1d1'
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '12px 12px 0 0'
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '12px'
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px'
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px'
  },
  label: {
    fontFamily: 'Trident, Newsreader, Times New Roman, Times, serif',
    verticalAlign: '-3px'
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end'
  }
};
var styles = function styles(_ref) {
  var _ref$additionalStyle = _ref.additionalStyle,
      additionalStyle = _ref$additionalStyle === void 0 ? {
    header: {},
    content: {},
    icon: {},
    label: {}
  } : _ref$additionalStyle,
      color = _ref.color,
      isHeaderNone = _ref.isHeaderNone,
      isLargeHeader = _ref.isLargeHeader,
      isHeaderAuto = _ref.isHeaderAuto,
      upside = _ref.upside;
  return {
    computedCapsuleStyle: _objectSpread(_objectSpread(_objectSpread({}, style.capsule), upside ? style.upsideCapsule : null), additionalStyle.root),
    computedHeaderStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyleCollapsed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header), {}, {
      borderRadius: '5px'
    }),
    computedContentStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.content), upside ? style.upsideContent : null), isLargeHeader ? style.contentLargeHeader : null), isLargeHeader && upside ? style.upsideContentLargeHeader : null), isHeaderNone ? style.contentNoHeader : null), additionalStyle.content),
    computedIconWrapperStyle: _objectSpread({}, additionalStyle.icon),
    computedLabelStyle: _objectSpread(_objectSpread(_objectSpread({}, style.label), additionalStyle.label), {}, {
      marginLeft: '10px'
    }),
    computedCheckIconStyle: _objectSpread({}, style.checkIcon),
    computedChevronIconlStyle: {
      display: 'flex',
      width: '9px',
      height: '9px',
      stroke: 'white',
      strokeWidth: '2px',
      alignItems: 'center',
      marginTop: '-3px'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx
var __jsx = react_default.a.createElement;






var SMALL = 'small';
var LARGE = 'large';
var AUTO = 'auto';
var NONE = 'none';
var Capsule_Capsule = function Capsule(_ref) {
  var additionalStyle = _ref.additionalStyle,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      contentClassName = _ref.contentClassName,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? SMALL : _ref$header,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].ALL_INCLUSIVE : _ref$icon,
      label = _ref.label,
      upside = _ref.upside,
      validated = _ref.validated,
      _ref$isAccordion = _ref.isAccordion,
      isAccordion = _ref$isAccordion === void 0 ? false : _ref$isAccordion,
      dataTestId = _ref.dataTestId;
  var isLargeHeader = header === LARGE;
  var isHeaderNone = header === NONE;
  var isHeaderAuto = header === AUTO;

  var _styles = styles({
    additionalStyle: additionalStyle,
    color: color,
    isHeaderNone: isHeaderNone,
    isLargeHeader: isLargeHeader,
    isHeaderAuto: isHeaderAuto,
    upside: upside
  }),
      computedCapsuleStyle = _styles.computedCapsuleStyle,
      computedCheckIconStyle = _styles.computedCheckIconStyle,
      computedContentStyle = _styles.computedContentStyle,
      computedHeaderStyle = _styles.computedHeaderStyle,
      computedHeaderFullStyle = _styles.computedHeaderFullStyle,
      computedHeaderFullStyleCollapsed = _styles.computedHeaderFullStyleCollapsed,
      computedIconWrapperStyle = _styles.computedIconWrapperStyle,
      computedLabelStyle = _styles.computedLabelStyle,
      computedChevronIconlStyle = _styles.computedChevronIconlStyle;

  var _useState = Object(react["useState"])(!isAccordion ? true : false),
      displayed = _useState[0],
      setDisplayed = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var toggleDisplay = function toggleDisplay() {
    setDisplayed(function (display) {
      return !display;
    });
  };

  var custsomAccordionStyle = function custsomAccordionStyle() {
    if (isAccordion) {
      if (displayed) {
        return computedHeaderFullStyle;
      }

      return computedHeaderFullStyleCollapsed;
    }

    return computedHeaderStyle;
  };

  return __jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])('Capsule', className),
    style: computedCapsuleStyle,
    "data-testid": dataTestId
  }, header !== 'none' && __jsx("div", {
    onClick: isAccordion ? toggleDisplay : function () {},
    style: custsomAccordionStyle()
  }, (isLargeHeader || isHeaderAuto) && __jsx(react["Fragment"], null, __jsx("div", {
    className: "flex items-center"
  }, __jsx("div", {
    style: computedIconWrapperStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: icon,
    width: computedIconWrapperStyle.width || '1.25rem'
  })), __jsx("span", {
    style: computedLabelStyle
  }, label)), isAccordion && __jsx("span", {
    style: computedChevronIconlStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: "select",
    width: "1em",
    className: Object(classnames_utils["a" /* classnames */])('flex', {
      'rotate-180 transform': displayed
    })
  })))), __jsx("div", {
    className: contentClassName,
    style: computedContentStyle
  }, validated && __jsx("div", {
    className: "relative"
  }, __jsx("div", {
    style: computedCheckIconStyle
  }, __jsx(Icon["a" /* Icon */], {
    className: "text-success",
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "3rem"
  }))), isAccordion ? __jsx(lib["UnmountClosed"], {
    isOpened: displayed
  }, children) : children));
};

/***/ }),

/***/ "k4ez":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("a4SZ");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redirectToUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return redirectToOidc; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");









function redirectToUri(router) {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation(), uri).toString();
      router.push(redirectUri);
    };
  };
}
function redirectToOidc(appContext, redirectUrl) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = redirectUrl || currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}

/***/ }),

/***/ "kH/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addressFragment; });
var addressFragment = "\nfragment Address on Address {\n    additionalInformation1\n    additionalInformation2\n    addOn\n    city\n    country\n    countryCode\n    stateOrDistrict\n    streetName\n    streetNumber\n    town\n    zipCode\n  }\n";

/***/ }),

/***/ "kMkq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return synchronizeChildcareQPWithKidsQP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFacetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateActiveFacetsQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasDepartureCityAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterFacetsToHide; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInactiveFacetValues; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VqLN");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zygG");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("sW3P");
































var _facetsQueryParamMapp;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_CRITERIA_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_CITY_FACET_ID */ "r"]);
}

function getInactiveFacetValues(facets, activeFacets, facetId) {
  var _matchingFacet$list$m, _matchingFacet$list, _activeFacets$facetId;

  var _facets$filter = facets.filter(function (_ref) {
    var id = _ref.id;
    return id === facetId;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_facets$filter, 1),
      matchingFacet = _facets$filter2[0];

  var matchingFacetValues = (_matchingFacet$list$m = matchingFacet === null || matchingFacet === void 0 ? void 0 : (_matchingFacet$list = matchingFacet.list) === null || _matchingFacet$list === void 0 ? void 0 : _matchingFacet$list.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })) !== null && _matchingFacet$list$m !== void 0 ? _matchingFacet$list$m : [];
  var matchingActiveFacetValues = Object.keys((_activeFacets$facetId = activeFacets[facetId]) !== null && _activeFacets$facetId !== void 0 ? _activeFacets$facetId : {});
  return matchingFacetValues.filter(function (option) {
    return !matchingActiveFacetValues.includes(option);
  });
}

function filterFacetsToHide(facets, facetsToHide) {
  var facetIdsWithOptionsToHide = Object.keys(facetsToHide !== null && facetsToHide !== void 0 ? facetsToHide : {});
  return facets.map(function (facet) {
    if (facetIdsWithOptionsToHide.includes(facet.id)) {
      return _objectSpread(_objectSpread({}, facet), {}, {
        list: facet.list.filter(function (_ref3) {
          var value = _ref3.value;
          return !facetsToHide[facet.id].includes(value);
        })
      });
    }

    return facet;
  });
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facet, 'selected');
  });
  return selectedCity ? lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_31___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(timestampDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_31___default()(), 'day') : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_31___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"]) {
    return lodash_times__WEBPACK_IMPORTED_MODULE_30___default()(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_31___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function convertQueryParamToKids(value) {
  if (!value) {
    return [];
  }

  return value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
}

function convertKidsToChildcareQueryParam(_ref4) {
  var departureDate = _ref4.departureDate,
      kids = _ref4.kids;

  if (!departureDate) {
    return [];
  }

  return kids.reduce(function (acc, _ref5) {
    var birthdate = _ref5.birthdate;
    return birthdate ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(acc), [moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate).diff(moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate), 'months')]) : acc;
  }, []).map(function (diffInMonths) {
    if (diffInMonths >= 4 && diffInMonths < 24) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_0_TO_2 */ "i"];
    }

    if (diffInMonths >= 24 && diffInMonths < 48) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_2_TO_3 */ "k"];
    }

    if (diffInMonths >= 48 && diffInMonths < 132) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_4_TO_10 */ "l"];
    }

    if (diffInMonths >= 132 && diffInMonths < 216) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_11_TO_17 */ "j"];
    }

    return '';
  }).filter(Boolean);
}

function unserializeKidsFromQueryParam(value, isSeller) {
  var maxKidsNumber = isSeller ? _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX_SELLER */ "H"] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"];

  if (!value) {
    return [];
  }

  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > maxKidsNumber) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) {
    return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]));
  }

  var kids = convertQueryParamToKids(value);
  return kids.length > maxKidsNumber ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref6, index) {
    var birthdate = _ref6.birthdate,
        childcareIncluded = _ref6.childcareIncluded;

    if (!birthdate || !kidsValidationState || (kidsValidationState === null || kidsValidationState === void 0 ? void 0 : kidsValidationState.length) > 0 && kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"]);
    return childcareIncluded ? "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });
    return childcareIncluded ? "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]);
};
var synchronizeChildcareQPWithKidsQP = function synchronizeChildcareQPWithKidsQP(_ref7) {
  var childcareFacetQueryParam = _ref7.childcareFacetQueryParam,
      departureDate = _ref7.departureDate,
      departureDateQueryParam = _ref7.departureDateQueryParam,
      kids = _ref7.kids,
      _ref7$kidsQueryParam = _ref7.kidsQueryParam,
      kidsQueryParam = _ref7$kidsQueryParam === void 0 ? '' : _ref7$kidsQueryParam;
  var previousDepartureDate = formatDepartureDateForStore(departureDateQueryParam, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]);
  var previousKids = convertQueryParamToKids(kidsQueryParam);
  var previousChildcareIncluded = previousKids.some(function (kid) {
    return kid.childcareIncluded;
  });
  var childcareIncluded = kids.some(function (kid) {
    return kid.childcareIncluded;
  });

  if (!childcareIncluded && !previousChildcareIncluded) {
    // childcareIncluded checkbox unchecked and unchanged => no override
    return undefined;
  }

  var childcareRemoved = previousChildcareIncluded && !childcareIncluded;
  var kidsRemoved = previousKids.length > 0 && kids.length === 0;

  if (childcareRemoved || kidsRemoved) {
    // childcareIncluded checkbox unchecked or kids removed from FilterWho => reset childcare filter
    return '';
  } // childcareIncluded checkbox checked => override childcare filter with matching kids age range and existing childcare options


  var childcareFilterOptionsFromPreviousKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: previousDepartureDate,
    kids: previousKids
  })));

  var childcareFilterOptionsFromKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: departureDate,
    kids: kids
  })));

  var childcareFilterOptionsToRemove = childcareFilterOptionsFromPreviousKids.filter(function (option) {
    return !childcareFilterOptionsFromKids.includes(option);
  });
  var chilcareFilterOptions = childcareFacetQueryParam.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(childcareFilterOptionsFromKids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(chilcareFilterOptions.filter(function (option) {
    return !childcareFilterOptionsToRemove.includes(option);
  }))))).filter(Boolean).join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref8) {
  var birthdate = _ref8.birthdate,
      departureDate = _ref8.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_31___default()().add(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "s"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var customFacetsQueryParamMapping = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_34__[/* FLIGHT_DURATION_FACET_ID */ "C"], 'f');
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_ID */ "f"], 'ch'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* COUNTRIES_FACET_ID */ "m"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DESTINATIONS_FACET_ID */ "w"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"], 's'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* TYPES_OF_STAY_FACET_ID */ "Z"], 't'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$queryPar;

    var activeFacets = ((_queryParams$queryPar = queryParams[queryParamMapping[facetId]]) === null || _queryParams$queryPar === void 0 ? void 0 : _queryParams$queryPar.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"])) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      var facet = decodeURI(activeFacet);

      if (facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
        var _SEASON_FACET_QUERY_P;

        facet = (_SEASON_FACET_QUERY_P = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_EN_TO_FR */ "U"][facet]) !== null && _SEASON_FACET_QUERY_P !== void 0 ? _SEASON_FACET_QUERY_P : facet;
      }

      acc[facet] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});

    if (facet.length && facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
      facet = facet.map(function (label) {
        var _SEASON_FACET_QUERY_P2;

        return (_SEASON_FACET_QUERY_P2 = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_FR_TO_EN */ "V"][label]) !== null && _SEASON_FACET_QUERY_P2 !== void 0 ? _SEASON_FACET_QUERY_P2 : label;
      });
    }

    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, queryParamMapping[facetId], facet.length ? facet.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]) : undefined));
    return facets;
  }, {});
};
var hasDepartureCityAvailable = function hasDepartureCityAvailable(departureCities, departureCity) {
  return departureCities === null || departureCities === void 0 ? void 0 : departureCities.some(function (_ref9) {
    var value = _ref9.value;
    return value === departureCity;
  });
};


/***/ }),

/***/ "kZDm":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "kZEO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kjCq":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("yhbn");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "km0D":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var isCallable = __webpack_require__("ANQd");
var isPrototypeOf = __webpack_require__("VXxY");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "kq48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "l/UU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_OPTION_VALIDITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ALREADY_EXISTS; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var BOOKING_ALREADY_EXISTS = 'BOOKING_ALREADY_EXISTS';

/***/ }),

/***/ "l1aQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceRemoteSelector; });
var priceRemoteSelector = function priceRemoteSelector(_ref) {
  var priceRemote = _ref.priceRemote;
  return priceRemote || {};
};

/***/ }),

/***/ "l6h7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var defineGlobalProperty = __webpack_require__("9vpE");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "lPgN":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var hasOwn = __webpack_require__("/GgU");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineProperty = __webpack_require__("87KK").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zygG");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4xcl");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("RUiN");
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("GzVq");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsItemIds */ "b"])({
      id: item.headerId,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])({
      initialSelectedItem: props.initialSelectedItem || 0,
      initialSelectedItems: props.initialSelectedItems || [0]
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setInitialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    var router = Object(next_router__WEBPACK_IMPORTED_MODULE_14__["useRouter"])();
    var uri = new urijs__WEBPACK_IMPORTED_MODULE_15___default.a(router.asPath);
    var urihash = uri.hash();

    var hashChangeHandler = function hashChangeHandler(hash) {
      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(headerId));
      });
      var index = ids.indexOf("#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(hash)));

      if (index !== -1) {
        setInitialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        Object(_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__[/* scrollToElement */ "a"])("#".concat(mainId), 100);
      } else {
        setInitialItems({
          initialSelectedItem: 0,
          initialSelectedItems: [0]
        });
      }
    };

    Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
      if (urihash) {
        hashChangeHandler(urihash);
      }
    }, [urihash]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      setInitialItems: setInitialItems,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "lZ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOMMODATION_COMFORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORRESPONDANCE_ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VILLETA_ROOM_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORRESPONDENCE_CABIN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_TYPE; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);




/**
 * @see src/components/utils/icon/icons.js l40
 */
var ACCOMMODATION_COMFORT_ORDER = ['000017', // club
'000048', // club seaside view
'000022', // superior
'000061', // superior
'000018', // deluxe
'000039', // deluxe zen
'000047', // deluxe seaside view
'000056', // Deluxe Exclusive
'000019', // suite
'000020', // suite 5 tridents
'000024', // chalet
'000038', // villa
'000040' // oasis family
];
var SINGLE_ROOM = 'simpleRoom';
var SEPARATE_ROOMS = 'separatedRooms';
var CONNECTING_ROOMS = 'simpleRooms';
var SEPARATE_ROOMS_3 = 'separatedRooms3';
var CORRESPONDANCE_ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS
};
var CORRESPONDENCE_CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins'
};
var ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS_3
};
var CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins3'
};
var VILLETA_ROOM_REGEX = new RegExp(/^(B2|B2\+|B2T)+$/);


/***/ }),

/***/ "ljKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FastField; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Field; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Form; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ Formik; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ useFormikContext; });

// UNUSED EXPORTS: ErrorMessage, FieldArray, FormikConsumer, FormikContext, FormikProvider, connect, getActiveElement, getIn, insert, isEmptyArray, isEmptyChildren, isFunction, isInputEvent, isInteger, isNaN, isObject, isPromise, isString, move, prepareDataForValidation, replace, setIn, setNestedObjectValues, swap, useField, useFormik, validateYupSchema, withFormik, yupToFormErrors

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__("F0GY");
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);

// CONCATENATED MODULE: /opt/webapp/node_modules/formik/node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseGetTag.js
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ var _baseGetTag = (objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getNative.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getNative = (getValue);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_root.js
var _root = __webpack_require__("fw2E");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (Map);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var _defineProperty = (defineProperty);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var keys = (nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var keysIn = (nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__("1vCq");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbols.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var _getSymbols = (stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbolsIn.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function _getSymbolsIn_stubArray() {
  return [];
}

/* harmony default export */ var _getSymbolsIn = (_getSymbolsIn_stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _getAllKeys_nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _getAllKeys = (_getAllKeys_nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function _getAllKeysIn_nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _getAllKeysIn = (_getAllKeysIn_nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getTag.js
/** Used for built-in method references. */
var _getTag_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _getTag_nativeObjectToString = _getTag_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function _getTag_objectToString(value) {
  return _getTag_nativeObjectToString.call(value);
}

/* harmony default export */ var _getTag = (_getTag_objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneByTag.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var _initCloneByTag = (identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isPrototype.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var _isPrototype = (stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isBuffer.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isBuffer_stubFalse() {
  return false;
}

/* harmony default export */ var isBuffer = (isBuffer_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isMap.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isMap_stubFalse() {
  return false;
}

/* harmony default export */ var isMap = (isMap_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSet.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSet_stubFalse() {
  return false;
}

/* harmony default export */ var isSet = (isSet_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSymbol.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSymbol_stubFalse() {
  return false;
}

/* harmony default export */ var isSymbol = (isSymbol_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_toKey.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function _toKey_identity(value) {
  return value;
}

/* harmony default export */ var _toKey = (_toKey_identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toString.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function toString_identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_toString = (toString_identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

// EXTERNAL MODULE: /opt/webapp/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("oXkQ");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var formik_esm_isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var formik_esm_isEmptyChildren = function isEmptyChildren(children) {
  return react["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return formik_esm_isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && formik_esm_isObject(value) && formik_esm_isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = lodash_es_toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = lodash_es_clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = lodash_es_toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (formik_esm_isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = lodash_es_clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (formik_esm_isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/Object(react["createContext"])(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = Object(react["useContext"])(FormikContext);
  !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (react_fast_compare_default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = Object(react["useRef"])(props.initialValues);
  var initialErrors = Object(react["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = Object(react["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = Object(react["useRef"])(props.initialStatus);
  var isMounted = Object(react["useRef"])(false);
  var fieldRegistry = Object(react["useRef"])({});

  if (false) {}

  Object(react["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = Object(react["useReducer"])(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = Object(react["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {}

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = Object(react["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {}

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = Object(react["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = Object(react["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = Object(react["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = es.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  Object(react["useEffect"])(function () {
    if (validateOnMount && isMounted.current === true && react_fast_compare_default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = Object(react["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (isMounted.current === true && !react_fast_compare_default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = Object(react["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = Object(react["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = Object(react["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = Object(react["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = Object(react["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = Object(react["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = Object(react["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = Object(react["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = Object(react["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) { var activeElement; }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = Object(react["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = Object(react["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = Object(react["useCallback"])(function (nameOrOptions) {
    var isAnObject = formik_esm_isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = Object(react["useMemo"])(function () {
    return !react_fast_compare_default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = Object(react["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  Object(react["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {}

  return Object(react["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? Object(react["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || lodash_es_isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (lodash_es_isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? es(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = es(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];

function useEventCallback(fn) {
  var ref = Object(react["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return Object(react["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = formik_esm_isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  Object(react["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {}

  !fieldName ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {} // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  Object(react["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(component, _extends({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return Object(react["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return Object(react["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return Object(react["createElement"])(asElement, _extends({}, field, props), children);
}

var Form = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return Object(react["createElement"])("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return Object(react["createElement"])(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return Object(react["createElement"])(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(react["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return hoist_non_react_statics_cjs_default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return Object(react["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
      return Object(react["createElement"])(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoist_non_react_statics_cjs_default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var formik_esm_FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [lodash_es_cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !react_fast_compare_default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(react["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(react["Component"]);

formik_esm_FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/connect(formik_esm_FieldArrayInner);

var formik_esm_ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(react["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(react["Component"]);

var ErrorMessage = /*#__PURE__*/connect(formik_esm_ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var formik_esm_FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && render) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(render && children && !formik_esm_isEmptyChildren(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return Object(react["createElement"])(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return Object(react["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return Object(react["createElement"])(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(react["Component"]);

var FastField = /*#__PURE__*/connect(formik_esm_FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setCustomFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateCustomFilters; });
/* unused harmony export resetCustomFilters */
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSearchFilterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateFilters; });
/* unused harmony export resetFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setProductsFilteredWithActiveCustomFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setProductsBeforeActiveCustomFacetsFiltering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setIsSearchEnabled; });
/* unused harmony export setOrderByPrice */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("9QcM");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_TOGGLE_FACET_SELECTED */ "x"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = lodash_times__WEBPACK_IMPORTED_MODULE_14___default()(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_QUERY */ "w"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_19__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_27__[/* searchQuerySelector */ "q"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_INITIAL_PRICES */ "n"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "q"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_FACETS */ "c"], {
    categoryId: categoryId
  });
}
function clearAll() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_ALL */ "b"]);
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_REDIRECTION */ "i"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_SEARCH */ "j"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_CUSTOM_FILTERS */ "l"], {
    customFilters: customFilters
  });
}
function updateCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_CUSTOM_FILTERS */ "A"], {
    customFilters: customFilters
  });
}
function resetCustomFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_CUSTOM_FILTERS */ "g"]);
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_FILTERS */ "m"], {
    filters: filters
  });
}
function setSearchFilterList(searchFilterList) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_FILTERS */ "v"], {
    searchFilterList: searchFilterList
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_FILTERS */ "B"], {
    filters: filters
  });
}
function resetFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_FILTERS */ "h"]);
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(resetCustomFilters());
                dispatch(resetFilters());
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_DATE_REQUIRED */ "o"], {
    isDateRequired: isDateRequired
  });
}
function setProductsFilteredWithActiveCustomFacets(productsFilteredWithActiveCustomFacets) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS */ "t"], {
    productsFilteredWithActiveCustomFacets: productsFilteredWithActiveCustomFacets
  });
}
function setProductsBeforeActiveCustomFacetsFiltering(productsBeforeActiveCustomFacetsFiltering) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING */ "s"], {
    productsBeforeActiveCustomFacetsFiltering: productsBeforeActiveCustomFacetsFiltering
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_SEARCH_ENABLED */ "p"], {
    isSearchEnabled: isSearchEnabled
  });
}
function setOrderByPrice(orderByPrice) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_ORDER_BY_PRICE */ "r"], {
    orderByPrice: orderByPrice
  });
}

/***/ }),

/***/ "luEP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

exports.mixed = _mixed.default;

var _boolean = _interopRequireDefault(__webpack_require__("+Mso"));

exports.bool = _boolean.default;

var _string = _interopRequireDefault(__webpack_require__("E8R/"));

exports.string = _string.default;

var _number = _interopRequireDefault(__webpack_require__("4XSA"));

exports.number = _number.default;

var _date = _interopRequireDefault(__webpack_require__("+VQP"));

exports.date = _date.default;

var _object = _interopRequireDefault(__webpack_require__("5r8v"));

exports.object = _object.default;

var _array = _interopRequireDefault(__webpack_require__("AdY7"));

exports.array = _array.default;

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _Lazy = _interopRequireDefault(__webpack_require__("gqH2"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

exports.ValidationError = _ValidationError.default;

var _reach = _interopRequireDefault(__webpack_require__("zBae"));

exports.reach = _reach.default;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

exports.isSchema = _isSchema.default;

var _setLocale = _interopRequireDefault(__webpack_require__("Lo6J"));

exports.setLocale = _setLocale.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}

/***/ }),

/***/ "mbB6":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    isArray = __webpack_require__("wxYD");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ "mmil":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("8+jV");
var uid = __webpack_require__("rvZv");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "mu8A":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var hasOwn = __webpack_require__("/GgU");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "mwRp":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("E+Ue");
var aCallable = __webpack_require__("eGzU");
var NATIVE_BIND = __webpack_require__("vCWs");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "n4a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = prependDeep;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function prependDeep(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var sourceVal = source[key],
          targetVal = target[key];

      if (targetVal === undefined) {
        target[key] = sourceVal;
      } else if (targetVal === sourceVal) {
        continue;
      } else if ((0, _isSchema.default)(targetVal)) {
        if ((0, _isSchema.default)(sourceVal)) target[key] = sourceVal.concat(targetVal);
      } else if (isObject(targetVal)) {
        if (isObject(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
      } else if (Array.isArray(targetVal)) {
        if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
      }
    }
  }

  return target;
}

module.exports = exports["default"];

/***/ }),

/***/ "nHh7":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var hasOwn = __webpack_require__("/GgU");
var toString = __webpack_require__("vnfA");
var shared = __webpack_require__("8+jV");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("6qX7");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "nJrx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var shared = __webpack_require__("8+jV");
var hasOwn = __webpack_require__("/GgU");
var uid = __webpack_require__("rvZv");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "naLQ":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    createWrap = __webpack_require__("P+cI"),
    getHolder = __webpack_require__("4mQY"),
    replaceHolders = __webpack_require__("AeOa");

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nnO8":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "o+/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key in rest) {
      delete rest[key];
    }
  }
  return rest;
};

exports.default = omit;

/***/ }),

/***/ "oL6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_MESSAGES */
/* unused harmony export buildTransportKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areAnyTimeSlotIdsPresent; });
/* unused harmony export getAccommodationComfortIndex */
/* unused harmony export getAdultsCount */
/* unused harmony export getPackage */
/* unused harmony export getCurrency */
/* unused harmony export getRONPackage */
/* unused harmony export getKidsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFormattedArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFormattedDepartureDate; });
/* unused harmony export hasAllInclusive */
/* unused harmony export hasChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTotalPriceFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMainHouseholdAttendee; });
/* unused harmony export hasTransport */
/* unused harmony export isTransportATrain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isCharterFlight; });
/* unused harmony export isDateAfterOptionRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isOptionAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isRecommendedTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return saveRecommendedTransport; });
/* unused harmony export getArrivalDate */
/* unused harmony export getTripArrival */
/* unused harmony export getTripDeparture */
/* unused harmony export hasAccomodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareAccommodationsByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compareProposalsByComfort; });
/* unused harmony export getNbParticipants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasErroredProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasFetchProposalsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getResolvedProposals; });
/* unused harmony export getSelectedProposal */
/* unused harmony export getSelectedProposalById */
/* unused harmony export getStockWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTotalValue; });
/* unused harmony export getFormatedPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFormatedPriceByLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPriceDiff; });
/* unused harmony export hasTransportOrTransferSelected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDefaultProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isPremiumAccommodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isExclusiveCollectionRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isExclusiveCollectionSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getQuickSearchErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isExpiredDepartureDate; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("CzFL");
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Hz96");
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_nth__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("1RIK");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("ldK3");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("lZ21");
/* harmony import */ var _booking_process_constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("XpIN");
/* harmony import */ var _label_labelUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("WGoB");
/* harmony import */ var _currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("wz9x");
/* harmony import */ var _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("z8xc");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("tI+f");































var OPTIONS_DAYS_RANGE = 29;
var DEFAULT_STOCK_WARNING_LIMIT = 2;
var TWO_WEEKS_IN_MS = 14 * 24 * 3600 * 1000;

function getAccommodationComfortIndex(accommodation) {
  return _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(accommodation, 'categoryId'));
}

function compareProposalsByComfort(proposal1, proposal2) {
  var proposal1Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal1, 'accommodations[0]'));
  var proposal2Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal2, 'accommodations[0]')); // if we have not sorted the accommodation we don't change the order returned by the api

  if (proposal1Index === -1 || proposal2Index === -1) {
    return 0;
  }

  return proposal1Index - proposal2Index;
}

function compareAccommodationsByComfort(accommodation1, accommodation2) {
  return getAccommodationComfortIndex(accommodation1) - getAccommodationComfortIndex(accommodation2);
}

function areAnyTimeSlotIdsPresent(attendees, targetIds) {
  var targetSet = new Set(targetIds);
  return attendees.some(function (attendee) {
    return attendee.schedules.some(function (schedule) {
      return schedule.timeSlots.some(function (slot) {
        return targetSet.has(slot.id);
      });
    });
  });
}

function isCharterFlight(cancellationPolicy) {
  return [_booking_process_constants__WEBPACK_IMPORTED_MODULE_26__[/* LEGAL_INFO_THEO_ID */ "d"], _booking_process_constants__WEBPACK_IMPORTED_MODULE_26__[/* LEGAL_INFO_WEBTHEO_ID */ "e"]].includes(cancellationPolicy);
}

function isDateAfterOptionRange(date) {
  return date && date.isValid() && date.diff(moment__WEBPACK_IMPORTED_MODULE_21___default()(), 'days') >= OPTIONS_DAYS_RANGE;
}

function isOptionAllowed(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'optionAvailable');
}

function getAdultsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.adults.length', 1);
}

function getCurrency(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.currency');
}

function getKidsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.children.length', 0);
}

function getTotalPriceFormatted(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.total.formattedValue');
}

function getArrivalDate(proposal) {
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* momentFromApiDate */ "j"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'arrivalDate'));
}

function getTripDeparture(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.inbound.travelSections[0].departure.label', '');
}

function getTripArrival(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.outbound.travelSections[0].departure.label', '');
}

function hasChildren(proposal) {
  return getKidsCount(proposal) > 0;
}

function hasChildcare(proposal) {
  return proposal.additionalServices.childcares.length > 0;
}

function hasAllInclusive(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packageId') === _constants__WEBPACK_IMPORTED_MODULE_30__[/* PACKAGE_ALL_INCLUSIVE */ "f"];
}

function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMMM YYYY';
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* momentFromApiDate */ "j"])(date).format(dateFormat);
}

function getFormattedArrivalDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'arrivalDate'), dateFormat);
}

function getFormattedDepartureDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'departureDate'), dateFormat);
}

function getRONPackage(proposal) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_19___default()(packages, function (pkg) {
    return pkg.id === _constants__WEBPACK_IMPORTED_MODULE_30__[/* PACKAGE_ROOM_ONLY */ "h"];
  });
}

function getPackage(proposal, packageId) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_19___default()(packages, function (pkg) {
    return (pkg === null || pkg === void 0 ? void 0 : pkg.id) === packageId;
  }) || {};
}

function hasTransport(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports');
}

function hasTransfer(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default()(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'additionalServices.transfers'));
}

function hasTransportOrTransferSelected(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default()((proposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  }));
}

function isTransportATrain(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.inbound.travelSections[0].transport.type') === 'TRAIN' && lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.outbound.travelSections[0].transport.type') === 'TRAIN';
}

function hasAccomodation(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'accommodations.length');
}

function getResolvedProposals(proposals) {
  return proposals.filter(function (p) {
    return !p.errorCode;
  });
}

function hasErroredProposals(proposals) {
  return proposals.some(function (p) {
    return p.errorCode;
  });
}

function hasFetchProposalsFailed(_ref) {
  var _proposals$, _proposals$$price;

  var errors = _ref.errors,
      proposals = _ref.proposals;
  return errors && errors.length > 0 || hasErroredProposals(proposals) || !proposals || proposals.length === 0 || ((_proposals$ = proposals[0]) === null || _proposals$ === void 0 ? void 0 : (_proposals$$price = _proposals$.price) === null || _proposals$$price === void 0 ? void 0 : _proposals$$price.gap) >= _constants__WEBPACK_IMPORTED_MODULE_30__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "i"];
}

function getSelectedProposal(proposals, selectedProposalIndex) {
  return lodash_nth__WEBPACK_IMPORTED_MODULE_18___default()(proposals, selectedProposalIndex);
}

function getSelectedProposalById(proposals, selectedProposalId) {
  return proposals.find(function (proposal) {
    return proposal.id === selectedProposalId;
  }) || proposals[0];
}

function getStockWarning(i18n, remainingStock) {
  return {
    showStockWarning: remainingStock <= lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'stockWarningLimit', DEFAULT_STOCK_WARNING_LIMIT),
    stockWarning: "".concat(remainingStock, " ").concat(Object(_label_labelUtils__WEBPACK_IMPORTED_MODULE_27__[/* pluralizeLabel */ "d"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'room', ''), lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'rooms', ''), remainingStock))
  };
}

function getNbParticipants(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.list.length', 0);
}

function getTotalValue(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.total.value', 0);
}

function getFormatedPrice(formatedPrice, amount) {
  if (amount === 0) {
    return "".concat(formatedPrice);
  }

  return amount > 0 ? "+".concat(formatedPrice) : "-".concat(formatedPrice);
}

function getFormatedPriceByLocale(price, locale, currency) {
  return getFormatedPrice(Object(_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_28__[/* formatAmountForLocale */ "b"])(Math.abs(price), locale, currency), price);
}

function getPriceDiff(proposalPrice, selectedProposalPrice, locale, currency) {
  var diffPrice = proposalPrice - selectedProposalPrice;
  return diffPrice === 0 ? null : getFormatedPriceByLocale(diffPrice, locale, currency);
}

var getDefaultProposal = function getDefaultProposal(proposals, resort) {
  /**
   * There is a random corner case that make selectedProposal as undefined
   * It should be the default one (mainly the first one).
   * Maybe proposals array is empty at some point...
   * Unable to reproduce the bug... See BookingEngine.container
   */
  var firstProposal = proposals[0] || {};

  if (resort && resort.id === _constants__WEBPACK_IMPORTED_MODULE_30__[/* CEFALU_RESORT */ "a"]) {
    var deluxeProposal = proposals.find(function (proposal) {
      return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'accommodations[0].comfortType') === _constants__WEBPACK_IMPORTED_MODULE_30__[/* DELUXE_COMFORT */ "e"];
    });
    return deluxeProposal ? deluxeProposal : firstProposal;
  }

  return firstProposal;
};

var isPremiumAccommodation = function isPremiumAccommodation(accommodation) {
  return !!(accommodation.comfortId && [_constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_SUITE */ "c"], _constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_CHALET */ "b"], _constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_VILLA */ "d"]].includes(accommodation.comfortId));
};

var isExclusiveCollectionRoom = function isExclusiveCollectionRoom(accommodation, product) {
  return accommodation.exclusiveCollection || Number(product === null || product === void 0 ? void 0 : product.comfort) >= 5;
};

var isExclusiveCollectionSpace = function isExclusiveCollectionSpace(accommodation, product) {
  return accommodation.exclusiveCollection && (product === null || product === void 0 ? void 0 : product.comfort) === 4;
};

function buildTransportDetailKey(transportDetail) {
  return transportDetail.travelSections.map(function (section) {
    var _section$transport, _section$transport2, _section$transport2$c, _section$departure, _section$departure2, _section$departure3, _section$arrival, _section$arrival2, _section$arrival3;

    var transportClass = _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_29__[/* TRANSPORT_CLASS_TO_I18N */ "f"][(_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : _section$transport["class"]];
    var company = "".concat(transportClass).concat(((_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.id) || '');
    return "".concat((_section$departure = section.departure) === null || _section$departure === void 0 ? void 0 : _section$departure.id).concat((_section$departure2 = section.departure) === null || _section$departure2 === void 0 ? void 0 : _section$departure2.date).concat((_section$departure3 = section.departure) === null || _section$departure3 === void 0 ? void 0 : _section$departure3.time, "-").concat((_section$arrival = section.arrival) === null || _section$arrival === void 0 ? void 0 : _section$arrival.id).concat((_section$arrival2 = section.arrival) === null || _section$arrival2 === void 0 ? void 0 : _section$arrival2.date).concat((_section$arrival3 = section.arrival) === null || _section$arrival3 === void 0 ? void 0 : _section$arrival3.time, "-").concat(company);
  }).join(':');
}

var buildTransportKey = function buildTransportKey(transport) {
  return "".concat(buildTransportDetailKey(transport.inbound), "/").concat(buildTransportDetailKey(transport.outbound));
};

var isRecommendedTransport = function isRecommendedTransport(transport, proposalId) {
  if (!transport || !transport.inbound || !transport.outbound) {
    return false;
  }

  return buildTransportKey(transport) === Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* getFromLocalStorage */ "a"])("recommendedTransport-".concat(proposalId));
};

var saveRecommendedTransport = function saveRecommendedTransport(transport, proposalId) {
  var localStorageKey = "recommendedTransport-".concat(proposalId);

  if (!Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* getFromLocalStorage */ "a"])(localStorageKey)) {
    Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* setInLocalStorage */ "c"])(localStorageKey, buildTransportKey(transport), {
      ttl: TWO_WEEKS_IN_MS
    });
  }
};

var getMainHouseholdAttendee = function getMainHouseholdAttendee(proposal, householdId) {
  var customerId = proposal.households[householdId].attendees[0].customerId;
  return proposal.attendees.list.find(function (attendee) {
    return attendee.customerId === customerId;
  });
};

var ERROR_MESSAGES = {
  RESORT_NOT_AVAILABLE: 'productsComparison.resortNotAvailable',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  INVALID_PRODUCT_ID: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  NO_TRANSPORT: 'booking.accommodation.errorMessages.noTransport',
  NO_ACCOMMODATION: 'booking.accommodation.errorMessages.noAccommodation',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.accommodation.errorMessages.ageIncorrectOrUnauthorized',
  INVALID_BOOKING_CRITERIA: 'booking.accommodation.errorMessages.invalidBookingCriteria',
  NO_PROPOSAL: 'booking.accommodation.errorMessages.noProposalAvailable',
  TECHNICAL_ERROR: 'booking.accommodation.errorMessages.technicalError',
  INVALID_VOUCHER_CODE: 'booking.accommodation.errorMessages.technicalError',
  AUTHORIZATION_ERROR: 'productsComparison.unknownAttendee'
};
var QUICK_SEARCH_ERROR_MESSAGES = {
  INVALID_PRODUCT_ID: 'booking.partners.errorMessages.invalidResort',
  NO_ACCOMMODATION: 'booking.partners.errorMessages.noAccommodation',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.partners.errorMessages.resortNotOnSale',
  NO_TRANSPORT: 'booking.partners.errorMessages.noTransport',
  TOO_MANY_ATTENDEES: 'booking.partners.errorMessages.attendees',
  UNAUTHORIZED_SALES_NETWORK: 'booking.partners.errorMessages.salesNetwork',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.partners.errorMessages.ageIncorrectOrUnauthorized',
  NO_PROPOSAL: 'booking.partners.errorMessages.noProposalAvailable',
  INVALID_BOOKING_CRITERIA: 'booking.partners.errorMessages.invalidBookingCriteria',
  FIELD_EMPTY: 'booking.partners.errorMessages.emptyField',
  INVALID_RESORT_ARRIVAL_DATE: 'booking.partners.errorMessages.invalidArrivalDate',
  UNKNOWN_DEPARTURE_CITY: 'booking.partners.errorMessages.invalidDepartureCity',
  TECHNICAL_ERROR: 'booking.partners.errorMessages.technicalError'
};
var QUICK_SEARCH_ERROR_LABELS = Object.keys(QUICK_SEARCH_ERROR_MESSAGES);

var toUpperSnakeCase = function toUpperSnakeCase(errorCode) {
  return lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16___default()(errorCode).toUpperCase();
};

var getQuickSearchErrorMessage = function getQuickSearchErrorMessage(errorCode) {
  var errorLabel = toUpperSnakeCase(errorCode);
  return QUICK_SEARCH_ERROR_LABELS.includes(errorLabel) ? Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])(QUICK_SEARCH_ERROR_MESSAGES[errorLabel]) : Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.partners.errorMessages.defaultErrorMessage');
};

var isExpiredDepartureDate = function isExpiredDepartureDate(router) {
  return moment__WEBPACK_IMPORTED_MODULE_21___default()(router.query.departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_21___default()(new Date()), 'day');
};



/***/ }),

/***/ "oNVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "oa0l":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "pNXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Introduction_Introduction; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var defaultTheme = {
  thRoot: 'flex flex-col sm:flex-row gap-20 overflow-hidden',
  thLeft: 'flex-1',
  thRight: 'flex-1',
  thTitleTheme: 'title-brand-n1',
  thSmall: 'font-sans lowercase text-14',
  thSubtitle: 'text-sienna',
  thSubtitleTheme: 'title-sans-n2'
};
var themes = {
  "default": defaultTheme,
  column: _objectSpread(_objectSpread({}, defaultTheme), {}, {
    thRoot: 'flex flex-col gap-20 overflow-hidden',
    thLeft: 'flex flex-col items-center justify-center',
    thRight: 'flex justify-center'
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx

var __jsx = react_default.a.createElement;





var Introduction_Introduction = function Introduction(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isTextSeeMoreCollapseEnabled = _ref.isTextSeeMoreCollapseEnabled,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      small = _ref.small,
      subtitle = _ref.subtitle,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var hasHeading = !!title || !!subtitle;
  var hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLeft = _themes$theme.thLeft,
      thRight = _themes$theme.thRight,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-testid": dataTestId
  }, hasHeading && __jsx("div", {
    className: thLeft
  }, __jsx(Title["a" /* Title */], {
    hLevel: 2,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && __jsx("small", {
    className: thSmall
  }, small)), __jsx(Title["a" /* Title */], {
    className: thSubtitle,
    hLevel: 3,
    theme: thSubtitleTheme
  }, subtitle)), hasText && __jsx("div", {
    className: thRight
  }, __jsx(TextSeeMore["a" /* TextSeeMore */], {
    isCollapseEnabled: isTextSeeMoreCollapseEnabled,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text
  })));
};

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pfAP":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var getMethod = __webpack_require__("Uey1");
var ordinaryToPrimitive = __webpack_require__("ZoVA");
var wellKnownSymbol = __webpack_require__("nJrx");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes = __webpack_require__("MZFe");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isBestPrice = _ref.isBestPrice,
      isHighlighted = _ref.isHighlighted,
      isSelectable = _ref.isSelectable,
      isSelected = _ref.isSelected,
      isTablet = _ref.isTablet,
      lastAvailability = _ref.lastAvailability,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      thDay: Object(classnames_utils["a" /* classnames */])("group flex flex-1 cursor-pointer flex-col items-center justify-center ".concat(isTablet ? 'h-100 p-5' : 'h-52', " relative border-r border-t border-grey text-center text-14 transition-all duration-250 ease-in"), {
        'text-black hocus:text-white': isSelectable
      }),
      thDayCornerMark: Object(classnames_utils["a" /* classnames */])({
        'corner-mark-tr-turquoise': siblingOpen && isTablet,
        'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-12',
      thDayNumber: Object(classnames_utils["a" /* classnames */])('left-0 top-0 text-10 md:absolute md:p-5', {
        'font-normal md:text-12': !isSelectable,
        'font-bold md:text-16': isSelectable,
        'text-current': siblingOpen
      }),
      thDayOldPrice: 'text-12 line-through hidden md:block text-current',
      thDayPrice: 'text-12 md:text-16',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col group items-center justify-center h-48 leading-tight relative text-14 text-center',
      thDayMessage: 'hidden',
      thDayNumberContainer: Object(classnames_utils["a" /* classnames */])('relative isolate'),
      thDayNumber: Object(classnames_utils["a" /* classnames */])('relative z-1', {
        'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
        'text-grey group-hover:text-white': !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted
      }),
      thDayUnavailable: 'line-through',
      thDayHighlight: 'absolute bg-current group-hover:bg-transparent h-26 left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-26',
      thDayOldPrice: 'hidden',
      thDayPrice: Object(classnames_utils["a" /* classnames */])('mx-auto -mb-5 mt-5 block self-end text-10 font-bold', {
        'text-black group-hover:text-white': !isSelected,
        'text-white': isSelected
      }),
      thStatusMessage: 'hidden',
      thFrom: 'hidden',
      thShowPricePlaceholder: true
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var __jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return isVisible && shouldDisplayDetails && __jsx("div", {
    className: "text-initial absolute left-1/2 top-0 z-2 w-400 -translate-x-1/2 transform font-normal"
  }, __jsx("div", {
    className: "animation-duration-500 absolute inset-x-0 bottom-full animate-fadeIn"
  }, __jsx("div", {
    className: "arrow-down arrow-large arrow-white rounded-12 bg-white shadow-md after:drop-shadow-md"
  }, __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("aside", {
    className: "arrow arrow-bg-lightGrey arrow-down arrow-white animation-duration-500 absolute bottom-full left-1/2 z-3 w-280 -translate-x-1/2 transform animate-fadeIn font-normal shadow-diffuse"
  }, DayPriceDoubleSeason_jsx("div", {
    className: "text-initial overflow-hidden rounded-12 border border-lightGrey bg-white"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx




var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */











var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      isBestPrice = _ref$price.isBestPrice,
      lastAvailability = _ref$price.lastAvailability,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      selectedBestPrice = _ref.selectedBestPrice,
      selectedDuration = _ref.selectedDuration,
      selectedRealPrice = _ref.selectedRealPrice,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplaySelectedDepartureDateMessageWithPrice = _ref.shouldDisplaySelectedDepartureDateMessageWithPrice,
      shouldDisplaySelectedReturningDateMessage = _ref.shouldDisplaySelectedReturningDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isBestPrice: isBestPrice,
    isHighlighted: isHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isTablet: isTablet,
    lastAvailability: lastAvailability,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumberContainer = _themes$theme.thDayNumberContainer,
      thDayNumber = _themes$theme.thDayNumber,
      thDayHighlight = _themes$theme.thDayHighlight,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom,
      thShowPricePlaceholder = _themes$theme.thShowPricePlaceholder;

  var setIsVisible = debounce_default()(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : DayWithPrice_jsx("span", {
      className: "text-8 md:mx-1 md:px-1 md:text-10"
    }, compactPrice);
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  var selectedPrice = selectedRealPrice || selectedBestPrice;
  var isDateSelectable = ['open', 'noDeparture'].includes(availability);
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'absolute inset-0 z-3 h-full w-full': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    "data-testid": "price-calendar-date",
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("div", {
    className: thDayNumberContainer
  }, DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayNumber)
  }, moment_default()(day).format('D')), isHighlighted && DayWithPrice_jsx("div", {
    className: thDayHighlight
  })), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && (siblingOpen ? shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey)) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), ' ', DayWithPrice_jsx("div", {
    className: "mt-5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), shouldDisplaySelectedDepartureDateMessageWithPrice && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), selectedPrice && selectedDuration && DayWithPrice_jsx("div", {
    className: "flex flex-col"
  }, DayWithPrice_jsx("span", null, Object(i18n["h" /* t */])('price.format.unitTotalPerTripIndicative').toUpperCase()), DayWithPrice_jsx("span", {
    className: "text-12 font-bold leading-tight md:text-16",
    "data-testid": "selected-date-best-price"
  }, theme === 'compact' ? getCompactPrice(selectedPrice) : selectedPrice))), shouldDisplaySelectedReturningDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedReturningDateMessage').toUpperCase()), isLoading ? DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    className: "text-black"
  }) : DayWithPrice_jsx(react["Fragment"], null, shouldDisplayPrice && !!price && DayWithPrice_jsx("div", {
    className: "flex flex-col text-current",
    "data-testid": "price-calendar-date-price"
  }, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)), thShowPricePlaceholder && (!shouldDisplayPrice || !price) && DayWithPrice_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])(thDayPrice, {
      'opacity-0': !isDateSelectable
    })
  }, isDateSelectable ? Object(string_util["d" /* truncate */])(Object(i18n["h" /* t */])('faceting.when.dateSelect'), 6) : DayWithPrice_jsx(react_default.a.Fragment, null, "\xA0"))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx








var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      selectedBestPrice = _ref2.selectedBestPrice,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedDuration = _ref2.selectedDuration,
      selectedMonth = _ref2.selectedMonth,
      selectedRealPrice = _ref2.selectedRealPrice,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedBestPrice", "selectedDays", "selectedDuration", "selectedMonth", "selectedRealPrice", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices || theme === 'compact';
  var bothDatesSelected = Boolean(from && to);
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return get_default()(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, '!text-lightGrey', disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [JSON.stringify(flattenedPrices)]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [JSON.stringify(openingDates)]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker["a" /* Datepicker */], Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      var shouldDisplayPrice = theme === 'compact' ? hasPrices && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] : hasPrices && !to && !moment_default()(from).isSame(day, 'day');
      var price = resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day));
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        hasPrices: hasPrices,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isSelected: Boolean(dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected]),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: price,
        product: product,
        selectedBestPrice: selectedBestPrice,
        selectedDuration: selectedDuration,
        selectedRealPrice: selectedRealPrice,
        isHighlighted: (dayModifiers.today || price.isBestPrice || price.lastAvailability || price.siblingOpen) && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected],
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: shouldDisplayPrice,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedDepartureDateMessageWithPrice: bothDatesSelected && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedReturningDateMessage: bothDatesSelected && moment_default()(to).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "q/8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPrice; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);






var getProductArgs = function getProductArgs(_ref) {
  var duration = _ref.duration,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      withDate = _ref.withDate;
  var queryParams = location.queryParams,
      urlParams = location.urlParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var tripDuration = withDate ? duration || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DURATION */ "h"]] : null;
  var productArgsToBuild = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = withDate ? queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DEPARTURE_DATE */ "g"]] || '' : '';
  productArgsToBuild.departureCity = transport || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_TRANSPORT */ "m"]] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  return Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams, productArgsToBuild);
};

function fetchPrice(_ref2) {
  var appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$forceAdultPerTr = _ref2.forceAdultPerTrip,
      forceAdultPerTrip = _ref2$forceAdultPerTr === void 0 ? false : _ref2$forceAdultPerTr,
      location = _ref2.location,
      productId = _ref2.productId,
      transport = _ref2.transport,
      _ref2$withDate = _ref2.withDate,
      withDate = _ref2$withDate === void 0 ? true : _ref2$withDate;
  var queryParams = location.queryParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var productArgs = getProductArgs({
    duration: duration,
    location: location,
    productId: productId,
    transport: transport,
    withDate: withDate
  });
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var query = "query {\n    price(".concat(productArgs, ") {\n      offerColor( offerName : \"").concat(offerName, "\")\n      bestPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      initialPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      productId\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        departureCity {\n          value\n          name\n        }\n        numberOfAdults\n        accommodationComfortLabel\n        accommodationId\n        offerId\n      }\n    }\n  }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_PRICE_TICKET */ "ed"]
  });
}



/***/ }),

/***/ "qPLk":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "qXr/":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "qYhz":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    toInteger = __webpack_require__("m2YG"),
    values = __webpack_require__("0iyY");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ "qqpj":
/***/ (function(module, exports, __webpack_require__) {

var baseToNumber = __webpack_require__("t/wz"),
    baseToString = __webpack_require__("JcJ6");

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString(value);
        other = baseToString(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

module.exports = createMathOperation;


/***/ }),

/***/ "qr7w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;

/***/ }),

/***/ "qs2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("LTtw");
var DESCRIPTORS = __webpack_require__("uGjT");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var hasOwn = __webpack_require__("/GgU");
var isCallable = __webpack_require__("ANQd");
var isPrototypeOf = __webpack_require__("VXxY");
var toString = __webpack_require__("vnfA");
var defineBuiltInAccessor = __webpack_require__("yYuE");
var copyConstructorProperties = __webpack_require__("sfoL");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "r2he":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeStyle; });
const refProps = ['type', 'source', 'source-layer', 'minzoom', 'maxzoom', 'filter', 'layout'];
// Prepare a map style object for diffing
// If immutable - convert to plain object
// Work around some issues in older styles that would fail Mapbox's diffing
function normalizeStyle(style) {
    if (!style) {
        return null;
    }
    if (typeof style === 'string') {
        return style;
    }
    if ('toJS' in style) {
        style = style.toJS();
    }
    if (!style.layers) {
        return style;
    }
    const layerIndex = {};
    for (const layer of style.layers) {
        layerIndex[layer.id] = layer;
    }
    const layers = style.layers.map(layer => {
        // @ts-expect-error
        const layerRef = layerIndex[layer.ref];
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = { ...layer };
            // Breaks style diffing :(
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        if (layerRef) {
            normalizedLayer = normalizedLayer || { ...layer };
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of refProps) {
                if (propName in layerRef) {
                    normalizedLayer[propName] = layerRef[propName];
                }
            }
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return { ...style, layers };
}
//# sourceMappingURL=style-utils.js.map

/***/ }),

/***/ "rFVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Participants_Participants; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("hCOa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/create-react-class/index.js
var create_react_class = __webpack_require__("Y3fD");
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-input-tel-date/FormInputTelDate.jsx



















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */








var dayDefaultStruct = {
  ref: 'day',
  stateName: 'dayValue',
  placeholderPropName: 'dayPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var monthDefaultStruct = {
  ref: 'month',
  stateName: 'monthValue',
  placeholderPropName: 'monthPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var yearDefaultStruct = {
  ref: 'year',
  stateName: 'yearValue',
  placeholderPropName: 'yearPlaceholder',
  maxLength: 4,
  onChange: null,
  placeholder: null
};
var datePatterns = [{
  key: 'd',
  struct: dayDefaultStruct
}, {
  key: 'm',
  struct: monthDefaultStruct
}, {
  key: 'y',
  struct: yearDefaultStruct
}];
/* DEPRECATED : DO NOT USE ANYMORE */

var FormInputTelDate = create_react_class_default()({
  displayName: "FormInputTelDate",
  // TODO: cleanup !!
  // eslint-disable-next-line react/no-unused-class-component-methods
  getDefaultProps: function getDefaultProps() {
    return {
      dateFormat: 'DDMMYYYY',
      onBlur: function onBlur() {},
      onChange: function onChange() {}
    };
  },
  getInitialState: function getInitialState() {
    var formattedDate = moment_default()(this.props.value, this.props.dateFormat);
    return this.props.value && formattedDate.isValid() ? {
      dayValue: formattedDate.format('DD'),
      monthValue: formattedDate.format('MM'),
      yearValue: formattedDate.format('YYYY')
    } : {
      dayValue: '',
      monthValue: '',
      yearValue: ''
    };
  },
  areAllInputsFilled: function areAllInputsFilled() {
    return this.state.dayValue.length === dayDefaultStruct.maxLength && this.state.monthValue.length === monthDefaultStruct.maxLength && this.state.yearValue.length === yearDefaultStruct.maxLength;
  },
  getFormattedDate: function getFormattedDate() {
    if (isEmpty_default()(this.state.yearValue) && isEmpty_default()(this.state.monthValue) && isEmpty_default()(this.state.dayValue)) {
      return '';
    }

    return this.areAllInputsFilled() ? moment_default()([+this.state.yearValue, +this.state.monthValue - 1, +this.state.dayValue]).format(this.props.dateFormat) : moment_default.a.invalid().toString();
  },
  handleChange: function handleChange(value, event, nextInput, maxLength) {
    var _this = this;

    this.setState(Object(defineProperty["a" /* default */])({}, value, event.target.value), function () {
      _this.props.onChange(_this.getFormattedDate());
    });

    if (nextInput && maxLength && event.target.value.length === maxLength) {
      react_dom_default.a.findDOMNode(nextInput).focus();
    }
  },
  handleBlur: function handleBlur(value, event, nextInput) {
    if (!nextInput || get_default()(event, 'relatedTarget.className', '').indexOf('FormInputTelDate-input') === -1) {
      this.props.onBlur(this.getFormattedDate());
    }
  },
  getHandleChangeFunction: function getHandleChangeFunction(field, nextRef, maxLength) {
    var _this2 = this;

    return function (event) {
      return _this2.handleChange(field, event, nextRef, maxLength);
    };
  },
  getHandleBlurFunction: function getHandleBlurFunction(field, nextRef) {
    var _this3 = this;

    return function (event) {
      return _this3.handleBlur(field, event, nextRef);
    };
  },
  buildFormatStructure: function buildFormatStructure(_ref, index, patterns) {
    var struct = _ref.struct,
        size = _ref.size;
    var nextRef = index + 1 < patterns.length ? get_default()(this.refs, patterns[index + 1].struct.ref) : null;
    return _objectSpread(_objectSpread({}, struct), {}, {
      id: "".concat(this.props.id, "-").concat(index),
      maxLength: size,
      onChange: this.getHandleChangeFunction(struct.stateName, nextRef, size),
      onBlur: this.getHandleBlurFunction(struct.stateName, nextRef),
      placeholder: get_default()(this.props, struct.placeholderPropName)
    });
  },
  getPatternPos: function getPatternPos(dateFormat) {
    return function (datePattern) {
      return _objectSpread(_objectSpread({}, datePattern), {}, {
        pos: dateFormat.indexOf(datePattern.key)
      });
    };
  },
  getPatternSize: function getPatternSize(dateFormat) {
    return function (datePattern) {
      return _objectSpread(_objectSpread({}, datePattern), {}, {
        size: (dateFormat.match(new RegExp(datePattern.key, 'g')) || []).length
      });
    };
  },
  getDateStructure: function getDateStructure(dateFormat) {
    return sortBy_default()(datePatterns.map(this.getPatternPos(dateFormat)), ['pos']).map(this.getPatternSize(dateFormat)).map(this.buildFormatStructure);
  },
  getValidationState: function getValidationState() {
    var validationState = this.props.validationState;
    return validationState === 'IS_VALID' && !this.areAllInputsFilled() ? 'NOT_VALIDATED' : validationState;
  },
  render: function render() {
    var _this4 = this;

    var _this$props = this.props,
        className = _this$props.className,
        id = _this$props.id,
        label = _this$props.label,
        isRequired = _this$props.isRequired;
    var structures = this.getDateStructure(this.props.dateFormat.toLowerCase());
    var validationState = this.getValidationState();
    var isValid = validationState === 'IS_VALID';
    var isInvalid = validationState === 'IS_INVALID';
    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex flex-col', className)
    }, !!label && __jsx(Label["a" /* Label */], {
      className: "mx-15 mb-5",
      htmlFor: id,
      isRequired: isRequired,
      label: label
    }), __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('outline-custom flex overflow-hidden rounded-pill border-1 transition-all duration-250 ease-in', {
        'border-success': isValid,
        'border-red': isInvalid
      })
    }, __jsx("div", {
      className: "flex w-full items-center text-14"
    }, structures.map(function (structure, index) {
      return __jsx("div", {
        className: "relative flex flex-1 items-center",
        key: "".concat(_this4.state[structure.id], "-").concat(index)
      }, !!index && __jsx("span", null, "/"), __jsx("input", {
        className: Object(classnames_utils["a" /* classnames */])('h-42 w-full bg-transparent text-center', {
          'cursor-progress': _this4.props.isLoading
        }),
        id: _this4.state[structure.id],
        maxLength: structure.maxLength,
        onBlur: structure.onBlur,
        onChange: structure.onChange,
        placeholder: structure.placeholder,
        ref: structure.ref,
        type: "tel",
        value: _this4.state[structure.stateName]
      }));
    })), (isValid || isInvalid) && __jsx("span", {
      className: Object(classnames_utils["a" /* classnames */])('flex items-center justify-center px-10 text-10 transition-all duration-250 ease-in', {
        'text-success': isValid,
        'text-red': isInvalid
      })
    }, __jsx(Icon["a" /* Icon */], {
      name: isValid ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
      width: "0.8125rem"
    }))));
  }
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx + 1 modules
var FormValidator = __webpack_require__("/013");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var participants_constants = __webpack_require__("93Yv");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx























var Participants_jsx = react_default.a.createElement;

function Participants_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Participants_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Participants_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Participants_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var Participants_Participants = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(Participants, _FormValidator);

  var _super = _createSuper(Participants);

  function Participants() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Participants);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onAdultsNumberChange", function (_, value) {
      _this.props.setAdultsNumber(value);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKidsNumberChange", function (_, value) {
      var kids = Array(value).fill(undefined).map(function (kid, i) {
        if (_this.props.kids[i]) {
          return _this.props.kids[i];
        }

        return kid;
      });

      var kidsValidations = _this.state.fields.map(function (_ref) {
        var validationState = _ref.validationState;
        return validationState;
      });

      _this.props.setKids({
        kids: kids,
        kidsValidations: kidsValidations
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleKids", function (idx) {
      return function (value) {
        var kidsValidations = _this.validateFields().map(function (kidsValidation) {
          return kidsValidation.validationState;
        });

        var kids = _this.props.kids.map(function (kid, index) {
          return idx !== index ? kid : Participants_objectSpread(Participants_objectSpread({}, kid), {}, {
            birthdate: moment_default()(value, _this.props.dateFormat).valueOf()
          });
        });

        _this.props.setKids({
          kids: kids,
          kidsValidations: kidsValidations
        });
      };
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Participants, [{
    key: "getFields",
    value: function getFields(props) {
      var _this2 = this;

      var dateFormat = props.dateFormat,
          kids = props.kids,
          _props$adultAge = props.adultAge,
          adultAge = _props$adultAge === void 0 ? participants_constants["b" /* DEFAULT_MAX_AGE */] : _props$adultAge,
          _props$childAge = props.childAge,
          childAge = _props$childAge === void 0 ? participants_constants["d" /* DEFAULT_MIN_AGE */] : _props$childAge,
          departureDate = props.departureDate;
      return kids.map(function (kid, idx) {
        var birthdate = _this2.getKidBirthdate(idx);

        var adultAgeInYear = +adultAge;
        var childAgeInYear = +childAge / 12;
        var params = {
          birthdayFormat: dateFormat,
          onDate: departureDate,
          onDateFormat: 'YYYYMMDD'
        };
        return {
          name: "birthdate.".concat(idx),
          value: birthdate,
          validators: [Object(CommonValidators["c" /* maxAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: adultAgeInYear
          })), Object(CommonValidators["d" /* minAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: childAgeInYear
          }))]
        };
      });
    }
  }, {
    key: "getKidBirthdate",
    value: function getKidBirthdate(idx) {
      var birthdate = get_default()(this.props.kids[idx], 'birthdate');

      return get_default()(this.state, "fields.".concat(idx, ".value")) || (birthdate ? moment_default()(birthdate).format(this.props.dateFormat) : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          adultsLabel = _this$props.adultsLabel,
          adultsNumber = _this$props.adultsNumber,
          childrenBirthdayDateFormatPlaceholder = _this$props.childrenBirthdayDateFormatPlaceholder,
          className = _this$props.className,
          kids = _this$props.kids,
          kidsAgeLimit = _this$props.kidsAgeLimit,
          kidsLabel = _this$props.kidsLabel,
          minAgeInformation = _this$props.minAgeInformation;
      var maxPax = this.context.isSeller ? constants["L" /* MAX_PAX_SELLER */] : constants["K" /* MAX_PAX */] + 1;

      var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
        return maxPax - kids.length;
      };

      var getMaxKidsAvailable = function getMaxKidsAvailable() {
        return maxPax - adultsNumber;
      };

      return Participants_jsx("section", {
        className: Object(classnames_utils["a" /* classnames */])('gap-20 md:gap-40 grid grid-cols-1 md:grid-cols-2', className)
      }, Participants_jsx("div", null, Participants_jsx("div", {
        className: "bg-white flex md:inline-flex flex-col md:flex-row gap-10 justify-between p-15 md:px-40 rounded-12"
      }, Participants_jsx(InputNumber["a" /* InputNumber */], {
        dataTestId: "ParticipantsAdultsSelect",
        label: adultsLabel,
        max: getMaxAdultsAvailable(),
        min: 1,
        onChange: this.onAdultsNumberChange,
        step: 1,
        value: adultsNumber
      }), !this.props.adultOnly && Participants_jsx(InputNumber["a" /* InputNumber */], {
        dataTestId: "ParticipantsChildrenSelect",
        max: getMaxKidsAvailable(),
        label: kidsLabel,
        min: 0,
        notes: kidsAgeLimit,
        onChange: this.onKidsNumberChange,
        step: 1,
        value: kids.length
      })), minAgeInformation && kids.length > 0 && Participants_jsx("p", {
        className: "flex font-sans gap-10 items-center md:justify-end mt-10 text-10 text-center text-orange",
        "data-selector": "ParticipantsKidsAgeMessage"
      }, Participants_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].WARNING,
        size: "1rem"
      }), minAgeInformation)), kids.length > 0 && Participants_jsx("ul", {
        className: "gap-20 grid grid-cols-1 md:grid-cols-2"
      }, Array.from({
        length: this.props.kids.length
      }).map(function (child, idx) {
        var label = Object(dist["messageFormat"])(childrenBirthdayDateFormatPlaceholder).format({
          childIndex: "".concat(idx + 1)
        });

        var birthdate = _this3.getKidBirthdate(idx);

        var _get2 = get_default()(_this3.state, "fields.".concat(idx), {}),
            validationState = _get2.validationState;

        return Participants_jsx("li", {
          key: idx
        }, Participants_jsx(FormInputTelDate, {
          className: "direction-ltr",
          dateFormat: _this3.props.dateFormat,
          dayPlaceholder: _this3.props.dayPlaceholder,
          id: "birthday".concat(idx),
          isRequired: true,
          label: label,
          monthPlaceholder: _this3.props.monthPlaceholder,
          onBlur: _this3.handleKids(idx),
          onChange: _this3.updateFieldValue("birthdate.".concat(idx)),
          validationState: validationState,
          value: birthdate,
          yearPlaceholder: _this3.props.yearPlaceholder
        }));
      })));
    }
  }]);

  return Participants;
}(FormValidator["a" /* default */]);

Object(defineProperty["a" /* default */])(Participants_Participants, "defaultProps", {
  kids: []
});

Object(defineProperty["a" /* default */])(Participants_Participants, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/***/ }),

/***/ "rFb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var PROPOSAL_SEARCH_ERROR_MAPPING = {
  invalidProductId: 'calendar.resortNotOnSale',
  invalidBookingCriteria: 'invalidBookingCriteria',
  noAccommodation: 'noAccommodation',
  noProposalAvailable: 'noProposalAvailable',
  noProposalWithFlight: 'noProposalWithFlight',
  notOnSaleForThePeriod: 'calendar.resortNotOnSale',
  noTransport: 'noTransport',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized'
};
var BookingErrors = function BookingErrors(_ref) {
  var className = _ref.className,
      errorCode = _ref.errorCode;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])({
      'arrow-upRight arrow-large arrow-lightSand arrow-bg arrow-bg-lightGrey md:relative md:border-t-1': isTablet
    }, className),
    id: "Package-error"
  }, __jsx("div", {
    className: "m-auto text-center text-20 text-red md:max-w-1/2 md:py-25"
  }, errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode] ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])("booking.accommodation.errorMessages.".concat(PROPOSAL_SEARCH_ERROR_MAPPING[errorCode])) : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.accommodation.errorMessageNoProposal')));
};

/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "raDx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_PARTICIPANTS; });
/* unused harmony export PAGE_BE_BANKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingEngineUri; });
/* unused harmony export getBookingCriteriaOffsetSell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBookingCriteriaDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var _getDefaultProposal;

  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });

  var _selectedProposalId = selectedProposalId || ((_getDefaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__[/* getDefaultProposal */ "d"])(proposals, resort)) === null || _getDefaultProposal === void 0 ? void 0 : _getDefaultProposal.id);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: _selectedProposalId,
    coderesort: resort === null || resort === void 0 ? void 0 : resort.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_OFFSETSELL */ "h"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getBookingCriteriaDepartureCities = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(productId, appContext) {
    var query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                      departureCities {\n                        value\n                        name\n                      }\n                  }\n            }");
            return _context2.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_DEPARTURE_CITIES */ "g"]
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getBookingCriteriaDepartureCities(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_11___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rokF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = inherits;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];

/***/ }),

/***/ "rueY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCalendarTripPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setPossibleDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setInitialDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setIsPriceCalendarSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCalendarBlockInputDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCalendar; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uDfI");
/* harmony import */ var _calendar_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VtPb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cvSI");
/* harmony import */ var _priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("q/8t");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fflk");
/* harmony import */ var _trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Mn1B");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6wD6");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("L73y");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("nv//");


















function fetchCalendar(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar, _state$calendar2, _state$calendar$calen, _state$calendar3;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.isLoading) && ((_state$calendar2 = state.calendar) === null || _state$calendar2 === void 0 ? void 0 : _state$calendar2.lastRequestId) !== -1;

    if (calendarRequestInProgress || JSON.stringify(options) === JSON.stringify((_state$calendar$calen = (_state$calendar3 = state.calendar) === null || _state$calendar3 === void 0 ? void 0 : _state$calendar3.calendarCriteria) !== null && _state$calendar$calen !== void 0 ? _state$calendar$calen : {})) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_ABORT */ "i"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR */ "h"], {
      departureCity: options.transport,
      productId: options.resortId,
      options: options
    }, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchCalendar */ "g"])(appContext, options)
    }));
  };
}
function fetchCalendarTripPrice(options) {
  return function (dispatch, getState) {
    var _state$calendar4, _state$calendar5;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar4 = state.calendar) === null || _state$calendar4 === void 0 ? void 0 : _state$calendar4.isLoading) && ((_state$calendar5 = state.calendar) === null || _state$calendar5 === void 0 ? void 0 : _state$calendar5.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE_ABORT */ "k"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE */ "j"], {}, {
      optimist: true,
      promise: Object(_priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__[/* fetchPrice */ "a"])(options)
    }));
  };
}
function fetchBookableDates(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar6, _state$calendar7, _state$calendar8, _state$calendar9;

    var state = getState();
    var bookableDateRequestInProgress = ((_state$calendar6 = state.calendar) === null || _state$calendar6 === void 0 ? void 0 : _state$calendar6.bookableDatesLoading) && ((_state$calendar7 = state.calendar) === null || _state$calendar7 === void 0 ? void 0 : _state$calendar7.bookableDateLastRequestId) !== -1;

    if (bookableDateRequestInProgress || options.departureCity === ((_state$calendar8 = state.calendar) === null || _state$calendar8 === void 0 ? void 0 : _state$calendar8.bookableDatesCriteria.departureCity) && options.productId === ((_state$calendar9 = state.calendar) === null || _state$calendar9 === void 0 ? void 0 : _state$calendar9.bookableDatesCriteria.productId)) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES_ABORT */ "g"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES */ "f"], {}, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchBookableDates */ "f"])(appContext, options)
    }));
  };
}
function selectMonth(selectedMonth) {
  // format YYYYMM (number)
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_CHANGE_MONTH */ "a"], {
    selectedMonth: selectedMonth
  });
}

function determineDepartureDate(state) {
  if (!Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state)) {
    var departureDateFromUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__[/* getQueryParameters */ "j"])(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocation()), _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__[/* QUERY_DEPARTURE_DATE */ "g"]);

    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(departureDateFromUrl, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]) || Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state);
  }

  return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
}

function setPossibleDepartureDate() {
  return function (dispatch, getState) {
    var findDayInMonths = function findDayInMonths() {
      var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dayId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var id = parseInt(dayId, 10);
      var allDays = months.reduce(function (acc, m) {
        return [].concat(acc, m.days);
      }, []);
      return allDays.find(function (d) {
        return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(d, 'dayContent.id') === id;
      });
    };

    var departureDate = determineDepartureDate(getState());

    if (departureDate) {
      var calendarMonth = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(getState(), 'calendar.calendar.months');

      var day = findDayInMonths(calendarMonth, departureDate);

      var dayContent = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(day, 'dayContent', null);

      if (dayContent) {
        if (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(dayContent, 'canGoToBooking')) {
          var yearAndMonth = parseInt(dayContent.id / 100, 10);
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: dayContent
            })); // makes sure tripCriteria.departureDate in store is synchronised
            // TODO: merge tripDateCriteria into tripCriteria #12563

            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_5___default()("".concat(dayContent.id), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]).valueOf()));
            dispatch(selectMonth(yearAndMonth));
          });
        } else {
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: null
            }));
            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(null));
          });
        }
      }
    }
  };
}
var setInitialDuration = function setInitialDuration(duration) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_INITIAL_DURATION */ "c"],
    payload: {
      duration: duration
    }
  };
};
var setIsPriceCalendarSelection = function setIsPriceCalendarSelection(isPriceCalendarSelection) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION */ "d"],
    payload: {
      isPriceCalendarSelection: isPriceCalendarSelection
    }
  };
};
var setCalendarBlockInputDepartureDate = function setCalendarBlockInputDepartureDate(blockInputDepartureDate) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */ "b"],
    payload: {
      blockInputDepartureDate: blockInputDepartureDate
    }
  };
};
var clearCalendar = function clearCalendar() {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CLEAR_CALENDAR */ "e"]
  };
};

/***/ }),

/***/ "rvZv":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "s2Gj":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),

/***/ "s9tc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEventFormResorts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventFormRegions; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("yjkv");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9BmX");
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_toUpper__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_8__);









var getEventFormResorts = function getEventFormResorts(resorts) {
  return lodash_sortBy__WEBPACK_IMPORTED_MODULE_8___default()(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_6___default()(resorts, 'id').map(function (_ref) {
    var _destination$areaId$s;

    var id = _ref.id,
        name = _ref.name,
        destination = _ref.destination,
        openingStatus = _ref.openingStatus;
    return {
      id: id,
      name: name,
      openingStatus: openingStatus,
      region: destination.area,
      regionId: (_destination$areaId$s = destination.areaId.split('_').splice(3).join('_')) === null || _destination$areaId$s === void 0 ? void 0 : _destination$areaId$s.toUpperCase()
    };
  }), function (resort) {
    return lodash_toUpper__WEBPACK_IMPORTED_MODULE_7___default()(resort.name);
  });
};
var getEventFormRegions = function getEventFormRegions(resorts) {
  return lodash_sortBy__WEBPACK_IMPORTED_MODULE_8___default()(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_6___default()(resorts, function (resort) {
    return resort.regionId;
  }).map(function (_ref2) {
    var region = _ref2.region,
        regionId = _ref2.regionId;
    return {
      name: region,
      value: regionId
    };
  }), function (region) {
    return lodash_toUpper__WEBPACK_IMPORTED_MODULE_7___default()(region.name);
  });
};

/***/ }),

/***/ "sCYz":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var getBuiltIn = __webpack_require__("x90g");
var wellKnownSymbol = __webpack_require__("nJrx");
var defineBuiltIn = __webpack_require__("Swp0");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_CRITERIA_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILDCARE_FILTER_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SEASON_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLIGHT_DURATION_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SORT_BY_PRICE_QUERY_PARAM; });
/* unused harmony export PRODUCTS_TO_COMPARE_QUERY_PARAM */
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOM_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GROUP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHILDCARE_FILTER_FACET_OPTION_0_TO_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHILDCARE_FILTER_FACET_OPTION_2_TO_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHILDCARE_FILTER_FACET_OPTION_4_TO_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHILDCARE_FILTER_FACET_OPTION_11_TO_17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHILDCARE_FILTER_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHILDCARE_FILTER_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FILTER_FACET_AVERAGE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FLIGHT_DURATION_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLIGHT_DURATION_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FLIGHT_DURATION_FACET_AS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SEASON_FACET_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEASON_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEASON_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEASON_FACET_QUERY_PARAM_FR_TO_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SEASON_FACET_QUERY_PARAM_EN_TO_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TYPES_OF_STAY_FACET_BADGE_ICON_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TYPES_OF_STAY_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TYPES_OF_STAY_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
var CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var SEASON_FACET_ID = 'seasons_ns';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_types';
var FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
var QUERY_QUERY_PARAM = 'search';
var SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, CHILDCARE_FILTER_FACET_ID, COUNTRIES_FACET_ID, DESTINATIONS_FACET_ID, SEASON_FACET_ID, TYPES_OF_STAY_FACET_ID];
var CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  trackingPrefixLabel: 'childcare'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  trackingPrefixLabel: 'season'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}];
var GROUP_STRING = 'group::';
var CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = "".concat(GROUP_STRING, "from_0_to_2");
var CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = "".concat(GROUP_STRING, "from_2_to_3");
var CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = "".concat(GROUP_STRING, "from_4_to_10");
var CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = "".concat(GROUP_STRING, "from_11_to_17");
var CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';
var CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "babyClub"),
  from_2_to_3: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "miniClub"),
  from_4_to_10: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "petitClub"),
  from_11_to_17: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "teenClub")
};
var CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168
};
var FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';
var FLIGHT_DURATION_FACET_LABELS = {
  '2h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "2h"),
  '4h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "4h"),
  '8h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h"),
  '8hmore': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h_more")
};
var FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [{
    label: '2h',
    value: '2h',
    count: -1
  }, {
    label: '4h',
    value: '4h',
    count: -1
  }, {
    label: '8h',
    value: '8h',
    count: -1
  }, {
    label: '8hmore',
    value: '8hmore',
    count: -1
  }]
};
var SEASON_FACET_FIRST_OPTION = 'SOLEIL';
var SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';
var SEASON_FACET_LABELS = {
  NEIGE: "".concat(SEASON_FACET_LABELS_PREFIX, "snow"),
  SOLEIL: "".concat(SEASON_FACET_LABELS_PREFIX, "sun")
};
var SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN'
};
var SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL'
};
var NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];
var TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT3
  },
  4: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT4
  },
  5: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].DIAMOND
  },
  6: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT6
  },
  CRUISE: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].CRUISE
  },
  JOYVIEW: {
    className: 'rounded-4 size-40 bg-blueWave border-blueWave text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT_JOYVIEW
  },
  TOUR: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TOUR
  }
};
var TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';
var TYPES_OF_STAY_FACET_LABELS = {
  3: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "3_tridents"),
  4: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "4_tridents"),
  5: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "exclusive_collection"),
  6: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "villa"),
  CRUISE: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "cruise"),
  JOYVIEW: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "joyview"),
  TOUR: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "tour")
};
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.filters.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.filters.where.countriesTitle'
  }],
  titleLabel: 'faceting.filters.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  titleLabel: 'faceting.filters.activities.title'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  dataLabel: 'childcare',
  facetLists: [{
    deep: false,
    id: CHILDCARE_FILTER_FACET_ID,
    facetLabels: CHILDCARE_FILTER_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.childcare.title',
  trackingPrefixLabel: 'childcare'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: TYPES_OF_STAY_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  dataLabel: 'flightDuration',
  facetLists: [{
    deep: false,
    id: FLIGHT_DURATION_FACET_ID,
    facetLabels: FLIGHT_DURATION_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.flightDuration.title',
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  capitalizeLabels: true,
  dataLabel: 'season',
  facetLists: [{
    deep: false,
    id: SEASON_FACET_ID,
    facetLabels: SEASON_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.season.title',
  trackingPrefixLabel: 'season'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sfoL":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("/GgU");
var ownKeys = __webpack_require__("1m4l");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "sjzV":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW");

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ "ssvU":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "t/wz":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  return +value;
}

module.exports = baseToNumber;


/***/ }),

/***/ "tI+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGE_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PACKAGE_ROOM_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CEFALU_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELUXE_COMFORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PACKAGE_FOOD_AND_BEVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMFORT_TYPE_SUITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMFORT_TYPE_CHALET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMFORT_TYPE_VILLA; });
var PACKAGE_ALL_INCLUSIVE = 'PAI';
var PACKAGE_ROOM_ONLY = 'RON';
var PACKAGE_FOOD_AND_BEVERAGE = 'FFB';
var CEFALU_RESORT = 'CFAC';
var DELUXE_COMFORT = 'Deluxe';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var COMFORT_TYPE_SUITE = 'typeoflodging_comfort_type_suite';
var COMFORT_TYPE_CHALET = 'typeoflodging_comfort_type_chalet';
var COMFORT_TYPE_VILLA = 'typeoflodging_comfort_type_villa';


/***/ }),

/***/ "tNma":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _cloneDeepWith = _interopRequireDefault(__webpack_require__("NdXQ"));

var _toArray2 = _interopRequireDefault(__webpack_require__("Vk6K"));

var _locale = __webpack_require__("qr7w");

var _Condition = _interopRequireDefault(__webpack_require__("hCAA"));

var _runValidations = _interopRequireDefault(__webpack_require__("wM5X"));

var _prependDeep = _interopRequireDefault(__webpack_require__("n4a0"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _createValidation = _interopRequireDefault(__webpack_require__("JeoY"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _reach = __webpack_require__("zBae");

var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(_locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

var proto = SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    var before = this._mutate;
    this._mutate = true;
    var result = fn(this);
    this._mutate = before;
    return result;
  },
  concat: function concat(schema) {
    if (!schema || schema === this) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var next = (0, _prependDeep.default)(schema.clone(), this); // new undefined default is overriden by old non-undefined one, revert

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = this.tests;
    next._exclusive = this._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    next.withMutation(function (next) {
      schema.tests.forEach(function (fn) {
        next.test(fn.OPTIONS);
      });
    });
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(options) {
    var schema = this;

    if (schema._conditions.length) {
      var conditions = schema._conditions;
      schema = schema.clone();
      schema._conditions = [];
      schema = conditions.reduce(function (schema, condition) {
        return condition.resolve(schema, options);
      }, schema);
      schema = schema.resolve(options);
    }

    return schema;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict(isStrict) {
    if (isStrict === void 0) {
      isStrict = true;
    }

    var next = this.clone();
    next._options.strict = isStrict;
    return next;
  },
  _isPresent: function _isPresent(value) {
    return value != null;
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      exclusive: true,
      test: function test(value) {
        return this.schema._isPresent(value);
      }
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.OPTIONS.name !== 'required';
    });
    return next;
  },
  nullable: function nullable(isNullable) {
    if (isNullable === void 0) {
      isNullable = true;
    }

    var next = this.clone();
    next._nullable = isNullable;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    var opts;

    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }

    if (opts.message === undefined) opts.message = _locale.mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    if (arguments.length === 1) {
      options = keys;
      keys = '.';
    }

    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (dep.isSibling) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return {
          name: fn.OPTIONS.name,
          params: fn.OPTIONS.params
        };
      }).filter(function (n, idx, list) {
        return list.findIndex(function (c) {
          return c.name === n.name;
        }) === idx;
      })
    };
  }
};
var _arr = ['validate', 'validateSync'];

var _loop = function _loop() {
  var method = _arr[_i];

  proto[method + "At"] = function (path, value, options) {
    if (options === void 0) {
      options = {};
    }

    var _getIn = (0, _reach.getIn)(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], (0, _extends2.default)({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i = 0; _i < _arr.length; _i++) {
  _loop();
}

var _arr2 = ['equals', 'is'];

for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
  var alias = _arr2[_i2];
  proto[alias] = proto.oneOf;
}

var _arr3 = ['not', 'nope'];

for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
  var _alias = _arr3[_i3];
  proto[_alias] = proto.notOneOf;
}

proto.optional = proto.notRequired;
module.exports = exports["default"];

/***/ }),

/***/ "tPlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantsErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DwNm");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ParticipantsErrors = function ParticipantsErrors(_ref) {
  var className = _ref.className,
      config = _ref.config,
      errors = _ref.errors,
      isSubmitted = _ref.isSubmitted;
  var maxPax = errors.maxPax,
      departureDate = errors.departureDate,
      birthdays = errors.birthdays,
      birthdaysErrorMessage = errors.birthdaysErrorMessage;

  if (maxPax) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.errorMaxGuestsLabel
    });
  }

  if (isSubmitted && departureDate) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.departureDateErrorMessage
    });
  }

  if (isSubmitted && birthdays) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: birthdaysErrorMessage
    });
  }

  return null;
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelToSnakeCase; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str ? str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  }) : '';
};



/***/ }),

/***/ "tnKh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumber;
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

var objectToString = Object.prototype.toString;

function isNumber(value) {
  var numberTag = '[object Number]';
  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
}

/***/ }),

/***/ "ttFy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("Km8e");

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {}

var validateFormat = function validateFormat(format) {};

if (false) {}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) { var printWarning; }

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "tuzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRateMessagesProperties; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].FLEX_RATES;
var getRateMessagesProperties = function getRateMessagesProperties(rate) {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLegal')
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLegal')
      };

    default:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLegal')
      };
  }
};

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uGjT":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCustomerSearchResult; });
/* unused harmony export filterProposalBySamePackage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransportsError; });
/* unused harmony export getAllChildcaresByProductInfoId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCityTransportsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsPmrChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdditionalAccommodationsError; });
/* unused harmony export getFilteredAdditionalAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalTransports; });
/* unused harmony export getSearchCriteriaTransports */
/* unused harmony export getSearchCriteriaTransportsInbound */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getPaymentProviders; });
/* unused harmony export getProposalsWithMappedAttendees */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCurrentProposal; });
/* unused harmony export getCurrentTotalPrice */
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getInsurancesStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getStreetViews; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("1IsZ");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("eZ08");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getCityTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref3) {
  var additionalTransports = _ref3.additionalTransports;
  return additionalTransports.transports.cityTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref4) {
  var paymentProviders = _ref4.paymentProviders;
  return paymentProviders;
});
var getInsurancesStore = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref5) {
  var insurance = _ref5.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var searchCriteria = _ref7.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var transports = _ref8.transports;
  return transports;
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var error = _ref9.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var isLoading = _ref10.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref11) {
  var additionalAccommodations = _ref11.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref12) {
  var isLoading = _ref12.isLoading;
  return isLoading;
});
var getIsLoadingFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref13) {
  var isLoadingFilteredAccommodationsAlternativesByComfort = _ref13.isLoadingFilteredAccommodationsAlternativesByComfort;
  return isLoadingFilteredAccommodationsAlternativesByComfort;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var accommodationsSets = _ref14.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var filters = _ref15.filters;
  return filters;
});
var getAdditionalAccommodationsPmrChecked = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var isPmrChecked = _ref16.isPmrChecked;
  return isPmrChecked;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var error = _ref17.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var filteredAccommodations = _ref18.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var getFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref19) {
  var filteredAccommodationsAlternativesByComfort = _ref19.filteredAccommodationsAlternativesByComfort;
  return filteredAccommodationsAlternativesByComfort;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref20) {
  var proposals = _ref20.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref21) {
  var resort = _ref21.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref22) {
  var selectedProposalId = _ref22.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref23) {
  var proposals = _ref23.proposals,
      selectedProposalId = _ref23.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* getDefaultProposal */ "d"])(proposals)
  );
});
var getAllChildcaresByProductInfoId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state, productInfoId) {
  return productInfoId;
}, function (_ref24, productInfoId) {
  var additionalServices = _ref24.additionalServices;
  return additionalServices.childcares.filter(function (_ref25) {
    var id = _ref25.pricingInfo.id;
    return id === productInfoId;
  });
});
var getCurrentTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (proposal) {
  return proposal.price.total.value;
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal, resort) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  } // todo add the urban oasis condition once the feature is merged and ofc remove this comment 🤷‍ (Souhail)


  return (resort === null || resort === void 0 ? void 0 : resort.isJoyview) || (resort === null || resort === void 0 ? void 0 : resort.isUrbanOasis) ? proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  }) : proposals.filter(function (item) {
    var _item$accommodations2 = item.accommodations,
        accommodations = _item$accommodations2 === void 0 ? [] : _item$accommodations2;
    return accommodations.length;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(proposalsSelector, getCurrentProposal, getCurrentResort, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref26) {
  var rentalEquipments = _ref26.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getStreetViews = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref27) {
  var streetViews = _ref27.streetViews;
  return streetViews;
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref28) {
  var suggestions = _ref28.suggestions;
  return suggestions;
});
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state) {
  return Object(_attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__[/* selectAttendeesWithInfosByHouseholds */ "c"])(state).attendees;
}, function (_ref29, attendeesWithInfos) {
  var additionalServices = _ref29.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.attendees.forEach(function (attendee) {
      var product = {
        price: attendee.rentedAmount.value,
        services: [service]
      };

      if (attendee.rentedAmount.value > 0) {
        if (!acc[attendee.id]) {
          acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])({}, productInfo.id, _objectSpread({}, product));
        } else if (!acc[attendee.id][productInfo.id]) {
          acc[attendee.id][productInfo.id] = _objectSpread({}, product);
        } else {
          acc[attendee.id][productInfo.id].services.push(service);
        }
      }
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref30) {
    var _ref31 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref30, 2),
        id = _ref31[0],
        rentedServices = _ref31[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref32) {
  var booking = _ref32.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("05v4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */








var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])();
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_16__["useRouter"])();
  var uri = router.asPath;
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "pointer-events-auto flex cursor-default flex-col items-center justify-center gap-20 bg-white p-30",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__[/* ENTER */ "f"]) {
        router.push(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col items-center justify-center gap-10"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("p", {
    className: "rounded-4 bg-turquoise px-10 py-5 text-12 font-bold text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(statusMessageKey))), __jsx("p", {
    className: "text-center text-14 leading-tight text-black sm:leading-normal"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    "data-testid": "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      track(_objectSpread({
        categoryGA: 'resort',
        labelGA: 'switchSeason'
      }, trackingData));
      e.preventDefault();
      e.stopPropagation();
      router.push(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton')));
};

/***/ }),

/***/ "v5ZW":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIndexOf = __webpack_require__("c7Qd"),
    baseIndexOfWith = __webpack_require__("A0wc"),
    baseUnary = __webpack_require__("SU8Q"),
    copyArray = __webpack_require__("QT01");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),

/***/ "vCWs":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeCustomFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ customFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ productsBeforeActiveCustomFacetsFilteringSelector; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSearchFilterList; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector, productsFilteredWithActiveCustomFacetsSelector

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__("SqqE");
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/inRange.js
var inRange = __webpack_require__("+ILc");
var inRange_default = /*#__PURE__*/__webpack_require__.n(inRange);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/includes.js
var includes = __webpack_require__("qYhz");
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js


















var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    Object(defineProperty["a" /* default */])(this, "_list", void 0);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !includes_default()(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = isEmpty_default()(facets) ? constants["p" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["k" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return inRange_default()(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["d" /* CHILDCARE_CRITERIA_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(uniqWith_default()(childcareFilters, isEqual_default.a));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return isEmpty_default()(kids) ? this : this.addFilter({
        id: constants["c" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return pick_default()(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js









/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeCustomFacets = _ref2.activeCustomFacets;
  return activeCustomFacets || {};
});
var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var activeFacets = _ref3.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var query = _ref4.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var facets = _ref5.facets;
  return facets || [];
});
var customFiltersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var customFilters = _ref6.customFilters;
  return customFilters || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var filters = _ref7.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var prices = _ref8.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var _ref9$products = _ref9.products,
      products = _ref9$products === void 0 ? [] : _ref9$products;
  return products;
});
var productsBeforeActiveCustomFacetsFilteringSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$productsBefore = _ref10.productsBeforeActiveCustomFacetsFiltering,
      productsBeforeActiveCustomFacetsFiltering = _ref10$productsBefore === void 0 ? null : _ref10$productsBefore;
  return productsBeforeActiveCustomFacetsFiltering;
});
var productsFilteredWithActiveCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref11) {
  var _ref11$productsFilter = _ref11.productsFilteredWithActiveCustomFacets,
      productsFilteredWithActiveCustomFacets = _ref11$productsFilter === void 0 ? null : _ref11$productsFilter;
  return productsFilteredWithActiveCustomFacets;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$recommandedPro = _ref12.recommandedProducts,
      recommandedProducts = _ref12$recommandedPro === void 0 ? [] : _ref12$recommandedPro;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref13) {
  var banners = _ref13.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref14) {
  var _ref14$products = _ref14.products,
      products = _ref14$products === void 0 ? [] : _ref14$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref15) {
    var id = _ref15.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref16) {
  var _ref16$kidsValidation = _ref16.kidsValidationState,
      kidsValidationState = _ref16$kidsValidation === void 0 ? [] : _ref16$kidsValidation;
  return kidsValidationState;
});
var getSearchFilterList = Object(lib["createSelector"])(facetingSelector, function (_ref17) {
  var _ref17$searchFilterLi = _ref17.searchFilterList,
      searchFilterList = _ref17$searchFilterLi === void 0 ? [] : _ref17$searchFilterLi;
  return searchFilterList;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref18) {
      var _ref19 = Object(slicedToArray["a" /* default */])(_ref18, 2),
          filter = _ref19[0],
          isSelected = _ref19[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["c" /* ADULTS_ONLY_FACET_ID */], constants["d" /* CHILDCARE_CRITERIA_FACET_ID */], constants["r" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["y" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["g" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["r" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vJ43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTINATION", function() { return DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTINATION_TOUR", function() { return DESTINATION_TOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTINATION_MICE", function() { return DESTINATION_MICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTINATION_TRAVEL", function() { return DESTINATION_TRAVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESORT", function() { return RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUR", function() { return TOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CRUISE", function() { return CRUISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LANDING", function() { return LANDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LANDING_MICE", function() { return LANDING_MICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OFFER", function() { return OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PREBOOKING", function() { return PREBOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESORT_MICE", function() { return RESORT_MICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOMEPAGE", function() { return HOMEPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME", function() { return HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolve", function() { return resolve; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("CcNa");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("4i1p");














function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_13__["b2cPagesService"].PAGE_TYPES;
var DESTINATION = PAGE_TYPES.DESTINATION,
    DESTINATION_TOUR = PAGE_TYPES.DESTINATION_TOUR,
    DESTINATION_MICE = PAGE_TYPES.DESTINATION_MICE,
    DESTINATION_TRAVEL = PAGE_TYPES.DESTINATION_TRAVEL,
    RESORT = PAGE_TYPES.RESORT,
    TOUR = PAGE_TYPES.TOUR,
    CRUISE = PAGE_TYPES.CRUISE,
    LANDING = PAGE_TYPES.LANDING,
    LANDING_MICE = PAGE_TYPES.LANDING_MICE,
    OFFER = PAGE_TYPES.OFFER,
    PREBOOKING = PAGE_TYPES.PREBOOKING,
    RESORT_MICE = PAGE_TYPES.RESORT_MICE,
    HOMEPAGE = PAGE_TYPES.HOMEPAGE,
    HOME = PAGE_TYPES.HOME;


var getQuery = function getQuery(pageContext, location) {
  var pageType = pageContext.pageType,
      _pageContext$pageMeta = pageContext.pageMeta;
  _pageContext$pageMeta = _pageContext$pageMeta === void 0 ? {} : _pageContext$pageMeta;
  var resortId = _pageContext$pageMeta.resortId;
  var urlParams = location.urlParams,
      queryParams = location.queryParams; //$FlowFixMe

  var productId = resortId || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.productId) || '';
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_15__[/* buildProductArgs */ "c"])(productId, urlParams);

  if (pageType === LANDING) {
    return "query {\n      resort(".concat(productArgs, ") {\n        id\n        type\n      }\n    }");
  }

  var offerName = queryParams.offer ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_13__["url"].decodePath(queryParams.offer) : '';
  var departureCity = queryParams.departure_city || '';
  var productArgsWithOffer = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_15__[/* buildProductArgs */ "c"])(productId, urlParams, {
    offerName: offerName,
    departureCity: departureCity
  });
  return "query {\n    resort(".concat(productArgs, ") {\n      id type name comfort seasonName image destination {country area} adultOnly\n    }\n    price(").concat(productArgsWithOffer, ") {\n      termsAndConditions {\n        departureDate\n        departureCity { value name }\n      }\n      bestPrice {value}\n      initialPrice {value}\n    }\n    bookingCriteria(").concat(productArgs, ") {\n      initialDuration(").concat(productArgsWithOffer, ")\n      initialNumberOfAdults(").concat(productArgsWithOffer, ")\n      initialNumberOfChildren\n    }\n  }");
};

var trackingData = function trackingData(pageContext, location, props) {
  var pagePath = location.pathname;

  var pageProps = _objectSpread(_objectSpread({}, pageContext), {}, {
    pagePath: pagePath
  });

  var resort = props.resort,
      price = props.price,
      bookingCriteria = props.bookingCriteria;
  var pageData = {
    resort: resort,
    price: price,
    bookingCriteria: bookingCriteria
  };

  switch (pageContext.pageType) {
    case OFFER:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getOfferTrackingProps */ "f"])(pageProps);

    case DESTINATION:
    case DESTINATION_TOUR:
    case DESTINATION_MICE:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getDestinationTrackingProps */ "b"])(pageProps);

    case DESTINATION_TRAVEL:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getDestinationTravelTrackingProps */ "c"])(pageProps);

    case RESORT:
    case CRUISE:
    case RESORT_MICE:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getResortTrackingProps */ "h"])(_objectSpread(_objectSpread({}, pageProps), {}, {
        pageData: pageData
      }));

    case TOUR:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getTourTrackingProps */ "i"])(_objectSpread(_objectSpread({}, pageProps), {}, {
        pageData: pageData
      }));

    case LANDING:
    case LANDING_MICE:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getLandingTrackingProps */ "e"])(pageProps, resort);

    case PREBOOKING:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getPrebookingTrackingProps */ "g"])(pageProps);

    case HOME:
    case HOMEPAGE:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getHomepageTrackingProps */ "d"])(pageProps);

    default:
      return Object(_utils__WEBPACK_IMPORTED_MODULE_17__[/* getDefaultTrackingProps */ "a"])(pageProps);
  }
};

var resolve = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(appContext, cmsProps, pageContext, location) {
    var pageType, _pageContext$pageMeta2, resortId, queryParams, productId, query, data;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageType = pageContext.pageType, _pageContext$pageMeta2 = pageContext.pageMeta;
            _pageContext$pageMeta2 = _pageContext$pageMeta2 === void 0 ? {} : _pageContext$pageMeta2;
            resortId = _pageContext$pageMeta2.resortId;
            queryParams = location.queryParams;
            productId = resortId || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.productId) || ''; // Fetch data for resort, resort_mice, tour and cruise pages only

            if (!(![RESORT, TOUR, CRUISE, RESORT_MICE, LANDING].includes(pageType) || !productId)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              trackingData: trackingData(pageContext, location, cmsProps)
            });

          case 7:
            _context.prev = 7;
            query = getQuery(pageContext, location);
            _context.next = 11;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__[/* LINE_COMMON_TRACKING */ "ob"],
              strictErrors: false
            });

          case 11:
            data = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, data), {}, {
              trackingData: trackingData(pageContext, location, _objectSpread(_objectSpread({}, data), cmsProps))
            }));

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](7);
            console.log('Error while fetching tracking data: ', _context.t0);
            return _context.abrupt("return", {});

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 15]]);
  }));

  return function resolve(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "vnfA":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "vpua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getValidateFieldFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusNextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInputClasses; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("C/y5");
/* harmony import */ var _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("45yR");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_8__);









var getValidationStatus = function getValidationStatus(_ref, _ref2) {
  var name = _ref.name,
      value = _ref.value;
  var touched = _ref2.touched,
      errors = _ref2.errors,
      submitCount = _ref2.submitCount;
  var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hadInteraction = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(touched, name) || submitCount > 0;
  var validationState = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(errors, name) ? _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_INVALID */ "a"] : _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_VALID */ "b"];
  var isValidated = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_VALID */ "b"] && value;
  var isErrored = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_INVALID */ "a"];
  return {
    isDefaultState: !isValidated && !isErrored && !isDisabled,
    isErrored: isErrored,
    isTouched: hadInteraction,
    isValidated: isValidated
  };
}; // eslint-disable-next-line no-promise-executor-return

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var getValidateFieldFunction = function getValidateFieldFunction(validator, context, locale) {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee2(val) {
      var validationResult;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              validationResult = '';

              if (!(locale === 'ja-JP')) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return sleep(300).then( /*#__PURE__*/Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee() {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return validator.validateSync(val, {
                          context: context
                        });

                      case 3:
                        _context.next = 8;
                        break;

                      case 5:
                        _context.prev = 5;
                        _context.t0 = _context["catch"](0);
                        validationResult = _context.t0.message;

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 5]]);
              })));

            case 4:
              _context2.next = 14;
              break;

            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return validator.validateSync(val, {
                context: context
              });

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](6);
              validationResult = _context2.t0.message;

            case 14:
              return _context2.abrupt("return", validationResult);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 11]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var focusNextInput = function focusNextInput(target) {
  var nextRef = target.nextSibling;

  if (target.value.length === target.maxLength && nextRef) {
    nextRef.focus();
  }
};
var getInputClasses = function getInputClasses(_ref5) {
  var hasHeight = _ref5.hasHeight,
      _ref5$hasRadius = _ref5.hasRadius,
      hasRadius = _ref5$hasRadius === void 0 ? true : _ref5$hasRadius,
      hasValidationStatus = _ref5.hasValidationStatus,
      isDefaultState = _ref5.isDefaultState,
      isDisabled = _ref5.isDisabled,
      isErrored = _ref5.isErrored,
      isValidated = _ref5.isValidated,
      _ref5$hasNoBorder = _ref5.hasNoBorder,
      hasNoBorder = _ref5$hasNoBorder === void 0 ? false : _ref5$hasNoBorder;
  return Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__[/* classnames */ "a"])('w-full appearance-none border px-20 py-10 text-14 leading-normal text-black outline-none transition-all duration-250 ease-in', {
    'rounded-pill': hasRadius,
    'h-48': hasHeight,
    'border-lightGrey hocus:border-black': isDefaultState,
    'border-success': isValidated,
    'formik-errored border-red': isErrored,
    'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled,
    'pe-40': hasValidationStatus && (isErrored || isValidated),
    'border-none': hasNoBorder
  });
};

/***/ }),

/***/ "vuE1":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("XTsI");
__webpack_require__("nHh7");
__webpack_require__("hU7e");
__webpack_require__("xVUo");
__webpack_require__("cdJH");


/***/ }),

/***/ "wFQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceRemoteContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PriceRemoteContextProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var initialState = {
  isCompact: false,
  isDetailOpened: false,
  hasOpenedDetailsAtLeastOnce: false,
  hasShownOptionHoldAtLeastOnce: false,
  isInLayer: false,
  isJoyview: false,
  isOverrideSticky: true,
  isTotalPrice: false,
  submitPriceRemoteForm: function submitPriceRemoteForm() {}
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var PriceRemoteContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_8__["createContext"])([initialState, function () {}]);
var PriceRemoteContextProvider = function PriceRemoteContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(PriceRemoteContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "wKkN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var uncurryThis = __webpack_require__("kZDm");
var hiddenKeys = __webpack_require__("qXr/");
var isObject = __webpack_require__("1YFU");
var hasOwn = __webpack_require__("/GgU");
var defineProperty = __webpack_require__("87KK").f;
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternalModule = __webpack_require__("Ed3r");
var isExtensible = __webpack_require__("YF+p");
var uid = __webpack_require__("rvZv");
var FREEZING = __webpack_require__("+pJz");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "wM5X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _synchronousPromise = __webpack_require__("V5RX");

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var promise = function promise(sync) {
  return sync ? _synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var Promise = promise(sync);
  return Promise.all(promises.map(function (p) {
    return Promise.resolve(p).then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  }));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}

/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "waz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ToastContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({
  ref: null
});

/***/ }),

/***/ "we+H":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "woxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProgressBar_ProgressBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var themes = {
  "default": {
    thRoot: 'bg-darkGrey leading-0 overflow-hidden relative',
    thBar: 'transition-width duration-250 ease-in h-2'
  },
  rounded: {
    thRoot: 'bg-lightSand leading-0 overflow-hidden relative rounded-pill',
    thBar: 'rounded-pill transition-width duration-250 ease-in h-15'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx

var __jsx = react_default.a.createElement;




var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!isInteger_default()(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / (max - min);
  var currentPercent = stepPercent * (value - min);
  var _themes$theme = themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    role: "progressbar"
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%")
    }
  }));
};

/***/ }),

/***/ "wxLG":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "wyfB":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),

/***/ "x90g":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex items-center', {
        'flex-col gap-5 text-center': hasColumnLayout,
        'justify-between gap-10': !hasColumnLayout
      }),
      thLabel: Object(classnames_utils["a" /* classnames */])('text-14', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'block text-10',
      thInputs: 'flex gap-5 items-center shrink-0',
      thInput: Object(classnames_utils["a" /* classnames */])('outline-custom h-30 text-center text-18 font-bold leading-[1.875em]', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in size-48',
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop_default.a : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? noop_default.a : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          _this$props4$dataTest = _this$props4.dataTestId,
          dataTestId = _this$props4$dataTest === void 0 ? 'InputNumber' : _this$props4$dataTest,
          _this$props4$hasColum = _this$props4.hasColumnLayout,
          hasColumnLayout = _this$props4$hasColum === void 0 ? false : _this$props4$hasColum,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("span", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-decrease"),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 0.5, "em")
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-increase"),
        disabled: increaseDisabled,
        onClick: this.increase,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "xP4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ components_map; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ components_marker; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ components_popup; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ navigation_control; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ components_source; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ components_layer; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ useMap; });

// UNUSED EXPORTS: Map, AttributionControl, FullscreenControl, GeolocateControl, ScaleControl, useControl, MapProvider

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/use-map.js



const MountedMapsContext = react["createContext"](null);
const MapProvider = props => {
    const [maps, setMaps] = Object(react["useState"])({});
    const onMapMount = Object(react["useCallback"])((map, id = 'default') => {
        setMaps(currMaps => {
            if (id === 'current') {
                throw new Error("'current' cannot be used as map id");
            }
            if (currMaps[id]) {
                throw new Error(`Multiple maps with the same id: ${id}`);
            }
            return { ...currMaps, [id]: map };
        });
    }, []);
    const onMapUnmount = Object(react["useCallback"])((id = 'default') => {
        setMaps(currMaps => {
            if (currMaps[id]) {
                const nextMaps = { ...currMaps };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return (react["createElement"](MountedMapsContext.Provider, { value: {
            maps,
            onMapMount,
            onMapUnmount
        } }, props.children));
};
function useMap() {
    var _a;
    const maps = (_a = Object(react["useContext"])(MountedMapsContext)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = Object(react["useContext"])(MapContext);
    const mapsWithCurrent = Object(react["useMemo"])(() => {
        return { ...maps, current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map };
    }, [maps, currentMap]);
    return mapsWithCurrent;
}
//# sourceMappingURL=use-map.js.map
// EXTERNAL MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/mapbox/mapbox.js
var mapbox_mapbox = __webpack_require__("M2Ff");

// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/mapbox/create-ref.js
/** These methods may break the react binding if called directly */
const skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function createRef(mapInstance, mapLib) {
    if (!mapInstance) {
        return null;
    }
    const map = mapInstance.map;
    const result = {
        getMap: () => map,
        // Overwrite getters to use our shadow transform
        getCenter: () => mapInstance.transform.center,
        getZoom: () => mapInstance.transform.zoom,
        getBearing: () => mapInstance.transform.bearing,
        getPitch: () => mapInstance.transform.pitch,
        getPadding: () => mapInstance.transform.padding,
        getBounds: () => mapInstance.transform.getBounds(),
        project: (lnglat) => {
            return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
        },
        unproject: (point) => {
            return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
        }
    };
    for (const key of getMethodNames(map)) {
        // @ts-expect-error
        if (!(key in result) && !skipMethods.includes(key)) {
            result[key] = map[key].bind(map);
        }
    }
    return result;
}
function getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while (proto) {
        for (const key of Object.getOwnPropertyNames(proto)) {
            if (key[0] !== '_' &&
                typeof obj[key] === 'function' &&
                key !== 'fire' &&
                key !== 'setEventedParent') {
                result.add(key);
            }
        }
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}
//# sourceMappingURL=create-ref.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/utils/use-isomorphic-layout-effect.js
// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
/* harmony default export */ var use_isomorphic_layout_effect = (useIsomorphicLayoutEffect);
//# sourceMappingURL=use-isomorphic-layout-effect.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/utils/set-globals.js
const globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function setGlobals(mapLib, props) {
    for (const key of globalSettings) {
        if (key in props) {
            mapLib[key] = props[key];
        }
    }
    if (props.RTLTextPlugin &&
        mapLib.getRTLTextPluginStatus &&
        mapLib.getRTLTextPluginStatus() === 'unavailable') {
        mapLib.setRTLTextPlugin(props.RTLTextPlugin, (error) => {
            if (error) {
                // eslint-disable-next-line
                console.error(error);
            }
        }, false);
    }
}
//# sourceMappingURL=set-globals.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/map.js







const MapContext = react["createContext"](null);
const defaultProps = {
    // Constraints
    minZoom: 0,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    // Interaction handlers
    scrollZoom: true,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    // Style
    mapStyle: { version: 8, sources: {}, layers: [] },
    styleDiffing: true,
    projection: 'mercator',
    renderWorldCopies: true,
    // Callbacks
    onError: e => console.error(e.error),
    // Globals
    RTLTextPlugin: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js'
};
const Map = Object(react["forwardRef"])((props, ref) => {
    const mountedMapsContext = Object(react["useContext"])(MountedMapsContext);
    const [mapInstance, setMapInstance] = Object(react["useState"])(null);
    const containerRef = Object(react["useRef"])();
    const { current: contextValue } = Object(react["useRef"])({ mapLib: null, map: null });
    Object(react["useEffect"])(() => {
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || __webpack_require__.e(/* import() */ 173).then(__webpack_require__.t.bind(null, "QGPn", 7)))
            .then(mapboxgl => {
            if (!isMounted) {
                return;
            }
            if (!mapboxgl.Map) {
                // commonjs style
                mapboxgl = mapboxgl.default;
            }
            if (!mapboxgl || !mapboxgl.Map) {
                throw new Error('Invalid mapLib');
            }
            if (mapboxgl.supported(props)) {
                setGlobals(mapboxgl, props);
                if (props.reuseMaps) {
                    mapbox = mapbox_mapbox["a" /* default */].reuse(props, containerRef.current);
                }
                if (!mapbox) {
                    mapbox = new mapbox_mapbox["a" /* default */](mapboxgl.Map, props, containerRef.current);
                }
                contextValue.map = createRef(mapbox, mapboxgl);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapMount(contextValue.map, props.id);
            }
            else {
                throw new Error('Map is not supported by this browser');
            }
        })
            .catch(error => {
            props.onError({
                type: 'error',
                target: null,
                originalEvent: null,
                error
            });
        });
        return () => {
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) {
                    mapbox.recycle();
                }
                else {
                    mapbox.destroy();
                }
            }
        };
    }, []);
    use_isomorphic_layout_effect(() => {
        if (mapInstance) {
            mapInstance.setProps(props);
        }
    });
    Object(react["useImperativeHandle"])(ref, () => contextValue.map, [mapInstance]);
    const style = Object(react["useMemo"])(() => ({
        position: 'relative',
        width: '100%',
        height: '100%',
        ...props.style
    }), [props.style]);
    return (react["createElement"]("div", { id: props.id, ref: containerRef, style: style }, mapInstance && (react["createElement"](MapContext.Provider, { value: contextValue }, props.children))));
});
Map.displayName = 'Map';
Map.defaultProps = defaultProps;
/* harmony default export */ var components_map = (Map);
//# sourceMappingURL=map.js.map
// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");

// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/utils/apply-react-style.js
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function applyReactStyle(element, styles) {
    if (!element || !styles) {
        return;
    }
    const style = element.style;
    for (const key in styles) {
        const value = styles[key];
        if (Number.isFinite(value) && !unitlessNumber.test(key)) {
            style[key] = `${value}px`;
        }
        else {
            style[key] = value;
        }
    }
}
//# sourceMappingURL=apply-react-style.js.map
// EXTERNAL MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/utils/deep-equal.js
var deep_equal = __webpack_require__("/xkv");

// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/marker.js
/* global document */






const marker_defaultProps = {
    draggable: false,
    popup: null,
    rotation: 0,
    rotationAlignment: 'auto',
    pitchAlignment: 'auto'
};
/* eslint-disable complexity,max-statements */
function Marker(props) {
    const { map, mapLib } = Object(react["useContext"])(MapContext);
    const thisRef = Object(react["useRef"])({ props });
    thisRef.current.props = props;
    const marker = Object(react["useMemo"])(() => {
        let hasChildren = false;
        react["Children"].forEach(props.children, el => {
            if (el) {
                hasChildren = true;
            }
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options).setLngLat([props.longitude, props.latitude]);
        mk.getElement().addEventListener('click', (e) => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, {
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', e => {
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
        });
        mk.on('drag', e => {
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
        });
        mk.on('dragend', e => {
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
        });
        return mk;
    }, []);
    Object(react["useEffect"])(() => {
        marker.addTo(map.getMap());
        return () => {
            marker.remove();
        };
    }, []);
    Object(react["useEffect"])(() => {
        applyReactStyle(marker.getElement(), props.style);
    }, [props.style]);
    if (marker.getLngLat().lng !== props.longitude || marker.getLngLat().lat !== props.latitude) {
        marker.setLngLat([props.longitude, props.latitude]);
    }
    if (props.offset && !Object(deep_equal["a" /* arePointsEqual */])(marker.getOffset(), props.offset)) {
        marker.setOffset(props.offset);
    }
    if (marker.isDraggable() !== props.draggable) {
        marker.setDraggable(props.draggable);
    }
    if (marker.getRotation() !== props.rotation) {
        marker.setRotation(props.rotation);
    }
    if (marker.getRotationAlignment() !== props.rotationAlignment) {
        marker.setRotationAlignment(props.rotationAlignment);
    }
    if (marker.getPitchAlignment() !== props.pitchAlignment) {
        marker.setPitchAlignment(props.pitchAlignment);
    }
    if (marker.getPopup() !== props.popup) {
        marker.setPopup(props.popup);
    }
    return Object(react_dom["createPortal"])(props.children, marker.getElement());
}
Marker.defaultProps = marker_defaultProps;
// @ts-ignore
/* harmony default export */ var components_marker = (react["memo"](Marker));
//# sourceMappingURL=marker.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/popup.js
/* global document */






// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */
function Popup(props) {
    const { map, mapLib } = Object(react["useContext"])(MapContext);
    const container = Object(react["useMemo"])(() => {
        return document.createElement('div');
    }, []);
    const thisRef = Object(react["useRef"])({ props });
    thisRef.current.props = props;
    const popup = Object(react["useMemo"])(() => {
        const options = { ...props };
        const pp = new mapLib.Popup(options).setLngLat([props.longitude, props.latitude]);
        pp.once('open', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        return pp;
    }, []);
    Object(react["useEffect"])(() => {
        const onClose = e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return () => {
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) {
                popup.remove();
            }
        };
    }, []);
    Object(react["useEffect"])(() => {
        applyReactStyle(popup.getElement(), props.style);
    }, [props.style]);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) {
            popup.setLngLat([props.longitude, props.latitude]);
        }
        // @ts-ignore
        if (props.offset && !Object(deep_equal["b" /* deepEqual */])(popup.options.offset, props.offset)) {
            popup.setOffset(props.offset);
        }
        // @ts-ignore
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            // @ts-ignore
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        // @ts-ignore
        if (popup.options.className !== props.className) {
            // @ts-ignore
            const prevClassList = getClassList(popup.options.className);
            const nextClassList = getClassList(props.className);
            for (const c of prevClassList) {
                if (!nextClassList.has(c)) {
                    popup.removeClassName(c);
                }
            }
            for (const c of nextClassList) {
                if (!prevClassList.has(c)) {
                    popup.addClassName(c);
                }
            }
            // @ts-ignore
            popup.options.className = props.className;
        }
    }
    return Object(react_dom["createPortal"])(props.children, container);
}
// @ts-ignore
/* harmony default export */ var components_popup = (react["memo"](Popup));
//# sourceMappingURL=popup.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/use-control.js


function useControl(onCreate, onRemove, opts) {
    const context = Object(react["useContext"])(MapContext);
    const ctrl = Object(react["useMemo"])(() => onCreate(context), []);
    Object(react["useEffect"])(() => {
        var _a;
        const { map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, (_a = (opts || onRemove)) === null || _a === void 0 ? void 0 : _a.position);
        }
        return () => {
            if (typeof onRemove === 'function') {
                onRemove(context);
            }
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) {
                map.removeControl(ctrl);
            }
        };
    }, []);
    return ctrl;
}
//# sourceMappingURL=use-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/attribution-control.js




function AttributionControl(props) {
    const ctrl = useControl(({ mapLib }) => new mapLib.AttributionControl(props), {
        position: props.position
    });
    Object(react["useEffect"])(() => {
        // @ts-ignore
        applyReactStyle(ctrl._container, props.style);
    }, [props.style]);
    return null;
}
/* harmony default export */ var attribution_control = (react["memo"](AttributionControl));
//# sourceMappingURL=attribution-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/fullscreen-control.js
/* global document */




function FullscreenControl(props) {
    const ctrl = useControl(({ mapLib }) => new mapLib.FullscreenControl({
        container: props.containerId && document.getElementById(props.containerId)
    }), { position: props.position });
    Object(react["useEffect"])(() => {
        // @ts-ignore
        applyReactStyle(ctrl._controlContainer, props.style);
    }, [props.style]);
    return null;
}
/* harmony default export */ var fullscreen_control = (react["memo"](FullscreenControl));
//# sourceMappingURL=fullscreen-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/geolocate-control.js




const GeolocateControl = Object(react["forwardRef"])((props, ref) => {
    const thisRef = Object(react["useRef"])({ props });
    const ctrl = useControl(({ mapLib }) => {
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        const setupUI = gc._setupUI;
        gc._setupUI = args => {
            if (!gc._container.hasChildNodes()) {
                setupUI(args);
            }
        };
        gc.on('geolocate', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        gc.on('error', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        gc.on('outofmaxbounds', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        gc.on('trackuserlocationstart', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        gc.on('trackuserlocationend', e => {
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        });
        return gc;
    }, { position: props.position });
    thisRef.current.props = props;
    Object(react["useImperativeHandle"])(ref, () => ({
        trigger: () => ctrl.trigger()
    }), []);
    Object(react["useEffect"])(() => {
        // @ts-ignore
        applyReactStyle(ctrl._container, props.style);
    }, [props.style]);
    return null;
});
GeolocateControl.displayName = 'GeolocateControl';
/* harmony default export */ var geolocate_control = (react["memo"](GeolocateControl));
//# sourceMappingURL=geolocate-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/navigation-control.js




function NavigationControl(props) {
    const ctrl = useControl(({ mapLib }) => new mapLib.NavigationControl(props), {
        position: props.position
    });
    Object(react["useEffect"])(() => {
        // @ts-ignore
        applyReactStyle(ctrl._container, props.style);
    }, [props.style]);
    return null;
}
/* harmony default export */ var navigation_control = (react["memo"](NavigationControl));
//# sourceMappingURL=navigation-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/scale-control.js




const scale_control_defaultProps = {
    unit: 'metric',
    maxWidth: 100
};
function ScaleControl(props) {
    const ctrl = useControl(({ mapLib }) => new mapLib.ScaleControl(props), {
        position: props.position
    });
    // @ts-ignore
    if (ctrl.options.unit !== props.unit || ctrl.options.maxWidth !== props.maxWidth) {
        // @ts-ignore
        ctrl.options.maxWidth = props.maxWidth;
        // This method will trigger an update
        ctrl.setUnit(props.unit);
    }
    Object(react["useEffect"])(() => {
        // @ts-ignore
        applyReactStyle(ctrl._container, props.style);
    }, [props.style]);
    return null;
}
ScaleControl.defaultProps = scale_control_defaultProps;
/* harmony default export */ var scale_control = (react["memo"](ScaleControl));
//# sourceMappingURL=scale-control.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/utils/assert.js
function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
//# sourceMappingURL=assert.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/source.js






let sourceCounter = 0;
function createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = { ...props };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */
function updateSource(source, props, prevProps) {
    assert(props.id === prevProps.id, 'source id changed');
    assert(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for (const key in props) {
        if (key !== 'children' && key !== 'id' && !Object(deep_equal["b" /* deepEqual */])(prevProps[key], props[key])) {
            changedKey = key;
            changedKeyCount++;
        }
    }
    if (!changedKeyCount) {
        return;
    }
    const type = props.type;
    if (type === 'geojson') {
        source.setData(props.data);
    }
    else if (type === 'image') {
        source.updateImage({ url: props.url, coordinates: props.coordinates });
    }
    else if ((type === 'canvas' || type === 'video') &&
        changedKeyCount === 1 &&
        changedKey === 'coordinates') {
        source.setCoordinates(props.coordinates);
    }
    else if (type === 'vector' && 'setUrl' in source) {
        // Added in 1.12.0:
        // vectorTileSource.setTiles
        // vectorTileSource.setUrl
        switch (changedKey) {
            case 'url':
                source.setUrl(props.url);
                break;
            case 'tiles':
                source.setTiles(props.tiles);
                break;
            default:
        }
    }
    else {
        // eslint-disable-next-line
        console.warn(`Unable to update <Source> prop: ${changedKey}`);
    }
}
/* eslint-enable complexity */
function Source(props) {
    const map = Object(react["useContext"])(MapContext).map.getMap();
    const propsRef = Object(react["useRef"])(props);
    const [, setStyleLoaded] = Object(react["useState"])(0);
    const id = Object(react["useMemo"])(() => props.id || `jsx-source-${sourceCounter++}`, []);
    Object(react["useEffect"])(() => {
        if (map) {
            const forceUpdate = () => setStyleLoaded(version => version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return () => {
                var _a;
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers) {
                            // @ts-ignore (2339) source does not exist on all layer types
                            if (layer.source === id) {
                                map.removeLayer(layer.id);
                            }
                        }
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [map]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) {
        updateSource(source, props, propsRef.current);
    }
    else {
        source = createSource(map, id, props);
    }
    propsRef.current = props;
    return ((source &&
        react["Children"].map(props.children, child => child &&
            Object(react["cloneElement"])(child, {
                source: id
            }))) ||
        null);
}
/* harmony default export */ var components_source = (Source);
//# sourceMappingURL=source.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/components/layer.js




/* eslint-disable complexity, max-statements */
function updateLayer(map, id, props, prevProps) {
    assert(props.id === prevProps.id, 'layer id changed');
    assert(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') {
        return;
    }
    const { layout = {}, paint = {}, filter, minzoom, maxzoom, beforeId } = props;
    if (beforeId !== prevProps.beforeId) {
        map.moveLayer(id, beforeId);
    }
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for (const key in layout) {
            if (!Object(deep_equal["b" /* deepEqual */])(layout[key], prevLayout[key])) {
                map.setLayoutProperty(id, key, layout[key]);
            }
        }
        for (const key in prevLayout) {
            if (!layout.hasOwnProperty(key)) {
                map.setLayoutProperty(id, key, undefined);
            }
        }
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for (const key in paint) {
            if (!Object(deep_equal["b" /* deepEqual */])(paint[key], prevPaint[key])) {
                map.setPaintProperty(id, key, paint[key]);
            }
        }
        for (const key in prevPaint) {
            if (!paint.hasOwnProperty(key)) {
                map.setPaintProperty(id, key, undefined);
            }
        }
    }
    if (!Object(deep_equal["b" /* deepEqual */])(filter, prevProps.filter)) {
        map.setFilter(id, filter);
    }
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) {
        map.setLayerZoomRange(id, minzoom, maxzoom);
    }
}
function createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = { ...props, id };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */
let layerCounter = 0;
function Layer(props) {
    const map = Object(react["useContext"])(MapContext).map.getMap();
    const propsRef = Object(react["useRef"])(props);
    const [, setStyleLoaded] = Object(react["useState"])(0);
    const id = Object(react["useMemo"])(() => props.id || `jsx-layer-${layerCounter++}`, []);
    Object(react["useEffect"])(() => {
        if (map) {
            const forceUpdate = () => setStyleLoaded(version => version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return () => {
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) {
                    map.removeLayer(id);
                }
            };
        }
        return undefined;
    }, [map]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) {
        try {
            updateLayer(map, id, props, propsRef.current);
        }
        catch (error) {
            console.warn(error); // eslint-disable-line
        }
    }
    else {
        createLayer(map, id, props);
    }
    // Store last rendered props
    propsRef.current = props;
    return null;
}
/* harmony default export */ var components_layer = (Layer);
//# sourceMappingURL=layer.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/types/external.js

//# sourceMappingURL=external.js.map
// CONCATENATED MODULE: /opt/webapp/node_modules/react-map-gl/dist/esm/index.js













// Types

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "xS1b":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "xVJP":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "xVUo":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var apply = __webpack_require__("KXRF");
var call = __webpack_require__("we+H");
var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var isSymbol = __webpack_require__("km0D");
var arraySlice = __webpack_require__("gp/v");
var getReplacerFunction = __webpack_require__("NEd/");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "xe/R":
/***/ (function(module, exports) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "xny9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("aWzz");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("7nmT");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _google_map_map = __webpack_require__("d0l/");

var _google_map_map2 = _interopRequireDefault(_google_map_map);

var _marker_dispatcher = __webpack_require__("HXK1");

var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);

var _google_map_markers = __webpack_require__("T3et");

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

var _google_map_markers_prerender = __webpack_require__("Q78w");

var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);

var _google_heatmap = __webpack_require__("2MAG");

var _google_map_loader = __webpack_require__("Q4AL");

var _google_map_loader2 = _interopRequireDefault(_google_map_loader);

var _geo = __webpack_require__("U0R4");

var _geo2 = _interopRequireDefault(_geo);

var _raf = __webpack_require__("J+Il");

var _raf2 = _interopRequireDefault(_raf);

var _pick = __webpack_require__("/ile");

var _pick2 = _interopRequireDefault(_pick);

var _omit = __webpack_require__("o+/o");

var _omit2 = _interopRequireDefault(_omit);

var _log = __webpack_require__("OFzH");

var _log2 = _interopRequireDefault(_log);

var _isEmpty = __webpack_require__("AYG8");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNumber = __webpack_require__("tnKh");

var _isNumber2 = _interopRequireDefault(_isNumber);

var _detect = __webpack_require__("IrNZ");

var _detect2 = _interopRequireDefault(_detect);

var _shallowEqual = __webpack_require__("aJtP");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _isPlainObject = __webpack_require__("8Y4Q");

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArraysEqualEps = __webpack_require__("hB/3");

var _isArraysEqualEps2 = _interopRequireDefault(_isArraysEqualEps);

var _detectElementResize = __webpack_require__("LEY8");

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

var _passiveEvents = __webpack_require__("6mUV");

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */


// helpers


// loaders


// utils


// consts
var kEPS = 0.00001;
var K_GOOGLE_TILE_SIZE = 256;
// real minZoom calculated here _getMinZoom
var K_IDLE_TIMEOUT = 100;
var K_IDLE_CLICK_TIMEOUT = 300;
var DEFAULT_MIN_ZOOM = 3;
// Starting with version 3.32, the maps API calls `draw()` each frame during
// a zoom animation.
var DRAW_CALLED_DURING_ANIMATION_VERSION = 32;
var IS_REACT_16 = _reactDom2.default.createPortal !== undefined;

var createPortal = IS_REACT_16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function defaultOptions_() /* maps */{
  return {
    overviewMapControl: false,
    streetViewControl: false,
    rotateControl: true,
    mapTypeControl: false,
    // disable poi
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    }],
    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
  };
}

var latLng2Obj = function latLng2Obj(latLng) {
  return (0, _isPlainObject2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
};

var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
  if (false) {}

  if (minZoom < zoom) {
    return zoom;
  }
  return minZoom;
};

var isFullScreen = function isFullScreen() {
  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
};

var GoogleMap = function (_Component) {
  _inherits(GoogleMap, _Component);

  // eslint-disable-line

  function GoogleMap(props) {
    _classCallCheck(this, GoogleMap);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getMinZoom = function () {
      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
        return Math.ceil((0, _log2.default)(maxTilesPerDim));
      }
      return DEFAULT_MIN_ZOOM;
    };

    _this._computeMinZoom = function (minZoom) {
      if (!(0, _isEmpty2.default)(minZoom)) {
        return minZoom;
      }
      return _this._getMinZoom();
    };

    _this._mapDomResizeCallback = function () {
      _this.resetSizeOnIdle_ = true;
      if (_this.maps_) {
        var originalCenter = _this.props.center || _this.props.defaultCenter;
        var currentCenter = _this.map_.getCenter();
        _this.maps_.event.trigger(_this.map_, 'resize');
        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
      }
    };

    _this._setLayers = function (layerTypes) {
      layerTypes.forEach(function (layerType) {
        _this.layers_[layerType] = new _this.maps_[layerType]();
        _this.layers_[layerType].setMap(_this.map_);
      });
    };

    _this._renderPortal = function () {
      return _react2.default.createElement(_google_map_markers2.default, {
        experimental: _this.props.experimental,
        onChildClick: _this._onChildClick,
        onChildMouseDown: _this._onChildMouseDown,
        onChildMouseEnter: _this._onChildMouseEnter,
        onChildMouseLeave: _this._onChildMouseLeave,
        geoService: _this.geoService_,
        insideMapPanes: true,
        distanceToMouse: _this.props.distanceToMouse,
        getHoverDistance: _this._getHoverDistance,
        dispatcher: _this.markersDispatcher_
      });
    };

    _this._initMap = function () {
      // only initialize the map once
      if (_this.initialized_) {
        return;
      }
      _this.initialized_ = true;

      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);

      _this._onBoundsChanged(); // now we can calculate map bounds center etc...

      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);

      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
        if (!_this.mounted_) {
          return;
        }

        var centerLatLng = _this.geoService_.getCenter();

        var propsOptions = {
          zoom: _this.props.zoom || _this.props.defaultZoom,
          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
        };

        // Start Heatmap
        if (_this.props.heatmap.positions) {
          Object.assign(_this, {
            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
          });
          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
        }
        // End Heatmap

        // prevent to exapose full api
        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
        // "SymbolPath", "ZoomControlStyle",
        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
        // "DistanceMatrixStatus",
        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
        // "GeocoderStatus", "KmlLayerStatus",
        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
        // "TravelMode", "UnitSystem"
        var mapPlainObjects = (0, _pick2.default)(maps, _isPlainObject2.default);
        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
        var defaultOptions = defaultOptions_(mapPlainObjects);

        var draggableOptions = !(0, _isEmpty2.default)(_this.props.draggable) && {
          draggable: _this.props.draggable
        };

        var minZoom = _this._computeMinZoom(options.minZoom);
        _this.minZoom_ = minZoom;

        var preMapOptions = _extends({}, defaultOptions, {
          minZoom: minZoom
        }, options, propsOptions);

        _this.defaultDraggableOption_ = !(0, _isEmpty2.default)(preMapOptions.draggable) ? preMapOptions.draggable : _this.defaultDraggableOption_;

        var mapOptions = _extends({}, preMapOptions, draggableOptions);

        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);

        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);

        _this.map_ = map;
        _this.maps_ = maps;

        _this._setLayers(_this.props.layerTypes);

        // Parse `google.maps.version` to capture the major version number.
        var versionMatch = maps.version.match(/^3\.(\d+)\./);
        // The major version is the first (and only) captured group.
        var mapsVersion = versionMatch && Number(versionMatch[1]);

        // render in overlay
        var this_ = _this;
        var overlay = Object.assign(new maps.OverlayView(), {
          onAdd: function onAdd() {
            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';

            var div = document.createElement('div');
            div.style.backgroundColor = 'transparent';
            div.style.position = 'absolute';
            div.style.left = '0px';
            div.style.top = '0px';
            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
            div.style.height = K_MAX_HEIGHT;

            if (this_.props.overlayViewDivStyle) {
              var overlayViewDivStyle = this_.props.overlayViewDivStyle;

              if ((typeof overlayViewDivStyle === 'undefined' ? 'undefined' : _typeof(overlayViewDivStyle)) === 'object') {
                Object.keys(overlayViewDivStyle).forEach(function (property) {
                  div.style[property] = overlayViewDivStyle[property];
                });
              }
            }

            var panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(div);
            this_.geoService_.setMapCanvasProjection(maps, overlay.getProjection());

            if (!IS_REACT_16) {
              createPortal(this_, this_._renderPortal(), div,
              // remove prerendered markers
              function () {
                return this_.setState({ overlay: div });
              });
            } else {
              this_.setState({ overlay: div });
            }
          },
          onRemove: function onRemove() {
            var renderedOverlay = this_.state.overlay;
            if (renderedOverlay && !IS_REACT_16) {
              _reactDom2.default.unmountComponentAtNode(renderedOverlay);
            }
            this_.setState({ overlay: null });
          },
          draw: function draw() {
            this_.updateCounter_++;
            this_._onBoundsChanged(map, maps, !this_.props.debounced);

            if (!this_.googleApiLoadedCalled_) {
              this_._onGoogleApiLoaded({ map: map, maps: maps });
              this_.googleApiLoadedCalled_ = true;
            }

            if (this_.mouse_) {
              var latLng = this_.geoService_.fromContainerPixelToLatLng(this_.mouse_);
              this_.mouse_.lat = latLng.lat;
              this_.mouse_.lng = latLng.lng;
            }

            this_._onChildMouseMove();

            if (this_.markersDispatcher_) {
              this_.markersDispatcher_.emit('kON_CHANGE');
              if (this_.fireMouseEventOnIdle_) {
                this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
              }
            }
          }
        });

        _this.overlay_ = overlay;

        overlay.setMap(map);
        if (_this.props.heatmap.positions) {
          _this.heatmap.setMap(map);
        }

        if (_this.props.onTilesLoaded) {
          maps.event.addListener(map, 'tilesloaded', function () {
            this_._onTilesLoaded();
          });
        }

        maps.event.addListener(map, 'zoom_changed', function () {
          // recalc position at zoom start
          if (this_.geoService_.getZoom() !== map.getZoom()) {
            if (!this_.zoomAnimationInProgress_) {
              this_.zoomAnimationInProgress_ = true;
              this_._onZoomAnimationStart();
            }

            // If draw() is not called each frame during a zoom animation,
            // simulate it.
            if (mapsVersion < DRAW_CALLED_DURING_ANIMATION_VERSION) {
              var TIMEOUT_ZOOM = 300;

              if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
                // there is strange Google Map Api behavior in chrome when zoom animation of map
                // is started only on second raf call, if was click on zoom control
                // or +- keys pressed, so i wait for two rafs before change state

                // this does not fully prevent animation jump
                // but reduce it's occurence probability
                (0, _raf2.default)(function () {
                  return (0, _raf2.default)(function () {
                    this_.updateCounter_++;
                    this_._onBoundsChanged(map, maps);
                  });
                });
              } else {
                this_.updateCounter_++;
                this_._onBoundsChanged(map, maps);
              }
            }
          }
        });

        maps.event.addListener(map, 'idle', function () {
          if (_this.resetSizeOnIdle_) {
            _this._setViewSize();
            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);

            if (currMinZoom !== _this.minZoom_) {
              _this.minZoom_ = currMinZoom;
              map.setOptions({ minZoom: currMinZoom });
            }

            _this.resetSizeOnIdle_ = false;
          }

          if (this_.zoomAnimationInProgress_) {
            this_.zoomAnimationInProgress_ = false;
            this_._onZoomAnimationEnd();
          }

          this_.updateCounter_++;
          this_._onBoundsChanged(map, maps);

          this_.dragTime_ = 0;

          if (this_.markersDispatcher_) {
            this_.markersDispatcher_.emit('kON_CHANGE');
          }
        });

        maps.event.addListener(map, 'mouseover', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = true;
        });

        // an alternative way to know the mouse is back within the map
        // This would not fire when clicking/interacting with google maps
        // own on-map countrols+markers. This handles an edge case for touch devices
        // + 'draggable:false' custom option. See #332 for more details.
        maps.event.addListener(map, 'click', function () {
          this_.mouseInMap_ = true;
        });

        maps.event.addListener(map, 'mouseout', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = false;
          this_.mouse_ = null;
          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        });

        maps.event.addListener(map, 'drag', function () {
          this_.dragTime_ = new Date().getTime();
          this_._onDrag(map);
        });
        // user choosing satellite vs roads, etc
        maps.event.addListener(map, 'maptypeid_changed', function () {
          this_._onMapTypeIdChange(map.getMapTypeId());
        });
      }).catch(function (e) {
        // notify callback of load failure
        _this._onGoogleApiLoaded({ map: null, maps: null });
        console.error(e); // eslint-disable-line no-console
        throw e;
      });
    };

    _this._onGoogleApiLoaded = function () {
      if (_this.props.onGoogleApiLoaded) {
        var _this$props;

        if (false) {}

        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
      }
    };

    _this._getHoverDistance = function () {
      return _this.props.hoverDistance;
    };

    _this._onDrag = function () {
      var _this$props2;

      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
    };

    _this._onMapTypeIdChange = function () {
      var _this$props3;

      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
    };

    _this._onZoomAnimationStart = function () {
      var _this$props4;

      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
    };

    _this._onZoomAnimationEnd = function () {
      var _this$props5;

      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
    };

    _this._onTilesLoaded = function () {
      return _this.props.onTilesLoaded && _this.props.onTilesLoaded();
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        var _this$props6;

        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
      }
      return undefined;
    };

    _this._onChildMouseDown = function (hoverKey, childProps) {
      _this.childMouseDownArgs_ = [hoverKey, childProps];
      if (_this.props.onChildMouseDown) {
        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
      }
    };

    _this._onChildMouseUp = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseUp) {
          var _this$props7;

          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
        _this.childMouseDownArgs_ = null;
        _this.childMouseUpTime_ = new Date().getTime();
      }
    };

    _this._onChildMouseMove = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseMove) {
          var _this$props8;

          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
      }
    };

    _this._onChildMouseEnter = function () {
      if (_this.props.onChildMouseEnter) {
        var _this$props9;

        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
      }
      return undefined;
    };

    _this._onChildMouseLeave = function () {
      if (_this.props.onChildMouseLeave) {
        var _this$props10;

        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
      }
      return undefined;
    };

    _this._setViewSize = function () {
      if (!_this.mounted_) return;
      if (isFullScreen()) {
        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
      } else {
        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
      }
      _this._onBoundsChanged();
    };

    _this._onWindowResize = function () {
      _this.resetSizeOnIdle_ = true;
    };

    _this._onMapMouseMove = function (e) {
      if (!_this.mouseInMap_) return;

      var currTime = new Date().getTime();
      var K_RECALC_CLIENT_RECT_MS = 50;

      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
      }
      _this.mouseMoveTime_ = currTime;

      var mousePosX = e.clientX - _this.boundingRect_.left;
      var mousePosY = e.clientY - _this.boundingRect_.top;

      if (!_this.mouse_) {
        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
      }

      _this.mouse_.x = mousePosX;
      _this.mouse_.y = mousePosY;

      var latLng = _this.geoService_.fromContainerPixelToLatLng(_this.mouse_);
      _this.mouse_.lat = latLng.lat;
      _this.mouse_.lng = latLng.lng;

      _this._onChildMouseMove();

      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
        _this.fireMouseEventOnIdle_ = true;
      } else {
        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        _this.fireMouseEventOnIdle_ = false;
      }
    };

    _this._onClick = function () {
      var _this$props11;

      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
    };

    _this._onMapClick = function (event) {
      if (_this.markersDispatcher_) {
        // support touch events and recalculate mouse position on click
        _this._onMapMouseMove(event);
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          if (_this.mouse_) {
            _this._onClick(_extends({}, _this.mouse_, {
              event: event
            }));
          }

          _this.markersDispatcher_.emit('kON_CLICK', event);
        }
      }
    };

    _this._onMapMouseDownNative = function (event) {
      if (!_this.mouseInMap_) return;

      _this._onMapMouseDown(event);
    };

    _this._onMapMouseDown = function (event) {
      if (_this.markersDispatcher_) {
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          // Hovered marker detected at mouse move could be deleted at mouse down time
          // so it will be good to force hovered marker recalculation
          _this._onMapMouseMove(event);
          _this.markersDispatcher_.emit('kON_MDOWN', event);
        }
      }
    };

    _this._onMapMouseDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        // to fix strange zoom in chrome
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._onKeyDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._isCenterDefined = function (center) {
      return center && ((0, _isPlainObject2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
    };

    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
      if (map) {
        var gmC = map.getCenter();
        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
      }

      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
        var zoom = _this.geoService_.getZoom();
        var bounds = _this.geoService_.getBounds();
        var centerLatLng = _this.geoService_.getCenter();

        if (!(0, _isArraysEqualEps2.default)(bounds, _this.prevBounds_, kEPS)) {
          if (callExtBoundsChange !== false) {
            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
            if (_this.props.onBoundsChange) {
              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
            }

            if (_this.props.onChange) {
              _this.props.onChange({
                center: _extends({}, centerLatLng),
                zoom: zoom,
                bounds: {
                  nw: {
                    lat: bounds[0],
                    lng: bounds[1]
                  },
                  se: {
                    lat: bounds[2],
                    lng: bounds[3]
                  },
                  sw: {
                    lat: bounds[4],
                    lng: bounds[5]
                  },
                  ne: {
                    lat: bounds[6],
                    lng: bounds[7]
                  }
                },
                marginBounds: {
                  nw: {
                    lat: marginBounds[0],
                    lng: marginBounds[1]
                  },
                  se: {
                    lat: marginBounds[2],
                    lng: marginBounds[3]
                  },
                  sw: {
                    lat: marginBounds[4],
                    lng: marginBounds[5]
                  },
                  ne: {
                    lat: marginBounds[6],
                    lng: marginBounds[7]
                  }
                },

                size: _this.geoService_.hasSize() ? {
                  width: _this.geoService_.getWidth(),
                  height: _this.geoService_.getHeight()
                } : {
                  width: 0,
                  height: 0
                }
              });
            }

            _this.prevBounds_ = bounds;
          }
        }
      }
    };

    _this._registerChild = function (ref) {
      _this.googleMapDom_ = ref;
    };

    _this.mounted_ = false;
    _this.initialized_ = false;
    _this.googleApiLoadedCalled_ = false;

    _this.map_ = null;
    _this.maps_ = null;
    _this.prevBounds_ = null;
    _this.heatmap = null;

    _this.layers_ = {};

    _this.mouse_ = null;
    _this.mouseMoveTime_ = 0;
    _this.boundingRect_ = null;
    _this.mouseInMap_ = true;

    _this.dragTime_ = 0;
    _this.fireMouseEventOnIdle_ = false;
    _this.updateCounter_ = 0;

    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
    _this.centerIsObject_ = (0, _isPlainObject2.default)(_this.props.center);

    _this.minZoom_ = DEFAULT_MIN_ZOOM;
    _this.defaultDraggableOption_ = true;

    _this.zoomControlClickTime_ = 0;

    _this.childMouseDownArgs_ = null;
    _this.childMouseUpTime_ = 0;

    _this.googleMapDom_ = null;

    if (false) {}

    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
    }

    _this.zoomAnimationInProgress_ = false;

    _this.state = {
      overlay: null
    };
    return _this;
  }

  GoogleMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted_ = true;
    (0, _passiveEvents2.default)(window, 'resize', this._onWindowResize, false);
    (0, _passiveEvents2.default)(window, 'keydown', this._onKeyDownCapture, true);
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    // gmap can't prevent map drag if mousedown event already occured
    // the only workaround I find is prevent mousedown native browser event

    if (mapDom) {
      (0, _passiveEvents2.default)(mapDom, 'mousedown', this._onMapMouseDownNative, true);
    }

    (0, _passiveEvents2.default)(window, 'mouseup', this._onChildMouseUp, false);
    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);

    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly

    setTimeout(function () {
      // to detect size
      _this2._setViewSize();
      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
        _this2._initMap();
      }
    }, 0, this);
    if (this.props.resetBoundsOnResize) {
      var that = this;
      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
    }
  };

  GoogleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (false) {}

    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
      setTimeout(function () {
        return _this3._initMap();
      }, 0);
    }

    if (this.map_) {
      var centerLatLng = this.geoService_.getCenter();
      if (this._isCenterDefined(nextProps.center)) {
        var nextPropsCenter = latLng2Obj(nextProps.center);
        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;

        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
            this.map_.panTo({
              lat: nextPropsCenter.lat,
              lng: nextPropsCenter.lng
            });
          }
        }
      }

      if (!(0, _isEmpty2.default)(nextProps.zoom)) {
        // if zoom chaged by user
        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
          this.map_.setZoom(nextProps.zoom);
        }
      }

      if (!(0, _isEmpty2.default)(this.props.draggable) && (0, _isEmpty2.default)(nextProps.draggable)) {
        // reset to default
        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
      } else if (!(0, _shallowEqual2.default)(this.props.draggable, nextProps.draggable)) {
        // also prevent this on window 'mousedown' event to prevent map move
        this.map_.setOptions({ draggable: nextProps.draggable });
      }

      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
      if (!(0, _isEmpty2.default)(nextProps.options) && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
        var mapPlainObjects = (0, _pick2.default)(this.maps_, _isPlainObject2.default);
        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
        // remove zoom, center and draggable options as these are managed by google-maps-react
        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);

        if ('minZoom' in options) {
          var minZoom = this._computeMinZoom(options.minZoom);
          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
        }

        this.map_.setOptions(options);
      }

      if (!(0, _shallowEqual2.default)(nextProps.layerTypes, this.props.layerTypes)) {
        Object.keys(this.layers_).forEach(function (layerKey) {
          _this3.layers_[layerKey].setMap(null);
          delete _this3.layers_[layerKey];
        });
        this._setLayers(nextProps.layerTypes);
      }
    }
  };

  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // draggable does not affect inner components
    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.markersDispatcher_.emit('kON_CHANGE');

    if (!(0, _shallowEqual2.default)(this.props.hoverDistance, prevProps.hoverDistance)) {
      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
    }
  };

  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted_ = false;
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    if (mapDom) {
      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
    }
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('keydown', this._onKeyDownCapture);
    window.removeEventListener('mouseup', this._onChildMouseUp, false);
    if (this.props.resetBoundsOnResize) {
      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
    }

    if (this.overlay_) {
      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
      this.overlay_.setMap(null);
    }

    if (this.maps_ && this.map_) {
      // fix google, as otherwise listeners works even without map
      this.map_.setOptions({ scrollwheel: false });
      this.maps_.event.clearInstanceListeners(this.map_);
    }

    this.map_ = null;
    this.maps_ = null;
    this.markersDispatcher_.dispose();

    this.resetSizeOnIdle_ = false;

    delete this.map_;
    delete this.markersDispatcher_;
  };
  // calc minZoom if map size available
  // it's better to not set minZoom less than this calculation gives
  // otherwise there is no homeomorphism between screen coordinates and map
  // (one map coordinate can have different screen coordinates)


  // this method works only if this.props.onChildMouseDown was called


  // this method works only if this.props.onChildMouseDown was called


  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough


  // gmap can't prevent map drag if mousedown event already occured
  // the only workaround I find is prevent mousedown native browser event


  GoogleMap.prototype.render = function render() {
    var overlay = this.state.overlay;
    var mapMarkerPrerender = !overlay ? _react2.default.createElement(_google_map_markers_prerender2.default, {
      experimental: this.props.experimental,
      onChildClick: this._onChildClick,
      onChildMouseDown: this._onChildMouseDown,
      onChildMouseEnter: this._onChildMouseEnter,
      onChildMouseLeave: this._onChildMouseLeave,
      geoService: this.geoService_,
      insideMapPanes: false,
      distanceToMouse: this.props.distanceToMouse,
      getHoverDistance: this._getHoverDistance,
      dispatcher: this.markersDispatcher_
    }) : null;

    return _react2.default.createElement(
      'div',
      {
        style: this.props.style,
        onMouseMove: this._onMapMouseMove,
        onMouseDownCapture: this._onMapMouseDownCapture,
        onClick: this._onMapClick
      },
      _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
      IS_REACT_16 && overlay && createPortal(this._renderPortal(), overlay),
      mapMarkerPrerender
    );
  };

  return GoogleMap;
}(_react.Component);

GoogleMap.propTypes = {
  apiKey: _propTypes2.default.string,
  bootstrapURLKeys: _propTypes2.default.any,

  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  defaultZoom: _propTypes2.default.number,
  zoom: _propTypes2.default.number,
  onBoundsChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseUp: _propTypes2.default.func,
  onChildMouseMove: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onZoomAnimationStart: _propTypes2.default.func,
  onZoomAnimationEnd: _propTypes2.default.func,
  onDrag: _propTypes2.default.func,
  onMapTypeIdChange: _propTypes2.default.func,
  onTilesLoaded: _propTypes2.default.func,
  options: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  hoverDistance: _propTypes2.default.number,
  debounced: _propTypes2.default.bool,
  margin: _propTypes2.default.array,
  googleMapLoader: _propTypes2.default.any,
  onGoogleApiLoaded: _propTypes2.default.func,
  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  style: _propTypes2.default.any,
  resetBoundsOnResize: _propTypes2.default.bool,
  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string) // ['TransitLayer', 'TrafficLayer']
};
GoogleMap.defaultProps = {
  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
  },

  hoverDistance: 30,
  debounced: true,
  options: defaultOptions_,
  googleMapLoader: _google_map_loader2.default,
  yesIWantToUseGoogleMapApiInternals: false,
  style: {
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    position: 'relative'
  },
  layerTypes: [],
  heatmap: {},
  heatmapLibrary: false
};
GoogleMap.googleMapLoader = _google_map_loader2.default;
exports.default = GoogleMap;

/***/ }),

/***/ "y/CH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];

/***/ }),

/***/ "y147":
/***/ (function(module) {

module.exports = JSON.parse("[\"ase\",\"art\",\"bmp\",\"blp\",\"cd5\",\"cit\",\"cpt\",\"cr2\",\"cut\",\"dds\",\"dib\",\"djvu\",\"egt\",\"exif\",\"gif\",\"gpl\",\"grf\",\"icns\",\"ico\",\"iff\",\"jng\",\"jpeg\",\"jpg\",\"jfif\",\"jp2\",\"jps\",\"lbm\",\"max\",\"miff\",\"mng\",\"msp\",\"nitf\",\"ota\",\"pbm\",\"pc1\",\"pc2\",\"pc3\",\"pcf\",\"pcx\",\"pdn\",\"pgm\",\"PI1\",\"PI2\",\"PI3\",\"pict\",\"pct\",\"pnm\",\"pns\",\"ppm\",\"psb\",\"psd\",\"pdd\",\"psp\",\"px\",\"pxm\",\"pxr\",\"qfx\",\"raw\",\"rle\",\"sct\",\"sgi\",\"rgb\",\"int\",\"bw\",\"tga\",\"tiff\",\"tif\",\"vtf\",\"xbm\",\"xcf\",\"xpm\",\"3dv\",\"amf\",\"ai\",\"awg\",\"cgm\",\"cdr\",\"cmx\",\"dxf\",\"e2d\",\"egt\",\"eps\",\"fs\",\"gbr\",\"odg\",\"svg\",\"stl\",\"vrml\",\"x3d\",\"sxd\",\"v2d\",\"vnd\",\"wmf\",\"emf\",\"art\",\"xar\",\"png\",\"webp\",\"jxr\",\"hdp\",\"wdp\",\"cur\",\"ecw\",\"iff\",\"lbm\",\"liff\",\"nrrd\",\"pam\",\"pcx\",\"pgf\",\"sgi\",\"rgb\",\"rgba\",\"bw\",\"int\",\"inta\",\"sid\",\"ras\",\"sun\",\"tga\"]");

/***/ }),

/***/ "y2Ah":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAIL_OPTIN; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* unused harmony export THEO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PASSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT_TYPES; });
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';
var PASSPORT = 'PASSPORT';
var IDCARD = 'IDCARD'; // right now we only manage these two document types

var DOCUMENT_TYPES = [PASSPORT, IDCARD];

/***/ }),

/***/ "y64Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PriceRemoteDetailsToggle; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _PriceRemoteContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wFQJ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var PriceRemoteDetailsToggle = function PriceRemoteDetailsToggle(_ref) {
  var className = _ref.className,
      handleClick = _ref.handleClick,
      isCollapsed = _ref.isCollapsed;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_PriceRemoteContext__WEBPACK_IMPORTED_MODULE_2__[/* PriceRemoteContext */ "a"]),
      isJoyview = _useContext[0].isJoyview;

  var color = isJoyview ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE_WAVE : _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLACK;
  var buttonLabel = Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('priceRemote.openAllInclusiveDetails');
  return __jsx("button", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex gap-5 items-center text-14', "text-".concat(color), className),
    "data-testid": "strip-button",
    onClick: handleClick,
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "0.8125rem"
  }), __jsx("span", {
    className: "underline"
  }, buttonLabel), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "shrink-0 ms-5 text-current transition-transform duration-250 ease-in",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ARROW_DOWN,
    rotation: !isCollapsed ? 180 : 0,
    width: "0.625rem"
  }));
};

/***/ }),

/***/ "yFoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransportCriteria; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("RUiN");
/* harmony import */ var _criteria_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+Rc+");
/* harmony import */ var _criteria_criteria_transport_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("M3jp");
/* harmony import */ var _hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Akr5");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("loSl");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].NO_TRANSPORT_VALUE;
var TransportCriteria = function TransportCriteria(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      handleDepartureCity = _ref.handleDepartureCity,
      initialTransport = _ref.initialTransport,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRANSPORT : _ref$transportIcon,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var isInitialMount = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(true);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useDispatch */ "d"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isTransportCriteriaOpen = _useState[0],
      setTransportCriteriaIsOpen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isTransportCriteriaSet = _useState2[0],
      setTransportCriteriaIsSet = _useState2[1]; // Store update effect


  var _useSyncDepartureCity = Object(_hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_8__[/* useSyncDepartureCity */ "a"])({
    departureCitiesOptions: departureCitiesOptions,
    departureCity: departureCity,
    initialTransport: initialTransport,
    onChange: function onChange(newDepartureCity) {
      setTransportCriteriaIsSet(Boolean(newDepartureCity));
    },
    withValidDepartureCity: withValidDepartureCity
  }),
      inputDepartureCity = _useSyncDepartureCity.inputDepartureCity,
      setInputDepartureCity = _useSyncDepartureCity.setInputDepartureCity;

  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    if (!isInitialMount.current && inputDepartureCity) {
      saveTransport();
    }

    isInitialMount.current = false;
  }, [inputDepartureCity]);

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity || !inputDepartureCity) {
      if (handleDepartureCity) {
        handleDepartureCity(inputDepartureCity || NO_TRANSPORT_VALUE);
      } else {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__[/* changeDepartureCity */ "a"])(inputDepartureCity || NO_TRANSPORT_VALUE));
      }
    }

    setTransportCriteriaIsOpen(false);
    setTransportCriteriaIsSet(Boolean(inputDepartureCity));
  };

  var getIcon = function getIcon() {
    if (!departureCity || departureCity === NO_TRANSPORT_VALUE) {
      return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].NO_TRANSPORT;
    }

    return transportIcon;
  };

  var getLabel = function getLabel() {
    if (!isTransportCriteriaSet) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.subTitle');
    }

    var valueToMatch = departureCity || NO_TRANSPORT_VALUE;
    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === valueToMatch;
    });
    return selectedOption ? selectedOption.label : Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.subTitle');
  };

  var buttonLabel = __jsx("span", {
    className: "block flex-1 truncate"
  }, getLabel());

  var onOpen = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
    setTransportCriteriaIsOpen(true);
    Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_5__[/* scrollToElement */ "a"])('[data-testid="TransportCriteria-trigger"]');
  }, []);
  var onClear = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
    if (handleDepartureCity) {
      handleDepartureCity(NO_TRANSPORT_VALUE);
    } else {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__[/* changeDepartureCity */ "a"])(NO_TRANSPORT_VALUE));
    }

    setTransportCriteriaIsSet(false);
  }, []);
  return __jsx(_criteria_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_6__[/* CriteriaTrigger */ "a"], {
    dataTestId: "TransportCriteria-trigger",
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: Boolean(isTransportCriteriaSet && departureCity && departureCity !== NO_TRANSPORT_VALUE),
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.reset'),
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      theme: 'link'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.validate'),
      'data-testid': 'TransportCriteria-trigger-validate',
      onClick: saveTransport
    }],
    hasSwitch: true,
    isJoyview: isJoyview,
    isOpen: isTransportCriteriaOpen,
    onClear: onClear,
    onClose: saveTransport,
    onOpen: onOpen,
    theme: "default",
    trackingLabel: "departureCity"
  }, __jsx(_criteria_criteria_transport_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_7__[/* FilterTransport */ "a"], {
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    },
    className: "h-full",
    dataTestId: "TransportCriteria-input",
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    isDisabled: !departureCitiesOptions.length,
    labelDepartingFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.departingFrom'),
    optionsDepartureCities: departureCitiesOptions.length > 0 ? departureCitiesOptions : noDepartureCitiesOptions,
    placeholderFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.titleFrom'),
    selectPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.selectPlaceholder'),
    validateDepartureCity: saveTransport
  }));
};

/***/ }),

/***/ "yUod":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var anObject = __webpack_require__("ep/x");
var getMethod = __webpack_require__("Uey1");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "yWCo":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("T0aG")["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "yWv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Radio; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("C/y5");
/* harmony import */ var _inputsUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("vpua");
/* harmony import */ var _form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zwQs");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Radio = function Radio(_ref) {
  var className = _ref.className,
      field = _ref.field,
      form = _ref.form,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      _onChange = _ref.onChange,
      size = _ref.size,
      _ref$itemsCentered = _ref.itemsCentered,
      itemsCentered = _ref$itemsCentered === void 0 ? true : _ref$itemsCentered;

  var formValue = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(form.values, field.name, '');

  var _getValidationStatus = Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getValidationStatus */ "d"])(_objectSpread(_objectSpread({}, field), {}, {
    formValue: formValue
  }), form),
      isErrored = _getValidationStatus.isErrored; // values can be integer at form initialize but finally it's always a string, so we ensure it


  var isChecked = formValue.toString() === field.value.toString();
  return __jsx("label", {
    htmlFor: "radio-".concat(field.name, "-").concat(field.value),
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_17__[/* classnames */ "a"])('flex min-h-48 w-full gap-10 text-14', {
      'cursor-pointer': !isDisabled && !isLoading,
      'cursor-wait': isLoading,
      'cursor-not-allowed': isDisabled,
      'formik-errored': isErrored && isRequired,
      'items-center': itemsCentered
    }, className)
  }, __jsx(_form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__[/* RadioButton */ "a"], {
    className: size,
    isChecked: isChecked,
    isDisabled: isDisabled || isReadOnly
  }), __jsx("input", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])({}, field, {
    checked: isChecked,
    className: "sr-only",
    disabled: isDisabled,
    id: "radio-".concat(field.name, "-").concat(field.value),
    type: "radio",
    onChange: function onChange(event) {
      field.onChange(event);

      if (_onChange) {
        _onChange(event);
      }
    }
  })), label && __jsx("span", {
    className: "text-14 leading-normal text-black"
  }, label));
};

/***/ }),

/***/ "yYuE":
/***/ (function(module, exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__("OoaE");
var defineProperty = __webpack_require__("87KK");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "ydRd":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("3LIW");
var getBuiltIn = __webpack_require__("x90g");
var inspectSource = __webpack_require__("/ExG");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["h" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["h" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      rate = _ref.rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      rate: rate,
      startDate: startDate,
      unit: unit
    }),
    isModalOnly: true,
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "yhbn":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("gIGD");
var isConstructor = __webpack_require__("ydRd");
var isObject = __webpack_require__("1YFU");
var wellKnownSymbol = __webpack_require__("nJrx");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "yjkv":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "yvHl":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("/GgU");
var isCallable = __webpack_require__("ANQd");
var toObject = __webpack_require__("A+R+");
var sharedKey = __webpack_require__("mmil");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "z7Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLIGHT_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRAIN_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRANSPORT_CLASS_TO_I18N; });
/* unused harmony export SNCF_ID */
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatDate; });
/* unused harmony export getWayLabel */
/* unused harmony export formatConnectionLabel */
/* unused harmony export getStep */
/* unused harmony export hasPlane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasOnlyPlanes; });
/* unused harmony export hasOnlyTrain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isTransportTrain; });
/* unused harmony export isTransportPlaneTicket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* unused harmony export getCancellationPolicyDescription */
/* unused harmony export getNDCCancelationPolicyDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCompanyOperators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCompanyOperatorsName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTransportClasses; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("Jhhs");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jLkM");
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("yjkv");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ZHrn");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("XpIN");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("WGoB");



























var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var FLIGHT_CLASS_AVAILABLE_TO_SEARCH = ['PLANE_ECONOMY', 'PLANE_ECONOMY_PLUS', 'PLANE_BUSINESS', 'PLANE_PREMIUM', 'PLANE_FIRST'];
var TRAIN_CLASS_AVAILABLE_TO_SEARCH = ['TRAIN_SECOND', 'TRAIN_FIRST'];
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIB: 'emeraldClassLabel',
  DIV: 'economyClassLabel',
  ECO: 'economyClassLabel',
  'EC+': 'alizeeClassLabel',
  FIR: 'firstClassLabel',
  PLANE_BUSINESS: 'businessClassLabel',
  PLANE_ECONOMY: 'economyClassLabel',
  PLANE_ECONOMY_PLUS: 'alizeeClassLabel',
  PLANE_FIRST: 'firstClassLabel',
  PLANE_PREMIUM: 'premiumClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel',
  TRAIN_FIRST: 'firstClassLabel',
  TRAIN_SECOND: 'secondClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiTime */ "l"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function formatDate(date, format) {
  return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__[/* capitalizeName */ "a"])(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(date).format(format || Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('common.verboseDateFormatTechnicalID')));
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') {
    var _i18n$common, _i18n$common$transpor;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  }

  if (way === 'OUTBOUND') {
    var _i18n$common2, _i18n$common2$transpo;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  }

  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_18___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_18___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'connectionDurationInMin');

    var stopOverDuration = lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'stopDurationInMin');

    var information = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(stopOverDuration) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.reference'),
      type: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.type'),
      information: information,
      operator: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.label'),
      operatorId: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.id'),
      operatorLogo: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.logo'),
      start: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.date')
      },
      end: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.date')
      },
      technicalStops: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === BOAT;
  });
}

function hasPlane(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === PLANE;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportTrain(inbound, outbound) {
  return hasOnlyTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasOnlyTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));
}

function isTransportPlaneTicket(inbound, outbound) {
  return hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));
}

function getTransportIcon(inbound, outbound) {
  var isTrain = hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(travelSections) ? (travelSections || []).some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'arrival.time') || lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inbound, outbound) {
  return tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) || tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var numberMinutes = Number(minutes);

  if (numberMinutes < 60) {
    return "".concat(numberMinutes).concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.min'));
  }

  if (numberMinutes % 60 === 0) {
    return "".concat(numberMinutes / 60).concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.hours'));
  }

  var time = [Math.floor(numberMinutes / 60), Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.hours'), "".concat(isRTL ? '-' : ''), (numberMinutes % 60).toString().padStart(2, '0'), Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.min')];
  return time.join('');
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$outbound;

  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__[/* isCharterFlight */ "r"])(((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__[/* isCharterFlight */ "r"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
}

function getCompanyOperators() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = travelSections.reduce(function (companies, section) {
    var _section$transport, _section$transport$co, _section$transport2, _section$transport2$c;

    if ((section === null || section === void 0 ? void 0 : (_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : (_section$transport$co = _section$transport.companyOperator) === null || _section$transport$co === void 0 ? void 0 : _section$transport$co.id) && (section === null || section === void 0 ? void 0 : (_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.label)) {
      companies.push(section.transport.companyOperator);
    }

    return companies;
  }, []);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default()(companyOperators, 'id');
}

function getCompanyOperatorsName() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = getCompanyOperators(travelSections);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default()(companyOperators, 'id').map(function (company) {
    return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__[/* capitalizeName */ "a"])(company.label);
  });
}

function getTransportClasses() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allClasses = travelSections.map(function (section) {
    var _section$transport3;

    return section === null || section === void 0 ? void 0 : (_section$transport3 = section.transport) === null || _section$transport3 === void 0 ? void 0 : _section$transport3["class"];
  }).filter(Boolean);
  return lodash_uniq__WEBPACK_IMPORTED_MODULE_14___default()(allClasses);
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound2, _transport$outbound2; // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getNDCCancelationPolicyDescription = function getNDCCancelationPolicyDescription(transports, i18n) {
  var cancellationPolicy = getCancellationPolicy(transports);

  if (cancellationPolicy === _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_23__[/* LEGAL_INFO_NDC_ID */ "c"]) {
    var _getOptinsInfos, _getOptinsInfos$ndc;

    return (_getOptinsInfos = Object(_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_20__[/* getOptinsInfos */ "m"])(i18n === null || i18n === void 0 ? void 0 : i18n.bookingProcess)) === null || _getOptinsInfos === void 0 ? void 0 : (_getOptinsInfos$ndc = _getOptinsInfos.ndc) === null || _getOptinsInfos$ndc === void 0 ? void 0 : _getOptinsInfos$ndc.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;

  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "zBae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.getIn = getIn;
exports.default = void 0;

var _propertyExpr = __webpack_require__("dFUt");

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value, context) {
  var parent, lastPart, lastPartDebug; // if only one "value" arg then use it for both

  context = context || value;
  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(schema, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(schema, 'fields') || !(0, _has.default)(schema.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\") "));
      schema = schema.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = part;
      lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var reach = function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
};

var _default = reach;
exports.default = _default;

/***/ }),

/***/ "zSnQ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toIndexedObject = __webpack_require__("dNjr");
var nativeGetOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var DESCRIPTORS = __webpack_require__("uGjT");

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "zcYo":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "zwQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButton; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05v4");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var RadioButton = function RadioButton(_ref) {
  var className = _ref.className,
      dataTestid = _ref.dataTestid,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _onClick = function _onClick(event) {
    if (!isDisabled && onClick) {
      onClick(event);
    }
  };

  var _onKeyPress = function _onKeyPress(event) {
    if (event.which === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_3__[/* ENTER */ "f"]) {
      _onClick(event);
    }
  };

  return __jsx("span", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('outline-custom-sibling flex size-24 shrink-0 rounded-full border border-black p-2 text-saffron', {
      'cursor-not-allowed border-grey bg-pearl text-lightGrey': isDisabled
    }, className),
    "data-testid": dataTestid,
    role: "button",
    tabIndex: tabIndex,
    onClick: _onClick,
    onKeyPress: _onKeyPress
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])({
      'opacity-0': !isChecked
    }),
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].FAT_DOT,
    width: "100%"
  }));
};

/***/ })

}]);